webpackJsonp([13],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNgModule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);



var APP_REGEXP = /apps\/([a-zA-Z-]*)\/.*/;
var MODULE_REGEXP = /modules\/([a-zA-Z-]*)\/.*/;
var appMap = {
  "dette": "tael",
  "dette-garantie": "tael.app.dette-garantie",
  "intra": "intra",
  "observatoire": "tael.app.observatoire",
  "placement": "tael.app.placement",
  "pret": "tael.app.pret",
  "pret-intra": "tael.app.pret-intra",
  "credit-bail": "tael.app.credit-bail",
  "aide-subvention": "tael.app.aide-subvention",
  "of": "tael.app.of"
};
var moduleMap = {
  "common": "tael.module.common",
  "dette": "tael.module.dette",
  "gestion-compte": "tael.module.gestion-compte.main",
  "observatoire": "tael.module.observatoire",
  "placement": "tael.module.placement",
  "pret": "tael.module.pret",
  "pret-intra": "tael.module.pret-intra",
  "credit-bail": "tael.module.credit-bail",
  "aide-subvention": "tael.module.aide-subvention",
  "of": "tael.module.of",
  "interfacage": "tael.module.interfacage",
  "reporting": "tael.module.reporting",
  "reporting-components": "tael.module.reporting.components"
};

/**
 * Cheap trick for retrocompatibility, retrieving the angular module from the current fileName.
 * Used to stay in good ol'way reversed dependency approach.
 *
 * @param filePath The file path to get associated module of.
 * @return The associated angular module to use for this file.
 */
function getNgModule(path) {
  var filePath = path.replace(/\\/g, "/"); // fix for windows "\"
  // "src/apps/intra/intra-app.js"

  var ngModule = null;
  var matcher = APP_REGEXP.exec(filePath);
  if (matcher != null) {
    var appName = matcher[1];
    ngModule = appMap[appName];
  } else {
    matcher = MODULE_REGEXP.exec(filePath);
    if (matcher != null) {
      var moduleName = matcher[1];
      ngModule = moduleMap[moduleName];
    }
  }

  // console.log('getNgModule ->', filePath, ngModule);

  if (ngModule != null) {
    return __WEBPACK_IMPORTED_MODULE_0_angular___default.a.module(ngModule);
  } else {
    throw "Cannot find module for file ".concat(filePath, ". If it is a new module, add it in getNgModule.js");
  }
}

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular, $, numeral, moment) {

var MODULE_NAME = 'tael.module.common';
var ngModule = angular.module(MODULE_NAME, ['ngRoute', 'ngAnimate', 'ngSanitize', 'ui.sortable', "oc.lazyLoad", 'blueimp.fileupload' // file upload
]);
ngModule.config(function () {
  $.ajaxSetup({
    traditional: true
  });
  numeral.language('fr', {
    delimiters: {
      thousands: ' ',
      decimal: ','
    },
    abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't'
    },
    ordinal: function ordinal(number) {
      return number === 1 ? 'er' : 'ème';
    },
    currency: {
      symbol: '€'
    }
  });
  numeral.language('fr');
  moment.locale("fr");
});

// Warning : do NOT factorize this : webpack will not be able to parse parametrized context paths.
function requireAllInContext(context) {
  context.keys().forEach(context);
}
requireAllInContext(__webpack_require__(3793));
requireAllInContext(__webpack_require__(3792));
module.exports = MODULE_NAME;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(4), __webpack_require__(749), __webpack_require__(2)))

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */
/***/ (function(module, exports) {

module.exports = "<div class=page-inventaire-documents autosizing-container sizable-container> <tl-file-drop-overlay ng-if=showFileDropOverlay()></tl-file-drop-overlay> <tl-loader-overlay ng-if=loading></tl-loader-overlay> <div class=page-header fixed-component> <div class=tl-nav-breadcrumb> <div class=tl-nav-breadcrumb-element ng-repeat=\"arianeNode in location.arianeNodes\" ng-click=navigateTo(arianeNode.id)> <span>{{arianeNode.label}}</span> </div> </div> <div ng-if=\"location.node.tags.DIRECTORY_TYPE!='MODELES_DE_DOCUMENTS'\"> <tl-icon-button icon=fa-th-large ng-click=\"changeDisplayMode('vignette')\" ng-disabled=\"display.mode == 'vignette'\" tl-tooltip=\"{{'documents.AffichageEnVignettes' | translate}}\"></tl-icon-button> <tl-icon-button icon=fa-table ng-click=\"changeDisplayMode('table')\" ng-disabled=\"display.mode == 'table'\" tl-tooltip=\"{{'documents.AffichageEnTableau' | translate}}\"></tl-icon-button> <span if-not-aide-subvention> <tl-icon-button icon=\"fa-sharp fa-list-check\" ng-click=\"changeDisplayMode('maj')\" ng-disabled=\"display.mode == 'maj' || location.subNodes.length == 0\" tl-tooltip=\"{{'documents.MiseAJourMassive' | translate}}\"></tl-icon-button> </span> </div> </div> <div ng-if=\"location.node.tags.DIRECTORY_TYPE=='MODELES_DE_DOCUMENTS' && modelDocuments.length>0\"> <tl-modeles-documents></tl-modeles-documents> </div> <div ng-if=\"location.node.tags.DIRECTORY_TYPE!='MODELES_DE_DOCUMENTS'\"> <div class=page-header fixed-component> <span> <tl-text-input ng-model=display.filter.name placeholder=\"Filtrer par nom\" style=width:250px></tl-text-input> <select ng-model=display.filter.type ng-options=\"c.id as c.label for c in filterAllowedTypes()\"> <option value=\"\">Tous les types</option> </select> </span> <span ng-if=\"display.mode == 'table'\"> <label>Afficher le contenu des sous-répertoires</label> <tl-checkbox ng-model=display.recursive></tl-checkbox> </span> </div> <div class=mt-s ng-if=!loaded> <tl-circular-loader class=small></tl-circular-loader> <span>{{'common.Chargement' | translate}}</span> </div> <div class=box-layout sizable-container as-line-container> <div class=\"{{previewedDoc ? 'box-45' : 'box-100'}}\" sizable-container> <div ng-if=loaded ng-switch=\"location.subNodes.length == 0\"> <div ng-switch-when=true> <p ng-if=\"display.mode !== 'table'\" class=\"mb-l mt-m aucun-document\">{{'documents.AucunDocumentDansCeDossier' | translate}}</p> <p ng-if=\"display.mode === 'table'\" class=\"mb-l mt-m aucun-document\">{{'documents.AucunDocumentDansCeDossierPourCeFiltre' | translate}}</p> </div> <div ng-switch-default class=documents> <div ng-switch=display.mode> <div ng-switch-when=table> <tl-table class=mb-s sizeable-component table-config=documentsTableOptions></tl-table> <div fixed-component class=mb-s></div> </div> <div ng-switch-when=maj> <tl-table class=mb-s sizeable-component table-config=documentsMajTableOptions></tl-table> <div fixed-component class=mb-s></div> </div> <div ng-switch-default class=tl-document-box-list tl-sizeable-block sizeable-component use-max-height> <tl-directory-box ng-repeat=\"directory in location.subNodes | filter:{type:'DIRECTORY'}\" directory=directory ng-click=navigateTo(directory.id)> <tl-icon-button authz-if-role=SAISIE ng-if=!directory.predefined icon=fa-pencil-square-o tl-tooltip=\"{{'documents.Editer'|translate}}\" ng-click=editDirectory(directory)></tl-icon-button> <tl-icon-button authz-if-role=SAISIE ng-if=!directory.predefined icon=fa-share-square-o tl-tooltip=\"{{'documents.Deplacer'|translate}}\" ng-click=moveNode(directory)></tl-icon-button> <tl-icon-button authz-if-role=SAISIE ng-if=\"!directory.predefined && directory.nbReps+directory.nbDocs == 1\" icon=fa-times-circle tl-tooltip=\"{{'documents.Supprimer'|translate}}\" ng-click=removeDirectory(directory)></tl-icon-button> </tl-directory-box> <tl-document-box ng-repeat=\"document in location.subNodes | filter:{type: '!DIRECTORY'}\" document=document> <tl-icon-button icon=fa-eye ng-if=canPreview(document) tl-tooltip=\"{{'documents.Previsualiser'|translate}}\" ng-click=previewDocument(document)></tl-icon-button> <tl-icon-button icon=fa-download ng-if=document.fileId tl-tooltip=\"{{'documents.Telecharger'|translate}}\" ng-click=downloadDocument(document)></tl-icon-button> <tl-icon-button authz-if-role=SAISIE icon=fa-pencil-square-o tl-tooltip=\"{{'documents.Editer'|translate}}\" ng-click=editDocument(document)></tl-icon-button> <tl-icon-button authz-if-role=SAISIE icon=fa-share-square-o tl-tooltip=\"{{'documents.Deplacer'|translate}}\" ng-click=moveNode(document)></tl-icon-button> <tl-icon-button authz-if-role=SAISIE icon=fa-times-circle tl-tooltip=\"{{'documents.Supprimer'|translate}}\" ng-click=removeDocument(document)></tl-icon-button> </tl-document-box> </div> </div> </div> </div> <div authz-if-role=SAISIE fixed-component class=pt-s> <div> <span ng-if=\"display.mode!=='maj'\"> <fileupload-btn ng-if=docUploadAllowedIn(location.node) btn-label-key=documents.AjouterUnDocument options=uploadOptions before-upload=beforeDocumentUpload upload-success=onDocumentUpload></fileupload-btn> <tl-button ng-if=externalDocAllowedIn(location.node) class=btn-secondary ng-click=createDocumentExterne() tl-tooltip=\"{{'documents.PourReferencerParSonUrlUnDocumentGereDansUneAutreGED'|translate}}\"> <i class=\"fa fa-plus-circle\"></i> <span>{{'documents.AjouterUnDocumentExterne' | translate}}</span> </tl-button> <tl-button ng-if=directoryCreationAllowedIn(location.node) class=btn-secondary ng-click=createDirectory()> <i class=\"fa fa-folder-open\"></i> <span>{{'documents.CreerUnRepertoire' | translate}}</span> </tl-button> </span> <tl-button class=btn-primary ng-click=saveMaj() ng-disabled=!hasDirty() ng-if=\"display.mode==='maj'\"> <i class=\"fa fa-save\"></i> <span>{{'documents.EnregistrerLesModifications' | translate}}</span> </tl-button> <tl-button class=btn-primary ng-click=downloadZIP() ng-disabled=\"location.subNodes.length == 0\"> <i class=\"fa fa-file-zip\"></i> <span>{{'documents.TelechargerTousLesDocuments' | translate}}</span> </tl-button> </div> <div ng-if=\"display.mode!=='maj' && docUploadAllowedIn(location.node)\" class=mt-xs> <span>{{'documents.VousPouvezAussiAjouterDesFichiersParGlisserDeposer' | translate}}</span> </div> </div> </div> <div class=box-55 sizable-container ng-if=previewedDoc> <div class=tl-document-preview-block> <div class=box-title fixed-component> <h3>{{previewedDoc.label}}</h3> <tl-icon-button class=btn-close tl-tooltip=\"{{'documents.Fermer'|translate}}\" icon=fa-times ng-click=closePreview()></tl-icon-button> </div> <tl-document-preview sizeable-component document=previewedDoc></tl-document-preview> </div> </div> </div> </div> </div> ";

/***/ }),
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */
/***/ (function(module, exports) {

module.exports = "<div class=banque-option> <div class=icon-col> <div class=icon-wrap ng-if=\"::option.id != null && !option.$notBank\"> <logo-contrepartie size=icon contrepartie-id={{::option.id}} contrepartie-type=BANQUE></logo-contrepartie> </div> </div> <div class=label-col> <span class=label>{{::option.libelleCourtUsuel}}</span> </div> </div>";

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports = "<div class=banque-option> <div class=icon-col> <div class=icon-wrap ng-if=\"::option.id != null && !option.$notBank\"> <logo-contrepartie contrepartie-id={{::option.id}} contrepartie-type=FINANCEUR_SUBVENTION size=icon></logo-contrepartie> </div> </div> <div class=label-col> <span class=label>{{::option.libelleCourtUsuel}}</span> </div> </div>";

/***/ }),
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1835 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1839 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1846 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1858 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1859 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1860 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1864 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1865 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1866 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1869 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1871 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1872 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */,
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */,
/* 2458 */,
/* 2459 */,
/* 2460 */,
/* 2461 */,
/* 2462 */,
/* 2463 */,
/* 2464 */,
/* 2465 */,
/* 2466 */,
/* 2467 */,
/* 2468 */,
/* 2469 */,
/* 2470 */,
/* 2471 */,
/* 2472 */,
/* 2473 */,
/* 2474 */,
/* 2475 */,
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */,
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */,
/* 2510 */,
/* 2511 */,
/* 2512 */,
/* 2513 */,
/* 2514 */,
/* 2515 */,
/* 2516 */,
/* 2517 */,
/* 2518 */,
/* 2519 */,
/* 2520 */,
/* 2521 */,
/* 2522 */,
/* 2523 */,
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */,
/* 2528 */,
/* 2529 */,
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */,
/* 2536 */,
/* 2537 */,
/* 2538 */,
/* 2539 */,
/* 2540 */,
/* 2541 */,
/* 2542 */,
/* 2543 */,
/* 2544 */,
/* 2545 */,
/* 2546 */,
/* 2547 */,
/* 2548 */,
/* 2549 */,
/* 2550 */,
/* 2551 */,
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */,
/* 2593 */,
/* 2594 */,
/* 2595 */,
/* 2596 */,
/* 2597 */,
/* 2598 */,
/* 2599 */,
/* 2600 */,
/* 2601 */,
/* 2602 */,
/* 2603 */,
/* 2604 */,
/* 2605 */,
/* 2606 */,
/* 2607 */,
/* 2608 */,
/* 2609 */,
/* 2610 */,
/* 2611 */,
/* 2612 */,
/* 2613 */,
/* 2614 */,
/* 2615 */,
/* 2616 */,
/* 2617 */,
/* 2618 */,
/* 2619 */,
/* 2620 */,
/* 2621 */,
/* 2622 */,
/* 2623 */,
/* 2624 */,
/* 2625 */,
/* 2626 */,
/* 2627 */,
/* 2628 */,
/* 2629 */,
/* 2630 */,
/* 2631 */,
/* 2632 */,
/* 2633 */,
/* 2634 */,
/* 2635 */,
/* 2636 */,
/* 2637 */,
/* 2638 */,
/* 2639 */,
/* 2640 */,
/* 2641 */,
/* 2642 */,
/* 2643 */,
/* 2644 */,
/* 2645 */,
/* 2646 */,
/* 2647 */,
/* 2648 */,
/* 2649 */,
/* 2650 */,
/* 2651 */,
/* 2652 */,
/* 2653 */,
/* 2654 */,
/* 2655 */,
/* 2656 */,
/* 2657 */,
/* 2658 */,
/* 2659 */,
/* 2660 */,
/* 2661 */,
/* 2662 */,
/* 2663 */,
/* 2664 */,
/* 2665 */,
/* 2666 */,
/* 2667 */,
/* 2668 */,
/* 2669 */,
/* 2670 */,
/* 2671 */,
/* 2672 */,
/* 2673 */,
/* 2674 */,
/* 2675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("aadService", ["$modal", "$http", "$dialogBox", "$q", function ($modal, $http, $dialogBox, $q) {
  return {
    /**
     *
     * @param $scope
     * @param aadId id de l'aad
     * @returns {*}
     */
    openEditionPopin: function openEditionPopin($scope, aadId) {
      return $modal.open({
        scope: $scope,
        controller: "AadCompteEditionPopinController",
        template: __webpack_require__(3652),
        vars: {
          edit: aadId != null,
          aadId: aadId
        },
        options: {
          width: 750
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/aad/aadService.js"))

/***/ }),
/* 2676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("AadCompteEditionPopinController", ["$scope", "$http", "$q", "contrepartieService", "lovService", "indexationService", function ($scope, $http, $q, contrepartieService, lovService, indexationService) {
  $http.get('/rest/intra/utilisateurs/consultants').then(function (response) {
    $scope.consultants = _.sortBy(response.data, function (consultant) {
      return consultant.label;
    });
  });

  // modification d'une aad existante
  if ($scope.aadId) {
    $http.get("/rest/intra/crm/aad/" + $scope.aadId).then(function (response) {
      console.log("aad", response);
      $scope.aad = response.data;
    });
  }
  $scope.aadFormConfig = {
    url: function url() {
      return '/rest/intra/crm/aad/save';
    },
    data: function data() {
      return $scope.aad;
    },
    customValidation: function customValidation() {
      return [];
    },
    fieldPrefix: "aad.",
    onSuccess: function onSuccess(aad) {
      $scope.$close(aad);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/aad/edition/aadCompteEditionPopin.js", __webpack_require__(1)))

/***/ }),
/* 2677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("AbonnementSyntheseMailPopinController", ["$scope", "$q", "$http", "$translate", "$session", "$notifications", "$authz", function ($scope, $q, $http, $translate, $session, $notifications, $authz) {
  $scope.compte = $session.getCompte().nomClient;
  $scope.frequences = [{
    id: 'MENSUELLE',
    label: 'En début de mois'
  }, {
    id: 'TRIMESTRIELLE',
    label: 'En début de trimestre'
  }, {
    id: 'SEMESTRIELLE',
    label: 'En début de semestre'
  }
  //        {id: 'ANNUELLE', label: 'En début d\'année'},
  ];
  if ($authz.hasRole('IT_ADMINISTRATION')) {
    $scope.frequences.push({
      id: 'QUOTIDIENNE',
      label: 'Tous les jours (uniquement pour les admin it)'
    });
  }
  $scope.momentFrequences = [{
    id: 'DEBUT_PERIODE',
    label: 'début de période'
  }, {
    id: 'FIN_PERIODE',
    label: 'fin de période'
  }];
  $scope.abonnement = {
    frequence: 'MENSUELLE',
    //momentFrequence: 'DEBUT_PERIODE',
    premiereSyntheseImmediate: true,
    abonneIds: []
  };
  $http.get('/rest/abonnementSyntheseDette/infos-pour-inscription').then(function (response) {
    $scope.info = response.data;
    $scope.abonnables = response.data.utilisateursAbonnables;
    $scope.utilisateursDejaAbonnes = response.data.utilisateursDejaAbonnes;
    $scope.abonnements = response.data.abonnements;
    $scope.abonnables = $scope.abonnablesList = _.map($scope.abonnables, function (user) {
      return {
        id: user.id,
        label: user.prenom + " " + user.nom
      };
    });
    var moi = _.find($scope.abonnables, {
      id: $session.getUser().id
    });
    if (moi) {
      $scope.abonnement.abonneIds.push(moi.id);
    }
  });
  $scope.formConfig = {
    url: function url() {
      return "/rest/abonnementSyntheseDette/abonnement";
    },
    data: function data() {
      return $scope.abonnement;
    },
    fieldPrefix: "abonnement.",
    onSuccess: function onSuccess(abonnement) {
      $notifications.info('Abonnement effectué.');
      $scope.$close(abonnement);
    },
    customValidation: function customValidation() {
      var errors = [];
      return errors;
    }
  };
  $scope.params = {
    newAbonneId: null
  };
  $scope.abonneList = function () {
    return _.filter($scope.abonnables, function (d) {
      return _.indexOf($scope.abonnement.abonneIds, d.id) === -1;
    });
  };
  $scope.removeAbonne = function (id) {
    var index = _.indexOf($scope.abonnement.abonneIds, id);
    $scope.abonnement.abonneIds.splice(index, 1);
  };
  $scope.addAbonne = function () {
    var abonneId = $scope.params.newAbonneId;

    // si non deja présent dans la liste on l'ajoute
    if (abonneId != null && _.indexOf($scope.abonnement.abonnesId, abonneId) === -1) {
      if ($scope.abonnement.abonneIds == null) {
        $scope.abonnement.abonneIds = [];
      }
      $scope.abonnement.abonneIds.push(abonneId);
    }
    $scope.params.newAbonneId = null;
  };
  $scope.renderUser = function (userId) {
    if ($scope.abonnables) {
      var ts = _.find($scope.abonnables, {
        id: userId
      });
      if (ts) {
        return ts.label;
      }
      return "[" + userId + "]";
    }
  };
  $scope.tableConfig = {
    id: "abonnementSynthese",
    source: "abonnements",
    allowSelection: true,
    selectionScope: $scope,
    selectionAttribute: "selected",
    initialSort: [0, "asc"],
    columns: [{
      attribute: 'utilisateur',
      title: "",
      cellClass: 'align-c',
      width: "25px"
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/abonnementSyntheseMail/abonnementSyntheseMailPopinController.js", __webpack_require__(1)))

/***/ }),
/* 2678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("abonnementSyntheseMailService", ["$http", "$modal", function ($http, $modal) {
  var createPopinOptions = {
    controller: "AbonnementSyntheseMailPopinController",
    template: __webpack_require__(3653)
  };
  return {
    abonnementPopin: function abonnementPopin() {
      return $modal.open(_.extend(createPopinOptions, {
        vars: {},
        options: {
          escape: false
        }
      }));
    },
    delete: function _delete(abonnementId) {
      return $http.delete('/rest/abonnementSyntheseDette/delete/' + abonnementId);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/abonnementSyntheseMail/abonnementSyntheseMailService.js", __webpack_require__(1)))

/***/ }),
/* 2679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlBookmark", ["$location", "$http", "$notifications", "$translate", "$applications", function ($location, $http, $notifications, $translate, $applications) {
  return {
    restrict: "E",
    scope: {
      titre: "@",
      icone: "@",
      url: "@",
      /**
       * type : optionnel, permet d'identifier facilement que des liens sont de même nature
       */
      type: "@",
      /**
       * optionnel, permet d'avoir un identifiant le d'entité qui a été bookmarquée
       */
      entiteId: "@"
    },
    replace: true,
    template: __webpack_require__(3654),
    controller: ["$scope", function controller($scope) {
      $scope.bookmarkUrl = $scope.url;
      $scope.$watch('url', function (newUrl) {
        // evite d'afficher le lien tant qu'on a pas chargé
        $scope.loaded = false;
        if (!$scope.url) {
          // par defaut l'url courant
          $scope.bookmarkUrl = $location.url();
        } else {
          $scope.bookmarkUrl = $scope.url;
        }
        $http.get('/rest/bookmark/url', {
          params: {
            url: $scope.bookmarkUrl
          }
        }).then(function (response) {
          $scope.loaded = true;
          // on récupère "" si rien... étrange non ?
          if (response.data && response.data.id != null) {
            $scope.bookmark = response.data;
          } else {}
        }).finally(function () {});
      });
      $scope.changeBookmark = function () {
        if ($scope.bookmark == null) {
          $http.post("/rest/bookmark/save", {
            url: $scope.bookmarkUrl,
            titre: $scope.titre || $scope.url,
            icone: $scope.icone,
            type: $scope.type,
            entiteId: $scope.entiteId,
            application: $applications.getCurrentAppId()
          }).then(function (response) {
            $scope.bookmark = response.data;
            $notifications.info($translate("raccourci.Enregistre"));
          });
        } else {
          $http.delete("/rest/bookmark/delete/" + $scope.bookmark.id);
          $scope.bookmark = null;
          $notifications.info($translate("raccourci.Retire"));
        }
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/bookmark/tlBookmark.js"))

/***/ }),
/* 2680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("SaisieBudgetCreationPopinController", ["$scope", "$http", "$translate", "$session", "$q", "lovService", "contextService", "$authz", "etatDetteService", "$applications", function ($scope, $http, $translate, $session, $q, lovService, contextService, $authz, etatDetteService, $applications) {
  var reloadContext = function reloadContext() {
    contextService.refreshData();
  };
  etatDetteService.getOrInitParams().then(function (params) {
    $scope.plansComptables = _.map(params.plansComptablesAccessibles, function (plan) {
      return {
        id: plan.id,
        label: $translate("lov.plansComptables." + plan.id)
      };
    });
  });
  var compte = $session.getCompte();
  var parentBudget = $scope.parent;

  // tout type de compte qui peut avoir de la dette garantie doit etre inclu
  $scope.collectivite = $session.getCompte().typeCompte === 'EPCI' || $session.getCompte().typeCompte === 'COMMUNE' || $session.getCompte().typeCompte === 'METROPOLE_ET_COLLECTIVITE_TERRITORIALE' || $session.getCompte().typeCompte === 'DEPARTEMENT' || $session.getCompte().typeCompte === 'REGION' || $session.getCompte().typeCompte === 'SYNDICAT';
  $scope.referenceCIRILMaxLength = parentBudget == null ? 2 : 10;
  if (!$scope.edition) {
    $scope.budget = {
      children: [],
      compteId: parentBudget ? parentBudget.compteId : compte.id,
      // module subvention coché par défaut si on a le module subvention - seuls les budgets racines sont concernés
      moduleSubvention: parentBudget == null && $session.getCompte().moduleSubvention,
      // module subvention coché par défaut si on a le module dette - seuls les budgets racines sont concernés
      moduleDette: parentBudget == null && $applications.getApp("DETTE").isAllowed($session.getHabilitations()),
      compteBudgetAvecModuleDette: parentBudget == null && $applications.getApp("DETTE").isAllowed($session.getHabilitations()),
      compteBudgetAvecModuleSubvention: parentBudget == null && $session.getCompte().moduleSubvention
    };
  }
  var originalBudget = $scope.budget;
  var budget = $scope.budget = angular.copy(originalBudget);
  $scope.comptesLies = [{
    "id": compte.id,
    "nom": compte.nomClient
  }];
  _.each(compte.comptesLies, function (nom, id) {
    $scope.comptesLies.push({
      "id": id,
      "nom": nom
    });
  });
  $scope.aComptesLies = $session.possedeComptesLies();
  $scope.params = {
    budgetPrincipal: $scope.budget.type === 'PRINCIPAL'
  };
  $scope.$watch('params.budgetPrincipal', function () {
    if ($scope.params.budgetPrincipal) {
      $scope.budget.type = 'PRINCIPAL';
    } else {
      $scope.budget.type = null;
    }
  });
  $scope.saveBudget = function () {
    // validation
    $scope.errorMessage = null;
    if (_.isEmpty(budget.nom)) {
      $scope.errorMessage = $translate('saisie.budget.creationPopin.name_required');
      return;
    }
    // if (budget.type === 'PRINCIPAL' && _.isEmpty(budget.planComptable)) {
    //     $scope.errorMessage = $translate('saisie.budget.creationPopin.planComptable_required');
    //     return;
    // }

    var savePromise = null;

    // saving
    if ($scope.edition) {
      savePromise = $http.post("/rest/budgets/" + budget.id, budget);
    } else {
      savePromise = $http.post("/rest/budgets/new", budget, {
        params: {
          parentId: parentBudget && parentBudget.id || null
        }
      });
    }
    savePromise.then(function (response) {
      var validation = response.data;
      if (validation.valid) {
        $scope.$close(validation.result);
      } else {
        $scope.errorMessage = validation.errors[0].message;
      }
      reloadContext();
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/budget/gestionBudgets/budgetCreationPopin.js", __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 2681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("SaisieBudgetDeplacementPopinController", ["$scope", "$http", "$translate", "$session", "$q", "lovService", "contextService", "budgetService", function ($scope, $http, $translate, $session, $q, lovService, contextService, budgetService) {
  var reloadContext = function reloadContext() {
    contextService.refreshData();
  };
  var compte = $session.getCompte();
  var parentBudget = $scope.parent;
  var originalBudget = $scope.originalBudget = $scope.budget;
  var budget = $scope.budget = angular.copy(originalBudget);
  var sep = function sep(depth) {
    if (depth === 0) {
      return "";
    } else {
      var _spaces = String.fromCharCode(160) + String.fromCharCode(160) + String.fromCharCode(160) + String.fromCharCode(160);
      var spaces = _spaces;
      for (var i = 1; i < depth; i++) {
        spaces += _spaces;
      }
      return spaces;
    }
  };
  $http.get('/rest/budgets/possibilites-deplacements/' + budget.id).then(function (response) {
    var budgetsDeplacement = budgetService.flattenTree(response.data);
    $scope.budgetsDeplacement = _.each(budgetsDeplacement, function (b) {
      return b.nom = sep(b.depth) + " " + b.nom;
    });
  });
  $scope.saveBudget = function () {
    // saving
    var savePromise = $http.post("/rest/budgets/deplace-budget?budgetId=" + budget.id + "&newParentId=" + budget.parentId);
    savePromise.then(function (response) {
      var validation = response.data;
      reloadContext();
      $scope.$close(budget);
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/budget/gestionBudgets/budgetDeplacementPopin.js", __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('gestionBudgets', function () {
  return {
    restrict: 'E',
    scope: true,
    template: __webpack_require__(3657),
    controller: 'GestionBudgetsController'
  };
});
ngModule.controller('GestionBudgetsController', ["$scope", "$q", "$http", "$modal", "$compile", "$session", "budgetService", "contextService", "$dialogBox", function ($scope, $q, $http, $modal, $compile, $session, budgetService, contextService, $dialogBox) {
  var reloadContext = function reloadContext() {
    contextService.refreshData();
  };
  var loadBudgets = function loadBudgets() {
    return $q.when(budgetService.findAll({
      showArchive: true,
      showAllModules: true
    })).then(function (budgets) {
      $scope.budgets = budgets;
    });
  };
  loadBudgets();
  function refreshBudgetService() {
    budgetService.$reload();
  }
  $scope.$on("$destroy", function () {
    refreshBudgetService();
  });

  //// comptes liées
  var compte = $session.getCompte();
  $scope.comptesLies = [{
    "id": compte.id,
    "nom": compte.nomClient
  }];
  _.each(compte.comptesLies, function (nom, id) {
    $scope.comptesLies.push({
      "id": id,
      "nom": nom
    });
  });
  $scope.aComptesLies = $session.possedeComptesLies();
  $scope.compteLie = function (compteId) {
    return _.find($scope.comptesLies, function (e) {
      return e.id === compteId;
    }).nom;
  };
  ////

  var creationPopinModalOptions = {
    controller: "SaisieBudgetCreationPopinController",
    template: __webpack_require__(3655),
    options: {
      width: 800
    }
  };
  var deplacementPopinModalOptions = {
    controller: "SaisieBudgetDeplacementPopinController",
    template: __webpack_require__(3656),
    options: {
      width: 800
    }
  };
  $scope.openCreationPopin = function (parentBudget) {
    return $modal.open(_.extend(creationPopinModalOptions, {
      vars: {
        parent: parentBudget
      }
    }));
  };
  $scope.openEditionPopin = function (budget) {
    return $modal.open(_.extend(creationPopinModalOptions, {
      vars: {
        edition: true,
        budget: budget
      }
    }));
  };
  $scope.openDeplacementPopin = function (budget) {
    return $modal.open(_.extend(deplacementPopinModalOptions, {
      vars: {
        budget: budget
      }
    }));
  };

  // context menu

  var openedContextMenu = null;
  var contextMenuRow = null;
  var contextMenuLink = $compile("<saisie-budget-context-menu></saisie-budget-context-menu>");
  $scope.showBudgetContextMenu = function (budget, event) {
    $scope.hideBudgetContextMenu();
    var row = $(event.currentTarget);
    if (row.is(contextMenuRow)) {
      contextMenuRow = null;
      return;
    }
    contextMenuRow = row;
    var contextMenuScope = $scope.$new();
    _.extend(contextMenuScope, {
      budget: budget
    });
    contextMenuLink(contextMenuScope, function (contextMenu) {
      openedContextMenu = contextMenu;
      contextMenu.appendTo(row);
    });
  };
  $scope.hideBudgetContextMenu = function () {
    if (openedContextMenu == null) {
      return;
    }
    openedContextMenu.scope().$destroy();
    openedContextMenu.remove();
    openedContextMenu = null;
  };

  // end context menu

  var getTreeTableConfig = function getTreeTableConfig() {
    return {
      source: "budgets",
      labelAttribute: "nom",
      childrenAttribute: "children",
      mainCellContentTemplate: '' + '<div class="budget" ng-click="showBudgetContextMenu(model, $event)">' + '   <i class="fa {{depth == 0 ? \'fa-book\' : \'fa-file-text\'}}"></i>' + '<i class="fa fa-parking-circle blue principal" tl-tooltip="Budget principal" ng-if="model.type===\'PRINCIPAL\'"></i>' + '   <span style="text-decoration : underline {{model.color||\'undefined\'}} 3px">{{model.nom}}' + '<span ng-if="model.planComptable"> ({{"lov.plansComptables."+model.planComptable|translate}})</span></span>' + '<span ng-if="model.archive" class="b i"> (Archivé)</span>' + '<span ng-if="model.moduleSubvention && model.compteBudgetAvecModuleDette" class="module-pill capitalise-pill ml-xs" tl-tooltip="Budget disponible dans le module Subvention">S</span>' + '<span ng-if="model.moduleDette && model.compteBudgetAvecModuleSubvention" class="module-pill sim-pill ml-xs" tl-tooltip="Budget disponible dans le module Dette">D</span>' + '   <span class="ml-xs" ng-if="aComptesLies">({{compteLie(model.compteId)}})</span>' + '</div>'
    };
  };
  $scope.treeTableConfig = getTreeTableConfig();
  $scope.addBudget = function () {
    return $scope.openCreationPopin().then(function (newBudget) {
      $scope.budgets.push(newBudget);
      refreshBudgetService();
    });
  };
  $scope.addChildBudget = function (parentBudget) {
    return $scope.openCreationPopin(parentBudget).then(function (newBudget) {
      parentBudget.children.push(newBudget);
      refreshBudgetService();
    });
  };
  $scope.editBudget = function (budget) {
    return $scope.openEditionPopin(budget).then(function (editedBudget) {
      _.extend(budget, editedBudget);
      refreshBudgetService();
    });
  };
  $scope.deplaceBudget = function (budget) {
    return $scope.openDeplacementPopin(budget).then(function (movedBudget) {
      removeBudget(budget);

      // trouve le nouveau budget parent et ajoute ce budget
      if (movedBudget.parentId == null) {
        $scope.budgets.push(movedBudget);
      } else {
        var newParentBudget = findBudget($scope.budgets, movedBudget.parentId);
        newParentBudget.children.push(movedBudget);
      }
      refreshBudgetService();
    });
  };
  function removeBudget(budget) {
    var budgetIdx;
    if (budget.parentId) {
      var parentBudget = findParentBudget($scope.budgets, budget.id);
      budgetIdx = _.indexOf(parentBudget.children, budget);
      parentBudget.children.splice(budgetIdx, 1);
    } else {
      budgetIdx = _.indexOf($scope.budgets, budget);
      $scope.budgets.splice(budgetIdx, 1);
    }
  }
  $scope.deleteBudget = function (budget) {
    $http.post("/rest/budgets/" + budget.id + "/delete", budget).then(function (response) {
      var data = response.data;
      if (data === null || data.length === 0) {
        removeBudget(budget);
        refreshBudgetService();
        reloadContext();
      } else {
        var max = 8;
        var msg = "";
        var items;
        if (data.length > max) {
          items = data.slice(0, max);
        } else {
          items = data;
        }
        _.each(items, function (item) {
          msg += '<p>' + item.response + '</p>';
        });
        if (data.length > max) {
          msg += '<p class="i mt-s">' + 'et ' + (data.length - max) + ' autres erreurs...' + '</p>';
        }
        $dialogBox.alert({
          title: "Impossible de supprimer ce budget",
          html: msg
        });
      }
    });
  };
  var findParentBudget = function findParentBudget(budgetList, budgetId) {
    var budget;
    var _recurseFind = function recurseFind(children, parentBudget) {
      for (var i = 0; i < children.length; i++) {
        budget = children[i];
        if (budget.id === budgetId) {
          return parentBudget;
        } else if (budget.children.length) {
          budget = _recurseFind(budget.children, budget);
          if (budget) {
            return budget;
          }
        }
      }
      return null;
    };
    return _recurseFind(budgetList, null);
  };
  var findBudget = function findBudget(budgetList, budgetId) {
    var budget;
    var _recurseFind2 = function recurseFind(children, parentBudget) {
      for (var i = 0; i < children.length; i++) {
        budget = children[i];
        if (budget.id === budgetId) {
          return budget;
        } else if (budget.children.length) {
          budget = _recurseFind2(budget.children, budget);
          if (budget) {
            return budget;
          }
        }
      }
      return null;
    };
    return _recurseFind2(budgetList, null);
  };
}]);
ngModule.directive("saisieBudgetContextMenu", ["$dialogBox", "$translate", function ($dialogBox, $translate) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '<div class="budget-context-menu">' + '<i ng-click="onEditClick()" class="fa fa-edit" title="Editer le budget"></i>' + '<i ng-click="onAddClick()" class="fa fa-plus-square" title="Ajouter un sous-budget"></i>' + '<i authz-if-intra ng-click="onDeplaceClick()" class="fa fa-arrow-right" title="Deplacer ce budget"></i>' + '<i ng-if="!budget.children.length" ng-click="onDeleteClick()" class="fa fa-times-circle" title="Supprimer ce budget"></i>' + '</div>',
    link: function link($scope, $el, $attrs) {
      var budget = $scope.budget;
      $el.click(function (event) {
        event.stopPropagation();
      });
      $scope.onEditClick = function () {
        $scope.hideBudgetContextMenu();
        $scope.editBudget(budget);
      };
      $scope.onAddClick = function () {
        $scope.hideBudgetContextMenu();
        $scope.addChildBudget(budget);
      };
      $scope.onDeplaceClick = function () {
        $scope.hideBudgetContextMenu();
        $scope.deplaceBudget(budget);
      };
      $scope.onDeleteClick = function () {
        $scope.hideBudgetContextMenu();
        $dialogBox.confirm({
          title: $translate("saisie.budget.popins.delete.title"),
          text: $translate("saisie.budget.popins.delete.text", {
            budget: budget.nom
          })
        }).then(function () {
          $scope.deleteBudget(budget);
        });
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/budget/gestionBudgets/gestionBudgets.js", __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 2683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("ifBudget", ["$animate", "budgetService", function ($animate, budgetService) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (budgetService.isNommageBudget()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/budget/if-budget.js"))

/***/ }),
/* 2684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("ifOperation", ["$animate", "budgetService", function ($animate, budgetService) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (budgetService.isNommageOperation()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/budget/if-operation.js"))

/***/ }),
/* 2685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("saisieChampAdditionnel", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      cible: "@cible",
      classifications: "@"
    },
    template: __webpack_require__(3658),
    link: function link($scope, $el, $attrs) {},
    controller: ["$scope", "$q", "$http", "$modal", "$compile", "$applications", "$element", "$session", "budgetService", "contextService", "$dialogBox", "classificationService", "tlTableUtils", "$notifications", "$rootScope", "$location", "pageStatus", function controller($scope, $q, $http, $modal, $compile, $applications, $element, $session, budgetService, contextService, $dialogBox, classificationService, tlTableUtils, $notifications, $rootScope, $location, pageStatus) {
      var urlRoot = '/rest/saisie/champAdditionnel';
      $scope.moduleSubvention = $applications.isAideSubventionApplication();
      var load = function load() {
        return $http.get(urlRoot + "/champsLibresPourCible/" + $scope.cible, {
          params: {
            avecClassifications: true
          }
        }).then(function (response) {
          $scope.champs = response.data;
          $scope.selectedChamp = tlTableUtils.getNewTableSelection($scope.selectedChamp, $scope.champs);
          if ($scope.selectedChamp == null && $scope.champs.length > 0) {
            // idealement ce serait plutôt la première ligne du tableau (peu importe les tris) qu'on voudrait voir sélectionnée
            $scope.selectedChamp = $scope.champs[0];
          }
        });
      };
      $scope.sortableOptions = {
        axis: 'y',
        handle: '.grip',
        cancel: '.grip.disabled',
        items: "tr:has(.grip)",
        placeholder: "sortable-placeholder",
        start: function start(e, ui) {
          // Sélectionne la ligne dès le début du déplacement pour un retour visuel immédiat.
          $scope.$apply(function () {
            $scope.selectedChamp = ui.item.scope().model;
          });

          // L'assistant est un clone, on doit lui ajouter manuellement la classe de sélection
          // pour qu'il ait la bonne couleur pendant le déplacement.
          ui.helper.addClass('selected');

          // Ajuste la hauteur du placeholder pour correspondre à l'élément déplacé
          ui.placeholder.height(ui.item.height());
        },
        stop: function stop(e, ui) {
          // L'ID de l'élément qui a été déplacé.
          var movedChampId = ui.item.scope().model.id;
          var orderedIds = $scope.champs.map(function (champ) {
            return champ.id;
          });
          $scope.submitting = true;
          $http.post('/rest/saisie/champAdditionnel/reorder', orderedIds).then(function () {
            classificationService.$reload();
            //load().then(() => {
            $notifications.info('Ordre des champs mis à jour.');
            // Resynchronise la sélection avec l'objet de la nouvelle liste pour éviter les données périmées.
            var newSelectedChamp = $scope.champs.find(function (c) {
              return c.id === movedChampId;
            });
            if (newSelectedChamp) {
              $scope.selectedChamp = newSelectedChamp;
            }
            //});
          }).catch(function () {
            $notifications.error('Erreur lors de la mise à jour de l\'ordre des champs.');
            load();
          }).finally(function () {
            $scope.submitting = false;
          });
        },
        helper: function helper(e, tr) {
          var $originals = tr.children();
          var $helper = tr.clone();
          $helper.children().each(function (index) {
            $(this).width($originals.eq(index).width());
          });
          return $helper;
        }
      };
      var unwatchEditChamp;
      var watchEditChamp = function watchEditChamp() {
        unwatchEditChamp = $scope.$watch('editChamp', function (newVal, oldVal) {
          if ($scope.editChamp && oldVal != null && oldVal !== newVal) {
            console.log('$scope.editChamp dirty', newVal, oldVal);
            $scope.editChamp.$dirty = true;
          }
        }, true);
      };
      watchEditChamp();
      var cible = $scope.cible;
      var labelNommageCible = "?";
      if (cible === 'PRODUIT') {
        if ($scope.moduleSubvention) {
          labelNommageCible = "subvention";
        } else {
          labelNommageCible = "produit";
        }
      } else {
        labelNommageCible = cible === 'COMPTE' ? "entité" : cible === 'PROJET' ? "projet" : "contrepartie";
      }
      $scope.typesClassification = [];
      $scope.typesClassification.push({
        id: 'SIMPLE',
        label: "Une valeur par " + labelNommageCible
      });
      if (cible !== 'CONTREPARTIE') {
        $scope.typesClassification.push({
          id: 'MULTIPLE',
          label: "Plusieurs valeurs par " + labelNommageCible
        });

        // pour le moment pas de classif répartissables sur le module subvnetion
        if (!$scope.moduleSubvention) {
          $scope.typesClassification.push({
            id: 'REPARTITION',
            label: "Valeurs répartissables en % par " + labelNommageCible
          });
        }
      }

      /**
       * a chaque changement de selection on doit desactiver le watch de l'edit pour le changer
       */
      function updateEditChampWithSelectedChamp() {
        // on debranche le watch pour pouvoir modifier l'edit sans le marquer en dirty
        unwatchEditChamp();
        if (!$scope.selectedChamp) {
          $scope.editChamp = null;
        } else {
          $scope.editChamp = _.extend({}, $scope.selectedChamp);
        }
        // et on le rebranche
        watchEditChamp();
      }
      var watchChamp = function watchChamp() {
        $scope.$watch('selectedChamp', function (newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }
          updateEditChampWithSelectedChamp();
        });
      };
      watchChamp();
      $scope.selectChamp = function (champ, $event) {
        // Si le clic provient de la poignée de déplacement, on ne fait rien pour laisser le drag-and-drop s'activer.
        if ($event && $($event.target).hasClass('grip')) {
          return;
        }
        if ($scope.editChamp && $scope.editChamp.$dirty) {
          $dialogBox.alert({
            title: "Vous avez des modification non sauvegardée.",
            text: "Veuillez sauvegarder ou annuler vos modifications avant de changer de champ additionnel"
          });
          if ($event) $event.stopPropagation();
          return;
        }
        $scope.selectedChamp = champ;
      };
      $scope.addChamp = function () {
        classificationService.openChampAdditionnelCreationPopin($scope.cible).then(function (response) {
          // pour permettre de sélectionner le champ créée
          $scope.selectedChamp = {
            id: response.id
          };
          load();
          pageStatus.invalidate();
          classificationService.$reload();
        });
      };
      $scope.annulerModifications = function () {
        updateEditChampWithSelectedChamp();
        $notifications.info('Modifications annulées');
      };
      $scope.save = function () {
        $scope.errors = null;
        $scope.submitting = true;
        $http.post('/rest/saisie/champAdditionnel', $scope.editChamp).then(function (response) {
          var validation = response.data;
          if (validation.valid) {
            return load().then(function () {
              $notifications.info('Modifications enregistrées');
              updateEditChampWithSelectedChamp();
              pageStatus.invalidate();
              classificationService.$reload();
            });
          } else {
            $scope.errors = validation.errors;
            $element.find(".libelle")[0].scrollIntoView({
              block: "start",
              inline: "nearest",
              behavior: "smooth"
            });
          }
        }).finally(function () {
          $scope.submitting = false;
        });
      };
      $scope.editClassificationValue = function (classification) {
        classificationService.openEditionValeursPopin(classification).then(function () {
          load();
          pageStatus.invalidate();
          classificationService.$reload();
        });
      };
      $scope.deleteChamp = function (champ) {
        if ($scope.editChamp.$dirty) {
          //$notifications.warn("Veuillez sauvegarder ou annuler vos modifications avant de supprimer le champ")
          return;
        }
        $dialogBox.confirm({
          title: "Suppression d'un champ additionnel",
          text: "Êtes-vous sûr de vouloir supprimer le champ additionnel '" + champ.nom + "' ?"
        }).then(function () {
          classificationService.delete(champ.id).then(function (response) {
            if (response.valid) {
              $notifications.info("Champ additionnel " + champ.nom + " supprimé.");
              load();
              classificationService.$reload();
            }
          });
        });
      };
      var forcePageQuit = false;
      // show confirm dialog on location change is produit has been modified since last save.
      $rootScope.$on("$locationChangeStart", function (event, next, current) {
        var showDialog = !(forcePageQuit || !($scope.editChamp && $scope.editChamp.$dirty));
        if (showDialog) {
          event.preventDefault();
          $dialogBox.confirm({
            title: "Modifications non sauvegardées",
            text: "Le champ additionel contient des modification non sauvegardées. Si vous quittez maintenant, " + "toutes les modifications seront perdues. Êtes-vous sûr de vouloir quitter ?"
          }).then(function () {
            forcePageQuit = true;
            $scope.annulerModifications();
            $location.$$parse(next);
          });
        }
      });
      load();
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/champAdditionnel/saisieChampAdditionnel.js", __webpack_require__(4), __webpack_require__(1)))

/***/ }),
/* 2686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
ngModule.controller('CheckEcheanceEditionController', ["$scope", "$translate", "$q", "$http", "UUID", "$modal", "$notifications", "arrayUtils", "$dateFormat", "$dialogBox", "tlTableUtils", "lovService", function ($scope, $translate, $q, $http, UUID, $modal, $notifications, arrayUtils, $dateFormat, $dialogBox, tlTableUtils, lovService) {
  // On travaille sur une copie
  $scope.editedEcheance = _objectSpread({}, $scope.echeance);
  $q.when(lovService.getValidationStates()).then(function (validationStates) {
    $scope.validationStates = _.reject(validationStates, function (state) {
      return state.id === 'NON_VERIFIE';
    });
  });
  $scope.saving = false;
  $scope.validateAndSave = function () {
    $scope.saving = true;
    $scope.echeance.validation = $scope.editedEcheance.validation;
    $scope.echeance.numeroMandat = $scope.editedEcheance.numeroMandat;
    $scope.echeance.validationUser = null;
    $scope.echeance.validationDate = null;
    $http.post('/rest/evenementsGestionProduit/' + $scope.produitId + '/validationEcheance/', $scope.echeance).then(function (response) {
      $scope.$close();
    }).finally(function () {
      $scope.saving = false;
    });
  };

  // Utilitaires
  $scope.formatDate = function (value) {
    return $dateFormat.short(value);
  };
  $scope.formatePointage = function (model) {
    var pointage = "";
    pointage += "Pointé par ";
    pointage += model.validationUser ? model.validationUser : "vous-même";
    pointage += model.validationDate ? " le " + $dateFormat.short(model.validationDate) : " à l'instant";
    return pointage;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/checkEcheance/checkEcheanceEdition.js", __webpack_require__(1)))

/***/ }),
/* 2687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("checkEcheanceService", ["$modal", "$http", "$dialogBox", "$q", function ($modal, $http, $dialogBox, $q) {
  var createPopinOptions = {
    controller: "CheckEcheanceEditionController",
    template: __webpack_require__(3659)
  };
  return {
    openPopin: function openPopin(produitId, echeance) {
      return $modal.open(_.extend(createPopinOptions, {
        vars: {
          produitId: produitId,
          echeance: echeance
        },
        options: {
          width: 600
        }
      }));
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/checkEcheance/checkEcheanceService.js", __webpack_require__(1)))

/***/ }),
/* 2688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("ChampAdditionnelCreationPopinController", ["$scope", "$applications", "$q", "$http", "$translate", "lovService", "$notifications", "classificationService", "contextService", function ($scope, $applications, $q, $http, $translate, lovService, $notifications, classificationService, contextService) {
  var isEdit = $scope.edit;
  var cible = $scope.cible;
  $scope.moduleSubvention = $applications.isAideSubventionApplication();
  var originalClassification = isEdit || $scope.classification != null ? $scope.classification : {
    nom: null,
    type: 'CLASSIFICATION',
    cible: cible,
    affichages: $scope.moduleSubvention ? ['CREATION'] : null,
    // pour le type 'CLASSIFICATION'
    pseudoType: "SIMPLE"
  };
  var classification = $scope.classification = angular.copy(originalClassification);
  $scope.originalClassification = angular.copy(originalClassification);
  $scope.typesChamps = [{
    id: 'CLASSIFICATION',
    label: "Classification"
  }, {
    id: 'STRING',
    label: "Texte"
  }, {
    id: 'LONG',
    label: "Nombre (entier)"
  }, {
    id: 'DOUBLE',
    label: "Nombre (décimal)"
  }, {
    id: 'POURCENTAGE',
    label: "Nombre (pourcentage)"
  }, {
    id: 'DATEMIDNIGHT',
    label: "Date"
  }, {
    id: 'BOOLEAN',
    label: "Oui / Non"
  }

  //        {id: 'MONTANT', label: "Montant"},
  ];
  if ($applications.isAideSubventionApplication() && (cible === 'PRODUIT' || cible === 'PROJET')) {
    $scope.typesChamps.push({
      id: 'UTILISATEUR',
      label: "Utilisateur"
    }, {
      id: 'GROUPE',
      label: "Groupe"
    });
  }
  var labelNommageCible = "?";
  if (cible === 'PRODUIT') {
    if ($scope.moduleSubvention) {
      labelNommageCible = "subvention";
    } else {
      labelNommageCible = "produit";
    }
  } else {
    labelNommageCible = cible === 'COMPTE' ? "entité" : cible === 'PROJET' ? "projet" : "contrepartie";
  }
  $scope.typesClassification = [];
  $scope.typesClassification.push({
    id: 'SIMPLE',
    label: "Une valeur par " + labelNommageCible
  });
  if (cible !== 'CONTREPARTIE') {
    $scope.typesClassification.push({
      id: 'MULTIPLE',
      label: "Plusieurs valeurs par " + labelNommageCible
    });

    // pour le moment pas de classif répartissables sur le module subvnetion
    if (!$scope.moduleSubvention) {
      $scope.typesClassification.push({
        id: 'REPARTITION',
        label: "Valeurs répartissables en % par " + labelNommageCible
      });
    }
  }
  $scope.classificationFormConfig = {
    url: function url() {
      return '/rest/saisie/champAdditionnel';
    },
    data: function data() {
      return classification;
    },
    fieldPrefix: "classification.",
    customValidation: function customValidation() {
      var errors = [];
      if ($scope.classification.nom == null || $scope.classification.nom.trim().length === 0) {
        errors.push({
          fieldName: 'nom',
          message: 'Le nom est obligatoire.'
        });
      }
      return errors;
    },
    onSuccess: function onSuccess(savedClassification) {
      _.extend(classification, savedClassification);
      classificationService.$reload();
      // on change la structure (nombre de filtres du contexte), il faut donc rechager le contexte
      contextService.reloadContext();
      contextService.refreshData();
      $notifications.info("Champs additionnel enregistré");
      $scope.$close(classification);
    },
    onError: function onError(errors) {}
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/classification/champAdditionnelCreationPopin.js", __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("ClassificationCreationPopinController", ["$scope", "$applications", "$q", "$http", "$translate", "lovService", "$notifications", "classificationService", "contextService", function ($scope, $applications, $q, $http, $translate, lovService, $notifications, classificationService, contextService) {
  var isEdit = $scope.edit;
  var cible = $scope.cible;
  var classifications = $scope.classifications;
  $scope.moduleSubvention = $applications.isAideSubventionApplication();
  var originalClassification = isEdit || $scope.classification != null ? $scope.classification : {
    nom: null,
    pseudoType: 'SIMPLE',
    type: 'CLASSIFICATION',
    cible: cible,
    affichages: $scope.moduleSubvention ? ['CREATION'] : null
  };
  var classification = $scope.classification = angular.copy(originalClassification);
  $scope.originalClassification = angular.copy(originalClassification);
  var labelNommageCible = "?";
  if (cible === 'PRODUIT') {
    if ($scope.moduleSubvention) {
      labelNommageCible = "subvention";
    } else {
      labelNommageCible = "produit";
    }
  } else {
    labelNommageCible = cible === 'COMPTE' ? "entité" : cible === 'PROJET' ? "projet" : "contrepartie";
  }
  $scope.typesClassification = [];
  $scope.typesClassification.push({
    id: 'SIMPLE',
    label: "Une valeur par " + labelNommageCible
  });
  if (cible !== 'CONTREPARTIE') {
    $scope.typesClassification.push({
      id: 'MULTIPLE',
      label: "Plusieurs valeurs par " + labelNommageCible
    });

    // pour le moment pas de classif répartissables sur le module subvnetion
    if (!$scope.moduleSubvention) {
      $scope.typesClassification.push({
        id: 'REPARTITION',
        label: "Valeurs répartissables en % par " + labelNommageCible
      });
    }
  }
  $scope.saisieValide = function () {
    return false;
  };
  $scope.nomExistant = function () {
    return _.some(classifications, function (c) {
      return $scope.classification.nom === c.nom && $scope.classification.id !== c.id;
    });
  };
  $scope.classificationFormConfig = {
    url: function url() {
      return '/rest/saisie/champAdditionnel';
    },
    data: function data() {
      return classification;
    },
    fieldPrefix: "classification.",
    customValidation: function customValidation() {
      var errors = [];
      if ($scope.classification.nom == null || $scope.classification.nom.trim().length === 0) {
        errors.push({
          fieldName: 'nom',
          message: 'Le nom est obligatoire.'
        });
      }
      if ($scope.classification.nom !== null && $scope.nomExistant()) {
        errors.push({
          fieldName: 'nom',
          message: 'Il existe déjà une classification portant ce nom.'
        });
      }
      return errors;
    },
    onSuccess: function onSuccess(savedClassification) {
      _.extend(classification, savedClassification);
      classificationService.$reload();
      // on change la structure (nombre de filtres du contexte), il faut donc rechager le contexte
      contextService.reloadContext();
      contextService.refreshData();
      $notifications.info("Classification enregistrée");
      $scope.$close(classification);
    },
    onError: function onError(errors) {}
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/classification/classificationCreationPopin.js", __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("classificationService", ["$modal", "$http", "$dialogBox", "$q", "contextService", function ($modal, $http, $dialogBox, $q, contextService) {
  var createPopinOptions = {
    controller: "ClassificationCreationPopinController",
    template: __webpack_require__(3661)
  };
  var createChampAdditionnelPopinOptions = {
    controller: "ChampAdditionnelCreationPopinController",
    template: __webpack_require__(3660)
  };
  var editionValeursPopinOptions = {
    controller: "ClassificationValeursEditionPopinController",
    template: __webpack_require__(3663)
  };

  /**
   * champs additionnels quelque soit leur type
   */
  var classifications = null;
  var loadIfRequired = function loadIfRequired(cible) {
    if (classifications == null) {
      return doServerSync();
    } else {
      return classifications[cible];
    }
  };
  var doServerSync = function doServerSync() {
    var deferred = $q.defer();
    $http.get("/rest/saisie/champAdditionnel/list").then(function (response) {
      classifications = response.data;
      deferred.resolve(classifications);
    });
    return deferred.promise;
  };
  return {
    $reload: function $reload() {
      return doServerSync();
    },
    /**
     * champs additionnels et classifications
     * @returns {*}
     */
    findAllMultiplesCibles: function findAllMultiplesCibles(cibles) {
      var requetes = [];
      cibles.forEach(function (cible) {
        requetes.push(loadIfRequired(cible));
      });
      return $q.all(requetes).then(function () {
        return _.filter(classifications, function (c) {
          return !cibles || cibles.includes(c.cible);
        });
      });
    },
    /**
     * champs additionnels et classifications
     * @returns {*}
     */
    findAll: function findAll(cible) {
      return $q.when(loadIfRequired(cible)).then(function () {
        return _.filter(classifications, function (c) {
          return !cible || c.cible === cible;
        });
      });
    },
    /**
     * hors classification
     * @returns {*}
     */
    findAllChampsAdditionnels: function findAllChampsAdditionnels(cible) {
      return $q.when(loadIfRequired()).then(function () {
        return _.filter(classifications, function (c) {
          return c.type !== 'CLASSIFICATION' && (!cible || c.cible === cible);
        });
      });
    },
    /**
     * hors champs additionnels
     * @returns {*}
     */
    findAllClassifications: function findAllClassifications(cible) {
      return $q.when(loadIfRequired()).then(function () {
        return _.filter(classifications, function (c) {
          return c.type === 'CLASSIFICATION' && (!cible || c.cible === cible);
        });
      });
    },
    /**
     * hors champs additionnels
     * @returns {*}
     */
    findAllClassificationsForAnyCible: function findAllClassificationsForAnyCible(cibles) {
      return $q.when(loadIfRequired()).then(function () {
        return _.filter(classifications, function (c) {
          return c.type === 'CLASSIFICATION' && (cibles.length == 0 || _.includes(cibles, c.cible));
        });
      });
    },
    openCreationPopin: function openCreationPopin(cible, classifications) {
      return $modal.open(_.extend(createPopinOptions, {
        vars: {
          edit: false,
          cible: cible,
          classifications: classifications
        }
      }));
    },
    openEditionPopin: function openEditionPopin(classification, classifications) {
      return $modal.open(_.extend(createPopinOptions, {
        vars: {
          classification: classification,
          cible: classification.cible,
          edit: true,
          classifications: classifications
        }
      }));
    },
    openChampAdditionnelCreationPopin: function openChampAdditionnelCreationPopin(cible) {
      return $modal.open(_.extend(createChampAdditionnelPopinOptions, {
        vars: {
          edit: false,
          cible: cible
        }
      }));
    },
    openChampAdditionnelEditionPopin: function openChampAdditionnelEditionPopin(classification) {
      return $modal.open(_.extend(createChampAdditionnelPopinOptions, {
        vars: {
          classification: classification,
          edit: true
        }
      }));
    },
    /**
     * Suppression de la classification. Si echec, affiche un message d'erreur
     * @param classificationId
     * @returns {*}
     */
    delete: function _delete(classificationId) {
      return $http.delete("/rest/saisie/champAdditionnel/delete/" + classificationId).then(function (response) {
        var result = response.data;
        if (!result.valid) {
          $dialogBox.alert({
            title: "Impossible de supprimer la classification",
            text: result.message
          });
        } else {
          // on a supprimé un filtre, il faut recharger
          contextService.reloadContext();
          contextService.refreshData();
        }
        return result;
      });
    },
    /**
     *
     * @return normalement une valeur directement (et non une promesse)
     */
    findById: function findById(classificationId) {
      // TODO CP2
      return $q.when(loadIfRequired()).then(function () {
        for (var i = 0; i < classifications.length; i++) {
          if (classifications[i].id === classificationId) {
            return classifications[i];
          }
        }
        return null;
      });
    },
    /**
     *
     * @param appId optionnel, ne retourne que ceux associés à l'application
     * @return {*} retourne la promise
     */
    findAllByAppId: function findAllByAppId(appId, cible) {
      return $http.get("/rest/saisie/champAdditionnel/list/" + cible, {
        params: {
          appId: appId
        }
      }).then(function (result) {
        return result.data;
      });
    },
    findAllTypeClassificationByAppId: function findAllTypeClassificationByAppId(appId, cible) {
      return $http.get("/rest/saisie/champAdditionnel/classificationsPourCible/" + cible, {
        params: {
          appId: appId
        }
      }).then(function (result) {
        return result.data;
      });
    },
    findAllTypeClassificationByAppIdByCibles: function findAllTypeClassificationByAppIdByCibles(appId, cibles) {
      return $http.get("/rest/saisie/champAdditionnel/classificationsPourCibles", {
        params: {
          appId: appId,
          cibles: cibles
        }
      }).then(function (result) {
        return result.data;
      });
    },
    openEditionValeursPopin: function openEditionValeursPopin(classification) {
      return $modal.open(_.extend(editionValeursPopinOptions, {
        vars: {
          classification: classification
        }
      }));
    },
    getRendu: function getRendu() {},
    /**
     * peut traiter tous les champs additionnels (classifs ou champs)
     * @param classifications les champs additionnels à traiter
     * @param columns
     * @param withSubtotalGroup permet d'afficher l'icone de groupement / degroupement
     * @param principal true / false ou undefined pour les 2
     */
    addInventaireClassificationColumns: function addInventaireClassificationColumns(classifications, columns, withSubtotalGroup, principal) {
      /**
       * alignement de la cellule en fonction du type de classification (ou d'une carac de la classification)
       */
      function classificationFieldAlign(classification) {
        switch (classification.type) {
          case 'STRING':
            return "align-l";
          case 'LONG':
            return "align-r";
          case 'DOUBLE':
            return "align-r";
          case 'DATEMIDNIGHT':
            return "align-c";
          case 'POURCENTAGE':
            return "align-r";
          case 'BOOLEAN':
            return "align-c";
        }
        return "align-l";
      }
      var indexInClassificationFields = 0;
      var indexInClassificationProduitFields = 0;
      var indexInClassificationContrepartieFields = 0;
      var indexInClassificationEntiteFields = 0;
      var indexInClassificationProjetsFields = 0;
      for (var i = 0; i < classifications.length; i++) {
        var prefix = "classification";
        var fieldName = 'classificationFields';
        var cible = classifications[i].cible;
        if (cible === 'PRODUIT') {
          indexInClassificationFields = indexInClassificationProduitFields++;
        } else {
          prefix = "classification-" + cible;
          if (cible === 'COMPTE') {
            fieldName = 'classificationEntiteFields';
            indexInClassificationFields = indexInClassificationEntiteFields++;
          } else if (cible === 'PROJET') {
            fieldName = 'classificationProjetsFields';
            indexInClassificationFields = indexInClassificationProjetsFields++;
          } else {
            fieldName = 'classificationContrepartieFields';
            indexInClassificationFields = indexInClassificationContrepartieFields++;
          }
        }
        if (principal === undefined || principal === true && classifications[i].principal || principal === false && !classifications[i].principal) {
          columns.push({
            id: prefix + "-" + i,
            title: classifications[i].nom,
            template: '<div style="max-height: 200px; overflow-y: auto">' + '<div class="champ-additionnel" ng-repeat="imputation in model.' + fieldName + '[' + indexInClassificationFields + '].imputations">' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'CLASSIFICATION\'" ng-class="{\'imputation\' : model.' + fieldName + '[' + indexInClassificationFields + '].multiple}">{{imputation.classificationValue}}</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'CLASSIFICATION\' && model.' + fieldName + '[' + indexInClassificationFields + '].repartition" class="imputation nowrap">{{imputation.imputation|number}}%</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'STRING\'">{{imputation.valueAsString}}</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'LONG\'"  class="align-r">{{imputation.valueAsLong|number}}</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'DOUBLE\'" class="align-r">{{imputation.valueAsDouble|number}}</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'DATEMIDNIGHT\'" class="align-c">{{imputation.valueAsDateMidnight|dateShort}}</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'POURCENTAGE\'"  class="align-r">{{imputation.valueAsPourcentage|number}}%</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'BOOLEAN\'">' + '    <i class="fa fa-check green align-c" ng-if="imputation.valueAsBoolean===true"></i>' + '    <i class="fa fa-times red align-c" ng-if="imputation.valueAsBoolean===false"></i>' + '  </span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'GROUPE\'" class="align-c imputation">{{imputation.classificationValue}}</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'UTILISATEUR\'" class="align-c imputation">{{imputation.classificationValue}}</span>' + '</div></div>',
            cellClass: classificationFieldAlign(classifications[i]),
            attribute: '' + fieldName + '.' + indexInClassificationFields + '.imputationsAsString',
            sortable: true,
            subtotalGroup: withSubtotalGroup,
            maxWidth: '600px'
          });
        }
      }
    },
    /**
     * ajout des champs additionnels à columnGroups
     * @param classifications
     * @param columnGroups
     * @param principal true / false ou undefined pour les 2
     */
    addInventaireClassificationColumnsGroup: function addInventaireClassificationColumnsGroup(classifications, columnGroups, principal) {
      for (var i = 0; i < classifications.length; i++) {
        if (principal === undefined || principal === true && classifications[i].principal || principal === false && !classifications[i].principal) {
          var prefix = "classification";
          if (classifications[i].cible !== 'PRODUIT') {
            prefix = "classification-" + classifications[i].cible;
          }
          columnGroups.push({
            id: prefix + "-" + i,
            title: classifications[i].nom,
            columns: [prefix + "-" + i],
            visible: false
          });
        }
      }
    },
    /**
     *
     * Classifications et Champs UTILISATEUR
     *
     * place dans $scope :
     * changeClassification
     *     --> classificationValues les valeurs possibles
     * toutCocherClassificationValues()
     * toutDecocherClassificationValues()
     * changeClassification(init, subventionService)
     * toutCocherClassificationEntitesValues()
     * toutDecocherClassificationEntitesValues()
     * changeClassificationProjets()
     * toutCocherClassificationProjetsValues()
     * toutDecocherClassificationProjetsValues()
     *
     */
    initInventaireClassificationFilter: function initInventaireClassificationFilter($scope, classificationService, $element) {
      classificationService.findAll('PRODUIT').then(function (classifications) {
        $scope.classifications = _.filter(classifications, function (c) {
          return c.type == 'CLASSIFICATION' || c.type == 'UTILISATEUR';
        });
      });

      /**
       *
       * @param init
       * @param subventionService pour les subventions
       * ajoute la classification correspondant à $scope.params.classificationId dans $scope.classification
       * ajoute classificationValues
       */
      $scope.changeClassification = function (init, subventionService) {
        // reinitialise les selections de la liste
        var classificationId = $scope.params.classificationId;
        if (classificationId != null) {
          classificationService.findById(classificationId).then(function (classification) {
            $scope.classification = classification;
            if (classification == null) {
              $scope.params.classificationId = null;
              $scope.params.classificationValuesId = [];
              return;
            }
            // liste des valeurs possibles
            $scope.params.classificationId = classification.id;
            if (classification.type === 'UTILISATEUR' && subventionService) {
              subventionService.getUtilisateursPourTaches(false, true).then(function (users) {
                $scope.classificationUtilisateurValeurs = $scope.classificationValues = users;
                if (!init) {
                  $scope.toutCocherClassificationValues();
                }
              });
            } else {
              $scope.classificationValues = classification.valeurs;
              if (!init) {
                $scope.toutCocherClassificationValues();
              }
            }
          });
        } else {
          $scope.params.classificationValuesId = [];
        }
      };
      $scope.toutCocherClassificationValues = function () {
        var classificationValuesId = [];
        if ($scope.classification.type === 'UTILISATEUR') {
          classificationValuesId = _.map($scope.classificationUtilisateurValeurs, function (v) {
            return v.id;
          });
        } else {
          classificationValuesId = _.map($scope.classification.valeurs, function (v) {
            return v.id;
          });
        }
        $scope.params.classificationValuesId = classificationValuesId;
        triggerChangeEvent();
      };
      $scope.toutDecocherClassificationValues = function () {
        $scope.params.classificationValuesId = [];
        triggerChangeEvent();
      };
      classificationService.findAllClassifications('COMPTE').then(function (classifications) {
        $scope.classificationsEntites = classifications;
      });
      $scope.changeClassificationEntites = function (init) {
        // reinitialise les selections de la liste
        var classificationEntitesId = $scope.params.classificationEntitesId;
        if (classificationEntitesId != null) {
          classificationService.findById(classificationEntitesId).then(function (classification) {
            $scope.classificationEntites = classification;
            if (classification == null) {
              $scope.params.classificationEntitesId = null;
              $scope.params.classificationEntitesValuesId = [];
              return;
            }
            // liste des valeurs possibles
            $scope.classificationEntitesValues = classification.valeurs;
            $scope.params.classificationEntitesId = classification.id;
            if (!init) {
              $scope.toutCocherClassificationEntitesValues();
            }
          });
        } else {
          $scope.params.classificationEntitesValuesId = [];
        }
      };
      $scope.toutCocherClassificationEntitesValues = function () {
        var classificationEntitesValuesId = [];
        classificationEntitesValuesId = _.map($scope.classificationEntites.valeurs, function (v) {
          return v.id;
        });
        $scope.params.classificationEntitesValuesId = classificationEntitesValuesId;
        triggerChangeEvent();
      };
      $scope.toutDecocherClassificationEntitesValues = function () {
        $scope.params.classificationEntitesValuesId = [];
        triggerChangeEvent();
      };
      classificationService.findAllClassifications('PROJET').then(function (classifications) {
        $scope.classificationsProjets = classifications;
      });
      $scope.changeClassificationProjets = function (init) {
        // reinitialise les selections de la liste
        var classificationProjetsId = $scope.params.classificationProjetsId;
        if (classificationProjetsId != null) {
          classificationService.findById(classificationProjetsId).then(function (classification) {
            $scope.classificationProjets = classification;
            if (classification == null) {
              $scope.params.classificationProjetsId = null;
              $scope.params.classificationProjetsValuesId = [];
              return;
            }
            // liste des valeurs possibles
            $scope.classificationProjetsValues = classification.valeurs;
            $scope.params.classificationProjetsId = classification.id;
            if (!init) {
              $scope.toutCocherClassificationProjetsValues();
            }
          });
        } else {
          $scope.params.classificationProjetsValuesId = [];
        }
      };
      $scope.toutCocherClassificationProjetsValues = function () {
        var classificationProjetsValuesId = [];
        classificationProjetsValuesId = _.map($scope.classificationProjets.valeurs, function (v) {
          return v.id;
        });
        $scope.params.classificationProjetsValuesId = classificationProjetsValuesId;
        triggerChangeEvent();
      };
      $scope.toutDecocherClassificationProjetsValues = function () {
        $scope.params.classificationProjetsValuesId = [];
        triggerChangeEvent();
      };
      function triggerChangeEvent() {
        _.defer(function () {
          $element.find('.checkbox').trigger("change", {
            value: $scope.parameterValue
          });
        });
      }
    },
    /**
     * cf. UtilisateurPourTacheDTO
     * todo - a reprendre pour généraliser aux autres appli que subvention - recopie de ce qui est sur subventionService, car pas accessible de common
     * On veut tous les utilisateurs qui peuvent avoir des tâches : sur les compte parents ou enfants.
     * Soit on a une s
     * @param shortLabel si true Prénom + Nom
     @param compteId indique à partir de quel compte partir (compte de la subvention)
     */
    getUtilisateursPourTaches: function getUtilisateursPourTaches(shortLabel, compteId) {
      return $http.get('/rest/saisie/aide-subvention/utilisateurs-pour-taches', {
        params: {
          short: shortLabel,
          keepInactif: true,
          compteId: compteId
        }
      }).then(function (response) {
        return response.data;
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/classification/classificationService.js", __webpack_require__(1)))

/***/ }),
/* 2691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("saisieClassification", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      cible: "@cible"
    },
    template: __webpack_require__(3662),
    link: function link($scope, $el, $attrs) {},
    controller: ["$scope", "$q", "$http", "$modal", "$compile", "$session", "budgetService", "contextService", "$dialogBox", "classificationService", "tlTableUtils", "$notifications", "pageStatus", function controller($scope, $q, $http, $modal, $compile, $session, budgetService, contextService, $dialogBox, classificationService, tlTableUtils, $notifications, pageStatus) {
      var urlRoot = '/rest/saisie/champAdditionnel';
      var load = function load() {
        $http.get(urlRoot + "/classificationsPourCible/" + $scope.cible).then(function (response) {
          $scope.classifications = response.data;
          $scope.selectedClassification = tlTableUtils.getNewTableSelection($scope.selectedClassification, $scope.classifications);
          if ($scope.selectedClassification == null && $scope.classifications.length > 0) {
            // idealement ce serait plutôt la première ligne du tableau (peu importe les tris) qu'on voudrait voir sélectionnée
            $scope.selectedClassification = $scope.classifications[0];
          }
        });
      };
      tlTableUtils.fixResize($scope, 'classifications');
      tlTableUtils.fixResize($scope, 'selectedClassification');
      $scope.classificationsTableConfig = {
        source: "classifications",
        selectionScope: $scope,
        allowSelection: true,
        selectionAttribute: "selectedClassification",
        initialSort: ["nom", "asc"],
        columns: [{
          title: "Nom",
          attribute: 'nom',
          template: '<span tl-tooltip="Créé par {{model.metadata.creationUser}} le {{model.metadata.creationDate|dateShort}} ">{{model.nom}}</span>' + '<span class="ml-m" ng-if="model.pseudoType==\'REPARTITION\'">' + '(<i class="fa fa-percent"  tl-tooltip="Répartition en pourcentage sur plusieurs valeurs de la classification"></i>)' + '</span>' + '<span class="ml-m" ng-if="model.pseudoType==\'MULTIPLE\'">' + '(<i class="fa fa-ellipsis-h"  tl-tooltip="Association possible à plusieurs valeurs de la classification"></i>)' + '</span>' + '<i ng-if="model.editable==false" class="fa fa-chevron-circle-up blue ml-m" ' + 'tl-tooltip="Cette classification est définie sur le compte \'{{model.compteNomClient}}\' et ne peut être modifiée que sur ce compte."></i>' + '<i ng-if="model.valeurs.length==0" class="fa fa-warning orange ml-m" tl-tooltip="N\'oubliez pas d\'ajouter des valeurs à cette classification"></i>',
          sortable: true,
          sortType: 'alphanum'
        }, {
          template: '<tl-icon-button ng-if="model.editable" authz-if-role="SAISIE" icon="edit" tl-tooltip="Editer" ng-click="editClassification(model)"></tl-icon-button>' + '<tl-icon-button ng-if="model.editable" authz-if-role="SAISIE" icon="delete" tl-tooltip="Supprimer" ng-click="deleteClassification(model)"></tl-icon-button>',
          width: '100px',
          cellClass: 'align-c'
        }]
      };
      $scope.addClassification = function () {
        classificationService.openCreationPopin($scope.cible, $scope.classifications).then(function (response) {
          // pour permettre de sélectionner la classification créée
          $scope.selectedClassification = {
            id: response.id
          };
          load();
          pageStatus.invalidate();
        });
      };
      $scope.editClassification = function (classification) {
        classificationService.openEditionPopin(classification, $scope.classifications).then(function (response) {
          load();
          pageStatus.invalidate();
        });
      };
      $scope.editClassificationValue = function (classification) {
        classificationService.openEditionValeursPopin(classification).then(function () {
          load();
          pageStatus.invalidate();
        });
      };
      $scope.deleteClassification = function (classification) {
        $dialogBox.confirm({
          title: "Suppression d'une classification",
          html: (classification.hasAffectations ? "<span class=\'red\'>Attention : Certaines contreparties sont affectées à cette classification.</span><br>" : "") + "Êtes-vous sûr de vouloir supprimer la classification '" + classification.nom + "' ?"
        }).then(function () {
          classificationService.delete(classification.id).then(function (response) {
            if (response.valid) {
              $notifications.info("Classification " + classification.nom + " supprimée.");
              load();
              pageStatus.invalidate();
            }
          });
        });
      };
      load();
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/classification/saisieClassification.js"))

/***/ }),
/* 2692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("ClassificationValeursEditionPopinController", ["$scope", "$q", "$http", "$translate", "lovService", "$notifications", "$dialogBox", "classificationService", "contextService", "$element", "chartUtils", "$rootScope", function ($scope, $q, $http, $translate, lovService, $notifications, $dialogBox, classificationService, contextService, $element, chartUtils, $rootScope) {
  var cible = $scope.classification.cible;
  var originalClassificationValeurs = $scope.classification.valeurs;
  $scope.classificationValeurs = angular.copy(originalClassificationValeurs);
  $scope.addClassificationValue = function () {
    $scope.classificationValeurs.push({
      id: null,
      nom: "",
      color: chartUtils.getGraphColor($scope.classificationValeurs.length),
      new: true
    });
  };
  var plainToTable = function plainToTable(text) {
    var table = [];
    var rowSeparator = '\n';
    if (text.indexOf('\r\n') > -1) {
      rowSeparator = '\r\n';
    }
    _.each(text.trim(rowSeparator).split(rowSeparator), function (rowData, lineIdx) {
      table[lineIdx] = [];
      _.each(rowData.split('\t'), function (cellData, rowIdx) {
        table[lineIdx][rowIdx] = cellData;
      });
    });
    return table;
  };
  $scope.createFromClipboard = function () {
    navigator.clipboard.read().then(function (clipboards) {
      for (var i = 0; i < clipboards.length; i++) {
        var clipboardItem = clipboards[i];
        var type = 'text/plain';
        clipboardItem.getType(type).then(function (blob) {
          blob.text().then(function (text) {
            // parsed est un tableau (ligne) de tableau (colonnes) dont on ne prendra que le premier element comme nom
            var parsed = plainToTable(text);
            if (parsed.length > 0) {
              var values = [];
              var resume = "";
              for (var row = 0; row < parsed.length; row++) {
                var valeurNom = parsed[row];
                if (valeurNom != null && valeurNom[0] != null && _.trim(valeurNom[0]).length > 0) {
                  valeurNom = _.trim(valeurNom[0]);
                  if (valeurNom.length > 40) {
                    valeurNom = valeurNom.substring(0, 40);
                  }
                  values.push({
                    id: null,
                    nom: "" + valeurNom,
                    color: chartUtils.getGraphColor($scope.classificationValeurs.length + values.length)
                  });

                  // résumé pour la popup de confirmation
                  if (row === 20) {
                    resume += ", ...";
                  }
                  if (row < 20) {
                    if (resume.length !== 0) {
                      resume += ", ";
                    }
                    resume += valeurNom;
                  }
                }
              }
              $dialogBox.confirm({
                title: "Ajout de valeurs",
                html: "Etes-vous sûr de vouloir ajouter ces " + values.length + " valeurs issues du presse-papier ?<br/>" + "<div>" + resume + "</div>"
              }).then(function () {
                {
                  for (var _row = 0; _row < values.length; _row++) {
                    $scope.classificationValeurs.push(values[_row]);
                  }

                  // retire les valeurs null qui seraient encore présentes
                  $scope.classificationValeurs = _.filter($scope.classificationValeurs, function (v) {
                    return v.nom != null && v.nom.trim().length > 0;
                  });
                  $notifications.info(values.length + " valeurs ajoutées");

                  // on force une revalidation avec invalidation (touch) des champs
                  _.delay(function () {
                    $rootScope.$emit("tlValidatedField:validate");
                    $scope.$apply();
                  }, 100);
                }
              });
            } else {
              $notifications.info("Aucune donnée disponible dans le presse-papier");
            }
          });
        });
      }
    });
  };
  if ($scope.classificationValeurs.length === 0) {
    $scope.addClassificationValue();
  }
  $scope.hasNomEnDoublon = function () {
    return _.some($scope.classificationValeurs, function (c) {
      return $scope.nomEnDoublon(c.nom);
    });
  };
  $scope.nomEnDoublon = function (nom) {
    return _.filter($scope.classificationValeurs, function (c) {
      return nom === c.nom;
    }).length > 1;
  };
  $scope.classificationValeursFormConfig = {
    url: function url() {
      return '/rest/saisie/champAdditionnel/' + $scope.classification.id + '/valeurs/';
    },
    data: function data() {
      return $scope.classificationValeurs;
    },
    customValidation: function customValidation() {
      var errors = [];
      for (var i = 0; i < $scope.classificationValeurs.length; i++) {
        var valeur = $scope.classificationValeurs[i];
        if (valeur.nom == null || valeur.nom.trim().length === 0) {
          errors.push({
            fieldName: 'classification.valeur' + i,
            message: 'La valeur est obligatoire.'
          });
        }
        if (valeur.nom != null && $scope.nomEnDoublon($scope.classificationValeurs[i].nom)) {
          errors.push({
            fieldName: 'classification.valeur' + i,
            message: 'Il existe déjà une autre valeur portant ce nom.'
          });
        }
      }
      return errors;
    },
    onSuccess: function onSuccess(savedClassificationValeurs) {
      _.extend($scope.classificationValeurs, savedClassificationValeurs);
      classificationService.$reload();
      contextService.refreshData();
      $notifications.info("Valeurs de la classification enregistrées");
      $scope.$close($scope.classificationValeurs);
    },
    onError: function onError(errors) {
      $scope.errors = errors;
      return;
    }
  };
  $scope.remove = function (value) {
    if (value.id != null) {
      $http.get('/rest/saisie/champAdditionnel/' + $scope.classification.id + '/valeur/' + value.id + '/utilisee').then(function (response) {
        if (response.data.response === false) {
          var index = _.indexOf($scope.classificationValeurs, value);
          $scope.classificationValeurs.splice(index, 1);
        } else {
          value.deleteErreur = 'Cette valeur est utilisée et n\'a pas pu être supprimée.';
        }
      });
    } else {
      var index = _.indexOf($scope.classificationValeurs, value);
      $scope.classificationValeurs.splice(index, 1);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/classification/valeur/classificationValeursEditionPopin.js", __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("comparaisonPanelService", ["$tauxFormat", "$montantFormat", "$numberFormat", "chartUtils", "$http", "$applications", "$authz", "tlTableUtils", "tlColors", function ($tauxFormat, $montantFormat, $numberFormat, chartUtils, $http, $applications, $authz, tlTableUtils, tlColors) {
  /**
   *
   * les modifications de couleurs sont a répercuter dans comparaisonPanelLineCharts.js (var chartMembreColors)
   */
  var chartMembreColors = ["#0069C0", "#F77600", "#2B957A", "#e2e03a", "#f13a3a", "#69d5f6", "#72f391", "#f5d3ca", "#9fabbb", "#ac735d", "#e7b0f1"];
  var chartMoyennesColors = ["#564AA3", "#00e30b", "#fc7600"];
  var getGraphColorMoyenne = function getGraphColorMoyenne(i) {
    return chartMoyennesColors[i % chartMoyennesColors.length];
  };
  var _getGraphColorMembre = function getGraphColorMembre(i) {
    return chartMembreColors[i % chartMembreColors.length];
  };
  var buildSortFn = function buildSortFn(i) {
    return function (a, b) {
      var attrA = a.valeurs[i];
      var attrB = b.valeurs[i];
      if (attrA == null && attrB == null) {
        return 0;
      } else if (attrA == null || attrA.valeur == null) {
        return -1;
      } else if (attrB == null || attrB.valeur == null) {
        return 1;
      } else {
        return attrA.valeur.valeur < attrB.valeur.valeur ? -1 : attrA.valeur.valeur > attrB.valeur.valeur ? 1 : 0;
      }
    };
  };
  return {
    getGraphColorMembre: function getGraphColorMembre(index) {
      return _getGraphColorMembre(index);
    },
    /**
     *
     * @param $scope
     * @param params (affichePopulation:false/true), "resultat si null"
     * @param resultat
     * @param nomResultatInScope source = "nomResultatInScope".lignes
     * @returns un 'tableConfig'
     */
    buildTableConfig: function buildTableConfig($scope, params, resultat, nomResultatInScope) {
      if (nomResultatInScope == null) {
        nomResultatInScope = "resultat";
      }
      $scope.getFormatterValue = function (value, model) {
        var res;
        if (value != null && model.type === 'taux') {
          res = $tauxFormat(value.valeur, 2);
        } else if (value != null && model.type === 'nombre') {
          if (value.valeur != null) {
            console.log(model);
            res = $numberFormat(value.valeur.valeur, model.nbDecimales);
            if (_.startsWith(resultat.dataType, 'POPULATION_')) {
              res += " hab.";
            }
          }
        } else {
          res = $montantFormat(value && value.valeur, 0);
          if (resultat.parHabitant) {
            res += "/hab.";
          }
        }
        return res;
      };
      var columns = [{
        attribute: "membre",
        title: "Nom",
        template: "<span ng-class=\"{b:model.reference||model.moyenne,i:model.moyenne}\">{{model.membre}} <span ng-if='model.membreDepartement'>({{model.membreDepartement}})</span></span>" + "<span ng-if=\"model.departement\" class=\"departement-pill ml-xs\">dep.</span>" + "<span ng-if=\"model.epci\" class=\"epci-pill ml-xs\">epci</span>",
        sortable: true
      }];

      // $scope.params non dispo sur les rapports personnalisés
      if (params && params.affichePopulation) {
        columns.push({
          attribute: 'population',
          title: "Population",
          template: '<span ng-if="model.population">{{model.population|number}} hab.</span>',
          filter: 'number',
          sortable: true,
          cellClass: 'align-r',
          sortType: 'number'
        });
      }
      for (var i = 0; i < resultat.nbAnnees; i++) {
        columns.push({
          attribute: "valeurs[" + i + "]",
          title: "" + resultat.anneeMax - resultat.nbAnnees + i + 1,
          filter: 'montant',
          template: "<span ng-class=\"{b:model.reference||model.moyenne,i:model.moyenne}\">{{getFormatterValue(model.valeurs[" + i + "], model)}}</span>",
          sortable: true,
          sortType: buildSortFn(i),
          cellClass: 'align-r'
        });
      }
      return {
        source: nomResultatInScope + ".lignes",
        allowSelection: true,
        selectionAttribute: "selection",
        selectionScope: $scope,
        columns: columns
      };
    },
    /**
     *
     * @param $scope
     * @param showDetails affiche  chaque entité sur le graphe (sinon juste moyenne et référence)
     * @param selectedMembre si renseigné et !showDetails alors affichera la ligne de l'entité avec membreId == selectedMembre.membreId
     */
    buildGraphe: function buildGraphe(chartConfig, $scope, lignes, showDetails, selectedMembre, hideMoyennes) {
      chartConfig.series = [];
      var idxColorDetail = 0; // pour ne pas commencer avec les memes couleur que les moyennes
      var idxColorMoyenne = 0;
      _.forEach(lignes, function (ligne) {
        if (ligne.reference || ligne.moyenne || showDetails || !showDetails && selectedMembre && ligne.membreId === selectedMembre.membreId) {
          var line = {
            name: ligne.membre,
            color: ligne.reference ? tlColors.FUSCHIA : ligne.moyenne ? getGraphColorMoyenne(idxColorMoyenne) : ligne.couleur ? ligne.couleur : _getGraphColorMembre(idxColorDetail),
            visible: true,
            data: _.map(ligne.valeurs, function (value, key) {
              return {
                x: value.annee,
                y: value.valeur == null ? null : ligne.type == 'taux' ? value.valeur.valeur * 100.0 : value.valeur.valeur
              };
            }).filter(function (p) {
              return p.y != null;
            })
          };
          if (ligne.moyenne && !hideMoyennes) {
            if (chartConfig.options.chart.type === 'line') {
              line['dashStyle'] = 'LongDash';
            }
            //  line['opacity']=0.6;
            //line['borderColor'] = tlColors.NEW_RED_1;
            //  line['borderWidth'] =1;
          }
          if (ligne.reference) {
            line['lineWidth'] = 3;
            line['borderWidth'] = 1;
            line['borderColor'] = tlColors.INTERET_SIMULES;

            //line.pointWidth=20

            line.groupPadding = 0.17;
          }
          if (!ligne.moyenne || !hideMoyennes) {
            chartConfig.series.push(line);
          }
          if (!ligne.moyenne && !ligne.reference) {
            idxColorDetail++;
          }
          if (ligne.moyenne) {
            idxColorMoyenne++;
          }
        }
      });
    },
    createChartConfig: function createChartConfig($scope, type, params) {
      var chartConfig = {
        options: {
          chart: {
            type: params && params.typeChart || 'line',
            zoomType: 'x',
            height: 250
          },
          // pour l'affichge de l'unité sur les axes
          typeData: type,
          legend: {
            enabled: true,
            align: 'right',
            layout: 'vertical',
            verticalAlign: 'top',
            y: 30,
            backgroundColor: 'rgba(109,176,194,0.1)',
            borderWidth: 0,
            borderRadius: 0,
            symbolWidth: 30
          },
          tooltip: {
            shared: true,
            formatter: function formatter() {
              var tooltip = '<span>' + this.x + '</span> :  <br/>';
              _.each(this.points, function (point) {
                var value = type == 'taux' ? $numberFormat.percentage(point.y / 100.0, 2) : $numberFormat.number(point.y, 0);
                var label = point.series.name;
                var serieLine = '<span style="color: ' + point.series.color + '; font-weight: bold;">' + label + '</span> : ' + value + (type == null ? " €" : "");
                tooltip += serieLine + "<br/>";
              });
              return tooltip;
            }
          },
          xAxis: {
            allowDecimals: false,
            alternateGridColor: null
          },
          yAxis: {
            title: {
              text: type == null ? "" : type == 'taux' ? '' : type == 'nombre' ? '' : type == 'habitant' ? '' : ''
            },
            labels: {
              formatter: function formatter() {
                var type = this.chart.options.typeData;
                var unit = type == null ? " €" : type == 'taux' ? '%' : type == 'nombre' ? '' : type == 'habitant' ? 'h.' : ' €';
                return this.axis.defaultLabelFormatter.call(this) + unit;
              }
            },
            startOnTick: false
          }
        }
      };
      return chartConfig;
    },
    getResultat: function getResultat($scope) {
      var _this = this;
      $http.get('/rest/observatoire/comparaison/indicateur', {
        params: $scope.params
      }).then(function (result) {
        $scope.resultat = result.data;
        $scope.lignes = result.data.lignes;
        $scope.tableConfig = _this.buildTableConfig($scope, $scope.params, $scope.resultat);
        $scope.chartConfig = _this.createChartConfig($scope, $scope.resultat.type, $scope.params);
        _this.buildGraphe($scope.chartConfig, $scope, $scope.resultat.lignes, $scope.params.showDetails, $scope.selection);
      });
    },
    /**
     *
     * @param $scope
     * @param params
     */
    getResultatObsFi: function getResultatObsFi($scope, params) {
      var _this2 = this;
      return $http.get('/rest/of/comparaison/indicateur', {
        params: params
      }).then(function (result) {
        $scope.resultat = result.data;
        $scope.lignes = result.data.lignes;
        $scope.selection = tlTableUtils.getNewTableSelection($scope.selection, $scope.lignes, 'membreId');
        $scope.tableConfig = _this2.buildTableConfig($scope, params, $scope.resultat);
        $scope.chartConfig = _this2.createChartConfig($scope, $scope.resultat.type, $scope.params);
        _this2.buildGraphe($scope.chartConfig, $scope, $scope.resultat.lignes, params.showDetails, $scope.selection);
        return $scope.resultat;
      });
    },
    /**
     * liste utilisée par les carto
     */
    getIndicateursList: function getIndicateursList(type) {
      var indicateurList = [];
      if ($applications.isDetteApplication) {
        [{
          id: 'ENCOURS_DETTE',
          label: 'Dette'
        }, {
          id: 'ANNUITE_DETTE',
          label: 'Annuité'
        }, {
          id: 'AMORTISSEMENT_DETTE',
          label: 'Amortissement'
        }, {
          id: 'INTERET_DETTE',
          label: 'Intérêt'
        }, {
          id: 'DOTATION_GLOBALE_FONCTIONNEMENT',
          label: 'Dotations'
        }].forEach(function (d) {
          return indicateurList.push(d);
        });
      }
      if ($authz.hasRole('MODULE_OBSERVATOIRE_FINANCIER')) {
        if (type === 'epci') {
          [{
            id: 'RECETTES_FONCTIONNEMENT',
            section: 'Produits de fonctionnement'
          }, {
            id: 'IMPOTS_LOCAUX',
            section: 'Produits de fonctionnement'
          }, {
            id: 'REVERSEMENT_FISCALITE',
            section: 'Produits de fonctionnement'
          }, {
            id: 'AUTRES_IMPOTS_ET_TAXES',
            section: 'Produits de fonctionnement'
          }, {
            id: 'DOTATION_GLOBALE_FONCTIONNEMENT',
            section: 'Produits de fonctionnement'
          }, {
            id: 'CHARGES_FONCTIONNEMENT',
            section: 'Charge de fonctionnement'
          }, {
            id: 'CHARGES_PERSONNEL',
            section: 'Charge de fonctionnement'
          }, {
            id: 'CHARGES_EXTERNES',
            section: 'Charge de fonctionnement'
          }, {
            id: 'CHARGES_FINANCIERES',
            section: 'Charge de fonctionnement'
          }, {
            id: 'SUBVENTIONS_VERSEES',
            section: 'Charge de fonctionnement'
          }, {
            id: 'RESULTAT_COMPTABLE',
            section: 'Résultat comptable'
          }, {
            id: 'RESSOURCES_INVESTISSEMENT',
            section: 'Ressources d\'investissement'
          }, {
            id: 'EMPRUNTS_ET_DETTES_ASSIMILEES',
            section: 'Ressources d\'investissement'
          }, {
            id: 'SUBVENTIONS_RECUES',
            section: 'Ressources d\'investissement'
          }, {
            id: 'FCTVA_INVESTISSEMENT',
            section: 'Ressources d\'investissement'
          }, {
            id: 'EMPLOIS_INVESTISSEMENT',
            section: 'Emplois d\'investissement'
          }, {
            id: 'DEPENSES_EQUIPEMENT',
            section: 'Emplois d\'investissement'
          }, {
            id: 'AMORTISSEMENT_DETTE',
            section: 'Emplois d\'investissement'
          }, {
            id: 'CAF'
          }, {
            id: 'CAF_NETTE'
          }, {
            id: 'ENCOURS_DETTE',
            section: 'Endettement'
          }, {
            id: 'ANNUITE_DETTE',
            section: 'Endettement'
          }, {
            id: 'RATIO_CAPACITE_DESENDETTEMENT',
            section: 'Endettement'
          }, {
            id: 'TAXE_HABITATION_BASE'
          }, {
            id: 'TAXE_HABITATION_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_HABITATION_PRODUITS'
          }, {
            id: 'TAXE_HABITATION_TAUX'
          }, {
            id: 'TAXE_FONCIERE_BATIE_BASE'
          }, {
            id: 'TAXE_FONCIERE_BATIE_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_FONCIERE_BATIE_PRODUITS'
          }, {
            id: 'TAXE_FONCIERE_BATIE_TAUX'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_BASE'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_PRODUITS'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_TAUX'
          }, {
            id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_BASE'
          }, {
            id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_PRODUITS'
          }, {
            id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_TAUX'
          }, {
            id: 'COTISATION_VA_ENTREPRISES'
          }, {
            id: 'IMPOSITION_FORFAITAIRE_ENTREPRISES_DE_RESEAU'
          }, {
            id: 'TAXE_SURFACES_COMMERCIALES'
          }

          //{id: 'POPULATION_DGFIP'}
          ].forEach(function (d) {
            return indicateurList.push(d);
          });
        } else if (type === 'departement') {
          return [{
            id: 'RECETTES_FONCTIONNEMENT'
          }, {
            id: 'IMPOTS_LOCAUX'
          }, {
            id: 'AUTRES_IMPOTS_ET_TAXES'
          },
          // dont taxe départementale de publicité foncière et droits d'enregistrement
          {
            id: 'TAXE_DEPARTEMENTALE_PUBLICITE_FONCIERE_ET_DROITS_ENREGISTREMENT'
          }, {
            id: 'DOTATION_GLOBALE_FONCTIONNEMENT'
          }, {
            id: 'CHARGES_FONCTIONNEMENT'
          }, {
            id: 'CHARGES_PERSONNEL'
          }, {
            id: 'CHARGES_EXTERNES'
          }, {
            id: 'AIDES_PERSONNES'
          }, {
            id: 'FRAIS_SEJOURS_HEBERGEMENT'
          }, {
            id: 'CHARGES_FINANCIERES'
          }, {
            id: 'SUBVENTIONS_VERSEES'
          }, {
            id: 'RESULTAT_COMPTABLE'
          }, {
            id: 'RESSOURCES_INVESTISSEMENT'
          }, {
            id: 'EMPRUNTS_ET_DETTES_ASSIMILEES'
          }, {
            id: 'SUBVENTIONS_RECUES'
          }, {
            id: 'FCTVA_INVESTISSEMENT'
          }, {
            id: 'EMPLOIS_INVESTISSEMENT'
          }, {
            id: 'DEPENSES_EQUIPEMENT'
          }, {
            id: 'AMORTISSEMENT_DETTE'
          }, {
            id: 'SUBVENTIONS_EQUIPEMENT_VERSEES'
          }, {
            id: 'BESOIN_FINANCEMENT_RESIDUELLE_SECTION_INVESTISSEMENT'
          }, {
            id: 'SOLDE_OPERATIONS_TIERS'
          }, {
            id: 'BESOIN_FINANCEMENT_SECTION_INVESTISSEMENT'
          }, {
            id: 'RESULTAT_ENSEMBLE'
          }, {
            id: 'EXCEDENT_BRUT_FONCTIONNEMENT'
          }, {
            id: 'CAF'
          }, {
            id: 'CAF_NETTE'
          }, {
            id: 'ENCOURS_DETTE'
          }, {
            id: 'ENCOURS_DETTE_NETTE_AIDE_FOND_SOUTIEN'
          }, {
            id: 'ANNUITE_DETTE'
          }, {
            id: 'RATIO_CAPACITE_DESENDETTEMENT',
            section: 'Endettement'
          }, {
            id: 'FOND_DE_ROULEMENT'
          }, {
            id: 'TAXE_FONCIERE_BATIE_BASE'
          }, {
            id: 'TAXE_FONCIERE_BATIE_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_FONCIERE_BATIE_PRODUITS'
          }, {
            id: 'TAXE_FONCIERE_BATIE_TAUX'
          }, {
            id: 'COTISATION_VA_ENTREPRISES'
          }, {
            id: 'IMPOSITION_FORFAITAIRE_ENTREPRISES_DE_RESEAU'
          }].forEach(function (d) {
            return indicateurList.push(d);
          });
        } else {
          [{
            id: 'RECETTES_FONCTIONNEMENT',
            section: 'RECETTES_FONCTIONNEMENT'
          }, {
            id: 'IMPOTS_LOCAUX',
            section: 'RECETTES_FONCTIONNEMENT'
          }, {
            id: 'AUTRES_IMPOTS_ET_TAXES',
            section: 'RECETTES_FONCTIONNEMENT'
          }, {
            id: 'DOTATION_GLOBALE_FONCTIONNEMENT',
            section: 'RECETTES_FONCTIONNEMENT'
          }, {
            id: 'CHARGES_FONCTIONNEMENT',
            section: 'CHARGES_FONCTIONNEMENT'
          }, {
            id: 'CHARGES_PERSONNEL',
            section: 'CHARGES_FONCTIONNEMENT'
          }, {
            id: 'CHARGES_EXTERNES',
            section: 'CHARGES_FONCTIONNEMENT'
          }, {
            id: 'CHARGES_FINANCIERES',
            section: 'CHARGES_FONCTIONNEMENT'
          }, {
            id: 'CONTINGENTS',
            section: 'CHARGES_FONCTIONNEMENT'
          }, {
            id: 'SUBVENTIONS_VERSEES',
            section: 'CHARGES_FONCTIONNEMENT'
          }, {
            id: 'RESULTAT_COMPTABLE',
            section: 'RESULTAT_COMPTABLE'
          }, {
            id: 'RESSOURCES_INVESTISSEMENT',
            section: 'RESSOURCES_INVESTISSEMENT'
          }, {
            id: 'EMPRUNTS_ET_DETTES_ASSIMILEES',
            section: 'RESSOURCES_INVESTISSEMENT'
          }, {
            id: 'SUBVENTIONS_RECUES',
            section: 'RESSOURCES_INVESTISSEMENT'
          }, {
            id: 'FCTVA_INVESTISSEMENT',
            section: 'RESSOURCES_INVESTISSEMENT'
          }, {
            id: 'RETOURS_BIENS_AFFECTES',
            section: 'RESSOURCES_INVESTISSEMENT'
          }, {
            id: 'EMPLOIS_INVESTISSEMENT',
            section: 'EMPLOIS_INVESTISSEMENT'
          }, {
            id: 'DEPENSES_EQUIPEMENT',
            section: 'EMPLOIS_INVESTISSEMENT'
          }, {
            id: 'AMORTISSEMENT_DETTE',
            section: 'EMPLOIS_INVESTISSEMENT'
          }, {
            id: 'CHARGES_INVESTISSEMENT_A_REPARTIR',
            section: 'EMPLOIS_INVESTISSEMENT'
          }, {
            id: 'IMMOBILISATIONS',
            section: 'EMPLOIS_INVESTISSEMENT'
          }, {
            id: 'BESOIN_FINANCEMENT_RESIDUELLE_SECTION_INVESTISSEMENT',
            section: 'BESOIN_FINANCEMENT_RESIDUEL'
          }, {
            id: 'SOLDE_OPERATIONS_TIERS',
            section: 'BESOIN_FINANCEMENT_RESIDUEL'
          }, {
            id: 'BESOIN_FINANCEMENT_SECTION_INVESTISSEMENT',
            section: 'BESOIN_FINANCEMENT_RESIDUEL'
          }, {
            id: 'RESULTAT_ENSEMBLE',
            section: 'BESOIN_FINANCEMENT_RESIDUEL'
          }, {
            id: 'EXCEDENT_BRUT_FONCTIONNEMENT',
            section: 'SECTION_AUTOFINANCEMENT'
          }, {
            id: 'CAF',
            section: 'AUTOFINANCEMENT'
          }, {
            id: 'CAF_NETTE',
            section: 'AUTOFINANCEMENT'
          }, {
            id: 'ENCOURS_DETTE',
            section: 'ENDETTEMENT'
          }, {
            id: 'ENCOURS_DETTE_NETTE_AIDE_FOND_SOUTIEN',
            section: 'ENDETTEMENT'
          }, {
            id: 'ANNUITE_DETTE',
            section: 'ENDETTEMENT'
          }, {
            id: 'RATIO_CAPACITE_DESENDETTEMENT',
            section: 'ENDETTEMENT'
          }, {
            id: 'FOND_DE_ROULEMENT',
            section: 'FONDS_DE_ROULEMENT'
          }, {
            id: 'TAXE_HABITATION_BASE',
            section: 'TAXE_BASE'
          }, {
            id: 'TAXE_HABITATION_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_HABITATION_PRODUITS'
          }, {
            id: 'TAXE_HABITATION_TAUX'
          }, {
            id: 'TAXE_FONCIERE_BATIE_BASE',
            section: 'TAXE_BASE'
          }, {
            id: 'TAXE_FONCIERE_BATIE_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_FONCIERE_BATIE_PRODUITS'
          }, {
            id: 'TAXE_FONCIERE_BATIE_TAUX'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_BASE',
            section: 'TAXE_BASE'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_REDUCTIONS_BASE'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_PRODUITS'
          }, {
            id: 'TAXE_FONCIERE_NON_BATIE_TAUX'
          }, {
            id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_BASE',
            section: 'TAXE_BASE'
          },
          // {id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_REDUCTIONS_BASE'},
          {
            id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_PRODUITS'
          }, {
            id: 'TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_TAUX'
          }, {
            id: 'COTISATION_FONCIERE_ENTREPRISES_BASE',
            section: 'TAXE_BASE'
          }, {
            id: 'COTISATION_FONCIERE_ENTREPRISES_REDUCTIONS_BASE'
          }, {
            id: 'COTISATION_FONCIERE_ENTREPRISES_PRODUITS'
          }, {
            id: 'COTISATION_FONCIERE_ENTREPRISES_TAUX'
          }, {
            id: 'COTISATION_VA_ENTREPRISES'
          }, {
            id: 'IMPOSITION_FORFAITAIRE_ENTREPRISES_DE_RESEAU'
          }, {
            id: 'TAXE_SURFACES_COMMERCIALES'
          }

          //{id: 'POPULATION_DGFIP'}
          ].forEach(function (d) {
            return indicateurList.push(d);
          });
        }
      }
      return indicateurList;
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/comparaisonPanel/comparaisonPanelService.js", __webpack_require__(1)))

/***/ }),
/* 2694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * @description Base class object.
 *
 * super mixin : thanks to maxbrunsfeld - https://gist.github.com/1542120
 * extend : thanks to backbone - http://backbonejs.org/
 *
 */
ngModule.factory("Class", function () {
  var Class = function Class() {
    this.initialize && this.initialize.apply(this, arguments);
  };
  _.extend(Class.prototype, {
    // The super method takes two parameters: a method name
    // and an array of arguments to pass to the overridden method.
    // This is to optimize for the common case of passing 'arguments'.
    _super: function _super(methodName, args) {
      // Keep track of how far up the prototype chain we have traversed,
      // in order to handle nested calls to _super.
      this._superCallObjects || (this._superCallObjects = {});
      var currentObject = this._superCallObjects[methodName] || this,
        parentObject = this.__findSuper__(methodName, currentObject);
      if (!parentObject || !parentObject[methodName]) {
        throw "No parent implementation found for method " + methodName;
      }
      this._superCallObjects[methodName] = parentObject;
      var result = parentObject[methodName].apply(this, args || []);
      delete this._superCallObjects[methodName];
      return result;
    },
    // Find the next object up the prototype chain that has a
    // different implementation of the method.
    __findSuper__: function __findSuper__(methodName, childObject) {
      var object = childObject;
      while (object[methodName] === childObject[methodName]) {
        object = object.constructor.__super__;
      }
      return object;
    }
  });

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function extend(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function child() {
        return parent.apply(this, arguments);
      };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function Surrogate() {
      this.constructor = child;
    };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate();

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) {
      _.extend(child.prototype, protoProps);
    }

    // Set a convenience property in case the parent's prototype is needed later.
    child.__super__ = parent.prototype;
    return child;
  };
  Class.extend = extend;
  return Class;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/classes/class.js", __webpack_require__(1)))

/***/ }),
/* 2695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);




var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
ngModule.factory("EventBus", ["Class", function (Class) {
  var array = [];
  var slice = array.slice;

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function eventsApi(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(name) === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }
    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function triggerEvents(events, args) {
    var ev,
      i = -1,
      l = events.length,
      a1 = args[0],
      a2 = args[1],
      a3 = args[2];
    switch (args.length) {
      case 0:
        while (++i < l) (ev = events[i]).callback.call(ev.ctx);
        return;
      case 1:
        while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1);
        return;
      case 2:
        while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2);
        return;
      case 3:
        while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3);
        return;
      default:
        while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
    }
  };
  var eventMixin = {
    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function on(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({
        callback: callback,
        context: context,
        ctx: context || this
      });
      return this;
    },
    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function once(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function () {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },
    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function off(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = {};
        return this;
      }
      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if (callback && callback !== ev.callback && callback !== ev.callback._callback || context && context !== ev.context) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }
      return this;
    },
    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function trigger(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    }
  };
  var EventBus = Class.extend(eventMixin, {
    makeBus: function makeBus(obj) {
      _.extend(obj, eventMixin);
    }
  });
  return EventBus;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/classes/eventbus.js", __webpack_require__(1)))

/***/ }),
/* 2696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_error_stack_parser__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_error_stack_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_error_stack_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);




var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
ngModule.factory("$remoteExceptionHandler", ["$injector", function ($injector) {
  var $http = null;
  var floodingCount = 0;
  var floodingHash = "";
  var maxflooding = 3;
  return {
    logError: function logError(exception, cause) {
      if ($http == null) {
        $http = $injector.get("$http"); // avoid cyclic dependency...
      }

      // try to parse stack to send usable info to client
      var parsedStack;
      try {
        parsedStack = __WEBPACK_IMPORTED_MODULE_0_error_stack_parser___default.a.parse(exception);
      } catch (e) {
        parsedStack = null;
      }
      var exceptionData = {
        name: exception.name,
        message: exception.message,
        stack: parsedStack,
        rawStack: exception.stack,
        location: document.location.href,
        userAgent: window.navigator.userAgent || window.navigator.vendor || window.opera
      };

      // genere un hash pour identifier si on est floodé par la meme exeption
      var hashCode = (exceptionData.name + exceptionData.message + exceptionData.location).split("").reduce(function (a, b) {
        a = (a << 5) - a + b.charCodeAt(0);
        return a & a;
      }, 0);
      if (hashCode === floodingHash) {
        floodingCount++;
      } else {
        floodingHash = hashCode;
        floodingCount = 0;
      }
      if (floodingCount > maxflooding) {
        if (floodingCount === maxflooding + 1 || floodingCount % 200 === 0) {
          console.log("silently flooding...");
        }
      } else {
        if (floodingCount === maxflooding) {
          exceptionData.message = "[Client side FLOODING] " + exceptionData.message;
        }
        $http.post("/rest/remote-logger/error", exceptionData, {
          silentError: true
        });
      }
    }
  };
}]);
ngModule.config(["$provide", function ($provide) {
  var unhandledRejectionText = "Possibly unhandled rejection";
  $provide.decorator("$exceptionHandler", ["$delegate", "$remoteExceptionHandler", function ($delegate, $remoteExceptionHandler) {
    return function taelExceptionHandler(exception, cause) {
      $delegate.apply($delegate, arguments);
      var isUnhandlerRejectionError = _.isString(exception) && _.includes(exception, unhandledRejectionText);
      if (!isUnhandlerRejectionError) {
        $remoteExceptionHandler.logError(exception, cause);
      }
    };
  }]);
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/error/exceptionHandler.js", __webpack_require__(1)))

/***/ }),
/* 2697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("$httpErrorHandler", ["$rootScope", "$modal", "$dialogBox", function ($rootScope, $modal, $dialogBox) {
  var popinScope = $rootScope.$new(),
    popinOpened = false;
  var errorHandler = {
    handleServerError: function handleServerError(error) {
      var statusCode = error.httpCode || error.statusCode || 500;
      if (statusCode === 403 || statusCode === 0) {
        // 0 -> canceled requests
        return;
      }
      if (statusCode === 401) {
        errorHandler.handlerUnauthorized(error);
      } else {
        errorHandler.handleError(error);
      }
    },
    handleError: function handleError(error) {
      if (popinOpened) {
        return;
      }
      popinOpened = true;
      if (error.statusCode === 401) {
        return this.handlerUnauthorized(error);
      }
      popinScope.error = error;
      $modal.open({
        template: __webpack_require__(3664),
        controller: ["$scope", function ($scope) {
          $scope.showDetails = false;
          $scope.toggleDetails = function () {
            $scope.showDetails = !$scope.showDetails;
          };
        }],
        scope: popinScope,
        options: {
          width: 700
        }
      }).then(function () {
        popinOpened = false;
      });
    },
    handlerUnauthorized: function handlerUnauthorized(unauthorizedError) {
      var cause = unauthorizedError.errorId;
      if (popinOpened) {
        return;
      }
      popinOpened = true;
      if (cause === "NOT_LOGGED") {
        var authentificationUrl = "https://www.taelys.com";
        window.location.href = authentificationUrl + "?errorMsg=session.timeout&target=" + window.location.href;
      } else if (cause === "ROLE_NOT_ALLOWED") {
        $dialogBox.alert({
          title: "Action interdite",
          text: "Vous ne disposez pas des droits necessaires pour effectuer cette action. " + "Si vous pensez que cela est une erreur, veuillez contacter votre consultant."
        }).then(function () {
          popinOpened = false;
        });
      }
    }
  };
  return errorHandler;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/error/httpErrorHandler.js"))

/***/ }),
/* 2698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.run(["$rootScope", "$debounce", function ($rootScope, $debounce) {
  // TODO : make x & y work
  var onWindowResize = $debounce(function () {
    $rootScope.$broadcast("$resize", {
      x: true,
      y: true
    });
  }, 100, false);
  $(window).on("resize", function () {
    $rootScope.$apply(function () {
      onWindowResize();
    });
  });
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/events/windowResize.js", __webpack_require__(4)))

/***/ }),
/* 2699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.filter("addCurrency", function () {
  return function addCurrencyFilter(value, sign) {
    var currency = sign || "€";
    return value + " " + currency;
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/filters/currency.js"))

/***/ }),
/* 2700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.filter('dateOfMonth', function () {
  return function (number) {
    switch (number) {
      case 1:
        return "1er";
      default:
        return number;
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/filters/dateOfMonth.js"))

/***/ }),
/* 2701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.filter("ellipsis", function () {
  return function ellipsisFilter(value, maxLength) {
    if (!maxLength) {
      maxLength = 25; // longueur par défaut
    }
    if (value.length > maxLength) {
      value = value.substring(0, maxLength - 3) + "...";
    }
    return value;
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/filters/ellipsis-filter.js"))

/***/ }),
/* 2702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, numeral) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.filter("fixing", ["stringUtils", function (stringUtils) {
  return function tauxFilter(value, fixedDecimals) {
    if (value == null) {
      return "-";
    }
    var isFixedDecimals = !_.isUndefined(fixedDecimals);
    var format;
    if (isFixedDecimals) {
      var nbDecimals = parseInt(fixedDecimals);
      format = "0,0." + stringUtils.repeatSequence("0", nbDecimals);
    } else {
      format = "0,0.[00]";
    }
    var res = "";

    // todo - a reprendre car on ne transmet plus tout l'index mais juste son id
    if (value.index.type === 'TAUX') {
      res = numeral(value.valeur * 100).format(format) + " %";
    } else {
      res = numeral(value.valeur).format(format);
    }
    if (value.type === 'ESTIME') {
      res += "*";
    }
    return res;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/filters/fixing-filters.js", __webpack_require__(1), __webpack_require__(749)))

/***/ }),
/* 2703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.filter("gissler", ["stringUtils", "$translate", function (stringUtils, $translate) {
  return function gisslerFilter(value) {
    if (value == null) {
      return "";
    }
    if (value.indice === 'HORS_CHARTE' || value.structure === 'HORS_CHARTE') {
      return $translate("lov.structuresGissler.HORS_CHARTE");
    }
    return $translate('lov.structuresGissler.' + value.structure) + $translate('lov.indicesGissler.' + value.indice);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/filters/gissler-filters.js"))

/***/ }),
/* 2704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.filter("lov", function () {
  return function lovFilter(lovId, lovValues) {
    if (!lovId) {
      return null;
    }
    for (var i = 0; i < lovValues.length; i++) {
      if (lovId === lovValues[i].id) {
        return lovValues[i].label;
      }
    }
    return null;
  };
});
ngModule.filter("translateLov", ["$translate", function ($translate) {
  return function translateLov(lovId, lovName) {
    if (!lovId) {
      return null;
    }
    return $translate("lov." + lovName + "." + lovId);
  };
}]);
ngModule.filter("lovIdsIn", function () {
  return function lovIdsIn(lovs, ids) {
    if (lovs == null || ids == null) {
      return null;
    }
    return _.filter(lovs, function (lov) {
      return _.includes(ids, lov.id);
    });
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/filters/lov.js", __webpack_require__(1)))

/***/ }),
/* 2705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.filter('orDash', function () {
  return function (value) {
    if (value == null) {
      return "-";
    }
    return value;
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/filters/orDash.js"))

/***/ }),
/* 2706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * @ngdoc filter
 * @name common.filter:period
 * @function
 *
 * @description
 * Formats a period (ie. years, month, days).
 *
 * @param {Period} The period to filter.
 *
 * @returns {string} Formatted period.
 */
ngModule.filter("period", function () {
  return function periodFilter(period) {
    if (period == null) {
      return "-";
    }
    var formattedAnnee = period.annees === 0 ? "" : period.annees === 1 ? "1 an" : period.annees + " ans";
    var formattedMois = period.mois === 0 ? "" : (formattedAnnee !== "" ? " et " : "") + (period.mois === 1 ? "1 mois" : period.mois + " mois");
    var formattedJours = period.jours === 0 ? "" : (formattedAnnee !== "" || formattedMois !== "" ? " et " : "") + (period.jours === 1 ? "1 jour" : period.jours + " jours");
    var formatted = formattedAnnee + formattedMois + formattedJours;
    return formatted;
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/filters/period-filter.js"))

/***/ }),
/* 2707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.filter('makeRange', function () {
  return function (input) {
    var lowBound, highBound;
    switch (input.length) {
      case 1:
        lowBound = 0;
        highBound = parseInt(input[0]) - 1;
        break;
      case 2:
        lowBound = parseInt(input[0]);
        highBound = parseInt(input[1]);
        break;
      default:
        return input;
    }
    var result = [];
    for (var i = lowBound; i <= highBound; i++) {
      result.push(i);
    }
    return result;
  };
});
ngModule.filter("repeat", ["stringUtils", function (stringUtils) {
  return function repeatFilter(sequence, times) {
    return stringUtils.repeatSequence(sequence, angular.isDefined(times) ? times : 1);
  };
}]);
ngModule.filter("join", function () {
  return function joinFilter(array, join) {
    return array.join(join || "");
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/filters/repeaters.js", __webpack_require__(3)))

/***/ }),
/* 2708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Apply given filter string ( can be a filter name or a filter name plus parameters )
 * Useful for dynamic /parametrized filter usage.
 *
 * I.E {{ myNumber | useFilter:'currency:2' }}
 */
ngModule.filter('useFilter', ["$filter", function ($filter) {
  return function useFilter() {
    var filterString = arguments[1],
      value = arguments[0];
    if (filterString == null) {
      return "";
    }
    var splits = filterString.split(":"),
      filterName = _.first(splits),
      filterParams = _.drop(splits);
    filterParams.splice(0, 0, value);
    return $filter(filterName).apply(null, filterParams);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/filters/useFilter.js", __webpack_require__(1)))

/***/ }),
/* 2709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Affiche "oui" ou "non" en fonction d'une entrée boolean
 */
ngModule.filter("yesOrNo", function () {
  return function yesOrNoFilter(value) {
    return value ? "Oui" : "Non";
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/filters/yesOrNo.filter.js"))

/***/ }),
/* 2710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("$asyncHttp", ["$q", "security", "$timeout", "$http", "$httpErrorHandler", "$dateConverter", "$dialogBox", "$notifications", "urlUtils", function ($q, security, $timeout, $http, $httpErrorHandler, $dateConverter, $dialogBox, $notifications, urlUtils) {
  function waitForCompletion(taskId) {
    function poll() {
      return $http.get('/rest/user-tasks/status/' + taskId).then(function (response) {
        var status = response.data;
        if (status === 'COMPLETED' || status === 'ERROR') {
          return status;
        }
        return $timeout(2000).then(poll);
      });
    }
    return poll();
  }
  function asyncCall(method, url, data) {
    var authenticatedUrl = urlUtils.addParams(url, security.getTokens());
    return $http.post('/rest/async-call/execute', {
      method: method,
      url: authenticatedUrl,
      data: data
    }).then(function (response) {
      var taskId = response.data.response;
      return waitForCompletion(taskId).then(function (status) {
        if (status !== 'COMPLETED') {
          return $http.get('/rest/user-tasks/errorMessage/' + taskId).then(function (response) {
            var error = new Error(response.data || "Erreur sur l'appel sync");
            error.taskId = taskId;
            error.status = status;
            throw error;
          });
        }
        var downloadUrl = "/rest/user-tasks/downloadUserTaskGeneratedCallResult/" + taskId;
        var authenticatedDownloadUrl = urlUtils.addParams(downloadUrl, security.getTokens());
        return $http.get(authenticatedDownloadUrl);
      });
    });
  }
  return {
    get: function get(url, data) {
      return asyncCall('GET', url, data.params);
    },
    post: function post(url, data) {
      return asyncCall('POST', url, data);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/http/$asyncHttp.js"))

/***/ }),
/* 2711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/* date format used for client/server and server/client communication */
ngModule.constant("$serverDateFormat", "YYYY-MM-DD HH:mm:ss");
ngModule.constant("$serverShortDateFormat", "YYYY-MM-DD");

/* regexp matching the server date format */
ngModule.constant("$serverDateFormatRegexp", /^[0-9]{4}-[0-9]{2}-[0-9]{2}[ ][0-9]{2}:[0-9]{2}:[0-9]{2}$/);

/* adds the date interceptor to http interceptors */
ngModule.config(["$httpProvider", function ($httpProvider) {
  $httpProvider.interceptors.push('dateParserInterceptor');
}]);

/**
 * Date converter used by the interceptor and other 'to server' serializers.
 */
ngModule.factory("$dateConverter", ["$serverDateFormat", "$serverDateFormatRegexp", function ($serverDateFormat, $serverDateFormatRegexp) {
  var serverDateFormatLength = $serverDateFormat.length;

  /**
   * Retu of original the object, recursively converting all string matching the $serverDateFormatRegexp to date object using the $serverDateFormat.
   */
  function parseObject(obj) {
    var keys = _.keys(obj);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i],
        value = obj[key];
      if (_.isString(value) && value.length === serverDateFormatLength && $serverDateFormatRegexp.test(value)) {
        obj[key] = moment(value, $serverDateFormat).toDate();
      } else if (_.isObject(value)) {
        parseObject(value);
      }
    }
    return obj;
  }

  /**
   * Returns a clone of the object, recursively converting all dates to strings using the $serverDateFormat
   */
  function formatObject(obj) {
    if (!_.isObject(obj)) {
      return obj;
    }
    var clone = _.extend({}, obj);
    _.each(clone, function (value, key) {
      if (_.isDate(value)) {
        clone[key] = moment(value).format($serverDateFormat);
      } else if (_.isArray(value)) {
        clone[key] = [];
        _.each(value, function (item, i) {
          clone[key][i] = formatObject(item);
        });
      } else if (_.isObject(value)) {
        clone[key] = formatObject(value);
      }
    });
    return clone;
  }
  return {
    parseObject: parseObject,
    formatObject: formatObject
  };
}]);

/* interceptor used to serialize dates when sending data to the server and parsing them when retrieving data */
ngModule.factory("dateParserInterceptor", ["$dateConverter", function ($dateConverter) {
  var parseResponseDates = function parseResponseDates(obj) {
    return $dateConverter.parseObject(obj);
  };
  var formatRequestDates = function formatRequestDates(obj) {
    return $dateConverter.formatObject(obj);
  };
  return {
    request: function request(_request) {
      if (_.isArray(_request.data)) {
        _request.data = _.map(_request.data, function (el) {
          return formatRequestDates(el);
        });
      } else if (_.isObject(_request.data)) {
        _request.data = formatRequestDates(_request.data);
      }
      if (_.isObject(_request.params)) {
        _request.params = formatRequestDates(_request.params);
      }
      return _request;
    },
    response: function response(_response) {
      var doNotParse = _response.config && _response.config.noDateParsing === true;
      if (_.isObject(_response.data) && !doNotParse) {
        _response.data = parseResponseDates(_response.data);
      }
      return _response;
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/http/dateParserInterceptor.js", __webpack_require__(1), __webpack_require__(2)))

/***/ }),
/* 2712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("$httpErrorInterceptor", ["$q", "$injector", function ($q, $injector) {
  var $httpErrorHandler = null;
  var delegateToErrorHandler = function delegateToErrorHandler(errorResponse) {
    var error = errorResponse.data;
    if (_.isString(error)) {
      error = {
        message: error
      };
    }
    if (error == null) {
      error = {};
    }
    error.httpCode = errorResponse.status;
    $httpErrorHandler.handleServerError(error);
  };
  return {
    responseError: function responseError(errorResponse) {
      if ($httpErrorHandler == null) {
        // avoid cyclic dependency for $http service.
        $httpErrorHandler = $injector.get("$httpErrorHandler");
      }
      if (errorResponse.config && errorResponse.config.silentError === true) {
        return $q.reject(errorResponse);
      }

      // canceled request
      if (errorResponse.status === -1) {
        return $q.reject(errorResponse);
      }
      delegateToErrorHandler(errorResponse);
      return $q.reject(errorResponse);
    }
  };
}]);
ngModule.config(["$httpProvider", function ($httpProvider) {
  $httpProvider.interceptors.push('$httpErrorInterceptor');
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/http/httpErrorInterceptor.js", __webpack_require__(1)))

/***/ }),
/* 2713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.config(["$httpProvider", function ($httpProvider) {
  $httpProvider.interceptors.push('noCacheInterceptor');
}]);

/**
 * Interceptor to reproduce the jQuery ajaxSetup({ cache : false }) behaviour.
 * Adds a '_={timestamp}' parameter to GET requests when config.cache !== true
 * for REST requests only.
 */
ngModule.factory("noCacheInterceptor", function () {
  var restRegexp = /^\/rest\/.*/;
  return {
    'request': function request(_request) {
      if (_request.method === "GET" && _request.cache !== true && restRegexp.test(_request.url)) {
        if (!_request.params) {
          _request.params = {};
        }
        _request.params._ = new Date().getTime();
      }
      return _request;
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/http/noCacheHttpInterceptor.js"))

/***/ }),
/* 2714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("$translate", ["$q", "$http", function ($q, $http) {
  var url, lang, translationMap;
  var translate = function translate(translationKey, translationParams) {
    var translationValue = translationMap != null && translationMap[translationKey];
    if (translationValue != null) {
      if (translationParams != null) {
        return supplant(translationValue, translationParams);
      } else {
        return translationValue;
      }
    } else {
      return "?" + translationKey + "?";
    }
  };
  translate.init = function (options) {
    url = options.url;
    lang = options.lang;

    // TODO : add noDateParsing flag
    return $http.get(url, {
      params: {
        lang: lang
      },
      noDateParsing: true
    }).then(function (response) {
      translationMap = response.data;
      console.log(_.size(translationMap) + ' traductions chargées');
    });
  };
  var SUPPLANT_REGEXP = /{{([^{}]*)}}/g;
  function supplant(template, values) {
    return template.replace(SUPPLANT_REGEXP, function (a, b) {
      var r = values[b];
      return r != null ? r : a;
    });
  }
  _.extend(translate, {
    exist: function exist(translationKey) {
      return translationMap != null && translationMap[translationKey] != null;
    }
  });
  return translate;
}]);
ngModule.filter("translate", ["$translate", function ($translate) {
  return function translateFilter(translationKey, translationParams) {
    return $translate(translationKey, translationParams);
  };
}]);
ngModule.directive("translate", ["$translate", "$sanitize", function ($translate, $sanitize) {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs) {
      var translationKey = $.trim($el.text());
      var translation = $translate(translationKey);
      $el.html($sanitize(translation));
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/i18n/$translate.js", __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 2715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.config(function () {
  var bundles = {
    clearText: 'Effacer',
    clearStatus: '',
    closeText: 'Fermer',
    closeStatus: 'Fermer sans modifier',
    prevText: '',
    prevStatus: 'Voir le mois précédent',
    nextText: '',
    nextStatus: 'Voir le mois suivant',
    currentText: 'Courant',
    currentStatus: 'Voir le mois courant',
    monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    monthNamesShort: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    monthStatus: 'Voir un autre mois',
    yearStatus: 'Voir un autre année',
    weekHeader: 'Sm',
    weekStatus: '',
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    dayStatus: 'Utiliser DD comme premier jour de la semaine',
    dateStatus: 'Choisir le DD, MM d',
    dateFormat: 'dd/mm/yy',
    firstDay: 1,
    initStatus: 'Choisir la date',
    isRTL: false
  };
  $.datepicker.regional['fr'] = bundles;
  $.datepicker.setDefaults($.datepicker.regional["fr"]);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/i18n/datepicker/datepicker_fr.js", __webpack_require__(4)))

/***/ }),
/* 2716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.config(function () {
  moment.defineLocale('fr', {
    months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    longDateFormat: {
      LT: 'HH:mm',
      LTS: 'LT:ss',
      L: 'DD/MM/YYYY',
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY LT',
      LLLL: 'dddd D MMMM YYYY LT'
    },
    calendar: {
      sameDay: '[Aujourd\'hui à] LT',
      nextDay: '[Demain à] LT',
      nextWeek: 'dddd [à] LT',
      lastDay: '[Hier à] LT',
      lastWeek: 'dddd [dernier à] LT',
      sameElse: 'L'
    },
    relativeTime: {
      future: 'dans %s',
      past: 'il y a %s',
      s: 'quelques secondes',
      m: 'une minute',
      mm: '%d minutes',
      h: 'une heure',
      hh: '%d heures',
      d: 'un jour',
      dd: '%d jours',
      M: 'un mois',
      MM: '%d mois',
      y: 'un an',
      yy: '%d ans'
    },
    ordinalParse: /\d{1,2}(er|)/,
    ordinal: function ordinal(number) {
      return number + (number === 1 ? 'er' : '');
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/i18n/moment/moment_fr.js", __webpack_require__(2)))

/***/ }),
/* 2717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("$print", ["$rootScope", "$timeout", "$compile", function ($rootScope, $timeout, $compile) {
  var printMode = false,
    toolbarLinkFn,
    toolbarEl,
    toolbarScope,
    onDisableCallback;
  var showToolbar = function showToolbar() {
    hideToolbar();
    if (toolbarLinkFn == null) {
      toolbarLinkFn = $compile($("<print-toolbar>"));
    }
    toolbarScope = $rootScope.$new();
    toolbarLinkFn(toolbarScope, function (clone) {
      toolbarEl = clone;
    });
    toolbarEl.appendTo(document.body);
  };
  var hideToolbar = function hideToolbar() {
    if (toolbarScope != null) {
      toolbarScope.$destroy();
      toolbarScope = null;
    }
    if (toolbarEl != null) {
      toolbarEl.remove();
      toolbarEl = null;
    }
  };
  return {
    isPrintEnabled: function isPrintEnabled() {
      return printMode;
    },
    enablePrint: function enablePrint(disableCallback) {
      if (printMode === true) {
        return;
      }
      onDisableCallback = disableCallback;
      $("html").addClass("print-mode");
      $("<div>").addClass("tl-print-overlay").appendTo($(".main-wrapper"));
      $rootScope.$broadcast("$print:enabled");
      $rootScope.$broadcast("$print:toggle", true);
      showToolbar();
      $timeout(function () {
        $rootScope.$broadcast("$resize-x");
      }, 50);
      printMode = true;
    },
    disablePrint: function disablePrint() {
      if (printMode === false) {
        return;
      }
      $("html").removeClass("print-mode");
      $(".tl-print-overlay").remove();
      $rootScope.$broadcast("$print:disabled");
      $rootScope.$broadcast("$print:toggle", false);
      hideToolbar();
      $timeout(function () {
        $rootScope.$broadcast("$resize-x");
      }, 50);
      printMode = false;
      if (onDisableCallback != null) {
        onDisableCallback();
        onDisableCallback = null;
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/print/print.js", __webpack_require__(4)))

/***/ }),
/* 2718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * show the element only in print mode.
 *
 * This directive act as a ng-if="printMode==true" directive
 */
ngModule.directive("printOnly", ["$print", "$animate", function ($print, $animate) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      var transcludedElement, transcludeScope;
      $scope.$watch(function () {
        return $print.isPrintEnabled();
      }, function (printEnabled) {
        if (printEnabled) {
          if (transcludeScope == null) {
            transcludeScope = $scope.$new();
            $transclude(transcludeScope, function (clone) {
              transcludedElement = clone;
              $animate.enter(clone, $element.parent(), $element);
            });
          }
        } else {
          if (transcludeScope) {
            transcludeScope.$destroy();
            transcludeScope = null;
          }
          if (transcludedElement) {
            transcludedElement.remove();
            transcludedElement = null;
          }
        }
      });
    }
  };
}]);

/**
 * show the element only in print mode.
 *
 * This directive act as a ng-if="printMode==true" directive
 */
ngModule.directive("noPrint", ["$print", "$animate", function ($print, $animate) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      var transcludedElement, transcludeScope;
      $scope.$watch(function () {
        return $print.isPrintEnabled();
      }, function (printEnabled) {
        if (!printEnabled) {
          if (transcludeScope == null) {
            transcludeScope = $scope.$new();
            $transclude(transcludeScope, function (clone) {
              transcludedElement = clone;
              $animate.enter(clone, $element.parent(), $element);
            });
          }
        } else {
          if (transcludeScope) {
            transcludeScope.$destroy();
            transcludeScope = null;
          }
          if (transcludedElement) {
            transcludedElement.remove();
            transcludedElement = null;
          }
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/print/printOnly.js"))

/***/ }),
/* 2719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("printToolbar", ["$window", "$print", function ($window, $print) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: __webpack_require__(3665),
    link: function link($scope, $el, $attrs, ctrl) {
      $scope.printPage = function () {
        $window.print();
      };
      $scope.exitPrintMode = function () {
        $print.disablePrint();
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/print/printToolbar.js"))

/***/ }),
/* 2720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.run(["$rootScope", "$applications", function ($rootScope, $applications) {
  $rootScope.appPath = $applications.getCurrentAppPath();
}]);
ngModule.factory("$applications", ["$window", "$APP_NAME", "$session", function ($window, $APP_NAME, $session) {
  var applicationMap = {
    DETTE: {
      id: "DETTE",
      path: "/tael",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_DETTE");
      }
    },
    DETTE_GARANTIE: {
      id: "DETTE_GARANTIE",
      path: "/dette-garantie",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_DETTE_GARANTIE");
      }
    },
    PLACEMENT: {
      id: "PLACEMENT",
      path: "/placement",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_PLACEMENT");
      }
    },
    OBSERVATOIRE_FINANCIER: {
      id: "OBSERVATOIRE_FINANCIER",
      path: "/of",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_OBSERVATOIRE_FINANCIER");
      }
    },
    INTRA: {
      id: "INTRA",
      path: "/intra",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "INTRA_TAELYS");
      }
    },
    OBSERVATOIRE: {
      id: "OBSERVATOIRE",
      path: "/observatoire",
      publicApp: true,
      isAllowed: function isAllowed(habilitations) {
        return true;
      }
    },
    PRET: {
      id: "PRET",
      path: "/pret",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_PRET");
      }
    },
    PRET_INTRA: {
      id: "PRET_INTRA",
      path: "/pret-intra",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_PRET_INTRA");
      }
    },
    CREDIT_BAIL: {
      id: "CREDIT_BAIL",
      path: "/credit-bail",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_CREDIT_BAIL");
      }
    },
    AIDE_SUBVENTION: {
      id: "AIDE_SUBVENTION",
      path: "/aide-subvention",
      publicApp: false,
      isAllowed: function isAllowed(habilitations) {
        return _.includes(habilitations, "MODULE_AIDE_SUBVENTION");
      }
    }
  };
  var $applications = {
    getApplicationNames: function getApplicationNames() {
      return _.keys(applicationMap);
    },
    getCurrentApp: function getCurrentApp() {
      return $applications.getApp($APP_NAME);
    },
    getCurrentAppId: function getCurrentAppId() {
      return $applications.getCurrentApp().id;
    },
    getCurrentAppPath: function getCurrentAppPath() {
      return $applications.getCurrentApp().path;
    },
    getApp: function getApp(appId) {
      return _.find(applicationMap, {
        id: appId
      });
    },
    getApplicationUrl: function getApplicationUrl(appId, path, compteId) {
      var appPath = $applications.getApp(appId).path;
      var url = appPath + (path || "/");
      if (compteId) {
        if (url.indexOf("?") !== -1) {
          url += "&toCompte=" + compteId;
        } else {
          url += "?toCompte=" + compteId;
        }
      }
      return url;
    },
    switchToApp: function switchToApp(appId) {
      // TODO : isAllowed check ?
      var app = $applications.getApp(appId);
      $window.location.href = app.path;
    },
    getAllowedApplications: function getAllowedApplications() {
      var apps = [];
      var habilitations = $session.getHabilitations();
      _.each(applicationMap, function (application) {
        if (application.isAllowed(habilitations)) {
          apps.push(application);
        }
      });
      return apps;
    },
    isDetteApplication: function isDetteApplication() {
      return $applications.getCurrentAppId() === "DETTE";
    },
    isDetteGarantieApplication: function isDetteGarantieApplication() {
      return $applications.getCurrentAppId() === "DETTE_GARANTIE";
    },
    isPretApplication: function isPretApplication() {
      return $applications.getCurrentAppId() === "PRET";
    },
    isPlacementApplication: function isPlacementApplication() {
      return $applications.getCurrentAppId() === "PLACEMENT";
    },
    isPretIntraApplication: function isPretIntraApplication() {
      return $applications.getCurrentAppId() === "PRET_INTRA";
    },
    isObservatoireFinancierApplication: function isObservatoireFinancierApplication() {
      return $applications.getCurrentAppId() === "OBSERVATOIRE_FINANCIER";
    },
    isCreditBailApplication: function isCreditBailApplication() {
      return $applications.getCurrentAppId() === "CREDIT_BAIL";
    },
    isAideSubventionApplication: function isAideSubventionApplication() {
      return $applications.getCurrentAppId() === "AIDE_SUBVENTION";
    }
  };
  return $applications;
}]);
ngModule.directive("ifDette", ["$animate", "$applications", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isDetteApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("ifPret", ["$animate", "$applications", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isPretApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("ifNotPret", ["$animate", "$applications", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (!$applications.isPretApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("ifPlacement", ["$animate", "$applications", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isPlacementApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("ifNotPlacement", ["$animate", "$applications", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (!$applications.isPlacementApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("ifPretIntra", ["$animate", "$applications", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isPretIntraApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("ifNotPretIntra", ["$animate", "$applications", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (!$applications.isPretIntraApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("ifCreditBail", ["$animate", "$applications", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isCreditBailApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("ifNotCreditBail", ["$animate", "$applications", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (!$applications.isCreditBailApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("ifDetteGarantie", ["$animate", "$applications", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isDetteGarantieApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("ifNotObservatoireFinancier", ["$animate", "$applications", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (!$applications.isObservatoireFinancierApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("ifObservatoireFinancier", ["$animate", "$applications", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isObservatoireFinancierApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("ifAideSubvention", ["$animate", "$applications", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($applications.isAideSubventionApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("ifNotAideSubvention", ["$animate", "$applications", function ($animate, $applications) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if (!$applications.isAideSubventionApplication()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("ifApplication", ["$applications", "$animate", function ($applications, $animate) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      var applicationNames = $attrs.ifApplication;
      var found = false;
      var applications = applicationNames.split('||');
      for (var i = 0; i < applications.length && !found; i++) {
        var inclusif = true;
        var applicationName = applications[i].trim();
        if (applicationName) {
          if (applicationName.substr(0, 1) === '!') {
            inclusif = false;
            applicationName = applicationName.substr(1);
          }
          if (applicationName && $applications.getCurrentAppId() === applicationName && inclusif || $applications.getCurrentAppId() !== applicationName && !inclusif) {
            found = true;
            $transclude($scope, function (clone) {
              $animate.enter(clone, $element.parent(), $element);
            });
          }
        }
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/security/$applications.js", __webpack_require__(1)))

/***/ }),
/* 2721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

// TODO : authz for routes -> interceptor

ngModule.factory("$authz", ["$session", function ($session) {
  var roleIntra = "INTRA_TAELYS";
  /**
   *
   * permet à un consultant d'afficher le site sans tenir compte du droit INTRA ne concerne que le front.
   */
  var roleIntraAvecVueClient = "INTRA_TAELYS_AVEC_VUE_CLIENT";
  var user = null,
    roles = {};
  var setUser = function setUser(_user, _habilitations) {
    user = _user;
    setRoles(_habilitations);
  };
  function setRoles(habilitations) {
    roles = {};
    _.each(habilitations, function (role) {
      roles[role] = true;
    });
  }
  var $authz = {
    $setUser: setUser,
    getId: function getId() {
      return user.id;
    },
    isClient: function isClient() {
      return !$authz.hasRole(roleIntra);
    },
    isIntra: function isIntra() {
      return !$authz.hasRole(roleIntraAvecVueClient) && $authz.hasRole(roleIntra);
    },
    hasRole: function hasRole(role) {
      return roles[role] === true;
    },
    hasRoles: function hasRoles(role1, role2, roleX) {
      var roles = arguments;
      if (roles.length === 1 && _.isArray(roles[0])) {
        roles = roles[0];
      }
      for (var i = 0; i < roles.length; i++) {
        if (!$authz.hasRole(roles[i])) {
          return false;
        }
      }
      return true;
    },
    hasAnyRole: function hasAnyRole(role1, role2, roleX) {
      var roles = arguments;
      if (roles.length === 1 && _.isArray(roles[0])) {
        roles = roles[0];
      }
      for (var i = 0; i < roles.length; i++) {
        if ($authz.hasRole(roles[i])) {
          return true;
        }
      }
      return false;
    }
  };
  return $authz;
}]);
ngModule.directive("authzIfClient", ["$authz", "$animate", function ($authz, $animate) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($authz.isClient()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);
ngModule.directive("authzIfIntra", ["$authz", "$animate", function ($authz, $animate) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      if ($authz.isIntra()) {
        $transclude($scope, function (clone) {
          $animate.enter(clone, $element.parent(), $element);
        });
      }
    }
  };
}]);

/**
 * authz-if-role="habililitation1||habililitation2".
 * Vous pouvez préfixer l'habilitation par ! pour tester le fait que l'utilisateur n'a pas ce rôle.
 * Utilisez || pour permettre plusieurs rôles
 */
ngModule.directive("authzIfRole", ["$authz", "$animate", function ($authz, $animate) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'AC',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      var roleNames = $attrs.authzIfRole;
      var found = false;
      var roles = roleNames.split('||');
      for (var i = 0; i < roles.length && !found; i++) {
        var inclusif = true;
        var roleName = roles[i].trim();
        if (roleName) {
          if (roleName.substr(0, 1) === '!') {
            inclusif = false;
            roleName = roleName.substr(1);
          }
          if (roleName && ($authz.hasRole(roleName) && inclusif || !$authz.hasRole(roleName) && !inclusif)) {
            found = true;
            $transclude($scope, function (clone) {
              $animate.enter(clone, $element.parent(), $element);
            });
          }
        }
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/security/$authz.js", __webpack_require__(1)))

/***/ }),
/* 2722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, moment, numeral, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts_highstock_src__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts_highstock_src___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highcharts_highstock_src__);




var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.provider("$session", function () {
  // utilisateur loggé
  var user,
    // compte visualisé
    compte,
    // prod, recette, dev, ...
    environment,
    // habilitations liées au compte visualisé (se consulte via $authz.hasRole)
    habilitations,
    // Liens vers des applications externes (OpenCash, Localnova, ..)
    externalApplications,
    // module de subvnetion accessible sur au moins un compte accesible à l'utilisateur - pour la gestion de groupe
    moduleSubventionAccessible;
  return {
    $get: ["$http", function $get($http) {
      return {
        $load: function $load() {
          return $http.get('/rest/authentication/session').then(function (response) {
            environment = response.data.environment;
            user = response.data.utilisateur;
            compte = response.data.compteVisualise;
            habilitations = response.data.habilitations;
            externalApplications = response.data.externalApplications;
            moduleSubventionAccessible = response.data.moduleSubventionAccessible;
            if (user.locale == null) {
              moment.locale("fr");
            } else {
              moment.locale(user.locale);
              numeral.language(user.locale);
              if (user.locale === 'en') {
                __WEBPACK_IMPORTED_MODULE_1_highcharts_highstock_src___default.a.setOptions({
                  lang: __WEBPACK_IMPORTED_MODULE_1_highcharts_highstock_src___default.a.translations['en_GB']
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_1_highcharts_highstock_src___default.a.setOptions({
                  lang: __WEBPACK_IMPORTED_MODULE_1_highcharts_highstock_src___default.a.translations['fr_FR']
                });
              }
            }
          });
        },
        getUser: function getUser() {
          return user;
        },
        /**
         *
         * @returns le compte visualise
         */
        getCompte: function getCompte() {
          return compte;
        },
        /**
         * passer par $authz.hasr role pour consulter les habilitations
         * @returns {*}
         */
        getHabilitations: function getHabilitations() {
          return habilitations;
        },
        getExternalApplications: function getExternalApplications() {
          return externalApplications;
        },
        isModuleSubventionAccessible: function isModuleSubventionAccessible() {
          return moduleSubventionAccessible;
        },
        /**
         *
         * @returns {boolean} true si le compte possède des comptes fils liés
         */
        possedeComptesLies: function possedeComptesLies() {
          return _.keys(this.getCompte().comptesLies).length > 0;
        },
        isNommageBudget: function isNommageBudget() {
          return !this.getCompte().budgetAsOperation;
        },
        isNommageOperation: function isNommageOperation() {
          return this.getCompte().budgetAsOperation;
        },
        getEnvironment: function getEnvironment() {
          return environment;
        }
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/security/$session.js", __webpack_require__(2), __webpack_require__(749), __webpack_require__(1)))

/***/ }),
/* 2723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, $, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.provider("security", ["$httpProvider", function ($httpProvider) {
  var roles = {
    INTRA_TAELYS: "INTRA_TAELYS"
  };
  var authenticationToken, compteId;
  return {
    $get: ["$http", "$window", "$location", "$APP_NAME", "$session", function $get($http, $window, $location, $APP_NAME, $session) {
      // Chaque fois que l'onglet obtient le focus, on repose le contenu du cookie d'authent de manière à ce qu'un nouvel onglet ouvert puisse le récupérer
      angular.element($window).bind('focus', function () {
        $.cookie('authenticationToken', authenticationToken, {
          path: '/'
        });
        if (compteId) {
          $.cookie('compteId', compteId, {
            path: '/'
          });
        } else {
          $.removeCookie('compteId', {
            path: '/'
          });
        }
        console.log('focus - set compteId to', compteId);
      });
      var deconnect = function deconnect() {
        $http.post('/rest/authentication/logout').then(function (response) {
          $.removeCookie('authenticationToken', {
            path: '/'
          });
          $.removeCookie('compteId', {
            path: '/'
          });
          sessionStorage.removeItem("compteId");
          sessionStorage.removeItem("authenticationToken");
          // par securité, mais ne sert plus à rien... juste pour nettoyer l'ancien comportement en 2020.5
          localStorage.removeItem("compteId");
          $window.location.href = response.data.response; // PGA : on redirige vers la home de la prod pour le moment.
        });
      };
      var setAuthenticationToken = function setAuthenticationToken() {
        authenticationToken = $location.search().authenticationToken || sessionStorage.getItem('authenticationToken') || $.cookie('authenticationToken');
        // Stocke le contenu du cookie d'authent de manière à ce qu'un nouvel onglet ouvert puisse le récupérer
        $.cookie('authenticationToken', authenticationToken, {
          path: '/'
        });
        // Stocke en sessionStorage pour que les appels ulterieurs (et le reload de l'appli) retrouvent bien la session courante
        sessionStorage.setItem("authenticationToken", authenticationToken);
        $httpProvider.defaults.headers.common['authenticationToken'] = authenticationToken;
      };
      var setAppId = function setAppId() {
        $httpProvider.defaults.headers.common['appId'] = $APP_NAME;
      };
      var setCompteId = function setCompteId() {
        if ($APP_NAME !== "INTRA") {
          compteId = $location.search().toCompte || sessionStorage.getItem("compteId") || $.cookie('compteId');
          if (compteId) {
            console.log('set compteId to', compteId);
            $httpProvider.defaults.headers.common['compteId'] = compteId;
            sessionStorage.setItem("compteId", compteId);
            $.cookie('compteId', compteId, {
              path: '/'
            });
          }
        } else {
          console.log('clean compteId');
          sessionStorage.removeItem("compteId");
          $.removeCookie('compteId', {
            path: '/'
          });
          compteId = null;
          delete $httpProvider.defaults.headers.common.compteId;
        }
      };
      return {
        getTokens: function getTokens() {
          var tokens = {
            authenticationToken: authenticationToken,
            appId: $APP_NAME
          };
          if (compteId != null) {
            tokens.compteId = compteId;
          }
          return tokens;
        },
        initAuthentication: function initAuthentication() {
          setAuthenticationToken();
          setAppId();
          setCompteId();

          // we cleanup transfert parameters
          var search = $location.search();
          if (search.toCompte || search.authenticationToken) {
            $location.search(_.omit($location.search(), "toCompte", "authenticationToken"));
          }
        },
        exit: function exit() {
          if ($APP_NAME === "INTRA") {
            deconnect();
          } else {
            var user = $session.getUser();
            if (_.includes(user.habilitations, roles.INTRA_TAELYS)) {
              $window.location.href = "/intra/";
            } else {
              deconnect();
            }
          }
        }
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/security/security.js", __webpack_require__(3), __webpack_require__(4), __webpack_require__(1)))

/***/ }),
/* 2724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.filter('dateCustom', ["$dateFormat", function ($dateFormat) {
  return function (date, format) {
    if (date == null) {
      return '';
    }
    return $dateFormat.custom(date, format);
  };
}]);

/**
 * ex : (fr) Lundi 12 Mars 2013
 */
ngModule.filter('date', ["$dateFormat", function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.date(date);
  };
}]);

/**
 * ex : 31/10/2015
 */
ngModule.filter('dateShort', ["$dateFormat", function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.short(date);
  };
}]);

/**
 * ex : 31/10/2015 14:14
 */
ngModule.filter('dateMedium', ["$dateFormat", function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.medium(date);
  };
}]);

/**
 * * ex : (fr) 21/09/2012 14:52:10
 */
ngModule.filter('dateLong', ["$dateFormat", function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.long(date);
  };
}]);

/**
 * * ex : 14:52:10
 */
ngModule.filter('time', ["$dateFormat", function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.time(date);
  };
}]);
ngModule.filter('elapseDays', ["$dateFormat", function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    } else {
      if (moment.duration(date).asDays() >= -1 && moment.duration(date).asDays() < 1) {
        // todo - i8n
        return "aujourd'hui";
      }
    }
    return moment.duration(date).humanize(true);
  };
}]);
ngModule.filter('dateUrlShort', ["$dateFormat", function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.urlShort(date);
  };
}]);
ngModule.filter('dateServer', ["$dateFormat", function ($dateFormat) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.server(date);
  };
}]);
ngModule.filter('dateYear', ["$dateFormat", function ($dateFormat) {
  // TODO : rename to getYear
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.year(date);
  };
}]);
ngModule.filter('dateDayOfMonth', ["$dateFormat", function ($dateFormat) {
  // TODO : rename to get...
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.custom(date, 'DD');
  };
}]);
ngModule.filter("getLongMonth", ["$dateFormat", function ($dateFormat) {
  return function getLongMonth(date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.custom(date, "MMMM");
  };
}]);
ngModule.filter('longMonthAndYear', ["$dateFormat", "$dateDisplayFormats", function ($dateFormat, $dateDisplayFormats) {
  return function (date) {
    if (date == null) {
      return '';
    }
    return $dateFormat.custom(date, $dateDisplayFormats.MONTH_AND_YEAR);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/types/date/dateFilters.js", __webpack_require__(2)))

/***/ }),
/* 2725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, moment, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("$dateDisplayFormats", function () {
  return {
    DATE: "dddd D MMM YYYY",
    LONG: "DD/MM/YYYY HH:mm:ss",
    MEDIUM: "DD/MM/YYYY HH:mm",
    SHORT: "DD/MM/YYYY",
    URL_SHORT: "YYYY-MM-DD",
    MONTH_AND_YEAR: "MMMM YYYY",
    YEAR: "YYYY",
    TIME: "HH:mm:ss"
  };
});
ngModule.factory("$dateFormat", ["$dateDisplayFormats", "$serverDateFormat", "$serverShortDateFormat", function ($dateDisplayFormats, $serverDateFormat, $serverShortDateFormat) {
  var $dateFormat = function $dateFormat(date, format) {
    if (date === null || date === "") {
      return null;
    }
    return moment(date).format(format);
  };
  _.extend($dateFormat, {
    /**
     * Returns a formatter function for given format.
     *
     * @param format The format to use for this formatter
     */
    formatter: function formatter(format) {
      return function (date) {
        return $dateFormat(date, format);
      };
    },
    custom: function custom(date, format) {
      return $dateFormat(date, format);
    },
    /**
     * YYYY-MM-DD HH:mm:ss
     */
    server: function server(date) {
      return $dateFormat(date, $serverDateFormat);
    },
    /**
     * YYYY-MM-DD
     */
    serverShort: function serverShort(date) {
      return $dateFormat(date, $serverShortDateFormat);
    },
    /**
     * ex : (fr) Lundi 12 Mars 2013
     */
    date: function date(_date) {
      return $dateFormat(_date, $dateDisplayFormats.DATE);
    },
    /**
     * ex : (fr) 21/09/2012 14:52:10
     */
    long: function long(date) {
      return $dateFormat(date, $dateDisplayFormats.LONG);
    },
    /**
     * ex : (fr) 21/09/2012 14:52
     */
    medium: function medium(date) {
      return $dateFormat(date, $dateDisplayFormats.MEDIUM);
    },
    /**
     * ex : (fr) 21/09/2012
     */
    short: function short(date) {
      return $dateFormat(date, $dateDisplayFormats.SHORT);
    },
    /**
     * date au format jj-mm-yyyy qui peut etre passé dans l'url
     */
    urlShort: function urlShort(date) {
      return $dateFormat(date, $dateDisplayFormats.URL_SHORT);
    },
    /**
     * ex : 2012
     */
    year: function year(date) {
      return $dateFormat(date, $dateDisplayFormats.YEAR);
    },
    /**
     * ex : 14:52:10
     */
    time: function time(date) {
      return $dateFormat(date, $dateDisplayFormats.TIME);
    }
  });
  return $dateFormat;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/types/date/dateFormat.js", __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 2726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.filter("duree", ["$dureeFormat", function ($dureeFormat) {
  return function dureeFilter(value) {
    return $dureeFormat(value);
  };
}]);

/**
 * formatage d'un nombre de mois en années/mois : (ex : 276 –> 2 ans et 3 mois)
 * Params:  value – un nombre de mois
 */
ngModule.filter("dureeFromMois", ["$dureeFormat", function ($dureeFormat) {
  return function dureeFilter(value) {
    var dureeFromMois = $dureeFormat.dureeFromMois(value);
    return dureeFromMois;
  };
}]);

/**
 * formatage d'un nombre de minutes en j/h/mn : (ex : 90 –> 1 h 3 mn) - x j y h z mn
 *
 * Params:  value – un nombre de minutes
 */
ngModule.filter("dureeFromMinutes", function () {
  return function tempsFilter(dureeEnMin) {
    var m = dureeEnMin % 60;
    var h = Math.floor(dureeEnMin / 60) % 24;
    var j = Math.floor(dureeEnMin / (60 * 24));
    var res = "";
    if (j > 0) {
      res += j + " j ";
    }
    if (h > 0) {
      res += h + " h ";
    }
    res += m + " mn ";
    return res;
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/types/duree/duree-filters.js"))

/***/ }),
/* 2727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * @ngdoc service
 * @name $dureeFormat
 * @function
 *
 * @description la valeur est une Period jodatime dont les composants sont stockés dans un tableau iValues[year, month, week, days, hours, minutes, seconds]
 *
 *
 */
ngModule.factory("$dureeFormat", ["stringUtils", function (stringUtils) {
  var defaultPlaceHolder = "-";
  var $numberFormat = function $numberFormat(value) {
    if (value == null) {
      return defaultPlaceHolder;
    }
    var res = "";
    var years = value.iValues[0];
    var months = value.iValues[1];
    if (years === 1) {
      res += years + " an";
    } else if (years > 1) {
      res += years + " ans";
    }
    if (months > 0 && years > 0) {
      res += " ";
    }
    if (months > 0 || years === 0) {
      if (years > 0) {
        res += " et ";
      }
      res += months + " mois";
    }
    return res;
  };
  _.extend($numberFormat, {
    /**
     * formatage d'un nombre de mois en années/mois : (ex : 276 --> 2 ans et 3 mois)
     *
     * @param value un nombre de mois
     */
    dureeFromMois: function dureeFromMois(value) {
      if (value == null) {
        return defaultPlaceHolder;
      }
      var res = "";
      var years = Math.floor(value / 12);
      var months = value % 12;
      if (years === 1) {
        res += years + " an ";
      } else if (years > 1) {
        res += years + " ans ";
      }
      if (months > 0 || years === 0) {
        if (years > 0) {
          res += " et ";
        }
        res += months + " mois ";
      }
      return res;
    },
    /**
     *
     * @param monthAmount si dépasse 11 alors sera ramené à une valeur entre 0 et 11 et les années incrémentées du nombre d'année correspondant
     * @param yearsAmount optionnel
     * @returns {string}
     */
    dureeFromAnneeEtMoisEtJour: function dureeFromAnneeEtMoisEtJour(yearsAmount, monthAmount, days) {
      var res = "";
      var years = Math.floor(monthAmount / 12);
      var months = monthAmount % 12;
      if (yearsAmount) {
        years += yearsAmount;
      }
      if (years === 1) {
        res += years + " an ";
      } else if (years > 1) {
        res += years + " ans ";
      }
      if (months > 0 || years === 0) {
        if (years > 0 && !(days > 0)) {
          res += " et ";
        }
        res += months + " mois ";
      }
      if (days > 0) {
        if (days > 1) {
          res += " et " + days + " jours";
        } else {
          res += " et " + days + " jour";
        }
      }
      return res;
    }
  });
  return $numberFormat;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/types/duree/dureeFormat.js", __webpack_require__(1)))

/***/ }),
/* 2728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * @ngdoc filter
 * @name common.filter:indexTaux
 * @function
 *
 * @description
 * Formats an indexTaux (ie. index, marge, periodicity).
 *
 * @param {IndexTaux} The indexTaux to filter.
 *
 * @returns {string} Formatted indexTaux.
 */
ngModule.filter("indexTaux", ["$indexTauxFormat", function ($indexTauxFormat) {
  return function indexTauxFilter(indexTaux) {
    return $indexTauxFormat(indexTaux);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/types/index-taux/indexTaux-filter.js"))

/***/ }),
/* 2729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * @ngdoc service
 * @name $indexTauxFormat
 * @function
 *
 * @description
 * IndexTaux formatter (ie. index, marge, periodicity).
 *
 */
ngModule.factory("$indexTauxFormat", function () {
  var $indexTauxFormat = function $indexTauxFormat(indexTaux) {
    if (indexTaux == null) {
      return "-";
    }
    var formattedIndex = indexTaux.index ? indexTaux.index : "Taux fixe";
    var formattedMarge = indexTaux.marge ? " + " + indexTaux.marge : "";
    var formattedPeriodicite = indexTaux.periodicite ? " (" + indexTaux.periodicite + ")" : "";
    var formatted = formattedIndex + formattedMarge + formattedPeriodicite;
    return formatted;
  };
  return $indexTauxFormat;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/types/index-taux/indexTauxFormat.js"))

/***/ }),
/* 2730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * @ngdoc filter
 * @name common.filter:montant
 * @function
 *
 * @description
 * Formats a montant (ie. 1 234 567,12 €).
 * If montant is of ESTIME type, will add an '*' add the end of the formatted value.
 * If fixedDecimals is provided, will format using given fixed decimal number,
 * else will format using 2 optional decimals.
 *
 * @param {Montant} The montant to filter.
 * @param {number=} The optional number of fixed decimal to use.
 * @param {signed=} optional,  si présent et non à false met toujours le signe (+/- always displayed).
 * @param {unite=} optional,  si K ou M met en millier ou million.
 *
 * @returns {string} Formatted montant.
 */
ngModule.filter("montant", ["$montantFormat", function ($montantFormat) {
  return function montantFilter(montant, fixedDecimals, signed, unite) {
    return $montantFormat.montant(montant, fixedDecimals, signed, unite);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/types/montant/montantFilter.js"))

/***/ }),
/* 2731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, numeral) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * @ngdoc service
 * @name $montantFormat
 * @function
 *
 * @description
 * Montant formatter.
 *
 */
ngModule.factory("$montantFormat", ["stringUtils", "currencyService", "parametrageMontantProviderService", function (stringUtils, currencyService, parametrageMontantProviderService) {
  var defaultPlaceHolder = "-";
  var $montantFormat = function $montantFormat(montant, fixedDecimals, signed, unite) {
    if (montant == null || montant.valeur == null) {
      return defaultPlaceHolder;
    }
    var isSigned = !_.isUndefined(signed) && signed !== false;
    var isFixedDecimals = !_.isUndefined(fixedDecimals);
    var format;
    if (parametrageMontantProviderService.cacherDecimales()) {
      format = "0,0";
    } else if (isFixedDecimals) {
      var nbDecimals = parseInt(fixedDecimals);
      format = "0,0." + stringUtils.repeatSequence("0", nbDecimals);
    } else {
      format = "0,0.00";
    }
    var valeur = montant.valeur;
    var currencySign = currencyService.getCurrencySign(montant.devise);
    if (unite == null) {
      unite = parametrageMontantProviderService.getUniteAffichageMontant();
    }
    if (unite === 'K') {
      currencySign = 'K' + currencySign;
      valeur = valeur / 1000.0;
    } else if (unite === 'M') {
      currencySign = 'M' + currencySign;
      valeur = valeur / 1000000.0;
    }
    var formatted = numeral(valeur).format(format);

    // todo - sans doute à intégrer dans la pattern de format
    if (isSigned) {
      if (numeral(montant.valeur) > 0.0000001) {
        formatted = "+ " + formatted;
      }
    }
    var estimated = montant.type === "ESTIME" || montant.type === "SIMULE";
    return formatted + " " + currencySign + (estimated ? " *" : "");
  };
  _.extend($montantFormat, {
    /**
     *
     * @param {Montant} montant
     * @param {number=} nbDecimals
     * @param {signed=} optional,  si présent et non à false met toujours le signe (+/- always displayed).
     * @param {unite=} optional,  si K ou M met en millier ou million.
     * @returns {string} The formatter montant.
     */
    montant: function montant(_montant, nbDecimals, signed, unite) {
      return $montantFormat(_montant, nbDecimals, signed, unite);
    },
    /**
     *
     * @param montantAsNumber un nombre (le montant)
     * @param devise la devise, par defaut EUR
     * @param nbDecimals
     * @param signed
     * @param unite
     * @returns {string|string}
     */
    number: function number(montantAsNumber, nbDecimals, devise, signed, unite) {
      var montant = null;
      if (montantAsNumber != null) {
        montant = {
          valeur: montantAsNumber,
          devise: devise || 'EUR'
        };
      }
      return $montantFormat(montant, nbDecimals, signed, unite);
    }
  });
  return $montantFormat;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/types/montant/montantFormat.js", __webpack_require__(1), __webpack_require__(749)))

/***/ }),
/* 2732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * @ngdoc filter
 * @name common.filter:number
 * @function
 *
 * @description
 * Formats a number as a number (ie. 1 234 567,12)
 * If fixedDecimals is provided, will format using given fixed decimal number,
 * else will format using 2 optional decimals.
 *
 * @param {number} The number to filter.
 * @param {number=} The optional number of fixed decimal to use.
 *
 * @returns {string} Formatted number.
 */
ngModule.filter("number", ["$numberFormat", function ($numberFormat) {
  return function numberFilter(value, fixedDecimals, optionalZeroAtTheEnd) {
    if (_.isNaN(value)) {
      return "";
    }
    return $numberFormat.number(value, fixedDecimals, optionalZeroAtTheEnd);
  };
}]);

// TODO : doc
ngModule.filter("currency", ["$numberFormat", function ($numberFormat) {
  return function currencyFilter(value, fixedDecimals, currencySymbol) {
    if (arguments.length === 2 && _.isString(fixedDecimals)) {
      return $numberFormat.number(value) + " " + fixedDecimals;
    } else if (arguments.length === 3) {
      return $numberFormat.number(value, fixedDecimals) + " " + currencySymbol;
    } else {
      return $numberFormat.currency(value, fixedDecimals);
    }
  };
}]);

/**
 * @ngdoc filter
 * @name common.filter:percentage
 * @function
 *
 * @description
 * Formats a number as a percentage (ie. 75,12 %)
 * If fixedDecimals is provided, will format using given fixed decimal number,
 * else will format using 2 optional decimals.
 *
 * @param {number} The number to filter.
 * @param {number=} The optional number of fixed decimal to use.
 *
 * @returns {string} Formatted number.
 */
ngModule.filter("percentage", ["$numberFormat", function ($numberFormat) {
  return function percentageFilter(value, fixedDecimals) {
    if (_.isNaN(value)) {
      return "";
    }
    return $numberFormat.percentage(value, fixedDecimals);
  };
}]);

/**
 * @ngdoc filter
 * @name common.filter:bytes
 * @function
 *
 * @description
 * Formats a number as readable bytes / fileSize (ie. 12,46 Mo)
 * If fixedDecimals is provided, will format using given fixed decimal number,
 * else will format using 2 optional decimals.
 *
 * @param {number} The number to filter.
 * @param {number=} The optional number of fixed decimal to use.
 *
 * @returns {string} Formatted number.
 */
ngModule.filter("bytes", ["$numberFormat", function ($numberFormat) {
  return function numberFilter(value, fixedDecimals) {
    return $numberFormat.bytes(value, fixedDecimals);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/types/number/numberFilters.js", __webpack_require__(1)))

/***/ }),
/* 2733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, numeral) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * @ngdoc service
 * @name $numberFormat
 * @function
 *
 * @description
 * Number formatter based on numeraljs.
 *
 */
ngModule.factory("$numberFormat", ["stringUtils", function (stringUtils) {
  /**
   *
   * @param nbDecimals le nombre de décimales a afficher. Si non fourni, alors c'est 2 décimales optionnelles en cas de 0
   * @param suffix optionnel
   * @param optionalZeroAtTheEnd si true, alors les décimales a la fin s'arrêteront si il y a des 0 meme sans atteindre le nbDecimals - uniquement utilisé si nbDecimals est renseigné
   * @returns {string}
   */
  var buildPattern = function buildPattern(nbDecimals, suffix, optionalZeroAtTheEnd) {
    if (_.isNumber(nbDecimals)) {
      var optionalZeron = optionalZeroAtTheEnd === true && nbDecimals > 0;
      return "0,0." + (optionalZeron ? "[" : "") + stringUtils.repeatSequence("0", nbDecimals) + (optionalZeron ? "]" : "") + (suffix ? " " + suffix : "");
    } else {
      return "0,0.[00]" + (suffix ? " " + suffix : "");
    }
  };
  var defaultPlaceHolder = "-";
  var $numberFormat = function $numberFormat(number, patternOrDecimals, suffix, optionalZeroAtTheEnd, signed) {
    if (number == null) {
      return defaultPlaceHolder;
    }
    var isSigned = !_.isUndefined(signed);
    var pattern;
    if (_.isNumber(patternOrDecimals) || suffix) {
      pattern = buildPattern(patternOrDecimals, suffix, optionalZeroAtTheEnd);
    } else {
      pattern = patternOrDecimals || buildPattern();
    }
    try {
      var res = numeral(number).format(pattern);
      if (isSigned) {
        if (numeral(number) > 0) {
          res = "+" + res;
        }
      }
      return res;
    } catch (e) {
      console.log("Impossible de formater", number, pattern, e);
      return "ERR";
    }
  };
  _.extend($numberFormat, {
    /**
     * Returns the precision to use in formatters to catch "enough" significative digits of the given number
     *
     * @param value The value to compute a precision for
     */
    precisionSignificative: function precisionSignificative(value) {
      return value < 0.01 ? 5 : value < 0.01 ? 3 : 2;
    },
    /**
     * Returns a formatter function for given pattern.
     *
     * @param pattern The format to use for this formatter
     */
    formatter: function formatter(pattern) {
      return function (number) {
        return $numberFormat(number, pattern);
      };
    },
    /**
     *
     * @param {number} number
     * @param {number=} nbDecimals
     * @param {boolean} optionalZeroAtTheEnd - si nbDecimals renseigné, permet de rendre optionnel les décimales finales à 0
     * @returns {string} The formatter number.
     */
    number: function number(_number, nbDecimals, optionalZeroAtTheEnd) {
      return $numberFormat(_number, nbDecimals, undefined, optionalZeroAtTheEnd);
    },
    /**
     *
     * @param {number} number
     * @param {number=} nbDecimals
     * @returns {string} The formatted percentage.
     */
    currency: function currency(number, nbDecimals) {
      return $numberFormat(number, nbDecimals, "$");
    },
    /**
     *
     * @param {number} number (base 1)
     * @param {number=} nbDecimals
     * @returns {string} The formatted percentage : ex : 0.012 --> 0.12 %
     */
    percentage: function percentage(number, nbDecimals) {
      return $numberFormat(number, nbDecimals, "%");
    },
    /**
     *
     * @param {number} number
     * @param {number=} nbDecimals
     * @returns {string} The formatted bytes.
     */
    bytes: function bytes(number, nbDecimals) {
      var formatted = $numberFormat(number, nbDecimals, "b");
      // PGA : for now, numeral doesn't supports translation for bytes... doing it manually until then...
      var mapping = {
        "KB": "Ko",
        "MB": "Mo",
        "GB": "Go",
        "B": "o"
      };
      _.each(mapping, function (french, english) {
        formatted = formatted.replace(english, french);
      });
      return formatted;
    }
  });
  return $numberFormat;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/types/number/numberFormat.js", __webpack_require__(1), __webpack_require__(749)))

/***/ }),
/* 2734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.filter("taux", ["$tauxFormat", function ($tauxFormat) {
  return function tauxFilter(taux, fixedDecimals, signed) {
    return $tauxFormat(taux, fixedDecimals, signed);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/types/taux/taux-filters.js"))

/***/ }),
/* 2735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, numeral) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * @ngdoc service
 * @name $numberFormat
 * @function
 *
 * @description
 * Number formatter based on numeraljs.
 *
 */
ngModule.factory("$tauxFormat", ["stringUtils", function (stringUtils) {
  var $tauxFormat = function $tauxFormat(value, fixedDecimals, signed) {
    if (value == null) {
      return "-";
    }
    var isSigned = !_.isUndefined(signed);
    var isFixedDecimals = !_.isUndefined(fixedDecimals);
    var format;
    if (isFixedDecimals) {
      var nbDecimals = parseInt(fixedDecimals);
      format = "0,0." + stringUtils.repeatSequence("0", nbDecimals);
    } else {
      format = "0,0.[00]";
    }
    var res = numeral(value.valeur * 100).format(format) + " %";
    // todo - sans doute à intégrer dans la pattern de format
    if (isSigned) {
      if (numeral(value.valeur) > 0) {
        res = "+" + res;
      }
    }
    if (value.type === 'ESTIME') {
      res += "*";
    }
    return res;
  };
  return $tauxFormat;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/types/taux/tauxFormat.js", __webpack_require__(1), __webpack_require__(749)))

/***/ }),
/* 2736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.filter('telephone', function () {
  return function (telephone) {
    // Insere des espaces entre les 5 groupes de 2 chiffres si le telephone commence bien par 10 chiffres, sinon laisse tel quel
    return telephone ? telephone.replace(/^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(.*)$/, "$1 $2 $3 $4 $5$6") : null;
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/types/telephoneFilters.js"))

/***/ }),
/* 2737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, numeral) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * @ngdoc service
 * @name $valeurFormat
 * @function
 *
 * @description
 * Number formatter based on numeraljs.
 *
 */
ngModule.factory("$valeurFormat", ["stringUtils", function (stringUtils) {
  var $valeurFormat = function $valeurFormat(value, fixedDecimals, signed) {
    if (value == null) {
      return "-";
    }
    var isSigned = !_.isUndefined(signed);
    var isFixedDecimals = !_.isUndefined(fixedDecimals);
    var format;
    if (isFixedDecimals) {
      var nbDecimals = parseInt(fixedDecimals);
      format = "0,0." + stringUtils.repeatSequence("0", nbDecimals);
    } else {
      format = "0,0.[00]";
    }
    var res = numeral(value.valeur).format(format);
    // todo - sans doute à intégrer dans la pattern de format
    if (isSigned) {
      if (numeral(value.valeur) > 0.0000001) {
        res = "+" + res;
      }
    }
    if (value.type === 'ESTIME') {
      res += "*";
    }
    return res;
  };
  return $valeurFormat;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/types/valeurFormat.js", __webpack_require__(1), __webpack_require__(749)))

/***/ }),
/* 2738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("$body", ["$document", function ($document) {
  return $document.find("body");
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/$body.js"))

/***/ }),
/* 2739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("$debounce", ["$timeout", function ($timeout) {
  /**
   * @ngdoc service
   * @name $debounce
   *
   * @description
   * Angular's $timeout wrapper around the 'debounce' approach (such as in underscore).
   * The 'fn' function will be asynchronously executed only after 'wait' ms without consecutive calls.
   * rootScope.$apply will be called after method execution, except if 'invokeApply' is false.
   *
   * @param {function()} [fn] A function to debounce.
   * @param {number=}  [wait] The debounce duration in milliseconds.
   * @param {boolean=} [invokeApply=true] If set to 'false', skips the {@link ng.$rootScope.Scope#$apply `$applỳ} call.
   *
   * @returns {function()} The debounced function wrapper.
   *                      The wrapper has a 'cancel' method attribute, which can be called to cancel the currently pending debounce.
   */
  function $debounce(fn, wait, invokeApply) {
    var timeoutPromise;
    function cancel() {
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
        timeoutPromise = null;
      }
    }
    function debouncedWrapper() {
      var self = this,
        args = arguments;
      cancel();
      timeoutPromise = $timeout(function () {
        fn.apply(self, args);
      }, wait, invokeApply);
    }
    debouncedWrapper.cancel = cancel;
    return debouncedWrapper;
  }
  return $debounce;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/$debounce.js"))

/***/ }),
/* 2740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Wrapper around the localStorage to parse / stringify during getItem and setItem
 */
ngModule.factory("$localStorage", ["$window", "NonPersistentStorage", function ($window, NonPersistentStorage) {
  var storage = isStorageSupported($window, "localStorage") ? $window.localStorage : new NonPersistentStorage();
  return {
    getItem: function getItem(key) {
      return JSON.parse(storage.getItem(key));
    },
    setItem: function setItem(key, value) {
      return storage.setItem(key, JSON.stringify(value));
    },
    removeItem: function removeItem(key) {
      return storage.removeItem(key);
    }
  };
}]);
function isStorageSupported(window, storeName) {
  try {
    var testKey = 'test-storage',
      storage = window[storeName];
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
}

/**
 * Naive localStorage / sessionStorage shim
 * ( mainly for safari private browsing mode )
 */
ngModule.factory("NonPersistentStorage", function () {
  return function NonPersistentStorage() {
    var self = this,
      data = {};
    var recomputeLength = function recomputeLength() {
      self.length = _.keys(data);
    };
    return {
      clear: function clear() {
        data = {};
        recomputeLength();
      },
      getItem: function getItem(key) {
        return _.has(data, key) ? JSON.parse(data[key]) : null;
      },
      key: function key(i) {
        var keys = _.keys(data);
        if (i < keys.length) {
          return keys[i];
        }
        return null;
      },
      removeItem: function removeItem(key) {
        delete data[key];
        recomputeLength();
      },
      setItem: function setItem(key, value) {
        data[key] = JSON.stringify(value);
        recomputeLength();
      },
      length: 0
    };
  };
});

//////////////
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/$localStorage.js", __webpack_require__(1)))

/***/ }),
/* 2741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Utility method returning current time.
 * This is a wrapper mainly for mocking purpose during tests.
 */
ngModule.factory("$now", function () {
  return function () {
    return _.now();
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/$now.js", __webpack_require__(1)))

/***/ }),
/* 2742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("$throttle", ["$timeout", "$now", "$rootScope", function ($timeout, $now, $rootScope) {
  /**
   * @ngdoc service
   * @name $throttle
   *
   * @description
   * Angular's $timeout wrapper around the 'throttle' approach (such as in underscore).
   * By default, throttle will execute the function as soon as you call it for the first time,
   * and, if you call it again any number of times during the wait period, as soon as that period is over.
   * If you'd like to disable the leading-edge call, pass {leading: false},
   * and if you'd like to disable the execution on the trailing-edge, pass {trailing: false}.
   *
   * @param {function()} fn A function to debounce.
   * @param {number}  delay The throttle duration in milliseconds.
   * @param {boolean=} [invokeApply=true] If set to 'false', skips the {@link ng.$rootScope.Scope#$apply `$applỳ} call.
   * @param {Object=} [options={}]
   *
   * @returns {function()} The throttled function wrapper.
   */
  function $throttle(fn, delay, invokeApply, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    var initial = true;
    if (arguments.length === 3 && _.isObject(invokeApply)) {
      options = invokeApply;
      invokeApply = true;
    }
    if (!options) {
      options = {};
    }
    var later = function later() {
      previous = options.leading === false ? 0 : $now();
      timeout = null;
      result = fn.apply(context, args);
      if (!timeout) {
        context = args = null;
      }
    };
    return function throttleWrapper() {
      var now = $now();
      if (!previous && options.leading === false) {
        previous = now;
        initial = false;
      }
      var remaining = delay - (now - previous);
      context = this;
      args = arguments;
      if (initial === true || remaining <= 0 || remaining > delay) {
        if (timeout) {
          $timeout.cancel(timeout);
          timeout = null;
        }
        previous = now;
        initial = false;
        result = fn.apply(context, args);
        if (invokeApply !== false) {
          $rootScope.$apply();
        }
        if (!timeout) {
          context = args = null;
        }
      } else if (!timeout && options.trailing !== false) {
        timeout = $timeout(later, remaining, invokeApply);
      }
      return result;
    };
  }
  return $throttle;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/$throttle.js", __webpack_require__(1)))

/***/ }),
/* 2743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
var uuid = __webpack_require__(911);
ngModule.factory("UUID", function () {
  return function UUID() {
    return uuid.v4(); // using node-uuid
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/UUID.js"))

/***/ }),
/* 2744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Utility class to manipulates and alter arrays.
 */
ngModule.factory("arrayUtils", function () {
  return {
    /**
     * Returns true if array contains any of given items, false otherwise.
     * @param array
     * @param items
     */
    containsAny: function containsAny(array, items) {
      for (var i = 0; i < items.length; i++) {
        if (_.includes(array, items[i])) {
          return true;
        }
      }
      return false;
    },
    /**
     * Clear the destination array, then fill it with elements from the source array.
     * Used to replace array while keeping it's reference.
     *
     * @param destination
     * @param source
     */
    fillWith: function fillWith(destination, source) {
      destination.splice(0, destination.length);
      destination.push.apply(destination, source);
    },
    /**
     * Remove all elements from given array
     * 
     * @param array
     */
    clearArray: function clearArray(array) {
      array.splice(0, array.length);
    },
    /**
     * Move an element in given `array` from `fromIndex` position to `toIndex` position.
     *
     * @param array
     * @param fromIndex
     * @param toIndex
     */
    moveElement: function moveElement(array, fromIndex, toIndex) {
      if (fromIndex < 0 || toIndex < 0 || fromIndex >= array.length || toIndex >= array.length) {
        return;
      }
      array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);
    },
    /**
     * Delete element at 'index' from given `array`
     *
     * @param array
     * @param index
     */
    deleteElement: function deleteElement(array, index) {
      if (index < 0 || index >= array.length) {
        return;
      }
      array.splice(index, 1);
    },
    /**
     * Insert given element at 'index' in given `array`
     *
     * @param array
     * @param index
     * @param element
     */
    insertElement: function insertElement(array, index, element) {
      if (index < 0 || index > array.length) {
        return;
      }
      array.splice(index, 0, element);
      return array;
    },
    /**
     * Swap given elements in given array
     *
     * @param array The array to swap in
     * @param firstIndex Index of the first element
     * @param secondIndex Index of the second element
     */
    swapElements: function swapElements(array, firstIndex, secondIndex) {
      var tmp = array[firstIndex];
      array[firstIndex] = array[secondIndex];
      array[secondIndex] = tmp;
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/arrayUtils.js", __webpack_require__(1)))

/***/ }),
/* 2745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("chartUtils", ["objectUtils", "$interpolate", "contrepartieService", "tlColors", "colorUtils", function (objectUtils, $interpolate, contrepartieService, tlColors, colorUtils) {
  var chartColors = [tlColors.NEW_BLUE_1, tlColors.NEW_ORANGE_1, tlColors.NEW_GREEN_1, tlColors.NEW_PURPLE_1, tlColors.NEW_LIGHT_BLUE, tlColors.NEW_ORANGE_2, tlColors.NEW_GREEN_4, tlColors.NEW_BLUE_2, tlColors.NEW_RED_1, tlColors.NEW_GREEN_3, tlColors.NEW_PURPLE_2];
  var tooltipTpl = '<span style="color: {{color}}; font-weight: {{weight}};">{{content}}</span>';
  var tooltipInterpolation = $interpolate(tooltipTpl);
  return {
    PLOT_LINE_COLOR: '#4DC100',
    /**
     * Creates an html span element displayable in highchart tooltip element.
     * @param content The content to display
     * @param options The options for the span element :
     *      - color [default : black] : the color of the element.
     *      - bold  [default : false] : if set to true, text will appear in bold.
     *      - br    [default : false] : if set to true, will append a <br/> tag to the end of the element.
     * @return {String} the html of the span
     */
    tooltipElement: function tooltipElement(content, options) {
      var o = options || {};
      var scope = {
        content: content,
        color: o.color || "black",
        weight: o.bold ? "bold" : "normal"
      };
      var html = tooltipInterpolation(scope);
      if (o.br) {
        html += "<br/>";
      }
      return html;
    },
    mapAndFilter: function mapAndFilter(serie, xAttribute, yAttribute, mapFct) {
      serie = this.filterEmptyValues(serie, xAttribute, yAttribute);
      var isDateAxis = serie.length > 0 && objectUtils.getProperty(serie[0], xAttribute) instanceof Date;
      serie = _.map(serie, mapFct || function (point) {
        return {
          x: isDateAxis ? objectUtils.getProperty(point, xAttribute).getTime() : objectUtils.getProperty(point, xAttribute),
          y: objectUtils.getProperty(point, yAttribute)
        };
      });
      return serie;
    },
    /**
     * ex : chartUtils.map(data, "date", "crd.valeur", {"devise": "crd.devise"})
     */
    map: function map(serie, xAttribute, yAttribute, otherAttributes) {
      serie = this.filterEmptyValues(serie, xAttribute, yAttribute);
      var isDateAxis = serie.length > 0 && objectUtils.getProperty(serie[0], xAttribute) instanceof Date;
      serie = _.map(serie, function (point) {
        var res = {
          x: isDateAxis ? objectUtils.getProperty(point, xAttribute).getTime() : objectUtils.getProperty(point, xAttribute),
          y: objectUtils.getProperty(point, yAttribute)
        };
        _.each(otherAttributes, function (property, name) {
          res[name] = objectUtils.getProperty(point, property);
        });
        return res;
      });
      return serie;
    },
    filterEmptyValues: function filterEmptyValues(items, xAttribute, yAttribute) {
      items = _.filter(items, function (item) {
        return objectUtils.getProperty(item, xAttribute) != null && objectUtils.getProperty(item, yAttribute) != null;
      });
      return items;
    },
    getDateVisualisationPlotLine: function getDateVisualisationPlotLine(contextService, dateVisualisation) {
      return [{
        color: '#4DC100',
        width: 2,
        value: (dateVisualisation || contextService.getContext().dateVisualisation).getTime(),
        zIndex: 5
      }];
    },
    getDateMarchePlotLine: function getDateMarchePlotLine(contextService) {
      return [{
        color: '#4DC100',
        width: 2,
        value: contextService.getContext().dateVisualisation.getTime(),
        zIndex: 5,
        label: {
          text: 'anticipés'
        }
      }];
    },
    getGraphColors: function getGraphColors() {
      return chartColors;
    },
    /**
     *
     * @param index index of the color in the chartColors array
     * @returns {string}
     */
    getGraphColor: function getGraphColor(index) {
      return chartColors[index % chartColors.length];
    },
    /**
     *
     * @param index index of the color in the chartColors array
     * @param opacity opacity to add (ex: 0.5)
     * @returns {string}
     */
    getGraphColorWithOpacity: function getGraphColorWithOpacity(index, opacity) {
      var color = chartColors[index % chartColors.length];
      if (opacity) {
        var hexToRgb = colorUtils.hexToRgb(color);
        color = "rgb(" + hexToRgb[0] + "," + hexToRgb[1] + "," + hexToRgb[2] + "," + opacity + ")";
      }
      return color;
    },
    darkenColor: function darkenColor(hex, ratio) {
      if (!hex || typeof hex !== 'string') {
        return hex;
      }
      if (hex.indexOf('#') === 0 && hex.length === 7) {
        var r = parseInt(hex.substring(1, 3), 16);
        var g = parseInt(hex.substring(3, 5), 16);
        var b = parseInt(hex.substring(5, 7), 16);
        r = Math.max(0, Math.floor(r * (1 - ratio)));
        g = Math.max(0, Math.floor(g * (1 - ratio)));
        b = Math.max(0, Math.floor(b * (1 - ratio)));
        var toHex = function toHex(val) {
          return ('0' + val.toString(16)).slice(-2);
        };
        return '#' + toHex(r) + toHex(g) + toHex(b);
      }
      return hex;
    },
    getGraphColorsForId: function getGraphColorsForId(id) {
      var color = contrepartieService.getContrepartieColor(id);
      if (color != null) {
        return color;
      }
      /* jshint bitwise:false */
      var hashCode = id.split("").reduce(function (a, b) {
        a = (a << 5) - a + b.charCodeAt(0);
        return a & a;
      }, 0);
      /* jshint bitwise:true */
      var index = Math.abs(hashCode) % chartColors.length;
      return chartColors[index];
    },
    /**
     *
     * @param title
     * @returns la configuration standard des pie charts
     */
    getDefautPieChartsConfig: function getDefautPieChartsConfig(title) {
      return {
        options: {
          chart: {
            type: 'pie',
            height: 250
          },
          tooltip: {
            crosshairs: false,
            pointFormat: '<b>{point.percentage:.1f}%</b>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                connectorWidth: 1,
                distance: 10,
                formatter: function formatter() {
                  return this.point.name + '<br/>' + Math.round(this.percentage) + ' %';
                }
              },
              innerSize: '60%'
            }
          },
          title: {
            text: title
          }
        }
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/chartUtils.js", __webpack_require__(1)))

/***/ }),
/* 2746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("colorUtils", function () {
  var padLeft = function padLeft(str, length) {
    var toPad = length - str.length;
    return new Array(toPad + 1).join("0") + str;
  };
  var limitToBoundaries = function limitToBoundaries(number, min, max) {
    return number < 0 ? min : number > max ? max : number;
  };
  var colorUtils = {
    // Convert a hex color to an RGB array e.g. [r,g,b]
    // Accepts the following formats: FFF, FFFFFF, #FFF, #FFFFFF
    hexToRgb: function hexToRgb(hex) {
      var r, g, b, parts;
      // Remove the hash if given
      hex = hex.replace('#', '');
      // If invalid code given return white
      if (hex.length !== 3 && hex.length !== 6) {
        return [255, 255, 255];
      }
      // Double up charaters if only three suplied
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      // Convert to [r,g,b] array
      r = parseInt(hex.substr(0, 2), 16);
      g = parseInt(hex.substr(2, 2), 16);
      b = parseInt(hex.substr(4, 2), 16);
      return [r, g, b];
    },
    // Converts an RGB color array e.g. [255,255,255] into a hexidecimal color value e.g. 'FFFFFF'
    rgbToHex: function rgbToHex(color, alpha) {
      var r = padLeft(limitToBoundaries(color[0], 0, 255).toString(16), 2);
      var g = padLeft(limitToBoundaries(color[1], 0, 255).toString(16), 2);
      var b = padLeft(limitToBoundaries(color[2], 0, 255).toString(16), 2);
      return "#" + r + g + b;
    },
    // Generates an array of color values in sequence from colors[0] to colors[X] using the specified number of steps
    generateGradient: function generateGradient(colors, nbSteps) {
      var stops = _.map(colors, function (color, i) {
        return {
          color: color,
          stop: parseInt(i * 100 / (colors.length - 1))
        };
      });
      var result = [];
      var getColorBetween = function getColorBetween(color1, color2, ratio) {
        var rgbA = colorUtils.hexToRgb(color1);
        var rgbB = colorUtils.hexToRgb(color2);
        var calcHex = function calcHex(colorA, colorB, ratio) {
          var cPerUnit = (colorB - colorA) / 100;
          return Math.round(cPerUnit * ratio + colorA);
        };
        var rVal = calcHex(rgbA[0], rgbB[0], ratio),
          gVal = calcHex(rgbA[1], rgbB[1], ratio),
          bVal = calcHex(rgbA[2], rgbB[2], ratio);
        return colorUtils.rgbToHex([rVal, gVal, bVal]);
      };
      var getColorAt = function getColorAt(colorPosition) {
        for (var i = 0; i < stops.length - 1; i++) {
          var currentStop = stops[i];
          var nextStop = stops[i + 1];
          if (colorPosition === currentStop.stop) {
            return currentStop.color;
          } else if (colorPosition <= nextStop.stop) {
            var total = nextStop.stop - currentStop.stop;
            var offset = colorPosition - currentStop.stop;
            var ratio = offset / total * 100;
            return getColorBetween(currentStop.color, nextStop.color, ratio);
          }
        }
        return stops[stops.length - 1].color;
      };
      _.times(nbSteps, function (i) {
        var colorPosition = parseInt(i * 100 / (nbSteps - 1));
        result.push(getColorAt(colorPosition));
      });
      return result;
    }
  };
  return colorUtils;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/colorUtils.js", __webpack_require__(1)))

/***/ }),
/* 2747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("dateUtils", function () {
  var dateUtils = {
    isBeginningOfYear: function isBeginningOfYear(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).dayOfYear() === 1;
    },
    isEndOfYear: function isEndOfYear(date) {
      var momentDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date);
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).date() === 31 && momentDate.month() === 11;
    }
  };
  return dateUtils;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/dateUtils.js"))

/***/ }),
/* 2748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.run(["$rootScope", "scopeUtils", "$window", function ($rootScope, scopeUtils, $window) {
  // TODO : inject only if in dev mode ?

  $window.countWatchers = function (scopeOrEl) {
    var scope = scopeOrEl ? angular.isElement(scopeOrEl) ? $(scopeOrEl).scope() : scopeOrEl : $rootScope;
    return scopeUtils.countWatchers(scope);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/debug/injectGlobals.js", __webpack_require__(3), __webpack_require__(4)))

/***/ }),
/* 2749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("deferredUtils", ["$q", "$injector", function ($q, $injector) {
  return {
    resolvePromiseMap: function resolvePromiseMap(resolve) {
      var promises = {};
      _.each(resolve, function (value, key) {
        promises[key] = _.isString(value) ? $injector.get(value) : $injector.invoke(value);
      });
      return $q.all(promises);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/deferredUtils.js", __webpack_require__(1)))

/***/ }),
/* 2750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("diacriticsMap", function () {
  var defaultDiacriticsRemovalap = [{
    'base': 'A',
    'letters': "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
  }, {
    'base': 'AA',
    'letters': "\uA732"
  }, {
    'base': 'AE',
    'letters': "\xC6\u01FC\u01E2"
  }, {
    'base': 'AO',
    'letters': "\uA734"
  }, {
    'base': 'AU',
    'letters': "\uA736"
  }, {
    'base': 'AV',
    'letters': "\uA738\uA73A"
  }, {
    'base': 'AY',
    'letters': "\uA73C"
  }, {
    'base': 'B',
    'letters': "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
  }, {
    'base': 'C',
    'letters': "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
  }, {
    'base': 'D',
    'letters': "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
  }, {
    'base': 'DZ',
    'letters': "\u01F1\u01C4"
  }, {
    'base': 'Dz',
    'letters': "\u01F2\u01C5"
  }, {
    'base': 'E',
    'letters': "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
  }, {
    'base': 'F',
    'letters': "F\u24BB\uFF26\u1E1E\u0191\uA77B"
  }, {
    'base': 'G',
    'letters': "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
  }, {
    'base': 'H',
    'letters': "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
  }, {
    'base': 'I',
    'letters': "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
  }, {
    'base': 'J',
    'letters': "J\u24BF\uFF2A\u0134\u0248"
  }, {
    'base': 'K',
    'letters': "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
  }, {
    'base': 'L',
    'letters': "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
  }, {
    'base': 'LJ',
    'letters': "\u01C7"
  }, {
    'base': 'Lj',
    'letters': "\u01C8"
  }, {
    'base': 'M',
    'letters': "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
  }, {
    'base': 'N',
    'letters': "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
  }, {
    'base': 'NJ',
    'letters': "\u01CA"
  }, {
    'base': 'Nj',
    'letters': "\u01CB"
  }, {
    'base': 'O',
    'letters': "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
  }, {
    'base': 'OI',
    'letters': "\u01A2"
  }, {
    'base': 'OO',
    'letters': "\uA74E"
  }, {
    'base': 'OU',
    'letters': "\u0222"
  }, {
    'base': 'OE',
    'letters': "\x8C\u0152"
  }, {
    'base': 'oe',
    'letters': "\x9C\u0153"
  }, {
    'base': 'P',
    'letters': "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
  }, {
    'base': 'Q',
    'letters': "Q\u24C6\uFF31\uA756\uA758\u024A"
  }, {
    'base': 'R',
    'letters': "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
  }, {
    'base': 'S',
    'letters': "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
  }, {
    'base': 'T',
    'letters': "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
  }, {
    'base': 'TZ',
    'letters': "\uA728"
  }, {
    'base': 'U',
    'letters': "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
  }, {
    'base': 'V',
    'letters': "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
  }, {
    'base': 'VY',
    'letters': "\uA760"
  }, {
    'base': 'W',
    'letters': "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
  }, {
    'base': 'X',
    'letters': "X\u24CD\uFF38\u1E8A\u1E8C"
  }, {
    'base': 'Y',
    'letters': "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
  }, {
    'base': 'Z',
    'letters': "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
  }, {
    'base': 'a',
    'letters': "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
  }, {
    'base': 'aa',
    'letters': "\uA733"
  }, {
    'base': 'ae',
    'letters': "\xE6\u01FD\u01E3"
  }, {
    'base': 'ao',
    'letters': "\uA735"
  }, {
    'base': 'au',
    'letters': "\uA737"
  }, {
    'base': 'av',
    'letters': "\uA739\uA73B"
  }, {
    'base': 'ay',
    'letters': "\uA73D"
  }, {
    'base': 'b',
    'letters': "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
  }, {
    'base': 'c',
    'letters': "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
  }, {
    'base': 'd',
    'letters': "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
  }, {
    'base': 'dz',
    'letters': "\u01F3\u01C6"
  }, {
    'base': 'e',
    'letters': "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
  }, {
    'base': 'f',
    'letters': "f\u24D5\uFF46\u1E1F\u0192\uA77C"
  }, {
    'base': 'g',
    'letters': "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
  }, {
    'base': 'h',
    'letters': "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
  }, {
    'base': 'hv',
    'letters': "\u0195"
  }, {
    'base': 'i',
    'letters': "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
  }, {
    'base': 'j',
    'letters': "j\u24D9\uFF4A\u0135\u01F0\u0249"
  }, {
    'base': 'k',
    'letters': "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
  }, {
    'base': 'l',
    'letters': "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
  }, {
    'base': 'lj',
    'letters': "\u01C9"
  }, {
    'base': 'm',
    'letters': "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
  }, {
    'base': 'n',
    'letters': "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
  }, {
    'base': 'nj',
    'letters': "\u01CC"
  }, {
    'base': 'o',
    'letters': "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
  }, {
    'base': 'oi',
    'letters': "\u01A3"
  }, {
    'base': 'ou',
    'letters': "\u0223"
  }, {
    'base': 'oo',
    'letters': "\uA74F"
  }, {
    'base': 'p',
    'letters': "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
  }, {
    'base': 'q',
    'letters': "q\u24E0\uFF51\u024B\uA757\uA759"
  }, {
    'base': 'r',
    'letters': "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
  }, {
    'base': 's',
    'letters': "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
  }, {
    'base': 't',
    'letters': "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
  }, {
    'base': 'tz',
    'letters': "\uA729"
  }, {
    'base': 'u',
    'letters': "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
  }, {
    'base': 'v',
    'letters': "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
  }, {
    'base': 'vy',
    'letters': "\uA761"
  }, {
    'base': 'w',
    'letters': "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
  }, {
    'base': 'x',
    'letters': "x\u24E7\uFF58\u1E8B\u1E8D"
  }, {
    'base': 'y',
    'letters': "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
  }, {
    'base': 'z',
    'letters': "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
  }];
  var diacriticsMap = {};
  for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
    var letters = defaultDiacriticsRemovalap[i].letters;
    for (var j = 0; j < letters.length; j++) {
      diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
    }
  }
  return diacriticsMap;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/diacriticsMap.js"))

/***/ }),
/* 2751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("directiveUtils", ["$compile", "$animate", function ($compile, $animate) {
  var SNAKE_CASE_REGEXP = /[A-Z]/g;
  var directiveUtils = {
    /**
     * Compiles a directives and returns the link function.
     * This is an alias for 'myDirective' -> $compile($("<my-directive>"))
     *
     * @param directiveName The name of the directive to compile
     * @param [attributes] list of attributes to set on the directive element
     * @returns The link method for given directive.
     */
    compileDirective: function compileDirective(directiveName, attributes) {
      var element = $("<" + directiveUtils.toSnakeCase(directiveName) + ">");
      if (attributes) {
        element.attr(attributes);
      }
      return $compile(element);
    },
    /**
     * Converts a camelCase name to snake case. Useful when trying to compile a directive from it's angular name.
     * Example : "myCustomDirective" -> "my_custom_directive"
     * @param name The name to convert to snake case.
     * @param [separator='-'] will use given separator instead of "-" if provided
     */
    toSnakeCase: function toSnakeCase(name, separator) {
      separator = separator || '-';
      return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
        return (pos ? separator : '') + letter.toLowerCase();
      });
    },
    /**
     * Retrieve given controller on nearest parent.
     * Useful when working with recursive / nested directives or controller
     * ( as require : "^controller" will first lookup on current element )
     *
     * @param $el The element to start search parents for (will NOT search controller on given element)
     * @param controllerName Name of the controller to retrive
     * @returns The parent controller or null if none found
     */
    getParentController: function getParentController($el, controllerName) {
      var current = $el,
        ctrl;
      while ((current = current.parent()).length) {
        /* jshint -W084 */
        if (ctrl = current.controller(controllerName)) {
          return ctrl;
        }
        /* jshint +W084 */
      }
      return null;
    },
    /**
     * Copy controllers from one element to another.
     * Used with multiple transclusion target
     * to copy root element controllers to transclusion targets.
     */
    copyControllers: function copyControllers(fromEl, toEl) {
      var controllersData = {};
      _.each(fromEl.data(), function (value, name) {
        if (/\$.*Controller$/.test(name)) {
          controllersData[name] = value;
        }
      });
      toEl.data(controllersData);
    },
    /**
     * Creates the watch change function for an ngIf like directive
     *
     * @param $element the transcluding directive element.
     * @param $transclude the pre-binded transclude form the directive's link fn.
     */
    createNgIfTranscludeWatchFn: function createNgIfTranscludeWatchFn($element, $transclude) {
      return function () {
        var childScope, element;
        return function (condition) {
          if (condition) {
            if (!childScope) {
              $transclude(function (clone, newScope) {
                childScope = newScope;
                element = clone;
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (element) {
              element.remove();
              element = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
          }
        };
      }();
    }
  };
  return directiveUtils;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/directiveUtils.js", __webpack_require__(4), __webpack_require__(1)))

/***/ }),
/* 2752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("fieldUtils", function () {
  var inputishSelectorList = ["input", "textarea"];
  var inputishSelector = inputishSelectorList.join(", ");
  var selectishSelectorList = [".tl-select-kind-field", ".tl-select", ".tl-checkbox", ".tl-radio-button", "select", "input[type=checkbox]", "input[type=radio]"];
  var selectishSelector = selectishSelectorList.join(", ");
  function buildOnInputKeypressHandler(handler) {
    return function (event) {
      if (event.which === 13) {
        handler(event);
      }
    };
  }
  var PREVIOUS_VALUE_DATA_KEY = "$fieldPreviousValue";
  function buildOnInputFocusHandler() {
    return function (event) {
      var input = $(event.currentTarget);
      input.data(PREVIOUS_VALUE_DATA_KEY, input.val());
    };
  }
  function buildOnInputBlurHandler(handler) {
    var checkValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return function (event) {
      var input = $(event.currentTarget);
      if (checkValue) {
        var currentVal = input.val();
        var previousVal = input.data(PREVIOUS_VALUE_DATA_KEY);
        if (currentVal !== previousVal) {
          handler(event);
        }
      } else {
        handler(event);
      }
    };
  }
  function buildOnSelectChangeHandler(handler) {
    return function (event) {
      _.defer(function () {
        handler(event);
      });
    };
  }
  return {
    /**
     * Bind given handler to trigger on change of any of given container's children.
     *
     * @returns a unregistration function remove all handlers created heres.
     */
    delegateFieldChange: function delegateFieldChange(container, handler) {
      var inputFocusHandler = buildOnInputFocusHandler();
      var inputKeypressHandler = buildOnInputKeypressHandler(handler);
      var inputBlurHandler = buildOnInputBlurHandler(handler);
      var selectChangeHandler = buildOnSelectChangeHandler(handler);
      container.on("focusin", inputishSelector, inputFocusHandler);
      container.on("keypress", inputishSelector, inputKeypressHandler);
      container.on("focusout", inputishSelector, inputBlurHandler);
      container.on("change", selectishSelector, selectChangeHandler);
      return function () {
        container.off("focusin", inputishSelector, inputFocusHandler);
        container.off("keypress", inputishSelector, inputKeypressHandler);
        container.off("focusout", inputishSelector, inputBlurHandler);
        container.off("change", selectishSelector, selectChangeHandler);
      };
    },
    /**
     * Bind given handler to trigger on leave of any of given container's children.
     *
     * @returns a unregistration function remove all handlers created heres.
     */
    delegateFieldBlur: function delegateFieldBlur(container, handler) {
      var inputBlurHandler = buildOnInputBlurHandler(handler, false);
      var selectChangeHandler = buildOnSelectChangeHandler(handler);
      container.on("change", selectishSelector, selectChangeHandler);
      container.on("focusout", inputishSelector, inputBlurHandler);
      return function () {
        container.off("focusout", inputishSelector, inputBlurHandler);
        container.off("change", selectishSelector, selectChangeHandler);
      };
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/fieldUtils.js", __webpack_require__(4), __webpack_require__(1)))

/***/ }),
/* 2753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Utility for drag and drop API
 */
ngModule.factory("fileDropUtils", function () {
  return {
    /**
     * Returns true if array contains any of given items, false otherwise.
     * @param el
     * @param scope
     * @param onEnter
     * @param onLeave
     */
    addFileDragEvents: function addFileDragEvents(el, scope, onEnter, onLeave) {
      var dragging = false;
      var leaving = false;
      var timeout = null;
      var onDragEnter = function onDragEnter() {
        if (onEnter) {
          scope.$apply(function () {
            return onEnter(el);
          });
        }
      };
      var onDragLeave = function onDragLeave() {
        if (onLeave) {
          scope.$apply(function () {
            return onLeave(el);
          });
        }
      };
      el.on('dragenter.filedrop', function () {
        leaving = false;
        if (!dragging) {
          dragging = true;
          onDragEnter();
        }
      });
      el.on('dragover.filedrop', function () {
        leaving = false;
        if (!dragging) {
          dragging = true;
          onDragEnter();
        }
      });
      el.on('dragleave.filedrop', function () {
        leaving = true;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          if (leaving) {
            dragging = false;
            onDragLeave();
          }
        }, 100);
      });
      el.on('drop.filedrop', function () {
        leaving = true;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          if (leaving) {
            dragging = false;
            onDragLeave();
          }
        }, 100);
      });
      return function () {
        el.off('.filedrop');
      };
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/fileDropUtils.js"))

/***/ }),
/* 2754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
var types = {
  "pdf": {
    extensions: ["pdf"],
    icon: "fal fa-file-pdf"
  },
  "image": {
    extensions: ["jpg", "jpeg", "png", "bmp", "svg", "gif"],
    icon: "fal fa-file-image"
  },
  "word": {
    extensions: ["doc", "docx"],
    icon: "fal fa-file-word"
  },
  "excel": {
    extensions: ["xls", "xlsx"],
    icon: "fal fa-file-excel"
  },
  "powerpoint": {
    extensions: ["ppt", "pptx"],
    icon: "fal fa-file-powerpoint"
  },
  "archive": {
    extensions: ["zip", "tar", "tgz", "gz"],
    icon: "fal fa-file-archive"
  },
  "video": {
    extensions: ["divx", "mp4", "mpeg4"],
    icon: "fal fa-file-video"
  },
  "msg": {
    extensions: ["msg", "eml"],
    icon: "fal fa-envelope"
  },
  "unknow": {
    extensions: [],
    icon: "fal fa-file-alt"
  }
};
var buildIconMap = function buildIconMap() {
  var map = [];
  _.each(types, function (type) {
    _.each(type.extensions, function (ext) {
      return map[ext] = type.icon;
    });
  });
  return map;
};
var extensionToIcon = buildIconMap();
ngModule.factory("fileUtils", ["iconUtils", function (iconUtils) {
  return {
    getExtension: function getExtension(filename) {
      var splits = filename.split(".");
      if (splits.length > 1) {
        return splits[splits.length - 1].toLowerCase();
      }
      return filename;
    },
    getPdfExtensions: function getPdfExtensions() {
      return types.pdf.extensions;
    },
    getImagesExtensions: function getImagesExtensions() {
      return types.image.extensions;
    },
    getMsgExtensions: function getMsgExtensions() {
      return types.msg.extensions;
    },
    getExtensionIcon: function getExtensionIcon(extension) {
      return iconUtils.getFullName(extensionToIcon[extension] || types.unknow.icon);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/fileUtils.js", __webpack_require__(1)))

/***/ }),
/* 2755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("iconUtils", function () {
  return {
    /**
     * Try to guess the icon fullname given a short icon.
     * Mostly used because of fontAwesome5, to manage old FA4 namings.
     *
     * Ex:
     * "fab fa-clock" -> "fab fa-clock"
     * "fa-clock" -> "fa fa-clock"
     * "error" -> "tl-ico icon-error"
     */
    getFullName: function getFullName(icon) {
      if (icon == null) {
        return icon;
      }
      var splits = icon.trim().split(" ");
      if (splits.length > 1) {
        return icon;
      }
      if (icon.indexOf("fa-") === 0) {
        return "fa ".concat(icon);
      }
      if (icon.indexOf("icon-") === 0) {
        return "tl-ico ".concat(icon);
      } else {
        return "tl-ico icon-".concat(icon);
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/iconUtils.js"))

/***/ }),
/* 2756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("imageUtils", ["$q", function ($q) {
  return {
    /**
     * Get image dimension for given url.
     * This is achieved by waiting for the image to load and check the width and height attributes.
     * This is a asynchronous method
     *
     * @param imageUrl The url of the image to get dimensions for.
     * @returns {deferred.promise|*} promise resolving with the image dimensions
     */
    getDimensions: function getDimensions(imageUrl) {
      var deferred = $q.defer();
      var img = new Image();
      img.onload = function () {
        deferred.resolve({
          width: img.width,
          height: img.height
        });
      };
      img.onerror = function () {
        deferred.reject();
      };
      img.src = imageUrl;
      return deferred.promise;
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/imageUtils.js"))

/***/ }),
/* 2757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("keyCodes", function () {
  return {
    BACKSPACE: 8,
    COMMA: 188,
    DELETE: 46,
    DOWN: 40,
    END: 35,
    ENTER: 13,
    ESCAPE: 27,
    HOME: 36,
    LEFT: 37,
    NUMPAD_ADD: 107,
    NUMPAD_DECIMAL: 110,
    NUMPAD_DIVIDE: 111,
    NUMPAD_ENTER: 108,
    NUMPAD_MULTIPLY: 106,
    NUMPAD_SUBTRACT: 109,
    PAGE_DOWN: 34,
    PAGE_UP: 33,
    PERIOD: 190,
    RIGHT: 39,
    SPACE: 32,
    TAB: 9,
    UP: 38
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/keyCodes.js"))

/***/ }),
/* 2758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("mktHistoryUtils", ["$translate", function ($translate) {
  return {
    /**
     * Génère un 'id' serializable pour la référence, pour permettre des comparaisons
     * @param reference
     */
    getReferenceId: function getReferenceId(reference) {
      if (reference == null) {
        return null;
      }
      var base = reference.type + "-";
      if (reference.type === "INDEX") {
        base += reference.indexId;
      } else if (reference.type === "CUSTOM_INDEXATION") {
        base += reference.indexationId;
      }
      return base;
    },
    isSameReference: function isSameReference(ref1, ref2) {
      // TODO : use getReferenceId instead
      if (ref1 == null || ref2 == null) {
        return false;
      } else if (ref1.type !== ref2.type) {
        return false;
      } else {
        if (ref1.type === "INDEX") {
          return ref1.indexId === ref2.indexId;
        } else if (ref1.type === "CUSTOM_INDEXATION") {
          return ref1.indexationId === ref2.indexationId;
        }
      }
    },
    /**
     * Vérifie la validité de structure du ValorisableReference donné :
     * Si de type INDEX, alors soit avoir un indexId,
     * Si de type CUSTOM_INDEXATION, alors doit avoir un attribute indexationId
     */
    isReferenceValid: function isReferenceValid(reference) {
      if (reference == null) {
        return false;
      }
      if (reference.type === "INDEX") {
        return reference.indexId != null;
      } else if (reference.type === "CUSTOM_INDEXATION") {
        return reference.indexationId != null;
      } else {
        return false;
      }
    },
    /**
     * Retourne le label à afficher sur l'axe de la courbe en fonction de l'indexType
     * @param indexType Valeur de l'enum IndexType.
     * @return {string} Le libellé à afficher.
     */
    getIndexTypeAxisLabel: function getIndexTypeAxisLabel(indexType) {
      switch (indexType) {
        case "TAUX":
          return $translate('marche.history.axisLabel.Taux');
        case "CHANGE":
          return $translate('marche.history.axisLabel.Cours');
        // yea, taux de change...
        case "INDICIEL":
          return $translate('marche.history.axisLabel.Valeur');
        default:
          return "";
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/mktHistoryUtils.js"))

/***/ }),
/* 2759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);


var numeral = __webpack_require__(749);

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("numberUtils", function () {
  var numberUtils = {
    /**
     * Clean given number string
     */
    cleanNumberString: function cleanNumberString(str) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return str // TODO : use decimalDelimiterKeys & automatize regexps
      .replace(/[.]/g, ",").replace(/[^\d,.-]/g, "");
    },
    parseNumber: function parseNumber(str) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cleaned = numberUtils.cleanNumberString(str, options);
      return numeral().unformat(cleaned);
    }
  };
  return numberUtils;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/numberUtils.js"))

/***/ }),
/* 2760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("objectUtils", function () {
  // TODO : tests
  return {
    /**
     * Remove all entry from given object.
     * This will only remove own properties from the object (testing hasOwnProperty)
     *
     * @param obj The object to remove all entries from.
     */
    clearObject: function clearObject(obj) {
      var keys = _.keys(obj);
      _.each(keys, function (key) {
        delete obj[key];
      });
    },
    /**
     * Returns true if object has at least one not null own property, false otherwise.
     * @param obj The object to check to non-null properties
     * @param {Array<String>=} keys Optional keys subset to use instead of obj.keys()
     */
    containsNotNullProperties: function containsNotNullProperties(obj, keys) {
      var keys = keys || _.keys(obj);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (obj.hasOwnProperty(key) && obj[key] != null) {
          return true;
        }
      }
      return false;
    },
    getProperty: function getProperty(obj, prop) {
      // TODO: replace whole implem with _.get
      var parts = prop.split('.');
      if (parts.length === 1) {
        return obj[prop];
      }
      var last = parts.pop(),
        l = parts.length,
        i = 1,
        current = parts[0];
      while ((obj = obj[current]) && i < l) {
        current = parts[i];
        i++;
      }
      if (obj) {
        return obj[last];
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/objectUtils.js", __webpack_require__(1)))

/***/ }),
/* 2761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
var supportedFormats = [{
  format: 'DD-MM-YYYY',
  regexp: /^[0-9]{2}-[0-9]{2}-[0-9]{4}$/
}, {
  format: 'DD/MM/YYYY',
  regexp: /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/
}, {
  format: 'YYYY-MM-DD',
  regexp: /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/
}, {
  format: 'YYYY/MM/DD',
  regexp: /^[0-9]{4}\/[0-9]{2}\/[0-9]{2}$/
}];
ngModule.factory("pasteUtils", ["$dateFormat", function ($dateFormat) {
  return {
    /**
     * Returns a column from given [rowIdx][colIdx] nested-array table.
     */
    getColumn: function getColumn(table, columnIdx) {
      var column = [];
      _.each(table, function (row, rowIdx) {
        column[rowIdx] = table[rowIdx][columnIdx];
      });
      return column;
    },
    parseExcelDate: function parseExcelDate(cellDate) {
      var format = _.find(supportedFormats, function (format) {
        return format.regexp.test(cellDate);
      });
      if (format == null) {
        return null;
      }
      return moment(cellDate, format.format).toDate();
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/pasteUtils.js", __webpack_require__(1), __webpack_require__(2)))

/***/ }),
/* 2762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("routeUtils", ["$route", function ($route) {
  var routeUtils = {
    /**
     * Interpolate section string ( with param ) with given url to get actual section url.
     *
     * I.E : '/fiche/:id' + '/fiche/my-id/subsection' -> '/fiche/my-id'
     *
     * @param section The section url to interpolate.
     * @param url The url to interpolate from.
     */
    interpolateSection: function interpolateSection(section, url) {
      var replaced = routeUtils.getRouteRegexp(section, false).exec(url);
      return replaced && replaced[0] || null;
    },
    /**
     * Parse given route and convert it to regexp.
     *
     * @param route the route url to convert
     * @param exact if true, will surround route regexp with "^route$"
     */
    getRouteRegexp: function getRouteRegexp(route, exact) {
      var parsed = route.replace(/([().])/g, '\\$1').replace(/(\/)?:(\w+)([\?\*])?/g, function (_, slash, key, option) {
        var optional = option === '?' ? option : null;
        var star = option === '*' ? option : null;
        slash = slash || '';
        return '' + (optional ? '' : slash) + '(?:' + (optional ? slash : '') + (star && '(.+?)' || '([^/]+)') + (optional || '') + ')' + (optional || '');
      }).replace(/([\/$\*])/g, '\\$1');
      if (exact) {
        parsed = "^" + parsed + "$";
      }
      return new RegExp(parsed);
    },
    /**
     * Replace parameter names by parameters value for given route.
     * Parameters not contained in param map will not be replaced.
     *
     * i.e : http://myapp/:param { param : "hello" } -> http://myapp/hello
     */
    replaceParams: function replaceParams(route, params) {
      return route.replace(/(\/)?:(\w+)([\?|\*])?/g, function (capture, slash, key, option, startIdx) {
        return _.has(params, key) ? slash + params[key] : capture;
      });
    },
    /**
     * Force reloading of the current route.
     */
    reloadRoute: function reloadRoute() {
      $route.reload();
    },
    /**
     * Force reloading of the app to the current page.
     */
    reloadApp: function reloadApp() {
      window.location.reload();
    }
  };
  return routeUtils;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/routeUtils.js", __webpack_require__(1)))

/***/ }),
/* 2763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("scopeUtils", ["$parse", function ($parse) {
  var scopeUtils = {
    dataBind: function dataBind(parentScopeName, scopeName, childScope, parentScope) {
      if (parentScope == null) {
        parentScope = childScope.$parent;
      }
      var parentGet = $parse(parentScopeName);
      var compare = parentGet.literal ? angular.equals : function (a, b) {
        return a === b;
      };
      var lastValue;
      var parentSet = parentGet.assign || function () {
        // reset the change, or we will throw this exception on every $digest
        lastValue = childScope[scopeName] = parentGet(parentScope);
        throw "didnt understand this exception";
      };
      lastValue = childScope[scopeName] = parentGet(parentScope);
      return childScope.$watch(function parentValueWatch() {
        var parentValue = parentGet(parentScope);
        if (!compare(parentValue, childScope[scopeName])) {
          // we are out of sync and need to copy
          if (!compare(parentValue, lastValue)) {
            // parent changed and it has precedence
            childScope[scopeName] = parentValue;
          } else {
            // if the parent can be assigned then do so
            parentSet(parentScope, parentValue = childScope[scopeName]);
          }
        }
        return lastValue = parentValue;
      }, null, parentGet.literal);
    },
    /**
     * Creates an accessor method to get or set given property on given scope.
     *
     * @param {Scope} scope : Scope to create accessor for
     * @param {String} propertyName : Name of the property to create accessor of.
     */
    createAccessor: function createAccessor(scope, propertyName) {
      var getter = $parse(propertyName);
      var setter = getter.assign;
      return function (value) {
        if (arguments.length) {
          return setter(scope, value);
        } else {
          return getter(scope);
        }
      };
    },
    /**
     * Count the watchers attached to a scope tree.
     *
     * @param scope The scope to count watchers of.
     * @returns {number} The number of watchers actually attach to given scope and children.
     */
    countWatchers: function countWatchers(scope) {
      var watchers = 0;
      scopeUtils.traverseScopeTree(scope, function (scope) {
        if (scope.$$watchers) {
          watchers += scope.$$watchers.length;
        }
      });
      return watchers;
    },
    /**
     * Apply watchers of given scope even if a digest progress is already in process on another level.
     * This will only do a one-time cycle of watchers, without cascade digest.
     *
     * Please note that this is (almost) a hack, behaviour may be hazardous so please use with caution.
     *
     * @param {Scope} scope : scope to apply watchers from.
     */
    applyWatchers: function applyWatchers(scope) {
      scopeUtils.traverseScopeTree(scope, function (scope) {
        var watchers = scope.$$watchers;
        if (!watchers) {
          return;
        }
        var watcher;
        for (var i = 0; i < watchers.length; i++) {
          watcher = watchers[i];
          var value = watcher.get(scope);
          watcher.fn(value, value, scope);
        }
      });
    },
    traverseScopeTree: function traverseScopeTree(parentScope, traverseFn) {
      var next,
        current = parentScope,
        target = parentScope;
      do {
        traverseFn(current);
        if (!(next = current.$$childHead || current !== target && current.$$nextSibling)) {
          while (current !== target && !(next = current.$$nextSibling)) {
            current = current.$parent;
          }
        }
      } while (current = next);
    }
  };
  return scopeUtils;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/scopeUtils.js", __webpack_require__(3)))

/***/ }),
/* 2764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * a utiliser par exemple : myArray.sort(sortUtils.alphanumCompartorBuilder('label')); Vous pouvez utiliser des propriété composées (x.y.label)
 */
ngModule.factory("sortUtils", ["objectUtils", function (objectUtils) {
  var buildPropertyGetter = function buildPropertyGetter(attr) {
    if (attr.split('.').length === 1) {
      return function (obj) {
        return obj[attr];
      };
    } else {
      return function (obj) {
        return objectUtils.getProperty(obj, attr);
      };
    }
  };
  var sortUtils = {
    stringComparatorBuilder: function stringComparatorBuilder(attr) {
      var getProperty = buildPropertyGetter(attr);
      return function stringComparator(a, b) {
        var attrA = (getProperty(a) || "").toLowerCase();
        var attrB = (getProperty(b) || "").toLowerCase();
        return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
      };
    },
    /**
     * cf. http://web.archive.org/web/20130826203933/http://my.opera.com/GreyWyvern/blog/show.dml/1671288
     */
    alphanumCompartorBuilder: function alphanumCompartorBuilder(attr) {
      var getProperty = buildPropertyGetter(attr);
      return function alphanumComparator(a, b) {
        var attrA = (getProperty(a) || "").toLowerCase();
        var attrB = (getProperty(b) || "").toLowerCase();
        var aa = attrA.split(/(\d+)/);
        var bb = attrB.split(/(\d+)/);
        for (var x = 0; x < Math.max(aa.length, bb.length); x++) {
          if (aa[x] !== bb[x]) {
            var cmp1 = isNaN(parseInt(aa[x], 10)) ? aa[x] : parseInt(aa[x], 10);
            var cmp2 = isNaN(parseInt(bb[x], 10)) ? bb[x] : parseInt(bb[x], 10);
            if (cmp1 === undefined || cmp2 === undefined) {
              return aa.length - bb.length;
            } else {
              return cmp1 < cmp2 ? -1 : 1;
            }
          }
        }
        return 0;
      };
    },
    dateComparatorBuilder: function dateComparatorBuilder(attr) {
      var getProperty = buildPropertyGetter(attr);
      return function dateComparator(a, b) {
        var attrA = getProperty(a);
        var attrB = getProperty(b);
        if (attrA == null && attrB == null) return 0;
        if (attrA == null && attrB != null) return -1;
        if (attrB == null && attrA != null) return 1;
        return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
      };
    },
    montantComparatorBuilder: function montantComparatorBuilder(attr) {
      var getProperty = buildPropertyGetter(attr);
      return function montantComparator(a, b) {
        var attrA = getProperty(a);
        var attrB = getProperty(b);
        if (attrA == null && attrB == null) {
          return 0;
        } else if (attrA == null) {
          return -1;
        } else if (attrB == null) {
          return 1;
        } else {
          return attrA.valeur < attrB.valeur ? -1 : attrA.valeur > attrB.valeur ? 1 : 0;
        }
      };
    },
    booleanComparatorBuilder: function booleanComparatorBuilder(attr) {
      var getProperty = buildPropertyGetter(attr);
      return function booleanComparator(a, b) {
        var attrA = getProperty(a);
        var attrB = getProperty(b);
        return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
      };
    },
    numberComparatorBuilder: function numberComparatorBuilder(attr) {
      var getProperty = buildPropertyGetter(attr);
      return function numberComparator(a, b) {
        var attrA = getProperty(a);
        var attrB = getProperty(b);
        return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
      };
    }
  };
  return sortUtils;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/sortUtils.js"))

/***/ }),
/* 2765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("stringUtils", ["diacriticsMap", function (diacriticsMap) {
  var stringUtils = {
    /**
     * Removes all html tags from given string
     * 
     * @param html
     * @return {string}
     */
    stripHtml: function stripHtml(html) {
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
    /**
     * Escapes special html characters from given string.
     *
     * I.E : "Hello > Dolly" -> "Hello & gt; Dolly"
     */
    escapeHtml: function escapeHtml(str) {
      return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
    },
    /**
     * Capitalizes given string.
     *
     * I.E : - "hello" -> "Hello"
     */
    capitalize: function capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    /**
     * Repeats given `sequence` `count` times
     */
    repeatSequence: function repeatSequence(sequence, count) {
      return new Array(count + 1).join(sequence);
    },
    /**
     * Counts the number of occurrences of given char in given string.
     */
    countCharOccurencies: function countCharOccurencies(string, char) {
      var matches = string.match(new RegExp("[" + char + "]", "gi"));
      return matches && matches.length || 0;
    },
    /**
     * Returns the position of the `x`th occurrence of given `val` in given `string`
     */
    xIndexOf: function xIndexOf(val, string, x) {
      if (x <= string.split(val).length - 1) {
        var ot = string.indexOf(val);
        if (x > 1) {
          for (var i = 1; i < x; i++) {
            ot = string.indexOf(val, ot + 1);
          }
        }
        return ot;
      } else {
        return -1;
      }
    },
    /**
     * Remove all accents from given string, preserving case.
     * Technically, it use a static diacritics map, to mimic the role of a normalizer.
     */
    removeAccents: function removeAccents(str) {
      // see http://stackoverflow.com/questions/990904/javascript-remove-accents-diacritics-in-strings
      return str.replace(/[^\u0000-\u007E]/g, function (a) {
        return diacriticsMap[a] || a;
      });
    },
    /**
     * Check if given containingTerm contains given searchTerm.
     * Test will be case insensitive, and ignore accents.
     *
     * I.E : 'Héllo'  contains 'ELLO'
     */
    containsIgnoringCaseAndAccents: function containsIgnoringCaseAndAccents(containingTerm, searchTerm) {
      if (containingTerm == null || searchTerm == null) {
        return false;
      }
      var st = stringUtils.removeAccents(searchTerm).toLowerCase(),
        ct = stringUtils.removeAccents(containingTerm).toLowerCase();
      return ct.indexOf(st) > -1;
    },
    /**
     * Urlify given string (aka makes it url friendly)
     *
     * I.E : 'Hello dolly' -> 'hello-dolly'
     *       'To/to' -> 'to-to'
     *       'éà' -> 'ea'
     *
     * @param str
     * @returns {string}
     */
    urlify: function urlify(str) {
      return stringUtils.removeAccents(str).replace(/ /g, '-').replace(/:/g, '-').replace(/\\/g, '-').replace(/\//g, '-').replace(/[^a-zA-Z0-9\-]+/g, '').replace(/-{2,}/g, '-').toLowerCase();
    }
  };
  return stringUtils;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/stringUtils.js"))

/***/ }),
/* 2766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("templateUtils", ["$q", "$http", "$templateCache", function ($q, $http, $templateCache) {
  return {
    load: function load(templateUrl) {
      return $http.get(templateUrl, {
        cache: $templateCache
      }).then(function (result) {
        return result.data;
      });
    },
    /**
     * Utility class to load template from given config (like angular for routes config for example)
     * accepting both the "template" or the "templateUrl" option
     *
     * @param {Object} config The config object to extract 'template' or 'templateUrl' from.
     * @return {Promise} Promise resolving with the
     */
    loadTemplate: function loadTemplate(config) {
      return config.template ? $q.when(config.template) : $http.get(config.templateUrl, {
        cache: $templateCache
      }).then(function (result) {
        return result.data;
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/templateUtils.js"))

/***/ }),
/* 2767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Utility class for url & query string forgery.
 */
ngModule.factory("urlUtils", function () {
  return {
    /**
     * Remove the query string from an url.
     *
     * i.e : https://www.taelys.com/mypage?foo=bar -> https://www.taelys.com/mypage
     */
    removeQueryString: function removeQueryString(url) {
      var qsStart = url.indexOf("?");
      return qsStart === -1 ? url : url.slice(0, qsStart);
    },
    /**
     * Retrieve the query string from an url.
     *
     * i.e : http://www.google.fr?foo=bar&q=hello -> foo=bar&q=hello
     */
    getQueryString: function getQueryString(url) {
      if (!_.isString(url)) {
        return "";
      }
      var qsStart = url.indexOf("?");
      if (qsStart !== -1) {
        return url.slice(qsStart + 1);
      } else {
        return "";
      }
    },
    /**
     * Add given parameter map to given url.
     * null or undefined values will be ignored.
     *
     * i.e : http://www.google.com?foo=bar  + { q : "lala" } ->  http://www.google.fr?foo=bar&q=lala
     */
    addParams: function addParams(url, params) {
      var queryString = this.getQueryString(url);
      var paramsObj = this.deparam(queryString);
      var extendedParams = _.extend(paramsObj, _.pickBy(params, function (value, key) {
        return value != null;
      }));
      return this.removeQueryString(url) + "?" + this.param(extendedParams);
    },
    /**
     * Transform given map to query string.
     * null or undefined values will be ignored.
     *
     * i.e : { foo : "bar", q : "lala" }  -> foo=bar&q=lala
     */
    param: function param(object) {
      return $.param(_.pickBy(object, function (value, key) {
        return value != null;
      }), true);
    },
    /**
     * Transform given query string to param map
     *
     * i.e : foo=bar&q=lala -> { foo : "bar", q : "lala" }
     */
    deparam: function deparam(params, coerce) {
      var obj = {},
        coerce_types = {
          'true': !0,
          'false': !1,
          'null': null
        };
      $.each(params.replace(/\+/g, ' ').split('&'), function (j, v) {
        var param = v.split('='),
          key = decodeURIComponent(param[0]),
          val,
          cur = obj,
          i = 0,
          keys = key.split(']['),
          keys_last = keys.length - 1;
        if (/\[/.test(keys[0]) && /\]$/.test(keys[keys_last])) {
          keys[keys_last] = keys[keys_last].replace(/\]$/, '');
          keys = keys.shift().split('[').concat(keys);
          keys_last = keys.length - 1;
        } else {
          keys_last = 0;
        }
        if (param.length === 2) {
          val = decodeURIComponent(param[1]);
          if (coerce) {
            val = val && !isNaN(val) ? +val : val === 'undefined' ? undefined : coerce_types[val] !== undefined ? coerce_types[val] : val;
          }
          if (keys_last) {
            for (; i <= keys_last; i++) {
              key = keys[i] === '' ? cur.length : keys[i];
              cur = cur[key] = i < keys_last ? cur[key] || (keys[i + 1] && isNaN(keys[i + 1]) ? {} : []) : val;
            }
          } else {
            if ($.isArray(obj[key])) {
              obj[key].push(val);
            } else if (obj[key] !== undefined) {
              obj[key] = [obj[key], val];
            } else {
              obj[key] = val;
            }
          }
        } else if (key) {
          obj[key] = coerce ? undefined : '';
        }
      });
      return obj;
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/urlUtils.js", __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 2768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Utility class to manipulate and alter 'Valeur' and 'Montant' types.
 *
 * @see `ValeurHelper.java`
 */
ngModule.factory("valeurUtils", function () {
  var mergeType = function mergeType(typeA, typeB) {
    if (typeA === 'SIMULE' || typeB === 'SIMULE') {
      return 'SIMULE';
    }
    if (typeA === 'ESTIME' || typeB === 'ESTIME') {
      return 'ESTIME';
    }
    if (typeA === 'MANUEL' || typeB === 'MANUEL') {
      return 'MANUEL';
    }
    return 'CONNU';
  };
  return {
    addValeur: function addValeur(a, b) {
      if (a == null) {
        return b;
      }
      if (b == null) {
        return a;
      }
      return {
        valeur: a.valeur + b.valeur,
        type: mergeType(a.type, b.type)
      };
    },
    /**
     * Additionne les montant donnés
     *
     * Retourne la somme, ou `null` si les montants n'ont pas la même devise
     */
    addMontant: function addMontant(a, b) {
      if (a == null) {
        return b;
      }
      if (b == null) {
        return a;
      }
      if (a.devise !== b.devise) {
        return null;
      }
      return {
        devise: a.devise,
        valeur: a.valeur + b.valeur,
        type: mergeType(a.type, b.type)
      };
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/core/utils/valeurUtils.js"))

/***/ }),
/* 2769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("CoucheAdditionnelleCreationPopinController", ["$scope", "$q", "$http", "$translate", "lovService", "$notifications", "coucheAdditionnelleService", function ($scope, $q, $http, $translate, lovService, $notifications, coucheAdditionnelleService) {
  var isEdit = $scope.edit;
  var originalCoucheAdditionnelle = isEdit || $scope.coucheAdditionnelle != null ? $scope.coucheAdditionnelle : {
    nom: null
  };
  var coucheAdditionnelle = $scope.coucheAdditionnelle = angular.copy(originalCoucheAdditionnelle);
  $scope.originalClassification = angular.copy(originalCoucheAdditionnelle);
  $scope.coucheAdditionnelleFormConfig = {
    url: function url() {
      return '/rest/saisie/couche-additionnelle';
    },
    data: function data() {
      return coucheAdditionnelle;
    },
    fieldPrefix: "coucheAdditionnelle.",
    customValidation: function customValidation() {
      var errors = [];
      if ($scope.coucheAdditionnelle.nom == null || $scope.coucheAdditionnelle.nom.trim().length === 0) {
        errors.push({
          fieldName: 'nom',
          message: 'Le nom est obligatoire.'
        });
      }
      return errors;
    },
    onSuccess: function onSuccess(savedClassification) {
      _.extend(coucheAdditionnelle, savedClassification);
      coucheAdditionnelleService.$reload();
      $notifications.info("Couche additionnelle enregistrée");
      $scope.$close(coucheAdditionnelle);
    },
    onError: function onError(errors) {}
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/coucheAdditionnelle/coucheAdditionnelleCreationPopin.js", __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("coucheAdditionnelleService", ["$modal", "$http", "$dialogBox", "$q", "contextService", function ($modal, $http, $dialogBox, $q, contextService) {
  var createPopinOptions = {
    controller: "CoucheAdditionnelleCreationPopinController",
    template: __webpack_require__(3666)
  };
  var coucheAdditionnelles = null;
  var loadIfRequired = function loadIfRequired() {
    if (coucheAdditionnelles == null) {
      return doServerSync();
    } else {
      return coucheAdditionnelles;
    }
  };
  var doServerSync = function doServerSync() {
    var deferred = $q.defer();
    $http.get("/rest/saisie/couche-additionnelle/list").then(function (response) {
      coucheAdditionnelles = response.data;
      deferred.resolve(coucheAdditionnelles);
    });
    return deferred.promise;
  };
  return {
    $reload: function $reload() {
      return doServerSync();
    },
    findAll: function findAll() {
      return $q.when(loadIfRequired()).then(function () {
        return coucheAdditionnelles;
      });
    },
    openCreationPopin: function openCreationPopin() {
      return $modal.open(_.extend(createPopinOptions, {
        vars: {
          edit: false
        }
      }));
    },
    openEditionPopin: function openEditionPopin(coucheAdditionnelle) {
      return $modal.open(_.extend(createPopinOptions, {
        vars: {
          coucheAdditionnelle: coucheAdditionnelle,
          edit: true
        }
      }));
    },
    /**
     * Suppression de la classification. Si echec, affiche un message d'erreur
     * @param coucheAdditionnelleId
     * @returns {*}
     */
    delete: function _delete(coucheAdditionnelleId) {
      return $http.delete("/rest/saisie/couche-additionnelle/delete/" + coucheAdditionnelleId).then(function (response) {
        var result = response.data;
        if (!result.valid) {
          $dialogBox.alert({
            title: "Impossible de supprimer la couche additionnelle",
            text: result.message
          });
        } else {
          // invalidations si nécessaire
        }
        return result;
      });
    },
    /**
     *
     * @return normalement une valeur directement (et non une promesse)
     */
    findById: function findById(coucheAdditionnelleId) {
      return $q.when(loadIfRequired()).then(function () {
        for (var i = 0; i < coucheAdditionnelles.length; i++) {
          if (coucheAdditionnelles[i].id === coucheAdditionnelleId) {
            return coucheAdditionnelles[i];
          }
        }
        return null;
      });
    },
    /**
     *
     * @param appId optionnel, ne retourne que ceux associés à l'application
     * @return {*} retourne la promise
     */
    findAllByAppId: function findAllByAppId(appId) {
      return $http.get("/rest/saisie/couche-additionnelle/list", {
        params: {
          appId: appId
        }
      }).then(function (result) {
        return result.data;
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/coucheAdditionnelle/coucheAdditionnelleService.js", __webpack_require__(1)))

/***/ }),
/* 2771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("saisieCoucheAdditionnelle", function () {
  return {
    restrict: "E",
    replace: true,
    template: __webpack_require__(3667),
    link: function link($scope, $el, $attrs) {},
    controller: ["$scope", "$q", "$http", "$modal", "$compile", "$session", "budgetService", "contextService", "$dialogBox", "coucheAdditionnelleService", "tlTableUtils", "$notifications", function controller($scope, $q, $http, $modal, $compile, $session, budgetService, contextService, $dialogBox, coucheAdditionnelleService, tlTableUtils, $notifications) {
      var urlRoot = '/rest/saisie/couche-additionnelle';
      var load = function load() {
        $http.get(urlRoot + "/list").then(function (response) {
          $scope.coucheAdditionnelles = response.data;
          $scope.selectedCoucheAdditionnelle = tlTableUtils.getNewTableSelection($scope.selectedCoucheAdditionnelle, $scope.coucheAdditionnelles);
          if ($scope.selectedCoucheAdditionnelle == null && $scope.coucheAdditionnelles.length > 0) {
            // idealement ce serait plutôt la première ligne du tableau (peu importe les tris) qu'on voudrait voir sélectionnée
            $scope.selectedCoucheAdditionnelle = $scope.coucheAdditionnelles[0];
          }
        });
      };
      tlTableUtils.fixResize($scope, 'coucheAdditionnelles');
      tlTableUtils.fixResize($scope, 'selectedCoucheAdditionnelle');
      $scope.coucheAdditionnellesTableConfig = {
        source: "coucheAdditionnelles",
        selectionScope: $scope,
        allowSelection: true,
        selectionAttribute: "selectedCoucheAdditionnelle",
        initialSort: ["nom", "asc"],
        columns: [{
          title: "Nom",
          attribute: 'nom',
          template: '{{model.nom}}' + '<i ng-if="model.editable==false" class="fa fa-chevron-circle-up blue ml-m" ' + 'tl-tooltip="Cette couche additionnelle est définie sur le compte \'{{model.compteNomClient}}\' et ne peut être modifiée que sur ce compte."></i>',
          sortable: true,
          sortType: 'alphanum'
        }, {
          template: '<tl-icon-button ng-if="model.editable" authz-if-role="SAISIE" icon="edit" tl-tooltip="Editer" ng-click="editCoucheAdditionnelle(model)"></tl-icon-button>' + '<tl-icon-button ng-if="model.editable" authz-if-role="SAISIE" icon="delete" tl-tooltip="Supprimer" ng-click="deleteCoucheAdditionnelle(model)"></tl-icon-button>',
          width: '100px',
          cellClass: 'align-c'
        }]
      };
      $scope.addCoucheAdditionnelle = function () {
        coucheAdditionnelleService.openCreationPopin().then(function (response) {
          // pour permettre de sélectionner la coucheAdditionnelle créée
          $scope.selectedCoucheAdditionnelle = {
            id: response.id
          };
          load();
        });
      };
      $scope.editCoucheAdditionnelle = function (coucheAdditionnelle) {
        coucheAdditionnelleService.openEditionPopin(coucheAdditionnelle).then(function (response) {
          load();
        });
      };
      $scope.deleteCoucheAdditionnelle = function (coucheAdditionnelle) {
        $dialogBox.confirm({
          title: "Suppression d'une couche additionnelle",
          text: "Êtes-vous sûr de vouloir supprimer la couche additionnelle '" + coucheAdditionnelle.nom + "' ?"
        }).then(function () {
          coucheAdditionnelleService.delete(coucheAdditionnelle.id).then(function (response) {
            if (response.valid) {
              $notifications.info("Couche additionnelle " + coucheAdditionnelle.nom + " supprimée.");
              load();
            }
          });
        });
      };
      load();
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/coucheAdditionnelle/saisieCoucheAdditionnelle.js"))

/***/ }),
/* 2772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("DocumentEcheanceEditionPopinController", ["$scope", "$dateFormat", function ($scope, $dateFormat) {
  var originalDocument = $scope.document;
  $scope.document = angular.copy(originalDocument);
  $scope.document.type = 'AVIS_ECHEANCE'; // par défaut
  if (!$scope.document.tags) {
    $scope.document.tags = {};
  }
  $scope.document.tags.DATE_ECHEANCE = $dateFormat.serverShort($scope.dateEcheance);
  $scope.errors = {};
  $scope.saveAndClose = function () {
    $scope.errors.label = $scope.document.label ? undefined : {
      message: "Champ obligatoire"
    };
    $scope.errors.type = $scope.document.type ? undefined : {
      message: "Champ obligatoire"
    };
    $scope.errors.url = !$scope.document.externe || $scope.document.url ? undefined : {
      message: "Champ obligatoire"
    };
    if (!$scope.errors.label && !$scope.errors.type && !$scope.errors.url) {
      _.extend(originalDocument, $scope.document);
      $scope.$close(originalDocument);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/documents/documentEcheanceEditionPopin.js", __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("documentEcheanceService", ["$modal", "$http", "$dialogBox", "$q", function ($modal, $http, $dialogBox, $q) {
  var createPopinOptions = {
    controller: "DocumentsEcheanceEditionController",
    template: __webpack_require__(3670)
  };
  return {
    openPopin: function openPopin(produitId, echeance) {
      return $modal.open(_.extend(createPopinOptions, {
        vars: {
          echeance: echeance,
          produitId: produitId
        },
        options: {
          width: 1200
        }
      }));
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/documents/documentEcheanceService.js", __webpack_require__(1)))

/***/ }),
/* 2774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_getNgModule__ = __webpack_require__(0);




function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_getNgModule__["a" /* default */])(__filename);
var documentPreviewPopin = {
  template: __webpack_require__(3669),
  controller: "DocumentPreviewCtrl",
  options: {
    width: 1000
  }
};
ngModule.controller("DocumentPreviewCtrl", ["$scope", "$element", function ($scope, $element) {
  $scope.maximizeWindow = function () {
    var dialogEl = $element.find(".tl-modal-content");
    if (dialogEl == null) {
      return;
    }
    dialogEl.addClass("full-size");
    $scope.initialWidth = dialogEl.css("width");
    dialogEl.css("width", "");
    $scope.maximized = true;
  };
  $scope.restoreWindow = function () {
    var dialogEl = $element.find(".tl-modal-content");
    if (dialogEl == null) {
      return;
    }
    dialogEl.removeClass("full-size");
    dialogEl.css("width", $scope.initialWidth);
    $scope.maximized = false;
  };
}]);
ngModule.factory("documentPreview", ["$modal", "fileUtils", function ($modal, fileUtils) {
  var supportedExtensions = [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(fileUtils.getImagesExtensions()), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(fileUtils.getPdfExtensions()), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(fileUtils.getMsgExtensions()));
  return {
    canPreview: function canPreview(document) {
      var extension = fileUtils.getExtension(document.fileId ? document.fileId : document.url);
      //console.log('extension', extension);
      return _.includes(supportedExtensions, extension);
    },
    /**
     *
     * @param document
     * @param documentViewUrl optionnel, permet de préciser quelle url renvoie le document (/${document.id} sera ajouté automatiquement si l'documentViewUrl ne contient pas de ?), par defaut c'est /rest/documents/view/${document.id}
     * @returns {*}
     */
    openPopin: function openPopin(document, documentViewUrl) {
      return $modal.open(_objectSpread({}, documentPreviewPopin, {
        vars: {
          document: document,
          documentViewUrl: documentViewUrl
        }
      }));
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/documents/documentPreview.js", __webpack_require__(1)))

/***/ }),
/* 2775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
ngModule.controller('DocumentsEcheanceEditionController', ["$scope", "$translate", "$q", "$http", "UUID", "$modal", "$notifications", "arrayUtils", "$dialogBox", "tlTableUtils", "lovService", function ($scope, $translate, $q, $http, UUID, $modal, $notifications, arrayUtils, $dialogBox, tlTableUtils, lovService) {
  $q.when(lovService.getTypesDocuments()).then(function (typesDocument) {
    $scope.typesDocument = typesDocument;
  });
  var documentType = function documentType(doc) {
    if (doc.type === 'CONTRAT_INITIAL') {
      return 1;
    }
    if (doc.type === 'AVENANT') {
      return 2;
    }
    if (doc.type === 'ECHEANCIER') {
      return 3;
    }
    if (doc.type === 'AUTRE_DOCUMENT') {
      return 4;
    }
    if (doc.type === 'AVIS_ECHEANCE') {
      return 5;
    }
    return 9;
  };
  var sortDocuments = function sortDocuments(documents) {
    documents.sort(function (doc1, doc2) {
      var byType = documentType(doc1) - documentType(doc2);
      if (byType === 0) {
        return doc2.dateAjout - doc1.dateAjout; // Date plus récente first
      }
      return byType;
    });
  };
  var updateNbDocsEcheance = function updateNbDocsEcheance() {
    $scope.echeance.nbDocsEcheance = $scope.echeanceDocuments.length;
  };
  $scope.produitDocuments;
  $scope.echeanceDocuments;
  var rebuildTablesDocuments = function rebuildTablesDocuments() {
    if ($scope.allDocuments) {
      $scope.produitDocuments = _.filter($scope.allDocuments.documents, function (d) {
        return d.dateEcheance === null;
      });
      $scope.echeanceDocuments = _.filter($scope.allDocuments.documents, function (d) {
        return d.dateEcheance != null;
      });
    }
  };
  $scope.deleteDocument = function (model) {
    $dialogBox.confirm({
      title: "Supprimer le document '" + model.nom + "'",
      text: "Etes-vous sûr de vouloir supprimer ce document ?"
    }).then(function () {
      $http.post('/rest/documents/delete/', model.id).then(function () {
        $notifications.info("Suppression effectuée.");
        var index = _.findIndex($scope.allDocuments.documents, function (ligne) {
          return ligne.id === model.id;
        });
        arrayUtils.deleteElement($scope.allDocuments.documents, index);
        if ($scope.selectedDocument && $scope.selectedDocument.id === model.id) {
          $scope.selectedDocument = null;
        }
        rebuildTablesDocuments();
        updateNbDocsEcheance();
        updateTables();
      });
    });
  };
  $scope.toggleJustificatifTresorerie = function (model) {
    $http.post('/rest/produitDocuments/tagTresorerie/', {
      documentId: model.id,
      justificatifTresorerie: model.justificatifTresorerie
    }).then(function () {
      $notifications.info("Mise à jour enregistrée.");
    });
  };
  $scope.allDocuments;
  var updateAllDocuments = function updateAllDocuments() {
    var data = {
      produitId: $scope.produitId,
      dateEcheance: $scope.echeance.dateFin
    };
    $http.post('/rest/produitDocuments', data).then(function (response) {
      $scope.allDocuments = response.data;
      sortDocuments($scope.allDocuments.documents);
      rebuildTablesDocuments();
      updateNbDocsEcheance();
      if ($scope.echeanceDocuments && $scope.echeanceDocuments.length > 0) {
        $scope.selectedDocument = $scope.echeanceDocuments[0];
      }
    });
  };
  updateAllDocuments();
  $scope.uploadOptions = {
    url: '/rest/documents/upload',
    dropZone: '.se-details-echeances',
    formData: {
      parentNodeId: $scope.produitId
    }
  };
  var editionPopinOptions = {
    controller: "DocumentEcheanceEditionPopinController",
    template: __webpack_require__(3668),
    options: {
      width: 600
    }
  };
  var openEditionPopin = function openEditionPopin(document, initial, allowedContent) {
    return $modal.open(_.extend(editionPopinOptions, {
      scope: $scope,
      vars: {
        document: document,
        initial: initial,
        allowedTypes: _.filter($scope.typesDocument, function (e) {
          return _.includes(allowedContent, e.id);
        }),
        dateEcheance: $scope.echeance.dateFin
      }
    }));
  };
  $scope.beforeDocumentUpload = function (uploadOptions, addedFile) {
    var document = {
      label: addedFile.name || $translate('documents.NouveauDocument'),
      tags: {
        JUSTIFICATIF_TRESORERIE: true
      }
    };
    return openEditionPopin(document, true, $scope.allDocuments.allowedDocsTypes).then(function (documentInfos) {
      return _objectSpread({}, uploadOptions.formData, {}, documentInfos, {}, documentInfos.tags);
    });
  };
  $scope.onDocumentUpload = function (result) {
    var document = {
      id: result.documentId,
      fileId: result.fileId,
      nom: result.fileName,
      type: result.type,
      dateAjout: __WEBPACK_IMPORTED_MODULE_2_moment___default()(),
      justificatifTresorerie: result.tags['JUSTIFICATIF_TRESORERIE'],
      dateEcheance: result.tags['DATE_ECHEANCE']
    };
    $scope.allDocuments.documents.push(document);
    sortDocuments($scope.allDocuments.documents);
    rebuildTablesDocuments();
    updateNbDocsEcheance();
    $scope.selectedDocument = _.find($scope.echeanceDocuments, function (e) {
      return function () {
        return e.id === document.id;
      };
    });
    updateTables();
  };
  $scope.createDocumentExterne = function () {
    var document = {
      id: UUID(),
      label: "",
      url: "",
      nbDocs: 1,
      nbDocsRec: 1,
      nbReps: 0,
      nbRepsRec: 0,
      size: 0,
      sizeRec: 0,
      externe: true,
      tags: {
        JUSTIFICATIF_TRESORERIE: true
      },
      dateAjout: __WEBPACK_IMPORTED_MODULE_2_moment___default()()
    };
    openEditionPopin(document, true, $scope.allDocuments.allowedDocsTypes).then(function () {
      $http.post('/rest/documents/add', document, {
        params: {
          parentNodeId: $scope.produitId
        }
      }).then(function () {
        document.justificatifTresorerie = document.tags && document.tags['JUSTIFICATIF_TRESORERIE'];
        document.dateEcheance = document.tags && document.tags['DATE_ECHEANCE'];
        document.nom = document.label;
        $scope.allDocuments.documents.push(document);
        sortDocuments($scope.allDocuments.documents);
        rebuildTablesDocuments();
        updateNbDocsEcheance();
        $scope.selectedDocument = _.find($scope.echeanceDocuments, function (e) {
          return function () {
            return e.id === document.id;
          };
        });
        updateTables();
      });
    });
  };
  var echeanceDocumentsTableColumns = [{
    title: 'Nom',
    attribute: 'nom',
    template: '{{model.nom | ellipsis:50}}'
  }, {
    title: 'Type',
    attribute: 'type',
    width: "230px",
    template: "<span>{{'lov.typesDocuments.'+model.type | translate}}</span>"
  }, {
    title: 'Date d\'ajout',
    attribute: 'dateAjout',
    width: "85px",
    template: '<span tl-tooltip="{{model.dateAjout | dateLong}}">{{model.dateAjout | dateShort}}</span>'
  }, {
    title: 'Justificatif trésorerie',
    attribute: 'justificatifTresorerie',
    width: "95px",
    cellClass: 'align-c',
    template: '' + '<i authz-if-role="!SAISIE" class="fa fa-check fa-2x green" ng-show="model.justificatifTresorerie"></i>' + '<i authz-if-role="!SAISIE" class="fa fa-times fa-2x grey" ng-show="!model.justificatifTresorerie"></i>' + '<label authz-if-role="SAISIE" class="toggle-btn">\n' + '  <tl-checkbox ng-click="toggleJustificatifTresorerie(model)" ng-model="model.justificatifTresorerie"></tl-checkbox>\n' + '</label>\n'
  }, {
    title: "",
    width: "95px",
    cellClass: 'align-c',
    template: '<tl-icon-button authz-if-role="SAISIE" class="" icon="delete" title="Supprimer le document" ng-click="deleteDocument(model); $event.stopPropagation();"></tl-icon-button>'
  }];
  $scope.echeanceDocumentsTable;
  var updateTables = function updateTables() {
    $scope.echeanceDocumentsTable = {
      source: "echeanceDocuments",
      id: "echeanceDocumentsTable",
      height: '500',
      allowSelection: true,
      selectionAttribute: "selectedDocument",
      selectionScope: $scope,
      columns: echeanceDocumentsTableColumns
    };
  };
  updateTables();
  tlTableUtils.fixResize($scope, 'echeanceDocuments');
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/documents/documentsEcheanceEdition.js", __webpack_require__(1)))

/***/ }),
/* 2776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlDirectoryBox", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      directory: "<"
    },
    transclude: true,
    template: __webpack_require__(3671),
    controller: ["$scope", "$translate", function controller($scope, $translate) {
      var ctrl = this;
      $scope.renduNbDocs = function (directory) {
        if (directory.nbDocsRec === 0) {
          return $translate("documents.Aucun");
        } else if (directory.nbDocsRec === 1) {
          return "1 " + $translate("documents.document");
        } else {
          return directory.nbDocsRec + " " + $translate("documents.documents");
        }
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/documents/tlDirectoryBox.js"))

/***/ }),
/* 2777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlDocumentBox", ["fileUtils", function (fileUtils) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      document: "<"
    },
    transclude: true,
    template: __webpack_require__(3672),
    controllerAs: "$ctrl",
    controller: ["$scope", "$translate", "$filter", function controller($scope, $translate, $filter) {
      var ctrl = this;
      $scope.renderType = function (document) {
        if (document.tags && document.tags.DATE_ECHEANCE) {
          return $translate("lov.typesDocuments." + document.type) + " " + $translate("lov.typesDocuments.DU", {
            'date': $filter("dateShort")(document.tags.DATE_ECHEANCE)
          });
        }
        return $translate("lov.typesDocuments." + document.type);
      };
      ctrl.getIcon = function () {
        var ext = fileUtils.getExtension($scope.document.url ? $scope.document.url : $scope.document.fileId);
        return fileUtils.getExtensionIcon(ext);
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/documents/tlDocumentBox.js"))

/***/ }),
/* 2778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlDocumentPreview", ["security", "urlUtils", "documentPreview", "fileUtils", "$http", function (security, urlUtils, documentPreview, fileUtils, $http) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      document: "<",
      height: "@",
      documentViewUrl: "@",
      page: "<",
      /* highlightText ne fonctionne pas avec le lecteur pdf emabarqué */
      highlightText: "<"
    },
    template: __webpack_require__(3673),
    link: function link($scope, $el, $attrs, $ctrl) {
      $scope.getFileIcon = function (filename) {
        if (!filename) return fileUtils.getExtensionIcon("");
        return fileUtils.getExtensionIcon(fileUtils.getExtension(filename));
      };
      $scope.downloadAttachment = function (attachment) {
        if (!attachment || !attachment.contentBase64) {
          return;
        }
        var byteCharacters = atob(attachment.contentBase64);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], {
          type: attachment.mimeType || 'application/octet-stream'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = attachment.filename || 'attachment';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      };
      var loadEmailDocument = function loadEmailDocument(documentId, extension) {
        $scope.loadingMsg = true;
        $scope.msgError = null;
        $scope.msgData = null;
        var endpoint = extension && extension.toLowerCase() === 'eml' ? 'eml-view' : 'msg-view';
        $http.get('/rest/documents/' + endpoint + '/' + encodeURIComponent(documentId)).then(function (response) {
          $scope.msgData = response.data;
          $scope.loadingMsg = false;
        }).catch(function (error) {
          $scope.loadingMsg = false;
          $scope.msgError = "Impossible de charger le contenu de l'email.";
        });
      };
      $scope.$watch("document", function (document) {
        if (!document) {
          return;
        }
        var documentId = document.id;
        if (!documentId) {
          documentId = document.fileId;
        }
        if ($scope.documentViewUrl) {
          var url = $scope.documentViewUrl;
          // rajout le documentId uniquement si il n'y a pas deja des query params
          if (url.indexOf('?') === -1) {
            url += "/".concat(documentId);
          }
          $scope.documentUrl = urlUtils.addParams(url, security.getTokens());
        } else {
          $scope.documentUrl = document.fileId ? urlUtils.addParams("/rest/documents/view/".concat(document.id), security.getTokens()) : document.url;
        }
        $scope.canPreview = documentPreview.canPreview(document);
        if ($scope.canPreview) {
          var extension = fileUtils.getExtension(document.fileId ? document.fileId : document.url);
          if (_.includes(fileUtils.getPdfExtensions(), extension)) {
            $scope.documentType = "pdf";
          } else if (_.includes(fileUtils.getImagesExtensions(), extension)) {
            $scope.documentType = "image";
          } else if (_.includes(fileUtils.getMsgExtensions(), extension) || extension && extension.toLowerCase() === 'eml') {
            $scope.documentType = "msg";
            loadEmailDocument(documentId, extension);
          } else {
            $scope.documentType = null;
            $scope.canPreview = false;
          }
        }
      });
      $scope.$watch("page", function (newPage) {
        if (newPage) {
          $scope.currentPage = newPage;
        }
      });
      $scope.$watch("highlightText", function (newText) {
        $scope.currentHighlightText = newText;
      });
      if (_.isNumber(parseInt($scope.height))) {
        _.defer(function () {
          $ctrl.setHeight(parseInt($scope.height));
        });
      }
    },
    controller: ["$scope", function controller($scope) {
      var ctrl = this;
      $scope.currentPage = 1;
      $scope.currentHighlightText = null;
      ctrl.setHeight = function (height) {
        $scope.componentHeight = height;
        $scope.$apply(); // PGA: we seems to be out of a digest loop, so forcing...
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/documents/tlDocumentPreview.js", __webpack_require__(1)))

/***/ }),
/* 2779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlModelesDocuments", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      directory: "<"
    },
    transclude: true,
    template: __webpack_require__(3674),
    controller: ["$scope", "$http", function controller($scope, $http) {
      var ctrl = this;
      $scope.loading = true;
      $http.get('/rest/modeles-documents/list').then(function (response) {
        $scope.documents = response.data;
      }).finally(function () {
        $scope.loading = false;
      });
      $scope.documentsTableConfig = {
        source: "documents",
        columns: [{
          title: 'Document',
          attribute: "description",
          template: '<div>{{model.description}}</div>',
          sortable: true
        }, {
          attribute: "id",
          cellClass: "align-c",
          width: "100px",
          template: '<file-download-link url="/rest/modeles-documents/download?modeleDocumentId={{model.id}}" tl-tooltip="Télécharger">' + '                <i class="icon fa fa-download"></i>' + '      </file-download-link>'
        }]
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/documents/tlModelesDocuments.js"))

/***/ }),
/* 2780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("CompteEditionPopinController", ["$scope", "$http", "$q", "currencyService", "lovService", "$authz", "stringUtils", function ($scope, $http, $q, currencyService, lovService, $authz, stringUtils) {
  var isEdit = $scope.edit;
  $scope.admin = $authz.hasRole("IT_ADMINISTRATION");
  $scope.experimentateur = $authz.hasRole("EXPERIMENTATEUR");
  $scope.clientSelectConfig = {
    idAttribute: "id",
    options: "clients",
    optionTemplate: '' + '<div class="report-template-option">' + '   <span class="label">{{option.codePostal}} - {{option.nom}}</span>' + '</div>',
    matcher: function matcher(text, option) {
      // TODO : test the method
      return stringUtils.containsIgnoringCaseAndAccents(option.nom, text) || stringUtils.containsIgnoringCaseAndAccents(option.codePostal, text);
    }
  };
  $scope.compteParentSelectConfig = {
    idAttribute: "id",
    // inutile car is sur la directive coté html
    //options : "comptes",
    optionTemplate: '' + '<div class="report-template-option">' + '   <span class="label">{{option.nomInterne}}</span>' + '</div>',
    matcher: function matcher(text, option) {
      return stringUtils.containsIgnoringCaseAndAccents(option.nomInterne, text);
    }
  };
  console.log("CompteEditionPopinController scopz", $scope);
  $scope.uploadIconOptions = {
    url: '/rest/intra/comptes/uploadIcon'
  };
  $scope.removeCompteParent = function () {
    $scope.compte.compteParentId = null;
    $scope.compte.compteParentNomInterne = null;
    $scope.compte.CompteParent = null;
  };
  if ($scope.compteId) {
    $http.get("/rest/intra/comptes/get/" + $scope.compteId).then(function (response) {
      $scope.compte = response.data;
    });
  } else {
    $scope.compte = {
      'devise': 'EUR',
      locale: 'fr',
      pays: 'FRA'
    }; // PGA : need to fetch defaults maybe ?

    if ($scope.compteParentId != null) {
      $scope.compte.compteParentNomInterne = $scope.compteParentNomInterne;
      $scope.compte.compteParentId = $scope.compteParentId;

      // champs dispo sur intra.comptes.dto.CompteDTO (listing des comtpes)
      $scope.compte.clientId = $scope.compteParent.clientId;
      $scope.compte.affectation = $scope.compteParent.affectation;
      $scope.compte.consultantId = $scope.compteParent.consultantId;
      $scope.compte.consultant2Id = $scope.compteParent.consultant2Id;
    }
  }
  $scope.$watch("compte.datasId", function () {
    if ($scope.compte && $scope.compte.datasId != null) {
      $http.get("/rest/data/" + $scope.compte.datasId).then(function (response) {
        $scope.nomData = response.data.label;
      });
    } else {
      $scope.nomData = null;
    }
  });
  $q.when(lovService.getPays()).then(function (lov) {
    $scope.pays = lov;
  });
  $http.get("/rest/intra/comptes/all").then(function (response) {
    $scope.comptes = response.data;
  });
  $http.get("/rest/crmClient/clients").then(function (response) {
    $scope.clients = response.data;
  });

  // var originalCompteCommune = isEdit ? $scope.compte : {};
  // $scope.compte = angular.copy(originalCompteCommune);

  //// lovs -> cleanup.
  $scope.currencies = currencyService.getAll();
  $q.when(lovService.getTypesCompte()).then(function (lov) {
    $scope.typesCompte = lov;
  });
  $q.when(lovService.getLocales()).then(function (lov) {
    $scope.locales = lov;
  });
  $q.when(lovService.getAffectations()).then(function (lov) {
    $scope.affectations = lov;
  });
  $q.when(lovService.getApplicationsClients()).then(function (lov) {
    $scope.applicationsClients = lov;
  });
  $http.get('/rest/intra/utilisateurs/consultants').then(function (response) {
    $scope.consultants = _.sortBy(response.data, function (consultant) {
      return consultant.label;
    });
  });
  ////

  $scope.$watch('compte', function (newValue) {
    if (newValue != null && newValue.datasId == null) {
      if (newValue.nomDonneeAssociee == null || newValue.nomDonneeAssociee.length === 0) {
        if (newValue.nomClient != null && newValue.nomClient.length > 1 && newValue.zone != null && newValue.zone.length > 1) {
          var url = '/rest/data/compteCommune'; // TODO : rename
          if (newValue.typeCompte === 'EPCI' || newValue.typeCompte === 'METROPOLE_ET_COLLECTIVITE_TERRITORIALE') {
            url = '/rest/data/compteEPCI';
          }
          if (newValue.typeCompte === 'DEPARTEMENT') {
            url = '/rest/data/compteDepartement';
          }
          if (newValue.typeCompte === 'SDIS') {
            url = '/rest/data/compteSdis';
          }
          $http.get(url, {
            params: {
              nom: newValue.nomClient,
              zone: newValue.zone
            }
          }).then(function (response) {
            if (newValue.typeCompte === 'DEPARTEMENT') {
              $scope.datas = [];
              $scope.datas.push(response.data);
            } else {
              $scope.datas = response.data;
            }
          });
        } else {
          $scope.datas = null;
        }
      } else {
        if (newValue.nomDonneeAssociee.length > 1 && newValue.zone != null && newValue.zone.length > 1) {
          var url = '/rest/data/compteCommune'; // TODO : rename
          if (newValue.typeCompte === 'EPCI' || newValue.typeCompte === 'METROPOLE_ET_COLLECTIVITE_TERRITORIALE') {
            url = '/rest/data/compteEPCI';
          }
          if (newValue.typeCompte === 'DEPARTEMENT') {
            url = '/rest/data/compteDepartement';
          }
          if (newValue.typeCompte === 'SDIS') {
            url = '/rest/data/compteSDIS';
          }
          $http.get(url, {
            params: {
              nom: newValue.nomDonneeAssociee,
              zone: newValue.zone
            }
          }).then(function (response) {
            if (newValue.typeCompte === 'DEPARTEMENT' || newValue.typeCompte === 'SDIS') {
              $scope.datas = [];
              $scope.datas.push(response.data);
            } else {
              $scope.datas = response.data;
            }
          });
        } else {
          $scope.datas = null;
        }
      }
    }
  }, true);
  $scope.compteFormConfig = {
    url: function url() {
      return '/rest/intra/comptes/save';
    },
    data: function data() {
      return $scope.compte;
    },
    fieldPrefix: "compte.",
    fields: {
      nomInterne: {
        mandatory: true
      },
      nomClient: {
        mandatory: true
      },
      nomClientCourt: {
        mandatory: true
      },
      zone: {
        mandatory: true
      }
    },
    onSuccess: function onSuccess(savedCompte) {
      $scope.$close(savedCompte);
    },
    customValidation: function customValidation() {
      var errors = [];
      if ($scope.compte && $scope.compte.typeCompte === 'ENTREPRISE' && $scope.compte.compteParentId != null) {
        if ($scope.compte.participation == null) {
          errors.push({
            fieldName: 'participation',
            message: 'La participation (en %) doit être renseignée.'
          });
        }
      }
      return errors;
    }
  };
  $scope.onSmallIconUpload = function (result) {
    $scope.compte.smallIconFileId = result.fileId;
  };
  $scope.onBigIconUpload = function (result) {
    $scope.compte.bigIconFileId = result.fileId;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/edition/compteEditionPopin.js", __webpack_require__(1)))

/***/ }),
/* 2781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("compteEditionService", ["$modal", function ($modal) {
  var popinParams = {
    controller: "CompteEditionPopinController",
    template: __webpack_require__(3675),
    options: {
      width: 1000
    }
  };
  return {
    openEditionPopin: function openEditionPopin($scope, compte) {
      console.log('BUILD openEditionPopin', compte);
      return $modal.open(_.extend({}, popinParams, {
        scope: $scope,
        vars: {
          edit: compte ? true : false,
          compteId: compte && compte.id
        },
        options: {
          width: 950
        }
      }));
    },
    openCreationFilialePopin: function openCreationFilialePopin($scope, compteParent) {
      return $modal.open(_.extend({}, popinParams, {
        scope: $scope,
        vars: {
          edit: false,
          compteParentId: compteParent.id,
          compteParentNomInterne: compteParent.nomInterne,
          compteParent: compteParent
        },
        options: {
          width: 950
        }
      }));
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/edition/compteEditionService.js", __webpack_require__(1)))

/***/ }),
/* 2782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Service de configuration pour les onglets de la fiche produit.
 */
ngModule.factory("fpConfigurator", ["$q", function ($q) {
  var tabRegistry = {};
  var providerRegistry = {};
  var tabById = function tabById(tabId) {
    return tabRegistry[tabId];
  };
  return {
    registerTab: function registerTab(tabId, tabDefinition) {
      tabRegistry[tabId] = tabDefinition;
    },
    setProductTabListProvider: function setProductTabListProvider(nature, providerFn) {
      providerRegistry[nature] = providerFn;
    },
    getFicheTabs: function getFicheTabs(produit) {
      var providerFn = providerRegistry[produit.natureRacine];
      if (providerFn == null) {
        providerFn = providerRegistry[produit.nature];
      }
      if (providerFn == null) {
        console.error('pas de provider pour la nature ' + produit.nature, produit);
        throw new Error('pas de provider pour la nature ' + produit.nature);
      }
      return $q.when(providerFn(produit)).then(function (tabIds) {
        return _.map(tabIds, tabById);
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/fiche-produit/fpConfigurator.js", __webpack_require__(1)))

/***/ }),
/* 2783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("guPresConnexion", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: __webpack_require__(3677)
  };
});
ngModule.directive("guPresOrganisationGenerale", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      module: "@module"
    },
    template: __webpack_require__(3681)
  };
});
ngModule.directive("guPresFonctionnalitesTransverses", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: __webpack_require__(3679)
  };
});
ngModule.directive("guPresAccueilRelation", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: __webpack_require__(3676)
  };
});
ngModule.directive("guPresConventions", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: __webpack_require__(3678)
  };
});
ngModule.directive("guPresVocabulaire", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: __webpack_require__(3682)
  };
});
ngModule.directive("guPresGestionCompte", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: __webpack_require__(3680)
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/guide-utilisateur/gu-pres-components.js"))

/***/ }),
/* 2784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("homeAad", function () {
  return {
    restrict: "E",
    replace: true,
    template: __webpack_require__(3683),
    controller: ["$scope", "$http", "aadService", function controller($scope, $http, aadService) {
      var loadResumeInfoClient = function loadResumeInfoClient() {
        $http.get('/rest/home/resume-information-client').then(function (response) {
          $scope.resumeInformationClient = response.data;
        });
      };
      loadResumeInfoClient();
      $scope.editAad = function (aadId) {
        aadService.openEditionPopin($scope, aadId).then(function () {
          loadResumeInfoClient();
        });
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/home/aad/home-aad.js"))

/***/ }),
/* 2785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("homeAnnonceNouvelleVersion", function () {
  return {
    restrict: "E",
    replace: true,
    template: __webpack_require__(3684),
    controller: ["$scope", "abonnementAlerteService", "$notifications", function controller($scope, abonnementAlerteService, $notifications) {
      // changer le nom a chaque nouvelle version
      $scope.taelVersion = "2026.3";
      var cookieName = "tl-annonce-v" + $scope.taelVersion;
      $scope.params = {};
      abonnementAlerteService.getAlerteNouvelleVersion().then(function (data) {
        $scope.params.alerteMailMaj = data;
      });
      $scope.show = $.cookie(cookieName) !== "true";
      $scope.close = function () {
        $scope.show = false;
        $.cookie(cookieName, "true");
      };
      $scope.changeAlerteMail = function () {
        abonnementAlerteService.setAlerteNouvelleVersion($scope.params.alerteMailMaj).then(function (data) {
          $notifications.info($scope.params.alerteMailMaj ? "Notification mail activée" : "Notification mail désactivée");
        });
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/home/annonceNouvelleVersion/homeAnnonceNouvelleVersion.js", __webpack_require__(4)))

/***/ }),
/* 2786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("homeBookmark", function () {
  return {
    restrict: "E",
    replace: true,
    template: __webpack_require__(3685),
    controller: ["$scope", "$http", "$applications", function controller($scope, $http, $applications) {
      function loadBookmarks() {
        $http.get('/rest/home/user-bookmarks').then(function (response) {
          $scope.bookmarks = response.data;
        });
      }
      loadBookmarks();
      $scope.toggleBookmarkEdition = function () {
        $scope.editionBookmarks = !$scope.editionBookmarks;
      };
      $scope.remove = function (bookmark) {
        bookmark.deleting = true;
        $http.delete('/rest/bookmark/delete/' + bookmark.id).then(function (response) {
          loadBookmarks();
        }).finally(function () {
          // on ne retire pas le deleting vu que la liste va etre rechargée, ça évite que cela "clignote"
        });
      };
      $scope.getFullUrl = function (bookmark) {
        return $applications.getApp(bookmark.application || 'DETTE').path + "/" + bookmark.url;
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/home/bookmark/homeBookmark.js"))

/***/ }),
/* 2787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("homeCampagne", function () {
  return {
    restrict: "E",
    replace: true,
    template: __webpack_require__(3686),
    controller: ["$scope", "$http", "$dialogBox", "$dateFormat", function controller($scope, $http, $dialogBox, $dateFormat) {
      $scope.reponseInvitation = {};
      var load = function load() {
        $http.get('/rest/home/get-info-campagne-utilisateur').then(function (response) {
          // contient "" si aucune campagne pour l'utilisateur
          $scope.campagne = response.data;
          $scope.reponseInvitation = {
            reponse: 'VIENDRA',
            sessionId: null,
            journee: 'COMPLETE'
          };
          if ($scope.campagne && $scope.campagne.sessions.length === 1) {
            $scope.reponseInvitation.sessionId = $scope.campagne.sessions[0].id;
          }
          $scope.reponsesInvitationCampagne = [{
            id: 'VIENDRA',
            label: 'Je viendrai'
          }, {
            id: 'NE_VIENDRA_PAS',
            label: 'Je ne viendrai pas'
          }];
          $scope.journeesCampagne = [{
            id: 'COMPLETE',
            label: 'Journée Complète'
          }, {
            id: 'MATIN',
            label: 'Matin'
          }, {
            id: 'APRES_MIDI',
            label: 'Après-midi'
          }];
          $scope.sessions = _.map($scope.campagne.sessions, function (c) {
            var label = _.upperFirst($dateFormat.date(c.date));
            if (c.heure) {
              label += " " + c.heure + "h";
              if (c.minutes) {
                label += c.minutes;
              }
            }
            if (c.lieu) {
              label += " - " + c.lieu;
            }
            return {
              id: c.id,
              label: label
            };
          });
        });
      };
      load();
      $scope.envoiReponseInvitation = function () {
        if ($scope.submit) {
          return;
        }
        $scope.submit = true;
        $http.post('/rest/home/save-campagne-utilisateur/' + $scope.campagne.id, null, {
          params: $scope.reponseInvitation
        }).then(function () {
          return $dialogBox.alert({
            title: "Participation enregistrée",
            text: "Votre réponse a bien été enregistrée. Si vous deviez changer d'avis, merci de contacter votre consultant pour l'en informer."
          }).then(function () {
            load();
          });
        }).finally(function () {
          $scope.submit = false;
        });
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/home/campagne/homeCampagne.js", __webpack_require__(1)))

/***/ }),
/* 2788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("homeDashboardChangeLog", ["$http", "$translate", function ($http, $translate) {
  return {
    restrict: "E",
    scope: {
      naturesApplicationCouranteUniquement: '@',
      // true ou false
      horsSubvention: '@' // true ou false
    },
    replace: true,
    template: __webpack_require__(3687),
    controllerAs: "componentCtrl",
    controller: ["$scope", function controller($scope) {
      var ctrl = this;
      ctrl.filter = {
        saisieConsultants: true,
        saisieClients: true,
        depuis: 30,
        naturesApplicationCouranteUniquement: $scope.naturesApplicationCouranteUniquement,
        horsSubvention: $scope.horsSubvention
      };
      $scope.getRecuperations = function () {
        var params = _.clone(ctrl.filter);
        $scope.loadingChangelog = true;
        $http.get('/rest/home/home-changelog/list', {
          params: params
        }).then(function (response) {
          $scope.modifications = response.data;
        }).finally(function () {
          $scope.loadingChangelog = false;
        });
      };
      var showSectionCookie = "home.show-changeLog";
      $scope.view = {
        showSection: $.cookie(showSectionCookie) !== undefined ? $.cookie(showSectionCookie) === 'true' : true
      };
      $scope.changeShow = function () {
        $scope.view.showSection = !$scope.view.showSection;
        $.cookie(showSectionCookie, $scope.view.showSection);
      };
      $scope.$watch("componentCtrl.filter", function (newValue, oldValue) {
        if (newValue && oldValue && newValue !== oldValue) {
          $scope.getRecuperations();
        }
      }, true);
      $scope.getRecuperations();
      $scope.modificationsTableConfig = {
        source: "modifications",
        height: 800,
        allowSelection: true,
        selectionAttribute: "selectedModif",
        selectionScope: $scope,
        columns: [{
          id: 'date',
          attribute: 'date',
          title: 'Date',
          filter: "dateShort",
          sortable: true,
          sortType: "date",
          width: 100,
          cellClass: 'align-c'
        }, {
          attribute: "compteNomInterne",
          title: 'Compte',
          sortable: true,
          width: 300,
          cellClass: 'align-l',
          template: '<span>{{::model.compteNomInterne}}</span>'
        }, {
          title: 'Changement',
          attribute: "descriptions",
          template: "\n                            <div style='max-height: 200px;overflow-y: auto'><div ng-repeat='m in model.compteLogs track by $index'>\n                                <span ng-if=\"m.garantie==true\" class='module-dg mr-xs'>dg</span>\n                                <span ng-if=\"m.pret==true\"  tl-tooltip=\"Pr\xEAt octroy\xE9\" class='module-pret mr-xs'>P</span>\n                                <span> {{m.description}}</span> <span class='b i'>{{m.user}}</span>\n                            </div>\n\n                            <div ng-repeat='m in model.modificationProduits'>\n                            <span class='sim-pill'>{{::m.reference}}</span>\n                            <pill-nature-produit class='ml-xs' ng-if=\"m.nature!='EMPRUNT_BANCAIRE'\" nature='{{::m.nature}}'></pill-nature-produit>\n                            <span ng-if=\"m.garantie==true\" class='module-dg ml-xs' tl-tooltip=\"Dette garantie\">dg</span>\n                            <span ng-if=\"m.pret==true\"  tl-tooltip=\"Pr\xEAt octroy\xE9\" class='module-pret ml-xs'>P</span>\n                             <span ng-if='m.nbMaj>1' class='i'>{{m.nbMaj}} changements.</span>\n                            <div ng-repeat='m in m.modifications track by $index'> <span class=''>- {{m.modification}}</span>\n                                 <span class='ml-xs i b'>({{m.user}})</span>\n                                <i class='ml-xs fa fa-search-plus blue' tl-tooltip ng-if='!view.detail && m.detail && m.detail.length>0'>\n                                    <tl-tooltip-content>\n                                        <div>\n                                            <span ng-bind-html='m.detail' class='changements-produit'></span>\n                                        </div>\n                                    </tl-tooltip-content>\n                                </i>\n                                <div ng-if='view.detail && m.detail && m.detail.length>0'>\n                                    <i class='mr-xs fa fa-search-plus blue'></i>\n                                    <span ng-bind-html='m.detail' class='changements-produit darkBlue'></span>\n                                </div>\n                            </div>\n                            </div>\n"
        }]
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/home/changelog/home-dashboard-changeLog.js", __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 2789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("homeContrat", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: __webpack_require__(3688),
    controller: ["$scope", "$http", "$session", "tlTableUtils", "$translate", "$applications", function controller($scope, $http, $session, tlTableUtils, $translate, $applications) {
      $scope.appPath = $applications.getCurrentAppPath();
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/home/infoIntra/contrat/homeContrat.js"))

/***/ }),
/* 2790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("homeInfoIntra", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {},
    template: __webpack_require__(3689),
    controller: ["$scope", "$http", "$translate", function controller($scope, $http, $translate) {
      $http.get('/rest/home/resume-client').then(function (response) {
        $scope.resume = response.data;
        $scope.crm = $scope.resume.suivi;
      });
      $scope.loadUtilisateursConnectes = function () {
        $scope.loadingUtilisateursConnectes = true;
        $http.get('/rest/home/resume-utilisateurs').then(function (response) {
          $scope.utilisateurs = response.data;
        }).finally(function () {
          $scope.loadingUtilisateursConnectes = false;
        });
      };
      $scope.loadUtilisateursConnectes();
      $scope.invitationsTableConfig = {
        id: 'invitationsTable',
        source: "resume.invitations",
        height: 600,
        columns: [{
          attribute: 'nom',
          title: "Nom",
          cellClass: "align-l",
          sortable: true
        }, {
          attribute: 'prenom',
          title: "Prenom",
          cellClass: "align-l",
          sortable: true
        }, {
          attribute: 'fonction',
          id: 'fonction',
          title: "Fonction",
          cellClass: "align-l",
          sortable: true
        }, {
          id: 'nbConnexion',
          attribute: 'nbConnexion',
          title: "Nb connexion",
          cellClass: "align-l",
          sortable: true,
          sortType: 'number'
        }, {
          title: "Suivi",
          columns: [{
            title: 'Invitation',
            attribute: 'envoye',
            template: '<span ng-if="model.envoye">Envoyée</span> <span  ng-if="!model.envoye" class="blue">A envoyer</span>'
          }, {
            title: "Echec",
            attribute: "echecEnvoi",
            template: '<i ng-if="model.echecEnvoi" class="fa fa-check green"></i>',
            cellClass: "align-c",
            sortable: true,
            sortType: 'boolean'
          }, {
            title: "Relancer",
            attribute: "aRelancer",
            template: '<i ng-if="model.aRelancer" class="fa fa-check green"></i>',
            cellClass: "align-c",
            sortable: true,
            sortType: 'boolean'
          }, {
            attribute: 'reponse',
            title: "Réponse",
            cellClass: "align-c",
            sortable: true
          }, {
            attribute: 'reponseParFormulaire',
            id: 'reponseParFormulaire',
            title: "Form.",
            cellClass: "align-c",
            sortable: true,
            template: '<span ng-if="model.reponseParFormulaire"><i class="fa fa-check green"></i></span>',
            sortType: 'boolean'
          }, {
            attribute: 'session',
            title: "Session",
            cellClass: "align-c",
            sortable: true
          }, {
            attribute: 'journee',
            title: "Journée",
            cellClass: "align-c",
            sortable: true
          }, {
            attribute: 'presence',
            title: "Présence",
            cellClass: "align-c",
            sortable: true
          }, {
            attribute: 'commentaire',
            title: "Commentaire taelys",
            cellClass: "align-c",
            width: '250px',
            sortable: true
          }, {
            attribute: 'remarque',
            id: 'remarque',
            title: "Remarque formulaire",
            cellClass: "align-c",
            sortable: true
          }]
        }]
      };
      $scope.utilisateursTableConfig = {
        id: 'homeUtilisateursTable',
        source: "utilisateurs",
        height: 600,
        columns: [{
          attribute: 'denomination',
          title: "Utilisateur",
          tooltip: 'Utilisateurs connectés dans les 3 dernières heures',
          cellClass: "align-c",
          sortable: true
        }, {
          attribute: 'email',
          title: "Email",
          cellClass: "align-c",
          sortable: true
        }, {
          attribute: 'dernierAcces',
          title: "Dernier accès",
          filter: 'dureeFromMinutes',
          cellClass: "align-c",
          sortable: true,
          sortType: "number"
        }, {
          title: "Contexte",
          template: '<i class="fa fa-warning orange" ng-if="model.contexte.alerte" tl-tooltip="Un filtre est activé sans valeur cochée."></i>' + '<div ng-if="model.contexteResume.resumeBudget">Budget : {{model.contexteResume.resumeBudget}}</div>' + '<div ng-if="model.contexte.contexteDette.filtreSimulation.enabled">{{model.contexte.contexteDette.filtreSimulation.simulationsInclues.length}} simulation(s)' + '<div ng-if="model.contexte.contexteDette.filtreProduit.enabled">{{model.contexte.contexteDette.filtreProduit.produitsInclus.length}} produit(s)' + '</div>',
          cellClass: "align-c",
          sortable: true
        }, {
          attribute: 'dateVisualisation',
          title: "Date de visualisation",
          template: '{{model.dateVisualisation|dateShort}} ',
          cellClass: "align-c",
          sortable: true,
          sortType: 'date'
        }]
      };
      $scope.formationsTableConfig = {
        id: 'homeFormationsTable',
        source: "resume.formations",
        initialSort: ['date', 'desc'],
        columns: [{
          attribute: 'nom',
          title: 'Nom',
          cellClass: "align-c"
        }, {
          attribute: 'prenom',
          title: 'Prénom',
          cellClass: "align-c"
        }, {
          attribute: 'formation',
          title: 'Formation',
          cellClass: "align-c"
        }, {
          attribute: 'date',
          title: 'Date',
          template: '<span>{{model.date | dateShort}}</span><span ng-if="model.heure"> ({{model.heure}})</span>',
          filter: "dateShort",
          sortable: true,
          sortType: "date",
          width: "200px",
          cellClass: "align-c"
        }, {
          attribute: 'formationModalite',
          title: 'Modalité',
          template: "<span> {{'lov.formationModalites.' + model.formationModalite | translate}}</span>",
          width: "200px",
          cellClass: "align-c"
        }]
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/home/infoIntra/homeInfoIntra.js"))

/***/ }),
/* 2791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("WelcomePopinController", ["$scope", "$location", "$http", "abonnementAlerteService", "$session", "$notifications", function ($scope, $location, $http, abonnementAlerteService, $session, $notifications) {
  $scope.params = {
    alerteMailVersionMaj: true,
    alerteMailPublicationMaj: true
  };
  $scope.user = $session.getUser();

  /*
  $scope.changeAlerteMailVersion = () => {
      abonnementAlerteService.setAlerteNouvelleVersion($scope.params.alerteMailMaj).then((data) => {
          $notifications.info(($scope.params.alerteMailMaj) ? "Notification mail activée" : "Notification mail désactivée");
      });
   }
   $scope.changeAlerteMailPublication = () => {
      abonnementAlerteService.setAlerteNouvellePublication($scope.params.alerteMailMaj).then((data) => {
          $notifications.info(($scope.params.alerteMailMaj) ? "Notification mail activée" : "Notification mail désactivée");
      });
  };
  */
  $scope.validateAndSave = function () {
    abonnementAlerteService.setAlerteNouvelleVersion($scope.params.alerteMailVersionMaj).then(function () {
      abonnementAlerteService.setAlerteNouvellePublication($scope.params.alerteMailPublicationMaj);
    });
    $scope.errorMessage = null;
    $http.put('/rest/home/welcome-screen-off');
    $scope.$close();
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/home/welcome/welcome.js"))

/***/ }),
/* 2792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("welcomeService", ["$http", "$modal", function ($http, $modal) {
  return {
    welcome: function welcome() {
      $http.get('/rest/home/info').then(function (response) {
        var welcomeInfo = response.data;
        if (welcomeInfo.afficheWelcomeScreen) {
          return $modal.open({
            template: __webpack_require__(3690),
            controller: "WelcomePopinController",
            options: {
              width: 800
            },
            vars: {
              homeInfo: welcomeInfo
            }
          });
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/home/welcome/welcomeService.js"))

/***/ }),
/* 2793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("itCompiler", ["$compile", "$parse", "$interpolate", function ($compile, $parse, $interpolate) {
  // perf optim
  function createElement(tagName) {
    return $(document.createElement(tagName));
  }
  return function itCompiler(tableCtrl) {
    var compiler = this;

    // Parent virtuel pour fournir le contrôleur aux directives qui le requièrent (^infiniTable)
    var provider = angular.element('<div>').data('$' + 'infiniTable' + 'Controller', tableCtrl);
    var getConfig = function getConfig() {
      return tableCtrl.getConfig();
    };
    var getContext = function getContext() {
      return tableCtrl.getContext();
    };

    /**
     * Compile all template found in the config object and put them into the linkers.
     * A template is a config attribute matching /(.*)Template$/.
     * Directive can be added to template element if a key matching.
     * For example, for the key rowTemplate, if a key rowDirective is found, the value will be used a directive
     */
    compiler.compileTemplates = function () {
      var config = getConfig();
      var templatePropRegexp = /(.*)Template$/;
      _.each(config, function (value, key) {
        if (templatePropRegexp.test(key)) {
          var templateName = key.substring(0, key.length - "Template".length);
          var template = $(value);
          var directiveKey = templateName + "Directive";
          if (_.has(config, directiveKey)) {
            _.each(config[directiveKey].split(" "), function (directiveName) {
              template.attr(directiveName, "");
            });
          }
          var linkFn = $compile(template);
          tableCtrl.linkers[templateName] = function (scope, cloneConnectFn) {
            return linkFn(scope, function (clone) {
              provider.append(clone); // Attache temporairement au provider pour satisfaire le 'require'
              if (cloneConnectFn) {
                cloneConnectFn(clone);
              }
            });
          };
        }
      });
    };

    /**
     * Compute columns from columns configuration and put computed informations into table context.
     *
     * @param initial true if this is used for initial columns computation
     */
    compiler.computeColumns = function (initial) {
      // TODO : split between compilation and refresh to avoid 'initial' parameter

      var computed = [],
        config = getConfig(),
        context = getContext(),
        groups = [],
        columns = [];
      var columnIdx = 0;
      var addGroup = function addGroup(group) {
        if (group.condition && !group.condition()) {
          return;
        }
        if (!group.id) {
          group.id = group.title ? 'group-' + group.title : 'group-' + groups.length;
        }
        var groupColumns = group.columns;
        var initialIdx = columnIdx;
        var columnCount = 0;
        _.each(groupColumns, function (column) {
          if (addColumn(column)) {
            columnCount++;
          }
        });
        group.fromColumn = initialIdx;
        group.toColumn = initialIdx + columnCount - 1;
        groups.push(group);
      };
      var addColumn = function addColumn(column) {
        if (column.condition && !column.condition()) {
          return false;
        }
        columns.push(column);
        columnIdx++;
        return true;
      };
      _.each(config.columns, function (columnOrGroup, i) {
        var isGroup = columnOrGroup.group || columnOrGroup.columns;
        isGroup ? addGroup(columnOrGroup) : addColumn(columnOrGroup);
      });
      var findGroup = function findGroup(idx) {
        for (var i = 0; i < groups.length; i++) {
          if (idx >= groups[i].fromColumn && idx <= groups[i].toColumn) {
            return groups[i];
          }
        }
        return null;
      };
      var usedIds = [];
      var getId = function getId(column, index) {
        var baseId;
        if (column.id) {
          baseId = column.id;
        } else if (column.attribute) {
          baseId = "col-".concat(column.attribute);
        } else {
          baseId = "col-".concat(index);
        }
        var id = baseId;
        var ext = 0;
        while (usedIds.indexOf(id) > -1) {
          id = "".concat(baseId, "-").concat(ext++);
        }
        usedIds.push(id);
        return id;
      };

      // process columns configuration
      _.each(columns, function (column, i) {
        var columnGroup = findGroup(i);
        computed.push({
          id: getId(column, i),
          index: i,
          column: column,
          group: columnGroup,
          headerInjector: compiler.makeHeaderInjector(column),
          cellInjector: compiler.makeCellInjector(column),
          footerCellInjector: compiler.makeFooterCellContentInjector(column),
          subtotalCellInjector: compiler.makeSubtotalCellContentInjector(column),
          sortable: column.sortable || config.sortable && column.sortable !== false,
          footer: column.footer || false,
          subtotal: column.subtotal || false,
          visible: column.visible != null ? column.visible : true
        });
      });
      context.columns = computed;
      if (initial) {
        _.each(config.columnGroups, function (columnGroup) {
          var visible = _.has(columnGroup, "visible") ? columnGroup.visible : true;
          _.each(columnGroup.columns, function (columnId) {
            var column = _.find(context.columns, {
              id: columnId
            });
            if (column != null) {
              column.visible = visible;
              column.column.visible = visible;
            }
          });
        });
      }
      context.visibleColumns = _.filter(computed, {
        visible: true
      });

      // check if current columns config has displayed group headers.
      var hasHeaderGroups = false;
      for (var i = 0; i < groups.length; i++) {
        var group = groups[i];
        var colspan = 0;
        for (var colIdx = group.fromColumn; colIdx <= group.toColumn; colIdx++) {
          if (computed[colIdx].visible) {
            colspan++;
          }
        }
        if (colspan > 0) {
          hasHeaderGroups = true;
          break;
        }
      }
      context.hasHeaderGroups = hasHeaderGroups;
    };

    /**
     * Compile a cell injector function for given column and returns it.
     *
     * @param column The column configuration object
     *
     * @returns {function} the row injector function, with following parameters :
     *      args[0] : the row element
     *      args[1] : the row scope
     */
    compiler.makeCellInjector = function (column) {
      var config = getConfig(),
        cellTemplate = $(config.cellTemplate);
      if (column.cellClass) {
        cellTemplate.addClass(column.cellClass);
      }
      if (column.linker) {
        // allow usage of custom linker. actually used by the tree renderer's tree column.
        return column.linker;
      } else if (column.template) {
        var cellContentTemplate = _.result(column, "template");
        cellTemplate.html(cellContentTemplate);
        var cellLinkFn = $compile(cellTemplate);
        return function (rowEl, rowScope) {
          cellLinkFn(rowScope, function (cellElement) {
            provider.append(cellElement);
            cellElement.appendTo(rowEl);
          });
        };
      } else if (column.expression) {
        var interpolateFn = $interpolate(column.expression);
        return function (rowEl, rowScope) {
          var cellElement = $(cellTemplate[0].cloneNode(false));
          var cellContent = createElement("span").html(interpolateFn(rowScope));
          cellElement.html(cellContent);
          cellElement.appendTo(rowEl);
        };
      } else {
        var parseFn = $parse("model." + column.attribute + (column.filter ? "|" + column.filter : ""));
        return function (rowEl, rowScope) {
          var cellElement = $(cellTemplate[0].cloneNode(false));
          var cellContent = createElement("span").html(parseFn(rowScope));
          cellElement.html(cellContent);
          cellElement.appendTo(rowEl);
        };
      }
    };
    compiler.makeCellContentInjector = function (column, config) {
      if (column.template) {
        var cellContentTemplate = _.result(column, "template");
        var cellContentTemplateLinkFn = $compile(cellContentTemplate);
        return function (cellScope, cellElement) {
          cellContentTemplateLinkFn(cellScope, function (cellContent) {
            cellContent.appendTo(cellElement);
          });
        };
      } else {
        var expression = column.expression ? column.expression : column.filter ? "{{ model." + column.attribute + " | " + column.filter + " }}" : "{{ model." + column.attribute + " }}";
        if (column.watch || config.watch) {
          // TODO : test can be improved
          var expressionTemplate = "<span>" + expression + "</span>";
          var expressionLinkFn = $compile(expressionTemplate);
          return function (cellScope, cellElement) {
            expressionLinkFn(cellScope, function (expressionElement) {
              expressionElement.appendTo(cellElement);
            });
          };
        } else {
          var interpolateFn = $interpolate(expression);
          return function (cellScope, cellElement) {
            var cellContent = $("<span>").html(interpolateFn(cellScope));
            cellContent.appendTo(cellElement);
          };
        }
      }
    };

    /**
     * Compile a header injector function for given column and returns it.
     *
     * @param column The column configuration objet
     *
     * @returns {function} the header injector function, with following parameters :
     *      args[0] : the row element
     *      args[1] : the row scope
     */
    compiler.makeHeaderInjector = function (column) {
      if (column.headerTemplate) {
        var headerContentTemplate = _.result(column, "headerTemplate");
        var linkFn = $compile(headerContentTemplate);
        return function (headerCell, headerScope) {
          linkFn(headerScope, function (clone) {
            provider.append(clone); // Fournit le contrôleur via le provider
            clone.appendTo(headerCell); // Déplace l'élément vers sa destination finale
          });
        };
      } else {
        return function (headerCell, headerScope) {
          var titles = _.isArray(column.title) ? column.title : [column.title || ""];
          var titleContainer = $("<div>").addClass("it-title-container").appendTo(headerCell);
          _.each(titles, function (title, i) {
            var titleSpan = $("<span>").addClass("it-title").addClass("it-title-" + i).text(title);
            titleContainer.append(titleSpan);
          });
        };
      }
    };

    /**
     * Compile a footer cell injector function for given column and returns it.
     *
     * @param column The column configuration object
     *
     * @returns {function} the footer cell injector function, with following parameters :
     *      args[0] : the row element
     *      args[1] : the row scope
     */
    compiler.makeFooterCellContentInjector = function (column) {
      if (column.footerTemplate) {
        var cellContentTemplate = _.result(column, "footerTemplate");
        var linkFn = $compile(cellContentTemplate);
        return function (cellScope, cellElement) {
          linkFn(cellScope, function (clone) {
            provider.append(clone);
            clone.appendTo(cellElement);
          });
        };
      } else {
        var expression = column.footerExpression ? column.footerExpression : column.footerFilter || column.filter ? "{{ footerValue | " + (column.footerFilter || column.filter) + " }}" : "{{ footerValue }}";
        var expressionTemplate = "<span ng-if=\"footerValue != null\">".concat(expression, "</span>");
        var expressionLinkFn = $compile(expressionTemplate);
        return function (cellScope, cellElement) {
          expressionLinkFn(cellScope, function (expressionElement) {
            expressionElement.appendTo(cellElement);
          });
        };
      }
    };

    /**
     * Compile a subtotal cell injector function for given column and returns it.
     *
     * @param column The column configuration object
     *
     * @returns {function} the subtotal cell injector function, with following parameters :
     *      args[0] : the row element
     *      args[1] : the row scope
     */
    compiler.makeSubtotalCellContentInjector = function (column) {
      if (column.subtotalTemplate) {
        var cellContentTemplate = _.result(column, "subtotalTemplate");
        var linkFn = $compile(cellContentTemplate);
        return function (cellScope, cellElement) {
          linkFn(cellScope, function (clone) {
            provider.append(clone);
            clone.appendTo(cellElement);
          });
        };
      } else {
        var expression = column.subtotalExpression ? column.subtotalExpression : column.subtotalFilter || column.filter ? "{{ subtotalValue | " + (column.subtotalFilter || column.filter) + " }}" : "{{ subtotalValue }}";
        var expressionTemplate = "<span ng-if=\"subtotalValue != null\">".concat(expression, "</span>");
        var expressionLinkFn = $compile(expressionTemplate);
        return function (cellScope, cellElement) {
          expressionLinkFn(cellScope, function (expressionElement) {
            expressionElement.appendTo(cellElement);
          });
        };
      }
    };
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/common/itCompiler.js", __webpack_require__(4), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("itFooterAccumulator", ["valeurUtils", function (valeurUtils) {
  var defaultReducer = function defaultReducer(sum, current) {
    return sum + current;
  };
  var reducers = {
    number: function number(data, attribute) {
      return _.reduce(data, function (sum, current) {
        var value = _.get(current, attribute);
        if (value) {
          return sum + value;
        }
        return sum;
      }, 0);
    },
    montant: function montant(data, attribute) {
      var total = null;
      for (var i = 0; i < data.length; i++) {
        var current = _.get(data[i], attribute);
        if (total == null) {
          total = current;
        } else {
          var sum = valeurUtils.addMontant(total, current);
          if (sum == null) {
            return null;
          }
          total = sum;
        }
      }
      return total;
    },
    taux: function taux(data, attribute) {
      var total = null;
      for (var i = 0; i < data.length; i++) {
        var current = _.get(data[i], attribute);
        if (total == null) {
          total = current;
        } else {
          total = valeurUtils.addValeur(total, current);
        }
      }
      return total;
    }
  };
  return {
    getEligibleTypes: function getEligibleTypes() {
      return Object.keys(reducers);
    },
    accumulate: function accumulate(dataSource, column) {
      var reducer;
      if (column.footerReducer) {
        if (typeof column.footerReducer === 'string') {
          reducer = reducers[column.footerReducer] || defaultReducer;
        } else {
          reducer = column.footerReducer;
        }
      } else {
        reducer = reducers[column.dataType] || defaultReducer;
      }
      try {
        return reducer(dataSource, column.attribute);
      } catch (e) {
        console.log("error accumulating data for column ".concat(column, ": ").concat(e));
        return null;
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/common/itFooterAccumulator.js", __webpack_require__(1)))

/***/ }),
/* 2795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("itFooterManager", ["itFooterAccumulator", function (itFooterAccumulator) {
  return function (tableCtrl) {
    var manager = this,
      tableScope = tableCtrl.getScope(),
      linkers = tableCtrl.linkers,
      context = tableCtrl.getContext(),
      ui = tableCtrl.ui,
      footerRootScope = null;

    /**
     * Compute the footer values and inject them in the table scope's `footerValues` properties.
     *
     * `footerValues` is a Map<column.id, value>
     */
    manager.computeFooterValues = function () {
      context.footerValues = {};
      if (tableCtrl.getConfig().footer === false) {
        return;
      }
      var dataSource = tableCtrl.getDataSource();
      var footerValues = {};
      context.columns.filter(function (column) {
        var colDef = column.column;
        return (colDef.dataType || colDef.footerReducer) && column.column.footer !== false;
      }).forEach(function (column) {
        var footerValue = itFooterAccumulator.accumulate(dataSource, column.column);
        footerValues[column.id] = footerValue;
      });
      context.footerValues = footerValues;
    };

    /**
     * Return true if the table config define a static footer, false otherwise.
     */
    manager.hasStaticFooter = function (config) {
      return config.footer === 'static' || config.footer === true;
    };

    /**
     * Return true if the table config define an inline footer, false otherwise.
     */
    manager.hasInlineFooter = function (config) {
      return config.footer === 'inline';
    };

    /**
     * Refresh the static footer, adding, removing or updating it depending on the current config.
     */
    manager.refreshStaticFooter = function () {
      if (footerRootScope != null) {
        footerRootScope.$destroy();
        footerRootScope = null;
        ui.footerTable.find('tfoot').empty();
      }
      if (manager.hasStaticFooter(tableCtrl.getConfig())) {
        ui.footerDiv.show();
        footerRootScope = tableScope.$new();
        createFooterRow();
      } else {
        ui.footerDiv.hide();
      }
    };
    var createFooterRow = function createFooterRow() {
      ui.contentFoot.empty();
      var footerRowLinker = linkers.footerRow;
      var footerRow = null;
      footerRowLinker(tableScope, function (_footerRow) {
        footerRow = _footerRow;
        footerRow.appendTo(ui.footerTable.find('tfoot'));
      });
      footerRowLinker(tableScope, function (_footerRow) {
        footerRow = _footerRow;
        footerRow.appendTo(ui.contentFoot);
      });
      ui.contentFoot.hide();
    };
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/common/itFooterManager.js"))

/***/ }),
/* 2796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * it-header-cell
 */
ngModule.directive('itHeaderCell', function () {
  return {
    restrict: "A",
    require: "^infiniTable",
    scope: true,
    link: function link($scope, $el, $attrs, tableCtrl) {
      var column = $scope.column;
      var context = tableCtrl.getContext();
      if (column && column.id) {
        $el.attr('data-col-id', column.id);
      }
      if (column.column.subtotalGroup) {
        addSubtotalFeature();
      }
      if (column.sortable) {
        addSortableFeature();
      }
      if (column.column.tooltip) {
        addTooltipFeature();
      }
      function addTooltipFeature() {
        var tooltipContainer = $("<div>").addClass("it-tooltip-content").html(column.column.tooltip).appendTo($el);
        $el.addClass("it-has-tooltip");
        $el.find(".it-title-container").qtip({
          content: {
            text: tooltipContainer
          },
          show: {
            delay: 450
          },
          position: {
            // se passe mal dès que la page est trop longue - mais a priori inutile donc on met en commentaire
            //container : $el.closest(".infini-table"),
            my: 'top center',
            at: 'bottom center',
            adjust: {
              y: 8
            }
          },
          style: {
            classes: 'qtip-it-header'
          }
        });
        $el.find(".it-title-container").append('<i class="tooltip-info-icon fa fa-info-circle no-print"></i>');
      }
      function addSubtotalFeature() {
        var context = tableCtrl.getContext();
        function isSubtotalColumn() {
          return context.subtotal && context.subtotal.column != null && context.subtotal.column === (_.isNumber(context.subtotal.column) ? column.index : column.id);
        }
        $el.addClass("it-subtotal-column");
        var subtotalIcon = $("<i>").addClass("it-subtotal").prependTo($el);
        subtotalIcon.qtip({
          content: {
            text: isSubtotalColumn() ? 'Dégrouper' : 'Grouper'
          },
          show: {
            delay: 450,
            solo: true
          },
          position: {
            // se passe mal dès que la page est trop longue - mais a priori inutile donc on met en commentaire
            //container : $el.closest(".infini-table"),
            my: 'top center',
            at: 'bottom center',
            adjust: {
              y: 8
            }
          },
          style: {
            classes: 'qtip-it-header'
          }
        });
        subtotalIcon.click(function (event) {
          $scope.$apply(function () {
            tableCtrl.subTotalBy(column.id || column.index);
            // todo regarder dans le context sort colomn
            tableCtrl.sortBy(column.id || column.index, isSortColumn() ? context.sort.desc : false);
            // todo - nécessaire ?
            tableCtrl.refreshColumnsSizing();
            tableCtrl.refreshContent();

            // todo - utile ?
            _.delay(function () {
              $scope.$broadcast("$redraw");
              $scope.$apply();
            }, 200);
          });
          event.stopPropagation();
        });
        $scope.$watch(function () {
          return context.subtotal;
        }, function (subtotal) {
          if (isSubtotalColumn()) {
            subtotalIcon.addClass("it-subtotal-by");
          } else {
            subtotalIcon.removeClass("it-subtotal-by");
          }
        }, true);
      }
      function isSortColumn() {
        return context.sort.column === (_.isNumber(context.sort.column) ? column.index : column.id);
      }
      function addSortableFeature() {
        $el.addClass("it-sortable-column");
        var sortIcon = $("<i>").addClass("it-sort").appendTo($el);
        if (column.column.subtotalGroup) {
          sortIcon.addClass("it-sortable-column-with-subtotalgroup");
        }
        $el.click(function () {
          if ($el.data('it-just-dragged')) {
            $el.removeData('it-just-dragged');
            return;
          }
          $scope.$apply(function () {
            tableCtrl.sortBy(column.id || column.index, isSortColumn() ? !context.sort.desc : false);
          });
        });
        $scope.$watch(function () {
          return context.sort;
        }, function (sort) {
          if (isSortColumn()) {
            sortIcon.addClass("it-sorted-by");
            if (sort.desc) {
              sortIcon.removeClass("it-sort-asc").addClass("it-sort-desc");
            } else {
              sortIcon.removeClass("it-sort-desc").addClass("it-sort-asc");
            }
          } else {
            sortIcon.removeClass("it-sorted-by it-sort-asc it-sort-desc");
          }
        });
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/common/itHeaderCell.js", __webpack_require__(4), __webpack_require__(1)))

/***/ }),
/* 2797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * it-header-group-cell
 */
ngModule.directive('itHeaderGroupCell', function () {
  return {
    restrict: "A",
    require: "^infiniTable",
    scope: true,
    link: function link($scope, $el, $attrs, tableCtrl) {
      var group = $scope.group;
      if (group && group.id) {
        $el.attr('data-group-id', group.id);
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/common/itHeaderGroupCell.js"))

/***/ }),
/* 2798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("itHeaderManager", function () {
  return function (tableCtrl) {
    var manager = this,
      $scope = tableCtrl.getScope(),
      linkers = tableCtrl.linkers,
      context = tableCtrl.getContext(),
      ui = tableCtrl.ui,
      columnsParentScope = null;

    /**
     *
     */
    manager.constructColGroups = function () {
      var headerCols = [];
      var contentCols = [];
      var footerCols = [];

      // iterates on visible columns to create associated col element
      _.each(context.visibleColumns, function (computed) {
        if (!computed.visible) {
          return;
        }
        computed.headerCol = $(document.createElement("col"));
        computed.contentCol = $(document.createElement("col"));
        computed.footerCol = $(document.createElement("col"));
        headerCols.push(computed.headerCol[0]);
        contentCols.push(computed.contentCol[0]);
        footerCols.push(computed.footerCol[0]);
      });

      // adds the scrollbar col
      headerCols.push($('<col class="scrollbar">')[0]);
      contentCols.push($('<col class="scrollbar">')[0]);
      footerCols.push($('<col class="scrollbar">')[0]);

      // appends only once to avoid multiple repaint
      ui.headColgroup.empty().append(headerCols);
      ui.contentColgroup.empty().append(contentCols);
      ui.footerColgroup.empty().append(footerCols);
    };

    /**
     *
     */
    manager.constructHeaders = function () {
      if (columnsParentScope != null) {
        columnsParentScope.$destroy();
        ui.headTable.find('thead').empty();
        ui.contentHeadRow.empty();
      }
      columnsParentScope = $scope.$new();

      // var computedColumns = context.columns;
      var hasGroups = context.hasHeaderGroups;
      var headerRow = createHeadHeaderRow();
      var headerCellLinker = linkers.headerCell;
      var contentHeaderCellLinker = linkers.contentHeaderCell;
      var headerGroupRow,
        groupCellLinker,
        lastGroup = null;
      if (hasGroups) {
        headerGroupRow = createHeadGroupRow();
        groupCellLinker = linkers.headerGroupCell;
      }
      _.each(context.visibleColumns, function (computed) {
        var group = computed.group;
        var column = computed.column;
        var columnScope = columnsParentScope.$new();
        columnScope.column = computed;

        // add group row cell if necessary
        if (group && group !== lastGroup) {
          lastGroup = group;

          // calculating effective colspan ( visible = false )
          var colspan = 0;
          for (var colIdx = group.fromColumn; colIdx <= group.toColumn; colIdx++) {
            if (context.columns[colIdx].visible) {
              colspan++;
            }
          }
          var groupScope = columnsParentScope.$new();
          groupScope.group = group;
          groupCellLinker(groupScope, function (headerCell) {
            headerCell.text(group.title);
            headerCell.attr("colspan", colspan);
            if (group.id) {
              headerCell.attr("data-group-id", group.id);
            }
            if (group.tooltip) {
              var $el = headerCell;
              var tooltipContainer = $("<div>").addClass("it-tooltip-content").html(group.tooltip).appendTo($el);
              $el.addClass("it-has-tooltip");
              $el.qtip({
                content: {
                  text: tooltipContainer
                },
                show: {
                  delay: 450
                },
                position: {
                  // se passe mal dès que la page est trop longue - mais a priori inutile donc on met en commentaire
                  //  container: $el.closest(".infini-table"),
                  my: 'top center',
                  at: 'bottom center',
                  adjust: {
                    y: 8
                  }
                },
                style: {
                  classes: 'qtip-it-header'
                }
              });
              $el.append('<i class="tooltip-info-icon fa fa-info-circle no-print"></i>');
            }
            headerCell.appendTo(headerGroupRow);
          });
        }

        // add header row cell
        headerCellLinker(columnScope, function (headerCell) {
          // FIX : Attacher l'élément au DOM (headerRow ou headerGroupRow) AVANT d'injecter le contenu via headerInjector.
          // Cela permet aux directives potentiellement présentes dans le template (comme it-header-cell) 
          // de trouver le contrôleur parent ^infiniTable lors de leur compilation.
          if (hasGroups && group == null) {
            headerCell.attr("rowspan", 2);
            headerCell.appendTo(headerGroupRow);
          } else {
            headerCell.appendTo(headerRow);
          }
          computed.headerInjector(headerCell, columnScope);
          if (column.headerClass) {
            headerCell.addClass(column.headerClass);
          }
          computed.headerCell = headerCell;
        });

        // add content header cell
        contentHeaderCellLinker(columnScope, function (contentHeaderCell) {
          // FIX : Attacher au DOM AVANT injection du contenu pour les mêmes raisons que ci-dessus.
          ui.contentHeadRow.append(contentHeaderCell);
          if (computed.sortable) {
            contentHeaderCell.addClass("it-sortable-column");
          }
          computed.headerInjector(contentHeaderCell, columnScope);
        });
      });
      var $scrollbarTh = $('<th class="scrollbar">').attr("rowspan", hasGroups ? 2 : 1);
      if (hasGroups) {
        $scrollbarTh.appendTo(headerGroupRow);
      } else {
        $scrollbarTh.appendTo(headerRow);
      }
      ui.contentHeadRow.append($('<th class="scrollbar">'));
      ui.contentHeadRow.hide();
    };
    var createHeadGroupRow = function createHeadGroupRow() {
      var headerGroupRowLinker = linkers.headerGroupRow;
      var headerGroupRow = null;
      headerGroupRowLinker($scope, function (_headerGroupRow) {
        headerGroupRow = _headerGroupRow;
        headerGroupRow.prependTo(ui.headTable.find('thead'));
      });
      return headerGroupRow;
    };
    var createHeadHeaderRow = function createHeadHeaderRow() {
      var headerRowLinker = linkers.headerRow;
      var headerRow = null;
      headerRowLinker($scope, function (_headerRow) {
        headerRow = _headerRow;
        headerRow.appendTo(ui.headTable.find('thead'));
      });
      return headerRow;
    };
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/common/itHeaderManager.js", __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 2799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Keyboard controls feature for InfiniTable.
 *
 * Enabled by default.
 */
ngModule.factory("itKeyboardControls", ["keyCodes", function (keyCodes) {
  return function (tableCtrl) {
    var controls = this,
      ctrl = tableCtrl,
      $el = tableCtrl.getElement(),
      $scope = tableCtrl.getScope();

    // keydown listener on the main table element.
    $el.keydown(function (event) {
      // get the handler map
      var keyHandlerMap = getKeyHandlerMap(); // TODO : only once per table configuration load.
      // get the handler. declared -> we execute it.
      var keyHandler = keyHandlerMap[event.which];
      if (keyHandler != null) {
        keyHandler(event, ctrl, $scope);
      }
    });
    function getKeyHandlerMap() {
      var handlerMap = {};

      // default key handlers
      handlerMap[keyCodes.UP] = upKeyDefaultHandler;
      handlerMap[keyCodes.DOWN] = downKeyDefaultHandler;
      handlerMap[keyCodes.PAGE_UP] = pageUpKeyDefaultHandler;
      handlerMap[keyCodes.PAGE_DOWN] = pageDownKeyDefaultHandler;

      // row selection key handlers
      var hasSelectionEnabled = tableCtrl.getConfig().allowSelection;
      if (hasSelectionEnabled) {
        handlerMap[keyCodes.UP] = upKeyRowSelectionHandler;
        handlerMap[keyCodes.DOWN] = downKeyRowSelectionHandler;
      }

      // tree key handlers
      var isTree = tableCtrl.getConfig().type === "tree";
      if (isTree) {
        handlerMap[keyCodes.LEFT] = leftKeyTreeHandler;
        handlerMap[keyCodes.RIGHT] = rightKeyTreeHandler;
      }
      return handlerMap;
    }
  };

  // default handlers

  function upKeyDefaultHandler(event, ctrl, $scope) {
    var scrolled = ctrl.scroll.offset(-1);
    if (scrolled) {
      event.preventDefault();
      $scope.$apply();
    }
  }
  function downKeyDefaultHandler(event, ctrl, $scope) {
    var scrolled = ctrl.scroll.offset(1);
    if (scrolled) {
      event.preventDefault();
      $scope.$apply();
    }
  }
  function pageUpKeyDefaultHandler(event, ctrl, $scope) {
    var scrolled = ctrl.scroll.pageUp();
    if (scrolled) {
      event.preventDefault();
      $scope.$apply();
    }
  }
  function pageDownKeyDefaultHandler(event, ctrl, $scope) {
    var scrolled = ctrl.scroll.pageDown();
    if (scrolled) {
      event.preventDefault();
      $scope.$apply();
    }
  }

  //// row selection handlers;

  function upKeyRowSelectionHandler(event, ctrl, $scope) {
    var selectionFeature = ctrl.getSelectionFeature();
    var selectionChanged = selectionFeature.selectPreviousRow();
    if (selectionChanged) {
      keepSelectionInTableScroll(ctrl);
      event.preventDefault();
      $scope.$apply();
    }
  }
  function downKeyRowSelectionHandler(event, ctrl, $scope) {
    var selectionFeature = ctrl.getSelectionFeature();
    var selectionChanged = selectionFeature.selectNextRow();
    if (selectionChanged) {
      keepSelectionInTableScroll(ctrl);
      event.preventDefault();
      $scope.$apply();
    }
  }
  function keepSelectionInTableScroll(ctrl) {
    var selectionIndex = ctrl.getSelectionFeature().getRowSelectionIndex(),
      pagination = ctrl.context.pagination,
      firstIdx = pagination.first,
      lastIdx = pagination.last;

    // console.log("key down ->", selectionIndex, firstIdx, lastIdx);

    if (selectionIndex < firstIdx) {
      ctrl.scroll.offset(-1);
    } else if (selectionIndex > lastIdx) {
      ctrl.scroll.offset(selectionIndex - lastIdx);
    }
  }

  //// tree handlers

  function leftKeyTreeHandler(event, ctrl, $scope) {
    var selectionFeature = ctrl.getSelectionFeature();
    if (!selectionFeature) return;
    var selectionIndex = selectionFeature.getRowSelectionIndex();
    if (selectionIndex === -1) return;
    var renderer = ctrl.getRenderer();
    var flattenedTree = renderer.getActualSource();
    var node = flattenedTree[selectionIndex];
    if (node && node.expanded && renderer.hasChildren(node)) {
      // Collapse the node
      renderer.collapseNode(node.nodeId);
      event.preventDefault();
      $scope.$apply();
    } else if (node && node.parent) {
      // Select parent
      var parentIndex = _.findIndex(flattenedTree, function (n) {
        return n.nodeId === node.parent.nodeId;
      });
      if (parentIndex !== -1) {
        selectionFeature.selectRow(parentIndex);
        keepSelectionInTableScroll(ctrl);
        event.preventDefault();
        $scope.$apply();
      }
    }
  }
  function rightKeyTreeHandler(event, ctrl, $scope) {
    var selectionFeature = ctrl.getSelectionFeature();
    if (!selectionFeature) return;
    var selectionIndex = selectionFeature.getRowSelectionIndex();
    if (selectionIndex === -1) return;
    var renderer = ctrl.getRenderer();
    var flattenedTree = renderer.getActualSource();
    var node = flattenedTree[selectionIndex];
    if (node && !node.expanded && renderer.hasChildren(node)) {
      // Expand the node
      renderer.expandNode(node.nodeId);
      event.preventDefault();
      $scope.$apply();
    }
  }
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/common/itKeyboardControls.js", __webpack_require__(1)))

/***/ }),
/* 2800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("itRenderingFn", function () {
  /**
   * Generator function for the table rendering fn.
   */
  return function renderingFnFactory(tableCtrl, renderer) {
    var getCurrentHeight = function getCurrentHeight() {
      return tableCtrl.ui.contentTable[0].clientHeight; // significantly faster than using jQuery
      // return tableCtrl.ui.contentTable.height();
    };

    /**
     * The main rendering method for infiniTable, standard and tree modes.
     *
     * Options :
     *      - index     : the index to start rendering at
     *      - initial   : true if it's the first rendering since datasource refresh
     *      - full      : if set to true, then it will print all the lines ( no scrolling ).
     *                    used for print for example
     */
    return function renderingFn(options) {
      // console.time("renderingFn");

      var displayedRows = renderer.getDisplayedRows(),
        oldRows = displayedRows.slice(0),
        actualLength = renderer.getActualLength(),
        dataSource = tableCtrl.getDataSource();

      // empty the currently displayed rows
      displayedRows.splice(0, displayedRows.length);

      // detaching old rows to empty the table
      for (var i = 0; i < oldRows.length; i++) {
        oldRows[i].detach();
      }

      // hyjacking when empty dataSource
      if (!dataSource || !actualLength) {
        return;
      }
      var fullMode = options.full /*|| true*/,
        index = fullMode ? 0 : options.index,
        initial = options.initial,
        rowContainer = tableCtrl.ui.contentBody,
        config = tableCtrl.getConfig(),
        firstIdx = fullMode ? 0 : index || 0,
        lastIdx,
        currentIdx = firstIdx,
        filled = false,
        availableHeight = tableCtrl.getAvailableBodyHeight(),
        nextRow;
      tableCtrl.ui.contentTable.css("height", "auto");
      if (firstIdx >= actualLength) {
        firstIdx = index = actualLength - 1;
      }

      // are we filling from the bottom ? aka is the last element of the table the active one ?
      var fromBottom = index > 0 && index === actualLength - 1;
      do {
        var row = renderer.getOrCreateRow(currentIdx);
        if (row !== undefined) {
          nextRow = row.appendTo(rowContainer).show();
          displayedRows.push(nextRow);
        } else {
          console.log('undefined row at ', currentIdx, tableCtrl);
        }
        if (!fullMode) {
          filled = getCurrentHeight() >= availableHeight;

          // initial draw -> we need to double check that column sizing is correct before assuming table is filled.
          if (initial && filled) {
            tableCtrl.refreshColumnsSizing();
            filled = getCurrentHeight() >= availableHeight;
          }
        }
        currentIdx++;
      } while (!filled && currentIdx < actualLength);
      lastIdx = currentIdx - 1;

      // not filled : we were at the end of the table. need to reverse fill when possible
      if (!filled && firstIdx > 0) {
        var previousRow;
        currentIdx = firstIdx - 1;
        do {
          previousRow = renderer.getOrCreateRow(currentIdx).prependTo(rowContainer).show();
          displayedRows.unshift(previousRow);
          filled = getCurrentHeight() >= availableHeight;
          currentIdx--;
        } while (!filled && currentIdx > -1);
        firstIdx = currentIdx + 1;
      }

      // if filled from bottom
      if (fromBottom) {
        var tableOffset = getCurrentHeight() - availableHeight;
        // si negatif, alors cela crée un décalge en haut, on ramène à 0 (à voir un jour avec PGA).
        if (tableOffset < 0) {
          tableOffset = 0;
        }
        tableCtrl.ui.contentTable.css({
          bottom: tableOffset + "px"
        });
      } else {
        tableCtrl.ui.contentTable.css({
          bottom: "0px"
        });
      }

      // // overflow : last row is only partially visible -> we remove it from the count for the pagination state
      var overflow = getCurrentHeight() > availableHeight;
      if (overflow) {
        if (fromBottom) {
          firstIdx += 1;
        } else {
          lastIdx -= 1;
        }
      }
      tableCtrl.context.pagination = {
        first: firstIdx,
        last: lastIdx,
        count: lastIdx - firstIdx + 1,
        total: actualLength,
        filled: filled,
        full: fullMode || firstIdx === 0 && lastIdx === actualLength - 1 && getCurrentHeight() <= availableHeight
      };

      // console.timeEnd("renderingFn");

      // console.log("rendered", firstIdx, lastIdx)

      // refresh scrollbar state
      tableCtrl.getScrollBar().refresh();
      tableCtrl.applyUsedHeight();
      tableCtrl.ui.contentTable.css("height", "100%");
      if (config.onScrollChange) {
        config.onScrollChange(tableCtrl.context.pagination, dataSource);
      }
    };
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/common/itRenderingFn.js"))

/***/ }),
/* 2801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("itRowPrecompiler", ["$window", "$rootScope", "itUtils", function ($window, $rootScope, itUtils) {
  return function (tableCtrl, renderer) {
    var rowManager = this,
      $scope = tableCtrl.getScope(),
      config,
      context,
      renderedRows,
      rowManagementIntervalId = null,
      rowPrecompilationQueue = [];
    var initialize = function initialize() {
      config = tableCtrl.getConfig();
      context = tableCtrl.getContext();
      renderedRows = renderer.getCompiledRows();
    };
    rowManager.start = function () {
      initialize();
      rowPrecompilationQueue = null;
      rowManagementIntervalId = $window.setInterval(rowManagementCycle, config.rowManagementCycleInterval);
    };
    rowManager.stop = function () {
      $window.clearInterval(rowManagementIntervalId);
      rowManagementIntervalId = null;
    };
    rowManager.reset = function () {
      rowManager.stop();
      rowManager.start();
    };
    var rowManagementCycle = function rowManagementCycle() {
      if (rowPrecompilationQueue == null) {
        rowPrecompilationQueue = computePrecompilationQueue();
      }

      // console.log("precompute list = ", rowPrecompilationQueue);

      if (rowPrecompilationQueue.length) {
        var count = 0;
        do {
          precompileNextRow();
        } while (rowPrecompilationQueue.length && ++count < config.rowPerManagementCycle);
      } else {
        var watcherCount = itUtils.countWatchers(config.countRootWatchers ? $rootScope : $scope);

        // console.log("cleanup : watcher count = ", watcherCount);

        if (watcherCount > config.maxWatchers) {
          removeNextUnusedRows();
        } else {
          rowManager.stop();
        }
      }
    };
    var computePrecompilationQueue = function computePrecompilationQueue() {
      var pagination = context.pagination;
      if (!pagination.filled) {
        return [];
      }
      var precompilationList = [];
      var pageCount = config.preloadedPageCount;
      var rowCount = pageCount * pagination.count;
      var nextIdx = pagination.last + 1;
      var i = 0;
      while (nextIdx < pagination.total && i < rowCount) {
        if (renderedRows[nextIdx] == null) {
          precompilationList.push(nextIdx);
        }
        nextIdx++;
        i++;
      }

      // TODO : also add previous pages

      return precompilationList;
    };
    var removeNextUnusedRows = function removeNextUnusedRows() {
      var pagination = context.pagination,
        pageCount = config.preloadedPageCount,
        rowCount = pageCount * pagination.count;
      var firstIdx = Math.max(pagination.first - rowCount, 0);
      var lastIdx = Math.min(pagination.last + rowCount, pagination.total - 1);

      // console.log("dont touch from " + firstIdx + " to " + lastIdx);

      var removalCount = 0;
      for (var i = 0; i < renderedRows.length; i++) {
        if (i >= firstIdx && i <= lastIdx) {
          continue;
        }
        if (renderedRows[i] != null) {
          renderer.deleteRow(i);
          removalCount++;
        }
        if (removalCount >= config.rowPerManagementCycle) {
          break;
        }
      }
    };
    var precompileNextRow = function precompileNextRow() {
      var nextId = rowPrecompilationQueue[0];
      renderer.createRow(nextId, true);
      rowPrecompilationQueue.shift();
    };
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/common/itRowPrecompiler.js"))

/***/ }),
/* 2802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Row selection feature for InfiniTable.
 *
 * Enable via allowSelection : true if the configuration.
 *
 * Properties :
 *      - allowSelection [true/false] set to true to enable feature.
 *      - selectionAttribute
 *      - selectionScope
 */
ngModule.factory("itRowSelectionFeature", ["itUtils", function (itUtils) {
  return function itRowSelectionFeature(tableCtrl) {
    var feature = this,
      ctrl = tableCtrl,
      $scope = tableCtrl.getScope(),
      rowSelection = null,
      selectionScope = null,
      selectionAccessor = null;
    feature.enable = function () {
      initializeRowSelection();
    };
    feature.getRowSelection = function () {
      return rowSelection;
    };
    feature.getRowSelectionIndex = function () {
      var renderer = ctrl.getRenderer(),
        dataSource = renderer.getActualSource(),
        rowSelection = feature.getRowSelection();
      var actualIdx = _.indexOf(dataSource, rowSelection);
      // pour les tree
      if (actualIdx === -1 && rowSelection && ctrl.getConfig().type === 'tree') {
        var idx = 0;
        _.each(dataSource, function (d) {
          if (d.nodeId && rowSelection.nodeId && d.nodeId === rowSelection.nodeId || d.model === rowSelection) {
            actualIdx = idx;
          }
          idx++;
        });
      }
      return actualIdx;
    };
    feature.selectRow = function (idx) {
      // todo : or model ?
      var renderer = ctrl.getRenderer(),
        dataSource = renderer.getActualSource();
      setSelectedModel(dataSource[idx]);
    };
    feature.selectNextRow = function () {
      var renderer = ctrl.getRenderer(),
        dataSource = renderer.getActualSource(),
        actualIdx = _.indexOf(dataSource, rowSelection);

      // pour les tree
      if (actualIdx === -1 && ctrl.getConfig().type === 'tree') {
        var idx = 0;
        _.each(dataSource, function (d) {
          if (d.nodeId === rowSelection.nodeId
          // necessaire car le click met directement le model
          || d.model === rowSelection) {
            actualIdx = idx;
          }
          idx++;
        });
      }
      if (actualIdx < dataSource.length - 1) {
        setSelectedModel(dataSource[actualIdx + 1]);
        return true;
      } else {
        return false;
      }
    };
    feature.selectPreviousRow = function () {
      var renderer = ctrl.getRenderer(),
        dataSource = renderer.getActualSource(),
        actualIdx = _.indexOf(dataSource, rowSelection);

      // pour les tree
      if (actualIdx === -1 && ctrl.getConfig().type === 'tree') {
        var idx = 0;
        _.each(dataSource, function (d) {
          if (d.nodeId === rowSelection.nodeId
          // necessaire car le click met directement le model
          || d.model === rowSelection) {
            actualIdx = idx;
          }
          idx++;
        });
      }
      if (actualIdx > 0) {
        setSelectedModel(dataSource[actualIdx - 1]);
        return true;
      } else {
        return false;
      }
    };
    function setSelectedModel(model) {
      rowSelection = model;
      selectionAccessor(model);
    }

    // TODO : feature.disable

    function initializeRowSelection() {
      var config = ctrl.getConfig();
      selectionScope = config.selectionScope || $scope.$parent;
      if (!config.selectionAttribute) {
        console.error('pas de selectionAttribute de défini sur la configuration', config);
        // on en défini un par defaut pour que la selection des lignes fonctionne quand meme.
        config.selectionAttribute = "defautSelectionAttribute";
      }
      selectionAccessor = itUtils.createAccessor(selectionScope, config.selectionAttribute);

      // initialize the selection row value in case of preselection
      rowSelection = selectionAccessor();

      // click on a row -> we select the row.
      ctrl.ui.contentBody.delegate("tr", "click", function (event) {
        var row = $(event.currentTarget);
        var model = row.scope().model;
        selectionScope.$apply(function () {
          var currentSelection = selectionAccessor();
          if (currentSelection === model) {
            // TODO : apply probably useless in that case.
            return;
          }
          if (config.type === 'tree') {
            var renderer = ctrl.getRenderer(),
              dataSource = renderer.getActualSource();
            _.each(dataSource, function (d) {
              if (d.model === model) {
                model = d.model;
              }
            });
          }
          selectionAccessor(model);
        });
      });
      $scope.$watch(function () {
        return selectionAccessor();
      }, function (selection) {
        rowSelection = selection;
      });

      /**
       * Wire a getter for this feature on the table controller.
       */
      ctrl.getSelectionFeature = function () {
        return feature;
      };

      /**
       * Returns the currently selected row model.
       */
      ctrl.getRowSelection = function () {
        return rowSelection;
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/common/itRowSelectionFeature.js", __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 2803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * IT Scrollbar
 */
ngModule.directive('itScrollbar', ["$window", function ($window) {
  return {
    restrict: "EA",
    scope: true,
    require: ["itScrollbar", "^infiniTable"],
    replace: true,
    template: '<div class="it-scrollbar">' + '   <div class="it-sb-btn it-sb-btn-up">&#9650;</div>' + '   <div class="it-sb-track">' + '       <div class="it-sb-thumb"></div>' + '   </div>' + '   <div class="it-sb-btn it-sb-btn-down">&#9660;</div>' + '</div>',
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0];
      var tableCtrl = controllers[1];
      tableCtrl.$setScrollbarCtrl(ctrl);
      ctrl.$setTableCtrl(tableCtrl);
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        computed = false,
        context = null,
        isDragging = false,
        tableCtrl = null,
        $el = $element;
      var btnUp = $el.find(".it-sb-btn-up"),
        track = $el.find(".it-sb-track"),
        thumb = $el.find(".it-sb-thumb"),
        btnDown = $el.find(".it-sb-btn-down");
      ctrl.$setTableCtrl = function (_tableCtrl) {
        tableCtrl = _tableCtrl;
        context = tableCtrl.getContext();
      };
      ctrl.hide = function () {
        $el.hide();
      };
      ctrl.show = function () {
        $el.show();
      };
      var trackHeight = null,
        thumbHeight = null;
      var computeHeights = function computeHeights() {
        var config = tableCtrl.getConfig();

        // track

        trackHeight = track.innerHeight();

        // thumb

        var ratio = context.pagination.count / tableCtrl.getRenderer().getActualLength();
        thumbHeight = Math.floor(trackHeight * ratio);
        if (config.scrollbarThumbMinHeight && config.scrollbarThumbMinHeight > thumbHeight) {
          thumbHeight = config.scrollbarThumbMinHeight;
        }
        if (config.scrollbarThumbMaxHeight && config.scrollbarThumbMaxHeight < thumbHeight) {
          thumbHeight = config.scrollbarThumbMaxHeight;
        }
        thumb.height(thumbHeight);
        computed = true;
      };
      ctrl.refresh = function (recompute) {
        if (recompute || !computed) {
          computeHeights();
        }
        var pagination = context.pagination;

        // thumb position
        if (!isDragging) {
          var height = trackHeight - thumbHeight;
          var percentage = pagination.first / (pagination.total - pagination.count);
          var offset = height * percentage;
          setThumbPosition(offset);
        }

        // thumb
        if (pagination.filled) {
          thumb.show();
        } else {
          thumb.hide();
        }

        // btn up
        if (pagination.first === 0) {
          btnUp.addClass("disabled");
        } else {
          btnUp.removeClass("disabled");
        }

        // btn down
        if (pagination.last === pagination.total - 1) {
          btnDown.addClass("disabled");
        } else {
          btnDown.removeClass("disabled");
        }
      };

      // thumb dragging

      var setThumbPosition = function setThumbPosition(pos) {
        thumb.css({
          top: pos
        });
      };
      thumb.draggable({
        containment: "parent",
        axis: "y",
        start: function start(e, ui) {
          isDragging = true;
        },
        drag: function drag(e, ui) {
          var offset = ui.position.top;
          var height = track.innerHeight() - thumb.height();
          var percentage = offset * 100 / height;
          $scope.$apply(function () {
            tableCtrl.scroll.toPercent(percentage);
          });
        },
        stop: function stop(e) {
          isDragging = false;
        }
      });

      // track click

      track.mousedown(function (event) {
        if (thumb.is(event.target)) {
          return;
        }
        var intervalId;
        var clickOffset = event.offsetY;
        var thumbPosition = thumb.position().top;
        var reverse = thumbPosition > clickOffset;
        var clearInterval = function clearInterval() {
          $window.clearInterval(intervalId);
        };
        var scrollPage = function scrollPage() {
          $scope.$apply(function () {
            reverse ? tableCtrl.scroll.pageUp() : tableCtrl.scroll.pageDown();
          });
        };
        var _mouseUpHandler = function mouseUpHandler() {
          clearInterval();
          $($window).unbind("mouseup", _mouseUpHandler);
        };
        scrollPage();
        intervalId = $window.setInterval(function () {
          thumbPosition = thumb.position().top;
          if (reverse ? thumbPosition < clickOffset : thumbPosition > clickOffset) {
            _mouseUpHandler();
            return;
          }
          scrollPage();
        }, 100);
        $($window).mouseup(_mouseUpHandler);
      });

      // btnUp / btnDown click

      var initIntervalScroll = function initIntervalScroll(reverse) {
        var intervalId;
        var clearInterval = function clearInterval() {
          $window.clearInterval(intervalId);
        };
        var scrollTick = function scrollTick() {
          $scope.$apply(function () {
            tableCtrl.scroll.offset(reverse ? -1 : 1);
          });
        };
        var startIntervalScroll = function startIntervalScroll() {
          scrollTick();
          intervalId = $window.setInterval(function () {
            scrollTick();
          }, 100);
        };
        var _mouseUpHandler2 = function mouseUpHandler() {
          clearInterval();
          $($window).unbind("mouseup", _mouseUpHandler2);
        };
        return function () {
          startIntervalScroll();
          $($window).mouseup(_mouseUpHandler2);
        };
      };
      btnUp.mousedown(initIntervalScroll(true));
      btnDown.mousedown(initIntervalScroll(false));
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/common/itScrollbar.js", __webpack_require__(4)))

/***/ }),
/* 2804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("itSortFactory", ["objectUtils", "sortUtils", function (objectUtils, sortUtils) {
  // TODO : registry to add comparators

  var comparators = {
    boolean: sortUtils.booleanComparatorBuilder,
    string: sortUtils.stringComparatorBuilder,
    alphanum: sortUtils.alphanumCompartorBuilder,
    number: sortUtils.numberComparatorBuilder,
    montant: sortUtils.montantComparatorBuilder,
    taux: sortUtils.montantComparatorBuilder,
    date: sortUtils.dateComparatorBuilder
  };
  return {
    /**
     * s'appuie sur column.sortType || column.dataType (ou par défaut string) qui peut etre une fonction de tri ou le nom d'un comparateur
     * @param column qui doit avoir un champs attribute pour construire la methode d'accès (ou un autre champs infiqué par le parametre attribute)
     * @param attribute optionnel, si non renseigné utilise column.attribute
     * @returns un comparator auquel passer en parametre des lignes
     */
    getColumnComparator: function getColumnComparator(column, attribute) {
      var typeOrFunc = column.sortType || column.dataType || "string";
      var sortMethod;
      if (_.isFunction(typeOrFunc)) {
        sortMethod = typeOrFunc;
      } else {
        var comparatorBuilder = comparators[typeOrFunc];
        sortMethod = comparatorBuilder(attribute || column.attribute);
      }
      return sortMethod;
    },
    sort: function sort(dataSource, column, reverse) {
      if (dataSource == null) {
        return;
      }

      // TODO : try to add type autodetect guess dataType using first element data ?

      var typeOrFunc = column.sortType || column.dataType || "string";
      var sortMethod;
      if (_.isFunction(typeOrFunc)) {
        sortMethod = typeOrFunc;
      } else {
        var comparatorBuilder = comparators[typeOrFunc];
        sortMethod = comparatorBuilder(column.attribute);
      }
      try {
        dataSource.sort(sortMethod);
      } catch (err) {
        throw new Error("Impossible de trier la colonne " + JSON.stringify(column) + ", vérifiez que vous avez un attribute non null et sortType correctement défini : " + err.message, err);
      }
      if (reverse) {
        dataSource.reverse();
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/common/itSortFactory.js", __webpack_require__(1)))

/***/ }),
/* 2805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("itTableRegistry", function () {
  var registryMap = {};
  var registry = {
    /**
     * Register the table to the registry.
     *
     * @returns {Function} unregistering function
     */
    register: function register(tableId, tableCtrl) {
      if (_.includes(registryMap, tableId)) {
        throw "Table already registered for id " + tableId + ". is there a naming conflict ?";
      }
      registryMap[tableId] = tableCtrl;
      return function () {
        registry.unregister(tableId);
      };
    },
    /**
     * Get API controller for given table
     *
     * @param tableId
     */
    getController: function getController(tableId) {
      return registryMap[tableId];
    },
    /**
     * Unregister given table.
     */
    unregister: function unregister(tableId) {
      delete registryMap[tableId];
    }
  };
  return registry;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/common/itTableRegistry.js", __webpack_require__(1)))

/***/ }),
/* 2806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("itUtils", ["$parse", function ($parse) {
  var itUtils = {
    /**
     * Creates an accessor method to get or set given property on given scope.
     *
     * @param {Scope} scope : Scope to create accessor for
     * @param {String} propertyName : Name of the property to create accessor of.
     */
    createAccessor: function createAccessor(scope, propertyName) {
      var getter = $parse(propertyName);
      if (getter == null) {
        console.error("createAccessor : impossible de creer un getter pour propertyName : " + propertyName);
      }
      var setter = getter.assign;
      return function (value) {
        if (arguments.length) {
          return setter(scope, value);
        } else {
          return getter(scope);
        }
      };
    },
    /**
     * Count the watchers attached to a scope tree.
     *
     * @param scope The scope to count watchers of.
     * @returns {number} The number of watchers actually attach to given scope and children.
     */
    countWatchers: function countWatchers(scope) {
      var watchers = 0;
      itUtils.traverseScopeTree(scope, function (scope) {
        if (scope.$$watchers) {
          watchers += scope.$$watchers.length;
        }
      });
      return watchers;
    },
    /**
     * Apply watchers of given scope even if a digest progress is already in process on another level.
     * This will only do a one-time cycle of watchers, without cascade digest.
     *
     * Please note that this is (almost) a hack, behaviour may be hazardous so please use with caution.
     *
     * @param {Scope} scope : scope to apply watchers from.
     */
    applyWatchers: function applyWatchers(scope) {
      itUtils.traverseScopeTree(scope, function (scope) {
        var watchers = scope.$$watchers;
        if (!watchers) {
          return;
        }
        var watcher;
        for (var i = 0; i < watchers.length; i++) {
          watcher = watchers[i];
          var value = watcher.get(scope);
          watcher.fn(value, value, scope);
        }
      });
    },
    /**
     * Traverse given scope and all of the scope children tree, calling given function for each scope.
     * @param parentScope
     * @param traverseFn The function executed for each scope, having the scope as only parameter.
     */
    traverseScopeTree: function traverseScopeTree(parentScope, traverseFn) {
      var next,
        current = parentScope,
        target = parentScope;
      do {
        traverseFn(current);
        if (!(next = current.$$childHead || current !== target && current.$$nextSibling)) {
          while (current !== target && !(next = current.$$nextSibling)) {
            current = current.$parent;
          }
        }
      } while (current = next);
    },
    /**
     * Aliases for common keyboard key codes
     */
    keyCodes: {
      BACKSPACE: 8,
      COMMA: 188,
      DELETE: 46,
      DOWN: 40,
      END: 35,
      ENTER: 13,
      ESCAPE: 27,
      HOME: 36,
      LEFT: 37,
      NUMPAD_ADD: 107,
      NUMPAD_DECIMAL: 110,
      NUMPAD_DIVIDE: 111,
      NUMPAD_ENTER: 108,
      NUMPAD_MULTIPLY: 106,
      NUMPAD_SUBTRACT: 109,
      PAGE_DOWN: 34,
      PAGE_UP: 33,
      PERIOD: 190,
      RIGHT: 39,
      SPACE: 32,
      TAB: 9,
      UP: 38
    }
  };
  return itUtils;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/common/itUtils.js"))

/***/ }),
/* 2807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("itColumnSelector", ["itTableRegistry", function (itTableRegistry) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    controllerAs: "selectorCtrl",
    template: __webpack_require__(3691),
    link: function link($scope, $el, $attrs, ctrl) {
      if ($attrs.xlsUrl) {
        $scope.xlsUrl = $attrs.xlsUrl;
        // post
        $scope.xlsPostMethod = $attrs.xlsMethod === 'post';
      }
      if ($attrs.docx) {
        $scope.docx = true;
      }
      $attrs.$observe("tableId", function (tableId) {
        var unwatch = $scope.$watch(function () {
          return itTableRegistry.getController(tableId);
        }, function (tableController) {
          if (!tableController) {
            return;
          }
          unwatch();
          ctrl.setTableController(tableController);
        });
      });
    },
    controller: ["$scope", "xlsMetadataService", function controller($scope, xlsMetadataService) {
      var ctrl = this,
        tableCtrl = null;
      $scope.menuOpened = false;
      $scope.columnGroups = [];
      $scope.xlsMetadata = function () {
        console.log('xlsMetadata', $scope.xlsUrl, $scope.xlsPostMethod);
        xlsMetadataService.openMetadataPopin($scope.xlsUrl, $scope.xlsPostMethod, null, false, !$scope.docx).then(function () {});
      };
      ctrl.setTableController = function (_tableCtrl) {
        tableCtrl = _tableCtrl;
        $scope.columnGroups = tableCtrl.getColumnGroups(); // TODO : watch ?
        $scope.isResizable = tableCtrl.getConfig() && tableCtrl.getConfig().resizable === true;
        $scope.isReorderable = tableCtrl.getConfig() && tableCtrl.getConfig().reorderable === true;
      };
      $scope.toggleMenu = function () {
        $scope.menuOpened = !$scope.menuOpened;
      };
      $scope.toggleGroup = function (group) {
        tableCtrl.setGroupVisibility(group.id, !$scope.isGroupVisible(group));
      };
      $scope.resetColumnsSize = function () {
        if (tableCtrl && tableCtrl.resetColumnsSize) {
          tableCtrl.resetColumnsSize();
        }
      };
      $scope.resetColumnsOrder = function () {
        if (tableCtrl && tableCtrl.resetColumnsOrder) {
          tableCtrl.resetColumnsOrder();
        }
      };
      $scope.isGroupVisible = function (group) {
        var visibilityMap = tableCtrl.getColumnsVisibility();
        for (var i = 0; i < group.columns.length; i++) {
          if (visibilityMap[group.columns[i]] === false) {
            return false;
          }
        }
        return true;
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/components/itColumnSelector.js"))

/***/ }),
/* 2808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * bouton pour grouper/degrouper suivant une colonne + cache la colonne de groupement quand groupé
 * Il s'agit d'une version simplifiée qui marche dans le contexte du porfeuille de subvention. A méliorer pour généraliser (etat du bouton, colonne affichée, cachée, ...)
 */
ngModule.directive("itSubtotalButton", ["itTableRegistry", function (itTableRegistry) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    controllerAs: "selectorCtrl",
    template: __webpack_require__(3692),
    link: function link($scope, $el, $attrs, ctrl) {
      if ($attrs.subtotalGroup) {
        // id de la colonne
        $scope.column = $attrs.subtotalGroup;
      } else {
        console.error("Il manque un attribut subtotal-group à it-subtotal-button");
      }
      if ($attrs.groupLabel) {
        $scope.groupLabel = $attrs.groupLabel;
      } else {
        $scope.groupLabel = "Grouper";
      }
      if ($attrs.ungroupLabel) {
        $scope.ungroupLabel = $attrs.ungroupLabel;
      } else {
        $scope.ungroupLabel = "Dégrouper";
      }

      // initialisé par un watch sur le context
      $scope.group = null;
      $attrs.$observe("tableId", function (tableId) {
        var unwatch = $scope.$watch(function () {
          return itTableRegistry.getController(tableId);
        }, function (tableController) {
          if (!tableController) {
            return;
          }
          unwatch();
          ctrl.setTableController(tableController);
        });
      });
    },
    controller: ["$scope", "xlsMetadataService", function controller($scope, xlsMetadataService) {
      var ctrl = this,
        tableCtrl = null;
      ctrl.setTableController = function (_tableCtrl) {
        tableCtrl = _tableCtrl;
        $scope.$watch(function () {
          return tableCtrl.getContext().subtotal;
        }, function (subtotal) {
          if (subtotal == null) {
            $scope.group = false;
          } else {
            $scope.group = subtotal.column === $scope.column;
          }
        }, true);
      };
      function isSortColumn(context, column) {
        return context.sort.column === (_.isNumber(context.sort.column) ? column.index : column.id);
      }
      $scope.click = function (event) {
        if (!tableCtrl) {
          console.error("Pas de table controller disponible ");
        }
        var currentGroup = $scope.group;
        var column = tableCtrl.findColumnByIndexOrId($scope.column);
        tableCtrl.subTotalBy(column.id || column.index);

        // ne stock pas le tri lié au sous total
        tableCtrl.sortBy(column.id || column.index, isSortColumn(tableCtrl.getContext(), column) ? tableCtrl.getContext().sort.desc : false, {
          //  silent:true
          //, noContextUpdate:true
        });

        // on cache la colonne si on est en groupé.
        tableCtrl.toggleColumnVisibility($scope.column, currentGroup);
        tableCtrl.refreshColumnsSizing();
        tableCtrl.refreshContent();

        //$scope.group = !$scope.group;

        // todo - utile ?
        _.delay(function () {
          $scope.$broadcast("$redraw");
          $scope.$apply();
        }, 200);
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/components/subtotalButton/itSubtotalButton.js", __webpack_require__(1)))

/***/ }),
/* 2809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, angular, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/*

--- TODO :

- row selection
    - improve system to remove per-row watch
    - implement allowUnselect
    - implement multipleSelection

- sorting
    - clean itSortFactory
    - custom sorting function
    - add sortAttribute
    - check if sortType exists and warn if not

- allow smarter way to select a row than with the onRowClick handler
- allow to disable scroll mode ( more gracefully than with width : 1000000px ... )
- pagination mode ?
- column sizing with minWidth / width / maxWidth approach ?
- optimise rendering
- regroup config option in sub objects
- add tests
- massive cleanup
- remove console.log's

 */

ngModule.directive('infiniTable', ["$debounce", "keyCodes", "itKeyboardControls", "itTableRegistry", function ($debounce, keyCodes, itKeyboardControls, itTableRegistry) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    controllerAs: "$tableCtrl",
    template: '' + '<div class="infini-table" tabindex="0">' + '   <div class="it-head">' + '       <table class="it-head-table">' + '           <colgroup></colgroup>' + '           <thead></thead>' + '       </table>' + '   </div>' + '   <div class="it-body">' + '       <div class="it-scroll-container" style="height:100%; width:100%; overflow:hidden;">' + '           <table class="it-body-table">' + '               <colgroup></colgroup>' + '               <thead>' + '                   <tr></tr>' + '               </thead>' + '               <tbody></tbody>' + '               <tfoot></tfoot>' + '           </table>' + '       </div>' + '       <div it-scrollbar></div>' + '   </div>' + '   <div class="it-foot">' + '       <table class="it-foot-table">' + '           <colgroup></colgroup>' + '           <tfoot></tfoot>' + '       </table>' + '   </div>' + '   <div class="it-horizontal-scroll" style="overflow-x: auto; overflow-y: hidden; height: 14px; display: none;">' + '       <div class="it-horizontal-scroll-content" style="height: 1px;"></div>' + '   </div>' + '</div>',
    link: function link($scope, $el, $attrs, ctrl) {
      var unwatchConfig, unwatchSource, unregisterTable;
      $attrs.$observe("tableConfig", function (tableConfigPropName) {
        initializeTableEvent();
        unwatchConfig = $scope.$parent.$watch(tableConfigPropName, function (tableConfig) {
          if (tableConfig == null) {
            return;
          }
          setTableConfig(tableConfig);
        });
      });
      var setTableConfig = function setTableConfig(config) {
        if (!config.id) {
          config.generatedId = true;
          config.id = _.uniqueId("infiniTable-");
        }
        ctrl.initializeTable(config);

        // unregister if required (reload) then register to the global table registry
        unregisterTable && unregisterTable();
        unregisterTable = itTableRegistry.register(config.id, ctrl);

        // stop previous source watcher if exists;
        unwatchSource && unwatchSource();

        // watch & observe dataSource
        unwatchSource = $scope.$parent.$watch(config.source, function (dataSource) {
          if (!dataSource) {
            return;
          }
          ctrl.setDatasource(dataSource);
        });
      };
      var initializeTableEvent = function initializeTableEvent() {
        // mousewheel scroll
        $el.mousewheel(function (event) {
          $scope.$apply(function () {
            var deltaY = event.deltaY;
            var deltaX = event.deltaX;
            if (deltaY !== 0) {
              var scrolled = ctrl.scroll.offset(deltaY > 0 ? -1 : 1);
              if (scrolled) {
                event.preventDefault();
              }
            }
            if (deltaX !== 0) {
              var horizontalScroll = ctrl.ui.horizontalScroll;
              if (horizontalScroll.is(':visible')) {
                var currentLeft = horizontalScroll.scrollLeft();
                var factor = event.deltaFactor || 20;
                horizontalScroll.scrollLeft(currentLeft + deltaX * factor);
                if (horizontalScroll.scrollLeft() !== currentLeft) {
                  event.preventDefault();
                }
              }
            }
          });
        });

        // keypress listener
        var keyboardControls = new itKeyboardControls(ctrl);

        /*
        var debouncedColumnSizing = $debounce(function() {
            ctrl.refreshColumnsSizing();
        }, 100);
         $scope.$on("$resize:required", debouncedColumnSizing);
        */
      };

      // ctrl cleanup on $destroy
      $scope.$on("$destroy", function () {
        ctrl.dispose();
        unregisterTable && unregisterTable();
        unwatchConfig && unwatchConfig();
        unwatchSource && unwatchSource();
      });
      $scope.$on("$resize", function () {
        ctrl.onResize();
      });
      $scope.$on("$redraw", function () {
        ctrl.refreshColumnsSizing();
      });
    },
    controller: "InfiniTableController"
  };
}]);
ngModule.controller("InfiniTableController", ["$scope", "$element", "$injector", "itFooterManager", "itSortFactory", "itCompiler", "itHeaderManager", "itRowSelectionFeature", "infiniTableConfigManager", "itFooterAccumulator", "UUID", function ($scope, $element, $injector, itFooterManager, itSortFactory, itCompiler, itHeaderManager, itRowSelectionFeature, infiniTableConfigManager, itFooterAccumulator, UUID) {
  var ctrl = this;
  var stateManager = infiniTableConfigManager.getTableStateManager();

  // Accessors
  ctrl.getContext = function () {
    return context;
  };
  ctrl.getConfig = function () {
    return config;
  };
  ctrl.getScope = function () {
    return $scope;
  };
  ctrl.getElement = function () {
    return $element;
  };
  ctrl.getDataSource = function () {
    return dataSource;
  };
  ctrl.getRenderer = function () {
    return renderer;
  };
  ctrl.getCompiler = function () {
    return compiler;
  };
  ctrl.getScrollBar = function () {
    return scrollbar;
  };
  ctrl.linkers = {};
  var renderer,
    dataSource = [],
    autoresize = true,
    fullMode = false,
    config,
    scrollbar,
    /*
    true si affichage de la scrollbar horizontale
     */
    horizontalScrollbar,
    context = ctrl.context = {
      pagination: {},
      footerValues: {},
      sort: {}
    },
    ui = ctrl.ui = {
      table: $element,
      // head
      headDiv: $element.find(".it-head"),
      headTable: $element.find(".it-head table"),
      headColgroup: $element.find(".it-head table colgroup"),
      // content
      contentDiv: $element.find(".it-body"),
      contentScrollContainer: $element.find(".it-body .it-scroll-container"),
      contentTable: $element.find(".it-body table"),
      contentColgroup: $element.find(".it-body table colgroup"),
      contentHead: $element.find(".it-body table thead"),
      contentHeadRow: $element.find(".it-body table thead tr"),
      contentBody: $element.find(".it-body table tbody"),
      contentFoot: $element.find(".it-body table tfoot"),
      // footer
      footerDiv: $element.find(".it-foot"),
      footerTable: $element.find(".it-foot table"),
      footerColgroup: $element.find(".it-foot table colgroup"),
      // horizontal scroll
      horizontalScroll: $element.find(".it-horizontal-scroll"),
      horizontalScrollContent: $element.find(".it-horizontal-scroll-content")
    },
    compiler = ctrl.compiler = new itCompiler(ctrl),
    headerCtrl = new itHeaderManager(ctrl),
    footerCtrl = new itFooterManager(ctrl);
  var hasVisibilityManager = false,
    unbindVisibilityHandler = null,
    renderRequired = false,
    recomputeRequired = false;
  var tableState = null,
    isStateManaged = false;
  var autoScrollRaf = null,
    autoScrollSpeed = 0;
  function stopAutoScroll() {
    if (autoScrollRaf) {
      cancelAnimationFrame(autoScrollRaf);
      autoScrollRaf = null;
    }
    autoScrollSpeed = 0;
  }
  function onVisibilityChange(visible) {
    if (visible) {
      if (renderRequired) {
        setScrollPosition(lastScrollOptions);
        renderRequired = false;
      }
      if (recomputeRequired) {
        computeColumnSizing();
        recomputeRequired = false;
      }
      scrollbar.refresh(true);
    }
  }
  ctrl.isVisible = function () {
    if (hasVisibilityManager) {
      return config.visibilityManager.isVisible();
    } else {
      return true;
    }
  };
  ctrl.initializeTable = function (tableConfig) {
    if (unbindVisibilityHandler != null) {
      unbindVisibilityHandler();
    }
    if (renderer != null) {
      renderer.clearContent();
    }
    var tableType = tableConfig.type || "table";
    var rendererName = tableType === "tree" ? "itTreeRenderer" : "itTableRenderer";
    var rendererClass = $injector.get(rendererName);
    renderer = new rendererClass(ctrl);
    config = renderer.processConfiguration(tableConfig);

    // Add stickyColumnsCount to config
    config.stickyColumnsCount = tableConfig.stickyColumnsCount || 0;
    if (tableConfig.fullMode != null) {
      fullMode = tableConfig.fullMode;
    }

    // Ensure every column has a unique ID
    var usedIds = [];
    var _ensureIds = function ensureIds(cols) {
      _.each(cols, function (col, i) {
        if (col.group || col.columns) {
          if (!col.id) {
            var baseId = col.title ? 'group-' + col.title : 'group-' + i;
            var id = baseId;
            var ext = 0;
            while (usedIds.indexOf(id) > -1) {
              id = baseId + '-' + ext++;
            }
            col.id = id;
          }
          usedIds.push(col.id);
          _ensureIds(col.columns);
        } else {
          if (!col.id) {
            var _baseId = col.attribute ? 'col-' + col.attribute : 'col-' + i;
            var _id = _baseId;
            var _ext = 0;
            while (usedIds.indexOf(_id) > -1) {
              _id = _baseId + '-' + _ext++;
            }
            col.id = _id;
          }
          usedIds.push(col.id);
        }
      });
    };
    _ensureIds(config.columns);

    // Sauvegarde de la configuration originale des colonnes (ordre et largeurs)
    config.originalColumns = angular.copy(config.columns);
    config.originalWidths = {};
    var _collectOriginalWidths = function collectOriginalWidths(cols) {
      _.each(cols, function (col) {
        if (col.group || col.columns) {
          _collectOriginalWidths(col.columns);
        } else {
          config.originalWidths[col.id] = col.width;
        }
      });
    };
    _collectOriginalWidths(config.columns);

    // state manager
    if (config.stateManager != null) {
      stateManager = config.stateManager;
    }
    isStateManaged = stateManager.handleConfig(config);
    if (isStateManaged) {
      tableState = stateManager.getTableState(config.id);
    }
    if (tableState != null) {
      applyStateToConfig();
    }

    // defaut - si columnGroups alors par defaut à true, sinon à defaut à false
    horizontalScrollbar = config.columnGroups && config.columnGroups.length > 0;
    console.log('horizontalScrollbar', horizontalScrollbar, config);

    // active le "scroll horizontal" quand on a trop de colonnes affichées.
    if (config.horizontalScroll === true) {
      horizontalScrollbar = true;
    } else if (config.horizontalScroll === false) {
      horizontalScrollbar = false;
    }

    // visibility manager
    hasVisibilityManager = config.visibilityManager != null;
    if (hasVisibilityManager) {
      unbindVisibilityHandler = config.visibilityManager.onVisibilityChange(onVisibilityChange);
    }
    context.footerValues = {};
    compiler.compileTemplates();
    computeColumns(true);
    initializeHeaderAndFooter();
    initializeRowEvents(); // TODO : undelegate before re-applying (for config change / reload)

    if (config.allowSelection) {
      // TODO : undelegate before re-applying (for config change / reload)
      var rowSelectionFeature = new itRowSelectionFeature(ctrl);
      rowSelectionFeature.enable();
    }

    // PGA : the test is used for external height managers. // TODO : allow to enable / disable
    if (context.maxHeight == null) {
      ctrl.setHeight(config.height);
    }
  };
  function applyStateToConfig() {
    // ordre initial des colonnes
    if (tableState.columnsOrder != null && tableState.columnsOrder.length > 0) {
      config.columns = reorderColumnsWithSavedOrder(config.columns, tableState.columnsOrder);
    }

    // visibilité initiale des colonnes

    if (tableState.columnsVisibility != null) {
      console.log('apply tableState columnsVisibility', tableState.columnsVisibility, config);
      _.each(tableState.columnsVisibility, function (isColumnVisible, columnId) {
        var column = _.find(config.columns, {
          id: columnId
        });
        // console.log(isColumnVisible, columnId, column);
        if (column != null) {
          column.visible = isColumnVisible;
        }
      });
    }

    // visibilité initiale des groupes de colonnes.

    if (tableState.columnGroupsVisibility != null) {
      _.each(tableState.columnGroupsVisibility, function (isGroupVisible, groupId) {
        var columnGroup = _.find(config.columnGroups, {
          id: groupId
        });
        if (columnGroup != null) {
          columnGroup.visible = isGroupVisible;
        }
      });
    }

    // largeur initiale des colonnes
    if (tableState.columnsWidth != null) {
      _.each(tableState.columnsWidth, function (width, columnId) {
        var column = _.find(config.columns, {
          id: columnId
        });
        if (column != null) {
          column.width = width;
        }
      });
    }
  }

  /**
   * Retourne la liste des identifiants des colonnes sticky (les premières colonnes du tableau).
   */
  function getStickyColumnIds() {
    var stickyCount = config.stickyColumnsCount || 0;
    if (stickyCount <= 0) {
      return [];
    }
    var ids = [];
    var count = 0;
    var cols = config.originalColumns || config.columns;
    var _collectStickyIds = function collectStickyIds(items) {
      for (var i = 0; i < items.length; i++) {
        if (count >= stickyCount) {
          break;
        }
        var item = items[i];
        if (item.group || item.columns) {
          _collectStickyIds(item.columns);
        } else {
          if (item.id) {
            ids.push(item.id);
          }
          count++;
        }
      }
    };
    _collectStickyIds(cols);
    return ids;
  }

  /**
   * Détermine si un identifiant ou un objet colonne/groupe correspond à un élément sticky.
   */
  function isSticky(idOrCol) {
    var stickyCount = config.stickyColumnsCount || 0;
    if (stickyCount <= 0 || !idOrCol) {
      return false;
    }
    var stickyIds = getStickyColumnIds();
    if (_.isString(idOrCol)) {
      if (stickyIds.indexOf(idOrCol) > -1) {
        return true;
      }
      var topItem = findTopLevelItem(idOrCol);
      if (topItem && (topItem.group || topItem.columns)) {
        return _.some(topItem.columns, function (subCol) {
          return stickyIds.indexOf(subCol.id) > -1;
        });
      }
      return false;
    }
    if (idOrCol.id && stickyIds.indexOf(idOrCol.id) > -1) {
      return true;
    }
    if (idOrCol.group || idOrCol.columns) {
      return _.some(idOrCol.columns, function (subCol) {
        return stickyIds.indexOf(subCol.id) > -1;
      });
    }
    return false;
  }

  /**
   * Retourne le nombre d'éléments de premier niveau (colonnes top-level ou groupes)
   * correspondant aux colonnes sticky.
   */
  function getStickyTopLevelCount() {
    var stickyCount = config.stickyColumnsCount || 0;
    if (stickyCount <= 0) {
      return 0;
    }
    var count = 0;
    var cols = config.originalColumns || config.columns;
    var topCount = 0;
    for (var i = 0; i < cols.length; i++) {
      if (count >= stickyCount) {
        break;
      }
      var item = cols[i];
      if (item.group || item.columns) {
        count += item.columns ? item.columns.length : 0;
      } else {
        count += 1;
      }
      topCount++;
    }
    return topCount;
  }

  /**
   * Réordonne la liste des colonnes de configuration selon un ordre sauvegardé dans le tableState.
   * Si de nouvelles colonnes ont été ajoutées dans le code (non présentes dans tableState),
   * elles sont replacées juste après la colonne qui les précédait dans la définition originale.
   * Les colonnes appartenant à un groupe restent au sein de ce groupe, et sont réordonnées à l'intérieur.
   * Les colonnes sticky (stickyColumnsCount) restent fixes en début de tableau et ne sont pas déplacées.
   */
  function reorderColumnsWithSavedOrder(configColumns, savedOrder) {
    if (!savedOrder || !savedOrder.length || !configColumns || !configColumns.length) {
      return configColumns;
    }
    var stickyTopCount = getStickyTopLevelCount();
    var stickyItems = [];
    var reorderableItems = configColumns;
    if (stickyTopCount > 0) {
      stickyItems = configColumns.slice(0, stickyTopCount);
      reorderableItems = configColumns.slice(stickyTopCount);
    }

    // 1. Réordonner les sous-colonnes à l'intérieur de chaque groupe réordonnable
    _.each(reorderableItems, function (item) {
      if (item.group || item.columns) {
        if (item.columns && item.columns.length > 0) {
          item.columns = reorderFlatColumns(item.columns, savedOrder);
        }
      }
    });

    // 2. Réordonner les éléments de premier niveau (colonnes et groupes)
    var reordered = reorderTopLevelColumns(reorderableItems, savedOrder);
    return stickyItems.concat(reordered);
  }
  function reorderFlatColumns(columnList, savedOrder) {
    var existingColMap = {};
    _.each(columnList, function (col) {
      existingColMap[col.id] = col;
    });
    var result = [];
    var placedColIds = {};

    // Ajouter les colonnes de l'ordre sauvegardé qui existent dans cette liste
    _.each(savedOrder, function (colId) {
      if (existingColMap[colId]) {
        result.push(existingColMap[colId]);
        placedColIds[colId] = true;
      }
    });

    // Insérer les colonnes non présentes dans le state sauvegardé
    _.each(columnList, function (col, i) {
      if (!placedColIds[col.id]) {
        var targetIdx = -1;
        for (var prevIdx = i - 1; prevIdx >= 0; prevIdx--) {
          var prevCol = columnList[prevIdx];
          var idxInResult = result.indexOf(prevCol);
          if (idxInResult !== -1) {
            targetIdx = idxInResult + 1;
            break;
          }
        }
        if (targetIdx !== -1) {
          result.splice(targetIdx, 0, col);
        } else {
          result.unshift(col);
        }
        placedColIds[col.id] = true;
      }
    });
    return result;
  }
  function reorderTopLevelColumns(configColumns, savedOrder) {
    function getFirstAppearanceIndex(item) {
      if (item.group || item.columns) {
        var minIdx = -1;
        _.each(item.columns, function (subCol) {
          var idx = savedOrder.indexOf(subCol.id);
          if (idx !== -1 && (minIdx === -1 || idx < minIdx)) {
            minIdx = idx;
          }
        });
        return minIdx;
      } else {
        return savedOrder.indexOf(item.id);
      }
    }
    var itemsWithSavedIndex = [];
    var unplacedItems = [];
    _.each(configColumns, function (item, originalIdx) {
      var savedIdx = getFirstAppearanceIndex(item);
      if (savedIdx !== -1) {
        itemsWithSavedIndex.push({
          item: item,
          savedIdx: savedIdx,
          originalIdx: originalIdx
        });
      } else {
        unplacedItems.push({
          item: item,
          originalIdx: originalIdx
        });
      }
    });
    itemsWithSavedIndex.sort(function (a, b) {
      return a.savedIdx - b.savedIdx;
    });
    var result = _.map(itemsWithSavedIndex, 'item');
    _.each(unplacedItems, function (unplaced) {
      var targetIdx = -1;
      for (var prevIdx = unplaced.originalIdx - 1; prevIdx >= 0; prevIdx--) {
        var prevItem = configColumns[prevIdx];
        var idxInResult = result.indexOf(prevItem);
        if (idxInResult !== -1) {
          targetIdx = idxInResult + 1;
          break;
        }
      }
      if (targetIdx !== -1) {
        result.splice(targetIdx, 0, unplaced.item);
      } else {
        result.unshift(unplaced.item);
      }
    });
    return result;
  }
  ctrl.setAutoResize = function (_autoresize) {
    autoresize = _autoresize;
  };
  ctrl.onResize = function () {
    if (autoresize) {
      ctrl.refreshColumnsSizing();
    }
  };
  ctrl.$setScrollbarCtrl = function (_scrollbarCtrl) {
    scrollbar = _scrollbarCtrl;
  };
  var computeColumns = function computeColumns(initial) {
    compiler.computeColumns(initial);
  };

  ///////////
  // Row events
  ///////////

  var initializeRowEvents = function initializeRowEvents() {
    var eventScope = config.eventApplyScope || $scope;
    var previousHover = null;

    // row mouseenter
    ui.contentBody.delegate("tr", "mouseenter", function (event) {
      var row = $(event.currentTarget);
      if (config.hoverClass) {
        if (previousHover) {
          previousHover.removeClass(config.hoverClass);
        }
        row.addClass(config.hoverClass);
        previousHover = row;
      }
      if (config.onRowEnter) {
        eventScope.$apply(function () {
          config.onRowEnter(row.scope().model, row);
        });
      }
    });

    // row mouseleave
    ui.contentBody.delegate("tr", "mouseleave", function (event) {
      var row = $(event.currentTarget);
      if (config.hoverClass) {
        row.removeClass(config.hoverClass);
      }
      if (config.onRowLeave) {
        eventScope.$apply(function () {
          config.onRowLeave(row.scope().model, row);
        });
      }
    });

    // onRowClick handler
    ui.contentBody.delegate("tr", "click", function (event) {
      if (config.onRowClick) {
        var row = $(event.currentTarget),
          model = row.scope().model;
        eventScope.$apply(function () {
          config.onRowClick(model, row);
        });
      }
    });
  };

  //////////
  // HEADER FUNCS
  //////////

  var initializeHeaderAndFooter = function initializeHeaderAndFooter() {
    headerCtrl.constructColGroups();
    headerCtrl.constructHeaders();
    footerCtrl.refreshStaticFooter();
    initializeColumnResizing();
    initializeColumnReordering();
  };

  /**
   * effectue le tri
   */
  ctrl.sortBy = function (columnIndexOrId, desc, options) {
    var silent = options != null && options.silent;
    // permet au suoustotal de ne pas modifier l'enregistrement du tri dans le contexte
    var noContextUpdate = options != null && options.noContextUpdate;

    // get the column
    var column = findColumnByIndexOrId(columnIndexOrId);
    if (column == null) {
      column = context.visibleColumns[0];
    }

    // sort dataSource.children columns (recusively)
    function recusiveTreeSort(dataSource, column, desc) {
      _.each(dataSource, function (l) {
        itSortFactory.sort(l.children, column, desc);
        // sort each children
        recusiveTreeSort(l.children, column, desc);
      });
    }

    // apply the sorting to the collection
    if (column.sortable) {
      itSortFactory.sort(dataSource, column.column, desc);

      // tree must sort children recusively
      if (config.type === 'tree') {
        recusiveTreeSort(dataSource, column.column, desc);
      }
    }

    // tri suivant le subtotalColumnId
    if (context.subtotal) {
      // retire les lignes de soustotal de la datasource
      _.remove(dataSource, {
        "__type__": "subtotal"
      });
      var subTotalColumn = findColumnByIndexOrId(context.subtotal.column);
      if (subTotalColumn != null) {
        var subTotalAttribute = subTotalColumn.column.attribute;
        if (subTotalColumn.column.subtotalGroupAttribute) {
          subTotalAttribute = subTotalColumn.column.subtotalGroupAttribute;
        }

        // on regroupe les données par la valeur de la colonne de sous-total
        // Note: groupBy preserve l'ordre des éléments, donc le tri effectué précédemment sur dataSource est conservé au sein des groupes.
        var groups = _.groupBy(dataSource, function (item) {
          return _.get(item, subTotalAttribute);
        });

        // on calcul l'aggrégat pour chaque groupe pour la colonne en cours de tri
        var groupList = _.map(groups, function (rows, key) {
          var aggregate = itFooterAccumulator.accumulate(rows, column.column);
          if (column.id === subTotalColumn.id) {
            aggregate = _.get(rows[0], subTotalAttribute);
          }
          return {
            key: key,
            rows: rows,
            aggregate: aggregate
          };
        });

        // on tri les groupes suivant l'aggrégat
        var aggregateColumnDef = _.extend({}, column.column, {
          id: 'aggregate',
          attribute: 'aggregate',
          comparator: undefined // on retire le comparateur car il s'attend à recevoir des lignes de données, et non des objets d'aggrégats
        });
        itSortFactory.sort(groupList, aggregateColumnDef, desc);

        // on remet à plat
        dataSource = [];
        _.each(groupList, function (group) {
          _.each(group.rows, function (row) {
            return dataSource.push(row);
          });
        });
        createSubtotalRowsInDatasource(subTotalColumn.column);
      }
    }

    // refresh the table
    refreshContent(config.keepIndexOnSort);

    // if state is managed, we update the state and persist it.
    if (isStateManaged && !silent) {
      tableState.sort = {
        column: columnIndexOrId,
        desc: desc || false
      };
      tableState.subtotalGroup = {
        column: context.subtotal ? context.subtotal.column : null
      };
      stateManager.setTableState(config.id, tableState);
    }
    if (!noContextUpdate) {
      // set context sort state
      context.sort = {
        // l'index de la colonne
        column: column.index,
        desc: desc
      };
    }
  };

  /**
   * indique la colonne de soustotal (ex: via un click sur la colonne de titreou un bouton)
   *  stock dans le context l'information (n'effectue aucune modification sur la datasource)
   */
  ctrl.subTotalBy = function (columnIndexOrId, options) {
    // get the column
    var column = findColumnByIndexOrId(columnIndexOrId);
    if (column == null) {
      column = context.visibleColumns[0];
      if (column == null) {
        console.error('Impossible de faire un sous total sur la colonne introuvable ', columnIndexOrId);
        return;
      }
    }
    if (context.subtotal && (context.subtotal.column === column.index || context.subtotal.column === column.id)) {
      context.subtotal.column = null;
    } else {
      var subtotalDesc = false;
      if (context.subtotal) {
        subtotalDesc = context.subtotal.desc;
      }
      // si la colonne de tri est la meme que la colonne de soustotal, alors on applique son sens de tri
      if (context.sort.column === column.id || context.sort.column === column.index) {
        subtotalDesc = context.sort.desc;
      }

      // set context sort state
      context.subtotal = {
        /**
         * id ou index de la colonne
         *
         */
        column: column.id || column.index,
        desc: subtotalDesc
      };
    }
  };
  function findColumnByIndexOrId(columnIndexOrId) {
    if (_.isNumber(columnIndexOrId)) {
      return _.find(context.columns, {
        index: columnIndexOrId
      });
    } else {
      return _.find(context.columns, {
        id: columnIndexOrId
      });
    }
  }
  ctrl.findColumnByIndexOrId = function (columnIndexOrId) {
    return findColumnByIndexOrId(columnIndexOrId);
  };

  //////////////
  // COLUMNS VISIBILITY
  //////////////

  /**
   *
   * @param columnIds
   * @param visible
   * @param optionalColumns si tru alors les columIds peuvent ne pas exister sur le tableau (colonnes dynamiques,
   * utilisé pour la lisye des versements sur les subvention) et donc on ne veut pas d'erreur pour ne pas les avoir trouvées.
   */
  function toggleColumnsVisibility(columnIds, visible, optionalColumns) {
    _.each(columnIds, function (columnId) {
      var column = _.find(context.columns, {
        id: columnId
      });
      if (!column) {
        if (!optionalColumns) {
          // la colonne n'a pas été trouvée, alors qu'elle est définie sur le tableau. Sans doute une erreur dans la declaration dans le js des colonnes du groupe
          console.error("Cant't find id " + columnId + " in context.columns", context.columns);
        }
      } else {
        column.column.visible = arguments.length >= 2 ? visible : !column.visible;
      }
    });
    computeColumns();
    initializeHeaderAndFooter();
    refreshContent(true);
  }
  function isColumnGroupVisible(groupId) {
    var group = _.find(config.columnGroups, {
      id: groupId
    });
    var visibilityMap = ctrl.getColumnsVisibility();
    for (var i = 0; i < group.columns.length; i++) {
      if (visibilityMap[group.columns[i]] === false) {
        return false;
      }
    }
    return true;
  }
  ctrl.getColumnGroups = function () {
    return config.columnGroups;
  };
  ctrl.getColumnsVisibility = function () {
    var map = {};
    _.each(context.columns, function (column) {
      map[column.id] = column.visible;
    });
    return map;
  };
  ctrl.getColumnGroupsVisibility = function () {
    var map = {};
    _.each(config.columnGroups, function (group) {
      map[group.id] = isColumnGroupVisible(group.id);
    });
    return map;
  };

  /**
   * change la visiblité et rafraichi l'affichage
   * @param columnId
   * @param visible
   */
  ctrl.setColumnVisibility = function (columnId, visible) {
    var column = ctrl.findColumnByIndexOrId(columnId);
    toggleColumnsVisibility([columnId], visible);
  };
  ctrl.setGroupVisibility = function (groupId, visible) {
    var group = _.find(config.columnGroups, {
      id: groupId
    });
    if (!group) {
      console.error("Can't find group " + groupId);
    }
    toggleColumnsVisibility(group.columns, visible, group.optionalColumns);

    // if state is managed, we update the state and persist it.
    if (isStateManaged) {
      tableState.columnGroupsVisibility = ctrl.getColumnGroupsVisibility();
      stateManager.setTableState(config.id, tableState);
    }
  };

  /**
   * change la propriété visible de la colonne, sans relancer aucun recalcul/reaffichage
   * @param columnId
   * @param visible optionnel
   */
  ctrl.toggleColumnVisibility = function (columnId, visible) {
    var column = ctrl.findColumnByIndexOrId(columnId);
    if (visible !== undefined) {
      column.column.visible = visible;
    } else {
      column.column.visible = !column.column.visible;
    }
  };

  /**
   * Réinitialise les largeurs de toutes les colonnes à leur valeur par défaut
   * et purge cette donnée dans la persistance du TableState.
   */
  ctrl.resetColumnsSize = function () {
    if (isStateManaged && tableState) {
      tableState.columnsWidth = {};
      stateManager.setTableState(config.id, tableState);
    }
    if (config.originalWidths) {
      var _applyOriginalWidths = function applyOriginalWidths(cols) {
        _.each(cols, function (col) {
          if (col.group || col.columns) {
            _applyOriginalWidths(col.columns);
          } else if (config.originalWidths[col.id] !== undefined) {
            col.width = config.originalWidths[col.id];
          }
        });
      };
      _applyOriginalWidths(config.columns);
    }
    ctrl.refreshColumnsSizing();
  };

  /**
   * Réinitialise l'ordre de toutes les colonnes à leur configuration par défaut
   * et purge cette donnée dans la persistance du TableState.
   */
  ctrl.resetColumnsOrder = function () {
    if (isStateManaged && tableState) {
      delete tableState.columnsOrder;
      stateManager.setTableState(config.id, tableState);
    }
    if (config.originalColumns) {
      config.columns = angular.copy(config.originalColumns);
    }
    computeColumns();
    initializeHeaderAndFooter();
    refreshContent(true);
    computeColumnSizing();
  };

  /**
   * Déplace une colonne ou un groupe de colonnes avant ou après un élément cible.
   * - Si l'élément est au premier niveau (colonne top-level ou groupe entier), il peut être déplacé
   *   par rapport à un autre élément du premier niveau (autre groupe ou colonne top-level).
   * - Si la colonne est à l'intérieur d'un groupe, elle ne peut être déplacée qu'au sein de ce même groupe.
   * - Les colonnes sticky ne peuvent pas être déplacées et aucune colonne ne peut être déplacée avant/parmi elles.
   * @param sourceId ID ou index de la colonne ou du groupe à déplacer
   * @param targetId ID ou index de la colonne ou du groupe cible
   * @param isBefore boolean Si true insère avant la cible, sinon après (défaut true)
   */
  ctrl.moveColumn = function (sourceId, targetId, isBefore) {
    if (isBefore === undefined) {
      isBefore = true;
    }
    if (!sourceId || !targetId || sourceId === targetId) {
      return;
    }
    if (isSticky(sourceId) || isSticky(targetId)) {
      return;
    }

    // 1. Vérifier s'il s'agit d'un déplacement au sein d'un même groupe
    var sourceLeaf = findColumnByIndexOrId(sourceId);
    var targetLeaf = findColumnByIndexOrId(targetId);
    if (sourceLeaf && targetLeaf && sourceLeaf.group && targetLeaf.group && sourceLeaf.group === targetLeaf.group) {
      var group = sourceLeaf.group;
      var fromIndex = _.findIndex(group.columns, function (col) {
        return col.id === sourceLeaf.id || col === sourceLeaf.column;
      });
      var toIndex = _.findIndex(group.columns, function (col) {
        return col.id === targetLeaf.id || col === targetLeaf.column;
      });
      if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) {
        return;
      }
      var movedCol = group.columns.splice(fromIndex, 1)[0];
      toIndex = _.findIndex(group.columns, function (col) {
        return col.id === targetLeaf.id || col === targetLeaf.column;
      });
      var insertIndex = isBefore ? toIndex : toIndex + 1;
      group.columns.splice(insertIndex, 0, movedCol);
      _onColumnsOrderChanged();
      return;
    }

    // Si l'une des feuilles appartient à un groupe et pas l'autre, ou à des groupes différents -> interdit
    if (sourceLeaf && sourceLeaf.group || targetLeaf && targetLeaf.group) {
      return;
    }

    // 2. Déplacement au niveau supérieur (top-level : colonnes sans groupe ou groupes entiers)
    var sourceTopItem = findTopLevelItem(sourceId, sourceLeaf);
    var targetTopItem = findTopLevelItem(targetId, targetLeaf);
    if (!sourceTopItem || !targetTopItem || sourceTopItem === targetTopItem) {
      return;
    }
    var stickyTopCount = getStickyTopLevelCount();
    var topFromIndex = config.columns.indexOf(sourceTopItem);
    var topToIndex = config.columns.indexOf(targetTopItem);
    if (topFromIndex === -1 || topToIndex === -1 || topFromIndex === topToIndex) {
      return;
    }
    if (topFromIndex < stickyTopCount || topToIndex < stickyTopCount) {
      return;
    }
    var movedTopItem = config.columns.splice(topFromIndex, 1)[0];
    topToIndex = config.columns.indexOf(targetTopItem);
    var topInsertIndex = isBefore ? topToIndex : topToIndex + 1;
    if (topInsertIndex < stickyTopCount) {
      config.columns.splice(topFromIndex, 0, movedTopItem);
      return;
    }
    config.columns.splice(topInsertIndex, 0, movedTopItem);
    _onColumnsOrderChanged();
  };
  ctrl.moveGroup = function (sourceGroupId, targetId, isBefore) {
    ctrl.moveColumn(sourceGroupId, targetId, isBefore);
  };
  function findTopLevelItem(idOrIndex, leafColumn) {
    if (leafColumn && !leafColumn.group && leafColumn.column) {
      var leafIdx = config.columns.indexOf(leafColumn.column);
      if (leafIdx !== -1) {
        return leafColumn.column;
      }
    }
    if (_.isNumber(idOrIndex)) {
      return config.columns[idOrIndex] || null;
    }
    return _.find(config.columns, function (item) {
      return item.id === idOrIndex || item === idOrIndex;
    }) || null;
  }
  function _onColumnsOrderChanged() {
    // Mise à jour et persistance du tableState
    if (isStateManaged) {
      if (!tableState) {
        tableState = {};
      }
      tableState.columnsOrder = ctrl.getColumnsOrder();
      stateManager.setTableState(config.id, tableState);
    }
    computeColumns();
    initializeHeaderAndFooter();
    refreshContent(true);
    computeColumnSizing();
  }

  /**
   * Retourne la liste ordonnée des identifiants des colonnes
   */
  ctrl.getColumnsOrder = function () {
    var ids = [];
    var _collectIds = function collectIds(cols) {
      _.each(cols, function (col) {
        if (col.group || col.columns) {
          _collectIds(col.columns);
        } else if (col.id) {
          ids.push(col.id);
        }
      });
    };
    _collectIds(config.columns);
    return ids;
  };

  ////////

  var initializeColumnResizing = function initializeColumnResizing() {
    ui.headDiv.find('.it-resize-handle').remove();
    if (config.resizable !== true) {
      return;
    }
    _.each(context.visibleColumns, function (computedColumn) {
      if (!computedColumn) return;
      var th = ui.headTable.find('th[data-col-id="' + computedColumn.id + '"]');
      if (th.length === 0) return;
      var colDef = computedColumn.column;
      if (colDef.resizable === false) return;
      var handle = $('<div class="it-resize-handle" title="Redimensionner"></div>');
      handle.css({
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        width: '6px',
        cursor: 'col-resize',
        'z-index': 500
      });
      if (th.css('position') === 'static') {
        th.css('position', 'relative');
      }
      th.append(handle);
      handle.on('click', function (e) {
        e.stopPropagation(); // Évite de déclencher le tri quand on relâche la souris sur la poignée
      });
      handle.on('dblclick', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $scope.$applyAsync(function () {
          colDef.width = config.originalWidths[colDef.id];
          if (isStateManaged && tableState && tableState.columnsWidth) {
            delete tableState.columnsWidth[colDef.id];
            stateManager.setTableState(config.id, tableState);
          }
          computeColumnSizing();
        });
      });
      var startX,
        startWidth,
        minW = 50,
        maxW = 1500;
      handle.on('mousedown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        startX = e.pageX;
        startWidth = computedColumn.width || th.outerWidth();
        var initialWidthStr = colDef.width;
        // Parsing des contraintes de la configuration colonne
        if (colDef.minWidth) {
          if (_.isNumber(colDef.minWidth)) minW = colDef.minWidth;else if (isPixelWidthRegexp.test(colDef.minWidth)) minW = parseInt(colDef.minWidth, 10);
        }
        if (colDef.maxWidth) {
          if (_.isNumber(colDef.maxWidth)) maxW = colDef.maxWidth;else if (isPixelWidthRegexp.test(colDef.maxWidth)) maxW = parseInt(colDef.maxWidth, 10);
        }
        var $doc = $(document);
        var rafId;

        // Injection d'une balise style pour forcer le curseur sur TOUS les éléments
        var $cursorStyle = $('#it-resize-cursor-style');
        if ($cursorStyle.length === 0) {
          $cursorStyle = $('<style id="it-resize-cursor-style"></style>').appendTo('head');
        }
        $cursorStyle.html('* { cursor: col-resize !important; user-select: none !important; }');
        handle.css('cursor', 'col-resize');
        var mousemoveHandler = function mousemoveHandler(eMove) {
          var deltaX = eMove.pageX - startX;
          var rawWidth = startWidth + deltaX;
          var newWidth = rawWidth;
          var currentCursor = 'col-resize';
          if (rawWidth <= minW) {
            newWidth = minW;
            currentCursor = 'not-allowed'; // Curseur interdit pour indiquer la limite atteinte
          } else if (rawWidth >= maxW) {
            newWidth = maxW;
            currentCursor = 'not-allowed'; // Curseur interdit pour indiquer la limite atteinte
          }
          $cursorStyle.html('* { cursor: ' + currentCursor + ' !important; user-select: none !important; }');
          handle.css('cursor', currentCursor);
          colDef.width = newWidth + 'px';

          // Optimisation du reflow à 60fps
          if (rafId) {
            cancelAnimationFrame(rafId);
          }
          rafId = requestAnimationFrame(function () {
            computeColumnSizing();
          });
        };
        var _mouseupHandler = function mouseupHandler(eUp) {
          $doc.off('mousemove', mousemoveHandler);
          $doc.off('mouseup', _mouseupHandler);

          // Restaure le comportement natif du curseur
          $cursorStyle.remove();
          handle.css('cursor', 'col-resize');
          if (rafId) {
            cancelAnimationFrame(rafId);
          }

          // On évite la mise à jour asynchrone et la sauvegarde serveur si on a juste cliqué sans modifier la largeur
          if (colDef.width === initialWidthStr) {
            return;
          }
          $scope.$applyAsync(function () {
            computeColumnSizing();

            // Rendu persistant du redimensionnement si le tableau supporte la gestion des états
            if (isStateManaged) {
              if (!tableState.columnsWidth) tableState.columnsWidth = {};
              tableState.columnsWidth[colDef.id] = colDef.width;
              stateManager.setTableState(config.id, tableState);
            }
          });
        };
        $doc.on('mousemove', mousemoveHandler);
        $doc.on('mouseup', _mouseupHandler);
      });
    });
  };
  var initializeColumnReordering = function initializeColumnReordering() {
    stopAutoScroll();
    $element.off('.it-reorder');
    ui.headTable.find('th').removeAttr('draggable').removeClass('it-reorderable it-dragging it-drop-target-left it-drop-target-right').off('.it-reorder');
    if (config.reorderable !== true) {
      return;
    }
    var draggedId = null;
    var draggedType = null; // 'group', 'top-column', or 'sub-column'
    var draggedGroup = null;
    function startAutoScroll() {
      if (!autoScrollRaf) {
        autoScrollRaf = requestAnimationFrame(autoScrollStep);
      }
    }
    function autoScrollStep() {
      if (autoScrollSpeed !== 0 && ui.horizontalScroll.is(':visible')) {
        var hs = ui.horizontalScroll[0];
        var currentScroll = ui.horizontalScroll.scrollLeft();
        var maxScroll = hs.scrollWidth - hs.clientWidth;
        var newScroll = Math.max(0, Math.min(maxScroll, currentScroll + autoScrollSpeed));
        if (newScroll !== currentScroll) {
          ui.horizontalScroll.scrollLeft(newScroll);
          ui.headDiv.scrollLeft(newScroll);
          ui.contentScrollContainer.scrollLeft(newScroll);
          ui.footerDiv.scrollLeft(newScroll);
        }
      }
      if (draggedId) {
        autoScrollRaf = requestAnimationFrame(autoScrollStep);
      } else {
        autoScrollRaf = null;
      }
    }
    function updateAutoScroll(e) {
      if (!draggedId || !ui.horizontalScroll.is(':visible')) {
        autoScrollSpeed = 0;
        return;
      }
      var clientX = e.originalEvent && e.originalEvent.clientX != null ? e.originalEvent.clientX : e.clientX;
      if (clientX == null) {
        return;
      }
      var headDivEl = ui.headDiv[0];
      if (!headDivEl) {
        autoScrollSpeed = 0;
        return;
      }
      var rect = headDivEl.getBoundingClientRect();
      var threshold = 60; // zone d'activation en pixels à partir du bord
      var minSpeed = 5;
      var maxSpeed = 25;

      // Calcul du bord gauche scrollable (après les éventuelles colonnes sticky)
      var leftBound = rect.left;
      var stickyCells = ui.headTable.find('.it-sticky-column');
      if (stickyCells.length > 0) {
        var maxStickyRight = rect.left;
        stickyCells.each(function () {
          var r = this.getBoundingClientRect();
          if (r.right > maxStickyRight) {
            maxStickyRight = r.right;
          }
        });
        leftBound = maxStickyRight;
      }
      var leftZone = leftBound + threshold;
      var rightZone = rect.right - threshold;
      if (clientX < leftZone) {
        var distance = Math.max(0, leftZone - clientX);
        var ratio = Math.min(1, distance / threshold);
        autoScrollSpeed = -(minSpeed + ratio * (maxSpeed - minSpeed));
      } else if (clientX > rightZone) {
        var distance = Math.max(0, clientX - rightZone);
        var ratio = Math.min(1, distance / threshold);
        autoScrollSpeed = minSpeed + ratio * (maxSpeed - minSpeed);
      } else {
        autoScrollSpeed = 0;
      }
    }
    $element.on('dragover.it-reorder', function (e) {
      updateAutoScroll(e);
    });
    $element.on('dragleave.it-reorder', function (e) {
      if (e.target === $element[0] || !$.contains($element[0], e.target)) {
        autoScrollSpeed = 0;
      }
    });

    // 1. En-têtes de groupe (th.it-group-cell)
    ui.headTable.find('th.it-group-cell').each(function () {
      var th = $(this);
      var groupId = th.attr('data-group-id');
      if (!groupId) return;
      if (isSticky(groupId)) {
        return;
      }
      th.addClass('it-reorderable');
      th.attr('draggable', 'true');
      th.on('dragstart.it-reorder', function (e) {
        draggedId = groupId;
        draggedType = 'group';
        draggedGroup = null;
        th.data('it-just-dragged', true);
        th.addClass('it-dragging');
        startAutoScroll();
        if (e.originalEvent && e.originalEvent.dataTransfer) {
          e.originalEvent.dataTransfer.setData('text/plain', groupId);
          e.originalEvent.dataTransfer.effectAllowed = 'move';
        }
      });
      th.on('dragover.it-reorder', function (e) {
        updateAutoScroll(e);
        if (!draggedId || draggedId === groupId) {
          return;
        }
        if (isSticky(draggedId) || isSticky(groupId)) {
          return;
        }

        // Un groupe ne peut être déposé que sur un autre groupe ou sur une colonne top-level
        if (draggedType !== 'group' && draggedType !== 'top-column') {
          return;
        }
        e.preventDefault();
        if (e.originalEvent && e.originalEvent.dataTransfer) {
          e.originalEvent.dataTransfer.dropEffect = 'move';
        }
        var rect = th[0].getBoundingClientRect();
        var relX = (e.originalEvent.clientX || e.clientX) - rect.left;
        var isLeft = relX < rect.width / 2;
        if (isLeft) {
          th.addClass('it-drop-target-left').removeClass('it-drop-target-right');
        } else {
          th.addClass('it-drop-target-right').removeClass('it-drop-target-left');
        }
      });
      th.on('dragleave.it-reorder', function () {
        th.removeClass('it-drop-target-left it-drop-target-right');
      });
      th.on('dragend.it-reorder', function () {
        stopAutoScroll();
        draggedId = null;
        draggedType = null;
        draggedGroup = null;
        ui.headTable.find('th').removeClass('it-dragging it-drop-target-left it-drop-target-right');
        setTimeout(function () {
          th.removeData('it-just-dragged');
        }, 100);
      });
      th.on('drop.it-reorder', function (e) {
        stopAutoScroll();
        e.preventDefault();
        e.stopPropagation();
        th.removeClass('it-drop-target-left it-drop-target-right');
        var sourceId = e.originalEvent && e.originalEvent.dataTransfer ? e.originalEvent.dataTransfer.getData('text/plain') : draggedId;
        if (!sourceId) {
          sourceId = draggedId;
        }
        if (sourceId && groupId && sourceId !== groupId) {
          if (isSticky(sourceId) || isSticky(groupId)) {
            return;
          }
          if (draggedType === 'group' || draggedType === 'top-column') {
            var rect = th[0].getBoundingClientRect();
            var relX = (e.originalEvent.clientX || e.clientX) - rect.left;
            var isLeft = relX < rect.width / 2;
            $scope.$evalAsync(function () {
              ctrl.moveColumn(sourceId, groupId, isLeft);
            });
          }
        }
        draggedId = null;
        draggedType = null;
        draggedGroup = null;
        ui.headTable.find('th').removeClass('it-dragging it-drop-target-left it-drop-target-right');
        setTimeout(function () {
          th.removeData('it-just-dragged');
        }, 100);
      });
    });

    // 2. En-têtes de colonnes (th.it-header-cell)
    _.each(context.visibleColumns, function (computedColumn) {
      if (!computedColumn) return;
      var th = ui.headTable.find('th[data-col-id="' + computedColumn.id + '"]');
      if (th.length === 0) return;
      var colDef = computedColumn.column;
      if (colDef.reorderable === false) return;
      if (isSticky(computedColumn.id) || isSticky(computedColumn.column)) {
        return;
      }
      var isTopLevel = computedColumn.group == null;
      th.addClass('it-reorderable');
      th.attr('draggable', 'true');
      th.on('dragstart.it-reorder', function (e) {
        draggedId = computedColumn.id;
        draggedType = isTopLevel ? 'top-column' : 'sub-column';
        draggedGroup = computedColumn.group || null;
        th.data('it-just-dragged', true);
        th.addClass('it-dragging');
        startAutoScroll();
        if (e.originalEvent && e.originalEvent.dataTransfer) {
          e.originalEvent.dataTransfer.setData('text/plain', computedColumn.id);
          e.originalEvent.dataTransfer.effectAllowed = 'move';
        }
      });
      th.on('dragover.it-reorder', function (e) {
        updateAutoScroll(e);
        if (!draggedId || draggedId === computedColumn.id) {
          return;
        }
        if (isSticky(draggedId) || isSticky(computedColumn.id) || isSticky(computedColumn.column)) {
          return;
        }
        if (isTopLevel) {
          // Cible = colonne de premier niveau : autorisée si l'élément déplacé est un groupe ou une colonne de premier niveau
          if (draggedType !== 'group' && draggedType !== 'top-column') {
            return;
          }
        } else {
          // Cible = sous-colonne : autorisée UNIQUEMENT si l'élément déplacé est une sous-colonne du MÊME groupe
          if (draggedType !== 'sub-column' || draggedGroup !== computedColumn.group) {
            return;
          }
        }
        e.preventDefault();
        if (e.originalEvent && e.originalEvent.dataTransfer) {
          e.originalEvent.dataTransfer.dropEffect = 'move';
        }
        var rect = th[0].getBoundingClientRect();
        var relX = (e.originalEvent.clientX || e.clientX) - rect.left;
        var isLeft = relX < rect.width / 2;
        if (isLeft) {
          th.addClass('it-drop-target-left').removeClass('it-drop-target-right');
        } else {
          th.addClass('it-drop-target-right').removeClass('it-drop-target-left');
        }
      });
      th.on('dragleave.it-reorder', function () {
        th.removeClass('it-drop-target-left it-drop-target-right');
      });
      th.on('dragend.it-reorder', function () {
        stopAutoScroll();
        draggedId = null;
        draggedType = null;
        draggedGroup = null;
        ui.headTable.find('th').removeClass('it-dragging it-drop-target-left it-drop-target-right');
        setTimeout(function () {
          th.removeData('it-just-dragged');
        }, 100);
      });
      th.on('drop.it-reorder', function (e) {
        stopAutoScroll();
        e.preventDefault();
        e.stopPropagation();
        th.removeClass('it-drop-target-left it-drop-target-right');
        var sourceId = e.originalEvent && e.originalEvent.dataTransfer ? e.originalEvent.dataTransfer.getData('text/plain') : draggedId;
        if (!sourceId) {
          sourceId = draggedId;
        }
        var targetId = computedColumn.id;
        if (sourceId && targetId && sourceId !== targetId) {
          if (isSticky(sourceId) || isSticky(targetId) || isSticky(computedColumn.column)) {
            return;
          }
          var canDrop = false;
          if (isTopLevel) {
            if (draggedType === 'group' || draggedType === 'top-column') {
              canDrop = true;
            }
          } else {
            if (draggedType === 'sub-column' && draggedGroup === computedColumn.group) {
              canDrop = true;
            }
          }
          if (canDrop) {
            var rect = th[0].getBoundingClientRect();
            var relX = (e.originalEvent.clientX || e.clientX) - rect.left;
            var isLeft = relX < rect.width / 2;
            $scope.$evalAsync(function () {
              ctrl.moveColumn(sourceId, targetId, isLeft);
            });
          }
        }
        draggedId = null;
        draggedType = null;
        draggedGroup = null;
        ui.headTable.find('th').removeClass('it-dragging it-drop-target-left it-drop-target-right');
        setTimeout(function () {
          th.removeData('it-just-dragged');
        }, 100);
      });
    });
  };
  var isPixelWidthRegexp = /px$/i;
  var isPercentageWidthRegexp = /%$/i;

  // Helper function to apply sticky styles to a single cell
  var _applyStickyStylesToCell = function _applyStickyStylesToCell(cell, columnIndex, cumulativeLeft, zIndexBase, bgColor, isLastStickyCol) {
    if (cell && cell.length) {
      // Ensure cell exists
      cell.css({
        'position': 'sticky',
        'left': cumulativeLeft + 'px',
        'z-index': zIndexBase - columnIndex,
        'border-right': isLastStickyCol ? '1px solid #cccccc' : '1px solid #E8E8E8',
        'transform': 'translateZ(0)',
        '-webkit-backface-visibility': 'hidden'
      }).addClass('it-sticky-column'); // Add class for CSS specificity support
      if (!cell.hasClass('it-subtotal-cell')) {
        cell.css({
          'background-color': bgColor || 'inherit'
        }); // Use explicit bgColor if provided, or inherit
      }
    }
  };

  // Expose this method for renderers to call on new rows
  ctrl.applyStickyStylesToRow = function (rowElement) {
    var stickyColumnsCount = config.stickyColumnsCount || 0;
    var cumulativeStickyWidth = 0;

    // Only apply if there are sticky columns configured
    if (stickyColumnsCount === 0) {
      return;
    }
    for (var colIdx = 0; colIdx < stickyColumnsCount; colIdx++) {
      var computedColumn = context.visibleColumns[colIdx];
      if (computedColumn && computedColumn.visible) {
        var cell = rowElement.find('> td').eq(colIdx);
        _applyStickyStylesToCell(cell, colIdx, cumulativeStickyWidth, 50, 'inherit', colIdx === stickyColumnsCount - 1); // Body rows inherit from TR for selection support
        cumulativeStickyWidth += computedColumn.width || 0; // Use the pre-calculated width
      }
    }
  };
  var computeColumnSizing = function computeColumnSizing() {
    if (!ctrl.isVisible()) {
      recomputeRequired = true;
      return;
    }
    var showScrollbar = context.pagination.full !== true,
      computedColumns = context.visibleColumns,
      // largeur disponible a l'écran pour afficher la table
      totalTableDivWidth = ui.contentDiv.width(),
      scrollbarWidth = config.scrollbarWidth,
      // largeur disponible a l'écran pour afficher la table - la taille des colonnes visibles de la table
      availableWidth = totalTableDivWidth,
      usedWidth = 0,
      requireAutosizing = false,
      i;
    if (showScrollbar) {
      availableWidth -= scrollbarWidth;
    }
    function setColumnWidth(index, width) {
      computedColumns[index].headerCol.width(width);
      computedColumns[index].contentCol.width(width);
      computedColumns[index].footerCol.width(width);
    }

    // sizing the scrollbar column
    if (showScrollbar) {
      scrollbar.show();
      ui.headColgroup.find(".scrollbar").width(scrollbarWidth);
      ui.contentColgroup.find(".scrollbar").width(scrollbarWidth);
      ui.footerColgroup.find(".scrollbar").width(scrollbarWidth);
      $element.removeClass("it-no-scrollbar");
    } else {
      scrollbar.hide();
      ui.headColgroup.find(".scrollbar").width(0);
      ui.contentColgroup.find(".scrollbar").width(0);
      ui.footerColgroup.find(".scrollbar").width(0);
      $element.addClass("it-no-scrollbar");
    }

    // First pass: Determine all column widths
    for (i = 0; i < computedColumns.length; i++) {
      var computedColumn = computedColumns[i],
        width = computedColumn.column.width || "auto",
        widthInPixel = null;
      if (_.isNumber(width)) {
        widthInPixel = width;
      } else if (isPixelWidthRegexp.test(width)) {
        widthInPixel = parseInt(width.substring(0, width.length - 2));
      } else if (isPercentageWidthRegexp.test(width)) {
        var percentage = parseInt(width.substring(0, width.length - 1));
        widthInPixel = percentage * totalTableDivWidth / 100;
      } else {
        // auto
        requireAutosizing = true;
      }
      if (widthInPixel != null) {
        availableWidth -= widthInPixel;
        usedWidth += widthInPixel;
        computedColumn.autowidth = false;
        computedColumn.width = widthInPixel; // Store the computed width
        setColumnWidth(i, widthInPixel);
      } else {
        setColumnWidth(i, ""); // Clear width for auto-sized columns initially
        computedColumn.autowidth = true;
      }
    }
    var hasHorizontalOverflow = availableWidth < 0;

    // console.log('availableWidth', availableWidth, 'hasHorizontalOverflow', hasHorizontalOverflow, 'usedWidth', usedWidth)
    var newTableWidth = usedWidth;
    if (showScrollbar) {
      newTableWidth += scrollbarWidth;
    }
    var widthFromColumns = 0;
    if (horizontalScrollbar) {
      // console.log('horizontalScrollbar for table', config.id);
      if (hasHorizontalOverflow) {
        // Case A: Fixed columns already overflow.
        if (requireAutosizing) {
          // Add fallback width for auto columns
          var autoColCount = _.filter(computedColumns, 'autowidth').length;
          // arbitrairement 100px par colonne autodimensionnable
          newTableWidth += autoColCount * 100;
          //            console.log('autoColCount', autoColCount);

          widthFromColumns = newTableWidth;
        } else {
          widthFromColumns = usedWidth;
        }
      } else if (requireAutosizing) {
        // Case B: Check if auto columns cause overflow
        var contentHeaders = ui.contentHeadRow.find("th");

        // Allow table to expand to fit content
        // We use max-content to ensure the table takes its natural width based on content,
        // ignoring the container's width constraint.
        ui.contentTable.css({
          "table-layout": "auto",
          "width": "max-content",
          "min-width": "100%"
        });
        ui.contentHeadRow.show();
        ui.contentFoot.show();
        var tableFullExpendWidth = ui.contentTable.width();

        // If actual width exceeds available width, we have overflow
        if (tableFullExpendWidth > totalTableDivWidth) {
          // console.log("actualWidth > availableWidth", tableFullExpendWidth, availableWidth)
          hasHorizontalOverflow = true;
          // inutile et inadapté je pense. Il faut recaculer avec les colonnes
          newTableWidth = tableFullExpendWidth;
        }
        if (hasHorizontalOverflow) {
          // console.log('computedColumns', computedColumns)
          // Capture widths for auto columns
          for (i = 0; i < computedColumns.length; i++) {
            if (computedColumns[i].visible) {
              if (computedColumns[i].autowidth) {
                var widthCol = contentHeaders.eq(i).width();
                // l'affichage du scrolling levant toute contrainte de largeur, un maxWidth evite qu'un champ ne s'étende trop.
                var currentColumn = computedColumns[i].column;
                if (currentColumn.maxWidth) {
                  // soit le nombre en px (100), soit  en chaine : '100px'
                  var maxWidth;
                  if (_.isNumber(currentColumn.maxWidth)) {
                    maxWidth = currentColumn.maxWidth;
                  } else if (isPixelWidthRegexp.test(currentColumn.maxWidth)) {
                    maxWidth = parseInt(currentColumn.maxWidth.substring(0, currentColumn.maxWidth.length - 2));
                  }
                  if (maxWidth && maxWidth < widthCol) {
                    widthCol = maxWidth;
                  }
                } else {
                  // on limite les colonnes à 500px de large par défaut
                  if (widthCol > 500) {
                    //   console.log('Limit widthCol to 500', computedColumns[i], widthCol);
                    widthCol = 500;
                  }
                }
                if (currentColumn.minWidth) {
                  // soit le nombre en px (100), soit  en chaine : '100px'
                  var minWidth;
                  if (_.isNumber(currentColumn.minWidth)) {
                    minWidth = currentColumn.minWidth;
                  } else if (isPixelWidthRegexp.test(currentColumn.minWidth)) {
                    minWidth = parseInt(currentColumn.minWidth.substring(0, currentColumn.minWidth.length - 2));
                  }
                  if (minWidth && minWidth > widthCol) {
                    widthCol = minWidth;
                  }
                }

                //console.log(computedColumns[i], widthCol)

                setColumnWidth(i, widthCol);
                computedColumns[i].width = widthCol; // Store calculated width for sticky calculations
                widthFromColumns += widthCol;
                //console.log('autoWidth ' + i, widthCol)
              } else {
                //console.log('use fixed width', computedColumns[i], computedColumns[i].width)

                widthFromColumns += computedColumns[i].width;
                //console.log('width ' + i, computedColumns[i].width)
              }
            }
          }
        }

        // Restore fixed layout
        ui.contentTable.css({
          "table-layout": "fixed"
        });
        ui.contentHeadRow.hide();
        ui.contentFoot.hide();
      } else {
        widthFromColumns = usedWidth;
      }
      if (hasHorizontalOverflow) {
        // console.log('actualWidth > availableWidth , newTableWidth, widthFromColumns ', actualWidth, availableWidth, newTableWidth, widthFromColumns, scrollbarWidth)
        newTableWidth = widthFromColumns + (showScrollbar ? scrollbarWidth : 0);
        // console.log('newTableWidth', newTableWidth, 'widthFromColumns', widthFromColumns)

        // si on occupe pas toute la place au final ?
        if (newTableWidth < totalTableDivWidth) {
          //   console.log('newTableWidth<totalTableDivWidth', newTableWidth, totalTableDivWidth)
          hasHorizontalOverflow = false;
        }
      }
      if (hasHorizontalOverflow) {
        //console.log('show horizontalScroll - newTableWidth', newTableWidth)
        ui.horizontalScroll.show();
        ui.horizontalScrollContent.width(newTableWidth);
        ui.headTable.width(newTableWidth);
        ui.contentTable.width(newTableWidth);
        ui.footerTable.width(newTableWidth);

        // Ensure containers hide overflow
        ui.headDiv.css('overflow-x', 'hidden');
        ui.contentScrollContainer.css('overflow-x', 'hidden');
        ui.footerDiv.css('overflow-x', 'hidden');

        // Bind scroll
        ui.horizontalScroll.off('scroll.horizontal').on('scroll.horizontal', function () {
          var left = $(this).scrollLeft();
          ui.headDiv.scrollLeft(left);
          ui.contentScrollContainer.scrollLeft(left);
          ui.footerDiv.scrollLeft(left);
        });
      } else {
        ui.horizontalScroll.hide();
        ui.headTable.css('width', '100%');
        ui.contentTable.css('width', '100%');
        ui.footerTable.css('width', '100%');
        ui.horizontalScroll.off('scroll.horizontal');

        // Reset scroll positions
        ui.headDiv.scrollLeft(0);
        ui.contentScrollContainer.scrollLeft(0);
        ui.footerDiv.scrollLeft(0);
      }
    } else {
      //  console.log("don't show horizontal scrollbar");
    }

    // Get computed background colors for header and footer once
    var headerBgColor = ui.headDiv.css('background-color') || 'white';
    var footerBgColor = ui.footerDiv.css('background-color') || 'white';

    // Apply sticky styles based on determined widths
    var stickyColumnsCount = hasHorizontalOverflow ? config.stickyColumnsCount || 0 : 0;
    var cumulativeStickyWidth = 0;

    // Force separate borders for sticky reliability
    if (stickyColumnsCount > 0) {
      ui.headTable.css({
        'border-collapse': 'separate',
        'border-spacing': '0'
      });
      ui.contentTable.css({
        'border-collapse': 'separate',
        'border-spacing': '0'
      });
      ui.footerTable.css({
        'border-collapse': 'separate',
        'border-spacing': '0'
      });
    } else {
      // Reset to default if no sticky columns
      ui.headTable.css({
        'border-collapse': '',
        'border-spacing': ''
      });
      ui.contentTable.css({
        'border-collapse': '',
        'border-spacing': ''
      });
      ui.footerTable.css({
        'border-collapse': '',
        'border-spacing': ''
      });
    }

    // Reset sticky styles for all cells before re-applying (but NOT background-color here, handled individually)
    $element.find('.it-head-table th, .it-head-table td, .it-body-table td, .it-foot-table td').css({
      'position': '',
      'left': '',
      'z-index': '',
      'border-right': '',
      'transform': '',
      '-webkit-backface-visibility': ''
    });
    var _loop = function _loop() {
        computedColumn = computedColumns[i];
        currentColumnWidth = computedColumn.width;
        if (i < stickyColumnsCount) {
          var leftPos = cumulativeStickyWidth;

          // L'utilisation de zIndexBase différents pour l'en-tête (100), le pied de page (75) et le corps (50) est essentielle pour gérer la superposition verticale du tableau, en plus de la superposition horizontale des colonnes "sticky".

          // Apply to it-head
          // Pour le moment cela ne marche bien que si les stickys ne sont pas des colonnes au sein de groupe. Donc définis sur le premier tr.
          ui.headTable.find('tr:first').each(function () {
            var cell = $(this).find('> th, > td').eq(i);
            _applyStickyStylesToCell(cell, i, leftPos, 100, headerBgColor, i === stickyColumnsCount - 1); // Explicit color for header
          });

          // Apply to it-body (existing rows)
          ui.contentTable.find('> tbody > tr').each(function () {
            // Target tbody rows specifically
            var rowElement = $(this);
            var cell = rowElement.find('> td').eq(i);
            _applyStickyStylesToCell(cell, i, leftPos, 50, 'inherit', i === stickyColumnsCount - 1); // Inherit for body (selection support)
          });

          // Apply to it-foot
          if (config.footer) {
            ui.footerTable.find('tr').each(function () {
              var cell = $(this).find('> th, > td').eq(i);
              _applyStickyStylesToCell(cell, i, leftPos, 75, footerBgColor, i === stickyColumnsCount - 1); // Explicit color for footer
            });
          }
          cumulativeStickyWidth += currentColumnWidth || 0;
        } else {
          // Remove sticky class and background-color if it was previously sticky
          var nonStickyCell = $element.find('.it-head-table tr, .it-body-table tr, .it-foot-table tr').find('> th, > td').eq(i);
          nonStickyCell.removeClass('it-sticky-column').css('background-color', '');
        }
      },
      computedColumn,
      currentColumnWidth;
    for (i = 0; i < computedColumns.length; i++) {
      _loop();
    }
    ctrl.applyUsedHeight();
    if (scrollbar) {
      scrollbar.refresh(true);
    }
  };
  ctrl.enableFullMode = function () {
    fullMode = true;
    setScrollPosition({
      full: true
    });
    computeColumnSizing();
  };
  ctrl.disableFullMode = function () {
    fullMode = false;
    setScrollPosition({
      index: 0,
      initial: false
    });
    computeColumnSizing();
  };
  ctrl.refreshColumnsSizing = function () {
    if (config == null) {
      return;
    }
    computeColumnSizing();
  };

  //////////
  // HEIGHT SIZING
  //////////

  ctrl.setHeight = function (height, redraw) {
    context.maxHeight = height;
    if (redraw && dataSource && renderer) {
      // ctrl.applyMaxAvailableHeight(); // TODO : useful ?
      ctrl.scroll.toIndex(context.pagination && context.pagination.first || 0);
      computeColumnSizing();
      scrollbar.refresh(true);
      // ctrl.applyUsedHeight();
    }
  };

  /**
   * Compute the total height available for the table body. ( aka table height minus header / footer height )
   *
   * @returns {Number} the available height or null if there is no height limitation.
   */
  ctrl.getAvailableBodyHeight = function () {
    if (context.maxHeight) {
      // TODO : might want to compute this only once. (+ compute border instead of hardcoded -1)
      var headerHeight = ui.headDiv.height() - 2;
      var footerHeight = footerCtrl.hasStaticFooter(config) ? ui.footerDiv.height() + 3 : 2;
      var available = context.maxHeight - headerHeight - footerHeight;
      if (ui.horizontalScroll.is(":visible")) {
        available -= ui.horizontalScroll.outerHeight();
      }
      return available;
    } else {
      return null;
    }
  };

  /**
   * Inner method,
   */
  ctrl.applyUsedHeight = function () {
    var filled = context.pagination.filled;
    var full = context.pagination.full;
    if (fullMode) {
      ui.contentDiv.css("height", "auto");
    } else if (filled && !full) {
      var availableHeight = ctrl.getAvailableBodyHeight();
      ui.contentDiv.height(availableHeight);
    } else {
      ui.contentDiv.height(ui.contentTable.height());
    }
  };

  //////////
  /// SCROLL
  //////////

  ctrl.scroll = {
    toIndex: function toIndex(index) {
      return setScrollPosition({
        index: index
      });
    },
    toTop: function toTop() {
      return setScrollPosition({
        index: 0
      });
    },
    toBottom: function toBottom() {
      return setScrollPosition({
        index: renderer.getActualLength() - 1
      });
    },
    toPercent: function toPercent(percent) {
      if (percent === 100) {
        return ctrl.scroll.toBottom();
      } else if (percent === 0) {
        return ctrl.scroll.toTop();
      } else {
        var itemIdx = Math.round(percent / 100 * (renderer.getActualLength() - context.pagination.count));
        return setScrollPosition({
          index: itemIdx
        });
      }
    },
    pageUp: function pageUp() {
      return ctrl.scroll.offset(-(context.pagination.count - 1));
    },
    pageDown: function pageDown() {
      return ctrl.scroll.offset(context.pagination.count - 1);
    },
    offset: function offset(count) {
      var firstIdx = context.pagination.first,
        lastIdx = context.pagination.last,
        actualLength = renderer.getActualLength(),
        scrollTo;
      if (count < 0 ? firstIdx === 0 : lastIdx === actualLength - 1) {
        return false;
      }
      if (lastIdx + count >= actualLength - 1) {
        scrollTo = actualLength - 1;
      } else {
        scrollTo = count > 0 ? Math.min(firstIdx + count, actualLength - 1) : Math.max(firstIdx + count, 0);
      }
      return setScrollPosition({
        index: scrollTo
      });
    }
  };
  ctrl.refreshContent = function () {
    computeColumns();
    initializeHeaderAndFooter();
    refreshContent(true);
  };

  //////////
  /// RENDER
  //////////

  function createSubtotalRowsInDatasource(subTotalColumn) {
    var i = 0,
      subtotalBeginingPosition = 0;
    var subTotalAttribute = subTotalColumn.attribute;
    if (subTotalColumn.subtotalGroupAttribute) {
      subTotalAttribute = subTotalColumn.subtotalGroupAttribute;
    }
    var sortedDatasource = [];

    // liste des lignes avec la meme valeur
    var subtotalDatasource = [];
    context.subtotalValues = [];
    while (i <= dataSource.length) {
      //        dataSource.
      if (i > 0) {
        var previousVal = _.get(dataSource[i - 1], subTotalAttribute);
        var comparaison = -1;
        // si on est pas ser la dernière ligne
        if (i < dataSource.length) {
          comparaison = itSortFactory.getColumnComparator(subTotalColumn, subTotalAttribute)(dataSource[i - 1], dataSource[i]);
        }
        if (comparaison !== 0) {
          // identifiant unique pour la ligne de sous-total
          var uuid = UUID();
          var subtotalRow = {
            __type__: 'subtotal',
            "__refValue__": previousVal,
            // on passe le filter de la valeur de référence, pour l'affichage dans la ligne de total
            "__refValueFilter__": subTotalColumn.filter,
            "__refColumn__": subTotalColumn,
            "__columnId__": subTotalColumn.id,
            "id": uuid,
            // reprend la dernière ligne qui sert à produire la ligne. Permet de s'appuyer dessus pour le rendu
            "lastModel": dataSource[i - 1]
          };

          // calcul et stock sous-totaux
          var subTotalData = subtotalValues(subtotalDatasource);
          context.subtotalValues[uuid] = subTotalData;
          // permet d'accéder à l'ensemble des données du sous-total dans le template
          subtotalRow.subTotalData = subTotalData;
          if (config.subtotalBefore === true) {
            sortedDatasource.splice(subtotalBeginingPosition, 0, subtotalRow);
          } else {
            sortedDatasource.push(subtotalRow);
          }

          // reinitialise lignes avec meme valeur
          subtotalDatasource = [];
          subtotalBeginingPosition = sortedDatasource.length;
        }
      }
      // la dernière ligne a déjà été ajoutée

      if (i !== dataSource.length) {
        sortedDatasource.push(dataSource[i]);
        subtotalDatasource.push(dataSource[i]);
      }
      i++;
    }
    dataSource = sortedDatasource;
  }
  ctrl.setDatasource = function (_dataSource) {
    dataSource = _dataSource.slice(0); // making copy to be able to change order and stuff.

    if (config.footer) {
      footerCtrl.computeFooterValues();
      if (footerCtrl.hasInlineFooter(config)) {
        dataSource.push({
          __type__: 'footer'
        });
      }
    }
    var initialIndex = context.pagination.first;
    performInitialSort();
    if (config.keepIndexOnReload) {
      setScrollPosition({
        index: initialIndex,
        initial: true
      });
    }
  };
  var subtotalValues = function subtotalValues(subdatasource) {
    var subtotalValues = [];
    ctrl.getContext().columns.filter(function (column) {
      var colDef = column.column;
      return colDef.dataType || colDef.footerReducer && column.column.footer !== false;
    }).forEach(function (column) {
      var footerValue = itFooterAccumulator.accumulate(subdatasource, column.column);
      subtotalValues[column.id] = footerValue;
    });
    return subtotalValues;
  };
  var refreshContent = function refreshContent(keepIndex) {
    var initialIndex = keepIndex ? context.pagination.first : getInitialScrollPosition();
    renderer.clearContent(true);
    setScrollPosition({
      index: initialIndex,
      initial: true
    });
    computeColumnSizing();
    ctrl.applyUsedHeight();
    scrollbar.refresh(true);
  };

  /**
   * Retourne la position initiale dans le cas ou config.initialScroll === true
   *
   * config.initialScroll peut etre :
   *      - l'index d'une colonne
   *      - une fonction retournant l'index d'une colonne
   *      - la reference du modèle d'une colonne.
   *
   * @return number l'index calculé de la position initiale.
   */
  function getInitialScrollPosition() {
    var initialScroll = config.initialScroll;
    if (_.isFunction(initialScroll)) {
      initialScroll = initialScroll(dataSource);
    }
    if (_.isNumber(initialScroll)) {
      return initialScroll;
    } else if (_.isObject(initialScroll)) {
      if (config.type === 'tree') {
        // todo - recherche recusive + gestion ouverts/fermés
        var _position = _.indexOf(dataSource, initialScroll);
        return Math.max(_position, 0);
      }
      var position = _.indexOf(dataSource, initialScroll);
      return Math.max(position, 0);
    } else {
      return 0;
    }
  }
  var findDeepIndex = function findDeepIndex(collection, predicate, recursProperty) {
    var items = [];
    _.each(collection, function (each) {
      return items.push(each);
    });
    return _.indexOf(items, function (value, key, coll) {
      if (predicate(value, key, coll)) {
        return true;
      } else {
        _.each(value[recursProperty], function (each) {
          return items.push(each);
        });
      }
    });
  };

  /**
   * Sets the scroll position on the renderer.
   *
   * @param index      The index of the first row to display
   * @param initial    [optional] true if this is the first rendering of the table
   * @return {boolean} true if the scroll changed the position of the table, false otherwise
   *                   (scrolling up from first row, or bottom from last row for example)
   */
  function setScrollPosition(scrollOptions) {
    if (ctrl.isVisible()) {
      renderer.setScrollPosition(_.extend(scrollOptions, {
        full: fullMode
      }));
    } else {
      lastScrollOptions = scrollOptions;
      renderRequired = true;
    }
    return true; // TODO : implements, checking the first/last index before & after setting scroll position.
  }
  var lastScrollOptions = null;
  function performInitialSort() {
    var initialSubtotal = null;
    if (tableState != null && tableState.subtotalGroup != null) {
      initialSubtotal = tableState.subtotalGroup.column;
    } else {
      initialSubtotal = config.initialSubtotalGroup;
    }
    if (initialSubtotal != null) {
      context.subtotal = {
        column: initialSubtotal
      };
    }
    var initialSort = null;
    if (tableState != null && tableState.sort != null) {
      initialSort = tableState.sort;
    } else {
      initialSort = config.initialSort;
    }
    if (initialSort != null) {
      var sort = normalizeSortOption(initialSort);
      ctrl.sortBy(sort.column, sort.desc, {
        silent: true
      });
    } else {
      // il nous faut  déclencher le tri sur le soustotal puisqu'il n'a pas été déclenché par un tri initial
      if (initialSubtotal) {
        // todo regarder dans le context sort colomn  ?
        var sortOrder = false;
        ctrl.sortBy(initialSubtotal, sortOrder);
      }
      refreshContent(false);
    }
  }

  /**
   * Normalize a sort option to a sort object.
   *
   * Sort option can be of format :
   *  - 'columnId'
   *  - columnIndex
   *  - ["columnId", "desc"]
   *  - ["columnId", true]
   *  - { column : "columnId", desc : true }
   *  - { column : "columnId", desc : "desc"}
   *
   * @param sort
   */
  function normalizeSortOption(sort) {
    var columnId, desc;
    if (_.isNumber(sort) || _.isString(sort)) {
      columnId = sort;
      desc = false;
    } else if (_.isArray(sort)) {
      columnId = sort[0];
      desc = sort[1] === true || sort[1] === "desc";
    } else if (_.isObject(sort)) {
      columnId = sort.column;
      desc = sort.desc === true || sort.desc === "desc";
    } else {
      columnId = 0;
      desc = false;
    }
    return {
      column: columnId,
      desc: desc
    };
  }

  // cleanup / disposal

  ctrl.dispose = function () {
    stopAutoScroll();
    renderer && renderer.clearContent(false);
    unbindVisibilityHandler && unbindVisibilityHandler();
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/infiniTable.js", __webpack_require__(1), __webpack_require__(3), __webpack_require__(4)))

/***/ }),
/* 2810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("infiniTableConfigManager", function () {
  var stateManager = null;
  return {
    /**
     * 
     * @param provider
     */
    setTableStateManager: function setTableStateManager(provider) {
      stateManager = provider;
    },
    getTableStateManager: function getTableStateManager() {
      return stateManager;
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/infiniTableConfigManager.js"))

/***/ }),
/* 2811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("itDefaultConfig", function () {
  // Unused, only for documentation
  var columnOptions = {
    // the unique ID for this column. if unset a default id will be generated
    id: 'myId',
    // the attribute associated with this column. It can be nested.
    // by default (unless `expression` or `template` is provided), this is what will be displayed in the cell
    // note that is is also used for
    attribute: 'some.attribute',
    // the type of the data to render. Currently only used for sorting and footer data aggregation features.
    dataType: 'number',
    // allow to use an angular filter when rendering in `attribute` mode.
    // has no effect for `expression` and `template` modes
    filter: 'montant:2',
    // takes precedence over attribute if present, used for more complex display
    expression: '{{$index + 1}} {{model.Attribute}}',
    // most advanced rendering option. Accepts a plain angular template that will be compiled
    template: "<div>{model.attribute}</div>",
    // if true, attribute and expression rendering mode will be using active watchers
    // instead of one-shot interpolation.
    // this has no effect when `template` is provided
    watch: false,
    // the title to be displayed on the header cell
    // can be either a string, or an array of string for multi-line titles
    title: 'My Column',
    // displays a tooltip when hovering over the header cell.
    // can either be a string or plain html (this will NOT be compiled)
    tooltip: 'Some tooltip',
    // if config.sortable OR column.sortable is true, the column will allow sorting
    sortable: true,
    // can be either a string identifying the type of the data for the sorting method,
    // or a function to use for sorting ( (a, b) => +-1 )
    // note that if not provided, 'dataType' will be used instead if present
    // see `itSortFactory`
    sortType: 'string',
    // custom class to append to the cell (TD) element. Mostly used for text-align.
    cellClass: 'align-r',
    // set to true to enabled footer data aggregation. `config.footer` must be set.
    // when enabled, it will use the default reducer for the specified `dataType` unless `footerReducer` is set.
    footer: false,
    // when set, will override the default data aggregator / reducer used for footer value computation
    // this can either be a string (id of the reducer in `itFooterAccumulator`), or a function of the form
    footerReducer: function footerReducer(data, attribute) {
      return _.reduce(data, function (sum, current) {
        return sum + _.get(current, attribute);
      }, 0);
    },
    // allow to specify specific css class for the footer cell. If unset, will defaults to `cellClass`
    footerCellClass: 'my-class',
    // allow to specify a specific filter for the footer cell rendering. if unset, will use `filter`
    // has no effect if `footerTemplate` is provided
    footerFilter: 'montant',
    // allow to specify a template for the footer cell rendering. you can also refere tu footerValues['col-anotherTotalColumn'] to get other columns values values
    footerTemplate: "<div>Somme: {{footerValue}}</div>",
    // if config.resizable is true, the column can be resized unless column.resizable is false
    resizable: true,
    // if config.reorderable is true, the column can be reordered unless column.reorderable is false
    reorderable: true
  };
  return {
    type: "table",
    // "table" / "tree"
    // row selection
    allowSelection: false,
    selectionAttribute: null,
    // attribute to set / get selected model from / to.
    selectionScope: null,
    // the scope to get / set selection attribute from/to . Defaulting to the table parent scope.
    // sorting
    sortable: false,
    // config.sortable || column.sortable
    initialSort: null,
    // initial sorting column and order. either the index of the column or a tuple [columnIdx, "desc" | "asc"]
    keepIndexOnSort: false,
    // do we stay at current index after sorting or do we go back to index 0 ?
    persistSort: true,
    // if true and table has a specified id, will pe
    // global events
    onScrollChange: null,
    // handler called when table render change (scroll, resize, dataSource change...) called with pagination as first parameter and ordered dataSource as second
    keepIndexOnReload: false,
    initialScroll: 0,
    // can be either a model, an index or a function given dataSource as only parameter and returning a model or an index.
    // row events
    hoverClass: null,
    onRowClick: null,
    onRowEnter: null,
    onRowLeave: null,
    eventApplyScope: null,
    // scope used for the apply of delegated event handler. Defaulting to the table scope.
    // Row management - cleanup & precompilation
    maxWatchers: 600,
    // maximum number of watcher, after what the table will start to cleanup undisplayed rows.
    countRootWatchers: false,
    // if true, will count the rootScope's watchers instead of the table's.
    rowManagementCycleInterval: 200,
    // interval between cleanup / precompilation cycles
    preloadedPageCount: 1,
    // number of pages before/after current displayed data to preload
    rowPerManagementCycle: 3,
    // max number of row to compile/destroy per cycle
    // general config
    watch: false,
    // if set to true, the column definition using attribute (and optionally filter) will watch for changes. Else the value expression will only be interpolated once, at row creation
    height: 500,
    // default height for the table is no sizing directive is used
    columnGroups: [],
    // columns group for column toggle features.
    // scrollbar config
    scrollbarWidth: 12,
    // width of the scrollbar. can be overridden for theming
    scrollbarThumbMinHeight: 20,
    // min height of the scrollbar thumb
    scrollbarThumbMaxHeight: null,
    // max height of the scrollbar thumb
    // templates
    headerGroupRowTemplate: '<tr class="it-group-row"></tr>',
    headerGroupCellTemplate: '<th class="it-group-cell"></th>',
    headerRowTemplate: '<tr class="it-header-row"></tr>',
    headerCellTemplate: '<th class="it-header-cell"></th>',
    contentHeaderCellTemplate: '<th class="body-header"></th>',
    rowTemplate: '<tr></tr>',
    cellTemplate: '<td></td>',
    footerRowTemplate: '<tr class="it-footer-row"></tr>',
    footerCellTemplate: '<td class="it-footer-cell"></td>',
    // directives
    headerCellDirective: "it-header-cell",
    headerGroupCellDirective: "it-header-group-cell",
    rowDirective: "it-row",
    footerRowDirective: 'it-footer-row',
    footerCellDirective: 'it-footer-cell',
    // footer
    footer: false,
    // either 'static' (fixed at the bottom), 'inline' (with data rows), or false (disabled)
    // visibility management
    visibilityManager: null,
    // to handle visibility management. must be an object implementing isVisible() and onVisibilityChange()
    // state management
    stateManager: null,
    // to manage persisted state of the table. see infiniTableConfigManager

    subtotalRowTemplate: '<tr class="it-subtotal-row"></tr>',
    subtotalCellTemplate: '<td class="it-subtotal-cell"></td>',
    subtotalRowDirective: 'it-subtotal-row',
    subtotalCellDirective: 'it-subtotal-cell'
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/standard/itDefaultConfig.js", __webpack_require__(1)))

/***/ }),
/* 2812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * it-footer-cell
 * On rend accesible dans le scope du template 'footerValue' et footerValues'
 */
ngModule.directive('itFooterCell', function () {
  return {
    restrict: "A",
    require: "^infiniTable",
    scope: false,
    link: function link($scope, $el, $attrs, tableCtrl) {
      var column = $scope.column;
      if (column.footer) {
        var setFooterValue = function setFooterValue(footerValues) {
          $scope.footerValue = footerValues ? footerValues[column.id] : undefined;
          // on met aussi l'ensemble des values des autres colonnes de total accessibles

          // on reconverti en tableau car footerValues est un objet et cela le rend compliqué à accéder sinon.
          var result = [];
          Object.keys(footerValues).forEach(function (key) {
            result[key] = footerValues[key];
          });
          $scope.footerValues = result;
        };

        // initial set before watch to be on time for initial column width computation
        setFooterValue(tableCtrl.getContext().footerValues);
        $scope.$watch(function () {
          return tableCtrl.getContext().footerValues;
        }, setFooterValue);
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/standard/itFooterCell.js"))

/***/ }),
/* 2813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * IT Footer Row
 */
ngModule.directive('itFooterRow', function () {
  return {
    restrict: "A",
    require: "^infiniTable",
    scope: true,
    link: function link($scope, $el, $attrs, tableCtrl) {
      var context = tableCtrl.getContext();
      var footerCellLinker = tableCtrl.linkers.footerCell;
      _.each(context.visibleColumns, function (computed) {
        var column = computed.column;
        var cellScope = $scope.$new();
        cellScope.column = computed;

        // add header row cell
        footerCellLinker(cellScope, function (footerCell) {
          computed.footerCellInjector(cellScope, footerCell);
          if (column.footerCellClass != null) {
            footerCell.addClass(column.footerCellClass);
          } else if (column.cellClass) {
            footerCell.addClass(column.cellClass);
          }
          computed.footerCell = footerCell;
          footerCell.appendTo($el);
        });
      });
      $('<td class="scrollbar">').appendTo($el);
    },
    controller: ["$scope", function controller($scope) {}]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/standard/itFooterRow.js", __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 2814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * IT Body Row
 */
ngModule.directive('itRow', ["$compile", "$interpolate", "scopeUtils", function ($compile, $interpolate, scopeUtils) {
  return {
    restrict: "A",
    require: "^infiniTable",
    scope: true,
    link: function link($scope, $el, $attrs, tableCtrl) {
      var context = tableCtrl.getContext(),
        config = tableCtrl.getConfig(),
        model = $scope.model;

      // row selection. See itRowSelectionFeature.
      if (config.allowSelection) {
        $el.addClass("it-selectable-row");
        $scope.$watch(function () {
          return tableCtrl.getRowSelection();
        }, function (selection) {
          if (selection === model ||
          // pour les tree
          selection && selection.$node && selection.model === model) {
            $el.addClass("it-selected");
          } else {
            $el.removeClass("it-selected");
          }
        });
      }

      // row construction
      var constructRow = function constructRow() {
        // creating cells
        _.each(context.columns, function (computed) {
          if (!computed.visible) {
            return;
          }
          var cellInjector = computed.cellInjector;
          cellInjector($el, $scope);
        });

        // adding scrollbar cell
        $('<td class="scrollbar"></td>').appendTo($el);

        // force digest of the row scope to interpolate values.
        // needed for height calculation)
        scopeUtils.applyWatchers($scope);
      };

      // perform initialisation
      constructRow();
    },
    controller: ["$scope", function controller($scope) {
      // TODO (?)
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/standard/itRow.js", __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 2815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * it-subtotal-cell
 */
ngModule.directive('itSubtotalCell', function () {
  return {
    restrict: "A",
    require: "^infiniTable",
    scope: false,
    link: function link($scope, $el, $attrs, tableCtrl) {
      var column = $scope.column;
      if (column.subtotal) {
        var setSubtotalValue = function setSubtotalValue(subtotalValues) {
          $scope.subtotalValue = subtotalValues ? subtotalValues[$scope.model.id][column.id] : undefined;
        };

        // initial set before watch to be on time for initial column width computation
        setSubtotalValue(tableCtrl.getContext().subtotalValues);
        $scope.$watch(function () {
          return tableCtrl.getContext().subtotalValues;
        }, setSubtotalValue);
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/standard/itSubtotalCell.js"))

/***/ }),
/* 2816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * IT subtotal Row
 */
ngModule.directive('itSubtotalRow', function () {
  return {
    restrict: "A",
    // require: "^infiniTable" est problématique car la ligne est "linkée" avant d'être ajoutée au DOM,
    // le controller parent ne peut donc pas être trouvé.
    // A la place, on récupère le controller via le scope, car il est exposé avec `controllerAs: '$tableCtrl'`
    // sur la directive infiniTable.
    scope: true,
    link: function link($scope, $el, $attrs) {
      var tableCtrl = $scope.$tableCtrl;
      if (!tableCtrl) {
        console.error("itSubtotalRow: Le contrôleur infiniTable n'a pas été trouvé sur le scope.");
        return;
      }
      var context = tableCtrl.getContext();
      var config = tableCtrl.getConfig();
      var subtotalCellLinker = tableCtrl.linkers.subtotalCell;

      // permet de sauter autant de colonne que mise en colspan
      var nbcolspan = 0;
      _.each(context.visibleColumns, function (computed) {
        var column = computed.column;
        var cellScope = $scope.$new();
        cellScope.column = computed;
        if (nbcolspan === 0) {
          // add subtotal row cell
          subtotalCellLinker(cellScope, function (subtotalCell) {
            computed.subtotalCellInjector(cellScope, subtotalCell);
            if (column.subtotalCellClass != null) {
              subtotalCell.addClass(column.subtotalCellClass);
            } else if (column.cellClass) {
              subtotalCell.addClass(column.cellClass);
            }
            if (column.subtotalColspan) {
              subtotalCell.attr('colspan', column.subtotalColspan);
              nbcolspan = column.subtotalColspan - 1;
            }
            computed.subtotalCell = subtotalCell;
            subtotalCell.appendTo($el);
          });
        } else {
          nbcolspan--;
        }
      });

      // row selection. See itRowSelectionFeature.
      if (config.allowSubtotalRowSelection) {
        $el.addClass("it-selectable-row");
        $scope.$watch(function () {
          return tableCtrl.getRowSelection();
        }, function (selection) {
          if (selection === $scope.model ||
          // pour les tree
          selection && selection.$node && selection.model === $scope.model) {
            $el.addClass("it-selected");
          } else {
            $el.removeClass("it-selected");
          }
        });
      }
      var cell = '<td class="scrollbar">';
      $(cell).appendTo($el);
    },
    controller: ["$scope", function controller($scope) {}]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/standard/itSubtotalRow.js", __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 2817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("itTableRenderer", ["itDefaultConfig", "itRowPrecompiler", "itRenderingFn", "$timeout", function (itDefaultConfig, itRowPrecompiler, itRenderingFn, $timeout) {
  // Inject $timeout

  return function itTableRenderer(tableCtrl) {
    var renderer = this,
      ui = tableCtrl.ui,
      $scope = tableCtrl.getScope(),
      displayedRows = [],
      compiledRows = [],
      renderingFn = itRenderingFn(tableCtrl, renderer),
      rowCompiler = new itRowPrecompiler(tableCtrl, renderer);
    renderer.processConfiguration = function (tableConfig) {
      return _.extend({}, angular.copy(itDefaultConfig), tableConfig);
    };
    renderer.getDisplayedRows = function () {
      return displayedRows;
    };
    renderer.getCompiledRows = function () {
      return compiledRows;
    };
    renderer.getActualSource = function () {
      return tableCtrl.getDataSource();
    };
    renderer.getActualLength = function () {
      return tableCtrl.getDataSource().length;
    };
    renderer.clearContent = function (reinit) {
      var row;
      for (var i = 0; i < compiledRows.length; i++) {
        row = compiledRows[i];
        if (row) {
          row.scope() && row.scope().$destroy();
          row.remove();
        }
      }
      rowCompiler.stop();
      tableCtrl.context.pagination = {};
      displayedRows.splice(0, displayedRows.length);
      tableCtrl.ui.contentBody.empty();
      if (reinit) {
        compiledRows = new Array(renderer.getActualLength());
      }
    };
    renderer.getOrCreateRow = function (i) {
      return compiledRows[i] || renderer.createRow(i, false);
    };
    var getRowLinker = function getRowLinker(model) {
      // peut arriver sur le detachement
      if (model == null) {
        return null;
      }
      switch (model.__type__) {
        case 'footer':
          return tableCtrl.linkers.footerRow;
        case 'subtotal':
          return tableCtrl.linkers.subtotalRow;
        default:
          return tableCtrl.linkers.row;
      }
    };
    renderer.createRow = function (i, detach) {
      // console.log("creating row for index = ", i);

      var rowModel = tableCtrl.getDataSource()[i];
      var rowScope = $scope.$new();
      rowScope.model = rowModel;
      rowScope.$index = i;
      rowScope.$first = i === 0;
      rowScope.$last = i === tableCtrl.getDataSource().length - 1;
      rowScope.$middle = !rowScope.$first && !rowScope.$last;
      var row = null;
      var rowLinker = getRowLinker(rowModel);
      if (rowLinker == null) {
        return;
      }
      rowLinker(rowScope, function (_row) {
        row = _row;
        // Add a specific class for subtotal rows
        if (rowModel.__type__ === 'subtotal') {
          row.addClass('it-subtotal-row');
        }
        ui.contentBody.append(row);
        // Apply sticky styles to the newly created row
        $timeout(function () {
          // Wrap in $timeout
          tableCtrl.applyStickyStylesToRow(row);
        }, 0);
      });
      compiledRows[i] = row;
      if (detach) {
        row.detach();
      }
      return row;
    };
    renderer.deleteRow = function (i) {
      var row = compiledRows[i];
      if (!row) {
        return;
      }
      row.scope() && row.scope().$destroy();
      row.remove();
      compiledRows[i] = null;
    };
    renderer.setScrollPosition = function (options) {
      renderingFn(options);
      // reset the row pre-compiler
      rowCompiler.reset(); // TODO : add debounce / throttle on managemennt process restart
    };
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/standard/itTableRenderer.js", __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 2818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("taelTableStateManager", ["$http", function ($http) {
  var tableStateMap = {};
  function loadTableStates() {
    return $http.get("/rest/infinitable/table-states").then(function (response) {
      tableStateMap = _.chain(response.data).map(function (tableConfig) {
        return [tableConfig.tableId, tableConfig];
      }).fromPairs().value();
    });
  }
  function saveTableState(tableId) {
    // TODO : deferred ?
    return $http.post("/rest/infinitable/table-state/save", tableStateMap[tableId]).then(function (response) {
      return response.response;
    });
  }
  return {
    $load: function $load() {
      return loadTableStates();
    },
    handleConfig: function handleConfig(tableConfig) {
      return !tableConfig.generatedId;
    },
    getTableState: function getTableState(tableId) {
      return tableStateMap[tableId] || {};
    },
    setTableState: function setTableState(tableId, tableState) {
      tableState.tableId = tableId;
      tableStateMap[tableId] = tableState;
      saveTableState(tableId);
    }
  };
}]);
ngModule.run(["taelTableStateManager", "infiniTableConfigManager", function (taelTableStateManager, infiniTableConfigManager) {
  infiniTableConfigManager.setTableStateManager(taelTableStateManager);
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/taelTableStateManager.js", __webpack_require__(1)))

/***/ }),
/* 2819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, angular, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

// TODO : wire row compiler eventually.

ngModule.factory("itTreeRenderer", ["itTreeDefaultConfig", "itRenderingFn", "infiniTableConfigManager", function (itTreeDefaultConfig, itRenderingFn, infiniTableConfigManager) {
  return function itTreeRenderer(tableCtrl) {
    var renderer = this,
      ui = tableCtrl.ui,
      $scope = tableCtrl.getScope(),
      $el = tableCtrl.getElement(),
      renderingFn = itRenderingFn(tableCtrl, renderer),
      tree = [],
      flattenedTree = [],
      displayedRows = [],
      innerState = {
        expanded: false,
        collapsed: false
      },
      idMap = {};
    var stateManager = infiniTableConfigManager.getTableStateManager();
    var tableState = null;
    var isStateManaged = false;
    $el.addClass("it-tree-table");
    function refreshInnerState() {
      var allCollapse = true;
      var allExpanded = true;
      var _isWholeBranchExpanded = function isWholeBranchExpanded(node) {
        if (renderer.hasChildren(node)) {
          if (node.expanded) {
            for (var i = 0; i < node.children.length; i++) {
              if (!_isWholeBranchExpanded(node.children[i])) {
                return false;
              }
            }
          } else {
            return false;
          }
        }
        return true;
      };
      for (var i = 0; i < tree.length; i++) {
        var node = tree[i];
        if (node.expanded === true) {
          // for collapse we only need to check first level.
          allCollapse = false;
        }
        if (allExpanded && !_isWholeBranchExpanded(node)) {
          allExpanded = false;
        }
      }
      innerState = {
        expanded: allExpanded,
        collapsed: allCollapse
      };
    }
    renderer.isAllExpanded = function () {
      return innerState.expanded;
    };
    renderer.isAllCollapsed = function () {
      return innerState.collapsed;
    };
    renderer.collapseAllRows = function () {
      _.each(tree, function (data, key) {
        renderer.collapseNode(data.nodeId, true, true, true);
      });
      if (isStateManaged) {
        stateManager.setTableState(tableCtrl.getConfig().id, tableState);
      }
      recomputeAndRender();
    };
    renderer.expandAllRows = function () {
      _.each(tree, function (data, key) {
        renderer.expandNode(data.nodeId, true, true, true);
      });
      if (isStateManaged) {
        stateManager.setTableState(tableCtrl.getConfig().id, tableState);
      }
      recomputeAndRender();
    };
    renderer.processConfiguration = function (tableConfig) {
      var mergedConfig = _.extend({}, angular.copy(itTreeDefaultConfig), tableConfig);

      // adding the tree column !
      var compiler = tableCtrl.getCompiler();
      var treeColumn = mergedConfig.treeColumn;
      var treeCellContentLink = compiler.makeCellContentInjector(treeColumn, mergedConfig);
      var hideSpacers = mergedConfig.showSpacers === false;
      _.extend(treeColumn, {
        linker: function itTreeColumnLinker(rowEl, rowScope) {
          var linkers = tableCtrl.linkers;
          if (rowScope.model && rowScope.model.children == null) {
            rowEl.addClass("it-tree-leaf");
          } else {
            rowEl.addClass("it-tree-node");
          }
          rowEl.addClass("it-tree-row depth-" + rowScope.depth);
          linkers.mainCell(rowScope, function (mainCell) {
            mainCell.appendTo(rowEl);

            //let treeCellWrapper = $('<div class="it-tree-cell-wrapper"></div>').appendTo(mainCell);

            linkers.nodeCell(rowScope, function (nodeCell) {
              nodeCell.appendTo(mainCell);
            });
            var treeCellContent = $('<div class="it-tree-cell-content"></div>').appendTo(mainCell);
            treeCellContent.css({
              "padding-left": (rowScope.depth + 1) * 24 + (hideSpacers ? 0 : 7) + "px"
            });
            treeCellContentLink(rowScope, treeCellContent);
          });
        }
      });
      mergedConfig.columns = mergedConfig.otherColumns;
      mergedConfig.columns.splice(0, 0, treeColumn);

      // state manager
      if (mergedConfig.stateManager != null) {
        stateManager = mergedConfig.stateManager;
      }
      isStateManaged = stateManager.handleConfig(mergedConfig);
      if (isStateManaged) {
        tableState = stateManager.getTableState(mergedConfig.id);
      }
      return mergedConfig;
    };

    //////

    var prepareDataSource = function prepareDataSource() {
      var dataSource = tableCtrl.getDataSource();
      var config = tableCtrl.getConfig();
      var initialDepth = _.result(config, "initialDepth");
      tree = [];
      flattenedTree = [];
      idMap = {};
      _.each(dataSource, function (model) {
        var data = prepareItem(model, null, initialDepth);
        tree.push(data);
      });
      recomputeFlattenedTree();
      renderer.refreshSpacers();
    };
    var prepareItem = function prepareItem(model, parentData, recurseToDepth) {
      var depth = parentData ? parentData.depth + 1 : 0;
      var expanded = recurseToDepth && recurseToDepth > depth;

      // Restore state if available
      if (isStateManaged && tableState && tableState.expandedNodes) {
        var nodeId = model[tableCtrl.getConfig().idAttribute];
        if (tableState.expandedNodes[nodeId]) {
          expanded = true;
        }
      }
      var data = {
        nodeId: _.uniqueId("node-"),
        model: model,
        row: null,
        depth: depth,
        parent: parentData || null,
        expanded: expanded,
        childrenLoaded: false,
        children: null
      };
      idMap[data.nodeId] = data;
      if (expanded) {
        loadChildren(data, recurseToDepth);
      }
      return data;
    };
    var loadChildren = function loadChildren(parentData, recurseToDepth) {
      parentData.children = [];
      var childrenModels = parentData.model[tableCtrl.getConfig().childrenAttribute];
      _.each(childrenModels, function (model) {
        var childData = prepareItem(model, parentData, recurseToDepth);
        parentData.children.push(childData);
      });
      parentData.childrenLoaded = true;
    };
    var recomputeFlattenedTree = function recomputeFlattenedTree() {
      flattenedTree = [];
      var _flattenNode = function flattenNode(data) {
        flattenedTree.push(data);
        if (data.expanded) {
          _.each(data.children, function (child) {
            _flattenNode(child);
          });
        }
      };
      _.each(tree, _flattenNode);
      return flattenedTree;
    };

    // TODO : handle recursive

    renderer.expandNode = function (nodeId, recursive, noRender, noStateSave) {
      var nodeData = idMap[nodeId];
      if (!nodeData.childrenLoaded) {
        loadChildren(nodeData);
      }
      nodeData.expanded = true;
      if (isStateManaged) {
        updateState(nodeData.model, true, noStateSave);
      }
      if (recursive) {
        _.each(nodeData.children, function (child) {
          return renderer.expandNode(child.nodeId, true, true, noStateSave);
        });
      }
      if (!noRender) {
        recomputeAndRender();
      }
    };
    renderer.collapseNode = function (nodeId, recursive, noRender, noStateSave) {
      var nodeData = idMap[nodeId];
      nodeData.expanded = false;
      if (isStateManaged) {
        updateState(nodeData.model, false, noStateSave);
      }
      if (recursive) {
        _.each(nodeData.children, function (child) {
          return renderer.collapseNode(child.nodeId, true, true, noStateSave);
        });
      }
      if (!noRender) {
        recomputeAndRender();
      }
    };
    function updateState(model, expanded, noSave) {
      if (!tableState.expandedNodes) {
        tableState.expandedNodes = {};
      }
      var nodeId = model[tableCtrl.getConfig().idAttribute];
      if (expanded) {
        tableState.expandedNodes[nodeId] = true;
      } else {
        delete tableState.expandedNodes[nodeId];
      }
      if (!noSave) {
        stateManager.setTableState(tableCtrl.getConfig().id, tableState);
      }
    }
    function recomputeAndRender() {
      var newFirstNodeId = getClosestVisible(tableCtrl.context.pagination.first);
      recomputeFlattenedTree();
      var newIndex = _.findIndex(flattenedTree, function (node) {
        return node.nodeId === newFirstNodeId;
      });
      renderer.setScrollPosition({
        index: newIndex
      });
      renderer.refreshSpacers();
      tableCtrl.refreshColumnsSizing();
      tableCtrl.getScrollBar().refresh(true);
    }
    function getClosestVisible(index) {
      var node = flattenedTree[index];
      while (node && !node.expanded && node.depth > 0) {
        node = node.parent;
      }
      return node.nodeId;
    }
    renderer.getDisplayedRows = function () {
      return displayedRows;
    };
    renderer.getActualSource = function () {
      return flattenedTree;
    };
    renderer.getActualLength = function () {
      return flattenedTree.length;
    };
    renderer.hasChildren = function (node) {
      var children = node.model[tableCtrl.getConfig().childrenAttribute];
      return children && children.length;
    };
    renderer.refreshSpacers = function () {
      var _refreshRepeatMeta = function refreshRepeatMeta(nodeList, recurse) {
        _.each(nodeList, function (childNode, i) {
          childNode.$node = {};
          childNode.$node.$index = i;
          childNode.$node.$first = i === 0;
          childNode.$node.$last = i === nodeList.length - 1;
          childNode.$node.$middle = !(childNode.$node.$first || childNode.$node.$last);
          if (recurse && childNode.childrenLoaded) {
            _refreshRepeatMeta(childNode.children, recurse);
          }
        });
      };
      _refreshRepeatMeta(tree, true);
      $scope.$broadcast("recompute-spacer");
    };
    renderer.clearContent = function (reinit) {
      _.each(idMap, function (node) {
        if (node.scope) {
          node.scope.$destroy();
          node.row.remove();
        }
      });

      // rowCompiler.stop();

      tableCtrl.context.pagination = {};
      tree = [];
      flattenedTree = [];
      idMap = {};
      displayedRows = [];
      tableCtrl.ui.contentBody.empty();
    };
    renderer.getOrCreateRow = function (i) {
      var data = flattenedTree[i];
      if (!data.row) {
        renderer.createRow(i);
      }
      return data.row;
    };
    renderer.createRow = function (i, detach) {
      var data = flattenedTree[i];
      var model = data.model;
      var rowScope = $scope.$new();
      _.extend(rowScope, {
        nodeId: data.nodeId,
        depth: data.depth,
        data: data,
        model: model,
        $index: i
      });
      var row = null;
      tableCtrl.linkers.row(rowScope, function (_row) {
        row = _row;
        ui.contentBody.append(row);
      });
      _.extend(data, {
        row: row,
        scope: rowScope
      });
      if (detach) {
        if (row != null) row.detach();
      }
      return row;
    };
    renderer.deleteRow = function (i) {
      var node = flattenedTree[i];
      if (!node || !node.scope) {
        return;
      }
      node.scope.$destroy();
      node.row.remove();
    };
    renderer.setScrollPosition = function (options) {
      if (options.initial) {
        // TODO : find more graceful way to init dataSource.
        prepareDataSource();
      }
      refreshInnerState();
      renderingFn(options);
    };
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/tree/itTreeRenderer.js", __webpack_require__(1), __webpack_require__(3), __webpack_require__(4)))

/***/ }),
/* 2820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("itTreeDefaultConfig", ["itDefaultConfig", function (itDefaultConfig) {
  return _.extend(angular.copy(itDefaultConfig), {
    type: "tree",
    initialDepth: 0,
    // the initial depth level to be opened, can either be boolean (true -> all , false -> 0) a number or a function returning a number.
    // config
    idAttribute: "id",
    labelAttribute: "id",
    childrenAttribute: "children",
    // spacers
    showSpacers: true,
    // false to use only blank space as spacer.
    spacerCrossClass: "spacer-cross",
    spacerCornerClass: "spacer-corner",
    spacerLineClass: "spacer-line",
    spacerNoneClass: "spacer-none",
    // templates
    nodeCellTemplate: '<it-tree-table-node-cell></it-tree-table-node-cell>',
    mainCellTemplate: '<td class="it-tree-cell"></td>',
    mainCellContentTemplate: '<div></div>',
    spacerTemplate: '<it-tree-table-spacer></it-tree-table-spacer>',
    togglerTemplate: '<it-tree-table-row-toggler></it-tree-table-row-toggler>',
    // directives
    rowDirective: "it-row it-tree-table-row",
    /**
     * si true, alors pas de lignes tracées au niveau racine
     */
    noRootLines: false
  });
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/tree/itTreeTableDefaultConfig.js", __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 2821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("itTreeTableNodeCell", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: ["^infiniTable", "^itTreeTableRow"],
    template: '<div class="it-tree-node-prefix"></div>',
    link: function link($scope, $el, $attrs, controllers) {
      var tableCtrl = controllers[0],
        config = tableCtrl.getConfig(),
        rendered = tableCtrl.getRenderer(),
        rowCtrl = controllers[1];
      if (config.showSpacers === false) {
        $el.addClass("no-spacers");
      }
      for (var i = 0; i <= $scope.depth; i++) {
        var spacerScope = $scope.$new();
        spacerScope.$spacerIdx = i;
        tableCtrl.linkers.spacer(spacerScope, function (spacer) {
          return spacer.appendTo($el);
        });
      }
      if (rendered.hasChildren(rowCtrl.getNode())) {
        tableCtrl.linkers.toggler($scope, function (toggler) {
          return toggler.appendTo($el);
        });
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/tree/itTreeTableNodeCell.js"))

/***/ }),
/* 2822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("itTreeTableRow", function () {
  return {
    restrict: "A",
    scope: true,
    require: ["^infiniTable", "itTreeTableRow"],
    link: function link($scope, $el, $attrs, controllers) {
      var treeCtrl = controllers[0],
        rowCtrl = controllers[1];
      rowCtrl.setTableCtrl(treeCtrl);
    },
    controller: ["$scope", function controller($scope) {
      var ctrl = this,
        tableCtrl = null,
        renderer = null;
      ctrl.setTableCtrl = function (_treeCtrl) {
        tableCtrl = _treeCtrl;
        renderer = tableCtrl.getRenderer();
      };
      ctrl.getScope = function () {
        return $scope;
      };
      ctrl.getNode = function () {
        return $scope.data;
      };
      ctrl.isExpanded = function () {
        return $scope.data.expanded;
      };
      ctrl.toggleCollapse = function (recursive) {
        ctrl.isExpanded() ? ctrl.collapse(recursive) : ctrl.expand(recursive);
      };
      ctrl.expand = function (recursive) {
        renderer.expandNode($scope.data.nodeId, recursive);
      };
      ctrl.collapse = function (recursive) {
        renderer.collapseNode($scope.data.nodeId, recursive);
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/tree/itTreeTableRow.js"))

/***/ }),
/* 2823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("itTreeTableRowToggler", function () {
  var expandedClass = "fa-minus-square",
    collapsedClass = "fa-plus-square";
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: "^itTreeTableRow",
    template: '' + '<div class="row-toggler" ng-click="toggleChildren()">' + '   <i class="fa fa-plus-square"></i>' + '</div>',
    link: function link($scope, $el, $attrs, rowCtrl) {
      $scope.$watch(function () {
        return rowCtrl.isExpanded();
      }, function (expanded) {
        if (expanded) {
          $el.find("i").removeClass(collapsedClass).addClass(expandedClass);
        } else {
          $el.find("i").removeClass(expandedClass).addClass(collapsedClass);
        }
      });
      $scope.toggleChildren = function () {
        rowCtrl.toggleCollapse();
      };
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/tree/itTreeTableRowToggler.js"))

/***/ }),
/* 2824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("itTreeTableSpacer", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: ["^infiniTable", "^itTreeTableRow"],
    template: '<div class="spacer"></div>',
    link: function link($scope, $el, $attrs, controllers) {
      var tableCtrl = controllers[0],
        rowCtrl = controllers[1],
        config = tableCtrl.getConfig(),
        lastClass = null,
        depth,
        index,
        upwardCount,
        isLastSpacer,
        spacerRowMeta;
      var update = function update() {
        depth = $scope.depth;
        index = $scope.$spacerIdx;
        upwardCount = depth - index; // - 1;
        isLastSpacer = upwardCount === 0;
        var node = rowCtrl.getNode();
        for (var i = 0; i < upwardCount; i++) {
          node = node.parent;
        }
        spacerRowMeta = node.$node;
      };
      $scope.$on("recompute-spacer", function () {
        update();
        recomputeSpacer();
      });
      var recomputeSpacer = function recomputeSpacer() {
        if (!spacerRowMeta) {
          return; // TODO : see why this is appening...
        }
        var noRootLines = config.noRootLines;
        var hasNextSibling = !spacerRowMeta.$last;
        var newClass = null;
        if (isLastSpacer) {
          if (hasNextSibling) {
            if (noRootLines && depth === 0) {
              newClass = config.spacerNoneClass;
            } else {
              newClass = config.spacerCrossClass;
            }
          } else {
            if (noRootLines && depth === 0) {
              newClass = config.spacerNoneClass;
            } else {
              newClass = config.spacerCornerClass;
            }
          }
        } else {
          if (hasNextSibling) {
            if (noRootLines && depth >= 1 && index === 0) {
              newClass = config.spacerNoneClass;
            } else {
              newClass = config.spacerLineClass;
            }
          } else {
            newClass = config.spacerNoneClass;
          }
        }
        $el.removeClass(lastClass).addClass(newClass);
        lastClass = newClass;
      };
      update();
      recomputeSpacer();
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/infiniTable/tree/itTreeTableSpacer.js"))

/***/ }),
/* 2825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("directoryEditionPopinController", ["$scope", function ($scope) {
  var originalDocument = $scope.document;
  $scope.document = angular.copy(originalDocument);
  $scope.saveAndClose = function () {
    _.extend(originalDocument, $scope.document);
    $scope.$close(originalDocument);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/inventaire/documents/directoryEditionPopin.js", __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("documentEditionPopinController", ["$scope", "$http", "$dateFormat", "$q", "lovService", "$applications", function ($scope, $http, $dateFormat, $q, lovService, $applications) {
  var originalDocument = $scope.document;
  $scope.document = angular.copy(originalDocument);
  $scope.aideSubventionApplication = $applications.isAideSubventionApplication();
  $scope.typesDocumentsEcheancesIds = [];
  $q.when(lovService.getTypesDocumentsEcheancesProduitsFinanciers()).then(function (typesDocumentEcheance) {
    $scope.typesDocumentsEcheancesIds = _.map(typesDocumentEcheance, function (t) {
      return t.id;
    });
    $scope.$watch('document', function (d) {
      if (!d.tags) {
        d.tags = {};
      }
      if (!$scope.typesDocumentsEcheancesIds.includes(d.type)) {
        d.tags.DATE_ECHEANCE = null;
      }
    }, true);
  });
  $scope.dateEcheances = [];
  if (!$scope.aideSubventionApplication) {
    $http.get("/rest/fiche/echeancier/" + $scope.produitId + "/datesEcheances").then(function (response) {
      $scope.dateEcheances = _.map(response.data, function (date) {
        return {
          'date': $dateFormat.serverShort(date),
          'label': $dateFormat.short(date)
        };
      });
    });
  }
  $scope.errors = {};
  $scope.saveAndClose = function () {
    $scope.errors.label = $scope.document.label ? undefined : {
      message: "Champ obligatoire"
    };
    $scope.errors.type = $scope.document.type ? undefined : {
      message: "Champ obligatoire"
    };
    $scope.errors.url = $scope.document.url === "" ? {
      message: "Champ obligatoire"
    } : undefined;
    if (!$scope.errors.label && !$scope.errors.type && !$scope.errors.url) {
      _.extend(originalDocument, $scope.document);
      $scope.$close(originalDocument);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/inventaire/documents/documentEditionPopin.js", __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, angular, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_getNgModule__ = __webpack_require__(0);




function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_getNgModule__["a" /* default */])(__filename);
ngModule.run(["fpConfigurator", function (fpConfigurator) {
  fpConfigurator.registerTab("documentsTree", {
    label: "fiche.Documents",
    icon: "fa-list-alt",
    fragment: "documentsTree",
    controller: "InventaireDocumentTabController",
    template: __webpack_require__(907),
    invalidable: true
  });
}]);
ngModule.controller('InventaireDocumentTabController', ["$rootScope", "$scope", "$q", "$http", "$fileDownload", "$session", "$modal", "lovService", "$dialogBox", "$translate", "UUID", "documentDrop", "$location", "documentPreview", "fileUtils", "$notifications", "$authz", "$filter", "sortUtils", function ($rootScope, $scope, $q, $http, $fileDownload, $session, $modal, lovService, $dialogBox, $translate, UUID, documentDrop, $location, documentPreview, fileUtils, $notifications, $authz, $filter, sortUtils) {
  var hasRoleSaisie = $authz.hasRole('SAISIE');
  $http.get('/rest/modeles-documents/list').then(function (response) {
    // pour savoir si il y a des modeles de documents (et afficher le répertoire que si non vide)
    $scope.modelDocuments = response.data;
  });
  $scope.showFileDropOverlay = function () {
    return hasRoleSaisie && documentDrop.isActive() && $scope.docUploadAllowedIn($scope.location.node);
  };
  $scope.$watch(function () {
    return documentDrop.isActive();
  }, function (active) {
    $scope.fileDropActive = active;
  });
  var forcePageQuit = false;
  $scope.loaded = false;
  var display = {
    mode: "vignette",
    // ou "table", ou "maj"
    recursive: false,
    filter: {
      name: null,
      type: null
    }
  };
  $scope.display = display;
  var displayRecursiveSav = false;
  $scope.$watch("display.mode", function (newMode, oldMode) {
    if (oldMode === 'table') {
      displayRecursiveSav = display.recursive;
      display.recursive = false;
    } else if (newMode === 'table') {
      display.recursive = displayRecursiveSav;
    }
    refreshLocationSubNodes();
  });
  $scope.$watch("display.recursive", function () {
    refreshLocationSubNodes();
  });
  $scope.$watch("display.filter", function () {
    refreshLocationSubNodes();
  }, true);
  var baseUrl = '/rest/documents';
  $scope.compteId = $session.getCompte().id;
  $q.when(lovService.getTypesDocuments()).then(function (typesDocument) {
    $scope.typesDocument = typesDocument;
  });

  // Base de connaissance des noeuds de l'arborescence, au format ArborescenceNodeDTO :
  // id, parentId, type, label, subNodesIds, fileId, creationDate, creationUser, le témoin predefined, les stats (nb de docs, de reps, taille, en propre et récursif)
  var nodes = {};

  // Données d'affichage pour la position courante dans l'arborescence
  var location = $scope.location = {
    node: {},
    // Noeud courant
    subNodes: [],
    // Liste des sous noeuds du noeud courant, récursivement si display.recursive = true
    majNodes: [],
    // Liste des documents de tous les sous noeuds du noeud courant, récursivement, pour maj
    arianeNodes: [],
    // Liste ordonnée des noeuds du fil d'ariane (de la racine au noeud courant)
    allowedTypes: [] // Types de docs créables dans le noeud courant
  };
  $scope.location = location;
  $scope.uploadOptions = {
    url: '/rest/documents/upload',
    dropZone: '.page-inventaire-documents',
    formData: {}
  };
  $scope.filterAllowedTypes = function () {
    var allowedTypes;
    if (display.recursive) {
      var subNodes = _computeNodeSubNodes(location.node, display.recursive);
      var subNodesTypes = _.uniq(_.map(subNodes, 'type'));
      allowedTypes = _.filter($scope.typesDocument, function (e) {
        return _.includes(subNodesTypes, e.id);
      });
    } else {
      allowedTypes = location.allowedTypes;
    }
    return allowedTypes;
  };
  var refreshLocationAllowedTypes = function refreshLocationAllowedTypes() {
    location.allowedTypes = _.filter($scope.typesDocument, function (e) {
      return _.includes(location.node.allowedContent, e.id);
    });
    location.allowedTypes.push({
      id: "DIRECTORY",
      label: "Répertoire"
    });
  };
  var updateUploadOptions = function updateUploadOptions(currentNodeId) {
    $scope.uploadOptions.formData.parentNodeId = currentNodeId;
  };
  var getPath = function getPath(node, startNode) {
    var pathNodes = [];
    while (node) {
      if (startNode && node && node.id === startNode.id) {
        break;
      }
      pathNodes.push(node);
      node = nodes[node.parentId];
    }
    return pathNodes.reverse();
  };

  // Reconstruit le fil d'ariane
  var refreshLocationArianeEntries = function refreshLocationArianeEntries() {
    if ($scope.documentContext) {
      var parentId = nodes[$scope.documentContext.root].parentId;
      location.arianeNodes = getPath(location.node, {
        id: parentId
      });
    } else {
      location.arianeNodes = getPath(location.node);
    }
  };
  var _computeNodeSubNodes = function computeNodeSubNodes(node, recursive) {
    var recursiveSubNodes = [];
    if (node.subNodesIds) {
      for (var j = 0; j < node.subNodesIds.length; j++) {
        var subNode = nodes[node.subNodesIds[j]];
        if (subNode != null) {
          if (subNode.type === 'DIRECTORY') {
            recursiveSubNodes.push(subNode);
            if (recursive) {
              recursiveSubNodes.push.apply(recursiveSubNodes, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(_computeNodeSubNodes(subNode, true)));
            }
          } else {
            recursiveSubNodes.push(subNode);
          }
        }
      }
    }
    return recursiveSubNodes;
  };
  var refreshLocationSubNodes = function refreshLocationSubNodes() {
    var newSubNodes = _computeNodeSubNodes(location.node, display.recursive);
    newSubNodes = _.filter(newSubNodes, function (node) {
      var kept = true;
      if ($scope.display.filter.name) {
        kept = node.label.toLowerCase().includes($scope.display.filter.name.trim().toLowerCase());
      }
      if ($scope.display.filter.type) {
        kept = kept && node.type === $scope.display.filter.type;
      }
      return kept;
    });
    location.subNodes = newSubNodes.map(function (node) {
      return _objectSpread({}, node, {
        tags: node.tags ? _objectSpread({}, node.tags) : null
      });
    });
    _.forEach(location.subNodes, function (node) {
      var chemin = getPath(node, location.node);
      node.completePathlabel = _.map(chemin, function (path) {
        return path ? path.label : "";
      }).join(' > ');
      chemin.pop(); // Supprimer le nom du fichier lui-même pour ne garder que son chemin
      node.pathlabel = _.map(chemin, function (path) {
        return path ? path.label : "";
      }).join(' > ');
    });
    location.subNodes.sort(sortUtils.alphanumCompartorBuilder('completePathlabel'));
    buildDocumentsTableOptions();
  };
  var doNavigateTo = $scope.navigateTo = function (nodeId) {
    location.node = nodes[nodeId];
    refreshLocationArianeEntries();
    refreshLocationSubNodes();
    refreshLocationAllowedTypes();
    updateUploadOptions(nodeId);
    if ($scope.display.mode == 'maj') {
      computeMajData();
    }
  };
  var navigateTo = $scope.navigateTo = function (nodeId) {
    var showDialog = $scope.display.mode == 'maj' && $scope.hasDirty();
    if (showDialog) {
      event.preventDefault();
      $dialogBox.confirm({
        title: "Mises à jour non sauvegardées",
        text: "La page comporte des mises à jour non sauvegardées. Si vous quittez maintenant, " + "toutes les modifications seront perdues. Êtes-vous sûr de vouloir quitter ?"
      }).then(function () {
        doNavigateTo(nodeId);
      });
    } else {
      doNavigateTo(nodeId);
    }
  };
  $http.get('/rest/documents/arborescence').then(function (response) {
    nodes = response.data.nodes;
    if ($scope.documentContext) {
      navigateTo($scope.documentContext.root);
    } else {
      navigateTo(response.data.defaultNodeId);
    }
    $scope.loaded = true;
  });
  $scope.downloadDocument = function (document) {
    $fileDownload.start('/rest/documents/download/' + document.id);
  };
  var zipDownloadPopinOptions = {
    controller: "zipDownloadPopinController",
    template: __webpack_require__(3696),
    options: {
      width: 800
    }
  };
  $scope.downloadZIP = function () {
    var node = nodes[location.node.id];
    var parentNode = nodes[location.node.parentId];
    return $modal.open(_.extend(zipDownloadPopinOptions, {
      scope: $scope,
      vars: {
        nodeId: node.id,
        nbDocs: node.nbDocs,
        nbDocsRec: node.nbDocsRec,
        size: node.size,
        sizeRec: node.sizeRec
      }
    }));
  };
  var editionPopinOptions = {
    controller: "documentEditionPopinController",
    template: __webpack_require__(3694),
    options: {
      width: 600
    }
  };
  var openEditionPopin = function openEditionPopin(document, initial, allowedContent) {
    var popinOptionsCopy = angular.copy(editionPopinOptions);
    return $modal.open(_.extend(popinOptionsCopy, {
      scope: $scope,
      vars: {
        document: document,
        produitId: location.arianeNodes[location.arianeNodes.length - 1].id,
        initial: initial,
        allowedTypes: _.filter($scope.typesDocument, function (e) {
          return _.includes(allowedContent, e.id);
        })
      }
    }));
  };
  var removeDocFromDirectory = function removeDocFromDirectory(node, directoryId) {
    var parentNode = nodes[directoryId];
    parentNode.subNodesIds = _.without(parentNode.subNodesIds, node.id);
    parentNode.nbDocs -= node.nbDocs;
    parentNode.nbReps -= node.nbReps;

    // par convention, le size d'un dossier est la somme des tailles des fichiers qu'il contient'
    parentNode.size -= node.size;

    // Mise à jour des stats
    while (parentNode != null) {
      parentNode.nbDocsRec -= node.nbDocsRec;
      parentNode.nbRepsRec -= node.nbRepsRec;
      parentNode.sizeRec -= node.sizeRec;
      parentNode = nodes[parentNode.parentId];
    }
  };
  var addDocToDirectory = function addDocToDirectory(node, directoryId) {
    var parentNode = nodes[directoryId];
    var currentNode = nodes[node.id];
    parentNode.subNodesIds.push(node.id);
    currentNode.parentId = directoryId;
    currentNode.rootId = findRootIdForChildOf(directoryId);
    if (!currentNode.creationDate) {
      currentNode.creationDate = moment();
    }
    if (!currentNode.creationUser) {
      currentNode.creationUser = $session.getUser().denomination;
    }
    parentNode.nbDocs += node.nbDocs;
    parentNode.nbReps += node.nbReps;

    // par convention, le size d'un dossier est la somme des tailles des fichiers qu'il contient'
    parentNode.size += node.size;

    // Mise à jour des stats
    while (parentNode != null) {
      parentNode.nbDocsRec += node.nbDocsRec;
      parentNode.nbRepsRec += node.nbRepsRec;
      parentNode.sizeRec += node.sizeRec;
      parentNode = nodes[parentNode.parentId];
    }
  };
  $scope.docUploadAllowedIn = function (node) {
    var allowedContent = node.allowedContent;
    var length = allowedContent ? allowedContent.length : 0;
    return length > _.includes(allowedContent, "DIRECTORY") ? 1 : 0;
  };
  $scope.externalDocAllowedIn = function (node) {
    return $authz.hasRole('DOCUMENTS_EXTERNES') && $scope.docUploadAllowedIn(node);
  };
  $scope.directoryCreationAllowedIn = function (node) {
    return _.includes(node.allowedContent, "DIRECTORY");
  };
  $scope.lastType = null;
  $scope.lastParentId = null;
  var uploadSequence = $q.when();
  var uploadCancelled = false;
  var pendingUploads = 0;
  $scope.nbUpload = 0;
  $scope.nbFinishedUpload = 0;
  $scope.beforeDocumentUpload = function (uploadOptions, addedFile) {
    if (pendingUploads === 0) {
      uploadCancelled = false;
    }
    pendingUploads++;
    $scope.nbUpload++;
    var nextStep = uploadSequence.then(function () {
      if (uploadCancelled) {
        return $q.reject('cancelled');
      }
      var document = {
        type: $scope.lastType,
        label: addedFile.name || $translate('documents.NouveauDocument'),
        // repertoire
        parentId: $scope.lastParentId,
        relativePath: addedFile.relativePath
      };
      return openEditionPopin(document, true, location.node.allowedContent).then(function (documentInfos) {
        if (!documentInfos) {
          return $q.reject('cancelled');
        }
        // on conserve le type choisi pour le reprooposer par defaut sur la prochaine fenetre.
        $scope.lastType = documentInfos.type;
        $scope.lastParentId = documentInfos.parentId;
        return _objectSpread({}, uploadOptions.formData, {}, documentInfos, {}, documentInfos.tags);
      }).catch(function (err) {
        console.log('reject !', err);
        uploadCancelled = true;
        return $q.reject(err);
      });
    });
    uploadSequence = nextStep.catch(function () {});
    return nextStep.finally(function () {
      pendingUploads--;
      $scope.nbFinishedUpload++;
      console.log('pendingUploads', pendingUploads);
      if (pendingUploads === 0) {
        $scope.lastType = null;
        $scope.lastParentId = null;
        $scope.nbUpload = 0;
        $scope.nbFinishedUpload = 0;
      }
    });
  };
  $scope.onDocumentUpload = function (result, config) {
    var rootId = findRootIdForChildOf(result.parentNodeId);
    var document = {
      id: result.documentId,
      type: result.type,
      label: result.fileName,
      fileId: result.fileId,
      rootId: rootId,
      nbDocs: 1,
      nbDocsRec: 1,
      nbReps: 0,
      nbRepsRec: 0,
      tags: result.tags,
      size: result.fileSize,
      sizeRec: result.fileSize,
      relativePath: config.files[0].relativePath
    };
    nodes[document.id] = document;
    addDocToDirectory(document, result.parentNodeId);
    refreshLocationSubNodes();
  };
  var isPretOuDetteDirectory = function isPretOuDetteDirectory(node) {
    return node.id.startsWith("DETTE@") || node.id.startsWith("PRET@");
  };
  var computeMajData = function computeMajData() {
    var recursiveSubNodes = _computeNodeSubNodes(location.node, true);
    recursiveSubNodes = _.filter(recursiveSubNodes, function (node) {
      return node.type !== 'DIRECTORY';
    });
    location.majNodes = recursiveSubNodes.map(function (node) {
      return _objectSpread({}, node, {
        tags: node.tags ? _objectSpread({}, node.tags) : null
      });
    });
    _.forEach(location.majNodes, function (node) {
      var chemin = getPath(node, location.node);
      node.completePathlabel = _.map(chemin, function (path) {
        return path ? path.label : "";
      }).join(' > ');
      chemin.pop(); // Supprimer le node du fichier lui-même pour ne garder que son chemin
      node.pathlabel = _.map(chemin, function (path) {
        return path ? path.label : "";
      }).join(' > ');
      var paths = getPath(node);
      node.docDetteOuPret = _.some(paths, isPretOuDetteDirectory);
    });
    location.majNodes.sort(sortUtils.alphanumCompartorBuilder('completePathlabel'));
  };
  $scope.isDirty = function (majNode) {
    var node = nodes[majNode.id];
    var nodeNonJustificatif = node.tags == null || node.tags == [] || node.tags.JUSTIFICATIF_TRESORERIE == false;
    var majNodeNonJustificatif = majNode.tags == null || majNode.tags == [] || majNode.tags.JUSTIFICATIF_TRESORERIE == false;
    return nodeNonJustificatif !== majNodeNonJustificatif;
  };
  $scope.hasDirty = function () {
    var dirty = _.some(location.majNodes, $scope.isDirty);
    return dirty;
  };
  $scope.changeDisplayMode = function (mode) {
    if (mode == 'maj') {
      computeMajData();
      $scope.display.mode = mode;
    } else {
      var showDialog = $scope.display.mode == 'maj' && $scope.hasDirty();
      if (showDialog) {
        event.preventDefault();
        $dialogBox.confirm({
          title: "Mises à jour non sauvegardées",
          text: "La page comporte des mises à jour non sauvegardées. Si vous quittez maintenant, " + "toutes les modifications seront perdues. Êtes-vous sûr de vouloir quitter ?"
        }).then(function () {
          $scope.display.mode = mode;
        });
      } else {
        $scope.display.mode = mode;
      }
    }
  };
  $rootScope.$on("$locationChangeStart", function (event, next, current) {
    var showDialog = !forcePageQuit && $scope.display.mode == 'maj' && $scope.hasDirty();
    if (showDialog) {
      event.preventDefault();
      $dialogBox.confirm({
        title: "Mises à jour non sauvegardées",
        text: "La page comporte des mises à jour non sauvegardées. Si vous quittez maintenant, " + "toutes les modifications seront perdues. Êtes-vous sûr de vouloir quitter ?"
      }).then(function () {
        forcePageQuit = true;
        $location.$$parse(next);
      });
    }
  });
  $scope.saveMaj = function () {
    var majs = [];
    _.forEach(location.majNodes, function (document) {
      if ($scope.isDirty(document)) {
        majs.push({
          id: document.id,
          label: document.label,
          type: document.type,
          url: document.url,
          tags: document.tags
        });
      }
    });
    $http.post(baseUrl + "/updates", majs).finally(function () {
      _.forEach(location.majNodes, function (document) {
        if ($scope.isDirty(document)) {
          nodes[document.id].tags = document.tags == null ? null : _objectSpread({}, document.tags);
        }
      });
    });
  };
  $scope.editDocument = function (document) {
    openEditionPopin(document, false, location.node.allowedContent).then(function () {
      $http.post(baseUrl + "/update", {
        id: document.id,
        label: document.label,
        type: document.type,
        url: document.url,
        tags: document.tags
      }).finally(function () {
        nodes[document.id] = document;
        refreshLocationSubNodes();
      });
    });
  };
  $scope.removeDocument = function (document) {
    $dialogBox.confirm({
      title: $translate("common.confirm_delete"),
      text: $translate("saisie.documents.popins.delete.text", {
        filename: document.label
      })
    }).then(function () {
      $http.post(baseUrl + "/delete", document.id).then(function () {
        removeDocFromDirectory(document, document.parentId);
        delete nodes[document.id];
        if ($scope.previewedDoc && $scope.previewedDoc.id == document.id) {
          $scope.previewedDoc = null;
        }
        $notifications.info('Document \'' + document.label + '\' supprimé.');
      }).finally(function () {
        refreshLocationSubNodes();
      });
    });
  };
  $scope.createDocumentExterne = function () {
    var document = {
      id: UUID(),
      type: null,
      label: "",
      url: "",
      nbDocs: 1,
      nbDocsRec: 1,
      nbReps: 0,
      nbRepsRec: 0,
      size: 0,
      sizeRec: 0
    };
    var parentNodeId = location.arianeNodes[location.arianeNodes.length - 1].id;
    openEditionPopin(document, true, location.node.allowedContent).then(function () {
      $http.post(baseUrl + "/add", document, {
        params: {
          parentNodeId: parentNodeId
        }
      }).then(function () {
        nodes[document.id] = document;
        addDocToDirectory(document, parentNodeId);
      }).finally(function () {
        refreshLocationSubNodes();
      });
    });
  };
  var directoryEditionPopinOptions = {
    controller: "directoryEditionPopinController",
    template: __webpack_require__(3693),
    options: {
      width: 600
    }
  };
  var openDirectoryEditionPopin = function openDirectoryEditionPopin(document, initial) {
    return $modal.open(_.extend(directoryEditionPopinOptions, {
      scope: $scope,
      vars: {
        document: document,
        initial: initial
      }
    }));
  };
  function estUnRootId(nodeId) {
    var some = _.some(nodes, function (node) {
      return node.rootId === nodeId;
    });
    return some;
  }
  function findRootIdForChildOf(nodeId) {
    var rootId = null;
    var parentId = nodeId;
    var lastParentId = parentId;
    while (rootId == null && parentId != null) {
      if (estUnRootId(parentId)) {
        rootId = parentId;
      } else {
        lastParentId = parentId;
        parentId = nodes[parentId].parentId;
      }
    }
    if (rootId == null) {
      rootId = lastParentId;
    }
    //console.log("Root trouvé : " + nodes[rootId].label + " pour " + nodes[nodeId].label);
    return rootId;
  }
  $scope.createDirectory = function () {
    var parentNodeId = location.arianeNodes[location.arianeNodes.length - 1].id;
    var rootId = findRootIdForChildOf(parentNodeId);
    var document = {
      id: UUID(),
      type: "DIRECTORY",
      nbDocs: 0,
      nbDocsRec: 0,
      nbReps: 1,
      nbRepsRec: 1,
      size: 0,
      sizeRec: 0,
      subNodesIds: [],
      allowedContent: nodes[parentNodeId].allowedContent,
      rootId: rootId
    };
    openDirectoryEditionPopin(document, true).then(function () {
      $scope.loading = true;
      $http.post(baseUrl + "/add", document, {
        params: {
          parentNodeId: parentNodeId
        }
      }).then(function () {
        nodes[document.id] = document;
        addDocToDirectory(document, parentNodeId);
      }).finally(function () {
        refreshLocationSubNodes();
        $scope.loading = false;
      });
    });
  };
  $scope.editDirectory = function (document) {
    openDirectoryEditionPopin(document, false).then(function () {
      $scope.loading = true;
      $http.post(baseUrl + "/update", {
        id: document.id,
        label: document.label
      }).then(function () {
        refreshLocationSubNodes();
      });
    }).finally(function () {
      $scope.loading = false;
    });
  };
  $scope.removeDirectory = function (document) {
    $dialogBox.confirm({
      title: $translate("common.confirm_delete"),
      text: $translate("saisie.documents.popins.delete.text", {
        filename: document.label
      })
    }).then(function () {
      $http.post(baseUrl + "/delete", document.id).then(function () {
        removeDocFromDirectory(document, document.parentId);
        delete nodes[document.id];
        refreshLocationSubNodes();
      });
    });
  };
  var moveNodePopinOptions = {
    controller: "moveNodePopinController",
    template: __webpack_require__(3695),
    options: {
      width: 800
    }
  };
  var openMoveNodePopin = function openMoveNodePopin(document) {
    return $modal.open(_.extend(moveNodePopinOptions, {
      scope: $scope,
      vars: {
        document: document
      }
    }));
  };
  var getNodeCompletePathLabel = function getNodeCompletePathLabel(node) {
    var completePath = node.label;
    var parentId = node.parentId;
    while (parentId != null) {
      var parentNode = nodes[parentId];
      completePath = parentNode.label + " -> " + completePath;
      parentId = parentNode.parentId;
    }
    return completePath;
  };
  var aPourParent = function aPourParent(node, possibleParentId) {
    var parentId = node.parentId;
    while (parentId != null) {
      if (parentId === possibleParentId) {
        return true;
      }
      parentId = nodes[parentId].parentId;
    }
  };
  $scope.moveNode = function (node) {
    var previousParentId = node.parentId;
    $scope.directories = _.map(_.filter(nodes, function (n) {
      return n.type === 'DIRECTORY' && n.id !== node.id // Pas le noeud qu'on essaie de bouger
      && n.id !== node.parentId // pas le parent actuel du noeud qu'on essaie de bouger
      && !aPourParent(n, node.id) // Pas un enfant du noeud qu'on essaie de bouger
      // Avec le même rootId ou bien dont l'id est le rootId du noeud qu'on essaie de bouger
      && (node.rootId === undefined || node.rootId === null || n.rootId === node.rootId || n.id === node.rootId);
    }), function (d) {
      return {
        id: d.id,
        label: getNodeCompletePathLabel(d)
      };
    });
    openMoveNodePopin(node).then(function () {
      if (node.parentId === '__NEW_DIR') {
        var parentNodeId = location.arianeNodes[location.arianeNodes.length - 1].id;
        var rootId = findRootIdForChildOf(parentNodeId);
        var document = {
          id: UUID(),
          type: "DIRECTORY",
          nbDocs: 0,
          nbDocsRec: 0,
          nbReps: 1,
          nbRepsRec: 1,
          size: 0,
          sizeRec: 0,
          subNodesIds: [],
          allowedContent: nodes[rootId].allowedContent,
          rootId: rootId
        };
        openDirectoryEditionPopin(document, true).then(function () {
          $scope.loading = true;
          $http.post(baseUrl + "/add", document, {
            params: {
              parentNodeId: parentNodeId
            }
          }).then(function () {
            nodes[document.id] = document;
            addDocToDirectory(document, parentNodeId);
          }).then(function () {
            node.parentId = document.id;
            removeDocFromDirectory(node, previousParentId);
            addDocToDirectory(node, node.parentId);
          }).finally(function () {
            refreshLocationSubNodes();
            $scope.loading = false;
          });
        });
      } else {
        $scope.loading = true;
        $http.post(baseUrl + "/move", node.id, {
          params: {
            newParentNodeId: node.parentId
          }
        }).then(function () {
          removeDocFromDirectory(node, previousParentId);
          addDocToDirectory(node, node.parentId);
        }).finally(function () {
          refreshLocationSubNodes();
          $scope.loading = false;
        });
      }
    });
  };
  $scope.renderType = function (document) {
    if (document.tags && document.tags.DATE_ECHEANCE) {
      return $translate("lov.typesDocuments." + document.type) + " " + $translate('lov.typesDocuments.DU', {
        'date': $filter("dateShort")(document.tags.DATE_ECHEANCE)
      });
    }
    return $translate("lov.typesDocuments." + document.type);
  };
  $scope.getDocumentIcon = function (document) {
    var ext = document.fileId == null ? null : fileUtils.getExtension(document.fileId);
    return fileUtils.getExtensionIcon(ext);
  };
  var buildDocumentsTableOptions = function buildDocumentsTableOptions() {
    $scope.documentsTableOptions = {
      source: "location.subNodes",
      sortable: true,
      initialSort: [0, "asc"],
      columns: [{
        attribute: 'completePathlabel',
        title: $translate("documents.Nom"),
        sortType: "alphanum",
        template: "\n                    <span ng-if=\"::model.type == 'DIRECTORY' \">\n                        <span ng-click=\"navigateTo(model.id)\" class=\"folder-link\">\n                            <i class=\"fa fa-folder-o\"></i>\n                            <span>{{::model.pathlabel}}{{::model.pathlabel?' > ':''}}{{::model.label}}</span>\n                        </span>\n                    </span>\n                    <span ng-if=\"::model.type != 'DIRECTORY' \">\n<!--                        <i class=\"{{::getDocumentIcon(model)}}\"></i>-->\n                        <span>{{::model.pathlabel}}{{::model.pathlabel?' > ':''}}<span style=\"font-weight:bold\">{{::model.label}}</span></span>\n                    </span>",
        sortable: true
      }, {
        attribute: 'type',
        title: $translate("documents.Type"),
        filter: "translateLov:'typesDocuments'",
        width: 100,
        template: '<span>{{renderType(model)}}</span>',
        sortType: "string",
        sortable: true
      }, {
        attribute: 'sizeRec',
        title: $translate("documents.Taille"),
        width: 100,
        filter: "bytes",
        sortType: "number",
        template: '<span>{{model.type === "DIRECTORY" ? (model.sizeRec > 0 ? (model.sizeRec | bytes) : "") : model.fileId ? (model.size | bytes) : ("documents.DocumentExterne" |translate) }}</span>',
        sortable: true
      }, {
        attribute: 'creationDate',
        title: $translate("documents.DateDAjout"),
        width: 100,
        cellClass: "align-c",
        filter: "dateShort",
        sortType: "date",
        sortable: true
      }, {
        attribute: 'creationUser',
        title: $translate("documents.AjoutePar"),
        width: 200,
        template: '<span>{{::model.predefined ? "Prédéfini" : model.creationUser}}</span>',
        sortable: true
      },
      // actions
      {
        attribute: 'actions',
        title: '',
        width: 200,
        template: "\n                <div ng-if=\"model.type == 'DIRECTORY' \" class=\"actions\"> \n                    <tl-icon-button authz-if-role=\"SAISIE\" ng-if=\"!model.predefined\" icon=\"fa-pencil-square-o\" tl-tooltip=\"{{'documents.Editer' | translate}}\" ng-click=\"editDirectory(model)\"></tl-icon-button> \n                    <tl-icon-button authz-if-role=\"SAISIE\" ng-if=\"!model.predefined\" icon=\"fa-arrow-right\" tl-tooltip=\"{{'documents.Deplacer' | translate}}\" ng-click=\"moveNode(model)\"></tl-icon-button> \n                    <tl-icon-button authz-if-role=\"SAISIE\" ng-if=\"!model.predefined && model.nbReps + model.nbDocs == 1\" icon=\"fa-times-circle\" tl-tooltip=\"{{'documents.Supprimer' | translate}}\" ng-click=\"removeDirectory(model)\"></tl-icon-button> \n                </div> \n                <div ng-if=\"model.type != 'DIRECTORY' \" class=\"actions\"> \n                    <tl-icon-button icon=\"fa-eye\" tl-tooltip=\"{{'documents.Previsualiser' | translate}}\" ng-if=\"canPreview(model)\" ng-click=\"previewDocument(model)\"></tl-icon-button> \n                    <tl-icon-button icon=\"fa-download\" tl-tooltip=\"{{'documents.Telecharger' | translate}}\" ng-click=\"downloadDocument(model)\"></tl-icon-button> \n                    <tl-icon-button authz-if-role=\"SAISIE\" icon=\"fa-pencil-square-o\" tl-tooltip=\"{{'documents.Editer' | translate}}\" ng-click=\"editDocument(model)\"></tl-icon-button> \n                    <tl-icon-button authz-if-role=\"SAISIE\" icon=\"fa-arrow-right\" tl-tooltip=\"{{'documents.Deplacer' | translate}}\" ng-click=\"moveNode(model)\"></tl-icon-button> \n                    <tl-icon-button authz-if-role=\"SAISIE\" icon=\"fa-times-circle\" tl-tooltip=\"{{'documents.Supprimer' | translate}}\" ng-click=\"removeDocument(model)\"></tl-icon-button> \n                </div>",
        cellClass: 'align-c',
        sortable: false
      }]
    };
  };
  $scope.documentsMajTableOptions = {
    source: "location.majNodes",
    columns: [{
      attribute: 'completePathlabel',
      title: $translate("documents.Nom"),
      template: "\n                    <span>\n                        <i ng-if=\"isDirty(model)\" tl-tooltip=\"Modifi\xE9\" class=\"mr-s fa allowed green fa-check-square-o\" ></i>\n                        <i class=\"{{::getDocumentIcon(model)}}\"></i>\n                        <span>{{::model.pathlabel}}{{::model.pathlabel?' > ':''}}<span style=\"font-weight:bold\">{{::model.label}}</span></span>\n                    </span>",
      sortable: true
    }, {
      attribute: 'type',
      title: $translate("documents.Type"),
      filter: "translateLov:'typesDocuments'",
      template: '<span>{{renderType(model)}}</span>',
      width: 100,
      sortType: "string",
      sortable: true
    }, {
      attribute: 'size',
      title: $translate("documents.Taille"),
      width: 100,
      filter: "bytes",
      cellClass: "align-r",
      sortType: "number",
      template: '<span>{{model.fileId ? (model.size | bytes) : ("documents.DocumentExterne" |translate) }}</span>',
      sortable: true
    }, {
      attribute: 'creationDate',
      title: $translate("documents.DateDAjout"),
      width: 100,
      cellClass: "align-c",
      filter: "dateShort",
      sortType: "date",
      sortable: true
    }, {
      attribute: 'creationUser',
      title: $translate("documents.AjoutePar"),
      width: 200,
      template: '<span>{{::model.predefined ? "Prédéfini" : model.creationUser}}</span>',
      sortable: true
    }, {
      attribute: 'tags',
      width: 100,
      cellClass: "align-c",
      title: $translate("documents.JustificatifComptable"),
      template: '<tl-checkbox ng-if="model.docDetteOuPret" ng-model="model.tags.JUSTIFICATIF_TRESORERIE"/>'
    }]
  };
  $scope.previewDocument = function (document) {
    $scope.previewedDoc = document;
  };
  $scope.closePreview = function () {
    $scope.previewedDoc = null;
  };
  $scope.canPreview = function (document) {
    return documentPreview.canPreview(document);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/inventaire/documents/documents.js", __webpack_require__(1), __webpack_require__(3), __webpack_require__(2)))

/***/ }),
/* 2828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("moveNodePopinController", ["$scope", function ($scope) {
  var originalDocument = $scope.document;
  $scope.document = angular.copy(originalDocument);
  $scope.errors = {};
  $scope.saveAndClose = function () {
    $scope.errors.emplacement = $scope.document.parentId !== originalDocument.parentId ? undefined : {
      message: "Champ obligatoire"
    };
    if (!$scope.errors.emplacement) {
      _.extend(originalDocument, $scope.document);
      $scope.$close(originalDocument);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/inventaire/documents/moveNodePopin.js", __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("zipDownloadPopinController", ["$scope", "$fileDownload", "$uiBlock", function ($scope, $fileDownload, $uiBlock) {
  $scope.params = {
    nodeId: $scope.nodeId,
    nbDocs: $scope.nbDocs,
    nbDocsRec: $scope.nbDocsRec,
    size: $scope.size,
    sizeRec: $scope.sizeRec,
    recursive: false
  };
  $scope.MAX_FILES_SIZE = 150 * 1024 * 1024;
  $scope.selectionIsTooBig = function () {
    console.log('Rec', $scope.params.sizeRec, $scope.MAX_FILES_SIZE, $scope.params.sizeRec > $scope.MAX_FILES_SIZE);
    return $scope.params.recursive ? $scope.params.sizeRec > $scope.MAX_FILES_SIZE : $scope.params.size > $scope.MAX_FILES_SIZE;
  };
  $scope.downloadAndClose = function () {
    $uiBlock.block();
    $fileDownload.start('/rest/documents/downloadZIP/' + $scope.params.nodeId + "/" + $scope.params.recursive).finally(function () {
      $uiBlock.unblock();
    });
    $scope.$close();
  };
  $scope.nbDocsATelecharger = function () {
    return $scope.params.recursive ? $scope.params.nbDocsRec : $scope.params.nbDocs;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/inventaire/documents/zipDownloadPopin.js"))

/***/ }),
/* 2830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("inventaireDocumentTab", function () {
  return {
    label: "portefeuille.Documents",
    icon: "fa-file-text-o",
    fragment: "documents",
    controller: "InventaireDocumentTabController",
    template: __webpack_require__(907)
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/inventaire/inventaireModuleFactory.js"))

/***/ }),
/* 2831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("OffreEBEditionPopinController", ["$scope", "$http", "$q", "contrepartieService", "lovService", "indexationService", function ($scope, $http, $q, contrepartieService, lovService, indexationService) {
  var isEdit = $scope.edit;
  $scope.searchExtraParams = {
    retireComptesSatellites: true
  };
  $scope.searchConfig = {
    stickToValue: "offre.compteNomInterne",
    labelAttribute: "nomInterne",
    searchUrl: "/rest/intra/comptes/search",
    extraParams: "searchExtraParams",
    resultTemplate: '<span class="name" ng-bind-html="result.nomInterne | underlineSearchResultMatch:search.q"></span>',
    onSelect: function onSelect(compte) {
      if (compte == null) {
        $scope.offre.compteId = null;
      } else {
        $scope.offre.compteId = compte.id;
      }
    }
  };
  $scope.penaliteFieldPrefix = "offre.penalite";
  $scope.typesModaliteIndexation = [{
    id: "FIXE",
    label: 'Fixe'
  }, {
    id: "VARIABLE",
    label: 'Variable'
  }];
  $scope.amortTypeIds = ["LINEAIRE", "CONSTANT", "IN_FINE", "A_LA_CARTE"];
  $q.when(lovService.getTypesPenaliteOptionRA()).then(function (typesPenaliteOptionRA) {
    $scope.typesPenalite = typesPenaliteOptionRA;
  });
  $q.when(lovService.getTypesPenaliteDegressive()).then(function (lov) {
    $scope.typesPenaliteDegressive = lov;
  });
  $q.when(lovService.getTauxPenaliteActuarielleIndex()).then(function (lov) {
    $scope.tauxPenaliteActuarielleIndex = lov;
  });
  $q.when(lovService.getTypesPenaliteActuarielle()).then(function (lov) {
    $scope.typesPenaliteActuarielle = lov;
  });
  $q.when(contrepartieService.getContreparties()).then(function (contreparties) {
    $scope.contreparties = contreparties;
  });
  $q.when(lovService.getTypesAmortissement()).then(function (typesAmortissement) {
    $scope.typesAmortissement = typesAmortissement;
  });
  $q.when(lovService.getPeriodicites()).then(function (periodicites) {
    $scope.periodicites = _.reject(periodicites, function (period) {
      return _.includes(["QUOTIDIENNE", "IN_FINE"], period.id);
    });
  });
  $q.when(indexationService.getIndicesClient()).then(function (indices) {
    $scope.indices = indices;
  });
  var initTauxMinMax = function initTauxMinMax() {
    // tauxMax
    $scope.tauxMax = {
      checked: false,
      value: null
    };
    $scope.$watch("offre.indexation.tauxMax", function (tauxMax) {
      $scope.tauxMax = {
        checked: tauxMax != null,
        value: $scope.tauxMax.value || tauxMax
      };
    });
    $scope.$watch("tauxMax", function (tauxMax) {
      if (tauxMax.checked) {
        $scope.offre.indexation.tauxMax = tauxMax.value;
      } else {
        $scope.offre.indexation.tauxMax = null;
      }
    }, true);

    // tauxMin
    $scope.tauxMin = {
      checked: false,
      value: null
    };
    $scope.$watch("offre.indexation.tauxMin", function (tauxMin) {
      $scope.tauxMin = {
        checked: tauxMin != null,
        value: $scope.tauxMin.value || tauxMin
      };
    });
    $scope.$watch("tauxMin", function (tauxMin) {
      if (tauxMin.checked) {
        $scope.offre.indexation.tauxMin = tauxMin.value;
      } else {
        $scope.offre.indexation.tauxMin = null;
      }
    }, true);
  };
  $scope.offreFormConfig = {
    url: function url() {
      return '/rest/intra/offres/saisie/EB/save';
    },
    data: function data() {
      return $scope.offre;
    },
    customValidation: function customValidation() {
      var errors = [];
      if ($scope.offre) {
        if ($scope.offre.indexation.typeModaliteIndexation === 'FIXE' && $scope.offre.indexation.tauxFixe == null) {
          console.log('ADD error');
          errors.push({
            fieldName: 'indexation.tauxFixe',
            message: 'Le taux fixe est obligatoire.'
          });
        }
      }
      return errors;
    },
    // rajouté devant le fieldName des errors
    fieldPrefix: "offre.",
    onSuccess: function onSuccess(offre) {
      $scope.$close(offre);
    }
  };

  // permet d'injecter une offre déjà saisie (demande de financement)
  if ($scope.newOffre) {
    $scope.offre = $scope.newOffre;
    $scope.penalite = $scope.newOffre.penalite;
  } else
    // modification d'une offre existante
    if ($scope.offreId) {
      $http.get("/rest/intra/offres/saisie/EB/" + $scope.offreId).then(function (response) {
        console.log(response);
        $scope.offre = response.data;
        $scope.penalite = $scope.offre.penalite;
        initTauxMinMax();
      });
    } else {
      // nouvelle offre à partir d'une copie
      if ($scope.copieId) {
        $http.get("/rest/intra/offres/saisie/EB/" + $scope.copieId).then(function (response) {
          $scope.offre = response.data;
          $scope.penalite = $scope.offre.penalite;
          $scope.offre.id = null;
          initTauxMinMax();
        });
      } else {
        $scope.offre = {
          penalite: {},
          indexation: {},
          visibleClient: true
        };
        $scope.penalite = $scope.offre.penalite;
        initTauxMinMax();
      }
    }
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/journalOffres/edition/offreEBEditionPopin.js", __webpack_require__(1)))

/***/ }),
/* 2832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("OffreLTEditionPopinController", ["$scope", "$http", "$q", "contrepartieService", "lovService", "indexationService", function ($scope, $http, $q, contrepartieService, lovService, indexationService) {
  var isEdit = $scope.edit;
  $scope.searchExtraParams = {
    retireComptesSatellites: true
  };
  $scope.searchConfig = {
    stickToValue: "offre.compteNomInterne",
    labelAttribute: "nomInterne",
    searchUrl: "/rest/intra/comptes/search",
    extraParams: "searchExtraParams",
    resultTemplate: '<span class="name" ng-bind-html="result.nomInterne | underlineSearchResultMatch:search.q"></span>',
    onSelect: function onSelect(compte) {
      if (compte == null) {
        $scope.offre.compteId = null;
      } else {
        $scope.offre.compteId = compte.id;
      }
    }
  };
  $scope.typesModaliteIndexation = [{
    id: "FIXE",
    label: 'Fixe'
  }, {
    id: "VARIABLE",
    label: 'Variable'
  }];
  $scope.typesModaliteIndexationCNU = [{
    id: "FIXE",
    label: 'Fixe'
  }, {
    id: "VARIABLE",
    label: 'Variable'
  }, {
    id: "AUTRE",
    label: 'Autre'
  }];
  $q.when(contrepartieService.getContreparties()).then(function (contreparties) {
    $scope.contreparties = contreparties;
  });
  $q.when(indexationService.getIndicesClient()).then(function (indices) {
    $scope.indices = indices;
  });
  var initTauxMinMax = function initTauxMinMax() {
    // tauxMax
    $scope.tauxMax = {
      checked: false,
      value: null
    };
    $scope.$watch("offre.indexation.tauxMax", function (tauxMax) {
      $scope.tauxMax = {
        checked: tauxMax != null,
        value: $scope.tauxMax.value || tauxMax
      };
    });
    $scope.$watch("tauxMax", function (tauxMax) {
      if (tauxMax.checked) {
        $scope.offre.indexation.tauxMax = tauxMax.value;
      } else {
        $scope.offre.indexation.tauxMax = null;
      }
    }, true);

    // tauxMin
    $scope.tauxMin = {
      checked: false,
      value: null
    };
    $scope.$watch("offre.indexation.tauxMin", function (tauxMin) {
      $scope.tauxMin = {
        checked: tauxMin != null,
        value: $scope.tauxMin.value || tauxMin
      };
    });
    $scope.$watch("tauxMin", function (tauxMin) {
      if (tauxMin.checked) {
        $scope.offre.indexation.tauxMin = tauxMin.value;
      } else {
        $scope.offre.indexation.tauxMin = null;
      }
    }, true);
  };
  if ($scope.newOffre) {
    $scope.offre = $scope.newOffre;
  } else
    // modification d'une offre existante
    if ($scope.offreId) {
      $http.get("/rest/intra/offres/saisie/LT/" + $scope.offreId).then(function (response) {
        $scope.offre = response.data;
        initTauxMinMax();
      });
    } else {
      // nouvelle offre à partir d'une copie
      if ($scope.copieId) {
        $http.get("/rest/intra/offres/saisie/LT/" + $scope.copieId).then(function (response) {
          $scope.offre = response.data;
          $scope.offre.id = null;
          initTauxMinMax();
        });
      } else {
        $scope.offre = {
          indexation: {},
          indexationCNU: {},
          visibleClient: true
        };
        initTauxMinMax();
      }
    }
  $scope.offreFormConfig = {
    url: function url() {
      return '/rest/intra/offres/saisie/LT/save';
    },
    data: function data() {
      return $scope.offre;
    },
    customValidation: function customValidation() {
      var errors = [];
      if ($scope.offre && $scope.offre.dateOffre == null) {
        errors.push({
          fieldName: 'dateOffre',
          message: 'La date est obligatoire.'
        });
      }
      return errors;
    },
    fieldPrefix: "offre.",
    fields: {
      banqueId: {
        mandatory: true
      }
    },
    onSuccess: function onSuccess(offre) {
      $scope.$close(offre);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/journalOffres/edition/offreLTEditionPopin.js"))

/***/ }),
/* 2833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("journalOffreService", ["$modal", function ($modal) {
  return {
    // edition / creation
    /**
     *
     * @param offre pour une nouvelle offre déjà remplie, passer une offre sans id. passer null pour creer une offre de 0.
     * @returns {*}
     */
    openOffreEBEditionPopin: function openOffreEBEditionPopin($scope, offre, copieId) {
      var newOffre = null;
      if (offre != null && offre.id == null) {
        newOffre = offre;
      }
      return $modal.open({
        scope: $scope,
        controller: "OffreEBEditionPopinController",
        template: __webpack_require__(3697),
        vars: {
          edit: offre && offre.id != null ? true : false,
          offreId: offre && offre.id,
          copieId: copieId,
          newOffre: newOffre
        },
        options: {
          width: 750
        }
      });
    },
    // edition / creation
    /**
     *
     * @param offre pour une nouvelle offre déjà remplie, passer une offre sans id. passer null pour creer une offre de 0.
     * @returns {*}
     */
    openOffreLTEditionPopin: function openOffreLTEditionPopin($scope, offre, copieId) {
      var newOffre = null;
      if (offre != null && offre.id == null) {
        newOffre = offre;
      }
      return $modal.open({
        scope: $scope,
        controller: "OffreLTEditionPopinController",
        template: __webpack_require__(3698),
        vars: {
          edit: offre && offre.id != null ? true : false,
          offreId: offre && offre.id,
          copieId: copieId,
          newOffre: newOffre
        },
        options: {
          width: 750
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/journalOffres/journalOffreService.js"))

/***/ }),
/* 2834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, moment, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("mktCourbesTauxChartConfigFactory", ["$numberFormat", "chartUtils", "$translate", function ($numberFormat, chartUtils, $translate) {
  var _e = chartUtils.tooltipElement;
  return function getCourbesTauxChartConfig(options) {
    var height = options && options.height || 450;
    return {
      chart: {
        type: 'spline',
        height: height,
        borderColor: '#322f8f'
      },
      colors: ['#4DC100', '#005e75', '#F48600'],
      plotOptions: {
        series: {
          marker: {
            enabled: false
          }
        }
      },
      tooltip: {
        enabled: true,
        shared: true,
        formatter: function formatter() {
          var maturite = moment.duration(this.x, "years").humanize();
          var tooltip = _e("Maturité " + maturite + " : ", {
            bold: true,
            br: true
          });
          _.each(this.points, function (point) {
            var value = $numberFormat.percentage(point.y, 2);
            var serieLine = _e(point.series.name, {
              color: point.series.color,
              bold: true
            }) + _e(' : ' + value);
            tooltip += serieLine + "<br/>";
          });
          return tooltip;
        }
      },
      xAxis: {
        type: 'linear',
        allowDecimals: false,
        title: {
          text: $translate('marche.history.courbeTaux.graph.maturite')
        }
      },
      yAxis: {
        title: {
          text: $translate('marche.history.courbeTaux.graph.Taux')
        },
        labels: {
          formatter: function formatter() {
            return $numberFormat.percentage(this.value, 2);
          }
        },
        startOnTick: false
      }
    };
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/courbes-taux/mktCourbesTauxChartConfigFactory.js", __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 2835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.component("mktCourbesTauxPage", {
  bindings: {},
  template: __webpack_require__(3699),
  controller: ["$scope", "$http", "$translate", "$numberFormat", "chartUtils", "mktCourbesTauxChartConfigFactory", "mktCourbesTauxService", "contextService", "$fileDownload", "$session", function controller($scope, $http, $translate, $numberFormat, chartUtils, mktCourbesTauxChartConfigFactory, mktCourbesTauxService, contextService, $fileDownload, $session) {
    $scope.courbes = [{
      id: "EUR",
      label: "EUR",
      groupe: $translate('marche.history.courbeTaux.groupe.Devise')
    }, {
      id: "USD",
      label: "USD",
      groupe: $translate('marche.history.courbeTaux.groupe.Devise')
    }, {
      id: "CHF",
      label: "CHF",
      groupe: $translate('marche.history.courbeTaux.groupe.Devise')
    }, {
      id: "GBP",
      label: "GBP",
      groupe: $translate('marche.history.courbeTaux.groupe.Devise')
    }, {
      id: "JPY",
      label: "JPY",
      groupe: $translate('marche.history.courbeTaux.groupe.Devise')
    }, {
      id: "TEC",
      label: "France (TEC)",
      groupe: $translate('marche.history.courbeTaux.groupe.Pays')
    }, {
      id: "OLO",
      label: "Belgique (OLO)",
      groupe: $translate('marche.history.courbeTaux.groupe.Pays')
    }];
    var dateVisualisation = contextService.getContext().dateVisualisation;
    var defautCourbe = _.find($scope.courbes, function (c) {
      return c.id === $session.getCompte().devise;
    });
    if (defautCourbe == null) {
      defautCourbe = $scope.courbes[0];
    }
    var params = $scope.params = {
      courbeId: defautCourbe.id,
      datesCustom: false,
      date1: dateVisualisation,
      date2: moment(dateVisualisation).subtract(1, 'month').toDate(),
      date3: moment(dateVisualisation).subtract(6, 'month').toDate(),
      date2Active: true,
      date3Active: true,
      avecCourbeOAT: false
    };
    $scope.$watch("params", function () {
      if (params.courbeId !== 'EUR') {
        params.avecCourbeOAT = false;
      }
      fetchDataForCourbe();
    }, true);
    var getParams = function getParams(params, isXls) {
      var requestParams = {
        courbeId: params.courbeId,
        date1: params.datesCustom ? params.date1 : null,
        date2: params.datesCustom && params.date2Active ? params.date2 : null,
        date3: params.datesCustom && params.date3Active ? params.date3 : null,
        avecCourbeOAT: params.avecCourbeOAT
      };
      if (isXls) {
        requestParams['xls'] = true;
      }
      return requestParams;
    };
    var fetchDataForCourbe = function fetchDataForCourbe() {
      $scope.loader = true;
      // todo - loader de la table, ça sera plus classe (overlay) !
      $http.get('/rest/marche/courbe-taux/indexes', {
        params: getParams(params)
      }).then(function (response) {
        $scope.indexCourbeTaux = response.data;
      }).finally(function () {
        $scope.loader = false;
      });
      setupIndexCourbeTauxTableConfig();
      mktCourbesTauxService.getCourbeTauxChartSeries(params.courbeId, params.datesCustom ? params.date1 : null, params.datesCustom && params.date2Active ? params.date2 : null, params.datesCustom && params.date3Active ? params.date3 : null, params.avecCourbeOAT).then(function (chartSeries) {
        $scope.chartConfigCourbeTaux.series = chartSeries;
      });
    };
    var setupIndexCourbeTauxTableConfig = function setupIndexCourbeTauxTableConfig() {
      var columnsFixing = [{
        attribute: 'fixingCourant',
        title: params.datesCustom ? moment(params.date1).format("DD/MM/YYYY") : $translate('marche.DernierFixing'),
        filter: "taux:2",
        cellClass: 'align-r'
      }];
      if (params.avecCourbeOAT === true) {
        columnsFixing.push({
          attribute: 'oatCourant',
          title: $translate('marche.OATEquivalente'),
          filter: "taux:2",
          cellClass: 'align-r'
        });
      }
      if (params.datesCustom === false || params.date2Active === true) {
        columnsFixing.push({
          attribute: 'fixing1Mois',
          title: params.datesCustom && params.date2Active ? moment(params.date2).format("DD/MM/YYYY") : $translate('marche.1Mois'),
          filter: "taux:2",
          cellClass: 'align-r'
        });
      }
      if (params.datesCustom === false || params.date3Active === true) {
        columnsFixing.push({
          attribute: 'fixing6Mois',
          title: params.datesCustom && params.date3Active ? moment(params.date3).format("DD/MM/YYYY") : $translate('marche.6Mois'),
          filter: "taux:2",
          cellClass: 'align-r'
        });
      }
      $scope.indexCourbeTauxTableConfig = {
        source: "indexCourbeTaux",
        height: 450,
        columns: [{
          attribute: 'index',
          title: $translate('marche.Index'),
          width: "180px",
          template: "<span> {{'index.' + model.index | translate}}</span>"
        }, {
          title: "Fixing",
          group: true,
          columns: columnsFixing
        }]
      };
    };
    $scope.chartConfigCourbeTaux = {
      options: mktCourbesTauxChartConfigFactory()
    };
    $scope.exportXls = function () {
      console.log('start download...');
      $fileDownload.start('/rest/marche/courbe-taux/indexes', getParams(params, true));
    };
  }]
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/courbes-taux/mktCourbesTauxPage.js", __webpack_require__(1), __webpack_require__(2)))

/***/ }),
/* 2836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("mktCourbesTauxService", ["$http", "chartUtils", "$translate", "tlColors", function ($http, chartUtils, $translate, tlColors) {
  return {
    getCompteCourbeTauxCurrency: function getCompteCourbeTauxCurrency($session) {
      return $http.get('/rest/marche/courbe-taux/devises').then(function (response) {
        var courbesTauxDevises = response.data;
        var devise = $session.getCompte().devise;
        console.log(courbesTauxDevises);
        console.log(devise);
        if (_.indexOf(courbesTauxDevises, devise) === -1) {
          console.log("fallback EUR");
          return 'EUR';
        }
        return devise;
      });
    },
    getCourbeTauxChartSeries: function getCourbeTauxChartSeries(courbeId, date1, date2, date3, avecCourbeOAT) {
      return $http.get('/rest/marche/courbe-taux', {
        params: {
          courbeId: courbeId,
          date1: date1,
          date2: date2,
          date3: date3,
          avecCourbeOAT: avecCourbeOAT
        }
      }).then(function (response) {
        var data = response.data;
        var serie = [{
          name: date1 == null ? $translate('marche.DernierFixing') : moment(date1).format('DD/MM/YYYY'),
          data: chartUtils.mapAndFilter(data, "maturite", "fixingCourant.valeur"),
          zIndex: 4,
          color: tlColors.COURBE_TAUX_1
        }];
        if (avecCourbeOAT) {
          serie.push({
            name: $translate('marche.OATEquivalente'),
            data: chartUtils.mapAndFilter(data, "maturite", "oatCourant.valeur"),
            zIndex: 3,
            color: tlColors.GREY2
          });
        }
        if (date1 == null || date2 != null) serie.push({
          name: date2 == null ? $translate('marche.1Mois') : moment(date2).format('DD/MM/YYYY'),
          data: chartUtils.mapAndFilter(data, "maturite", "fixing1Mois.valeur"),
          zIndex: 2,
          color: tlColors.COURBE_TAUX_2
        });
        if (date1 == null || date3 != null) serie.push({
          name: date3 == null ? $translate('marche.6Mois') : moment(date3).format('DD/MM/YYYY'),
          data: chartUtils.mapAndFilter(data, "maturite", "fixing6Mois.valeur"),
          zIndex: 1,
          color: tlColors.COURBE_TAUX_3
        });
        return serie;
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/courbes-taux/mktCourbesTauxService.js", __webpack_require__(1), __webpack_require__(2)))

/***/ }),
/* 2837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("mktDashboardCreateFavoritePopinCtrl", ["$scope", "$q", "indexationService", "mktDashboardService", "customIndexationService", "fixingService", function ($scope, $q, indexationService, mktDashboardService, customIndexationService, fixingService) {
  var ctrl = this;
  ctrl.reference = {
    type: "INDEX",
    indexId: null,
    indexationId: null
  };
  function initialize() {
    $q.when(indexationService.getIndicesClient()).then(function (indices) {
      ctrl.indices = indices;
    });
    $q.when(customIndexationService.fetchIndexations()).then(function (indexations) {
      ctrl.indexations = indexations;
    });
  }
  ctrl.saveFavorite = function () {
    ctrl.error = null;
    if (fixingService.isValidReference(ctrl.reference)) {
      mktDashboardService.createFavorite(ctrl.reference).then(function (favorite) {
        $scope.$close(favorite);
      });
    } else {
      ctrl.error = "Veuillez choisir l'indice ou l'indexation";
    }
  };
  initialize();
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/dashboard/mkt-dashboad-create-favorite-popin.js"))

/***/ }),
/* 2838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.component("mktDashboardPage", {
  bindings: {},
  template: __webpack_require__(3701),
  controller: ["mktDashboardService", "$dialogBox", "arrayUtils", "$session", "$translate", "mktCourbesTauxService", function controller(mktDashboardService, $dialogBox, arrayUtils, $session, $translate, mktCourbesTauxService) {
    var ctrl = this;
    mktCourbesTauxService.getCompteCourbeTauxCurrency($session).then(function (devise) {
      ctrl.state = {
        currency: devise,
        favEdition: false
      };
    });
    function refreshFavoriteList() {
      return mktDashboardService.getFavoriteIndexations().then(function (indexations) {
        ctrl.favoriteIndexations = indexations;
      });
    }
    ctrl.$onInit = function () {
      ctrl.detteIndexes = [];
      ctrl.favoriteIndexations = [];
      mktDashboardService.getDetteIndexes().then(function (indexes) {
        ctrl.detteIndexes = indexes;
      });
      refreshFavoriteList();
    };
    ctrl.createFavorite = function () {
      mktDashboardService.openFavoriteCreationPopin().then(function (favorite) {
        ctrl.favoriteIndexations.push(favorite);
      });
    };
    ctrl.toggleFavEdition = function () {
      ctrl.state.favEdition = !ctrl.state.favEdition;
    };
    ctrl.deleteFavorite = function (favoriteId) {
      $dialogBox.confirm({
        title: $translate("marche.dashboard.suppressionFavori.title"),
        text: $translate("marche.dashboard.suppressionFavori.text")
      }).then(function () {
        return mktDashboardService.deleteFavorite(favoriteId).then(function (success) {
          if (success) {
            var index = _.findIndex(ctrl.favoriteIndexations, {
              favoriteId: favoriteId
            });
            if (index > -1) {
              ctrl.favoriteIndexations.splice(index, 1);
            }
          }
        });
      });
    };
    ctrl.moveFavorite = function (favoriteId, toLeft) {
      var len = ctrl.favoriteIndexations.length;
      var index = _.findIndex(ctrl.favoriteIndexations, {
        favoriteId: favoriteId
      });
      if (toLeft && index === 0 || !toLeft && index === len - 1) {
        return;
      }
      var secondIndex = index + (toLeft ? -1 : 1);
      var secondId = ctrl.favoriteIndexations[secondIndex].favoriteId;
      mktDashboardService.switchFavoritePositions(favoriteId, secondId).then(function (success) {
        arrayUtils.swapElements(ctrl.favoriteIndexations, index, secondIndex);
      });
    };
  }]
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/dashboard/mkt-dashboard-page.js", __webpack_require__(1)))

/***/ }),
/* 2839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("mktUpDownCaret", function () {
  return {
    scope: {
      down: "<"
    },
    restrict: "E",
    replace: true,
    template: '<i class="mkt-up-down-caret fa {{down ? \'fa-caret-down\' : \'fa-caret-up\'}}"></i>',
    link: function link($scope, $el, $attrs) {}
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/dashboard/mkt-up-down-caret.js"))

/***/ }),
/* 2840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("mktDashboardCourbeTauxChart", ["mktCourbesTauxChartConfigFactory", "mktCourbesTauxService", function (mktCourbesTauxChartConfigFactory, mktCourbesTauxService) {
  return {
    restrict: "E",
    replace: false,
    scope: {
      currency: "="
    },
    template: '<tl-chart class="no-border" chart-config="chartConfigCourbeTaux"></tl-chart>',
    link: function link($scope, $el, $attrs, ctrl) {
      $scope.$watch("currency", function (currency) {
        mktCourbesTauxService.getCourbeTauxChartSeries(currency).then(function (chartSeries) {
          $scope.chartConfigCourbeTaux.series = chartSeries;
        });
      });
      $scope.chartConfigCourbeTaux = {
        options: mktCourbesTauxChartConfigFactory({
          height: 300
        })
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/dashboard/mktDashboardCourbeTauxChart.js"))

/***/ }),
/* 2841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("mktDashboardIndexAddBtn", function () {
  return {
    restrict: "E",
    scope: {
      clickHandler: "<"
    },
    replace: true,
    controllerAs: "$ctrl",
    template: __webpack_require__(3702),
    controller: ["$scope", function controller($scope) {
      var ctrl = this;
      ctrl.onClick = function () {
        $scope.clickHandler && $scope.clickHandler();
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/dashboard/mktDashboardIndexAddBtn.js"))

/***/ }),
/* 2842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("mktDashboardIndexSummary", ["fixingService", "chartUtils", "$numberFormat", "$dateFormat", "contextService", "mktHistoryUtils", "mktChartUtils", "$translate", "$q", function (fixingService, chartUtils, $numberFormat, $dateFormat, contextService, mktHistoryUtils, mktChartUtils, $translate, $q) {
  return {
    restrict: "E",
    scope: {
      index: "<",
      editing: "<",
      onDelete: "<",
      onMove: "<"
    },
    replace: true,
    controllerAs: "$ctrl",
    template: __webpack_require__(3703),
    controller: ["$scope", function controller($scope) {
      var getAxis = mktChartUtils.getAxis,
        getIndiceTypes = mktChartUtils.getIndiceTypes,
        getReferenceIndexType = mktChartUtils.getReferenceIndexType,
        getReferenceLabel = mktChartUtils.getReferenceLabel;
      var ctrl = this;
      ctrl.state = {};
      ctrl.$onInit = function () {
        $scope.$watch("index", onIndexChange);
      };
      function onIndexChange() {
        ctrl.index = $scope.index;
        if (ctrl.index == null) {
          return;
        }
        fixingService.getReferenceLabel(ctrl.index.reference).then(function (label) {
          ctrl.state.referenceLabel = label;
          var fixing = ctrl.index.fixing;
          var fixing1M = ctrl.index.fixing1M;
          var fixing3M = ctrl.index.fixing3M;
          var fixing1Y = ctrl.index.fixing1Y;
          if (fixing && fixing1M) {
            ctrl.state.var1M = fixing1M.valeur === 0.0 ? null : (fixing.valeur - fixing1M.valeur) / fixing1M.valeur;
          }
          if (fixing && fixing3M) {
            ctrl.state.var3M = fixing3M.valeur === 0.0 ? null : (fixing.valeur - fixing3M.valeur) / fixing3M.valeur;
          }
          if (fixing && fixing1Y) {
            ctrl.state.var1Y = fixing1Y.valeur === 0.0 ? null : (fixing.valeur - fixing1Y.valeur) / fixing1Y.valeur;
          }
          ctrl.state.chartConfig = buildChartConfig();
          getIndexChartData(ctrl.index).then(function (chartData) {
            ctrl.state.chartConfig.series = chartData;
          });
          ctrl.state.value = fixing ? formatValue(fixing) : "N/A";
        });
      }
      function formatValue(fixing) {
        if (ctrl.index.indexType === 'TAUX') {
          return $numberFormat.percentage(fixing.valeur, 2);
        } else {
          return $numberFormat.number(fixing.valeur, 2);
        }
      }
      function getIndexChartData(index) {
        return fixingService.getHistory(index.reference, {
          historique: 1,
          forward: 1,
          nbDonneeMax: 200
        }).then(function (indexHistory) {
          return fixingService.getReferenceLabel(index.reference).then(function (label) {
            return [{
              name: label,
              data: chartUtils.mapAndFilter(indexHistory, "date", "valeur")
            }];
          });
        });
      }
      function buildChartConfig() {
        var index = ctrl.index;
        var typeIndex = index.indexType;
        var labelFormatter;
        var tooltipFormatter;
        if (typeIndex === 'TAUX') {
          labelFormatter = function labelFormatter() {
            return $numberFormat.percentage(this.value, 1);
          };
          tooltipFormatter = function tooltipFormatter() {
            return '<span>' + $dateFormat.date(this.x) + '</span> : <b>' + $numberFormat.percentage(this.y, 2) + '</b>';
          };
        } else {
          labelFormatter = function labelFormatter() {
            return $numberFormat.number(this.value, 2);
          };
          tooltipFormatter = function tooltipFormatter() {
            return '<span>' + $dateFormat.date(this.x) + '</span> : <b>' + $numberFormat.number(this.y, 2) + '</b>';
          };
        }
        var config = {
          options: {
            chart: {
              spacingLeft: 2,
              spacingRight: 0,
              spacingTop: 5,
              spacingBottom: 5,
              zoomType: 'x',
              height: 200
            },
            plotOptions: {
              series: {
                pointInterval: 24 * 3600 * 1000,
                turboThreshold: 0,
                animation: false,
                color: '#2f7ed8'
              }
            },
            xAxis: {
              type: 'datetime',
              plotLines: chartUtils.getDateMarchePlotLine(contextService)
            },
            yAxis: {
              startOnTick: false,
              labels: {
                formatter: labelFormatter
              }
            },
            tooltip: {
              formatter: tooltipFormatter
            },
            legend: {
              enabled: false
            }
          },
          fsOptions: {
            legend: {
              enabled: true
            },
            title: {
              text: chartUtils.tooltipElement(ctrl.state.referenceLabel, {
                color: chartUtils.getGraphColor(0)
              })
            },
            navigator: {
              enabled: true,
              adaptToUpdatedData: false
            },
            scrollbar: {
              liveRedraw: false
            },
            rangeSelector: {
              enabled: true
            },
            yAxis: {
              labels: {
                formatter: function formatter() {
                  return typeIndex === "TAUX" ? $numberFormat.percentage(this.value, 2) : $numberFormat.number(this.value, 2);
                },
                style: {
                  color: chartUtils.getGraphColor(0)
                }
              },
              title: {
                text: mktHistoryUtils.getIndexTypeAxisLabel(typeIndex),
                style: {
                  color: chartUtils.getGraphColor(0)
                }
              }
            }
          }
        };
        return config;
      }
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/dashboard/mktDashboardIndexSummary.js"))

/***/ }),
/* 2843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("mktDashboardService", ["$http", "$modal", function ($http, $modal) {
  return {
    getDetteIndexes: function getDetteIndexes() {
      return $http.get("/rest/market/dashboard/dette-indexes").then(function (response) {
        return response.data;
      });
    },
    getFavoriteIndexations: function getFavoriteIndexations() {
      return $http.get("/rest/market/dashboard/favorites/list").then(function (response) {
        return response.data;
      });
    },
    openFavoriteCreationPopin: function openFavoriteCreationPopin() {
      return $modal.open({
        controller: "mktDashboardCreateFavoritePopinCtrl",
        template: __webpack_require__(3700)
      });
    },
    createFavorite: function createFavorite(valorisableRef) {
      return $http.post("/rest/market/dashboard/favorites/add", valorisableRef).then(function (response) {
        return response.data;
      });
    },
    deleteFavorite: function deleteFavorite(favoriteId) {
      var params = {
        id: favoriteId
      };
      return $http.get("/rest/market/dashboard/favorites/delete", {
        params: params
      }).then(function (response) {
        return response.data;
      });
    },
    switchFavoritePositions: function switchFavoritePositions(firstId, secondId) {
      var params = {
        firstId: firstId,
        secondId: secondId
      };
      return $http.get("/rest/market/dashboard/favorites/switch-position", {
        params: params
      }).then(function (response) {
        return response.data;
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/dashboard/mktDashboardService.js"))

/***/ }),
/* 2844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.component("mktDashboardTauxFixeTable", {
  bindings: {},
  template: __webpack_require__(3704),
  controller: ["$http", "$translate", function controller($http, $translate) {
    var ctrl = this;
    ctrl.state = {
      typeAmortissement: "LINEAIRE",
      periodicite: "SEMESTRIELLE"
    };
    ctrl.periodicites = [{
      id: 'MENSUELLE',
      name: $translate('lov.periodicites.MENSUELLE')
    }, {
      id: 'TRIMESTRIELLE',
      name: $translate('lov.periodicites.TRIMESTRIELLE')
    }, {
      id: 'SEMESTRIELLE',
      name: $translate('lov.periodicites.SEMESTRIELLE')
    }, {
      id: 'ANNUELLE',
      name: $translate('lov.periodicites.ANNUELLE')
    }];
    ctrl.typeAmortissements = [{
      id: 'LINEAIRE',
      name: $translate('lov.typesAmortissement.LINEAIRE')
    }, {
      id: 'CONSTANT',
      name: $translate('lov.typesAmortissement.CONSTANT')
    }, {
      id: 'IN_FINE',
      name: $translate('lov.typesAmortissement.IN_FINE')
    }];
    ctrl.$onInit = function () {
      loadTableData();
    };
    ctrl.onChange = function () {
      loadTableData();
    };
    function loadTableData() {
      ctrl.loading = true;
      var params = {
        typeAmortissement: ctrl.state.typeAmortissement,
        periodicite: ctrl.state.periodicite
      };
      $http.get("/rest/market/dashboard/taux-fixe-summary", {
        params: params
      }).then(function (response) {
        ctrl.tableData = response.data;
      }).finally(function () {
        ctrl.loading = false;
      });
    }
  }]
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/dashboard/mktDashboardTauxFixeTable.js"))

/***/ }),
/* 2845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.component("mktHistoryPage", {
  bindings: {},
  template: __webpack_require__(3705),
  controllerAs: "$ctrl",
  controller: ["$scope", "$q", "$debounce", "indexationService", "customIndexationService", "mktHistoryUtils", "$modal", "$applications", function controller($scope, $q, $debounce, indexationService, customIndexationService, mktHistoryUtils, $modal, $applications) {
    var ctrl = this;
    ctrl.formData = {
      references: [],
      forward: !$applications.isPlacementApplication(),
      forwardNbAnnees: 10,
      spread: false,
      calendarRef: null,
      calendarDate: new Date(),
      fullScreenChart: $applications.isPlacementApplication()
    };
    ctrl.forwardNbAnneesList = [5, 10, 15, 20, 30, 40];
    ctrl.validReferences = [];
    ctrl.calendarRefOptions = [];
    ctrl.$onInit = function () {
      ctrl.addReference();
      ctrl.formData.calendarRef = ctrl.formData.references[0];
      refreshIndexationList().then(function () {
        if ($scope.indexations.length > 0) {
          ctrl.formData.references[0].indexationId = $scope.indexations[0].id;
        }
      });
      refreshIndicesList().then(generateCalendarRefOptions);
      $scope.$watch("$ctrl.formData.references", onReferencesChange, true);
      $scope.$watch("$ctrl.formData.spread", onSpreadClick, true);
    };
    function isReferenceValidOuSpread(reference) {
      if (mktHistoryUtils.isReferenceValid(reference)) {
        return true;
      } else {
        // si on ne test pas undefined, on a parfois une erreur Cannot read properties of null (reading 'type'
        if (reference === undefined || reference === null) return false;
        return "SPREAD" === reference.type;
      }
    }
    function onSpreadClick() {
      onReferencesChange();
      if (ctrl.formData.spread) {
        ctrl.formData.calendarRef = ctrl.calendarRefOptions[2].reference;
      }
    }
    function onReferencesChange() {
      ctrl.validReferences = _.filter(ctrl.formData.references, isReferenceValidOuSpread);
      generateCalendarRefOptions();
      var previousRef = ctrl.formData.calendarRef;
      ctrl.formData.calendarRef = null;
      if (previousRef && previousRef.type === "SPREAD" && ctrl.calendarRefOptions[2] && ctrl.calendarRefOptions[2].reference && ctrl.calendarRefOptions[2].reference.type === "SPREAD") {
        ctrl.formData.calendarRef = ctrl.calendarRefOptions[2].reference;
      } else {
        for (var i = 0; i < ctrl.validReferences.length; i++) {
          if (mktHistoryUtils.isSameReference(previousRef, ctrl.validReferences[i])) {
            ctrl.formData.calendarRef = ctrl.validReferences[i];
            break;
          }
        }
      }
      if (ctrl.formData.calendarRef == null && ctrl.validReferences.length > 0) {
        ctrl.formData.calendarRef = ctrl.validReferences[0];
      }
    }
    function generateCalendarRefOptions() {
      var calendarRefOptions = _.map(ctrl.validReferences, function (reference, i) {
        return {
          label: i + 1 + " - " + ctrl.getReferenceLabel(reference),
          index: i,
          reference: reference
        };
      });
      if (ctrl.formData.references.length === 2) {
        var spreadReference = {
          type: "SPREAD",
          reference1: ctrl.validReferences[0],
          reference2: ctrl.validReferences[1]
        };
        calendarRefOptions.push({
          label: 3 + " - " + "Spread",
          index: 2,
          reference: spreadReference
        });
      }
      ctrl.calendarRefOptions = calendarRefOptions;
    }
    ctrl.addReference = function () {
      ctrl.formData.references.push({
        type: "INDEX",
        indexId: "ESTER"
      });
    };
    ctrl.removeReference = function (index) {
      ctrl.formData.references.splice(index, 1);
    };
    ctrl.onChartPointClick = function (date) {
      ctrl.formData.calendarDate = date;
    };
    ctrl.onChartSetExtremes = function (dateMin, dateMax) {
      updateExportParams(dateMin, dateMax);
    };
    function refreshIndicesList() {
      return $q.when(indexationService.getIndicesClient()).then(function (indices) {
        $scope.indices = indices;
      });
    }
    function refreshIndexationList() {
      return $q.when(customIndexationService.fetchIndexations()).then(function (indexations) {
        $scope.indexations = indexations.slice(0); // cloning before adding option
      });
    }

    /**
     * appelé suite à la cration d'une nouvelle indexation
     */
    $scope.refreshIndexationList = function () {
      refreshIndexationList().then(function () {
        generateCalendarRefOptions();
      });
    };
    var getIndexById = function getIndexById(indexId) {
      return _.find($scope.indices, {
        id: indexId
      });
    };
    var getIndexationById = function getIndexationById(indexationId) {
      return _.find($scope.indexations, {
        id: indexationId
      });
    };
    ctrl.getReferenceLabel = function (reference) {
      if (reference == null) {
        return "";
      }
      if (reference.type === "INDEX") {
        var indice = getIndexById(reference.indexId);
        return indice && indice.label;
      } else if (reference.type === "CUSTOM_INDEXATION") {
        var indexation = getIndexationById(reference.indexationId);
        return indexation && indexation.name;
      }
    };
    ctrl.toggleFullPageChart = function () {
      var fullScreen = ctrl.formData.fullScreenChart;
      ctrl.formData.fullScreenChart = !fullScreen;
      $scope.$broadcast("$autosize");
    };
    ctrl.toggleForward = function () {
      ctrl.formData.forward = !ctrl.formData.forward;
    };
    var exportParams = {
      dateDebut: null,
      dateFin: null
    };
    function updateExportParams(dateDebut, dateFin) {
      exportParams.dateDebut = dateDebut;
      exportParams.dateFin = dateFin;
    }

    /// file export

    ctrl.openHistoryExportPopin = function () {
      var labeledReferences = [];
      _.forEach(ctrl.formData.references, function (reference) {
        var fullReferenceLabel;
        if (reference.type === "CUSTOM_INDEXATION") {
          var indexation = getIndexationById(reference.indexationId);
          fullReferenceLabel = indexation && indexation.expression;
        } else {
          fullReferenceLabel = ctrl.getReferenceLabel(reference);
        }
        labeledReferences.push({
          reference: reference,
          fullReferenceLabel: fullReferenceLabel // todo - reference indexation non tronquée par ... quand trop long
        });
      });
      //
      return $modal.open({
        controller: "mktHistoryExportPopinCtrl",
        template: __webpack_require__(3709),
        vars: {
          exportParams: {
            // add forwards ?
            dateDebut: exportParams.dateDebut,
            dateFin: exportParams.dateFin
          },
          labeledReferences: labeledReferences,
          andSpread: ctrl.formData.references.length == 2 && ctrl.formData.spread
        }
      });
    };
  }]
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/historique/mkt-history-page.js", __webpack_require__(1)))

/***/ }),
/* 2846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, moment, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("mktHistoryCalendar", ["indexationService", "fixingService", "mktHistoryUtils", "$debounce", "$timeout", function (indexationService, fixingService, mktHistoryUtils, $debounce, $timeout) {
  return {
    restrict: "E",
    scope: {
      reference: "=",
      date: "="
    },
    replace: true,
    controllerAs: "calendarCtrl",
    template: __webpack_require__(3706),
    controller: ["$scope", function controller($scope) {
      var ctrl = this;
      $scope.calendarConfig = {
        hideWeekends: true,
        date: $scope.date
      };
      $scope.$watch("reference", function (reference) {
        ctrl.loadMonthlyFixings();
      }, true);
      $scope.$watch("date", function (date) {
        $scope.calendarConfig.date = date;
        ctrl.loadMonthlyFixings();
      });
      var currentMonth = null,
        currentYear = null,
        currentReference = null;
      ctrl.loadMonthlyFixings = $debounce(function () {
        var calendarDate = $scope.calendarConfig.date,
          month = moment(calendarDate).month(),
          year = moment(calendarDate).year(),
          reference = $scope.reference;
        var spread = reference != null && reference.type === 'SPREAD';
        var reference1,
          reference2 = null;
        if (spread) {
          reference1 = reference.reference1;
          reference2 = reference.reference2;
          if (!(mktHistoryUtils.isReferenceValid(reference1) && mktHistoryUtils.isReferenceValid(reference2))) {
            $scope.fixingsMap = {};
            return;
          }
        } else if (!mktHistoryUtils.isReferenceValid(reference)) {
          $scope.fixingsMap = {};
          return;
        }
        if (month === currentMonth && year === currentYear && mktHistoryUtils.isSameReference(currentReference, reference)) {
          return;
        }
        currentMonth = month;
        currentYear = year;
        currentReference = angular.copy(reference);
        ctrl.isLoading = true;
        if (spread) {
          return fixingService.getMonthlySpreadFixings(reference1, reference2, month, year).then(function (fixings) {
            $scope.fixingsMap = fixings;
            $timeout(function () {
              ctrl.isLoading = false;
            }, 0);
          });
        } else {
          return fixingService.getMonthlyFixings(reference, month, year).then(function (fixings) {
            $scope.fixingsMap = fixings;
            $timeout(function () {
              ctrl.isLoading = false;
            }, 0);
          });
        }
      }, 100);
      ctrl.getReferenceIndexType = function () {
        var reference = $scope.reference;
        if (reference.type === "INDEX") {
          var indice = indexationService.getIndice(reference.indexId);
          return indice && indice.type || "TAUX";
        } else {
          // hardcoded for now for indexations
          return "TAUX";
        }
      };
    }]
  };
}]);
ngModule.directive('mktCalendarCellTemplate', ["$numberFormat", function ($numberFormat) {
  return {
    restrict: "E",
    require: "^mktHistoryCalendar",
    scope: true,
    replace: true,
    template: '' + '<div class="mkt-cal-cell">' + '   <div class="day">' + '       {{day}}' + '   </div>' + '   <div class="value" ng-switch="fixing.state">' + '       <span ng-switch-when="CLOSED_MARKET_DAY">' + '           <i class="fa fa-moon-o"></i>' + '       </span>' + '       <span ng-switch-default>' + '           {{indexValue}}' + '       </span>' + '   </div>' + '</div>',
    link: function link($scope, $el, $attr, calendarCtrl) {
      $scope.indexValue = "-";
      $scope.fixing = null;
      var refreshIndexValue = function refreshIndexValue() {
        var monthMap = $scope.fixingsMap;
        var fixing = $scope.fixing = monthMap ? monthMap[$scope.day] : null;
        if (fixing != null) {
          var indexType = calendarCtrl.getReferenceIndexType();
          var usePercentage = indexType === "TAUX";
          var formattedIndexValue = $numberFormat[usePercentage ? "percentage" : "number"](fixing.valeur, 4);
          if (fixing.type === "ESTIME") {
            formattedIndexValue += "*";
          }
          $scope.indexValue = formattedIndexValue;
        } else {
          $scope.indexValue = "-";
        }
      };
      $scope.$watch("fixingsMap", refreshIndexValue);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/historique/mktHistoryCalendar.js", __webpack_require__(2), __webpack_require__(3)))

/***/ }),
/* 2847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("mktHistoryCalendarCarousel", ["contextService", function (contextService) {
  var MIN_CALENDAR_WIDTH = 360;
  return {
    restrict: "E",
    replace: true,
    scope: {
      indexationRef: "=",
      calendarDate: "="
    },
    controllerAs: "carouselCtrl",
    template: __webpack_require__(3707),
    link: function link($scope, $el, $attrs, ctrl) {
      ctrl.initialize();
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this;
      var nbMonthsToShow,
        currentDate = null; // this is actually a moment, not a date.

      ctrl.initialize = function () {
        /*
        var context           = contextService.getContext(),
            dateVisualisation = context.dateVisualisation;
        currentDate = moment(dateVisualisation).clone();
        */

        nbMonthsToShow = calculateNumberOfCalendars();
        $scope.$watch("calendarDate", onCalendarDateChange);
        $scope.$on("$resize", function () {
          refreshCalendarsOnResize();
        });
      };
      ctrl.showPrevious = function () {
        currentDate = currentDate.add(-1, "month");
        generateDisplayedMonths();
      };
      ctrl.showNext = function () {
        currentDate = currentDate.add(1, "month");
        generateDisplayedMonths();
      };
      ctrl.monthTrackKey = function (date) {
        return date.getFullYear() + "-" + date.getMonth();
      };
      function onCalendarDateChange() {
        var nextDate = $scope.calendarDate;
        if (nextDate != null && !moment(nextDate).isSame(currentDate, "month")) {
          currentDate = moment(nextDate);
          generateDisplayedMonths();
        }
      }
      function refreshCalendarsOnResize() {
        var newNbCalendars = calculateNumberOfCalendars();
        if (newNbCalendars !== nbMonthsToShow) {
          nbMonthsToShow = newNbCalendars;
          generateDisplayedMonths();
        }
      }
      function calculateNumberOfCalendars() {
        var totalWidth = $element.innerWidth(),
          buttonsWidth = $element.find(".mkt-carousel-btn").eq(0).width() * 2,
          availableWidth = totalWidth - buttonsWidth,
          nbCalendars = Math.floor(availableWidth / MIN_CALENDAR_WIDTH);
        // console.log("*** calculateNumberOfCalendars ->", nbCalendars, availableWidth);
        return nbCalendars;
      }
      function generateDisplayedMonths() {
        var lastMonth = currentDate.clone(); // TODO : parametrize here.
        var displayedMonths = [];
        for (var i = 0; i < nbMonthsToShow; i++) {
          displayedMonths.unshift(moment(lastMonth).add(-i, "month").toDate());
        }
        ctrl.months = displayedMonths;
      }
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/historique/mktHistoryCalendarCarousel.js", __webpack_require__(2)))

/***/ }),
/* 2848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.component("mktHistoryChart", {
  bindings: {
    references: "<",
    forward: "<",
    forwardNbAnnees: "<",
    spread: "<",
    chartConfig: "<",
    onPointClick: "<",
    onSetExtremes: "<"
  },
  template: __webpack_require__(3708),
  controller: ["$scope", "chartUtils", "contextService", "$numberFormat", "fixingService", "mktHistoryUtils", "stringUtils", "customIndexationService", "mktChartUtils", "$translate", function controller($scope, chartUtils, contextService, $numberFormat, fixingService, mktHistoryUtils, stringUtils, customIndexationService, mktChartUtils, $translate) {
    var getAxis = mktChartUtils.getAxis,
      getIndiceTypes = mktChartUtils.getIndiceTypes,
      getReferenceIndexType = mktChartUtils.getReferenceIndexType,
      getReferenceLabel = mktChartUtils.getReferenceLabel;
    var ctrl = this;
    var customIndexations = [];
    ctrl.$onInit = function () {
      customIndexationService.fetchIndexations().then(function (indexations) {
        customIndexations = indexations;
      });
    };
    ctrl.$onChanges = function (changes) {
      onInputChange();
    };
    function onInputChange() {
      if (ctrl.references.length > 0) {
        // todo NFR - il serait bien d'arreter le chargement en cours si il y en a déjà un avant de relancer l'update question de ne pas avoir de race
        updateChartData().then(function () {
          refreshChartConfig();
        });
      }
    }
    function isSpread() {
      return ctrl.references != null && ctrl.references.length === 2 && ctrl.spread === true;
    }
    function onChartSetExtremes(dateMin, dateMax) {
      if (ctrl.onSetExtremes) {
        ctrl.onSetExtremes(dateMin, dateMax);
      }
      updateChartData(dateMin, dateMax).then(function () {
        ctrl.chartConfig.series = generateChartSeries();
      });
    }

    /**
     * Updates the chart data for current references and options.
     *
     * @param dateDebut
     * @param dateFin
     * @return {*|Promise.<TResult>}
     */
    function updateChartData(dateDebut, dateFin) {
      if (isSpread()) {
        ctrl.loading = true;
        return fixingService.getSpreadHistory(ctrl.references[0], ctrl.references[1], {
          dateDebut: dateDebut,
          dateFin: dateFin,
          forward: ctrl.forward ? ctrl.forwardNbAnnees : 0
        }).then(function (data) {
          ctrl.chartData = data;
        }).finally(function () {
          ctrl.loading = false;
        });
      } else {
        ctrl.loading = true;
        return fixingService.getMultipleHistory(ctrl.references, {
          dateDebut: dateDebut,
          dateFin: dateFin,
          forward: ctrl.forward ? ctrl.forwardNbAnnees : 0
        }).then(function (indexHistories) {
          ctrl.chartData = indexHistories.histories;
        }).finally(function () {
          ctrl.loading = false;
        });
      }
    }

    /**
     * Refresh the chart config according to current indexations and options and inject it to controller
     */
    function refreshChartConfig() {
      if (ctrl.references == null || ctrl.references.length === 0) {
        return;
      }
      var chartConfig = isSpread() ? getSpreadModeChartConfig() : getClassicModeChartConfig();
      chartConfig.series = generateChartSeries();
      ctrl.chartConfig = chartConfig;
    }
    function generateChartSeries() {
      var series = [];
      if (isSpread()) {
        series.push({
          id: "spread-" + mktHistoryUtils.getReferenceId(ctrl.references[0]) + "-" + mktHistoryUtils.getReferenceId(ctrl.references[1]),
          name: "Spread (" + getReferenceLabel(ctrl.references[0]) + " - " + getReferenceLabel(ctrl.references[1]) + ")",
          data: chartUtils.mapAndFilter(ctrl.chartData.fixings, "date", "valeur"),
          color: chartUtils.getGraphColor(0),
          indexType: getReferenceIndexType(ctrl.references[0])
        });
      } else {
        var indexTypes = getIndiceTypes(ctrl.references);
        _.each(ctrl.references, function (reference, i) {
          var referenceIndexType = getReferenceIndexType(reference);
          var axisIndex = _.indexOf(indexTypes, referenceIndexType);
          var data;
          if (ctrl.chartData[i] == null) {
            console.log("Pas de fixing pour " + getReferenceLabel(reference), i);
            data = [];
          } else {
            data = chartUtils.mapAndFilter(ctrl.chartData[i].fixings, "date", "valeur");
          }
          series.push({
            id: mktHistoryUtils.getReferenceId(reference),
            name: getReferenceLabel(reference),
            data: data,
            color: chartUtils.getGraphColor(i),
            yAxis: axisIndex,
            indexType: referenceIndexType
          });
        });
      }
      return series;
    }

    /**
     * Generates the chart config for the classic mode.
     */
    function getClassicModeChartConfig() {
      var chartConfig = getBaseChartConfig();
      var title, subtitle;
      var references = ctrl.references;
      var indexTypes = getIndiceTypes(references);
      var axises = _.map(indexTypes, getAxis);
      if (references.length === 1) {
        title = chartUtils.tooltipElement(getReferenceLabel(references[0]), {
          color: chartUtils.getGraphColor(0)
        });
        if (references[0].type === "CUSTOM_INDEXATION") {
          var indexation = _.find(customIndexations, {
            id: references[0].indexationId
          });
          if (indexation != null) {
            subtitle = indexation.expression;
          }
        }
      } else if (references.length === 2) {
        title = chartUtils.tooltipElement(getReferenceLabel(references[0]), {
          color: chartUtils.getGraphColor(0)
        }) + " et " + chartUtils.tooltipElement(getReferenceLabel(references[1]), {
          color: chartUtils.getGraphColor(1)
        });
      } else {
        title = null;
        chartConfig.options.legend = {
          enabled: true,
          align: 'right',
          verticalAlign: 'top',
          layout: "vertical",
          x: -10,
          y: 30,
          floating: true
        };
      }
      chartConfig.options.yAxis = axises;
      chartConfig.options.subtitle.text = subtitle;
      chartConfig.title.text = title;
      return chartConfig;
    }

    /**
     * Generates the chart config for the spread mode.
     */
    function getSpreadModeChartConfig() {
      var chartConfig = getBaseChartConfig();
      var firstReference = ctrl.references[0],
        secondReference = ctrl.references[1];
      var indexType = getReferenceIndexType(firstReference);
      var firstLabel = stringUtils.escapeHtml(getReferenceLabel(firstReference)),
        secondLabel = stringUtils.escapeHtml(getReferenceLabel(secondReference));
      var title = "Spread (" + firstLabel + " - " + secondLabel + ")";
      var yAxis = {
        title: {
          text: mktHistoryUtils.getIndexTypeAxisLabel(indexType),
          style: {
            color: chartUtils.getGraphColor(0)
          }
        },
        labels: {
          formatter: function formatter() {
            return indexType === "TAUX" ? $numberFormat.percentage(this.value, 2) : $numberFormat.number(this.value, 2);
          },
          style: {
            color: chartUtils.getGraphColor(0)
          }
        },
        plotLines: [{
          color: '#9C9C9C',
          width: 1,
          value: 0.0,
          zIndex: 5
        }, {
          color: '#FF00FF',
          width: 1,
          value: ctrl.chartData.avg,
          zIndex: 5,
          label: {
            text: $translate('marche.history.graphique.spreadMoyen'),
            align: 'right',
            x: -5
          }
        }]
      };
      chartConfig.title.text = title;
      chartConfig.options.yAxis = yAxis;
      return chartConfig;
    }

    /**
     * Returns the base config for both chart modes.
     */
    function getBaseChartConfig() {
      return {
        useHighStocks: true,
        title: {
          text: ''
        },
        series: [],
        options: {
          reset: _.uniqueId("chart-reset"),
          chart: {
            animation: false,
            zoomType: 'x',
            height: 400,
            borderColor: '#322f8f',
            events: {
              click: function click(e) {
                if (ctrl.onPointClick) {
                  var axisValue = e.xAxis[0].value;
                  var date = moment(axisValue).toDate();
                  $scope.$apply(function () {
                    ctrl.onPointClick(date);
                  });
                }
              }
            }
          },
          subtitle: {
            text: ''
          },
          tooltip: {
            shared: true,
            formatter: function formatter() {
              var format = moment(this.x).format("D MMM YYYY");
              var tooltip = "<b>" + format + "</b> <br/>";
              _.each(this.points, function (point) {
                var value = point.series.userOptions.indexType === "TAUX" ? $numberFormat.percentage(point.y, 2) : $numberFormat.number(point.y, 4);
                var serieLine = '<span style="color: ' + point.series.color + '; font-weight: bold;">' + point.series.name + '</span> : ' + value;
                tooltip += serieLine + "<br/>";
              });
              return tooltip;
            }
          },
          plotOptions: {
            series: {
              showInNavigator: true,
              pointInterval: 24 * 3600 * 1000,
              turboThreshold: 0,
              animation: false,
              events: {
                click: function click(e) {
                  if (ctrl.onPointClick) {
                    var pointDate = e.point.x;
                    var date = moment(pointDate).toDate();
                    $scope.$apply(function () {
                      ctrl.onPointClick(date);
                    });
                  }
                }
              }
            },
            line: {
              marker: {
                enabled: false
              }
            }
          },
          xAxis: {
            type: 'datetime',
            plotLines: ctrl.forward ? chartUtils.getDateMarchePlotLine(contextService) : null,
            minRange: 1000 * 3600 * 24 * 7,
            // one week
            maxZoom: 14 * 24 * 3600000,
            // fourteen days ,
            events: {
              afterSetExtremes: function afterSetExtremes(e) {
                if (e.trigger !== "updatedData" && e.trigger != null) {
                  var dateMin = moment(e.min).toDate(),
                    dateMax = moment(Math.round(e.max)).toDate();
                  $scope.$apply(function () {
                    onChartSetExtremes(dateMin, dateMax);
                  });
                }
              }
            }
          },
          yAxis: [],
          navigator: {
            enabled: true,
            adaptToUpdatedData: false
          },
          scrollbar: {
            liveRedraw: false
          },
          rangeSelector: {
            enabled: true
          }
        }
      };
    }
  }]
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/historique/mktHistoryChart.js", __webpack_require__(1), __webpack_require__(2)))

/***/ }),
/* 2849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("mktHistoryExportPopinCtrl", ["$scope", "$fileDownload", "$uiBlock", function ($scope, $fileDownload, $uiBlock) {
  var labeledReferences = $scope.labeledReferences;
  var exportParams = $scope.exportParams;
  var andSpread = $scope.andSpread;

  // pour avoir un pas journalier quoi qu'il arrive
  exportParams.nbDonneeMax = -1;
  $scope.performExport = function () {
    $uiBlock.block();
    $fileDownload.start("/rest/market/history/export?xls=true", {
      labeledReferences: labeledReferences,
      andSpread: andSpread,
      options: exportParams
    }, {
      method: "POST"
    }).then(function () {
      $scope.$close();
    }).finally(function () {
      $uiBlock.unblock();
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/historique/mktHistoryExportPopin.js"))

/***/ }),
/* 2850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("marketdataIcePage", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: __webpack_require__(3710),
    controller: ["$scope", "$http", "$translate", "chartUtils", "lovService", "indexationService", "$q", "$numberFormat", "$dateFormat", function controller($scope, $http, $translate, chartUtils, lovService, indexationService, $q, $numberFormat, $dateFormat) {
      var MIN_DATE = __WEBPACK_IMPORTED_MODULE_1_moment___default()("20230901", "YYYYMMDD").toDate();
      var MAX_DATE = __WEBPACK_IMPORTED_MODULE_1_moment___default()().toDate();
      $scope.params = {
        dateMarche: __WEBPACK_IMPORTED_MODULE_1_moment___default()().toDate(),
        index: 'EUR3M',
        typeVol: 'LOG_NORMAL'
      };
      $scope.typeVolatilites = [{
        id: 'LOG_NORMAL',
        label: 'LOG NORMAL'
      }, {
        id: 'NORMAL',
        label: 'NORMAL'
      }];
      $scope.indices = _.map(["EUR1M", "EUR3M", "EUR6M", "EUR12M"], indexationService.getIndice);
      $scope.getData = function () {
        $scope.loading = true;
        $http.get("/rest/analyse/marketdata-pricer-option/donnees-courbe-taux", {
          params: $scope.params
        }).then(function (response) {
          $scope.ycData = response.data;
        }).finally(function () {
          $scope.loading = false;
        });
        $http.get("/rest/analyse/marketdata-pricer-option/donnees-volatilite", {
          params: $scope.params
        }).then(function (response) {
          $scope.matrice = response.data;
          $scope.volData = $scope.matrice.tenorVolatilities;
          var columns = [{
            attribute: 'tenor',
            title: 'tenor',
            cellClass: 'align-c',
            sortable: true,
            sortType: 'number'
          }];
          var minStrike = $scope.matrice.minStrike;
          var nbStrikes = $scope.volData[0].vol.length;
          for (var strike = 0; strike < nbStrikes; strike++) {
            columns.push({
              attribute: 'vol[' + strike + ']',
              title: '' + (minStrike + strike * 0.25) + "%",
              cellClass: 'align-c'
            });
          }
          $scope.volTableConfig = {
            source: "volData",
            allowSelection: true,
            selectionAttribute: "selectedVolData",
            selectionScope: $scope,
            footer: 'static',
            columns: columns
          };
          $http.get("/rest/analyse/marketdata-pricer-option/courbes-taux", {
            params: $scope.params
          }).then(function (response) {
            $scope.courbesTauxData = response.data;
            $scope.courbesTauxChartConfig.series = [{
              name: 'Courbe taux ICAP ' + $scope.params.index + ' (données du ' + $dateFormat.date($scope.courbesTauxData.dateCourbeICAP) + ')',
              data: chartUtils.mapAndFilter($scope.courbesTauxData.courbeICAP, "date", "valeur"),
              color: '#15a3ef'
            }, {
              name: 'Courbe taux Taelys' + ' (données du ' + $dateFormat.date($scope.courbesTauxData.dateCourbeTaelys) + ')',
              data: chartUtils.mapAndFilter($scope.courbesTauxData.courbeTaelys, "date", "valeur"),
              color: '#4daf19'
            }];
          }).finally(function () {
            $scope.loading = false;
          });
          $http.get("/rest/analyse/marketdata-pricer-option/courbes-anticipes", {
            params: $scope.params
          }).then(function (response) {
            $scope.courbesAnticipesData = response.data;
            $scope.courbesAnticipesChartConfig.series = [{
              name: 'Courbe taux ICAP ' + $scope.params.index,
              data: chartUtils.mapAndFilter($scope.courbesAnticipesData.courbeICAP, "date", "valeur"),
              color: '#15a3ef'
            }, {
              name: 'Courbe taux Taelys',
              data: chartUtils.mapAndFilter($scope.courbesAnticipesData.courbeTaelys, "date", "valeur"),
              color: '#4daf19'
            }, {
              name: 'Spread',
              data: chartUtils.mapAndFilter($scope.courbesAnticipesData.spread, "date", "valeur"),
              color: '#F77600'
            }];
          }).finally(function () {
            $scope.loading = false;
          });
        }).finally(function () {
          $scope.loading = false;
        });
      };
      $scope.$watch("params", function () {
        if ($scope.params.dateMarche < MIN_DATE) {
          $scope.params.dateMarche = MIN_DATE;
        }
        if ($scope.params.dateMarche > MAX_DATE) {
          $scope.params.dateMarche = MAX_DATE;
        }
        $scope.getData();
      }, true);
      $scope.ycDataTableConfig = {
        source: "ycData",
        allowSelection: true,
        selectionAttribute: "selectedYcData",
        selectionScope: $scope,
        footer: 'static',
        columns: [{
          attribute: 'id',
          title: 'id',
          cellClass: 'align-c',
          sortType: "date",
          sortable: true
        }, {
          attribute: 'fixing.dateValeur',
          title: 'dateValeur',
          filter: 'dateShort',
          cellClass: 'align-c',
          sortType: "date",
          sortable: true
        }, {
          attribute: 'fixing.valeur',
          title: 'Fixing',
          cellClass: 'align-c',
          filter: 'percentage:5'
        }]
      };
      $scope.courbesTauxChartConfig = {
        options: {
          chart: {
            type: 'line',
            height: '300',
            zoomType: "x"
          },
          legend: {
            enabled: false
          },
          tooltip: {
            shared: true,
            formatter: function formatter() {
              var tooltip = '<span>' + $dateFormat.date(this.x) + '</span> :  <br/>';
              _.each(this.points, function (point) {
                var value = $numberFormat.percentage(point.y, 3);
                var label = point.series.name;
                var serieLine = '<span style="color: ' + point.series.color + '; font-weight: bold;">' + label + '</span> : ' + value;
                tooltip += serieLine + "<br/>";
              });
              return tooltip;
            }
          },
          xAxis: {
            type: 'datetime',
            tickInterval: 1000 * 60 * 60 * 24 * 365
          },
          yAxis: {
            title: {
              text: 'Taux'
            },
            labels: {
              formatter: function formatter() {
                return $numberFormat.percentage(this.value, 2);
              }
            }
          }
        }
      };
      $scope.courbesAnticipesChartConfig = {
        options: {
          chart: {
            type: 'line',
            height: '300',
            zoomType: "x"
          },
          legend: {
            enabled: false
          },
          tooltip: {
            shared: true,
            formatter: function formatter() {
              var tooltip = '<span>' + $dateFormat.date(this.x) + '</span> :  <br/>';
              _.each(this.points, function (point) {
                var value = $numberFormat.percentage(point.y, 3);
                var label = point.series.name;
                var serieLine = '<span style="color: ' + point.series.color + '; font-weight: bold;">' + label + '</span> : ' + value;
                tooltip += serieLine + "<br/>";
              });
              return tooltip;
            }
          },
          xAxis: {
            type: 'datetime',
            tickInterval: 1000 * 60 * 60 * 24 * 365
          },
          yAxis: {
            title: {
              text: 'Taux'
            },
            labels: {
              formatter: function formatter() {
                return $numberFormat.percentage(this.value, 2);
              }
            }
          }
        }
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/ice/marketdataIcePage.js", __webpack_require__(1)))

/***/ }),
/* 2851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("IndexationsPersonnaliseesController", ["$scope", "$http", "$translate", "$dialogBox", "$notifications", "customIndexationService", "pageStatus", "$authz", function ($scope, $http, $translate, $dialogBox, $notifications, customIndexationService, pageStatus, $authz) {
  var refreshIndexationList = function refreshIndexationList() {
    return customIndexationService.fetchIndexations().then(function (indexations) {
      $scope.indexations = indexations;
    });
  };
  $scope.isIntra = function () {
    return $authz.isIntra();
  };
  $scope.indexationTableConfig = {
    id: "indexationTable",
    source: "indexations",
    columns: [{
      attribute: 'name',
      title: $translate('marche.history.indexations.nom')
    }, {
      attribute: 'expression',
      title: $translate('marche.history.indexations.Indexation')
    }, {
      attribute: 'tauxDuJour',
      filter: 'taux',
      title: $translate('marche.history.indexations.TauxADate'),
      cellClass: 'align-c'
    }, {
      attribute: 'ownerName',
      title: $translate('marche.history.indexations.Createur'),
      cellClass: 'align-c',
      template: '<div>{{model.ownerName}}</div><div>{{model.metadata.creationDate|dateShort}}</div>'
    }, {
      attribute: "shared",
      title: $translate('marche.history.indexations.Partagee'),
      filter: "yesOrNo",
      cellClass: "align-c"
    }, {
      title: $translate('marche.history.indexations.Actions'),
      cellClass: "align-c",
      template: '' + '<div>' + '   <tl-icon-button ng-if="::model.userIsOwner" icon="edit" tl-tooltip="{{\'marche.history.indexations.Editer\'|translate}}" ng-click="editIndexation(model.id)"></tl-icon-button>' + '   <tl-icon-button icon="copy" tl-tooltip="{{\'marche.history.indexations.Dupliquer\'|translate}}" ng-click="copyIndexation(model.id)"></tl-icon-button>' + '   <tl-icon-button ng-if="::model.userIsOwner || isIntra()" icon="delete" ng-class="{\'show-delete-intra\':!model.userIsOwner && isIntra()}" tl-tooltip="{{\'marche.history.indexations.Supprimer\'|translate}}" ng-click="deleteIndexation(model.id)"></tl-icon-button>' + '   <tl-icon-button ng-if="model.userIsOwner && !model.shared" icon="share" tl-tooltip="{{\'marche.history.indexations.Partager\'|translate}}" ng-click="toggleShareIndexation(model.id)"></tl-icon-button>' + '   <tl-icon-button ng-if="model.userIsOwner && model.shared" icon="unshare" tl-tooltip="{{\'marche.history.indexations.AnnulerPartage\'|translate}}" ng-click="toggleShareIndexation(model.id)"></tl-icon-button>' + '</div>'
    }]
  };
  refreshIndexationList();
  $scope.createNewIndexation = function () {
    customIndexationService.openCreationPopin().then(function () {
      refreshIndexationList();
      pageStatus.invalidate();
    });
  };
  $scope.editIndexation = function (indexationId) {
    customIndexationService.openEditionPopin(indexationId).then(function () {
      $notifications.info($translate('marche.history.indexations.notifications.IndexationSauvegardee'));
      refreshIndexationList();
      pageStatus.invalidate();
    });
  };
  $scope.copyIndexation = function (indexationId) {
    customIndexationService.openEditionPopin(indexationId, true).then(function () {
      $notifications.info($translate('marche.history.indexations.notifications.IndexationDupliquee'));
      refreshIndexationList();
      pageStatus.invalidate();
    });
  };
  $scope.deleteIndexation = function (indexationId) {
    return $dialogBox.confirm({
      title: $translate('marche.history.indexations.SuppressionIndexation.title'),
      text: $translate('marche.history.indexations.SuppressionIndexation.text')
    }).then(function () {
      return customIndexationService.deleteIndexation(indexationId);
    }).then(function () {
      $notifications.info($translate('marche.history.indexations.notifications.IndexationSupprimee'));
      refreshIndexationList();
      pageStatus.invalidate();
    });
  };
  $scope.toggleShareIndexation = function (indexationId) {
    return customIndexationService.toggleShareIndexation(indexationId).then(function () {
      $notifications.info($translate('marche.history.indexations.notifications.ModificationEffectuee'));
      refreshIndexationList();
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/indexations/indexationsPersonnalisees/indexationsPersonnalisees.js"))

/***/ }),
/* 2852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.component("mktIndexationsPage", {
  bindings: {},
  template: __webpack_require__(3712),
  controller: ["$scope", "$translate", "$authz", function controller($scope, $translate, $authz) {
    var tabs = [];
    tabs.push({
      title: $translate('marche.history.indexations.IndexationsPersonnalisees'),
      fragment: "indexationsPersonnalisees",
      template: __webpack_require__(3711),
      controller: "IndexationsPersonnaliseesController",
      invalidable: true
    });
    $scope.indexationsTabConfig = {
      tabsetClass: "reporting-tabs",
      pillsClass: "",
      tabParameter: "subsection",
      tabs: tabs
    };
  }]
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/marche/indexations/mktIndexations.js"))

/***/ }),
/* 2853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * passez en attribut application (nm de l'application)
 */
ngModule.directive("tlApplicationIcon", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<i tl-tooltip class=\"mr-s module-dette\" ng-class=\"[applicationClass]\">\n<tl-tooltip-content><div>{{'lov.applicationsClients.'+application|translate}}</div></tl-tooltip-content>\n{{'lov.applicationsClients.initial.'+application|translate}}\n</i>",
    link: function link($scope, $el, $attrs) {
      $scope.application = $attrs.application;
      $scope.applicationClass = "application-" + $scope.application;
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/modules/tl-application-icon.js"))

/***/ }),
/* 2854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlModuleAideSubvention", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<span tl-tooltip=\"Subventions\" class=\"mr-s module-aide-subvention\">S</span>"
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/modules/tl-module-aide-subvention.js"))

/***/ }),
/* 2855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlModuleCreditBail", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<span tl-tooltip=\"Cr\xE9dit bail\" class=\"mr-s module-credit-bail \">Cb</span>"
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/modules/tl-module-credit-bail.js"))

/***/ }),
/* 2856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlModuleDetteGarantie", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<span tl-tooltip=\"Dette garantie\" class=\"mr-s module-dg\">DG</span>"
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/modules/tl-module-dette-garantie.js"))

/***/ }),
/* 2857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlModuleDette", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<span tl-tooltip=\"Dette et financement\" class=\"mr-s module-dette\">D</span>"
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/modules/tl-module-dette.js"))

/***/ }),
/* 2858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
/**
 * attibut interface pour préciser le nom de l'interface (ex: <tl-module-interfacage interface="{{proposition.logicielInterfacage}}")
 */
ngModule.directive("tlModuleInterfacage", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      interface: "@"
    },
    template: "<span tl-tooltip=\"Interfa\xE7age {{interface}}\" class=\"mr-s module-mandatement\">I</span>"
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/modules/tl-module-interfacage.js"))

/***/ }),
/* 2859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlModuleOfComparoscope", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<span tl-tooltip=\"Observatoire financier - Comparoscope\" class=\"mr-s module-ofs\">OFC</span>"
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/modules/tl-module-of-comparoscope.js"))

/***/ }),
/* 2860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlModuleOf", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<span tl-tooltip=\"Observatoire financier\" class=\"mr-s module-of\">OF</span>"
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/modules/tl-module-of.js"))

/***/ }),
/* 2861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlModulePlacement", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<span tl-tooltip=\"Placement\" class=\"mr-s module-placement\">Pl</span>"
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/modules/tl-module-placement.js"))

/***/ }),
/* 2862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlModulePret", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<span tl-tooltip=\"Pr\xEAts octroy\xE9s\" class=\"mr-s module-pret\">Pr</span>"
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/modules/tl-module-pret.js"))

/***/ }),
/* 2863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.config(function () {
  $.extend($.jGrowl.defaults, {
    themeState: "no-state",
    position: "tl-notification-desk",
    closer: false,
    // "close all" button
    life: 6000,
    animateOpen: {
      opacity: "show",
      right: "+=200px"
    },
    animateClose: {
      opacity: "hide",
      right: "-=200px"
    }
  });
});
ngModule.factory("$notifications", function () {
  var addMessage = function addMessage(message, type, options) {
    $.jGrowl(message, _.extend(options, {
      theme: type
    }));
  };
  return {
    info: function info(message, options) {
      addMessage(message, "info", options || {});
    },
    error: function error(message, options) {
      addMessage(message, "error", options || {});
    },
    warn: function warn(message, options) {
      addMessage(message, "warn", options || {});
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/$notifications.js", __webpack_require__(4), __webpack_require__(1)))

/***/ }),
/* 2864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("abonnementAlerteService", ["$http", function ($http) {
  return {
    getAlerteNouvelleVersion: function getAlerteNouvelleVersion() {
      return $http.get('/rest/abonnement-alerte/nouvelle-version').then(function (response) {
        return response.data;
      });
    },
    setAlerteNouvelleVersion: function setAlerteNouvelleVersion(statut) {
      return $http.post('/rest/abonnement-alerte/nouvelle-version?statut=' + statut).then(function (response) {
        return response.data;
      });
    },
    getAlerteNouvellePublication: function getAlerteNouvellePublication() {
      return $http.get('/rest/abonnement-alerte/nouvelle-publication').then(function (response) {
        return response.data;
      });
    },
    setAlerteNouvellePublication: function setAlerteNouvellePublication(statut) {
      return $http.post('/rest/abonnement-alerte/nouvelle-publication?statut=' + statut).then(function (response) {
        return response.data;
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/abonnementAlerteService.js"))

/***/ }),
/* 2865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("applicationSettings", ["$http", "$q", function ($http, $q) {
  var deferred = $q.defer();
  var settings = null;
  return {
    loaded: deferred.promise,
    get: function get() {
      return this.loaded.then(function () {
        return settings;
      });
    },
    $load: function $load() {
      $http.get("/rest/application/settings").then(function (response) {
        settings = response.data;
        deferred.resolve(settings);
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/applicationSettings.js"))

/***/ }),
/* 2866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("budgetService", ["$http", "$q", "$session", "$applications", function ($http, $q, $session, $applications) {
  var budgets = null;
  var budgetMap = null;
  var budgetFetchPromise = null;
  var processServerBudgets = function processServerBudgets(serverBudget) {
    budgets = serverBudget;
    recomputeBudgetMap(budgets);
  };
  var recomputeBudgetMap = function recomputeBudgetMap(budgets) {
    budgetMap = {};
    if (!budgets) {
      return;
    }
    var _addToMap = function addToMap(budget) {
      budgetMap[budget.id] = budget;
      _.each(budget.children, function (child) {
        _addToMap(child);
      });
    };
    _.each(budgets, _addToMap);
  };
  var loadIfRequired = function loadIfRequired() {
    if (budgets != null) {
      return budgets;
    }
    if (budgetFetchPromise != null) {
      return budgetFetchPromise;
    }
    return doServerSync();
  };
  var doServerSync = function doServerSync() {
    var deferred = $q.defer();
    $http.get("/rest/budgets").then(function (response) {
      var budgets = response.data;
      processServerBudgets(budgets);
      deferred.resolve(budgets);
    });
    budgetFetchPromise = deferred.promise;
    return budgetFetchPromise;
  };
  return {
    $reload: function $reload() {
      return doServerSync();
    },
    $recompute: function $recompute() {
      recomputeBudgetMap(budgets);
    },
    /**
     * Par defaut uniquement les budgets non archivés, disponibles sur le module courant
     * @param config map optionnelle qui peut contenir {showArchive:true, showAllModules:true }
     *
     * @returns le graphe des budgets (donc les busgets racines comme liste)
     */
    findAll: function findAll(config) {
      // renvoie une copie pour protéger contre toute modification
      return $q.when(loadIfRequired()).then(function () {
        var budgetsAll = budgets.slice();
        if (!config || !config.showArchive === true) {
          budgetsAll = _.filter(budgetsAll, function (b) {
            return !b.archive;
          });
        }
        if (!config || config.showAllModules !== true) {
          budgetsAll = _.filter(budgetsAll, function (b) {
            return $applications.isAideSubventionApplication() && b.moduleSubvention || !$applications.isAideSubventionApplication() && b.moduleDette;
          });
        }
        return budgetsAll;
      });
    },
    /**
     *
     * @param budgetId
     * @returns {*} une promese à résoudre
     */
    findById: function findById(budgetId) {
      return $q.when(loadIfRequired()).then(function () {
        return budgetMap[budgetId];
      });
    },
    flattenTree: function flattenTree(budgets) {
      var flattened = [];
      var _appendSubTree = function appendSubTree(budget, depth) {
        var clone = _.extend(angular.copy(budget), {
          depth: depth
        });
        flattened.push(clone);
        if (budget.children && budget.children.length) {
          _.each(budget.children, function (children) {
            _appendSubTree(children, depth + 1);
          });
        }
      };
      _.each(budgets, function (budget) {
        _appendSubTree(budget, 0);
      });

      /**
       * idealement un tri MAIS par sous niveau
       flattened = flattened.sort(function (b1, b2) {
       let attrA = b1.nom.toLowerCase();
       let attrB = b2.nom.toLowerCase();
       return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
       });
       */

      return flattened;
    },
    getBudgetsForType: function getBudgetsForType(type) {
      return $http.get("/rest/budgets/type/" + type).then(function (response) {
        return response.data;
      });
    },
    isNommageBudget: function isNommageBudget() {
      return !$session.getCompte().budgetAsOperation;
    },
    isNommageOperation: function isNommageOperation() {
      return $session.getCompte().budgetAsOperation;
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/budgetService.js", __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 2867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("cbcService", function () {
  var structuresGissler = [{
    id: "A",
    label: "A"
  }, {
    id: "B",
    label: "B"
  }, {
    id: "C",
    label: "C"
  }, {
    id: "D",
    label: "D"
  }, {
    id: "E",
    label: "E"
  }, {
    id: "HORS_CHARTE",
    label: "H.C"
  }];
  var indicesGissler = [{
    id: "UN",
    label: "1"
  }, {
    id: "DEUX",
    label: "2"
  }, {
    id: "TROIS",
    label: "3"
  }, {
    id: "QUATRE",
    label: "4"
  }, {
    id: "CINQ",
    label: "5"
  }, {
    id: "HORS_CHARTE",
    label: "H.C"
  }];
  var cbcService = {
    getStructuresGisslers: function getStructuresGisslers() {
      return structuresGissler;
    },
    getIndicesGissler: function getIndicesGissler() {
      return indicesGissler;
    },
    getCbcLabel: function getCbcLabel(cbc, long) {
      if (!cbc || !cbc.structure || !cbc.indice) {
        return long ? "Non classifié" : "N.C";
      }
      if (cbc.structure == "HORS_CHARTE" || cbc.indice === "HORS_CHARTE") {
        return long ? "Hors charte" : "H.C";
      } else {
        return cbcService.getStructureLabel(cbc.structure) + cbcService.getIndiceLabel(cbc.indice);
      }
    },
    getStructureLabel: function getStructureLabel(structureId) {
      return _.find(structuresGissler, {
        id: structureId
      }).label;
    },
    getIndiceLabel: function getIndiceLabel(structureId) {
      return _.find(indicesGissler, {
        id: structureId
      }).label;
    }
  };
  return cbcService;
});
ngModule.filter("cbc", ["cbcService", function (cbcService) {
  return function cbcFilter(cbc, long) {
    return cbcService.getCbcLabel(cbc, long);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/cbcService.js", __webpack_require__(1)))

/***/ }),
/* 2868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("contrepartieService", ["$http", "$q", function ($http, $q) {
  var contrepartiesColorsMap = [];
  var groupeSort = function groupeSort(g1, g2) {
    if (g1.isDefault) {
      return 1;
    } else if (g2.isDefault) {
      return -1;
    } else {
      var attrA = g1.libelleJuridique.toLowerCase();
      var attrB = g2.libelleJuridique.toLowerCase();
      return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
    }
  };
  var fetchContrepartieUsedInCompte = function fetchContrepartieUsedInCompte() {
    return $http.get("/rest/contreparties/contrepartiesId").then(function (response) {
      return response.data;
    });
  };
  var fetchGroupesBanquaires = function fetchGroupesBanquaires() {
    // les groupes bancaires, avec leurs banques (cf. GroupeBancaireDTO)
    return $http.get('/rest/contreparties/groupesBancaires').then(function (response) {
      return response.data;
    });
  };
  var fetchGroupesFinanceurs = function fetchGroupesFinanceurs() {
    // les groupes bancaires, avec leurs banques (cf. GroupeBancaireDTO)
    return $http.get('/rest/contreparties/groupesFinanceurs').then(function (response) {
      return response.data;
    });
  };
  var fetchFinanceursSubventions = function fetchFinanceursSubventions() {
    // les financeurs (cf. FinanceurSubventionDTO)
    return $http.get('/rest/contreparties/financeurs-subvention').then(function (response) {
      return response.data;
    });
  };
  return {
    $load: function $load() {
      return $http.get("/rest/contreparties/compte-contreparties-colors-info").then(function (response) {
        contrepartiesColorsMap = response.data;
      });
    },
    getContrepartieColor: function getContrepartieColor(id) {
      return contrepartiesColorsMap[id];
    },
    /**
     * liste des banques (BanqueDTO) dans les groupe avec en plus  {groupLabel = group.libelleJuridique, $inCompte = true si inclu dans les produits du compte}
     */
    getContreparties: function getContreparties() {
      return $q.all({
        ids: fetchContrepartieUsedInCompte(),
        groupesBancaires: fetchGroupesBanquaires()
      }).then(function (_ref) {
        var ids = _ref.ids,
          groupesBancaires = _ref.groupesBancaires;
        groupesBancaires.sort(groupeSort);
        var banques = [];
        _.each(groupesBancaires, function (group) {
          _.each(group.banques, function (banque) {
            banque.groupLabel = group.libelleJuridique;
            banque.$inCompte = _.includes(ids, banque.id);
            banques.push(banque);
          });
        });
        return banques;
      });
    },
    /**
     * @returns liste des financeurs
     */
    getFinanceursSubvention: function getFinanceursSubvention() {
      return $q.all({
        ids: fetchContrepartieUsedInCompte(),
        groupesFinanceurs: fetchGroupesFinanceurs()
      }).then(function (_ref2) {
        var ids = _ref2.ids,
          groupesFinanceurs = _ref2.groupesFinanceurs;
        groupesFinanceurs.sort(groupeSort);
        var financeurs = [];
        _.each(groupesFinanceurs, function (group) {
          _.each(group.financeurs, function (financeur) {
            financeur.groupLabel = group.libelleJuridique;
            financeur.$inCompte = _.includes(ids, financeur.id);
            financeurs.push(financeur);
          });
        });
        return financeurs;
      });
    },
    /**
     *
     * @returns {*} un BanqueDTO
     */
    getCDC: function getCDC() {
      return $http.get('/rest/contreparties/cdc').then(function (response) {
        return response.data;
      });
    },
    /**
     *
     * @returns {*} un BanqueDTO
     */
    getBanquePostale: function getBanquePostale() {
      return $http.get('/rest/contreparties/banque-postale').then(function (response) {
        return response.data;
      });
    },
    /**
     *
     * @returns {*} un BanqueDTO
     */
    getCACIB: function getCACIB() {
      return $http.get('/rest/contreparties/CA-CIB').then(function (response) {
        return response.data;
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/contrepartieService.js", __webpack_require__(1)))

/***/ }),
/* 2869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("currencyService", ["$http", function ($http) {
  var currencies = [];
  var currenciesMap = {};
  var getFlagCode = function getFlagCode(isoCode) {
    return isoCode.substr(0, 2).toLowerCase();
  };
  return {
    $load: function $load() {
      return $http.get("/rest/devises").then(function (response) {
        currencies = response.data;
        _.each(currencies, function (currency) {
          currency.flagCode = getFlagCode(currency.isoCode);
          currenciesMap[currency.name] = currency;
        });
      });
    },
    getAll: function getAll() {
      return angular.copy(currencies);
    },
    getByName: function getByName(name) {
      var result = _.find(currencies, function (currency) {
        return currency.name === name;
      });
      return angular.copy(result);
    },
    getByNames: function getByNames(names) {
      var results = _.filter(currencies, function (currency) {
        return _.includes(names, currency.name);
      });
      return angular.copy(results);
    },
    getCurrencySign: function getCurrencySign(currency) {
      if (currency == null) {
        return null;
      }
      return currenciesMap[currency] ? currenciesMap[currency].sign : currency;
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/currencyService.js", __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 2870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, moment, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("etatDetteService", ["$dateFormat", "$modal", "contextService", "$http", "$authz", "$q", "budgetService", function ($dateFormat, $modal, contextService, $http, $authz, $q, budgetService) {
  /**
   * en dette propre, maintient les paramètres du formulaire de manière à pouvoir le partager entre la page etat de la dette et icne comptables
   * @type {null}
   */
  var params = null;
  function _getAnneeParDefaut() {
    var dateVisualisation = contextService.getContext().dateVisualisation;
    // changement d'annee au 1er aout : annee precedente, annee courante
    return moment(dateVisualisation).month() < 8 ? moment(dateVisualisation).year() - 1 : moment(dateVisualisation).year();
  }
  function _getMaquetteIdParDefaut() {
    var maquetteId;
    if ($authz.hasRole("RAPPORT_ETAT_DE_LA_DETTE_M4")) {
      maquetteId = 'M4';
    } else if ($authz.hasRole("RAPPORT_ETAT_DE_LA_DETTE_M14")) {
      maquetteId = 'M14';
    } else if ($authz.hasRole("RAPPORT_ETAT_DE_LA_DETTE_M21")) {
      maquetteId = 'M21';
    } else if ($authz.hasRole("RAPPORT_ETAT_DE_LA_DETTE_M52")) {
      maquetteId = 'M52';
    } else if ($authz.hasRole("RAPPORT_ETAT_DE_LA_DETTE_M57")) {
      maquetteId = 'M57';
    } else if ($authz.hasRole("RAPPORT_ETAT_DE_LA_DETTE_M61")) {
      maquetteId = 'M61';
    } else if ($authz.hasRole("RAPPORT_ETAT_DE_LA_DETTE_M71")) {
      maquetteId = 'M71';
    }
    return maquetteId;
  }
  function _getPlansComptablesAccessibles() {
    var plansComptablesAccessibles;
    var planComptablePrincipal = _getMaquetteIdParDefaut();
    if (planComptablePrincipal === 'M4') {
      plansComptablesAccessibles = [{
        id: 'M4'
      }, {
        id: 'M14'
      }, {
        id: 'M57'
      }];
    } else if (planComptablePrincipal === 'M14') {
      plansComptablesAccessibles = [{
        id: 'M14'
      }, {
        id: 'M4'
      }, {
        id: 'M57'
      }];
    } else if (planComptablePrincipal === 'M21') {
      plansComptablesAccessibles = [{
        id: 'M21'
      }];
    } else if (planComptablePrincipal === 'M52') {
      plansComptablesAccessibles = [{
        id: 'M52'
      }, {
        id: 'M4'
      }, {
        id: 'M22'
      }, {
        id: 'M57'
      }];
    } else if (planComptablePrincipal === 'M57') {
      plansComptablesAccessibles = [{
        id: 'M57'
      }, {
        id: 'M4'
      }, {
        id: 'M14'
      }];
    } else if (planComptablePrincipal === 'M61') {
      plansComptablesAccessibles = [{
        id: 'M61'
      }, {
        id: 'M57'
      }];
    } else if (planComptablePrincipal === 'M71') {
      plansComptablesAccessibles = [{
        id: 'M71'
      }, {
        id: 'M57'
      }];
    }
    return plansComptablesAccessibles;
  }
  function _getTypeBudgetParDefaut() {
    return 'CA';
  }
  return {
    /**
     * recupération synchrone. Doit etre initialisé via un getOrInitParams pour la dette propre pour que les budgets soient bien chargés avant et pouvoir selectionner le budget principal par defaut
     * @returns {null}
     */
    getParams: function getParams() {
      return params;
    },
    /**
     * a utiliser si il n'y a pas besoin d'asynchrone dans l'init (ou géré par l'appelant)
     * @param p
     */
    setParams: function setParams(p) {
      params = p;
    },
    /**
     *pour la dette propre uniquement
     * @returns params, sous forme de promise (asynchrone de manière à pouvoir initialiser avec le budget principal par défaut )
     */
    getOrInitParams: function getOrInitParams() {
      if (params != null) {
        return $q.when(params);
      }
      var defer = $q.defer();
      $http.get('/rest/budgets').then(function (response) {
        var budgets = budgetService.flattenTree(response.data);
        var budgetId = null;
        var planComptablePrincipal = null;
        _.each(budgets, function (b) {
          if (b.type === 'PRINCIPAL') {
            budgetId = b.id;
            planComptablePrincipal = b.planComptable;
          }
        });
        if (planComptablePrincipal == null) {
          planComptablePrincipal = _getMaquetteIdParDefaut();
        }
        params = {
          annee: _getAnneeParDefaut(),
          type: _getTypeBudgetParDefaut(),
          maquetteId: planComptablePrincipal,
          plansComptablesAccessibles: _getPlansComptablesAccessibles(),
          dateDeVote: moment().hour(0).minute(0).second(0).toDate(),
          budgetId: budgetId,
          garanties: true // plus d'actualité normalement
        };
        return defer.resolve(params);
      });
      return defer.promise;
    },
    getMaquetteIdParDefaut: function getMaquetteIdParDefaut() {
      return _getMaquetteIdParDefaut();
    },
    getPlansComptablesAccessibles: function getPlansComptablesAccessibles() {
      return _getPlansComptablesAccessibles();
    },
    getAnneeParDefaut: function getAnneeParDefaut() {
      return _getAnneeParDefaut();
    },
    getTypeBudgetParDefaut: function getTypeBudgetParDefaut() {
      return _getTypeBudgetParDefaut();
    },
    getTypesEtatDette: function getTypesEtatDette() {
      return [{
        'id': 'CA',
        label: 'Compte Administratif / CFU'
      }, {
        'id': 'BP',
        label: 'Budget Primitif'
      }, {
        'id': 'BS',
        label: 'Budget Supplémentaire'
      }, {
        'id': 'DM',
        label: 'Décision Modificative'
      }];
    },
    getAnnees: function getAnnees() {
      var annees = [];

      // 10 ans après l'année courante
      for (var a = 2014; a < this.getAnneeParDefaut() + 10; a++) {
        annees.push({
          'id': a,
          label: '' + a
        });
      }
      return annees;
    },
    /**
     *  * @param etatDette un objet avec la structure :
     * etatDette = {
            annee: ,
            type: ,
            budgetId: ,
            dateDeVote:
        };
     */
    getDownloadUrl: function getDownloadUrl(maquette, etat, etatDette) {
      var url = '/rest/etat-dette/' + maquette + '/' + etat + '/' + etatDette.type + '/xls?annee=' + etatDette.annee;
      if (etatDette.budgetId != null) {
        url += '&budgetId=' + etatDette.budgetId;
      }
      if (etatDette.type === 'BS' || etatDette.type === 'DM' && etatDette.dateDeVote != null) {
        url += '&dateDeVote=' + $dateFormat.server(etatDette.dateDeVote);
      }
      return url;
    },
    /**
     *  * @param etatDette un objet avec la structure :
     * etatDette = {
            annee: ,
            type: ,
            budgetId: ,
            dateDeVote:
        };
     */
    getDgDownloadUrl: function getDgDownloadUrl(maquette, etat, etatDette) {
      var url = '/rest/dette-garantie/reporting/etat-dette/' + maquette + '/' + etat + '/' + etatDette.type + '/xls?annee=' + etatDette.annee + "&afficherReference=" + etatDette.afficherReference;
      if (etatDette.type === 'BS' || etatDette.type === 'DM' && etatDette.dateDeVote != null) {
        url += '&dateDeVote=' + $dateFormat.server(etatDette.dateDeVote);
      }
      return url;
    },
    /**
     *
     * @param etatDette un objet avec la structure :
     * etatDette = {
            annee: ,
            type: ,
            budgetId: ,
            dateDeVote:
        };
     */
    getTotemDownloadUrl: function getTotemDownloadUrl(etatDette, typeProduit, zip) {
      if (etatDette == null) return "#";
      var url = '/rest/etat-dette/dematerialisation/';
      if (zip) {
        url = '/rest/etat-dette/dematerialisation/zip/';
      }
      if (typeProduit) {
        url += typeProduit + '/';
      }
      url += etatDette.type + '?annee=' + etatDette.annee;
      if (etatDette.budgetId != null && etatDette.budgetId !== "") {
        url += '&budgetId=' + etatDette.budgetId;
      }
      if (etatDette.type === 'BS' || etatDette.type === 'DM' && etatDette.dateDeVote != null) {
        url += '&dateDeVote=' + $dateFormat.server(etatDette.dateDeVote);
      }
      if (etatDette.afficherReference === true) {
        url += '&afficherReference=true';
      }
      url += '&garanties=false';
      url += '&plan=' + etatDette.maquetteId;
      return url;
    },
    openAideTotem: function openAideTotem() {
      return $modal.open({
        template: __webpack_require__(3713),
        options: {
          width: 1200
        }
      });
    },
    registerEtatDetteWatcherForVerification: function registerEtatDetteWatcherForVerification($scope) {
      var verificationEnCours = false;
      var relancerVerification = false;
      function verifieDonnees() {
        // Si une vérification est déjà en cours, on note qu'il faudra la relancer et on arrête là.
        if (verificationEnCours) {
          relancerVerification = true;
          return;
        }
        verificationEnCours = true;
        relancerVerification = false; // On va lancer la vérification, on reset le flag.
        $scope.loadVerification = true;
        $http.get('/rest/etat-dette/verifie-donnees/' + $scope.etatDette.maquetteId, {
          params: $scope.etatDette
        }).then(function (response) {
          $scope.verification = response.data;
        }).finally(function () {
          verificationEnCours = false;
          $scope.loadVerification = false;

          // Si une nouvelle demande a été faite pendant l'appel, on relance.
          if (relancerVerification) {
            verifieDonnees();
          }
        });
      }
      $scope.$watch('etatDette', function () {
        verifieDonnees();
      }, true);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/etatDetteService.js", __webpack_require__(2), __webpack_require__(1)))

/***/ }),
/* 2871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * permet d'afficher les informations liés à l'exercice comptable/fiscal
 */
ngModule.factory("exerciceService", ["$session", function ($session) {
  return {
    /**
     * janvier = 1
     */
    getMoisDebutExercice: function getMoisDebutExercice() {
      return $session.getCompte().moisDebutExercice;
    },
    /**
     * janvier = 1
     */
    getMoisFinExercice: function getMoisFinExercice() {
      return $session.getCompte().moisFinExercice;
    },
    /**
     *  si le moisDebutExercice est sur les 8 premiers mois alors c'est l'exercice de l'année N qui commence a ce mois sinon on considère que c'est l'exercice de l'année N+1 qui commence a ce mois
     * @param date
     * @returns {number|*}
     */
    getAnneeExercice: function getAnneeExercice(date) {
      var anneeExercice;
      var moisDebutExercice = $session.getCompte().moisDebutExercice;
      var mois = moment(date).month() + 1;
      if (moisDebutExercice <= 8) {
        if (mois >= moisDebutExercice) {
          anneeExercice = moment(date).year();
        } else {
          anneeExercice = moment(date).year() - 1;
        }
      } else {
        if (mois >= moisDebutExercice) {
          anneeExercice = moment(date).year() + 1;
        } else {
          anneeExercice = moment(date).year();
        }
      }
      console.log(date, anneeExercice);
      return anneeExercice;
    },
    getDateDebutExercice: function getDateDebutExercice(date) {
      var moisDebutExercice = this.getMoisDebutExercice();
      var dateDebutExercice;
      if (moisDebutExercice == null) {
        moisDebutExercice = 1;
      }
      dateDebutExercice = date;
      dateDebutExercice = moment(dateDebutExercice).startOf('months').toDate();
      if (moisDebutExercice > moment(date).get('month') + 1) {
        dateDebutExercice = moment(dateDebutExercice).subtract(1, 'years').toDate();
      }
      dateDebutExercice = moment(dateDebutExercice).set('months', moisDebutExercice - 1).toDate();
      return dateDebutExercice;
    },
    getDateFinExercice: function getDateFinExercice(date) {
      return moment(this.getDateDebutExercice(date)).add(1, 'years').subtract(1, 'days');
    },
    /**
     * "jj/mm" independamment de l'année (toujour 28 pour février)
     */
    getJourEtMoisFinExercice: function getJourEtMoisFinExercice() {
      return $session.getCompte().jourEtMoisFinExercice;
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/exerciceService.js", __webpack_require__(2)))

/***/ }),
/* 2872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("fixingService", ["$q", "$http", "indexationService", "customIndexationService", function ($q, $http, indexationService, customIndexationService) {
  var getMarketHistory = function getMarketHistory(reference, options) {
    return $http.post("/rest/market/history/indexation", {
      reference: reference,
      options: _.extend(options || {}, {
        nbDonneeMax: 200
      })
    }).then(function (response) {
      return response.data.fixings;
    });
  };
  var _getSpreadHistory = function getSpreadHistory(ref1, ref2, options) {
    return $http.post("/rest/market/history/spread", {
      reference1: ref1,
      reference2: ref2,
      options: _.extend(options || {}, {
        nbDonneeMax: 200
      })
    }).then(function (response) {
      return response.data;
    });
  };
  var getMultipleMarketHistories = function getMultipleMarketHistories(references, options) {
    return $http.post("/rest/market/history/multiple-indexations", {
      references: references,
      options: _.extend(options || {}, {
        nbDonneeMax: 200
      })
    }).then(function (response) {
      return response.data;
    });
  };
  var indexToReference = function indexToReference(indexId) {
    return {
      type: "INDEX",
      indexId: indexId
    };
  };
  var _isValidReference = function isValidReference(reference) {
    if (reference == null) {
      return false;
    }
    switch (reference.type) {
      case "INDEX":
        {
          return reference.indexId != null;
        }
      case "CUSTOM_INDEXATION":
        {
          return reference.indexationId != null;
        }
      default:
        {
          return false;
        }
    }
  };

  /*
   * Pour les parametres "reference", voir la classe ReferenceValorisable
   * La référence est consistitué d'un type, et d'attributes d'identification.
   *
   * Ex : - { type : 'INDEX', indexId : 'myId' }
   *      - { type : 'CUSTOM_INDEXATION', indexationId : 'myId' }
   *
   * Les parametres possibles des options sont les suivants :
   *      - dateDebut
   *      - dateFin
   *      - nbDonneeMax
   * */
  return {
    isValidReference: function isValidReference(reference) {
      return _isValidReference(reference);
    },
    /**
     * Returns the label for given reference
     *
     * @param reference
     * @returns Promise<String>
     */
    getReferenceLabel: function getReferenceLabel(reference) {
      switch (reference.type) {
        case "INDEX":
          {
            return $q.when(indexationService.getIndice(reference.indexId)).then(function (indice) {
              return indice ? indice.label : "";
            });
          }
        case "CUSTOM_INDEXATION":
          {
            return $q.when(customIndexationService.getIndexation(reference.indexationId)).then(function (indexation) {
              return indexation ? indexation.name : "";
            });
          }
        default:
          {
            return $q.resolve("");
          }
      }
    },
    /**
     * Returns the market history for given valorisable reference.
     *
     * @param reference
     * @param options
     */
    getHistory: function getHistory(reference, options) {
      return getMarketHistory(reference, options);
    },
    /**
     * Returns the history for a spread between given valorisable references.
     *
     * @param ref1 reference of the first valorisable
     * @param ref2 reference of the second valorisable
     * @param options
     */
    getSpreadHistory: function getSpreadHistory(ref1, ref2, options) {
      return _getSpreadHistory(ref1, ref2, options);
    },
    /**
     * Returns the history for given index.
     * This is an alias to the getHistory method for indexes-only valorisables.
     *
     * @param index The id of the index to get history for.
     * @param options
     */
    getIndexHistory: function getIndexHistory(index, options) {
      return getMarketHistory(indexToReference(index), options);
    },
    getMultipleHistory: function getMultipleHistory(references, options) {
      return getMultipleMarketHistories(references, options);
    },
    getMonthlyFixings: function getMonthlyFixings(reference, month, year) {
      return $http.post("/rest/market/fixings/for-month", {
        reference: reference,
        month: month,
        year: year
      }).then(function (response) {
        return response.data;
      });
    },
    getMonthlySpreadFixings: function getMonthlySpreadFixings(reference1, reference2, month, year) {
      return $http.post("/rest/market/fixings/for-month", {
        reference1: reference1,
        reference2: reference2,
        month: month,
        year: year
      }).then(function (response) {
        return response.data;
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/fixingService.js", __webpack_require__(1)))

/***/ }),
/* 2873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("groupeService", ["$http", "$session", function ($http, $session) {
  return {
    HORS_GROUPE: 'HORS_GROUPE',
    TOUS: 'TOUS',
    /**
     * liste des groupes existants pour le compte visualisé
     * @returns {*}
     */
    getGroupes: function getGroupes() {
      return $http.get('/rest/groupes').then(function (response) {
        return response.data;
      });
    },
    /**
     *
     * @param groupeId
     * @returns {*} un SimpleValidationDTO
     */
    deleteGroupe: function deleteGroupe(groupeId) {
      return $http.delete('/rest/groupes/delete/' + groupeId).then(function (response) {
        return response.data;
      });
    },
    /**
     *
     * @returns {*} Les groupes accessibles a l'utilisateurs (tous les groupes si aucun groupe sur le user)
     */
    getUserGroupes: function getUserGroupes() {
      var groupIds = $session.getUser().groupeIds;
      if (groupIds.length === 0) {
        return $http.get('/rest/groupes').then(function (response) {
          return response.data;
        });
      } else return $http.get('/rest/groupes').then(function (response) {
        return _.filter(response.data, function (groupe) {
          return _.includes(groupIds, groupe.id);
        });
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/groupeService.js", __webpack_require__(1)))

/***/ }),
/* 2874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Service gérant la liste des indexes.
 * Lié à la resource 'IndexesResource'.
 */
ngModule.factory("indexationService", ["$http", "$translate", function ($http, $translate) {
  var allIndexes = [];
  return {
    /**
     * Load all indices once at startup for synchronous call to main usages methods.
     * Require that $translate already loaded bundles.
     */
    $load: function $load() {
      return $http.get('/rest/indexes/all').then(function (response) {
        allIndexes = _.map(response.data, function (index) {
          return _.extend(index, {
            label: $translate('index.' + index.id),
            groupLabel: $translate('index.groups.' + index.groupe)
          });
        });
        return allIndexes;
      });
    },
    /**
     * Retourne la liste complete des indices disponibles, de manière synchrone. {id, groupe, type, label}
     */
    getAll: function getAll() {
      return allIndexes; // .slice(0) to clone ?
    },
    /**
     * Retourne l'indice pour l'identifiant donné. {id, groupe, type, label}
     */
    getIndice: function getIndice(indexId) {
      return _.find(allIndexes, {
        id: indexId
      });
    },
    /**
     * les indices du client sous forme de Promise
     * @return une liste de {id, groupe, type, label}
     */
    getIndicesClient: function getIndicesClient() {
      return $http.get('/rest/indexes/indexClient').then(function (response) {
        return _.map(response.data, function (val) {
          return {
            id: val.id,
            groupe: $translate('index.groups.' + val.groupe),
            type: val.type,
            label: $translate('index.' + val.id)
          };
        });
      });
    },
    /**
     * les indices des enveloppes par catégorie du client sous forme de Promise - map <category, list<indexId>>
     */
    getIndicesClientEnveloppeByCategory: function getIndicesClientEnveloppeByCategory() {
      return $http.get('/rest/indexes/indexClientEnveloppeByCategory').then(function (response) {
        return response.data;
      });
    },
    /**
     * les indices des enveloppes par catégorie du client sous forme de Promise - List<IndexDto> avec en group la categorie
     */
    getIndicesClientEnveloppeByCategoryAsList: function getIndicesClientEnveloppeByCategoryAsList() {
      return $http.get('/rest/indexes/indexClientEnveloppeByCategoryAsList').then(function (response) {
        _.each(response.data, function (d) {
          d.groupe = $translate('indexClientEnveloppeCategory.' + d.groupe);
        });
        return response.data;
      });
    },
    /**
     * synchrone
     * @returns {{id: string, label: string}}
     */
    getTauxFixe: function getTauxFixe() {
      // TODO PGA : probablement mauvaise pratique, vérifier les usages.
      return {
        id: 'TAUX_FIXE',
        label: 'Taux fixe'
      };
    },
    /**
     * synchrone
     */
    getIndexesIdComDeNonUt: function getIndexesIdComDeNonUt() {
      return ["ESTER", "EONIA", "EUR1W", "EUR1M", "EUR3M", "EUR6M", "EUR12M"];
    },
    /**
     */
    getIndexesBilletTresorerie: function getIndexesBilletTresorerie() {
      return $http.get('/rest/indexes/billet-tresorerie').then(function (response) {
        return _.map(response.data, function (val) {
          return {
            id: val.id,
            //        groupe: $translate('index.groups.' + val.groupe),
            type: val.type,
            label: $translate('index.' + val.id)
          };
        });
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/indexationService.js", __webpack_require__(1)))

/***/ }),
/* 2875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("indicateurService", ["$http", "chartUtils", "tlColors", function ($http, chartUtils, tlColors) {
  return {
    getAll: function getAll() {
      return $http.get('/rest/indicateurs/list').then(function (response) {
        return response.data;
      });
    },
    /**
     * creation de la serie
     * @param config
     * @param data IndicateurResultDTO
     * @param yAttribute valeur par défaut
     * @param pointCreationFct mapping spécifique des points
     */
    createConfigSeries: function createConfigSeries(config, data, yAttribute, pointCreationFct) {
      if (yAttribute === undefined) {
        yAttribute = "valeur";
      }
      config.series = [{
        name: data.nom + (data.avecSimulations ? " (portefeuille)" : ""),
        data: chartUtils.mapAndFilter(data.valeursPortefeuille, "date", yAttribute, pointCreationFct),
        color: tlColors.NEW_BLUE_1
      }];
      if (data.avecSimulations) {
        config.series.push({
          name: data.nom + " (avec impact des simulations)",
          data: chartUtils.mapAndFilter(data.valeurs, "date", yAttribute, pointCreationFct),
          color: tlColors.FUSCHIA
        });
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/indicateurService.js"))

/***/ }),
/* 2876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.provider("initialisationService", function () {
  var rootScopeInitializedProp = "appInitialized";
  var handlers = [];
  return {
    addInitialisationHandler: function addInitialisationHandler(handler) {
      handlers.push(handler);
    },
    $get: ["$q", "$rootScope", "$injector", function $get($q, $rootScope, $injector) {
      return {
        executeHandlers: function executeHandlers() {
          var invokedHandlers = _.map(handlers, function (handler) {
            return $injector.invoke(handler);
          });
          return $q.all(invokedHandlers).then(function () {
            $rootScope[rootScopeInitializedProp] = true;
          });
        }
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/initialisationService.js", __webpack_require__(1)))

/***/ }),
/* 2877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("lovService", ["$q", "$http", "$translate", function ($q, $http, $translate) {
  var lovs = {};

  /**
   *
   * @param lovName le nom de la lov. Possibilité de passé un paramètre via / (ex: syprospects/DETTE)
   * @param filterFunc
   * @param lovKeyComplement permet de fourni un complement à la clé de traduction ; key = lov.[lovName].[lovKeyComplement].[value]
   * @returns {function(): (*)}
   */
  var getLov = function getLov(lovName, filterFunc, lovKeyComplement) {
    return function () {
      if (_.has(lovs, lovName)) {
        return $q.resolve(lovs[lovName]);
      }
      return $http.get('/rest/lov/' + lovName).then(function (response) {
        var lov = _.map(response.data, function (val) {
          var lovNameSimple = lovName;
          // si le nom passé en paramètre contient '/', on retire le suffixe
          if (lovNameSimple.indexOf("/") !== -1) {
            lovNameSimple = lovNameSimple.substring(0, lovNameSimple.indexOf("/"));
          }
          var lovKey = 'lov.' + lovNameSimple;
          if (lovKeyComplement) {
            lovKey += "." + lovKeyComplement;
          }
          lovKey += '.' + val;
          return {
            id: val,
            label: $translate(lovKey)
          };
        });
        if (filterFunc) {
          lov = filterFunc(lov);
        }
        return lovs[lovName] = lov;
      }).catch(function (e) {
        console.error("impossible de recupérer la lov '" + lovName + "'", e);
        throw e;
      });
    };
  };

  /**
   * @returns liste des mois (Promise)
   *
   */
  var getMois = function getMois() {
    return [{
      id: 1,
      label: $translate("lov.mois.1")
    }, {
      id: 2,
      label: $translate("lov.mois.2")
    }, {
      id: 3,
      label: $translate("lov.mois.3")
    }, {
      id: 4,
      label: $translate("lov.mois.4")
    }, {
      id: 5,
      label: $translate("lov.mois.5")
    }, {
      id: 6,
      label: $translate("lov.mois.6")
    }, {
      id: 7,
      label: $translate("lov.mois.7")
    }, {
      id: 8,
      label: $translate("lov.mois.8")
    }, {
      id: 9,
      label: $translate("lov.mois.9")
    }, {
      id: 10,
      label: $translate("lov.mois.10")
    }, {
      id: 11,
      label: $translate("lov.mois.11")
    }, {
      id: 12,
      label: $translate("lov.mois.12")
    }];
  };
  _.set(lovs, 'mois', getMois());
  return {
    getStructuresGissler: getLov('structuresGissler'),
    getIndicesGissler: getLov('indicesGissler'),
    getTypesAmortissement: getLov('typesAmortissement'),
    getTypesAmortissementCDC: getLov('typesAmortissementCDC'),
    getPeriodicites: getLov('periodicites'),
    getPeriodicitesMasculin: getLov('periodicites', undefined, "masculin"),
    getBasesTaux: getLov('basesTaux', function (basesTaux) {
      return _.reject(basesTaux, function (baseTaux) {
        return _.includes(["BASE_THEORIQUE_30_360"], baseTaux.id);
      });
    }),
    getCalendriers: getLov('calendriers'),
    getTypesDeCotations: getLov('typesDeCotations'),
    getAjustementsDate: getLov('ajustementsDate'),
    getTypesFixing: getLov('typesFixing'),
    getTypesFlux: getLov('typesFlux'),
    getTypesDocuments: getLov('typesDocuments'),
    getTypesDocumentsAidesEtSubventions: getLov('typesDocuments/AidesEtSubventions'),
    getTypesDocumentsProduitsFinanciers: getLov('typesDocuments/ProduitsFinanciers'),
    getTypesDocumentsEcheancesProduitsFinanciers: getLov('typesDocuments/EcheancesProduitsFinanciers'),
    getTypesFrais: getLov('typesFrais'),
    getPeriodicitesOption: getLov('periodicitesOption'),
    getTypesPenaliteOptionRA: getLov("typesPenaliteOptionRA"),
    getTypesPenaliteActuarielle: getLov("typesPenaliteActuarielle"),
    getTauxPenaliteActuarielleIndex: getLov("tauxPenaliteActuarielleIndex"),
    getTypesPenaliteDegressive: getLov("typesPenaliteDegressive"),
    getTypesReglement: getLov("typesReglement"),
    getPlansComptables: getLov("plansComptables"),
    getLocales: getLov("locales"),
    getStatutsContrepartie: getLov('statutsContrepartie', function (statut) {
      return _.sortBy(statut, function (statut) {
        return statut.label;
      });
    }),
    getAffectations: getLov('affectations', function (affectations) {
      return _.sortBy(affectations, function (affectation) {
        return affectation.label;
      });
    }),
    getRoundingModes: getLov("roundingModes"),
    getTypesOptionTaux: getLov("typesOptionTaux"),
    getTypesIndicateurs: getLov("typesIndicateurs"),
    getFormatsIndicateurs: getLov("formatsIndicateurs"),
    getIndicateurOperations: getLov("indicateurOperations"),
    getTypesCompte: getLov("typesCompte"),
    getTimeUnits: getLov("timeUnits"),
    getNaturesBeneficiaires: getLov("naturesBeneficiaires"),
    getCategoriesBeneficiaires: getLov("categoriesBeneficiaires"),
    getLogiciels: getLov("logiciels"),
    getTaskStatuts: getLov("taskStatuts"),
    getTypeTickets: getLov("typeTickets"),
    getSensFlux: getLov("sensFlux"),
    getAjustementPeriodePaiement: getLov("ajustementPeriodePaiement"),
    getAjustementPeriodeFixing: getLov("ajustementPeriodeFixing"),
    getNaturesFlux: getLov("naturesFlux"),
    getApplicationsClients: getLov("applicationsClients"),
    getReglesCalageDate: getLov("reglesCalageDate"),
    getTypeRevisions: getLov("typeRevisions"),
    getTypesIndemniteRA: getLov("typesIndemniteRA"),
    getMois: getLov("mois"),
    getPays: getLov("pays"),
    // crm
    getTypesFacture: getLov("typesFacture"),
    getCrmTypesClient: getLov("crmTypesClient"),
    getCrmBureaux: getLov("crmBureaux"),
    getCrmTypesContrat: getLov("crmTypesContrat"),
    getCrmContratDocumentType: getLov("crmContratDocumentType"),
    // sytale
    getSyProspectStatut: getLov("syProspectStatut"),
    getSyEtapeCommerciale: getLov("syEtapeCommerciale"),
    getSyNatureOffre: getLov("syNatureOffre"),
    getSyTypeOffre: getLov("syTypeOffre"),
    getSyTypeActionActivite: getLov("syTypeActionActivite"),
    getSyFonctionMetier: getLov("syFonctionMetier"),
    getNdfNature: getLov("ndfNature"),
    getNdfStatut: getLov("ndfStatut"),
    getTypeRecommandationProduits: getLov("typeRecommandationProduits"),
    getCompteSuiviStatuts: getLov("compteSuiviStatuts"),
    getSyPrestataires: getLov("syPrestataires"),
    getSyPrestatairesDette: getLov("syPrestataires/DETTE"),
    getSyPrestatairesProspective: getLov("syPrestataires/PROSPECTIVE"),
    getSyPrestatairesGestionFinanciere: getLov("syPrestataires/GESTION_FINANCIERE"),
    getSyProspectTags: getLov("syProspectTags"),
    getActiviteTypes: getLov("activiteTypes"),
    getPricingObligataireMethodes: getLov("pricingObligataireMethodes"),
    getCategoryComptes: getLov("categoryComptes"),
    getPublicationTypes: getLov("publicationTypes"),
    getCadrages: getLov('cadrages'),
    getFormationModalites: getLov('formationModalites'),
    getTypesVersementSubvention: getLov("typesVersementSubvention"),
    getMarketDatasources: getLov("marketDatasources"),
    getTypeFinanceurSubventions: getLov("typeFinanceurSubventions"),
    getValidationStates: getLov("validationStates"),
    getStatutValidationProduits: getLov("statutValidationProduit"),
    /**
     * @returns Attention ce n'est pas une Promise
     */
    getTypeTauxProgression: function getTypeTauxProgression() {
      return [{
        id: false,
        label: "Périodique"
      }, {
        id: true,
        label: "Annuel"
      }];
    },
    /**
     * @returns Attention ce n'est pas une Promise
     */
    getTrueFalse: function getTrueFalse() {
      return [{
        id: true,
        label: 'Oui'
      }, {
        id: false,
        label: 'Non'
      }];
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/lovService.js", __webpack_require__(1)))

/***/ }),
/* 2878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("natureService", ["$q", "$http", "$translate", function ($q, $http, $translate) {
  var sousNaturesParNature = {};

  /**
   *
   * @param nature pour laquelle retourner les sous natures
   * @return {*}
   */
  function _getSousNatures(nature) {
    if (!_.isEmpty(sousNaturesParNature)) {
      return $q.resolve(sousNaturesParNature[nature]);
    }
    return $http.get('/rest/lov/sous-natures').then(function (response) {
      sousNaturesParNature = response.data;
      return sousNaturesParNature[nature];
    }).catch(function (e) {
      console.error("impossible de recupérer les sous-natures", e);
      throw e;
    });
  }
  return {
    /**
     *
     * @param nature
     * @return {*} promise
     */
    getSousNatures: function getSousNatures(nature) {
      return _getSousNatures(nature);
    },
    /**
     *
     * @param nature pour laquelle retourner les sous-natures
     * @return {*} promise
     */
    getSousNaturesLov: function getSousNaturesLov(nature) {
      return _getSousNatures(nature).then(function (sousNatures) {
        return _.map(sousNatures, function (sousNature) {
          return {
            id: sousNature,
            label: $translate('nature.' + sousNature)
          };
        });
      });
    },
    getSelectDefautConfig: function getSelectDefautConfig() {
      return {
        optionTemplate: '<div class="report-template-option">' + '<div class="display-ib">' + '<div style="min-width: 4em; display: inline-block; padding-right: 3px">' + '<pill-nature-produit nature=\'{{option.id}}\'></pill-nature-produit>' + '</div>' + ' <span class="label">{{option.label}}</span>' + '</div>'
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/natureService.js", __webpack_require__(1)))

/***/ }),
/* 2879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Services liés à la page de gestion des éditions rapides

 * Elements du scope partagés avec l'appelant (soit lu, soit modifié) :
 * $scope.classificationsMap
 * $scope.produits
 * $scope.displayProduits
 * $scope.hasDirty
 * $scope.resultat
 * $scope.error
 *
 * Elements du scope positionnés par le service à ses propres fins (pas utilisés par l'appelant) :
 * $scope.paramsAll
 * $scope.appliqueValeurCategorieAll
 * $scope.ouiNon
 * $scope.totalImputation
 */
ngModule.factory("saisieEditionRapideService", ["$q", "$http", "contextService", "$notifications", "$dialogBox", "groupeService", "classificationService", function ($q, $http, contextService, $notifications, $dialogBox, groupeService, classificationService) {
  return {
    refreshData: function refreshData($scope, listUrl, checkLigneCallback) {
      return $http.get(listUrl).then(function (response) {
        $scope.produits = response.data;

        // make model dirty
        _.each($scope.produits, function (model) {
          $scope.$watch(function () {
            return model;
          }, function (newModel, oldModel) {
            if (newModel === oldModel) {
              return;
            }
            model.$dirty = true;
            $scope.hasDirty = true;
            checkLigneCallback(model);
          }, true);
        });
      });
    },
    save: function save($scope, saveUrl, checkLigneCallback) {
      var modified = [];
      var error = false;
      _.each($scope.produits, function (model) {
        if (model.$dirty) {
          modified.push(model);
          if (checkLigneCallback(model)) {
            error = true;
          }
        }
      });
      $scope.error = error;
      if (!error) {
        return $http.post(saveUrl, modified).then(function (response) {
          $scope.resultat = response.data;
          if ($scope.resultat.errorProduitIds.length > 0) {
            $notifications.error("" + $scope.resultat.errorProduitIds.length + " erreur(s) à l'enregistrement");
          } else {
            if ($scope.resultat.savedProduitIds.length === 1) {
              $notifications.info("Mise à jour effectuée pour 1 ligne");
            } else {
              $notifications.info("Mise à jour effectuée pour " + $scope.resultat.savedProduitIds.length + " lignes");
            }
            $scope.hasDirty = false;
          }
          _.each(modified, function (model) {
            model.$dirty = $scope.resultat.savedProduitIds.indexOf(model.id) === -1;
          });
        });
      }
    },
    getErrorColumn: function getErrorColumn() {
      return {
        attribute: 'error',
        title: '',
        sortable: true,
        sortType: "boolean",
        template: "\n                        <span>\n                            <i ng-if=\"model.error==true || (resultat!=null && resultat.errorProduitIds.indexOf(model.id) !== -1)\" title=\"Erreur\" class=\"mr-s fa not-allowed fa-ban\" ></i>\n                            <i ng-if=\"model.error!=true && model.$dirty\" title=\"Modifi\xE9\" class=\"mr-s fa allowed fa-check-square-o\" ></i>\n                        </span>\n                    ",
        cellClass: 'align-c',
        width: '25px'
      };
    },
    addClassificationColumGroups: function addClassificationColumGroups(classifications, columnGroups) {
      var idx = 0;
      for (var i = 0; i < classifications.length; i++) {
        columnGroups.push({
          id: "classification-" + i,
          title: classifications[i].nom,
          columns: ["classification-" + i],
          visible: false
        });
        idx++;
      }
    },
    addClassificationColumns: function addClassificationColumns($scope, classifications, columns, $translate) {
      var idx = 0;
      $scope.ouiNon = [{
        id: true,
        label: $translate('common.Oui')
      }, {
        id: false,
        label: $translate('common.Non')
      }];
      classificationService.getUtilisateursPourTaches(true).then(function (users) {
        $scope.users = users;
      });
      groupeService.getGroupes().then(function (groupes) {
        $scope.groupes = groupes;
      });
      var _loop = function _loop() {
        var classification = classifications[i];
        if (classification.type === 'CLASSIFICATION') {
          // Champs additionnels de type Classification
          if (!classification.multiple) {
            // Classification mono-valeur
            if ($scope.paramsAll === undefined) {
              $scope.paramsAll = {
                classificationAll: {}
              };
              $scope.appliqueValeurCategorieAll = function (classificationId, idx) {
                var classification = $scope.classificationsMap[classificationId];
                var text = $scope.paramsAll.classificationAll[idx] == null ? "Toutes les lignes seront modifiées pour en ôter la valeur de classification choisie, confirmez-vous cette action ?" : "Toutes les lignes seront modifiées avec la valeur de classification choisie, confirmez-vous cette action ?";
                $dialogBox.confirm({
                  title: "Modifier les valeurs de la classification " + classification.nom,
                  text: text
                }).then(function () {
                  var nb = 0;
                  _.each($scope.displayProduits, function (model) {
                    if (model.classificationFields[idx].canEdit && model.classificationFields[idx].imputations[0].classificationValueId !== $scope.paramsAll.classificationAll[idx]) {
                      model.classificationFields[idx].imputations[0].classificationValueId = $scope.paramsAll.classificationAll[idx];
                      nb++;
                    }
                  });
                  $notifications.info(nb + " lignes modifiées");
                });
              };
            }
            // initialise à null pour permettre la suppression par défaut (1ere valeur).
            $scope.paramsAll[idx] = null;
            columns.push({
              id: "classification-" + idx,
              headerTemplate: '<div><span>' + classification.nom + '</span> ' + '<div><tl-select option-label-attribute="nom" tl-stop-event-propagation  ng-model="paramsAll.classificationAll[' + idx + ']" ' + 'options="classificationsMap[\'' + classification.id + '\'].valeurs" ' + 'empty-option-label="--Retirer--"></tl-select>' + '<tl-icon-button tl-stop-event-propagation icon="fa-level-down" ng-click="appliqueValeurCategorieAll(\'' + classification.id + '\', ' + idx + ')"> </tl-icon-button>' + '</div></div>',
              title: classification.nom,
              template: '<span ng-if="model.classificationFields[' + idx + '].canEdit"><tl-select style="width:70%"' + 'ng-model="model.classificationFields[' + idx + '].imputations[0].classificationValueId" ' + ' option-label-attribute="nom" options="classificationsMap[\'' + classification.id + '\'].valeurs" empty-option-label=""></tl-select>' + '</span>',
              cellClass: "align-c",
              attribute: 'classificationFields.' + idx + '.imputations.O.classificationValueId',
              sortType: new function () {
                var index = idx;
                var classificationId = classification.id;
                var valeurs = $scope.classificationsMap[classificationId].valeurs;
                // console.log('valeurs', valeurs);
                var valeurParId = new Map();
                valeurs.forEach(function (valeur) {
                  valeurParId.set(valeur.id, valeur.nom);
                });
                // console.log('valeurParId', valeurParId);
                return function (l1, l2) {
                  var id1 = l1.classificationFields[index].imputations[0].classificationValueId;
                  var id2 = l2.classificationFields[index].imputations[0].classificationValueId;
                  // console.log('id1', id1);
                  var v1 = valeurParId.get(id1) || "";
                  var v2 = valeurParId.get(id2) || "";
                  var res = v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
                  // console.log('v1', v1, "v2", v2, res);
                  return res;
                };
              }(),
              sortable: true
            });
            idx++;
          } else {
            // Classification multi-valeurs
            columns.push({
              id: "classification-" + idx,
              title: classification.nom,
              template: "\n                                    <div ng-if=\"model.classificationFields[".concat(idx, "].canEdit\" class=\"classif-overflow-y-auto\">\n                                        <div ng-repeat=\"imputation in model.classificationFields[").concat(idx, "].imputations\">\n                                            <tl-select style=\"min-width: 80px\" ng-model=\"imputation.classificationValueId\" options=\"classificationsMap['").concat(classification.id, "'].valeurs\" option-label-attribute=\"nom\" empty-option-label=\"\"></tl-select>\n                                            <span ng-if=\"model.classificationFields[").concat(idx, "].repartition==true\">\n                                                <tl-percent-input style=\"width:6em\" ng-model=\"imputation.imputation\"></tl-percent-input>\n                                            </span>\n                                        </div>\n                                        <span ng-if=\"model.classificationFields[").concat(idx, "].repartition==true\" class=\"b\" tl-tooltip=\"Total des imputations\" ng-class=\"{'red': totalImputation(model.classificationFields[").concat(idx, "].imputations)>100.000001}\">{{totalImputation(model.classificationFields[").concat(idx, "].imputations)}} %</span>\n                                        <i class=\"fa fa-plus-circle blue action-icon\" ng-click=\"addClassificationValue(model.classificationFields[").concat(idx, "])\"></i>\n                                    </div>\n                                "),
              cellClass: "align-r",
              attribute: 'classificationFields.' + idx + '.imputations.O.classificationValueId',
              sortable: true
            });
            idx++;
          }
        } else {
          // Champs additionnels de type Champ libre
          columns.push({
            id: "classification-" + idx,
            title: classification.nom,
            template: "\n                                <div ng-if=\"model.classificationFields[".concat(idx, "].canEdit\" class=\"classif-overflow-y-auto\">\n                                    <div ng-repeat=\"imputation in model.classificationFields[").concat(idx, "].imputations\">\n                                        <input class=\"full-width\" ng-if=\"imputation.type==='STRING'\" size=\"15\" ng-model=\"imputation.valueAsString\">\n                                        <input input-type-number number-integer ng-if=\"imputation.type==='LONG'\" ng-model=\"imputation.valueAsLong\" size=\"15\">\n                                        <input input-type-number ng-if=\"imputation.type==='DOUBLE'\" ng-model=\"imputation.valueAsDouble\" size=\"15\">\n                                        <span ng-if=\"imputation.type==='POURCENTAGE'\">\n                                        <tl-percent-input input-type-number ng-model=\"imputation.valueAsPourcentage\" size=\"15\">\n                                            </span>\n                                            <span ng-if=\"imputation.type==='BOOLEAN'\">\n                                          <select ng-model=\"imputation.valueAsBoolean\" ng-options=\"o.id as o.label for o in ouiNon\" tl-null-option=\"\"></select>\n                                        </span>\n                                 <span ng-if=\"imputation.type==='UTILISATEUR'\">\n                                  <tl-select ng-model=\"imputation.valueAsString\"\n                                          options=\"users\" empty-option-label=\"Aucun\"></tl-select>\n                                                                       <i class=\"fa fa-plus-circle blue action-icon\" \n                             ng-if=\"model.classificationFields[").concat(idx, "].multiple\"\n                             ng-click=\"addClassificationValue(model.classificationFields[").concat(idx, "])\"></i>\n\n                                </span>\n                                <span ng-if=\"imputation.type==='GROUPE'\">\n                                  <select ng-model=\"imputation.valueAsString\"\n                                          ng-options=\"g.id as g.nom for g in groupes\" tl-null-option=\"Aucun\"></select>\n                             <i class=\"fa fa-plus-circle blue action-icon\" \n                             ng-if=\"model.classificationFields[").concat(idx, "].multiple\"\n                             ng-click=\"addClassificationValue(model.classificationFields[").concat(idx, "])\"></i>\n\n                            </span>\n\n                                        <input ng-if=\"imputation.type==='DATEMIDNIGHT'\"\n                                               ng-model=\"imputation.valueAsDateMidnight\" input-type-date tl-datepicker>\n                                    </div>\n                                </div>\n                                "),
            cellClass: "align-c",
            attribute: 'classificationFields.' + idx + '.imputations.O.classificationValueId',
            sortable: true
          });
          idx++;
        }
      };
      for (var i = 0; i < classifications.length; i++) {
        _loop();
      }
      // total des imputations
      if (classifications.length > 0) {
        $scope.totalImputation = function (imputations) {
          var total = 0.0;
          _.each(imputations, function (imputation) {
            if (imputation.classificationValueId != null) {
              total += imputation.imputation;
            }
          });
          return total;
        };
      }
    },
    addClassificationValue: function addClassificationValue(classificationField) {
      if (classificationField.type == 'UTILISATEUR' || classificationField.type == 'GROUPE') {
        classificationField.imputations.push({
          classificationValueId: null,
          valueAsString: null,
          champAdditionnel: true,
          type: classificationField.type
        });
      } else {
        // console.log('addClassificationValue for', classificationField);
        classificationField.imputations.push({
          classificationValueId: null,
          imputation: classificationField.multiple ? 100.0 : 0.0
        });
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/saisieEditionRapideService.js", __webpack_require__(1)))

/***/ }),
/* 2880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("taelParameters", ["$http", function ($http) {
  return {
    getParameters: function getParameters() {
      return $http.get('/rest/tael-params').then(function (response) {
        return response.data;
      });
    },
    saveParameters: function saveParameters(paramMap) {
      return $http.post('/rest/tael-params', paramMap);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/taelParameters.js"))

/***/ }),
/* 2881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * if-user-tasks-status="RUNNING" = PENDING,STARTED, IN_PROGRESS
 * vous pouvez aussi indiquer ERROR, COMPLETED
 */
ngModule.directive('ifUserTask', ["userTaskService", "$animate", "directiveUtils", function (userTaskService, $animate, directiveUtils) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      userTaskService.loadTasksIfRequired();
      var taskType = $attrs.ifUserTask;
      var taskStatus = $attrs.ifUserTaskStatus;
      var conditionFn = function conditionFn() {
        var tasks = userTaskService.getCurrentTasks();
        if (taskType) {
          tasks = _.filter(tasks, {
            type: taskType
          });
        }
        if (taskStatus) {
          if (taskStatus === 'RUNNING') {
            tasks = _.filter(tasks, function (t) {
              return t.status === 'PENDING' || t.status === 'STARTED' || t.status === 'IN_PROGRESS';
            });
          } else {
            tasks = _.filter(tasks, function (t) {
              return t.status === taskStatus;
            });
          }
        }
        return tasks.length > 0;
      };
      var conditionalTransclude = directiveUtils.createNgIfTranscludeWatchFn($element, $transclude);
      $scope.$watch(conditionFn, conditionalTransclude);
    }
  };
}]);

/**
 * if-user-tasks-status="RUNNING" = PENDING,STARTED, IN_PROGRESS
 * vous pouvez aussi indiquer ERROR, COMPLETED
 */

ngModule.directive('ifNoUserTask', ["userTaskService", "$animate", "directiveUtils", function (userTaskService, $animate, directiveUtils) {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      userTaskService.loadTasksIfRequired();
      var taskType = $attrs.ifNoUserTask;
      var taskStatus = $attrs.ifUserTaskStatus;
      var conditionFn = function conditionFn() {
        var tasks = userTaskService.getCurrentTasks();
        if (taskType) {
          tasks = _.filter(tasks, {
            type: taskType
          });
        }
        if (taskStatus) {
          if (taskStatus === 'RUNNING') {
            tasks = _.filter(tasks, function (t) {
              return t.status === 'PENDING' || t.status === 'STARTED' || t.status === 'IN_PROGRESS';
            });
          } else {
            tasks = _.filter(tasks, function (t) {
              return t.status === taskStatus;
            });
          }
        }
        return tasks.length === 0;
      };
      var conditionalTransclude = directiveUtils.createNgIfTranscludeWatchFn($element, $transclude);
      $scope.$watch(conditionFn, conditionalTransclude);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/user-task/ifUserTask.js", __webpack_require__(1)))

/***/ }),
/* 2882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.component("userTaskListPopin", {
  template: __webpack_require__(3714),
  controller: ["$scope", "userTaskService", "$dialogBox", function controller($scope, userTaskService, $dialogBox) {
    var ctrl = this;
    ctrl.$onInit = function () {
      userTaskService.loadTasksIfRequired();
      userTaskService.reactivePooling();
      $scope.$watch(userTaskService.getCurrentTasks, function (currentTasks) {
        ctrl.tasks = currentTasks;
      });
    };
    ctrl.deleteAllTasks = function () {
      $dialogBox.confirm({
        title: "Suppression des tâches",
        text: "Voulez vous vraiment supprimer toutes les tâches (les rapports ne seront plus disponibles)"
      }).then(function () {
        userTaskService.deleteAllTasks();
      });
    };
  }]
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/user-task/userTaskListPopin.js"))

/***/ }),
/* 2883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('userTaskListTable', ["userTaskService", "$dialogBox", "$sce", function (userTaskService, $dialogBox, $sce) {
  return {
    restrict: 'E',
    replace: true,
    template: function template($attrs) {
      // TODO: attr to add or not the sizeable-component.
      return "\n                <div>\n                    <tl-loader-overlay ng-if=\"$ctrl.disableActions\"></tl-loader-overlay>\n                    <tl-table table-config=\"$ctrl.tableConfig\"></tl-table>\n                </div>\n            ";
    },
    scope: {
      taskType: '@'
    },
    controllerAs: '$ctrl',
    link: function link($scope, $el, $attrs, $ctrl) {
      $ctrl.initialize();
    },
    controller: ["$scope", function controller($scope) {
      var ctrl = this;
      ctrl.initialize = function () {
        ctrl.disableActions = false;
        userTaskService.loadTasksIfRequired();
        $scope.$watch(userTaskService.getCurrentTasks, function (currentTasks) {
          var taskType = $scope.taskType;
          if (taskType) {
            currentTasks = _.filter(currentTasks, {
              type: taskType
            });
          }
          ctrl.tasks = currentTasks;
        });
        ctrl.tableConfig = createTableConfig();
      };
      ctrl.startDownload = function (taskId) {
        userTaskService.startReportDownload(taskId);
      };
      ctrl.deleteReport = function (reportId) {
        if (ctrl.disableActions) return;
        $dialogBox.confirm({
          title: "Suppression du rapport",
          text: "Voulez vous vraiment supprimer le rapport ? Il se sera plus disponible au téléchargement."
        }).then(function () {
          ctrl.disableActions = true;
          userTaskService.deleteTask(reportId).finally(function () {
            ctrl.disableActions = false;
          });
        });
      };
      ctrl.deleteTask = function (taskId) {
        if (ctrl.disableActions) return;
        ctrl.disableActions = true;
        userTaskService.deleteTask(taskId).finally(function () {
          ctrl.disableActions = false;
        });
      };
      ctrl.killTask = function (taskId) {
        if (ctrl.disableActions) return;
        ctrl.disableActions = true;
        userTaskService.killTask(taskId).finally(function () {
          ctrl.disableActions = false;
        });
      };
      ctrl.showTextGeneration = function (taskId) {
        userTaskService.getTextGeneration(taskId).then(function (result) {
          var res = result.data;
          if (res.html) {
            $dialogBox.alert({
              title: "Résultat",
              html: $sce.trustAsHtml(res.resultat),
              width: 1000
            });
          } else {
            $dialogBox.alert({
              title: "Résultat",
              text: res.resultat,
              width: 1000
            });
          }
        });
      };
      var createTableConfig = function createTableConfig() {
        return {
          id: "userTaskListPopinTable",
          source: "$ctrl.tasks",
          height: 400,
          sortable: true,
          initialSort: ["creationDate", "desc"],
          columns: [{
            attribute: "label",
            title: "Libellé"
          }, {
            title: "Date de création",
            attribute: "creationDate",
            filter: "dateMedium",
            cellClass: 'align-c',
            width: "130px",
            sortType: 'date',
            sortable: true
          }, {
            title: "Dernière actualisation",
            attribute: "lastUpdateDate",
            filter: "dateMedium",
            cellClass: 'align-c',
            width: "130px",
            sortType: 'date',
            sortable: true
          }, {
            attribute: "status",
            title: "Status",
            width: "100px",
            filter: "translateLov:'userTaskStatus'",
            sortable: true
          }, {
            attribute: "progression",
            title: "Progression",
            filter: "percentage",
            cellClass: 'align-c',
            sortable: true
          }, {
            attribute: "message",
            title: "Message"
          }, {
            title: "Actions",
            template: "\n                           <div ng-if=\"model.result != null && model.result.type === 'FILE_GENERATION' \">\n                               <tl-icon-button icon=\"fa-download\" title=\"T\xE9l\xE9charger\" ng-click=\"$ctrl.startDownload(model.id)\"></tl-icon-button>\n                               <tl-icon-button icon=\"delete\" ng-show=\"!$ctrl.disableActions\" tl-tooltip=\"Supprimer\" ng-click=\"$ctrl.deleteReport(model.id)\"></tl-icon-button>\n                           </div>\n                           <div ng-if=\"model.result != null && model.result.type === 'TEXT_GENERATION' \">\n                               <tl-icon-button icon=\"fa-eye\" title=\"Afficher\" ng-click=\"$ctrl.showTextGeneration(model.id)\"></tl-icon-button>\n                               <tl-icon-button icon=\"delete\" ng-show=\"!$ctrl.disableActions\" tl-tooltip=\"Supprimer\" ng-click=\"$ctrl.deleteReport(model.id)\"></tl-icon-button>\n                           </div>\n                           <div ng-if=\"model.status == 'ERROR' \">\n                               <tl-icon-button icon=\"delete\" ng-show=\"!$ctrl.disableActions\" tl-tooltip=\"Supprimer\" ng-click=\"$ctrl.deleteTask(model.id)\"></tl-icon-button>\n                           </div>\n                           <div ng-if=\"model.result==null && model.completionDate!=null\">\n                               <tl-icon-button icon=\"delete\" ng-show=\"!$ctrl.disableActions\" tl-tooltip=\"Supprimer\" ng-click=\"$ctrl.deleteTask(model.id)\"></tl-icon-button>\n                           </div>\n                                <div ng-if=\"model.killable && model.status!=='COMPLETED' && model.status!=='ERROR' && model.result==null && model.completionDate==null\">\n                               <tl-icon-button icon=\"fa-bomb\" ng-show=\"!$ctrl.disableActions\" title=\"Arr\xEAter\" ng-click=\"$ctrl.killTask(model.id)\"></tl-icon-button>\n                           </div>\n                      \n                        "
          }]
        };
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/user-task/userTaskListTable.js", __webpack_require__(1)))

/***/ }),
/* 2884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("userTaskService", ["$http", "$q", "$notifications", "$stickyBox", "$fileDownload", function ($http, $q, $notifications, $stickyBox, $fileDownload) {
  var poolingInterval = 2500;
  var watchedTasks = [];
  // map taskId, callback
  var watchedTasksTerminationCallback = {};
  var watchedTasksProgressionCallback = {};
  var pooling = false;
  var currentTasks = [];
  var popinOpened = false;
  var startPooling = function startPooling() {
    if (pooling) {
      return;
    }
    pooling = true;
    fetchTasks();
    _poolingHandler();
  };
  var _poolingHandler = function poolingHandler() {
    _.delay(function () {
      fetchTasks().then(function (tasks) {
        currentTasks = tasks;
        _.each(currentTasks, notifyTaskProgression);
        var terminatedIds = getTerminatedTaskIds(tasks, watchedTasks);
        _.each(terminatedIds, notifyTerminatedTask);
        if (watchedTasks.length > 0) {
          _poolingHandler();
        } else {
          pooling = false;
        }
      });
    }, poolingInterval);
  };
  var getTerminatedTaskIds = function getTerminatedTaskIds(tasks, watchedIds) {
    var tasksIds = _.chain(tasks).filter(function (t) {
      return t.status === "COMPLETED" || t.status === "ERROR";
    }).map("id").value();
    return _.intersection(tasksIds, watchedIds);
  };
  var _getJSonGeneration = function getJSonGeneration(taskId) {
    return $http.get("/rest/user-tasks/result/".concat(taskId, "/json"));
  };
  var notifyTaskProgression = function notifyTaskProgression(task) {
    if (task.status !== 'COMPLETED' && task.status !== 'ERROR') {
      var callback = watchedTasksProgressionCallback[task.id];
      if (callback != null) {
        callback(task);
      }
    }
  };
  var notifyTerminatedTask = function notifyTerminatedTask(taskId) {
    var task = _.find(currentTasks, {
      id: taskId
    });
    console.log('notifyTerminatedTask', task);
    var type = task.result && task.result.type;
    if (task.status === 'ERROR') {
      $notifications.error("Tâche terminée en erreur : " + task.message);
      console.log(task);
    } else {
      switch (type) {
        case "FILE_GENERATION":
          {
            $notifications.info(getFileGenerationCompletedMessage(task), {
              life: 15 * 1000
            });
            break;
          }
        case "DTO_GENERATION":
          {
            console.log('DTO_GENERATION', task);
            _getJSonGeneration(taskId).then(function (result) {
              console.log("dto_result", result);
              console.log('DTO convert=', result.data);
              watchedTasksTerminationCallback[taskId](result.data);
            });
            break;
          }
        default:
          {
            $notifications.info("Tâche terminée. Ouvrez le gestionnaire pour obtenir son résultat.");
          }
      }
    }
    watchedTasks = _.without(watchedTasks, taskId);
  };
  var getFileGenerationCompletedMessage = function getFileGenerationCompletedMessage(task) {
    var message = $("\n            <div>\n                <span>Votre export est termin\xE9</span><br/>\n                <a href=\"#\">Cliquez ici pour t\xE9l\xE9charger le fichier</a>\n            </div>\n        ");
    message.click(function () {
      $fileDownload.start("/rest/user-tasks/downloadUserTaskGeneratedFile/" + task.id);
    });
    return message;
  };
  var fetchTasks = function fetchTasks() {
    return $http.get("/rest/user-tasks/listCurrentUserTaskReports").then(function (response) {
      currentTasks = response.data;
      return currentTasks;
    });
  };
  var getDefaultAddMessage = function getDefaultAddMessage() {
    return "Export déclenché. Vous serez prévenu une fois celui-ci terminé.";
  };
  var _setProgressionCallback = function setProgressionCallback(taskId, progressionCallback) {
    watchedTasksProgressionCallback[taskId] = progressionCallback;
  };
  var _startTaskWatch = function startTaskWatch(message, taskId, terminationCallback, noNotifyWatch) {
    if (!noNotifyWatch) {
      $notifications.info(message || getDefaultAddMessage());
    }
    watchedTasks.push(taskId);
    if (terminationCallback) {
      console.log('Callback enregistré pour la task ' + taskId);
      watchedTasksTerminationCallback[taskId] = terminationCallback;
    }
    if (!pooling) {
      startPooling();
    }
  };
  var _deleteTask = function deleteTask(taskId) {
    return $http.get("/rest/user-tasks/deleteUserTaskReport/" + taskId).then(function (response) {
      if (!pooling) {
        fetchTasks();
      }
    });
  };
  return {
    loadTasksIfRequired: function loadTasksIfRequired() {
      if (!pooling) {
        return fetchTasks();
      }
      return $q.resolve(currentTasks);
    },
    getCurrentTasks: function getCurrentTasks() {
      return currentTasks;
    },
    openTaskList: function openTaskList() {
      if (popinOpened) {
        return;
      }
      popinOpened = true;
      $stickyBox.open({
        title: "Tâches",
        template: "<user-task-list-popin></user-task-list-popin>",
        options: {
          width: 1000
        }
      }).then(function () {
        popinOpened = false;
      });
    },
    startReportDownload: function startReportDownload(taskId) {
      $fileDownload.start("/rest/user-tasks/downloadUserTaskGeneratedFile/" + taskId);
    },
    deleteTask: function deleteTask(taskId) {
      return _deleteTask(taskId);
    },
    deleteAllTasks: function deleteAllTasks(taskId) {
      return $http.get("/rest/user-tasks/deleteAllFinishedUserTasks").then(function (response) {
        if (!pooling) {
          fetchTasks();
        }
      });
    },
    killTask: function killTask(taskId) {
      return $http.put("/rest/user-tasks/killUserTask/" + taskId).then(function (response) {
        if (!pooling) {
          fetchTasks();
        }
      });
    },
    /**
     *
     * @param url resource @post qui fourni la réponse
     * * @param params les paramètre pour la ressource
     * @param callback en parametre le dto/list de dtos
     */
    runTask: function runTask(url, params, callback) {
      $http.post(url, params).then(function (response) {
        var taskId = response.data.taskId;
        _startTaskWatch("Traitement démarré", taskId, function (dto) {
          try {
            callback(dto);
          } catch (e) {
            console.log('expection au traitement du callback de la task ' + taskId, e);
            throw e;
          } finally {
            _deleteTask(taskId);
          }
        }, true);
      });
    },
    /**
     * methode permettant de démarrer la surveillance de la progression / completion de la tache
     * @param taskId
     * @param message
     */
    startTaskWatch: function startTaskWatch(taskId, terminationCallback, message) {
      _startTaskWatch(message, taskId, terminationCallback);
    },
    setProgressionCallback: function setProgressionCallback(taskId, progressionCallback) {
      _setProgressionCallback(taskId, progressionCallback);
    },
    getTextGeneration: function getTextGeneration(taskId) {
      return $http.get("/rest/user-tasks/result/".concat(taskId, "/text"));
    },
    getJSonGeneration: function getJSonGeneration(taskId) {
      return _getJSonGeneration(taskId);
    },
    reactivePooling: function reactivePooling() {
      if (!pooling) {
        fetchTasks().then(function () {
          _.each(currentTasks, function (t) {
            if (t.status === 'PENDING' || t.status === 'STARTED' || t.status === 'IN_PROGRESS') {
              _startTaskWatch(t.id, undefined, undefined, true);
            }
          });
        });
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/user-task/userTaskService.js", __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 2885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("webSocketService", ["$session", "$location", "$notifications", "UUID", function ($session, $location, $notifications, UUID) {
  var URL;

  // Pour identifier chaque conection pour un même authenticationToken (plusieurs tabs par exemple)
  var webSocketUniqueId = UUID();
  var webSocket;
  var reConnectionDelay;
  var _connect = function connect() {
    console.log("Tentative de connexion du webSocket");
    if ($session.getEnvironment()) {
      URL = $session.getEnvironment() === 'local' ? "ws://localhost:8080/ws/server" : "wss://" + $location.host() + "/ws/server";
      URL += "/" + webSocketUniqueId;
    } else {
      // Tentative de connection dans 1s
      setTimeout(_connect, 1000);
    }
    if (URL) {
      webSocket = new WebSocket(URL);
      webSocket.addEventListener("open", function (event) {
        console.log("WebSocket connecté");
        reConnectionDelay = 1000;
      });
      webSocket.addEventListener("close", function (event) {
        console.log("WebSocket déconnecté");
        // Tentative de reconnection tous les 1s, puis 2s, puis 4s, puis 8s, puis toutes les 10s
        setTimeout(_connect, Math.min(1000, reConnectionDelay += reConnectionDelay));
      });
      webSocket.addEventListener("message", function (event) {
        $notifications.info(event.data);
      });
    }
  };
  return {
    connect: _connect
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/services/webSocketService.js"))

/***/ }),
/* 2886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("ticketAnnulerDemandeReouverturePopinController", ["$scope", "$http", "$q", "lovService", "$notifications", function ($scope, $http, $q, lovService, $notifications) {
  var ticket = $scope.ticket;
  $scope.params = {
    ticketId: $scope.ticket.id,
    demande: null
  };
  $scope.annuler = function () {
    if ($scope.loading) return;
    $scope.loading = true;
    $http.post('/rest/echange/ticket-client/annuler-demande-reouverture/' + $scope.params.ticketId, null, {
      params: $scope.params
    }).then(function () {
      $notifications.info("Annulation de la demande prise en compte");
      $scope.$close();
    }).finally(function () {
      $scope.loading = false;
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ticket/annulerDemandeReouverture/ticketAnnulerDemandeReouverturePopinController.js"))

/***/ }),
/* 2887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("choixTicketPopinController", ["$scope", "$http", "$q", "lovService", function ($scope, $http, $q, lovService) {
  $http.get('/rest/echange/ticket-list-recents', {
    params: {
      compteId: $scope.compteId
    }
  }).then(function (result) {
    $scope.tickets = result.data;
  });
  $scope.ticketsTableConfig = {
    source: "tickets",
    allowSelection: true,
    selectionAttribute: "ticket",
    selectionScope: $scope,
    columns: [{
      title: "Titre",
      attribute: "titre",
      sortable: true
    }, {
      title: "Statut",
      attribute: "statutTicket",
      template: "{{'lov.taskStatuts.'+model.statutTicket|translate}}",
      sortable: true
    }, {
      title: "Type",
      attribute: "typeTicket",
      template: "{{'lov.typeTickets.'+model.typeTicket|translate}}",
      sortable: true
    }, {
      title: 'Date début',
      id: 'dateDebutTicket',
      attribute: 'dateDebutTicket',
      filter: "dateShort",
      sortable: true,
      sortType: "date"
    }, {
      title: 'Date fin',
      id: 'dateFinTicket',
      attribute: 'dateFinTicket',
      filter: "dateShort",
      sortable: true,
      sortType: "date"
    }]
  };
  $scope.saveAndClose = function () {
    $scope.$close($scope.ticket);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ticket/choixTicket/choixTicketPopinController.js"))

/***/ }),
/* 2888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("crmTicketService", ["$modal", function ($modal) {
  var editionPopinOptions = {
    controller: "ticketDocumentEditionPopinController",
    template: __webpack_require__(3723),
    options: {
      width: 600
    }
  };
  return {
    /**
     *
     * @param $scope
     * @param ticket un ticket existant ou le "prototype" d'un ticket à créer (compteId doit être renseigné si on est pas sur un compte client)
     * @returns {*}
     */
    openEditionPopin: function openEditionPopin($scope, ticket) {
      return $modal.open({
        scope: $scope,
        controller: "ticketEditionPopinController",
        template: __webpack_require__(3720),
        vars: {
          edit: ticket != null && ticket.id ? true : false,
          ticket: ticket
        },
        options: {
          width: 1000
        }
      });
    },
    /**
     *
     * @param compteId
     * @param dateDebutTicket ex: new Date()
     * @param dateFinTicket ex: new Date()
     * @param titre
     * @param visibleClient
     * @param statutTicket
     * @param idAttribution
     * @param typeTicket
     * @returns {{typeTicket, visibleClient, statutTicket, compteId, titre, dateDebutTicket: Date, idAttribution, dateFinTicket: Date, echanges: *[]}}
     */
    createNewTicket: function createNewTicket(compteId, dateDebutTicket, dateFinTicket, titre, visibleClient, statutTicket, idAttribution, typeTicket) {
      return {
        compteId: compteId,
        dateDebutTicket: dateDebutTicket,
        dateFinTicket: dateFinTicket,
        titre: titre,
        visibleClient: visibleClient,
        statutTicket: statutTicket,
        idAttribution: idAttribution,
        typeTicket: typeTicket,
        echanges: []
      };
    },
    openDocumentEditionPopin: function openDocumentEditionPopin($scope, document) {
      return $modal.open(_.extend(editionPopinOptions, {
        scope: $scope,
        vars: {
          document: document
        }
      }));
    },
    openEditionClientPopin: function openEditionClientPopin($scope, ticket) {
      return $modal.open({
        scope: $scope,
        controller: "ticketEditionClientPopinController",
        template: __webpack_require__(3718),
        vars: {
          edit: ticket ? true : false,
          ticket: ticket
        },
        options: {
          width: 960
        }
      });
    },
    openChoixTicketPopin: function openChoixTicketPopin($scope, compteId) {
      return $modal.open({
        scope: $scope,
        controller: "choixTicketPopinController",
        template: __webpack_require__(3716),
        vars: {
          compteId: compteId
        },
        options: {
          width: 700
        }
      });
    },
    openDeplacerPopin: function openDeplacerPopin($scope, ticket) {
      return $modal.open({
        scope: $scope,
        controller: "ticketDeplacerPopinController",
        template: __webpack_require__(3719),
        vars: {
          ticket: ticket
        },
        options: {
          width: 700
        }
      });
    },
    openDemandeReouverturePopin: function openDemandeReouverturePopin($scope, ticket) {
      return $modal.open({
        scope: $scope,
        controller: "ticketDemandeReouverturePopinController",
        template: __webpack_require__(3717),
        vars: {
          ticket: ticket
        },
        options: {
          width: 900
        }
      });
    },
    openAnnulerDemandeReouverturePopin: function openAnnulerDemandeReouverturePopin($scope, ticket) {
      return $modal.open({
        scope: $scope,
        controller: "ticketAnnulerDemandeReouverturePopinController",
        template: __webpack_require__(3715),
        vars: {
          ticket: ticket
        },
        options: {
          width: 900
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ticket/crmTicketService.js", __webpack_require__(1)))

/***/ }),
/* 2889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("ticketDemandeReouverturePopinController", ["$scope", "$http", "$q", "lovService", "$notifications", function ($scope, $http, $q, lovService, $notifications) {
  var ticket = $scope.ticket;
  $scope.params = {
    ticketId: $scope.ticket.id,
    demande: null
  };
  $scope.reouvrir = function () {
    if ($scope.loading) return;
    $scope.loading = true;
    $http.post('/rest/echange/ticket-client/demande-reouverture/' + $scope.params.ticketId, null, {
      params: $scope.params
    }).then(function () {
      $notifications.info("Demande envoyée");
      $scope.$close();
    }).finally(function () {
      $scope.loading = false;
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ticket/demandeReouverture/ticketDemandeReouverturePopinController.js"))

/***/ }),
/* 2890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("ticketEditionClientPopinController", ["$scope", "$http", "$session", "$dialogBox", "$translate", "UUID", "documentDrop", "documentPreview", function ($scope, $http, $session, $dialogBox, $translate, UUID, documentDrop, documentPreview) {
  var isEdit = $scope.edit;
  var originalTicket = isEdit ? $scope.ticket : {
    documentsIn: [],
    watcherIds: [],
    demandeurUtilisateurId: $session.getUser().id
  };
  $scope.compteVisualiseId = $session.getCompte().id;
  $scope.showDemandeFileDropOverlay = function () {
    return documentDrop.isActive();
  };
  $scope.params = {
    newWatcherId: null
  };
  var ticket = $scope.ticket = angular.copy(originalTicket);
  $http.get('/rest/echange/assignableUsers').then(function (response) {
    $scope.users = _.map(response.data, function (user) {
      return {
        id: user.id,
        label: user.prenom + " " + user.nom
      };
    });
  });
  $http.get('/rest/echange/demandeurs', {
    params: {
      compteId: ticket.compteId
    }
  }).then(function (response) {
    $scope.demandeurs = _.map(response.data, function (user) {
      return {
        id: user.id,
        label: (user.prenom != null ? user.prenom + " " : "") + user.nom,
        actif: user.actif
      };
    });
  });
  $scope.watcherList = function () {
    return _.filter($scope.demandeurs, function (d) {
      return d.actif && d.id !== $scope.ticket.demandeurUtilisateurId && _.indexOf($scope.ticket.watcherIds, d.id) === -1;
    });
  };
  $scope.removeWatcher = function (id) {
    var index = _.indexOf($scope.ticket.watcherIds, id);
    $scope.ticket.watcherIds.splice(index, 1);
  };
  $scope.addWatcher = function () {
    var watcherId = $scope.params.newWatcherId;

    // si non deja présent dans la liste on l'ajoute
    if (watcherId != null && watcherId !== $scope.ticket.demandeurUtilisateurId && _.indexOf($scope.ticket.watchersId, watcherId) === -1) {
      if ($scope.ticket.watcherIds == null) {
        $scope.ticket.watcherIds = [];
      }
      $scope.ticket.watcherIds.push(watcherId);
    }
    $scope.params.newWatcherId = null;
  };
  $scope.renderUser = function (userId) {
    if ($scope.demandeurs) {
      var ts = _.find($scope.demandeurs, {
        id: userId
      });
      if (ts) {
        var label = ts.label;
        if (!ts.actif) {
          label += " (désactivé)";
        }
        return label;
      }
      return "[" + userId + "]";
    }
  };
  $scope.ticketFormConfig = {
    url: function url() {
      return '/rest/echange/ticket-client/' + (isEdit && ticket.id || "");
    },
    data: function data() {
      return ticket;
    },
    fieldPrefix: "ticket.",
    fields: {
      // non implementé par tlValdatedField... on fait en back pour le moment
      demande: {
        mandatory: true
      }
    },
    onSuccess: function onSuccess(savedTicket) {
      _.extend(ticket, savedTicket);
      $scope.$close(ticket);
    },
    onError: function onError(errors) {}
  };
  var refreshDocumentsTable = function refreshDocumentsTable() {
    $scope.documentsTableConfig = {
      source: "ticket.documentsIn",
      id: "ticketDocumentsTable",
      height: 600,
      columns: [{
        attribute: "name",
        title: 'Nom'
      }, {
        attribute: 'name',
        title: "Actions",
        cellClass: "align-c",
        template: '' + '<div>' + '   <tl-icon-button ng-if="canPreviewDoc(model)" icon="fa-eye" title="Visualiser" ng-click="previewDocument(model)"></tl-icon-button>' + '   <tl-icon-button icon="delete" tl-tooltip="Supprimer" ng-click="removeDocument(model)"></tl-icon-button>' + '</div>'
      }]
    };
  };
  refreshDocumentsTable();
  $scope.uploadDocumentOptions = {
    url: '/rest/echange/ticket-client/upload-temp-document',
    dropZone: '.documents-drop-zone'
  };
  $scope.onDocumentUpload = function (result) {
    var document = {
      id: UUID(),
      fileId: result.fileId,
      name: result.fileName,
      type: 'TICKET_IN',
      size: result.fileSize,
      creationDate: new Date(),
      creationUserId: $session.getUser().id
    };
    $scope.ticket.documentsIn.push(document);
    refreshDocumentsTable();
  };
  $scope.canPreviewDoc = function (document) {
    return documentPreview.canPreview(document);
  };
  $scope.previewDocument = function (document) {
    documentPreview.openPopin(document, '/rest/echange/ticket-client/preview-temp-document/' + document.fileId);
  };
  $scope.removeDocument = function (document) {
    $dialogBox.confirm({
      title: $translate("common.confirm_delete"),
      text: $translate("saisie.documents.popins.delete.text", {
        filename: document.name
      })
    }).then(function () {
      $scope.ticket.documentsIn = _.filter($scope.ticket.documentsIn, function (d) {
        return d.id !== document.id;
      });
      refreshDocumentsTable();
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ticket/editionClient/ticketEditionClientPopinController.js", __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("ticketDeplacerPopinController", ["$scope", "$http", "$q", "lovService", "$notifications", function ($scope, $http, $q, lovService, $notifications) {
  var ticket = $scope.ticket;
  $scope.params = {
    ticketId: $scope.ticket.id,
    compteCibleId: $scope.ticket.compteId
  };
  $http.get('/rest/echange/comptes-cible-deplacement-ticket/' + $scope.params.ticketId).then(function (response) {
    $scope.comptesAccessibles = response.data;
  });
  $scope.deplacer = function () {
    $http.post('/rest/echange/ticket-deplacer/' + $scope.params.ticketId + "/" + $scope.params.compteCibleId).then(function () {
      $notifications.info("Changement de compte effectué");
      $scope.$close();
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ticket/editionConsultant/ticketDeplacerPopinController.js"))

/***/ }),
/* 2892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, moment, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("ticketEditionPopinController", ["$scope", "$http", "$q", "lovService", "$notifications", "$session", "$applications", function ($scope, $http, $q, lovService, $notifications, $session, $applications) {
  var isEdit = $scope.edit;
  var originalTicket = isEdit || $scope.ticket != null ? $scope.ticket : {
    documents: [],
    visibleClient: true,
    statutTicket: 'A_TRAITER',
    dateDebutTicket: moment().toDate(),
    watcherIds: [],
    echanges: [{
      'type': 'DEMANDE',
      message: null,
      edit: true
    }],
    subvention: $applications.isAideSubventionApplication()
  };
  var ticket = $scope.ticket = angular.copy(originalTicket);
  $scope.originalTicket = angular.copy(originalTicket);
  $scope.ajouterReponse = function () {
    $scope.ticket.echanges.push({
      type: 'REPONSE',
      message: null,
      date: null,
      edit: true
    });
  };
  $scope.ajouterDemande = function () {
    $scope.ticket.echanges.push({
      type: 'DEMANDE',
      message: null,
      date: null,
      edit: true
    });
  };

  // on ajoute un champ de réponse automatiquement sur réédition qui sera retiré si vide à la sauvegarde
  if (isEdit) {
    $scope.ajouterReponse();
  }
  if ($scope.ticket.watcherIds == null) {
    $scope.ticket.watcherIds = [];
  }
  $scope.params = {};
  $q.when(lovService.getTaskStatuts()).then(function (lov) {
    $scope.taskStatuts = lov;
  });
  $q.when(lovService.getTypeTickets()).then(function (lov) {
    $scope.typeTickets = lov;
  });
  $http.get('/rest/echange/assignableUsers').then(function (response) {
    $scope.users = _.map(response.data, function (user) {
      return {
        id: user.id,
        label: user.prenom + " " + user.nom
      };
    });
  });
  $http.get('/rest/echange/demandeurs', {
    params: {
      compteId: ticket.compteId
    }
  }).then(function (response) {
    $scope.demandeurs = _.map(response.data, function (user) {
      return {
        id: user.id,
        label: (user.prenom != null ? user.prenom + " " : "") + user.nom + (user.actif ? "" : " (désactivé)"),
        actif: user.actif
      };
    });
  });
  $scope.renderUser = function (userId) {
    if ($scope.demandeurs) {
      var ts = _.find($scope.demandeurs, {
        id: userId
      });
      if (ts) {
        var label = ts.label;
        if (!ts.actif) {
          label += " (désactivé)";
        }
        return label;
      }
      return "[" + userId + "]";
    }
  };

  /**
   *
   * uniquementles utilisateurs actifs
   */
  $scope.watcherList = function () {
    return _.filter($scope.demandeurs, function (d) {
      return d.actif && d.id !== $scope.ticket.demandeurUtilisateurId && _.indexOf($scope.ticket.watcherIds, d.id) === -1;
    });
  };
  $scope.removeWatcher = function (id) {
    var index = _.indexOf($scope.ticket.watcherIds, id);
    $scope.ticket.watcherIds.splice(index, 1);
  };
  $scope.addWatcher = function () {
    var watcherId = $scope.params.newWatcherId;

    // si non deja présent dans la liste on l'ajoute
    if (watcherId != null && watcherId !== ticket.demandeurUtilisateurId && _.indexOf($scope.ticket.watchersId, watcherId) === -1) {
      if ($scope.ticket.watcherIds == null) {
        $scope.ticket.watcherIds = [];
      }
      $scope.ticket.watcherIds.push(watcherId);
    }
    $scope.params.newWatcherId = null;
  };
  $scope.genereraNotificationMail = function () {
    // si il y a un demandeur d'indiqué et qu'on est sur une creation ou que le statut a changé.
    return $scope.ticket.demandeurUtilisateurId != null && ticket.visibleClient && (ticket.envoieMailForce || $scope.edit === false || $scope.ticket.statutTicket !== $scope.originalTicket.statutTicket);
  };
  $scope.dateFinAujourdhui = function () {
    $scope.ticket.dateFinTicket = new Date();
  };
  $scope.traiteParMoi = function () {
    $scope.ticket.idAttribution = $session.getUser().id;
  };
  $scope.ticketFormConfig = {
    url: function url() {
      return '/rest/echange/ticket/' + (isEdit && ticket.id || "");
    },
    data: function data() {
      return ticket;
    },
    customValidation: function customValidation() {
      var errors = [];
      return errors;
    },
    fieldPrefix: "ticket.",
    fields: {
      titre: {
        mandatory: true
      },
      typeTicket: {
        mandatory: true
      }
    },
    onSuccess: function onSuccess(savedTicket) {
      _.extend(ticket, savedTicket);
      $notifications.info("Ticket enregistré");
      $scope.$close(ticket);
    },
    onError: function onError(errors) {}
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ticket/editionConsultant/ticketEditionPopinController.js", __webpack_require__(2), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("ticketAddMessagePopinController", ["$scope", "$http", "$session", function ($scope, $http, $session) {
  // par sécurité on copie le ticket
  var ticket = $scope.ticket = angular.copy($scope.ticket);
  $scope.echange = {
    message: null
  };
  $scope.isMessageEmpty = function () {
    var isEmpty = $scope.echange.message == null || $scope.echange.message.trim().length === 0;
    console.log(isEmpty);
    return isEmpty;
  };
  $scope.saveMessage = function () {
    $http.post('/rest/echange/ticket-client/add-message/' + $scope.ticket.id, null, {
      params: $scope.echange
    }).then(function () {
      $scope.$close();
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ticket/fiche/addMessage/ticketAddMessagePopinController.js", __webpack_require__(3)))

/***/ }),
/* 2894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("crmTicketDetails", ["$http", "$modal", "$translate", "$fileDownload", "$dialogBox", "$authz", "lovService", "$q", "$session", "$route", "crmTicketService", "documentPreview", "documentDrop", "$notifications", function ($http, $modal, $translate, $fileDownload, $dialogBox, $authz, lovService, $q, $session, $route, crmTicketService, documentPreview, documentDrop, $notifications) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      ticket: '=',
      refreshFunction: "&",
      edition: "=",
      editionClient: "="
    },
    template: __webpack_require__(3722),
    controller: ["$scope", function controller($scope) {
      $scope.showDemandeFileDropOverlay = function () {
        return ($scope.edition || $scope.editionClient) && documentDrop.isActive();
      };
      $scope.showReponseFileDropOverlay = function () {
        return $scope.edition && documentDrop.isActive();
      };
      $scope.intra = $authz.isIntra();
      $scope.supprimerTicket = function (ticket) {
        $dialogBox.confirm({
          title: $translate("common.confirm_delete"),
          text: 'Confirmez vous la suppression du ticket ' + ticket.titre || '' + " ?"
        }).then(function () {
          $http.delete("/rest/echange/ticket/delete/" + ticket.id).then(function (response) {
            $scope.refreshFunction();
          });
        });
      };
      $scope.editTicket = function (ticket) {
        openEditionPopin(ticket).then(function () {
          $scope.refreshFunction();
        });
      };

      // edition popin

      var openEditionPopin = function openEditionPopin(ticket) {
        return crmTicketService.openEditionPopin($scope, ticket);
      };
      $scope.demandeUploadOptions = {
        url: '/rest/echange/document',
        formData: {
          ticketId: $scope.ticket.id
        },
        dropZone: '.block_demande'
      };
      $scope.reponseUploadOptions = {
        url: '/rest/echange/document',
        formData: {
          ticketId: $scope.ticket.id
        },
        dropZone: '.block_reponse'
      };
      $scope.$watch('ticket.id', function () {
        $scope.demandeUploadOptions.formData.ticketId = $scope.ticket.id;
        $scope.reponseUploadOptions.formData.ticketId = $scope.ticket.id;
        $http.get('/rest/echange/comptes-cible-deplacement-ticket/' + $scope.ticket.id).then(function (response) {
          $scope.comptesAccessibles = response.data;
        });
      });
      $scope.downloadDocument = function (document) {
        $fileDownload.start('/rest/echange/download/' + document.id);
      };
      $scope.downloadAllDemandeDocuments = function () {
        $fileDownload.start('/rest/echange/download-all-documents-reponse/' + $scope.ticket.id);
      };
      $scope.removeDocument = function (document) {
        $dialogBox.confirm({
          title: $translate("common.confirm_delete"),
          text: $translate("saisie.documents.popins.delete.text", {
            filename: document.name
          })
        }).then(function () {
          $http.delete("/rest/echange/remove-document", {
            params: {
              docId: document.id
            }
          }).then(function () {
            $scope.refreshFunction();
          });
        });
      };
      $scope.onResultatUpload = function () {
        $scope.refreshFunction();
      };
      $scope.editDocument = function (document) {
        crmTicketService.openDocumentEditionPopin($scope, document).then(function (updatedDocument) {
          $http.get("/rest/echange/update-document-name", {
            params: {
              docId: document.id,
              name: updatedDocument.name
            }
          }).then(function () {
            $scope.refreshFunction();
          });
        });
      };
      $scope.canPreviewDoc = function (document) {
        return documentPreview.canPreview(document);
      };
      $scope.previewDocument = function (document) {
        documentPreview.openPopin(document);
      };

      // edition client popin

      $scope.editTicketClient = function (ticket) {
        openEditionClientPopin(ticket).then(function () {
          $scope.refreshFunction();
        });
      };
      var openEditionClientPopin = function openEditionClientPopin(ticket) {
        return crmTicketService.openEditionClientPopin($scope, ticket).then(function () {
          return $scope.refreshFunction();
        });
      };
      $scope.deplacerTicket = function (ticket) {
        crmTicketService.openDeplacerPopin($scope, ticket).then(function () {
          return $scope.refreshFunction();
        });
      };
      $scope.copyToClipboard = function () {
        navigator.clipboard.writeText("https://tael.taelys.com/tael/echanges/nos-echanges?viewId=" + $scope.ticket.id + "&toCompte=" + $scope.ticket.compteId).then(function () {
          $notifications.info('Lien copié le presse papier');
        }).catch(function (e) {
          return console.error(e);
        });
      };
      $scope.openMessagePopin = function ($scope, ticket) {
        return $modal.open({
          scope: $scope,
          controller: "ticketAddMessagePopinController",
          template: __webpack_require__(3721),
          vars: {
            ticket: ticket
          },
          options: {
            width: 960
          }
        });
      };
      $scope.addMessage = function () {
        $scope.openMessagePopin($scope, $scope.ticket).then(function () {
          $scope.refreshFunction();
        });
      };
      $scope.demandeReouverture = function (ticket) {
        crmTicketService.openDemandeReouverturePopin($scope, ticket).then(function () {
          return $scope.refreshFunction();
        });
      };
      $scope.annulerDemandeReouverture = function (ticket) {
        crmTicketService.openAnnulerDemandeReouverturePopin($scope, ticket).then(function () {
          return $scope.refreshFunction();
        });
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ticket/fiche/crmTicketDetails.js"))

/***/ }),
/* 2895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("ticketDocumentEditionPopinController", ["$scope", function ($scope) {
  var originalDocument = $scope.document;
  $scope.document = angular.copy(originalDocument);
  $scope.saveAndClose = function () {
    _.extend(originalDocument, $scope.document);
    $scope.$close(originalDocument);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ticket/ticketDocumentEditionPopin.js", __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlIncludeTemplate", ["$animate", function ($animate) {
  return {
    restrict: 'EA',
    transclude: "element",
    terminal: true,
    priority: 400,
    controller: angular.noop,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      var srcExp = $attrs.tlIncludeTemplate || $attrs.src;
      var currentElement = null;
      var currentScope = null;
      var cleanupLastIncludeContent = function cleanupLastIncludeContent() {
        if (currentElement) {
          currentElement.remove();
          currentElement = null;
        }
        if (currentScope) {
          currentScope.$destroy();
          currentScope = null;
        }
      };
      $scope.$watch(srcExp, function (template) {
        if (template) {
          var newScope = $scope.$new();
          ctrl.template = template;
          var clone = $transclude(newScope, function (clone) {
            cleanupLastIncludeContent();
            $animate.enter(clone, null, $element);
          });
          currentScope = newScope;
          currentElement = clone;
        } else {
          cleanupLastIncludeContent();
          ctrl.template = null;
        }
      });
    }
  };
}]);
ngModule.directive("tlIncludeTemplate", ["$compile", function ($compile) {
  return {
    restrict: 'ECA',
    priority: -400,
    require: 'tlIncludeTemplate',
    link: function link(scope, $element, $attr, ctrl) {
      $element.html(ctrl.template);
      $compile($element.contents())(scope);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tl-include-template.js", __webpack_require__(3)))

/***/ }),
/* 2897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlProgressBar", function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      progress: "=position"
    },
    template: '' + '<div class="tl-progress-bar">' + '<div class="caption">{{progress | number}} %</div>' + '<div class="progress" ng-style="{ width: progress + \'%\'}"></div>' + '</div>'
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tl-progress-bar.js"))

/***/ }),
/* 2898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('tlChecklistModel', ["$parse", function ($parse) {
  return {
    restrict: 'A',
    scope: {
      tlChecklistModel: "=",
      tlChecklistValue: "="
    },
    link: function link($scope, $el, $attrs) {
      $scope.checked = false;

      // value added to list
      var value = $parse($attrs.tlChecklistValue)($scope.$parent);
      $el.on('click', function () {
        $scope.$apply(function () {
          $scope.checked = $el.is(":checked");
        });
      });

      // watch UI checked change
      $scope.$watch('checked', function (isChecked, oldValue) {
        $el.prop('checked', isChecked);
        if (isChecked === oldValue) {
          return;
        }
        var list = $scope.tlChecklistModel;
        if (!list) {
          return;
        }
        if (isChecked === true) {
          if (!_.includes(list, value)) {
            list.push(value);
            // setter($scope.$parent, current);
          }
        } else {
          var position = _.indexOf(list, value);
          if (position > -1) {
            list.splice(position, 1);
            // setter($scope.$parent, current);
          }
        }
      });

      // watch original model change
      $scope.$watchCollection("tlChecklistModel", function (newArr) {
        if (!newArr) {
          $scope.checked = false;
        } else {
          $scope.checked = _.includes(newArr, $scope.tlChecklistValue);
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tlChecklistModel.js", __webpack_require__(1)))

/***/ }),
/* 2899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('tlDropdown', ["$document", function ($document) {
  return {
    restrict: 'A',
    link: function link($scope, $el, $attrs, ctrl) {
      var dropdownId = $attrs.tlDropdown;
      if (dropdownId) {
        $scope.$on("dropdown:" + dropdownId + ":close", function () {
          ctrl.close();
        });
      }
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        opened = false;
      ctrl.isOpened = function () {
        return opened;
      };
      ctrl.toggle = function () {
        opened ? ctrl.close() : ctrl.open();
      };
      ctrl.open = function () {
        if (opened) {
          return;
        }
        _.defer(bindClickHandler); // avoid closing on open by triggering it
        $element.addClass("dropdown-open");
        opened = true;
      };
      ctrl.close = function () {
        if (!opened) {
          return;
        }
        unbindClickHandler();
        $element.removeClass("dropdown-open");
        opened = false;
      };
      var onDocumentClick = function onDocumentClick(e) {
        var parents = $(e.target).parents();
        if (parents.index($element) > -1 && parents.filter("[tl-dropdown-keep-open-on-click]").length > 0) {
          return;
        }
        $scope.$apply(function () {
          ctrl.close();
        });
      };
      var bindClickHandler = function bindClickHandler() {
        $document.bind("click", onDocumentClick);
      };
      var unbindClickHandler = function unbindClickHandler() {
        $document.unbind("click", onDocumentClick);
      };
      $scope.$on("$destroy", function () {
        unbindClickHandler();
      });
    }]
  };
}]);
ngModule.directive('tlDropdownToggle', function () {
  return {
    restrict: 'A',
    require: "^tlDropdown",
    link: function link($scope, $el, $attrs, dropdownCtrl) {
      $el.click(function () {
        $scope.$apply(function () {
          dropdownCtrl.toggle();
        });
      });
    }
  };
});
ngModule.directive('tlDropdownMenu', ["$animate", function ($animate) {
  return {
    restrict: 'A',
    transclude: "element",
    priority: 1000,
    require: "^tlDropdown",
    link: function link($scope, $el, $attrs, dropdownCtrl, transcludeFn) {
      var childScope, previousElements;
      $scope.$watch(function () {
        return dropdownCtrl.isOpened();
      }, function (opened, wasOpened) {
        if (opened === wasOpened) {
          return;
        }
        if (opened) {
          childScope = $scope.$new();
          transcludeFn(childScope, function (clone) {
            $animate.enter(clone, $el.parent(), $el);
            $animate.addClass(clone, "opened");
            previousElements = clone;
          });
        } else {
          if (childScope) {
            childScope.$destroy();
            childScope = null;
          }
          if (previousElements) {
            $animate.removeClass(previousElements, "opened").then(function () {
              previousElements.remove();
              previousElements = null;
            });
          }
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tlDropdown.js", __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 2900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('tlEnterPress', function () {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs) {
      $el.bind("keypress", function (event) {
        if (event.which === 13) {
          $scope.$apply(function () {
            $scope.$eval($attrs.tlEnterPress);
          });
          event.preventDefault();
        }
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tlEnterPress.js"))

/***/ }),
/* 2901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('tlEscapePress', function () {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs) {
      $el.bind("keydown", function (event) {
        if (event.which === 27) {
          $scope.$apply(function () {
            $scope.$eval($attrs.tlEscapePress);
          });
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tlEscapePress.js"))

/***/ }),
/* 2902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('tlFocusInit', ["$window", function ($window) {
  var timer;
  return function (scope, elm, attr) {
    if (timer) {
      $window.clearTimeout(timer);
    }
    timer = $window.setTimeout(function () {
      elm.focus();
    }, 0);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tlFocusInit.js"))

/***/ }),
/* 2903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlHorizontalMouseScroll", function () {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs) {
      $el.mousewheel(function (e, delta) {
        this.scrollLeft -= delta * 50;
        e.preventDefault();
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tlHorizontalMouseScroll.js"))

/***/ }),
/* 2904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Loader overlay : will block access to element using a loading overlay
 */
ngModule.directive('tlLoaderOverlay', function () {
  return {
    restrict: "E",
    template: "<div class='tl-loader-overlay'>" + "   <tl-circular-loader></tl-circular-loader>" + "</div>"
  };
});

/**
 * Modal overlay : will block access to element using an overlay
 *
 * Control of the state of the overlay is done by setting the tl-model-overlay attrivute
 */
ngModule.directive('tlModalOverlay', function () {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs, ctrl) {
      ctrl.loader = $("<div class='tl-blocker-overlay'></div>");
      $el.append(ctrl.loader);
      ctrl.hideLoader();
      $scope.$watch($attrs.tlModalOverlay, function (enabled) {
        enabled ? ctrl.showLoader() : ctrl.hideLoader();
      });
    },
    controller: ["$scope", function controller($scope) {
      var ctrl = this;
      ctrl.showLoader = function () {
        ctrl.loader.show();
      };
      ctrl.hideLoader = function () {
        ctrl.loader.hide();
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tlLoaderOverlay.js", __webpack_require__(4)))

/***/ }),
/* 2905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('tlLovOptions', ["$compile", function ($compile) {
  return {
    terminal: true,
    // mandatory, and so is the highest possible priority
    priority: 1000,
    restrict: "A",
    compile: function compile($el, $attrs) {
      // what are we doing here you ask ?
      // we are cheating : intercepting the compilation via 'terminal', adding the ngOptions directive,
      // remove this one, and compilating again in the link method we returns.
      // this was really easier before ng, 1.4, when ngOptions was an attribute for select and not a directive
      var lovName = $attrs.tlLovOptions,
        onetimeWatch = true,
        // TODO : parametrize ?
        watchPrefix = onetimeWatch ? "::" : "";
      $attrs.$set("ngOptions", "o.id as o.label for o in " + watchPrefix + lovName);
      $attrs.$set("tlLovOptions", null);
      return {
        pre: function postLink($scope, $el, $attrs) {
          $compile($el)($scope);
        }
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tlLovOptions.js"))

/***/ }),
/* 2906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Allow to add a null option to a select.
 * use as tl-null-option="my label text"
 */
ngModule.directive('tlNullOption', function () {
  return {
    priority: 600,
    // must execute before tlLovOptions
    require: "select",
    restrict: "A",
    link: {
      pre: function pre($scope, $el, $attrs, selectCtrl) {
        // adding option to select ctrl.
        var optionLabel = $attrs.tlNullOption;
        $("<option>").val("").text(optionLabel).appendTo($el);
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tlNullOption.js", __webpack_require__(4)))

/***/ }),
/* 2907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('tlOnExcelPaste', function () {
  var plainToTable = function plainToTable(text) {
    var table = [];
    var rowSeparator = '\n';
    if (text.indexOf('\r\n') > -1) {
      rowSeparator = '\r\n';
    }
    _.each(text.trim(rowSeparator).split(rowSeparator), function (rowData, lineIdx) {
      table[lineIdx] = [];
      _.each(rowData.split('\t'), function (cellData, rowIdx) {
        table[lineIdx][rowIdx] = cellData;
      });
    });
    return table;
  };
  return {
    restrict: "A",
    priority: 100,
    link: function link($scope, $el, $attrs) {
      var pasteHandler = $scope.$eval($attrs.tlOnExcelPaste);
      $el.bind('paste', function (e) {
        if (e.originalEvent == null || e.originalEvent.clipboardData == null || e.originalEvent.clipboardData.items.length === 0) {
          return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        var items = e.originalEvent.clipboardData.items;
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          if (item.kind === 'string' && item.type === 'text/plain') {
            item.getAsString(function (s) {
              var parsed = plainToTable(s);
              $scope.$apply(function () {
                pasteHandler(parsed);
              });
            });
          }
        }
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tlOnExcelPaste.js", __webpack_require__(1)))

/***/ }),
/* 2908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('tlOnFieldChange', ["fieldUtils", function (fieldUtils) {
  return {
    restrict: "A",
    scope: {
      'tlOnFieldChange': "&"
    },
    link: function link($scope, $el, $attrs) {
      fieldUtils.delegateFieldChange($el, function () {
        $scope.tlOnFieldChange();
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tlOnFieldChange.js"))

/***/ }),
/* 2909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlStopEventPropagation", function () {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs) {
      $el.click(function (e) {
        e.stopPropagation();
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tlStopEventPropagation.js"))

/***/ }),
/* 2910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Permet l'affichage d'un tooltip sur un element dom.
 *
 * un attibut tl-tooltip-position="bottom" permet de postionner le tooltip en dessous de l'élément
 */
ngModule.directive("tlTooltip", function () {
  return {
    restrict: 'A',
    link: function link($scope, $element, $attrs, ctrl) {
      if ($attrs.tlTooltipPosition) {
        $scope.tlTooltipPosition = $attrs.tlTooltipPosition;
      }
      if ($.trim($attrs.tlTooltip)) {
        ctrl.setTooltipContent($attrs.tlTooltip);
      }
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        tooltipScope = null,
        tooltipContent = null;
      ctrl.setTooltipContentLink = function (transcludeFn) {
        ctrl.destroyTooltip();
        tooltipScope = $scope.$new();
        transcludeFn(tooltipScope, function (content) {
          tooltipContent = content;
        });
        ctrl.attachTooltip();
      };
      ctrl.setTooltipContent = function (content) {
        ctrl.destroyTooltip();
        tooltipContent = content;
        ctrl.attachTooltip();
      };
      ctrl.attachTooltip = function () {
        var tooltipPosition = {
          // container : $element.closest(".main-container"),
          my: 'middle left',
          at: 'middle right',
          adjust: {
            x: 3
          },
          viewport: $(window)
        };
        if ($scope.tlTooltipPosition === 'bottom') {
          tooltipPosition = {
            my: 'top center',
            at: 'bottom center',
            adjust: {
              y: 8
            },
            viewport: $(window)
          };
        }
        _.defer(function () {
          // the defer is required to attach to re-compiled directives (tl-input-wrapper)
          var tooltipLength;
          if (_.isString(tooltipContent)) {
            tooltipLength = _.trim(tooltipContent).length;
          } else {
            tooltipLength = _.trim(tooltipContent.text()).length;
          }

          // n'affiche le tooltip que si il y a un contenu
          if (tooltipLength > 0) {
            $element.qtip({
              content: {
                text: tooltipContent
              },
              show: {
                delay: 200,
                solo: true
              },
              position: tooltipPosition,
              style: {
                classes: 'qtip-tl-tooltip' // TODO : allow easy parametrization
              }
            });
          }
        });
      };
      ctrl.destroyTooltip = function () {
        $element.qtip("destroy", true);
        if (tooltipScope != null) {
          tooltipScope.$destroy();
          tooltipScope = null;
        }
      };
      $scope.$on("$destroy", function () {
        ctrl.destroyTooltip();
      });
    }]
  };
});

/**
 * Permet d'utiliser du html dans le contenu des tooltips
 */
ngModule.directive("tlTooltipContent", function () {
  return {
    restrict: 'E',
    require: "^?tlTooltip",
    transclude: true,
    scope: true,
    link: function link($scope, $el, $attrs, tooltipCtrl, transcludeFn) {
      if (tooltipCtrl) {
        tooltipCtrl.setTooltipContentLink(transcludeFn);
      } else if ($attrs.tlTooltipId) {
        _.defer(function () {
          // defer to let angular finish the template linking. we never know.
          var target = $el.siblings().filter("[tl-tooltip-id='" + $attrs.tlTooltipId + "']");
          if (target.length) {
            target.controller("tlTooltip").setTooltipContentLink(transcludeFn);
          }
        });
      } else {
        throw "tlTooltipContent requires either a parent tlTooltip or to specify the tl-tooltip-id attribute";
      }
      $el.hide();
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tlTooltip.js", __webpack_require__(4), __webpack_require__(1)))

/***/ }),
/* 2911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlWaitFor", ["$animate", function ($animate) {
  return {
    transclude: 'element',
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function link($scope, $element, $attr, ctrl, $transclude) {
      var unwatchWaitFor = $scope.$watch($attr.tlWaitFor, function tlWaitForWatchAction(value) {
        if (value) {
          var childScope = $scope.$new();
          $transclude(childScope, function (clone) {
            $animate.enter(clone, $element.parent(), $element);
          });
          unwatchWaitFor();
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tl/tlWaitFor.js"))

/***/ }),
/* 2912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlFieldError", ["$translate", function ($translate) {
  return {
    restrict: "A",
    scope: true,
    link: function link($scope, $el, $attrs) {
      var fieldName = $attrs.tlFieldError;

      //console.log('Link '+fieldName);

      // le watch tel quel défini plus bas ne permet que des noms simples... sans profondeur
      if (fieldName.indexOf('.') !== -1) {
        console.error("tlFieldError a un un fieldname invalide : " + fieldName + ". Il ne doit pas y a voir de . dans le nom du champs, ceci n'est pas actuellement supporté");
      }

      // .tl-validated-input permet de définir directement un champs "custom" qui recevra la tooltip d'erreur et la couleur d'erreur
      var inputSelector = "input, select, textarea";
      $scope.$watch("errors." + fieldName, function (error) {
        if (error) {
          if ($el.find(inputSelector).val() !== undefined
          ///&& $el.find(inputSelector).first().val() !== "?" //  - ne marche pas quand un select input trouvés. pourquoi ?
          ) {
            //          console.log('Show error for '+fieldName);
            showError(error);
            return;
          } else {
            console.log('Cannot find field for tl-field-error : ' + fieldName, $el.find(inputSelector), $el.find(inputSelector).first().val());
          }
        }
        hideError();
      });

      // validation

      var showError = function showError(error) {
        $el.addClass("has-error");
        var element = $el.find(inputSelector);
        element.qtip({
          content: {
            text: error.message || $translate(error.messageKey)
          },
          position: {
            container: $el.closest("form"),
            my: 'top center',
            at: 'bottom center',
            adjust: {
              x: 3
            }
          },
          style: {
            classes: 'qtip-error'
          }
        });
      };
      var hideError = function hideError() {
        $el.removeClass("has-error");
        $el.find(inputSelector).qtip("destroy", true);
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/tlFieldError.js"))

/***/ }),
/* 2913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Utility service to use à global $uiLoader.Loader instance on the document.body element.
 */
ngModule.factory("$uiBlock", ["$rootScope", "$compile", function ($rootScope, $compile) {
  var loaderLinkFn = $compile("<div class='tl-loader-overlay'>" + "   <tl-circular-loader></tl-circular-loader>" + "</div>");
  var globalLoader = null;
  var getLoaderElement = function getLoaderElement($scope) {
    var loader = null;
    loaderLinkFn($scope, function (clone) {
      loader = clone;
    });
    return loader;
  };
  var Loader = function Loader($el, $scope) {
    var loader = this,
      loaderEl = getLoaderElement($scope);
    loader.show = function () {
      loaderEl.appendTo($el).show();
    };
    loader.hide = function () {
      loaderEl.fadeOut(200);
    };
    loader.destroy = function () {
      loaderEl.remove();
    };
    $scope.$on("$destroy", function () {
      loader.destroy();
    });
  };
  return {
    block: function block() {
      if (globalLoader == null) {
        globalLoader = new Loader(document.body, $rootScope, {});
      }
      globalLoader.show();
    },
    unblock: function unblock() {
      if (globalLoader != null) {
        globalLoader.hide();
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/$uiBlock.js"))

/***/ }),
/* 2914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

// thanks http://www.yearofmoo.com/2013/08/remastered-animation-in-angularjs-1-2.html

ngModule.animation('.anim-slide', function () {
  return {
    enter: function enter(element, done) {
      done();
    },
    leave: function leave(element, done) {
      done();
    },
    move: function move(element, done) {
      done();
    },
    addClass: function addClass(element, className, done) {
      if (className !== "ng-hide") {
        return done();
      }
      element.slideUp({}, done);
      return function (canceled) {
        if (canceled) {
          // element.stop(); // PGA : need to check how to delete height attribute on cancel. else it's buggy at startup.
        }
      };
    },
    removeClass: function removeClass(element, className, done) {
      if (className !== "ng-hide") {
        return done();
      }
      element.removeClass('ng-hide');
      element.slideDown({}, done);
      return function (canceled) {
        if (canceled) {
          // element.stop(); // PGA : see addClass.
        }
      };
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/animations/anim-slide.js"))

/***/ }),
/* 2915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("autosizingService", function () {
  var delegatesMap = {};
  var containerTypes = {};
  var defaultContainerType = null;
  return {
    registerDelegate: function registerDelegate(directiveName, provider) {
      delegatesMap[directiveName] = provider;
    },
    getDelegate: function getDelegate($element) {
      for (var directiveName in delegatesMap) {
        var directiveController = $element.controller(directiveName);
        if ($element.controller(directiveName)) {
          var delegateClass = delegatesMap[directiveName];
          return new delegateClass(directiveController, $element);
        }
      }
      return null;
    },
    ////

    registerContainerType: function registerContainerType(attribute, containerStrategy, isDefault) {
      containerTypes[attribute] = containerStrategy;
      if (isDefault) {
        defaultContainerType = attribute;
      }
    },
    getContainerStrategy: function getContainerStrategy(containerCtrl, $element, $attrs) {
      var containerStrategy = null;
      for (var containerType in containerTypes) {
        if (_.has($attrs, containerType)) {
          containerStrategy = containerTypes[containerType];
        }
      }
      if (containerStrategy == null) {
        containerStrategy = containerTypes[defaultContainerType];
      }
      return new containerStrategy(containerCtrl, $element);
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/autosizing/asRegistry.js", __webpack_require__(1)))

/***/ }),
/* 2916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Root container directive, who will drive the autosizing process of it's autosizable container.
 */
ngModule.directive("autosizingContainer", ["$debounce", function ($debounce) {
  return {
    restrict: "A",
    priority: 10,
    require: ["autosizingContainer", "sizableContainer", "?^hideableContainer"],
    link: function link($scope, $el, $attrs, controllers) {
      var autosizingCtrl = controllers[0],
        autosizableCtrl = controllers[1],
        hideableCtrl = controllers[2];
      autosizingCtrl.initialize(autosizableCtrl, hideableCtrl);
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        disabled = false,
        autosizableCtrl = null,
        hideableCtrl = null,
        needResize = false;
      ctrl.initialize = function (_autosizableCtrl, _hideableCtrl) {
        autosizableCtrl = _autosizableCtrl;
        hideableCtrl = _hideableCtrl;
        if (hideableCtrl) {
          needResize = isVisible();
          hideableCtrl.on("visibility:change", function (visible) {
            if (isVisible() && needResize) {
              resizeHandler();
            }
          });
        }
        $scope.$on("$resize", resizeHandler);
        $scope.$on("$autosize", resizeHandler);
        resizeHandler();
      };
      ctrl.enableAutosizing = function () {
        if (!disabled) {
          return;
        }
        disabled = false;
        resizeHandler();
      };
      ctrl.disableAutosizing = function () {
        if (disabled) {
          return;
        }
        disabled = true;
        // TODO : this will not be enought if components are already resized.
        // Need to propagate the information
        // but this work for now...
      };
      ctrl.getContainerHeight = function () {
        var reference = $element.closest(".autosize-reference"); // TODO : improve
        if (!reference.length) {
          reference = $element;
        }
        return reference.height();
      };
      ctrl.applyHeight = function () {
        var height = ctrl.getContainerHeight();
        // console.log("autosizing : applyHeight ->", height);
        autosizableCtrl.setHeight(height);
      };
      var isVisible = function isVisible() {
        return hideableCtrl ? hideableCtrl.isVisible() : true;
      };
      var resizeHandler = $debounce(function () {
        if (disabled) {
          // this is only to allow non-fixed height reports to resize when panel opens.
          // see Layout.js
          // TODO : should be handled in the layout controller.
          $scope.$broadcast("$redraw");
          return;
        }
        if (isVisible()) {
          ctrl.applyHeight();
          needResize = false;
        } else {
          needResize = true;
        }
      }, 100, false);
    }]
  };
}]);

/**
 * Use on a sizableContainer to set requested height of the container, either in % or px.
 *
 * Examples
 * - <div sizable-container as-fixed-height="50%">...</div>
 * - <div sizable-container as-fixed-height="200px">...</div>
 */
ngModule.directive("asFixedHeight", function () {
  return {
    restrict: "A",
    require: "sizableContainer",
    priority: 5,
    link: {
      pre: function pre($scope, $el, $attrs, containerCtrl) {
        containerCtrl.setRequestedHeightHandler(function () {
          return $attrs.asFixedHeight;
        });
      }
    }
  };
});

/**
 * Container able to resize it's content when asked.
 */
ngModule.directive("sizableContainer", ["$debounce", "autosizingService", "directiveUtils", function ($debounce, autosizingService, directiveUtils) {
  return {
    restrict: "A",
    priority: 1,
    link: function link($scope, $el, $attrs, ctrl) {
      var parentContainer = directiveUtils.getParentController($el, "sizableContainer");
      if (parentContainer) {
        parentContainer.addComponent(ctrl);
        $scope.$on("$destroy", function () {
          parentContainer.removeComponent(ctrl);
        });
      }
      ctrl.initialize();
    },
    controller: ["$scope", "$element", "$attrs", function controller($scope, $element, $attrs) {
      var ctrl = this,
        requiredHeightHandler = null,
        strategy = null,
        allocatedHeight = null,
        components = [];
      ctrl.initialize = function () {
        strategy = autosizingService.getContainerStrategy(ctrl, $element, $attrs);
      };
      ctrl.getComponents = function () {
        return components;
      };
      ctrl.addComponent = function (componentCtrl) {
        components.push(componentCtrl);
        debouncedApplyHeight();
      };
      ctrl.removeComponent = function (componentCtrl) {
        var componentIdx = _.indexOf(components, componentCtrl);
        if (componentIdx > -1) {
          components.splice(componentIdx, 1);
          debouncedApplyHeight();
        }
      };
      ctrl.setRequestedHeightHandler = function (handler) {
        requiredHeightHandler = handler;
      };
      ctrl.getRequestedHeight = function () {
        if (requiredHeightHandler) {
          return requiredHeightHandler();
        } else {
          return null;
        }
      };
      ctrl.setHeight = function (_allocatedHeight) {
        allocatedHeight = _allocatedHeight;
        applyHeight();
      };
      ctrl.refreshWidth = function () {
        _.each(components, function (component) {
          return component.refreshWidth();
        });
      };
      var applyHeight = function applyHeight() {
        if (!allocatedHeight) {
          return;
        }
        var offset = $element.outerHeight(true) - $element.innerHeight();
        var usableHeight = allocatedHeight - offset;
        strategy.setHeight(usableHeight);
      };
      var debouncedApplyHeight = $debounce(applyHeight, 100);
    }]
  };
}]);
ngModule.directive("sizeableComponent", ["autosizingService", function (autosizingService) {
  return {
    restrict: "A",
    priority: -1,
    require: ["sizeableComponent", "^sizableContainer"],
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        containerController = controllers[1];
      ctrl.initialize();
      containerController.addComponent(ctrl);
      $scope.$on("$destroy", function () {
        containerController.removeComponent(ctrl);
      });
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        delegate = null;
      ctrl.initialize = function () {
        delegate = autosizingService.getDelegate($element);
        if (delegate == null) {
          console.error('Pas de delegate trouvé pour gérer le resizing de ', $element);
        }
        $scope.$on("$resize-x", function () {
          // PGA : dirty approach, event triggered from Layout region only...
          delegate.refreshWidth();
        });
      };
      ctrl.refreshWidth = function () {
        return delegate.refreshWidth();
      };
      ctrl.setHeight = function (height) {
        if (delegate == null) {
          console.error('no delegate for ' + $element);
        }
        delegate.setHeight(height);
      };
      ctrl.getRequestedHeight = function () {
        return null;
      };
    }]
  };
}]);
ngModule.directive("fixedComponent", function () {
  return {
    restrict: "A",
    require: ["fixedComponent", "^sizableContainer"],
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        containerController = controllers[1];
      containerController.addComponent(ctrl);
      $scope.$on("$destroy", function () {
        containerController.removeComponent(ctrl);
      });
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this;
      ctrl.refreshWidth = angular.noop;
      ctrl.getRequestedHeight = function () {
        return $element.outerHeight(true) + "px";
      };
    }]
  };
});
ngModule.directive("tlSizeableBlock", function () {
  return {
    restrict: "A",
    controller: function controller() {
      // required to be declared as a component type.
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/autosizing/autosizing.js", __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 2917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.run(["autosizingService", "$q", function (autosizingService, $q) {
  autosizingService.registerDelegate("tlSizeableBlock", function (blockCtrl, $el) {
    var delegate = this;
    var useMaxHeight = $el.attr("use-max-height") != null;
    delegate.refreshWidth = angular.noop;
    delegate.setHeight = function (height) {
      if (useMaxHeight) {
        $el.css({
          "max-height": "".concat(height - 2, "px")
        });
      } else {
        $el.outerHeight(height);
      }
    };
  });
  autosizingService.registerDelegate("tlChart", function (chartCtrl, $el) {
    var delegate = this;
    var highchartCtrl = chartCtrl.getHighchartCtrl();
    highchartCtrl.setAutoResize(false);
    delegate.refreshWidth = function () {
      highchartCtrl.redraw();
    };
    delegate.setHeight = function (height) {
      // console.log("highchart -> setHeight");
      highchartCtrl.setHeight(height - 2); // TODO : 2 = border ...
    };
  });
  autosizingService.registerDelegate("highchart", function (chartCtrl, $el) {
    var delegate = this;
    chartCtrl.setAutoResize(false);
    delegate.refreshWidth = function () {
      chartCtrl.redraw();
    };
    delegate.setHeight = function (height) {
      // console.log("highchart -> setHeight");
      chartCtrl.setHeight(height - 2); // TODO : 2 = border ...
    };
  });
  autosizingService.registerDelegate("tlTable", function (tableCtrl, $el) {
    var delegate = this;
    var infiniTableCtrl = tableCtrl.getInfiniTableCtrl();
    infiniTableCtrl.setAutoResize(false);
    delegate.refreshWidth = function () {
      infiniTableCtrl.refreshColumnsSizing();
    };
    delegate.setHeight = function (height) {
      // border +1...
      infiniTableCtrl.setHeight(height - 4, true);
    };
  });
  autosizingService.registerDelegate("infiniTable", function (tableCtrl, $el) {
    var delegate = this;
    tableCtrl.setAutoResize(false);
    delegate.refreshWidth = function () {
      tableCtrl.refreshColumnsSizing();
    };
    delegate.setHeight = function (height) {
      // console.log("infiniTable -> setHeight");
      tableCtrl.setHeight(height - 2, true);
    };
  });
  autosizingService.registerDelegate("leaflet", function (leafletCtrl, $el) {
    var delegate = this;
    delegate.refreshWidth = function () {
      $q.when(leafletCtrl.getMap()).then(function (map) {
        map.invalidateSize();
      });
    };
    delegate.setHeight = function (height) {
      // console.log("leaflet -> setHeight");
      $el.height(height - 2);
      $q.when(leafletCtrl.getMap()).then(function (map) {
        map.invalidateSize();
      });
    };
  });
  autosizingService.registerDelegate("tlDocumentPreview", function (documentCtrl, $el) {
    var delegate = this;
    delegate.refreshWidth = angular.noop;
    delegate.setHeight = function (height) {
      $el.height(height - 2);
      documentCtrl.setHeight(height - 2);
    };
  });
  autosizingService.registerDelegate("pdfViewer", function (viewerCtrl, $el) {
    var delegate = this;
    delegate.refreshWidth = angular.noop;
    delegate.setHeight = function (height) {
      viewerCtrl.setHeight(height);
    };
  });
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/autosizing/componentTypes.js", __webpack_require__(3)))

/***/ }),
/* 2918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.run(["autosizingService", function (autosizingService) {
  autosizingService.registerContainerType("asVerticalContainer", function (containerCtrl, $el) {
    var strategy = this;
    strategy.setHeight = function (totalHeight) {
      var components = containerCtrl.getComponents(),
        usedHeight = 0,
        usedPercentage = 0,
        nbAuto = 0;

      // types : auto - fixed - percent
      var processed = [];
      _.each(components, function (component) {
        var componentHeight = component.getRequestedHeight();
        if (/^[0-9]*([.][0-9]*)?px$/.test(componentHeight)) {
          var heightInPixel = parseInt(componentHeight.substring(0, componentHeight.length - 2));
          usedHeight += heightInPixel;
          processed.push({
            component: component,
            type: "fixed",
            height: heightInPixel
          });
        } else if (/^[0-9]*([.][0-9]*)?%$/.test(componentHeight)) {
          var heightInPercent = parseInt(componentHeight.substring(0, componentHeight.length - 1));
          usedPercentage += heightInPercent;
          processed.push({
            component: component,
            type: "percent",
            height: heightInPercent
          });
        } else {
          nbAuto++;
          processed.push({
            component: component,
            type: "auto"
          });
        }
      });
      var availableHeight = totalHeight - usedHeight;
      var availablePercentage = 100 - usedPercentage;
      var heightPerAuto = availablePercentage / nbAuto;

      // console.log("total height : ", totalHeight, processed, heightPerAuto, heightPerAuto * availableHeight / 100);

      _.each(processed, function (proc) {
        if (proc.type === "percent") {
          proc.component.setHeight(parseInt(proc.height * availableHeight / 100));
        } else if (proc.type === "auto") {
          proc.component.setHeight(parseInt(heightPerAuto * availableHeight / 100));
        }
      });
    };
  }, true);
  autosizingService.registerContainerType("asLineContainer", function (containerCtrl, $el) {
    var strategy = this;
    strategy.setHeight = function (totalHeight) {
      var components = containerCtrl.getComponents();
      _.each(components, function (component) {
        component.refreshWidth();
        var componentHeight = component.getRequestedHeight();
        if (/^[0-9]*px$/.test(componentHeight)) {
          //var heightInPixel = parseInt(componentHeight.substring(0, componentHeight.length - 2));
          // nothing ?
        } else if (/^[0-9]*%$/.test(componentHeight)) {
          var heightInPercent = parseInt(componentHeight.substring(0, componentHeight.length - 1));
          component.setHeight(heightInPercent * totalHeight / 100);
        } else {
          component.setHeight(totalHeight);
        }
      });
    };
  });
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/autosizing/containerTypes.js", __webpack_require__(1)))

/***/ }),
/* 2919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Directive handling the visibility state of a container.
 * Used as information bus for children directive which need to know when they are displayed
 * ( to allow correct size computing or lazy initialisation for example )
 *
 * @see autosize.js
 */
ngModule.directive("hideableContainer", ["EventBus", "directiveUtils", function (EventBus, directiveUtils) {
  return {
    restrict: "AC",
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        parentCtrl = directiveUtils.getParentController($element, "hideableContainer"),
        containerVisible = true,
        parentVisible = true;
      EventBus.makeBus(ctrl);
      var isVisible = function isVisible() {
        return parentVisible && containerVisible;
      };
      var onVisibilityChange = function onVisibilityChange() {
        ctrl.trigger("visibility:change", isVisible());
      };
      if (parentCtrl) {
        parentVisible = parentCtrl.isVisible();
        var onParentVisibilityChange = function onParentVisibilityChange(newParentVisibility) {
          var wasVisible = isVisible();
          parentVisible = newParentVisibility;
          var nowVisible = isVisible();
          if (wasVisible !== nowVisible) {
            onVisibilityChange();
          }
        };
        parentCtrl.on("visibility:change", onParentVisibilityChange);
      }
      ctrl.setVisible = function (visible) {
        var wasVisible = isVisible();
        containerVisible = visible;
        var nowVisible = isVisible();
        if (wasVisible !== nowVisible) {
          onVisibilityChange();
        }
      };
      ctrl.isVisible = function () {
        return isVisible();
      };
      ctrl.onVisibilityChange = function (handler) {
        ctrl.on("visibility:change", handler);
        return function () {
          ctrl.off("visibility:change", handler);
        };
      };
      $scope.$on("$destroy", function () {
        ctrl.off();
        if (parentCtrl) {
          parentCtrl.off("visibility:change", onParentVisibilityChange);
        }
      });
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/autosizing/hideableContainer.js"))

/***/ }),
/* 2920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlButtonDeck", function () {
  return {
    restrict: "E",
    transclude: true,
    replace: true,
    template: "<div class=\"tl-button-deck\" ng-transclude></div>"
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/buttons/tl-button-deck.js"))

/***/ }),
/* 2921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
/**
 * exemple d'utilisation :<br/>
 *         <tl-button-with-subactions label="Actions" main-action-click="myMainAction()">
 *             <tl-subaction-item ng-click="openModal()"><span>Ouvre modale</span></tl-subaction-item>
 *             <tl-subaction-item><a href="/tael/inventaire">Inventaire</a></tl-subaction-item>
 *             <tl-subaction-item><a href="/tael/reporting"><span>Rapports</span></a></tl-subaction-item>
 *         </tl-button-with-subactions>
 */
ngModule.directive("tlButtonWithSubactions", function () {
  return {
    restrict: "E",
    transclude: true,
    scope: {
      label: '@',
      mainActionClick: '&?',
      // Add a new scope property for the main action click
      iconClass: '@?'
    },
    template: "\n            <div class=\"tl-button-with-subactions\">\n                <button ng-if=\"nbItems()!=1\" class=\"btn btn-primary\">\n                    <div class=\"button-container\">\n                    <span class=\"main-action\" ng-click=\"mainActionClick()\"><i ng-if=\"iconClass\" ng-class=\"iconClass\" class=\"main-action-icon\"></i> {{label}}</span>\n                    <i class=\"caret\" ng-click=\"toggleMenu()\" ng-show=\"nbItems()>1\" ng-class=\"{'fa fa-caret-down': !menuVisible, 'fa fa-caret-up': menuVisible}\"></i>\n                    </div>\n                    </button>\n                <ul class=\"subactions\" ng-show=\"menuVisible && nbItems()>1\" ng-transclude></ul>\n            </div>\n        ",
    controller: ["$scope", "$element", "$document", function controller($scope, $element, $document) {
      $scope.menuVisible = false;
      var handler = function handler(event) {
        if ($scope.menuVisible && !$element[0].contains(event.target)) {
          $scope.$apply(function () {
            $scope.menuVisible = false;
          });
        }
      };
      $document.on('click', handler);
      $scope.$on('$destroy', function () {
        $document.off('click', handler);
      });
      $scope.toggleMenu = function () {
        $scope.menuVisible = !$scope.menuVisible;
      };
      $scope.nbItems = function () {
        var entrees = $element.find('ul li');
        return entrees.length;
      };
    }]
  };
});
ngModule.directive("tlSubactionItem", function () {
  return {
    restrict: 'E',
    require: '^tlButtonWithSubactions',
    transclude: true,
    template: '<li ng-transclude></li>'
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/buttons/tl-button-with-subactions.js"))

/***/ }),
/* 2922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * par defaut un bouton type='submit' (car rien de précisé sur la directive). Mettre type='button' pour un bouton qui ne doit pas submiter.<br/>
 * ex :
 *<pre>{@code
 *  <tl-button type="button" class="btn-primary " ng-click="add()">Ajouter</tl-button>
 *}</pre>
 */
ngModule.directive("tlButton", ["uiUtils", "$mdButtonInkRipple", function (uiUtils, $mdButtonInkRipple) {
  return {
    restrict: "E",
    transclude: true,
    replace: true,
    template: function template(element, attrs) {
      return uiUtils.isAnchor(attrs) ? '<a class="btn" ng-transclude></a>' : '<button class="btn" ng-transclude></button>';
    },
    link: function link($scope, $el, $attrs) {
      $mdButtonInkRipple.attach($scope, $el);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/buttons/tl-button.js"))

/***/ }),
/* 2923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Allow a button to behave like a checkbox, having a true / false state.
 * ngModel is required
 */
ngModule.directive('tlCheckboxButton', function () {
  var ACTIVE_CLASS = "active";
  return {
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModelCtrl) {
      //model -> UI
      ngModelCtrl.$render = function () {
        element.toggleClass(ACTIVE_CLASS, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
      };

      //ui->model
      element.bind("click", function () {
        scope.$apply(function () {
          ngModelCtrl.$setViewValue(element.hasClass(ACTIVE_CLASS) ? getFalseValue() : getTrueValue());
          ngModelCtrl.$render();
        });
      });
      function getTrueValue() {
        return getCheckboxValue(attrs.btnCheckboxTrue, true);
      }
      function getFalseValue() {
        return getCheckboxValue(attrs.btnCheckboxFalse, false);
      }
      function getCheckboxValue(attributeValue, defaultValue) {
        var val = scope.$eval(attributeValue);
        return angular.isDefined(val) ? val : defaultValue;
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/buttons/tl-checkbox-button.js", __webpack_require__(3)))

/***/ }),
/* 2924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);


function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('tlChoiceButton', ["$compile", "$translate", "$interpolate", function ($compile, $translate, $interpolate) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '' + '<span class="tl-choice-button" ng-transclude>' + '</span>',
    scope: {
      model: '='
    },
    controller: ["$scope", function controller($scope) {
      $scope.clicked = function (event) {
        var nullOption = angular.element(event.currentTarget).attr('null-option');
        if (nullOption) {
          $scope.model = null;
        } else {
          $scope.model = angular.element(event.currentTarget).attr('value');
        }
      };
    }],
    link: function postLink(scope, element) {
      var items = element[0].children;
      var _iterator = _createForOfIteratorHelper(items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var value = angular.element(item).attr('value');
          var nullOption = angular.element(item).attr('null-option');
          console.log('nullOption', nullOption);
          if (nullOption === 'true') {
            value = 'null';
          } else {
            value = '\'' + value + '\'';
          }
          angular.element(item).attr('ng-click', 'clicked($event)');
          angular.element(item).attr('ng-class', '{\'tl-active-choice-item\':model===' + value + '}');
          item.classList.add("tl-choice-item");
          $compile(item)(scope);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/buttons/tl-choice-button.js", __webpack_require__(3)))

/***/ }),
/* 2925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlIconButton", ["uiUtils", "iconUtils", function (uiUtils, iconUtils) {
  return {
    restrict: "E",
    scope: false,
    replace: true,
    transclude: true,
    template: function template(element, attrs) {
      return uiUtils.isAnchor(attrs) ? '<a class="tl-icon-button"><i class="icon" ng-transclude></i></a>' : '<button type="button" class="tl-button_icon-button tl-icon-button">{{disabled}}<i class="icon" ng-transclude></i></button>';
    },
    link: function link($scope, $el, $attrs) {
      var iconEl = $el.find(".icon");
      var buttonEl = $el.find(".tl-button_icon-button");
      var previousIcon = null;
      var authzIfIntra = $attrs['authz-if-intra'];

      // couleur intra
      $attrs.$observe("authzIfIntra", function () {
        iconEl.addClass('green');
      });
      $attrs.$observe("icon", function () {
        var iconName = $attrs["icon"] || "";
        if (previousIcon != null) {
          iconEl.removeClass(previousIcon);
        }
        var fullIcon = iconUtils.getFullName(iconName);
        previousIcon = fullIcon;
        iconEl.addClass(fullIcon);
      });

      /**
       * // todo - un attribut disable...
        // attach before ng-click to stop propagation when disabled
       $el.on('click', function(event) {
          if (this.hasAttribute('disabled')) {
              event.stopImmediatePropagation();
          }
      });
        $attrs.$observe("tlDisabled", (value) => {
            $scope.disabled = value;
          if ($scope.disabled) {
              buttonEl.addClass('disabled');
          } else {
              buttonEl.removeClass('disabled');
          }
       });
       */
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/buttons/tl-icon-button.js"))

/***/ }),
/* 2926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
/**
 * exemple d'utilisation :<br/>
 *         <tl-menu-button label="Actions">
 *             <tl-menu-item ng-click="openModal()"><span>Ouvre modale</span></tl-menu-item>
 *             <tl-menu-item><a href="/tael/inventaire">Inventaire</a></tl-menu-item>
 *             <tl-menu-item><a href="/tael/reporting"><span>Rapports</span></a></tl-menu-item>
 *         </tl-menu-button>
 */
ngModule.directive("tlMenuButton", function () {
  return {
    restrict: "E",
    transclude: true,
    scope: {
      label: '@'
    },
    template: "\n            <div class=\"tl-menu-button\">\n                <button ng-if=\"nbItems()!=1\" class=\"btn btn-primary\" ng-click=\"toggleMenu()\">\n                    <i class=\"caret\" ng-class=\"{'fa fa-caret-down': !menuVisible, 'fa fa-caret-up': menuVisible}\"></i>{{label}}</button>\n                <ul ng-show=\"menuVisible && nbItems()!==1\" ng-class=\"{'align-right': menuAlignRight}\" ng-transclude></ul>\n                <button ng-if=\"nbItems()==1\" class=\"btn btn-primary single\" ng-transclude></button>\n            </div>\n        ",
    controller: ["$scope", "$element", "$document", "$timeout", "$window", function controller($scope, $element, $document, $timeout, $window) {
      $scope.menuVisible = false;
      $scope.menuAlignRight = false;
      $scope.toggleMenu = function () {
        $scope.menuVisible = !$scope.menuVisible;
        if ($scope.menuVisible) {
          // On utilise $timeout pour s'assurer que le menu est visible et a des dimensions
          // avant de faire les calculs.
          $timeout(function () {
            var ul = $element.find('ul');
            // Le conteneur de référence pour la position est la div interne, pas l'élément de la directive
            var menuContainer = $element.find('div.tl-menu-button');
            if (!ul.length || !menuContainer.length) {
              return;
            }
            var containerRect = menuContainer[0].getBoundingClientRect();
            var ulRect = ul[0].getBoundingClientRect();
            var viewportWidth = $window.innerWidth;

            // Si le menu, aligné à gauche de son conteneur, dépasse de la fenêtre
            if (containerRect.left + ulRect.width > viewportWidth) {
              $scope.menuAlignRight = true;
            } else {
              $scope.menuAlignRight = false;
            }
          }, 0); // En retirant le 'false', $timeout va automatiquement déclencher un $apply()
        }
      };
      $scope.nbItems = function () {
        var entrees = $element.find('ul li');
        return entrees.length;
      };
      var handler = function handler(event) {
        if ($scope.menuVisible && !$element[0].contains(event.target)) {
          $scope.$apply(function () {
            $scope.menuVisible = false;
          });
        }
      };
      $document.on('click', handler);
      $scope.$on('$destroy', function () {
        $document.off('click', handler);
      });
    }]
  };
});
ngModule.directive("tlMenuItem", function () {
  return {
    restrict: 'E',
    require: '^tlMenuButton',
    transclude: true,
    template: '<li ng-transclude></li>'
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/buttons/tl-menu-button.js"))

/***/ }),
/* 2927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("uiUtils", ["$parse", function ($parse) {
  return {
    parseConstantExpr: function parseConstantExpr(context, name, expression, fallback) {
      var parseFn;
      if (angular.isDefined(expression)) {
        parseFn = $parse(expression);
        if (!parseFn.constant) {
          throw 'Expected constant expression for `' + name + '`, but saw ' + expression;
        }
        return parseFn(context);
      }
      return fallback;
    },
    fakeNgModel: function fakeNgModel() {
      return {
        $fake: true,
        $setTouched: angular.noop,
        $setViewValue: function $setViewValue(value) {
          this.$viewValue = value;
          this.$render(value);
          this.$viewChangeListeners.forEach(function (cb) {
            cb();
          });
        },
        $isEmpty: function $isEmpty(value) {
          return ('' + value).length === 0;
        },
        $parsers: [],
        $formatters: [],
        $viewChangeListeners: [],
        $render: angular.noop
      };
    },
    isAnchor: function isAnchor(attr) {
      return angular.isDefined(attr.href) || angular.isDefined(attr.ngHref) || angular.isDefined(attr.ngLink);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/buttons/uiUtils.js", __webpack_require__(3)))

/***/ }),
/* 2928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, angular, $, moment) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory('tlCalendarDefaultConfig', function () {
  return {
    hideWeekends: false
  };
});
ngModule.directive('tlCalendar', ["$compile", "tlCalendarDefaultConfig", function ($compile, tlCalendarDefaultConfig) {
  return {
    restrict: "E",
    replace: true,
    transclude: true,
    scope: true,
    template: '' + '<div class="tl-calendar">' + '   <table>' + '       <thead tl-calendar-header></thead>' + '       <tbody></tbody>' + '   </table>' + '   <div class="tl-calendar-tpl" ng-transclude></div>' + '</div>',
    link: function link($scope, $el, $attrs, ctrl) {
      var configAttr = $attrs.calendarConfig;
      $scope.$watch(configAttr, function (config) {
        if (config == null) {
          return;
        }
        ctrl.initialize(config);
      });
      $scope.$on("$destroy", function () {
        ctrl.dispose();
      });
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        headerCtrl = null,
        config = null,
        cellTranscludeFn = null,
        ui = {
          rows: [],
          body: $element.find("table tbody")
        };
      var setConfig = function setConfig(_config) {
        config = _.extend(angular.copy(tlCalendarDefaultConfig), _config);
      };
      var createRow = function createRow(rowIdx) {
        var row = $("<tr>").addClass(rowIdx % 2 ? "even" : "odd");
        row.appendTo(ui.body);
        return row;
      };
      ctrl.setHeaderCtrl = function (_headerCtrl) {
        headerCtrl = _headerCtrl;
      };
      ctrl.initialize = function (config) {
        setConfig(config);
        headerCtrl.construct();
        var cellTemplate = $("<td tl-calendar-cell>"),
          cellLinkFn = $compile(cellTemplate),
          today = moment(),
          calendarDate = moment(config.date || new Date()).startOf("month"),
          monthOfDate = calendarDate.month(),
          firstDay = calendarDate.clone().startOf("month").startOf("week"),
          lastDay = calendarDate.clone().endOf("month").endOf("week");
        var isWeekendDay = function isWeekendDay(m) {
          return m.day() === 6 || m.day() === 0;
        };
        if (config.hideWeekends && isWeekendDay(calendarDate)) {
          firstDay = calendarDate.clone().add(calendarDate.day() === 6 ? 2 : 1, "day");
        }
        var currentDay = firstDay.clone(),
          rowIdx = 0,
          currentRow = null,
          i = 0;
        var createCellScope = function createCellScope(currentDay) {
          var cellScope = $scope.$new();
          // TODO : inject other vars to scope.
          _.extend(cellScope, {
            $index: i,
            $date: currentDay.toDate(),
            rowIndex: rowIdx,
            isToday: currentDay.isSame(today, "day"),
            isWeekend: isWeekendDay(currentDay),
            previousMonth: currentDay.month() < monthOfDate,
            currentMonth: currentDay.month() === monthOfDate,
            nextMonth: currentDay.month() > monthOfDate,
            year: currentDay.year(),
            month: currentDay.month(),
            day: currentDay.date(),
            dayOfWeek: currentDay.day()
          });
          return cellScope;
        };
        while (currentDay.isBefore(lastDay)) {
          // monday -> we create a new row
          if (currentDay.day() === 1) {
            currentRow = createRow(rowIdx);
            rowIdx++;
          }
          if (config.hideWeekends && isWeekendDay(currentDay)) {
            currentDay.add(1, "day");
            i++;
            continue;
          }
          var cellScope = createCellScope(currentDay);
          cellLinkFn(cellScope, function (cell) {
            cell.appendTo(currentRow);
            cellTranscludeFn(cellScope, function (cellContent) {
              cell.append(cellContent);
            });
          });
          currentDay.add(1, "day");
          i++;
        }
      };
      ctrl.dispose = function () {
        cellTranscludeFn = null;
      };
      ctrl.setCellTranscludeFunction = function (transcludeFn) {
        cellTranscludeFn = transcludeFn;
      };
      ctrl.getConfig = function () {
        return config;
      };
    }]
  };
}]);
ngModule.directive("tlCalendarCellTemplate", function () {
  return {
    restrict: "E",
    transclude: true,
    require: "^tlCalendar",
    link: function link($scope, $el, $attrs, calendarCtrl, transcludeFn) {
      calendarCtrl.setCellTranscludeFunction(transcludeFn);
    }
  };
});
ngModule.directive("tlCalendarCell", function () {
  return {
    restrict: "A",
    scope: true,
    link: function link($scope, $el, $attrs) {
      if ($scope.previousMonth) {
        $el.addClass("previous-month");
      }
      if ($scope.currentMonth) {
        $el.addClass("current-month");
      }
      if ($scope.nextMonth) {
        $el.addClass("next-month");
      }
      if ($scope.isToday) {
        $el.addClass("current-day");
      }
      if ($scope.isWeekend) {
        $el.addClass("weekend-day");
      }
    }
  };
});
ngModule.directive('tlCalendarHeader', ["$translate", function ($translate) {
  return {
    restrict: "A",
    require: ["tlCalendarHeader", "^tlCalendar"],
    replace: false,
    scope: true,
    link: function link($scope, $el, $attrs, controllers) {
      var headerCtrl = controllers[0];
      var calendarCtrl = controllers[1];
      calendarCtrl.setHeaderCtrl(headerCtrl);
      headerCtrl.setCalendarCtrl(calendarCtrl);
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        calendarCtrl = null;
      ctrl.setCalendarCtrl = function (_calendarCtrl) {
        calendarCtrl = _calendarCtrl;
      };
      ctrl.construct = function () {
        var config = calendarCtrl.getConfig();
        $element.empty();
        $element.append('<th>' + $translate('marche.history.indexations.calendar.Lun') + '</th>' + '<th>' + $translate('marche.history.indexations.calendar.Mar') + '</th>' + '<th>' + $translate('marche.history.indexations.calendar.Mer') + '</th>' + '<th>' + $translate('marche.history.indexations.calendar.Jeu') + '</th>' + '<th>' + $translate('marche.history.indexations.calendar.Ven') + '</th>');
        if (!config.hideWeekends) {
          $element.append('<th>' + $translate('marche.history.indexations.calendar.Sam') + '</th>' + '<th>' + $translate('marche.history.indexations.calendar.Dim') + '</th>');
        }
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/calendar/tl-calendar.js", __webpack_require__(1), __webpack_require__(3), __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 2929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Usage :
 *
 *  $dialogBox.confirm({
                title: "Le titre",
                text: "La question ?"
                html : "La question en html ?"
            }).then(function () {
             // si confirmé
            });
 */
ngModule.factory("$dialogBox", ["$q", "$translate", "$modal", function ($q, $translate, $modal) {
  return {
    alert: function alert(options) {
      var vars = _.extend({}, options);
      return $modal.open({
        template: __webpack_require__(3724),
        vars: vars,
        options: {
          escape: false
        }
      });
    },
    confirm: function confirm(options) {
      var vars = _.extend({
        confirmLabel: "common.dialog.confirm",
        cancelLabel: "common.dialog.cancel"
      }, options);
      return $modal.open({
        template: __webpack_require__(3725),
        vars: vars,
        options: {
          escape: true
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/dialogs/$dialogBox.js", __webpack_require__(1)))

/***/ }),
/* 2930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
ngModule.value("$modalDefaultOptions", {
  width: 800,
  fullWidth: false,
  escape: true,
  draggable: true
});
ngModule.directive("modalContainer", function () {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: '<div class="tl-modal-container"></div>'
  };
});
ngModule.directive('modalOverlay', function () {
  return {
    restrict: 'E',
    replace: true,
    template: '<div class="tl-modal-overlay"></div>'
  };
});
ngModule.directive('modalDialog', ["$animate", function ($animate) {
  return {
    restrict: 'E',
    scope: true,
    replace: true,
    transclude: true,
    template: '' + '<div class="tl-modal-dialog-container" ng-style="{ \'z-index\' : $zIndex }">' + '   <div class="tl-modal-dialog">' + '       <div class="tl-modal-content" ng-transclude></div>' + '   </div>' + '</div>',
    link: function link($scope, $el, $attrs) {
      var options = $scope.modalOptions;
      var dialogEl = $el.find(".tl-modal-content");
      if (dialogEl == null) {
        return;
      }
      if (options.fullWidth) {
        dialogEl.addClass("full-width");
      } else {
        dialogEl.width(options.width);
      }
      if (options.dialogClass) {
        dialogEl.addClass(options.dialogClass);
      }
      if (options.draggable) {
        // Switch to absolute positioning on mousedown to ensure Draggable calculates correct starting position
        dialogEl.on("mousedown", ".title", function (event) {
          if (event.which !== 1) return; // Only left click

          if (dialogEl.css("position") !== "absolute") {
            var rect = dialogEl[0].getBoundingClientRect();
            dialogEl.css({
              position: "absolute",
              top: rect.top + "px",
              left: rect.left + "px",
              margin: 0,
              right: "auto",
              bottom: "auto"
            });
          }
        });
        dialogEl.draggable({
          handle: ".title",
          containment: "window",
          start: function start(event, ui) {
            $("body").addClass("tl-modal-dragging");
          },
          stop: function stop() {
            $("body").removeClass("tl-modal-dragging");
          }
        });
        dialogEl.on("dblclick", ".title", function () {
          dialogEl.css({
            position: "",
            top: "",
            left: "",
            margin: "",
            right: "",
            bottom: ""
          });
        });
      }
      $animate.addClass(dialogEl, "tla-ready");
    }
  };
}]);
ngModule.factory('$modal', ["$compile", "$animate", "$rootScope", "$window", "$q", "templateUtils", "$controller", "$modalDefaultOptions", "keyCodes", "deferredUtils", function ($compile, $animate, $rootScope, $window, $q, templateUtils, $controller, $modalDefaultOptions, keyCodes, deferredUtils) {
  var $modal = {},
    container = null,
    overlay = null,
    openedDialogs = [];
  $rootScope.$on("$locationChangeStart", function (event, next, current) {
    // $locationChangeStart ==> $locationChangeSuccess
    if (openedDialogs.length > 0) {
      var dialog = getCurrentDialog();
      dialog.scope.$dismiss();
      event.preventDefault();
    }
  });
  var refreshDialogIndexes = function refreshDialogIndexes() {
    _.each(_.initial(openedDialogs), function (dialog) {
      dialog.scope.$zIndex = 1000;
    });
    _.last(openedDialogs).scope.$zIndex = 1100;
  };

  // container

  var createContainer = function createContainer() {
    if (container != null) {
      return;
    }
    var containerScope = $rootScope.$new(true);
    $compile('<modal-container></modal-container>')(containerScope, function (_container) {
      container = _container;
      $("body").append(container);
    });
  };

  // TODO : container is probably useless. Should append modals to body and remove this

  var showContainer = function showContainer() {
    if (container == null) {
      createContainer();
    }
  };
  var hideContainer = function hideContainer() {
    if (container != null) {
      container.scope() && container.scope().$destroy();
      container.remove();
      container = null;
    }
  };

  // overlay

  var createOverlay = function createOverlay() {
    if (overlay != null) {
      return;
    }
    var overlayScope = $rootScope.$new(true);
    $compile('<modal-overlay></modal-overlay>')(overlayScope, function (_overlay) {
      overlay = _overlay;
      $("body").append(overlay);
    });
  };
  var showOverlay = function showOverlay() {
    if (overlay == null) {
      createOverlay();
    }
    if (overlay) {
      $animate.addClass(overlay, "visible");
    }
  };
  var hideOverlay = function hideOverlay() {
    var oldOverlay = overlay;
    overlay && overlay.scope() && overlay.scope().$destroy();
    if (oldOverlay) {
      $animate.removeClass(oldOverlay, "visible").then(function () {
        oldOverlay.remove();
      });
    }
    overlay = null;
  };

  // dialog
  var openDialog = function openDialog(modal) {
    if (openedDialogs.length === 0) {
      showContainer();
      showOverlay();
      bindKeyboardEvents();
    }
    return createDialog(modal);
  };
  var createDialog = function createDialog(modal) {
    var dialogEl = $('<modal-dialog>');
    dialogEl.html(modal.template);
    $compile(dialogEl)(modal.scope, function (dialog) {
      modal.element = dialog;
      openedDialogs.push(modal);
      container.append(dialog);
    });
    refreshDialogIndexes();
    return modal.element;
  };
  var closeDialog = function closeDialog(dialog) {
    var dialogIndex = _.indexOf(openedDialogs, dialog);
    openedDialogs.splice(dialogIndex, 1);
    var isLastDialog = function isLastDialog() {
      return openedDialogs.length === 0;
    };
    $animate.addClass(dialog.element.find(".tl-modal-content"), "tla-removing").then(function () {
      dialog.scope.$destroy();
      dialog.element.remove();
      if (isLastDialog()) {
        hideContainer();
      }
    });
    if (isLastDialog()) {
      unbindKeyboardEvents();
      hideOverlay();
    } else {
      refreshDialogIndexes();
    }
  };
  var keydownHandler = function keydownHandler(event) {
    var dialog = getCurrentDialog();
    if (!dialog.options.options.escape) {
      return;
    }
    var dialogScope = dialog.scope;
    if (event.which === keyCodes.ESCAPE) {
      dialogScope.$apply(function () {
        dialogScope.$dismiss();
      });
    }
  };
  var bindKeyboardEvents = function bindKeyboardEvents() {
    $($window).keydown(keydownHandler);
  };
  var unbindKeyboardEvents = function unbindKeyboardEvents() {
    $($window).unbind("keydown", keydownHandler);
  };
  var getCurrentDialog = function getCurrentDialog() {
    return _.last(openedDialogs);
  };
  $modal.open = function (modalOptions) {
    var dialogResultDeferred = $q.defer();
    var dialogResultPromise = dialogResultDeferred.promise;

    // merge and clean up options
    modalOptions.resolve = modalOptions.resolve || {};
    modalOptions.options = _objectSpread({}, $modalDefaultOptions, {}, modalOptions.options);

    // verify options
    if (!modalOptions.template && !modalOptions.templateUrl) {
      throw new Error('One of template or templateUrl options is required.');
    }
    var resolvesPromise = deferredUtils.resolvePromiseMap(modalOptions.resolve);
    var templatePromise = templateUtils.loadTemplate(modalOptions);
    $q.all([resolvesPromise, templatePromise]).then(function (resolves) {
      var locals = resolves[0];
      var template = resolves[1];
      var dialogScope = (modalOptions.scope || $rootScope).$new();
      var dialogId = _.uniqueId("$dialog-");
      var dialog = {
        id: dialogId,
        options: modalOptions,
        scope: dialogScope,
        deferred: dialogResultDeferred,
        promise: dialogResultPromise,
        template: template,
        resolve: locals
      };
      if (modalOptions.vars) {
        _.extend(dialogScope, modalOptions.vars);
      }
      _.extend(dialogScope, {
        $dialogId: dialogId,
        modalOptions: modalOptions.options || {},
        $close: function $close(value) {
          closeDialog(dialog);
          dialogResultDeferred.resolve(value);
        },
        $dismiss: function $dismiss(reason) {
          closeDialog(dialog);
          dialogResultDeferred.reject(reason);
        }
      });
      var element = openDialog(dialog);
      _.extend(locals, {
        $element: element
      });

      // controller
      if (modalOptions.controller) {
        locals.$scope = dialogScope;
        locals.$dialog = dialog;
        dialog.ctrl = $controller(modalOptions.controller, locals);
      }

      // controllerAs alias
      dialogScope[modalOptions.controllerAs || "$ctrl"] = dialog.ctrl;
    });
    return dialogResultPromise;
  };
  $modal.isOpen = function () {
    return openedDialogs.length > 0;
  };
  $modal.dismiss = function (modalPromise) {
    _.each(openedDialogs, function (dialog) {
      if (dialog != null && dialog.promise === modalPromise) {
        dialog.scope.$dismiss();
      }
    });
  };
  $modal.dismissAll = function () {
    _.each(openedDialogs, function (dialog) {
      dialog.scope.$dismiss();
    });
  };
  return $modal;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/dialogs/$modal.js", __webpack_require__(4), __webpack_require__(1)))

/***/ }),
/* 2931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.value("$stickyDefaultOptions", {
  width: 600
});
ngModule.directive("stickyDeck", function () {
  return {
    restrict: "E",
    scope: true,
    replace: true,
    template: '<div class="sticky-deck"></div>',
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this;
      ctrl.getDeckElement = function () {
        return $element;
      };
    }]
  };
});
ngModule.directive("stickyDialog", ["$stickyBox", function ($stickyBox) {
  return {
    restrict: "E",
    scope: true,
    replace: true,
    transclude: true,
    template: __webpack_require__(3726),
    controllerAs: "stickyCtrl",
    link: function link($scope, $el, $attrs, ctrl) {
      var options = $scope.dialogOptions;
      ctrl.initialize(options);
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        boxContainer = $scope.$container,
        deckCtrl = $scope.$deckCtrl,
        $el = $element,
        state = {
          minimized: false,
          lastPosition: null
        };
      var updateIndex = function updateIndex() {
        $el.css("z-index", $stickyBox.incrementIndex());
      };
      ctrl.initialize = function (options) {
        updateIndex();
        $el.click(updateIndex);
        $el.width(options.width);
        $el.draggable({
          scroll: false,
          containment: "parent",
          appendTo: boxContainer,
          handle: ".dialog-header .title",
          start: function start(event, ui) {
            updateIndex();
          }
          // stack : 'dialog-selectors'
        });
        ctrl.centerInContainer();
      };
      ctrl.centerInContainer = function () {
        var width = $el.width(),
          height = $el.height(),
          containerWidth = boxContainer.width(),
          containerHeight = boxContainer.height(),
          widthDifference = containerWidth - width,
          heightDifference = containerHeight - height;
        $el.css({
          left: widthDifference / 2 + "px",
          top: heightDifference / 2 + "px"
        });
      };
      ctrl.isMinimized = function () {
        return state.minimized;
      };
      ctrl.closeDialog = function () {
        $scope.$close();
      };
      ctrl.minimizeDialog = function () {
        if (state.minimized) {
          return;
        }
        state.lastPosition = $el.position();
        $el.draggable("disable");
        $el.css({
          top: "",
          left: "",
          right: "",
          bottom: ""
        });
        $el.appendTo(deckCtrl.getDeckElement());
        state.minimized = true;
      };
      ctrl.maximizeDialog = function () {
        if (!state.minimized) {
          return;
        }
        state.minimized = false;
        $el.css({
          top: state.lastPosition.top,
          left: state.lastPosition.left,
          right: null,
          bottom: null
        });
        updateIndex();
        $el.appendTo($scope.$container);
        $el.draggable("enable");
      };
      ctrl.toggleDialog = function () {
        if (state.minimized) {
          ctrl.maximizeDialog();
        } else {
          ctrl.minimizeDialog();
        }
      };
      $scope.$on("$destroy", function () {
        $el.draggable("destroy");
      });
    }]
  };
}]);
ngModule.factory("$stickyBox", ["$compile", "$animate", "$rootScope", "$window", "$q", "$controller", "$body", "keyCodes", "deferredUtils", "templateUtils", "directiveUtils", "$stickyDefaultOptions", function ($compile, $animate, $rootScope, $window, $q, $controller, $body, keyCodes, deferredUtils, templateUtils, directiveUtils, $stickyDefaultOptions) {
  var deck = null,
    deckCtrl = null,
    deckScope = null,
    openedDialogs = [],
    currentIndex = 500;

  // deck

  var createDeck = function createDeck() {
    if (deckScope != null) {
      return;
    }
    var deckLink = directiveUtils.compileDirective("stickyDeck");
    deckScope = $rootScope.$new();
    deckLink(deckScope, function (_deckEl) {
      deck = _deckEl;
      deck.appendTo($body);
    });
    deckCtrl = deck.controller("stickyDeck");
  };

  // dialog

  var openDialog = function openDialog(dialog) {
    if (deck == null) {
      createDeck();
      dialog.scope.$deckCtrl = deckCtrl;
    }
    return createDialog(dialog);
  };
  var createDialog = function createDialog(dialog) {
    var dialogEl = $('<sticky-dialog>');
    dialogEl.html(dialog.template);
    $compile(dialogEl)(dialog.scope, function (clone) {
      dialog.element = clone;
      openedDialogs.push(dialog);
      (dialog.container || $body.find(".main-wrapper")).append(clone);
    });
    return dialog.element;
  };
  var closeDialog = function closeDialog(dialog) {
    var dialogIndex = _.indexOf(openedDialogs, dialog);
    openedDialogs.splice(dialogIndex, 1);
    if (openedDialogs.length === 0) {
      currentIndex = 500; // reseting
    }
    dialog.scope.$destroy();
    dialog.element.remove();
  };
  var $stickyBox = {
    incrementIndex: function incrementIndex() {
      return currentIndex++;
    },
    open: function open(dialogOptions) {
      var dialogResultDeferred = $q.defer(),
        dialogResultPromise = dialogResultDeferred.promise;
      dialogOptions.resolve = dialogOptions.resolve || {};
      dialogOptions.options = _.extend({}, $stickyDefaultOptions, dialogOptions.options || {});
      _.extend(dialogOptions.options, {
        title: dialogOptions.title || ""
      });

      // verify options
      if (!dialogOptions.template && !dialogOptions.templateUrl) {
        throw new Error('One of template or templateUrl options is required.');
      }
      var resolvesPromise = deferredUtils.resolvePromiseMap(dialogOptions.resolve),
        templatePromise = templateUtils.loadTemplate(dialogOptions);
      $q.all([resolvesPromise, templatePromise]).then(function (resolves) {
        var locals = resolves[0],
          template = resolves[1],
          dialogScope = (dialogOptions.scope || $rootScope).$new(),
          dialogId = _.uniqueId("$dialog-");
        var dialog = {
          id: dialogId,
          options: dialogOptions,
          scope: dialogScope,
          deferred: dialogResultDeferred,
          promise: dialogResultPromise,
          template: template,
          container: $body.find(".main-wrapper"),
          resolve: locals
        };
        if (dialogOptions.vars) {
          _.extend(dialogScope, dialogOptions.vars);
        }
        _.extend(dialogScope, {
          $dialogId: dialogId,
          $container: dialog.container,
          $deckCtrl: deckCtrl,
          dialogOptions: dialogOptions.options || {},
          $close: function $close(value) {
            closeDialog(dialog);
            dialogResultDeferred.resolve(value);
          },
          $dismiss: function $dismiss(reason) {
            closeDialog(dialog);
            dialogResultDeferred.reject(reason);
          }
        });
        dialog.element = openDialog(dialog);
        _.extend(locals, {
          $element: dialog.element
        });

        // controller
        if (dialogOptions.controller) {
          locals.$scope = dialogScope;
          locals.$dialog = dialog;
          dialog.ctrl = $controller(dialogOptions.controller, locals);
        }
      });
      return dialogResultPromise;
    }
  };
  return $stickyBox;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/dialogs/$stickyBox.js", __webpack_require__(4), __webpack_require__(1)))

/***/ }),
/* 2932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('tlFileDropOverlay', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: "\n        <div class=\"tl-file-drop-overlay\" tl-on-file-drag=\"onFileDragConfig\">\n            <div class=\"overlay-content\">\n                <span>D\xE9posez les fichiers ici.</span>\n            </div>\n        </div>\n    ",
    link: function link($scope, $el, $attrs) {
      $scope.onFileDragConfig = {
        onEnter: function onEnter() {
          $el.addClass('drop-hover');
        },
        onLeave: function onLeave() {
          $el.removeClass('drop-hover');
        }
      };
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/drag-n-drop/tl-file-drop-overlay.js"))

/***/ }),
/* 2933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('tlOnFileDrag', ["fileDropUtils", function (fileDropUtils) {
  return {
    restrict: 'A',
    link: function link($scope, $el, $attrs) {
      var configAttribute = $attrs.tlOnFileDrag;
      var unbindHandler = null;
      $scope.$watch(configAttribute, function (configOrHandler) {
        if (unbindHandler != null) {
          unbindHandler();
        }
        if (configOrHandler == null) {
          return;
        }
        var onEnter, onLeave;
        if (_.isFunction(configOrHandler)) {
          onEnter = configOrHandler;
          onLeave = angular.noop;
        } else {
          onEnter = configOrHandler.onEnter;
          onLeave = configOrHandler.onLeave;
        }
        unbindHandler = fileDropUtils.addFileDragEvents($el, $scope, onEnter, onLeave);
      });
      $scope.$on('$destroy', function () {
        if (unbindHandler != null) {
          unbindHandler();
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/drag-n-drop/tl-on-file-drag.js", __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 2934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);



function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);

/*
 * Global file download service.
 * Allows download of files in a one-page, ajax application.
 *
 * Please note that resource returning files must use FileDownloadUtils.setFileDownloadCookie
 * to correctlty use $.fileDownload directive.
 */
ngModule.factory("$fileDownload", ["$q", "security", "$http", "$httpErrorHandler", "$dateConverter", "$dialogBox", "$notifications", "urlUtils", function ($q, security, $http, $httpErrorHandler, $dateConverter, $dialogBox, $notifications, urlUtils) {
  function failBackErrorHandler() {
    $dialogBox.alert({
      title: "Erreur",
      html: "Impossible de télécharger le fichier.<br/>Désolé nous n'avons pas de détail sur l'incident, contactez le support si il persiste."
    });
  }
  var syncDownload = /*#__PURE__*/function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/_regenerator().m(function _callee(deferred, authenticatedUrl, options, data) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            $.fileDownload(authenticatedUrl, {
              httpMethod: options.method || "GET",
              cookieName: "fileDownload",
              cookieValue: "true",
              cookiePath: "/",
              data: $dateConverter.formatObject(data || {}),
              successCallback: function successCallback(url) {
                deferred.resolve();
              },
              failCallback: function failCallback(responseHtml, url) {
                // might be browser-dependent, so we try-proof it.
                try {
                  var error = JSON.parse($(responseHtml).text());
                  error.httpCode = 500;
                  $httpErrorHandler.handleServerError(error);
                } catch (e) {
                  failBackErrorHandler();
                }
                deferred.reject();
              }
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function syncDownload(_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();
  var wait = function wait(ms) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
    });
  };
  var waitForCompletion = /*#__PURE__*/function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/_regenerator().m(function _callee2(taskId) {
      var status;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            status = 'PENDING';
          case 1:
            if (!(status != 'COMPLETED' && status != 'ERROR')) {
              _context2.n = 4;
              break;
            }
            _context2.n = 2;
            return $http.get('/rest/user-tasks/status/' + taskId).then(function (response) {
              status = response.data;
            });
          case 2:
            _context2.n = 3;
            return wait(2000);
          case 3:
            _context2.n = 1;
            break;
          case 4:
            return _context2.a(2, status);
        }
      }, _callee2);
    }));
    return function waitForCompletion(_x5) {
      return _ref2.apply(this, arguments);
    };
  }();
  var asyncDownload = /*#__PURE__*/function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/_regenerator().m(function _callee3(deferred, authenticatedUrl, options, data) {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            $http.post('/rest/async-download/execute', {
              method: options && options.method || 'GET',
              url: authenticatedUrl,
              data: data
            }).then(function (response) {
              $notifications.info("Le téléchargement a démarré, vous serez notifié quand il sera terminé.");
              var taskId = response.data.response;
              waitForCompletion(taskId).then(function (status) {
                if (status == 'COMPLETED') {
                  var authenticatedDownloadUrl = urlUtils.addParams("/rest/user-tasks/downloadUserTaskGeneratedFile/" + taskId, security.getTokens());
                  syncDownload(deferred, authenticatedDownloadUrl, {}, {});
                  if (options.onSuccess) {
                    options.onSuccess();
                  }
                  $notifications.info("Téléchargement terminé");
                } else {
                  if (options.onFailure) {
                    options.onFailure();
                  }
                  $notifications.error("Téléchargement en erreur");
                  deferred.reject("Téléchargement en erreur");
                }
              });
            });
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function asyncDownload(_x6, _x7, _x8, _x9) {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    /**
     * Start the download of a resource.
     *
     * @param {String} url The url to download the resource from.
     * @param {Object} [data] The data to send with the request, either via query param for GET requests, or envelope for POST requests
     * @param {Object} [options] Optional configuration options for the download
     *                           - method : The http method to use, either 'GET' or 'POST'
     * @return {deferred.promise|*} A promise resolving when the file download is completed.
     */
    start: function start(url, data, options) {
      var deferred = $q.defer();
      options = options || {};
      var httpMethod = options.method || "GET";
      var async = options.async || false;
      var authenticatedUrl = urlUtils.addParams(url, security.getTokens());
      if (httpMethod === "POST" && data != null) {
        // see FormEncodedGsonMessageBodyReader for details...
        data = {
          POST_DATA: JSON.stringify($dateConverter.formatObject(data || {}))
        };
      }
      if (async) {
        asyncDownload(deferred, authenticatedUrl, options, data);
      } else {
        syncDownload(deferred, authenticatedUrl, options, data);
      }
      ;
      return deferred.promise;
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/file-download/$fileDownload.js", __webpack_require__(4)))

/***/ }),
/* 2935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * lien de téléchargement.
 * ex paramètres :
 * data="params"
 * options="{ method : 'POST'}"
 *
 *  on-success="fileDownloaded()" : methode appelée à la fin du téléchargement (retour du côté serveur)
  *  on-start="startDownload()" : m"thode appelée au déclenchement du téléchargement (avant appel serveur)
 */
ngModule.directive("fileDownloadLink", ["$fileDownload", "$uiBlock", function ($fileDownload, $uiBlock) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<span><a href="{{url}}" ng-click="download()" ng-transclude></a>' + '<tl-circular-loader class="xs" ng-if="downloading"></tl-circular-loader>' + ' </span>',
    scope: {
      url: "@",
      data: "=",
      options: "=",
      /**
       * appelé après le téléchargement
       */
      onSuccess: "&",
      /**
       * appelé après l'echec du téléchargement
       */
      onFailure: "&",
      /**
       * appelé avant l'appel serveur de telechagement
       */
      onStart: "&"
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      $scope.download = function () {
        // sur l'asynchrone on écite les clicks en serie...
        if ($scope.options && $scope.options.async && $scope.downloading) {
          return;
        }
        if (!($scope.options && $scope.options.async)) {
          $uiBlock.block();
        }
        if ($scope.onStart) {
          $scope.onStart();
        }
        $scope.downloading = true;
        $fileDownload.start($scope.url, $scope.data || {}, $scope.options || {}).then(function () {
          $scope.onSuccess && $scope.onSuccess();
        }, function () {
          $scope.onFailure && $scope.onFailure();
        }).finally(function () {
          $uiBlock.unblock();
          $scope.downloading = false;
        });
      };
    }],
    link: function link($scope, $el, $attrs) {
      $el.click(function (event) {
        event.preventDefault();
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/file-download/fileDownloadLink.js"))

/***/ }),
/* 2936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("documentDrop", ["$document", "$rootScope", "fileDropUtils", function ($document, $rootScope, fileDropUtils) {
  var dragging = false;
  var onDragStart = function onDragStart() {
    dragging = true;
  };
  var onDragStop = function onDragStop() {
    dragging = false;
  };
  fileDropUtils.addFileDragEvents($document, $rootScope, onDragStart, onDragStop);
  return {
    isActive: function isActive() {
      return dragging;
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/file-upload/document-drop.js"))

/***/ }),
/* 2937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
ngModule.value("fileuploadDefaultOptions", {
  //url             : '/rest/...', // Pas de valeur par défaut, à chaque usage sa ressource.
  dataType: "json",
  autoUpload: true,
  formData: {},
  maxFileSize: 15 * 1024 * 1024,
  // 15Mo
  messages: {}
});
ngModule.factory("$fileUpload", ["$modal", function ($modal) {
  var UploadLoader = function UploadLoader($scope) {
    var self = this,
      loaderScope = null,
      modalPromise = null;
    self.start = function () {
      loaderScope = $scope.$new();
      _.extend({
        progress: 0,
        bitrate: 0
      });
      self.show();
      $scope.$on("fileuploadprogress", self.onProcess);
      $scope.$on('fileuploadstop', self.close);
    };
    self.show = function () {
      modalPromise = $modal.open({
        scope: loaderScope,
        template: __webpack_require__(3728),
        options: {
          escape: false,
          width: 300,
          dialogClass: "fileupload-loader"
        }
      });
    };
    self.onProcess = function (event, data) {
      loaderScope.progress = data.loaded / data.total * 100;
      loaderScope.bitrate = data.bitrate;
    };
    self.close = function () {
      if (modalPromise) {
        $modal.dismiss(modalPromise);
        modalPromise = null;
        loaderScope.$destroy();
      }
    };
    $scope.$on("$destroy", function () {
      self.close();
    });
  };
  return {
    startLoader: function startLoader($scope) {
      var loader = new UploadLoader($scope);
      loader.start();
    }
  };
}]);

/**
 * ex :
 * <fileupload-btn btn-label="Upload"  upload-success="onDocumentUpload" options="uploadOptions"></fileupload-btn>
 *
 * attribut icon par défaut : fa-arrow-circle-o-up
 /* attribut btn-class ex: btn-class ="btn-action-small"

 */
ngModule.directive("fileuploadBtn", ["security", "urlUtils", "$parse", "$fileUpload", "$dialogBox", "$q", "$numberFormat", "fileuploadDefaultOptions", function (security, urlUtils, $parse, $fileUpload, $dialogBox, $q, $numberFormat, fileuploadDefaultOptions) {
  var openFileSizeTooBigPopin = function openFileSizeTooBigPopin(uploadOptions) {
    $dialogBox.alert({
      title: "Taille du fichier trop importante",
      html: "L'envoi est limité à des fichiers de " + $numberFormat.bytes(uploadOptions.maxFileSize) + " maximum.<br>" + "Essayez de le découper en plusieurs fichiers.<br>" + "Vous pouvez pour les fichiers pdf utiliser des outils en ligne tels que <a href='http://www.ilovepdf.com/fr/diviser_pdf' target='_blank'>celui-ci</a> ou <a href='http://smallpdf.com/fr/diviser-pdf' target='_blank'>celui-là.</a>"
    });
  };
  return {
    restrict: 'EA',
    replace: true,
    template: __webpack_require__(3727),
    scope: {
      options: "<",
      type: "@",
      owner: "@",
      btnLabel: "@",
      btnLabelKey: "@",
      accept: "@",
      beforeUpload: "<",
      uploadSuccess: "@",
      // workaround to provide additionnal info
      hint: "@"
    },
    link: function link($scope, $el, $attrs) {
      $scope.icon = $attrs['icon'] || 'fa-arrow-circle-o-up';
      $scope.btnClass = $attrs['btnClass'];
      $scope.$watch("options", function (options) {
        var mergedOptions = $scope.mergedOptions = _objectSpread({}, fileuploadDefaultOptions, {
          dropZone: $el
        }, options);
        mergedOptions.url = urlUtils.addParams(mergedOptions.url, security.getTokens());
        mergedOptions.formData = _objectSpread({}, mergedOptions.formData, {
          type: $scope.type || "AUTRE_DOCUMENT",
          owner: $scope.owner
        });

        // permet à la fenetre de choix de fichier de choisir plusieurs fichiers.
        if (mergedOptions.multiple === true) {
          $el.find(".file-input").prop('multiple', true);
        }
        mergedOptions.add = function (e, data, other) {
          var addedFile = data.files[0];
          if (addedFile.name === '.DS_Store') {
            console.log('Fichier ignoré ' + addedFile.name);
          } else if (addedFile.size && addedFile.size > mergedOptions.maxFileSize) {
            openFileSizeTooBigPopin(mergedOptions);
          } else {
            var beforeUploadHandler = $scope.beforeUpload;
            if (beforeUploadHandler) {
              $q.when(beforeUploadHandler(mergedOptions, addedFile)).then(function (newFormData) {
                if (newFormData) {
                  $el.find("form[file-upload]").fileupload("option", "formData", newFormData);
                }
                data.submit();
              });
            } else {
              data.submit();
            }
          }
        };
      }, true);
      $scope.$on('fileuploadstart', function (event, file) {
        $fileUpload.startLoader($scope);
      });
      $scope.$on("fileuploadfail", function (event, data) {
        var error = !data.result || data.result.message || data.files[0].error;
        console.log('error fileUpload', data);
        $dialogBox.alert({
          title: "Erreur lors de l'envoi du fichier",
          text: error
        });
      });
      $scope.$on('fileuploaddone', function (event, file) {
        if ($scope.uploadSuccess) {
          var handler = $parse($scope.uploadSuccess)($scope.$parent);
          handler(file.result, file);
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/file-upload/fileUpload.js", __webpack_require__(1)))

/***/ }),
/* 2938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("fileImage", ["security", "urlUtils", function (security, urlUtils) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '<img ng-src="{{filePath}}">',
    link: function link($scope, $el, $attrs) {
      $scope.filePath = null;
      $attrs.$observe("url", function (url) {
        $scope.filePath = urlUtils.addParams(url, security.getTokens());
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/fileImage.js"))

/***/ }),
/* 2939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("fileImageWithSize", ["security", "urlUtils", function (security, urlUtils) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '<div><img ng-src="{{filePath}}"><div class="size">{{width}}*{{height}}px</div></div>',
    link: function link($scope, $el, $attrs) {
      $scope.filePath = null;
      $attrs.$observe("url", function (url) {
        $scope.filePath = urlUtils.addParams(url, security.getTokens());
      });
      $el.find('img').on("load", function () {
        var img = $el.find('img')[0];
        $scope.width = img.naturalWidth;
        $scope.height = img.naturalHeight;
        $scope.$digest();
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/fileImageWithSize.js"))

/***/ }),
/* 2940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * The list of all icons available in font-awesome.
 * Used for the tl-icon-input and maybe other stuff later
 *
 * see http://stackoverflow.com/questions/27992992/i-need-list-of-all-class-name-of-font-awesome
 *
 * go here : http://fontawesome.io/icons/
 *
 * and do :
 * var t = $(".fontawesome-icon-list a").filter(function(i, e) { return !/(alias)/.test($(e).text()) }).find("i.fa").map(function(i, el) { return $(el).removeClass("fa").attr("class") }).toArray();
 * console.log(JSON.stringify(y));
 */
ngModule.factory("fontAwesomeIconList", function () {
  return ["fa-american-sign-language-interpreting", "fa-assistive-listening-systems", "fa-audio-description", "fa-blind", "fa-braille", "fa-deaf", "fa-envira", "fa-first-order", "fa-font-awesome", "fa-gitlab", "fa-glide", "fa-glide-g", "fa-google-plus-official", "fa-instagram", "fa-low-vision", "fa-pied-piper", "fa-question-circle-o", "fa-sign-language", "fa-snapchat", "fa-snapchat-ghost", "fa-snapchat-square", "fa-themeisle", "fa-universal-access", "fa-viadeo", "fa-viadeo-square", "fa-volume-control-phone", "fa-wheelchair-alt", "fa-wpbeginner", "fa-wpforms", "fa-yoast", "fa-adjust", "fa-anchor", "fa-archive", "fa-area-chart", "fa-arrows", "fa-arrows-h", "fa-arrows-v", "fa-asterisk", "fa-at", "fa-balance-scale", "fa-ban", "fa-bar-chart", "fa-barcode", "fa-bars", "fa-battery-empty", "fa-battery-full", "fa-battery-half", "fa-battery-quarter", "fa-battery-three-quarters", "fa-bed", "fa-beer", "fa-bell", "fa-bell-o", "fa-bell-slash", "fa-bell-slash-o", "fa-bicycle", "fa-binoculars", "fa-birthday-cake", "fa-bluetooth", "fa-bluetooth-b", "fa-bolt", "fa-bomb", "fa-book", "fa-bookmark", "fa-bookmark-o", "fa-briefcase", "fa-bug", "fa-building", "fa-building-o", "fa-bullhorn", "fa-bullseye", "fa-bus", "fa-calculator", "fa-calendar", "fa-calendar-check-o", "fa-calendar-minus-o", "fa-calendar-o", "fa-calendar-plus-o", "fa-calendar-times-o", "fa-camera", "fa-camera-retro", "fa-car", "fa-caret-square-o-down", "fa-caret-square-o-left", "fa-caret-square-o-right", "fa-caret-square-o-up", "fa-cart-arrow-down", "fa-cart-plus", "fa-cc", "fa-certificate", "fa-check", "fa-check-circle", "fa-check-circle-o", "fa-check-square", "fa-check-square-o", "fa-child", "fa-circle", "fa-circle-o", "fa-circle-o-notch", "fa-circle-thin", "fa-clock-o", "fa-clone", "fa-cloud", "fa-cloud-download", "fa-cloud-upload", "fa-code", "fa-code-fork", "fa-coffee", "fa-cog", "fa-cogs", "fa-comment", "fa-comment-o", "fa-commenting", "fa-commenting-o", "fa-comments", "fa-comments-o", "fa-compass", "fa-copyright", "fa-creative-commons", "fa-credit-card", "fa-credit-card-alt", "fa-crop", "fa-crosshairs", "fa-cube", "fa-cubes", "fa-cutlery", "fa-database", "fa-desktop", "fa-diamond", "fa-dot-circle-o", "fa-download", "fa-ellipsis-h", "fa-ellipsis-v", "fa-envelope", "fa-envelope-o", "fa-envelope-square", "fa-eraser", "fa-exchange", "fa-exclamation", "fa-exclamation-circle", "fa-exclamation-triangle", "fa-external-link", "fa-external-link-square", "fa-eye", "fa-eye-slash", "fa-eyedropper", "fa-fax", "fa-female", "fa-fighter-jet", "fa-file-archive-o", "fa-file-audio-o", "fa-file-code-o", "fa-file-excel-o", "fa-file-image-o", "fa-file-pdf-o", "fa-file-powerpoint-o", "fa-file-video-o", "fa-file-word-o", "fa-film", "fa-filter", "fa-fire", "fa-fire-extinguisher", "fa-flag", "fa-flag-checkered", "fa-flag-o", "fa-flask", "fa-folder", "fa-folder-o", "fa-folder-open", "fa-folder-open-o", "fa-frown-o", "fa-futbol-o", "fa-gamepad", "fa-gavel", "fa-gift", "fa-glass", "fa-globe", "fa-graduation-cap", "fa-hand-lizard-o", "fa-hand-paper-o", "fa-hand-peace-o", "fa-hand-pointer-o", "fa-hand-rock-o", "fa-hand-scissors-o", "fa-hand-spock-o", "fa-hashtag", "fa-hdd-o", "fa-headphones", "fa-heart", "fa-heart-o", "fa-heartbeat", "fa-history", "fa-home", "fa-hourglass", "fa-hourglass-end", "fa-hourglass-half", "fa-hourglass-o", "fa-hourglass-start", "fa-i-cursor", "fa-inbox", "fa-industry", "fa-info", "fa-info-circle", "fa-key", "fa-keyboard-o", "fa-language", "fa-laptop", "fa-leaf", "fa-lemon-o", "fa-level-down", "fa-level-up", "fa-life-ring", "fa-lightbulb-o", "fa-line-chart", "fa-location-arrow", "fa-lock", "fa-magic", "fa-magnet", "fa-male", "fa-map", "fa-map-marker", "fa-map-o", "fa-map-pin", "fa-map-signs", "fa-meh-o", "fa-microphone", "fa-microphone-slash", "fa-minus", "fa-minus-circle", "fa-minus-square", "fa-minus-square-o", "fa-mobile", "fa-money", "fa-moon-o", "fa-motorcycle", "fa-mouse-pointer", "fa-music", "fa-newspaper-o", "fa-object-group", "fa-object-ungroup", "fa-paint-brush", "fa-paper-plane", "fa-paper-plane-o", "fa-paw", "fa-pencil", "fa-pencil-square", "fa-pencil-square-o", "fa-percent", "fa-phone", "fa-phone-square", "fa-picture-o", "fa-pie-chart", "fa-plane", "fa-plug", "fa-plus", "fa-plus-circle", "fa-plus-square", "fa-plus-square-o", "fa-power-off", "fa-print", "fa-puzzle-piece", "fa-qrcode", "fa-question", "fa-question-circle", "fa-quote-left", "fa-quote-right", "fa-random", "fa-recycle", "fa-refresh", "fa-registered", "fa-reply", "fa-reply-all", "fa-retweet", "fa-road", "fa-rocket", "fa-rss", "fa-rss-square", "fa-search", "fa-search-minus", "fa-search-plus", "fa-server", "fa-share", "fa-share-alt", "fa-share-alt-square", "fa-share-square", "fa-share-square-o", "fa-shield", "fa-ship", "fa-shopping-bag", "fa-shopping-basket", "fa-shopping-cart", "fa-sign-in", "fa-sign-out", "fa-signal", "fa-sitemap", "fa-sliders", "fa-smile-o", "fa-sort", "fa-sort-alpha-asc", "fa-sort-alpha-desc", "fa-sort-amount-asc", "fa-sort-amount-desc", "fa-sort-asc", "fa-sort-desc", "fa-sort-numeric-asc", "fa-sort-numeric-desc", "fa-space-shuttle", "fa-spinner", "fa-spoon", "fa-square", "fa-square-o", "fa-star", "fa-star-half", "fa-star-half-o", "fa-star-o", "fa-sticky-note", "fa-sticky-note-o", "fa-street-view", "fa-suitcase", "fa-sun-o", "fa-tablet", "fa-tachometer", "fa-tag", "fa-tags", "fa-tasks", "fa-taxi", "fa-television", "fa-terminal", "fa-thumb-tack", "fa-thumbs-down", "fa-thumbs-o-down", "fa-thumbs-o-up", "fa-thumbs-up", "fa-ticket", "fa-times", "fa-times-circle", "fa-times-circle-o", "fa-tint", "fa-toggle-off", "fa-toggle-on", "fa-trademark", "fa-trash", "fa-trash-o", "fa-tree", "fa-trophy", "fa-truck", "fa-tty", "fa-umbrella", "fa-university", "fa-unlock", "fa-unlock-alt", "fa-upload", "fa-user", "fa-user-plus", "fa-user-secret", "fa-user-times", "fa-users", "fa-video-camera", "fa-volume-down", "fa-volume-off", "fa-volume-up", "fa-wheelchair", "fa-wifi", "fa-wrench", "fa-hand-o-down", "fa-hand-o-left", "fa-hand-o-right", "fa-hand-o-up", "fa-ambulance", "fa-subway", "fa-train", "fa-genderless", "fa-mars", "fa-mars-double", "fa-mars-stroke", "fa-mars-stroke-h", "fa-mars-stroke-v", "fa-mercury", "fa-neuter", "fa-transgender", "fa-transgender-alt", "fa-venus", "fa-venus-double", "fa-venus-mars", "fa-file", "fa-file-o", "fa-file-text", "fa-file-text-o", "fa-cc-amex", "fa-cc-diners-club", "fa-cc-discover", "fa-cc-jcb", "fa-cc-mastercard", "fa-cc-paypal", "fa-cc-stripe", "fa-cc-visa", "fa-google-wallet", "fa-paypal", "fa-btc", "fa-eur", "fa-gbp", "fa-gg", "fa-gg-circle", "fa-ils", "fa-inr", "fa-jpy", "fa-krw", "fa-rub", "fa-try", "fa-usd", "fa-align-center", "fa-align-justify", "fa-align-left", "fa-align-right", "fa-bold", "fa-chain-broken", "fa-clipboard", "fa-columns", "fa-files-o", "fa-floppy-o", "fa-font", "fa-header", "fa-indent", "fa-italic", "fa-link", "fa-list", "fa-list-alt", "fa-list-ol", "fa-list-ul", "fa-outdent", "fa-paperclip", "fa-paragraph", "fa-repeat", "fa-scissors", "fa-strikethrough", "fa-subscript", "fa-superscript", "fa-table", "fa-text-height", "fa-text-width", "fa-th", "fa-th-large", "fa-th-list", "fa-underline", "fa-undo", "fa-angle-double-down", "fa-angle-double-left", "fa-angle-double-right", "fa-angle-double-up", "fa-angle-down", "fa-angle-left", "fa-angle-right", "fa-angle-up", "fa-arrow-circle-down", "fa-arrow-circle-left", "fa-arrow-circle-o-down", "fa-arrow-circle-o-left", "fa-arrow-circle-o-right", "fa-arrow-circle-o-up", "fa-arrow-circle-right", "fa-arrow-circle-up", "fa-arrow-down", "fa-arrow-left", "fa-arrow-right", "fa-arrow-up", "fa-arrows-alt", "fa-caret-down", "fa-caret-left", "fa-caret-right", "fa-caret-up", "fa-chevron-circle-down", "fa-chevron-circle-left", "fa-chevron-circle-right", "fa-chevron-circle-up", "fa-chevron-down", "fa-chevron-left", "fa-chevron-right", "fa-chevron-up", "fa-long-arrow-down", "fa-long-arrow-left", "fa-long-arrow-right", "fa-long-arrow-up", "fa-backward", "fa-compress", "fa-eject", "fa-expand", "fa-fast-backward", "fa-fast-forward", "fa-forward", "fa-pause", "fa-pause-circle", "fa-pause-circle-o", "fa-play", "fa-play-circle", "fa-play-circle-o", "fa-step-backward", "fa-step-forward", "fa-stop", "fa-stop-circle", "fa-stop-circle-o", "fa-youtube-play", "fa-500px", "fa-adn", "fa-amazon", "fa-android", "fa-angellist", "fa-apple", "fa-behance", "fa-behance-square", "fa-bitbucket", "fa-bitbucket-square", "fa-black-tie", "fa-buysellads", "fa-chrome", "fa-codepen", "fa-codiepie", "fa-connectdevelop", "fa-contao", "fa-css3", "fa-dashcube", "fa-delicious", "fa-deviantart", "fa-digg", "fa-dribbble", "fa-dropbox", "fa-drupal", "fa-edge", "fa-empire", "fa-expeditedssl", "fa-facebook", "fa-facebook-official", "fa-facebook-square", "fa-firefox", "fa-flickr", "fa-fonticons", "fa-fort-awesome", "fa-forumbee", "fa-foursquare", "fa-get-pocket", "fa-git", "fa-git-square", "fa-github", "fa-github-alt", "fa-github-square", "fa-google", "fa-google-plus", "fa-google-plus-square", "fa-gratipay", "fa-hacker-news", "fa-houzz", "fa-html5", "fa-internet-explorer", "fa-ioxhost", "fa-joomla", "fa-jsfiddle", "fa-lastfm", "fa-lastfm-square", "fa-leanpub", "fa-linkedin", "fa-linkedin-square", "fa-linux", "fa-maxcdn", "fa-meanpath", "fa-medium", "fa-mixcloud", "fa-modx", "fa-odnoklassniki", "fa-odnoklassniki-square", "fa-opencart", "fa-openid", "fa-opera", "fa-optin-monster", "fa-pagelines", "fa-pied-piper-alt", "fa-pied-piper-pp", "fa-pinterest", "fa-pinterest-p", "fa-pinterest-square", "fa-product-hunt", "fa-qq", "fa-rebel", "fa-reddit", "fa-reddit-alien", "fa-reddit-square", "fa-renren", "fa-safari", "fa-scribd", "fa-sellsy", "fa-shirtsinbulk", "fa-simplybuilt", "fa-skyatlas", "fa-skype", "fa-slack", "fa-slideshare", "fa-soundcloud", "fa-spotify", "fa-stack-exchange", "fa-stack-overflow", "fa-steam", "fa-steam-square", "fa-stumbleupon", "fa-stumbleupon-circle", "fa-tencent-weibo", "fa-trello", "fa-tripadvisor", "fa-tumblr", "fa-tumblr-square", "fa-twitch", "fa-twitter", "fa-twitter-square", "fa-usb", "fa-viacoin", "fa-vimeo", "fa-vimeo-square", "fa-vine", "fa-vk", "fa-weibo", "fa-weixin", "fa-whatsapp", "fa-wikipedia-w", "fa-windows", "fa-wordpress", "fa-xing", "fa-xing-square", "fa-y-combinator", "fa-yahoo", "fa-yelp", "fa-youtube", "fa-youtube-square", "fa-h-square", "fa-hospital-o", "fa-medkit", "fa-stethoscope", "fa-user-md"];
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/fontAwesomeIconList.js"))

/***/ }),
/* 2941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlFormWizard", ["$compile", "$q", "templateUtils", "$controller", "deferredUtils", function ($compile, $q, templateUtils, $controller, deferredUtils) {
  return {
    restrict: "E",
    controllerAs: "formWizard",
    scope: true,
    replace: true,
    transclude: true,
    template: __webpack_require__(3729),
    link: function link($scope, $el, $attrs, ctrl) {
      $attrs.$observe("wizardConfig", function (configPropName) {
        $scope.$watch(configPropName, function (config) {
          if (config == null) {
            return;
          }
          ctrl.initialize(config);
        });
      });
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        currentStep = null,
        config = null;
      ctrl.initialize = function (_config) {
        config = $scope.config = _config;
        $scope.wizardTitle = config.title;
        ctrl.loadStep(config.initialStep || 0);
      };
      ctrl.getStepNumber = function () {
        return currentStep && currentStep.idx + 1;
      };
      ctrl.isFirstStep = function () {
        return currentStep && currentStep.idx === 0;
      };
      ctrl.isLastStep = function () {
        return currentStep && currentStep.idx === config.steps.length - 1;
      };
      ctrl.toNextStep = function () {
        ctrl.loadStep(currentStep.idx + 1);
      };
      ctrl.toPreviousStep = function () {
        ctrl.loadStep(currentStep.idx - 1);
      };
      ctrl.removeCurrentStep = function () {
        if (currentStep != null) {
          currentStep.scope.$destroy();
          currentStep.element.remove();
          currentStep = null;
        }
      };
      ctrl.isCurrentStepValid = function () {
        if (currentStep == null) {
          return false;
        }
        if (currentStep.controller && currentStep.controller.isValidStep) {
          return currentStep.controller.isValidStep();
        }
        return true;
      };
      ctrl.validateAndSave = function () {
        config.save && config.save();
      };
      ctrl.loadStep = function (stepIdx) {
        ctrl.removeCurrentStep();
        var step = config.steps[stepIdx];
        var resolvesPromise = deferredUtils.resolvePromiseMap(step.resolve || {});
        var templatePromise = templateUtils.loadTemplate(step);
        $q.all([resolvesPromise, templatePromise]).then(function (resolves) {
          var stepScope = $scope.$new();
          currentStep = {
            idx: stepIdx,
            scope: stepScope
          };
          var locals = resolves[0],
            template = resolves[1];
          if (step.controller) {
            locals.$scope = stepScope;
            locals.$element = $element;
            currentStep.controller = $controller(step.controller, locals);
          }
          $compile(template)(stepScope, function (content) {
            currentStep.element = content;
            $element.find(".content").append(content);
          });
        });
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/form-wizard/formWizard.js"))

/***/ }),
/* 2942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

// TODO: recode without depending on the shitty bs-switch.
// http://www.bootstrap-switch.org/
/**
 * @param on-change callback quand on change l'état
 */
ngModule.directive('btnOnOff', ["$timeout", "$translate", function ($timeout, $translate) {
  return {
    restrict: 'E',
    replace: true,
    template: '' + '<div class="make-switch switch-small" data-on-label="{{switchOnLabel | translate}}" data-off-label="{{switchOffLabel | translate}}">' + '   <input type="checkbox" ng-model="model" ng-change="change()"/>' + '</div>',
    scope: {
      model: '=',
      switchOnLabel: '@',
      switchOffLabel: '@',
      onChange: '&'
    },
    link: function postLink(scope, element, attrs) {
      var defaultOnLabel = "";
      var defaultOffLabel = "";
      var setDefaults = function setDefaults() {
        if (!scope.model) {
          scope.model = false;
        }
        if (!scope.switchOnLabel) {
          scope.switchOnLabel = defaultOnLabel;
        }
        if (!scope.switchOffLabel) {
          scope.switchOffLabel = defaultOffLabel;
        }
      };
      var listenToModel = function listenToModel() {
        scope.$watch('model', function (newValue) {
          if (newValue !== undefined) {
            element.bootstrapSwitch('setState', newValue || false);
          }
        });
        scope.change = function () {
          if (scope.onChange) {
            scope.onChange();
          }
        };
        scope.$watch('switchOnLabel', function (newValue) {
          element.bootstrapSwitch('setOnLabel', newValue ? $translate(newValue) : "&nbsp;");
        });
        scope.$watch('switchOffLabel', function (newValue) {
          element.bootstrapSwitch('setOffLabel', newValue ? $translate(newValue) : "&nbsp;");
        });
      };
      var listenToView = function listenToView() {
        element.on('switch-change', function (e, data) {
          var value = data.value;
          if (value !== scope.model) {
            scope.$apply(function () {
              scope.model = value;
            });
          }
        });
      };

      // Collect ya garbage - makes angular crash during view removal, do not uncomment.
      /*
       scope.$on('$destroy', function() {
       element.bootstrapSwitch('destroy');
       });
       */

      // Do stuff as soon as possible
      $timeout(function () {
        // Sets the defaults
        setDefaults();

        // Init the switch
        element.bootstrapSwitch();

        // Listen and respond to view changes
        listenToView();

        // Listen and respond to model changes
        listenToModel();
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/form/button/btn-on-off.js"))

/***/ }),
/* 2943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * FieldSet with a legend label
 */
ngModule.directive("fieldSet", function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      label: "@"
    },
    template: '' + '<div class="fieldset">' + '   <div ng-if="label" class="tl-legend">' + '       {{label | translate}}' + '   </div>' + '   <div class="content" ng-transclude></div>' + '</div>'
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/form/fieldSet.js"))

/***/ }),
/* 2944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
var DEBUG = false;

/**
 * Filtre les saisies et n'accepte que celles matchant la regexp donnée
 * La regexp doit être progressive, c'est à dire autoriser les saisies partielles et même vides (pour pouvoir tout effacer)

 * Adapté de https://github.com/AlphaGit/ng-pattern-restrict/blob/master/src/ng-pattern-restrict.js
 *
 * Utilisation :
 * <input ng-model="data.searchCommuneDepartement" input-acceptable-regexp="{{valeursAcceptablesRegexp}}">
 *  avec $scope.valeursAcceptablesRegexp = "^[0-9]?[1-9]?$|^2[AB]$";
 * ou bien simplement :
 * <input ng-model="data.searchCommuneDepartement" input-acceptable-regexp="^[0-9]?[1-9]?$|^2[AB]$">
 */
ngModule.directive("inputAcceptableRegexp", function () {
  function showDebugInfo() {
    console.log("[ngPatternRestrict] " + Array.prototype.join.call(arguments, ' '));
  }
  return {
    restrict: 'A',
    require: "?ngModel",
    compile: function uiPatternRestrictCompile() {
      DEBUG && showDebugInfo("Loaded");
      return function ngPatternRestrictLinking(scope, iElement, iAttrs, ngModelController) {
        var regex = /.*/,
          // validation regex object
          catchAllregex = true,
          // whether the previous regex is an allow-all regex
          oldValue,
          // keeping track of the previous value of the element
          caretPosition,
          // keeping track of where the caret is at to avoid jumpiness
          // housekeeping
          initialized = false,
          // have we initialized our directive yet?
          eventsBound = false,
          // have we bound our events yet?
          // functions
          getCaretPosition,
          // function to get the caret position, set in detectGetCaretPositionMethods
          setCaretPosition; // function to set the caret position, set in detectSetCaretPositionMethods

        //-------------------------------------------------------------------
        // caret position
        function getCaretPositionWithInputSelectionStart() {
          return iElement[0].selectionStart; // we need to go under jqlite
        }
        function getCaretPositionWithDocumentSelection() {
          // create a selection range from where we are to the beggining
          // and measure how much we moved
          var range = document.selection.createRange();
          range.moveStart('character', -iElement.val().length);
          return range.text.length;
        }
        function getCaretPositionWithWindowSelection() {
          var s = window.getSelection(),
            originalSelectionLength = String(s).length,
            selectionLength,
            didReachZero = false,
            detectedCaretPosition,
            restorePositionCounter;
          do {
            selectionLength = String(s).length;
            s.modify('extend', 'backward', 'character');
            // we're undoing a selection, and starting a new one towards the beggining of the string
            if (String(s).length === 0) {
              didReachZero = true;
            }
          } while (selectionLength !== String(s).length);
          detectedCaretPosition = didReachZero ? selectionLength : selectionLength - originalSelectionLength;
          s.collapseToStart();
          restorePositionCounter = detectedCaretPosition;
          while (restorePositionCounter-- > 0) {
            s.modify('move', 'forward', 'character');
          }
          while (originalSelectionLength-- > 0) {
            s.modify('extend', 'forward', 'character');
          }
          return detectedCaretPosition;
        }
        function setCaretPositionWithSetSelectionRange(position) {
          iElement[0].setSelectionRange(position, position);
        }
        function setCaretPositionWithCreateTextRange(position) {
          var textRange = iElement[0].createTextRange();
          textRange.collapse(true);
          textRange.moveEnd('character', position);
          textRange.moveStart('character', position);
          textRange.select();
        }
        function setCaretPositionWithWindowSelection(position) {
          var s = window.getSelection(),
            selectionLength;
          do {
            selectionLength = String(s).length;
            s.modify('extend', 'backward', 'line');
          } while (selectionLength !== String(s).length);
          s.collapseToStart();
          while (position--) {
            s.modify('move', 'forward', 'character');
          }
        }

        // HACK: Opera 12 won't give us a wrong validity status although the input is invalid
        // we can select the whole text and check the selection size
        // Congratulations to IE 11 for doing the same but not returning the selection.
        function getValueLengthThroughSelection(input) {
          // only do this on opera, since it'll mess up the caret position
          // and break Firefox functionality
          if (!/Opera/i.test(navigator.userAgent)) {
            return 0;
          }
          input.focus();
          document.execCommand("selectAll");
          var focusNode = window.getSelection().focusNode;
          return (focusNode || {}).selectionStart || 0;
        }

        //-------------------------------------------------------------------
        // event handlers
        function revertToPreviousValue() {
          iElement.val(oldValue);
          if (caretPosition !== undefined && caretPosition != null) {
            setCaretPosition(caretPosition);
          }
        }
        function updateCurrentValue(newValue) {
          oldValue = newValue;
          caretPosition = getCaretPosition();
        }
        function genericEventHandler(evt) {
          DEBUG && showDebugInfo("Reacting to event:", evt.type);
          if (catchAllregex) {
            DEBUG && showDebugInfo("Currently using a catch-all regex. No checks to do.");
            return;
          }

          //HACK Chrome returns an empty string as value if user inputs a non-numeric string into a number type input
          // and this may happen with other non-text inputs soon enough. As such, if getting the string only gives us an
          // empty string, we don't have the chance of validating it against a regex. All we can do is assume it's wrong,
          // since the browser is rejecting it either way.
          var newValue = iElement.val(),
            inputValidity = iElement.prop("validity");
          if (newValue === "" && iElement.attr("type") !== "text" && inputValidity && inputValidity.badInput) {
            DEBUG && showDebugInfo("Value cannot be verified. Should be invalid. Reverting back to:", oldValue);
            evt.preventDefault();
            revertToPreviousValue();
          } else if (newValue === "" && getValueLengthThroughSelection(iElement[0]) !== 0) {
            DEBUG && showDebugInfo("Invalid input. Reverting back to:", oldValue);
            evt.preventDefault();
            revertToPreviousValue();
          } else if (regex.test(newValue)) {
            DEBUG && showDebugInfo("New value passed validation against", regex, newValue);
            updateCurrentValue(newValue);
          } else {
            DEBUG && showDebugInfo("New value did NOT pass validation against", regex, newValue, "Reverting back to:", oldValue);
            evt.preventDefault();
            revertToPreviousValue();
          }

          // make sure the model is consistent with last approach
          // needed even when we don't change what has been input -- see https://github.com/AlphaGit/ng-pattern-restrict/pull/43
          if (ngModelController) {
            scope.$apply(function () {
              ngModelController.$setViewValue(oldValue);
            });
          }
        }

        //-------------------------------------------------------------------
        // setup events
        function bindListeners() {
          if (eventsBound) {
            return;
          }
          iElement.bind('input keyup click', genericEventHandler);
          DEBUG && showDebugInfo("Bound events: input, keyup, click");
        }
        function unbindListeners() {
          if (!eventsBound) {
            return;
          }
          iElement.unbind('input', genericEventHandler);
          //input: HTML5 spec, changes in content

          iElement.unbind('keyup', genericEventHandler);
          //keyup: DOM L3 spec, key released (possibly changing content)

          iElement.unbind('click', genericEventHandler);
          //click: DOM L3 spec, mouse clicked and released (possibly changing content)

          DEBUG && showDebugInfo("Unbound events: input, keyup, click");
          eventsBound = false;
        }

        //-------------------------------------------------------------------
        // initialization
        function readPattern() {
          var entryRegex = iAttrs.inputAcceptableRegexp;
          DEBUG && showDebugInfo("RegEx to use:", entryRegex);
          catchAllregex = /\^?\.\*\$?/.test(entryRegex);
          DEBUG && showDebugInfo("RegEx '" + entryRegex + "'" + (catchAllregex ? "is" : "is not") + " a catch all regex");
          try {
            regex = new RegExp(entryRegex);
          } catch (e) {
            throw "Invalid RegEx string parsed for inputAcceptableRegexp: " + entryRegex;
          }
        }
        function notThrows(testFn, shouldReturnTruthy) {
          try {
            return testFn() || !shouldReturnTruthy;
          } catch (e) {
            return false;
          }
        }
        function detectGetCaretPositionMethods() {
          var input = iElement[0];

          // Chrome will throw on input.selectionStart of input type=number
          // See http://stackoverflow.com/a/21959157/147507
          if (notThrows(function () {
            return input.selectionStart;
          })) {
            getCaretPosition = getCaretPositionWithInputSelectionStart;
          } else {
            // IE 9- will use document.selection
            // TODO support IE 11+ with document.getSelection()
            if (notThrows(function () {
              return document.selection;
            }, true)) {
              getCaretPosition = getCaretPositionWithDocumentSelection;
            } else {
              getCaretPosition = getCaretPositionWithWindowSelection;
            }
          }
        }
        function detectSetCaretPositionMethods() {
          var input = iElement[0];
          if (typeof input.setSelectionRange === 'function') {
            setCaretPosition = setCaretPositionWithSetSelectionRange;
          } else if (typeof input.createTextRange === 'function') {
            setCaretPosition = setCaretPositionWithCreateTextRange;
          } else {
            setCaretPosition = setCaretPositionWithWindowSelection;
          }
        }
        function initialize() {
          if (initialized) {
            return;
          }
          DEBUG && showDebugInfo("Initializing");
          readPattern();
          oldValue = iElement.val();
          if (!oldValue) {
            oldValue = "";
          }
          DEBUG && showDebugInfo("Original value:", oldValue);
          bindListeners();
          detectGetCaretPositionMethods();
          detectSetCaretPositionMethods();
          initialized = true;
        }
        function uninitialize() {
          DEBUG && showDebugInfo("Uninitializing");
          unbindListeners();
        }
        iAttrs.$observe("inputAcceptableRegexp", readPattern);
        scope.$on("$destroy", uninitialize);
        initialize();
      };
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/form/inputTypes/inputAcceptableRegexp.js"))

/***/ }),
/* 2945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("inputFilterRegexp", function () {
  return {
    require: 'ngModel',
    link: function link(scope, element, attrs, modelCtrl) {
      modelCtrl.$parsers.push(function (inputValue) {
        //console.log("attrs" + attrs.inputFilterRegexp)
        //console.log(scope[attrs.inputFilterRegexp]);
        var transformedInput = inputValue.replace(scope[attrs.inputFilterRegexp], "");
        if (transformedInput !== inputValue) {
          //console.log("Modif : '"+ inputValue + "' -> '" + transformedInput + "'");
          modelCtrl.$setViewValue(transformedInput);
          modelCtrl.$render();
        }
        return transformedInput;
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/form/inputTypes/inputFilterRegexp.js"))

/***/ }),
/* 2946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("inputTypeColor", ["$timeout", "tlColors", function ($timeout, tlColors) {
  var colorPalette = [[tlColors.WHITE, '#e9ecf3', '#BEBEBE', '#808080', tlColors.BLACK],
  // greyscales
  [tlColors.NEW_LIGHT_BLUE, tlColors.NEW_BLUE_1, tlColors.NEW_BLUE_2, tlColors.NEW_PURPLE_1, tlColors.NEW_PURPLE_2], [tlColors.NEW_GREEN_1, tlColors.NEW_GREEN_2, tlColors.NEW_GREEN_3, tlColors.NEW_GREEN_4, tlColors.NEW_BLACK_1], [tlColors.DARK_YELLOW, tlColors.NEW_ORANGE_1, tlColors.NEW_ORANGE_2, tlColors.NEW_RED_1, tlColors.NEW_RED_2], [tlColors.FUSCHIA, '#bfd7ff', '#15a3ef', '#322f8f', '#2a2758'],
  // fuschia + blues
  ['#ffc902', '#F48600', '#4DC100', '#bb4040', '#ff31dd'] // some colors from colors.less
  ];
  return {
    restrict: "A",
    require: "ngModel",
    link: function link($scope, $el, $attrs, modelCtrl) {
      $scope.$watch(function () {
        return modelCtrl.$modelValue;
      }, function (modelValue) {
        $el.spectrum("set", modelValue);
      });
      var onShow = function onShow() {
        $timeout(function () {
          $el.trigger("focusin");
        }, 0, false);
      };
      var onChange = function onChange(color) {
        if (modelCtrl.$modelValue !== (color ? color.toHexString() : null)) {
          $scope.$apply(function () {
            modelCtrl.$setViewValue(color ? color.toHexString() : null);
          });
          $timeout(function () {
            $el.trigger("blur");
          }, 20, false);
        }
      };
      var opts = {
        color: modelCtrl.$modelValue,
        show: onShow,
        change: onChange,
        hide: onChange,
        preferredFormat: "hex",
        // todo -i18n - idealement devrait utiliser le fichier de resource de langue, mais pas trouvé comment le faire prendre en charge
        cancelText: "Annuler",
        chooseText: "Valider",
        clearText: "Effacer couleur sélectionnée",
        noColorSelectedText: "Aucune couleur sélectionnée",
        togglePaletteMoreText: "Plus",
        togglePaletteLessText: "Moins",
        theme: "sp-taelys",
        showInput: true,
        showInitial: true,
        allowEmpty: true,
        showPalette: true,
        palette: colorPalette
      };
      $el.spectrum(opts);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/form/inputTypes/inputTypeColor.js"))

/***/ }),
/* 2947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, moment, _, $, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.constant("datepickerDefaultConfig", {
  changeMonth: true,
  changeYear: true,
  dateFormat: "dd/mm/yy",
  yearRange: "c-35:c+35",
  // highlight the day of currently displayed month that matches the selected day, if month/year is not the same
  onChangeMonthYear: function onChangeMonthYear(y, m, i) {
    if (i.currentMonth === m - 1 && i.currentYear === y) {
      return;
    }
    var lastDayOfMonth = moment(new Date(y, m - 1, 1)).endOf("month").get("date"),
      selectedDay = Math.min(i.currentDay, lastDayOfMonth);
    _.defer(function () {
      var datePicker = i.dpDiv,
        cells = datePicker.find("table tbody td");
      var sameDateCell = cells.filter(function (i, el) {
        return $(el).find("a").text().trim() === selectedDay + "";
      });
      sameDateCell.addClass("tl-datepicker-same-date");
    });
  }
});
ngModule.directive('inputTypeDate', ["$dateDisplayFormats", function ($dateDisplayFormats) {
  var validatorName = "validDateFormat";
  return {
    require: 'ngModel',
    link: function link($scope, $el, $attrs, modelCtrl) {
      $el.addClass("input-date");
      var dateFormat = $dateDisplayFormats.SHORT;
      modelCtrl.$formatters.push(function (value) {
        if (value) {
          return moment(value).format(dateFormat);
        }
        return null;
      });
      modelCtrl.$parsers.push(function (value) {
        if (!value) {
          modelCtrl.$setValidity(validatorName, true);
          return null;
        }
        if (_.isDate(value)) {
          modelCtrl.$setValidity(validatorName, true);
          return value;
        } else {
          var m = moment(value, dateFormat);
          var valid = m.isValid();
          modelCtrl.$setValidity(validatorName, valid);
          return valid ? m.toDate() : null;
        }
      });
    }
  };
}]);
ngModule.directive('tlDatepicker', ["datepickerDefaultConfig", function (datepickerDefaultConfig) {
  return {
    require: '?ngModel',
    link: function link($scope, $el, $attrs, modelCtrl) {
      // TODO : no need to extend on every watch, and no need to watch the extend result
      // also check is $attrs.uiDate exists, if not, no need to watch.

      var getOptions = function getOptions() {
        var options = angular.extend({}, datepickerDefaultConfig);
        if ($attrs.tlDatepicker) {
          angular.extend(options, $scope.$eval($attrs.tlDatepicker));
        }
        if ($attrs.datepickerDefaultDate) {
          options.defaultDate = $scope.$eval($attrs.datepickerDefaultDate);
        }
        if ($attrs.yearRange) {
          options.yearRange = $attrs.yearRange;
        }
        if ($attrs.minDate) {
          options.minDate = moment($attrs.minDate, 'YYYY/MM/DD').toDate();
        }
        if ($attrs.maxDate) {
          options.maxDate = moment($attrs.maxDate, 'YYYY/MM/DD').toDate();
        }
        return options;
      };
      var initDateWidget = function initDateWidget(options) {
        // Set the view value in a $apply block when users selects
        var _onSelect = options.onSelect || angular.noop;
        options.onSelect = function (value, picker) {
          $scope.$apply(function () {
            modelCtrl.$setViewValue(value);
            _onSelect(value, picker);
          });
          $el.trigger("blur");
        };
        $el.datepicker('destroy').datepicker(options);
      };

      // Watch for changes to the directives options
      $scope.$watch(getOptions, function (options) {
        initDateWidget(options);
      }, true);
    }
  };
}]);
ngModule.directive('tlDatepickerBtn', function () {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs) {
      // TODO : allow to specify an id or a selector...

      $el.click(function (event) {
        var input = $el.parent().find("input.hasDatepicker");
        if (input.length) {
          input.datepicker("show");
        }
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/form/inputTypes/inputTypeDate.js", __webpack_require__(2), __webpack_require__(1), __webpack_require__(4), __webpack_require__(3)))

/***/ }),
/* 2948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);


var numeral = __webpack_require__(749);

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Enhanced number directive.
 *
 * Currently the input is always done in french local
 *
 * Possible feature attributes :
 *
 * - number-integer : force the input to integer only ( default false )
 * - allow-negative : allow negative numbers in the input ( default false )
 * - integer-count="X"  : the max number of integer chars ( default 10 )
 * - max-decimals="Y"    : the max number of decimal chars (default 10 )
 * - no-thousands-delimiter : do not add a thousand delimiter (space). usefull for exemple for years where the common pattern is YYYY and not Y YYY.
 *
 */
ngModule.directive("inputTypeNumber", ["stringUtils", "numberUtils", "keyCodes", function (stringUtils, numberUtils, keyCodes) {
  var decimalDelimiterKeys = [".", ","];
  var isNumberKey = function isNumberKey(keyCode) {
    return keyCode >= 48 && keyCode <= 57;
  };
  var isDecimalSeparatorChar = function isDecimalSeparatorChar(character) {
    return _.includes(decimalDelimiterKeys, character);
  };
  return {
    restrict: 'A',
    require: "ngModel",
    link: function link($scope, $el, $attrs, modelCtrl) {
      $el.addClass("input-number");
      var maxIntegerCount = 12,
        maxDecimalCount = 2,
        numberFormat = "0,0.[00]",
        // on force la langue en français, mais idealement on devrait savoir faire la saisie dans la langue utilisateur
        decimalDelimiter = ',',
        //numeral.languageData().delimiters.decimal,
        thousandsDelimiter = '',
        //numeral.languageData().delimiters.thousands,
        isIntegerInput = _.has($attrs, "numberInteger"),
        allowNegative = _.has($attrs, "allowNegative"),
        noThousandsDelimiter = _.has($attrs, "noThousandsDelimiter");
      var refreshFormat = function refreshFormat() {
        numberFormat = "";
        if (!noThousandsDelimiter) {
          numberFormat += "0,";
        }
        numberFormat += "0.[" + new Array(maxDecimalCount + 1).join("0") + "]";
      };
      refreshFormat();
      var formatValue = function formatValue(value) {
        if (_.isNumber(value)) {
          value = String(value);
        }
        if (value == null || value.length === 0) {
          return "";
        }
        var cleaned = cleanValue(value),
          splits = cleaned.split(decimalDelimiter),
          integerPart = splits[0],
          decimalPart = splits[1],
          formatted = "",
          offset = integerPart.length % 3;
        for (var i = 0; i < integerPart.length; i++) {
          if (i > 0 && i % 3 === offset) {
            if (!noThousandsDelimiter) {
              formatted += " ";
            }
          }
          formatted += integerPart[i];
        }
        if (decimalPart != null) {
          decimalPart = decimalPart.substring(0, Math.min(maxDecimalCount, decimalPart.length));
          formatted += decimalDelimiter + decimalPart;
        }
        return formatted;
      };
      var cleanValue = function cleanValue(value) {
        return numberUtils.cleanNumberString(value);
      };
      if (_.has($attrs, "integerCount")) {
        $attrs.$observe("integerCount", function (integerCount) {
          if (integerCount) {
            maxIntegerCount = parseInt(integerCount);
            refreshFormat();
            if (modelCtrl.$modelValue) {
              // a this stage, value is a numeric, need to convert it to string for formatValue
              modelCtrl.$viewValue = formatValue("" + modelCtrl.$modelValue);
            }
            modelCtrl.$render();
          }
        });
      }
      if (_.has($attrs, "maxDecimals")) {
        $attrs.$observe("maxDecimals", function (maxDecimal) {
          if (maxDecimal) {
            maxDecimalCount = parseInt(maxDecimal);
            refreshFormat();
            if (modelCtrl.$modelValue) {
              // a this stage, value is a numeric, need to convert it to string for formatValue
              modelCtrl.$viewValue = formatValue("" + modelCtrl.$modelValue);
            }
            modelCtrl.$render();
          }
        });
      }
      modelCtrl.$formatters.push(function (value) {
        return formatValue(value);
        //return value != null ? numeral(value).format(numberFormat) : "";
      });
      modelCtrl.$parsers.push(function (value) {
        if (value == null || value === "") {
          return null;
        }
        value = value.replace(/[.]/g, ","); // TODO : generify with delimiters
        var currentLangage = numeral.language();
        // impossible de changer la langue 'localement'... donc on change et on remet
        numeral.language('fr');
        try {
          return numeral().unformat(value);
        } finally {
          numeral.language(currentLangage);
        }
      });
      var sanitizeInput = function sanitizeInput() {
        var inputValue = $el.val(),
          formatted = formatValue(inputValue);
        var sanitized;
        if (formatted) {
          var currentLangage = numeral.language();

          // impossible de changer la langue 'localement'... donc on change et on remet
          numeral.language('fr');
          try {
            sanitized = numeral(formatted).format(numberFormat);
          } finally {
            numeral.language(currentLangage);
          }
        } else {
          sanitized = "";
        }
        if (sanitized !== inputValue) {
          setViewValue(sanitized);
        }
      };
      var setViewValue = function setViewValue(value) {
        var viewValue = formatValue(value);

        // TAEL-4162 $apply already : inputTypeNumber.js - on a testé $applyAsync - mais ne marche pas bien, on perd le bon positionnement du caret, qui se remet toujours à la fin
        $scope.$apply(function () {
          modelCtrl.$setViewValue(viewValue);
          modelCtrl.$render();
        });
      };
      $el.on("input", sanitizeInput);
      $el.on("blur", sanitizeInput);
      $el.on("paste", function (event) {
        var paste = event.originalEvent.clipboardData.getData("text");

        // protège le past "à virugle" sur un champs entier
        if (isIntegerInput && paste) for (var i = 0; i < decimalDelimiterKeys.length; i++) {
          if (paste.indexOf(decimalDelimiterKeys[i]) !== -1) {
            // bloque le paste
            event.preventDefault();
          }
        }
      });
      $el.on("keydown", function (event) {
        var modelValue = modelCtrl.$modelValue || 0;
        var keyCode = event.which;
        switch (keyCode) {
          // K
          case 75:
            {
              event.preventDefault();
              if (modelValue === 0) {
                modelValue = 1;
              }
              setViewValue(modelValue * 1000);
              return;
            }
          // M
          case 77:
            {
              event.preventDefault();
              if (modelValue === 0) {
                modelValue = 1;
              }
              setViewValue(modelValue * 1000000);
              return;
            }
          case keyCodes.UP:
            {
              event.preventDefault();
              if (event.shiftKey) {
                if (modelValue === 0) {
                  modelValue = 1;
                }
                setViewValue(modelValue * 10);
              } else {
                var amount = event.ctrlKey ? 100 : event.altKey ? 1000 : 1;
                setViewValue(modelValue + amount);
              }
              return;
            }
          case keyCodes.DOWN:
            {
              event.preventDefault();
              if (event.shiftKey) {
                if (modelValue === 0) {
                  modelValue = 1;
                }
                setViewValue(modelValue / 10);
              } else {
                var _amount = event.ctrlKey ? 100 : event.shiftKey ? 1000 : 1;
                setViewValue(modelValue - _amount);
              }
              return;
            }
          case keyCodes.BACKSPACE:
            {
              event.preventDefault();
              var inputValue = $el.val();
              var selection = $el.getSelection();
              if (selection.start === 0 && selection.length === 0) {
                return;
              }
              if (selection.length > 0) {
                var newValue = inputValue.substring(0, selection.start) + inputValue.substring(selection.end, inputValue.length);
                setViewValue(newValue);
                $el.caret(selection.start, selection.start);
              } else {
                var nbRemove = 1;
                var erasedChar = inputValue.substring(selection.start - 1, selection.end);
                if (erasedChar === thousandsDelimiter) {
                  nbRemove = 2;
                }
                var _newValue = inputValue.substring(0, selection.start - nbRemove) + inputValue.substring(selection.end, inputValue.length);
                setViewValue(_newValue);
                $el.caret(selection.start - nbRemove, selection.start - nbRemove);
              }
              return;
            }
          case keyCodes.DELETE:
            {
              event.preventDefault();
              var _inputValue = $el.val();
              var _selection = $el.getSelection();
              if (_selection.length > 0) {
                var _newValue2 = _inputValue.substring(0, _selection.start) + _inputValue.substring(_selection.end, _inputValue.length);
                setViewValue(_newValue2);
                $el.caret(_selection.start, _selection.start);
              } else {
                var _erasedChar = _inputValue.substring(_selection.start, _selection.end + 1);
                var _newValue3 = _inputValue.substring(0, _selection.start) + _inputValue.substring(_selection.end + 1, _inputValue.length);
                setViewValue(_newValue3);
                if (_erasedChar === thousandsDelimiter) {
                  $el.caret(_selection.start + 1, _selection.start + 1);
                } else {
                  $el.caret(_selection.start, _selection.start);
                }
              }
              return;
            }
        }
      });
      $el.on("keypress", function (event) {
        if (event.which === keyCodes.ENTER) {
          sanitizeInput();
          return;
        }
        if (event.keyCode === keyCodes.TAB) {
          return; // required for FF...
        }
        event.preventDefault();
        var pressedCharCode = event.which,
          pressedChar = String.fromCharCode(pressedCharCode),
          oldInputValue = $el.val(),
          selection = $el.getSelection(),
          newInputValue = null;
        if (isNumberKey(pressedCharCode)) {
          newInputValue = oldInputValue.substring(0, selection.start) + pressedChar + oldInputValue.substring(selection.end, oldInputValue.length);

          // assert that we're not typing more than the maximum allowed character count.
          var delimiterIdx = oldInputValue.indexOf(decimalDelimiter),
            hasDecimal = delimiterIdx > -1,
            isTypingInteger = hasDecimal ? selection.start <= delimiterIdx : true,
            cleanedValueSplits = cleanValue(newInputValue).split(decimalDelimiter);
          if (isTypingInteger) {
            var integerPart = cleanedValueSplits[0];
            if (integerPart.length > maxIntegerCount) {
              return;
            }
          } else {
            var decimalPart = cleanedValueSplits[1];
            if (decimalPart.length > maxDecimalCount) {
              return;
            }
          }
          var occurencyCount = stringUtils.countCharOccurencies(oldInputValue.substring(0, selection.start), pressedChar);
          setViewValue(newInputValue);
          var charPosition = stringUtils.xIndexOf(pressedChar, $el.val(), occurencyCount + 1) + 1;
          if (charPosition === 0) {
            charPosition = $el.val().length;
          }
          $el.caret(charPosition, charPosition);
        } else if (allowNegative && pressedChar === "-") {
          if (selection.start > 0) {
            return;
          }
          newInputValue = "-" + oldInputValue.substring(selection.end, oldInputValue.length);
          setViewValue(newInputValue);
        } else if (!isIntegerInput && isDecimalSeparatorChar(pressedChar)) {
          // decimals separator
          // already have decimal separator
          if (oldInputValue.indexOf(decimalDelimiter) > -1) {
            return;
          }

          // TODO : only act if selection end is end of input

          newInputValue = oldInputValue.substring(0, selection.start) + decimalDelimiter + oldInputValue.substring(selection.end, oldInputValue.length);
          setViewValue(newInputValue);
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/form/inputTypes/inputTypeNumber.js", __webpack_require__(1)))

/***/ }),
/* 2949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Attention, le tlLiveForm ne surveille que les interactions directes utilisateur, mais pas les changements fait sur le model
 */
ngModule.directive("tlLiveForm", ["$parse", "$timeout", function ($parse, $timeout) {
  return {
    restrict: "A",
    controller: ["$scope", function controller($scope) {
      var ctrl = this,
        handler = null;
      ctrl.setHandler = function (_handler) {
        handler = _handler;
      };
      ctrl.notifyFieldChange = function () {
        handler && handler();
      };
    }],
    link: function link($scope, $el, $attrs, ctrl) {
      if ($attrs.tlLiveForm) {
        var formHandler = $parse($attrs.tlLiveForm);
        var executeHandler = function executeHandler() {
          return formHandler($scope);
        };
        ctrl.setHandler(executeHandler);
      }
      var bindDelegateEvents = function bindDelegateEvents() {
        var prevFocusInputValue = null;
        var onInputFocus = function onInputFocus(event) {
          var input = $(event.currentTarget);
          prevFocusInputValue = input.val();
        };
        var onInputBlur = function onInputBlur(event) {
          var input = $(event.currentTarget);
          var inputValue = input.val();
          if (inputValue !== prevFocusInputValue) {
            $scope.$apply(function () {
              ctrl.notifyFieldChange();
            });
            prevFocusInputValue = inputValue;
          }
        };
        var onInputKeypress = function onInputKeypress(event) {
          if (event.which === 13) {
            var input = $(event.currentTarget);
            prevFocusInputValue = input.val();
            $scope.$apply(function () {
              ctrl.notifyFieldChange();
            });
          }
        };
        var onSelectChange = function onSelectChange(event) {
          // seems not to work when el is select without the defer...
          $timeout(function () {
            ctrl.notifyFieldChange();
          }, 0);
        };
        $el.delegate("input:not([type=radio], [type=checkbox])", "focusin", onInputFocus);
        $el.delegate("input:not([type=radio], [type=checkbox])", "focusout", onInputBlur);
        $el.delegate("input:not([type=radio], [type=checkbox])", "keypress", onInputKeypress);
        $el.delegate(".tl-select, .tl-checkbox, select, input[type=checkbox], input[type=radio]", "change", onSelectChange);
      };
      bindDelegateEvents();
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/form/liveForm.js", __webpack_require__(4)))

/***/ }),
/* 2950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlSearchField", ["$http", "$compile", "$debounce", "$timeout", "$q", "keyCodes", "objectUtils", function ($http, $compile, $debounce, $timeout, $q, keyCodes, objectUtils) {
  var defaultConfig = {
    searchUrl: null,
    searchParameter: "q",
    labelAttribute: "id",
    /**
     * permet de définir une valeur par défaut : indique un champs present dans le scope
     */
    stickToValue: null,
    minLength: null,
    resultTemplate: '<span>{{result.id || "must config resultTemplate"}}</span>'
  };
  return {
    restrict: "E",
    scope: true,
    replace: true,
    template: __webpack_require__(3730),
    controllerAs: "searchFieldCtrl",
    link: function link($scope, $el, $attrs, ctrl) {
      var configName = $attrs.config;
      var unwatch = $scope.$watch(configName, function (config) {
        if (config != null) {
          unwatch();
          ctrl.initialize(config);
        }
      });
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        input = $element.find("input"),
        config = null,
        blurTimeout = null,
        requestCanceler = null,
        resultLinkFn = null;
      ctrl.initialize = function (_config) {
        config = _.extend({}, defaultConfig, _config);
        resultLinkFn = $compile(config.resultTemplate);
        input.on("input", function () {
          debouncedHandler($.trim(input.val()));
        });
        if (config.stickToValue != null) {
          $scope.$watch(config.stickToValue, function (value) {
            if (value) {
              $scope.search.q = value;
            }
          });
        }
        if (config.minLength != null) {
          $scope.search.minLength = config.minLength;
        } else {
          $scope.search.minLength = 2;
        }
      };
      ctrl.getResultLink = function () {
        return resultLinkFn;
      };
      $scope.search = {
        q: ""
      };
      $scope.results = [];
      $scope.selected = null;
      $scope.loadingResults = false;
      $scope.active = false;
      var cancelBlurTimeout = function cancelBlurTimeout() {
        if (blurTimeout) {
          $timeout.cancel(blurTimeout);
          blurTimeout = false;
        }
      };
      var setActive = function setActive() {
        cancelBlurTimeout();
        $scope.active = true;
      };
      var setInactive = function setInactive() {
        $scope.active = false;
      };
      $scope.onFocus = function () {
        if ($scope.search.q.length >= $scope.search.minLength) {
          setActive();
        }
      };
      $scope.setActiveItem = function (itemIdx) {
        $scope.selected = itemIdx;
      };
      $scope.onBlur = function () {
        $timeout(function () {
          $scope.active = false;
        }, 250);
      };
      $scope.onKeyDown = function (event) {
        var keyCode = event.which;
        switch (keyCode) {
          case keyCodes.UP:
            {
              if ($scope.selected != null) {
                $scope.selected -= 1;
                if ($scope.selected < 0) {
                  $scope.selected = null;
                }
              }
              event.preventDefault();
              break;
            }
          case keyCodes.DOWN:
            {
              if ($scope.selected == null) {
                $scope.selected = 0;
              } else {
                $scope.selected++;
              }
              event.preventDefault();
              break;
            }
          case keyCodes.ENTER:
            {
              if ($scope.results.length === 0) {
                return;
              }
              var selectedIdx = $scope.results.length === 1 ? 0 : $scope.selected;
              if (selectedIdx != null) {
                $scope.onResultClick($scope.results[selectedIdx]);
                setInactive();
              }
              event.preventDefault();
              break;
            }
          case keyCodes.ESCAPE:
            {
              setInactive();
              event.preventDefault();
              break;
            }
        }
      };
      $scope.onResultClick = function (result) {
        $scope.search.q = objectUtils.getProperty(result, config.labelAttribute);
        config.onSelect(result);
      };
      var performSearch = function performSearch(query) {
        if (requestCanceler) {
          requestCanceler();
        }
        var searchPromise;
        if (config.searchUrl) {
          var deferredCancel = $q.defer();
          requestCanceler = function requestCanceler() {
            deferredCancel.resolve();
          };
          var params = {};
          if (config.extraParams) {
            params = _.extend(params, $scope[config.extraParams]);
          }
          params[config.searchParameter] = query;
          searchPromise = $http.get(config.searchUrl, {
            params: params,
            timeout: deferredCancel.promise
          }).then(function (response) {
            return response.data;
          });
        } else {
          searchPromise = config.searchMethod(query, requestCanceler);
          requestCanceler = searchPromise.cancel;
        }
        $q.when(searchPromise).then(function (results) {
          $scope.loadingResults = false;
          $scope.selected = null;
          $scope.results = results;
          requestCanceler = null;
        });
      };
      var refreshSuggestions = function refreshSuggestions(query) {
        setActive();
        $scope.loadingResults = true;
        performSearch(query);
      };
      var debouncedHandler = $debounce(function (search) {
        var q = search || "";
        if (q.length < $scope.search.minLength) {
          $scope.results = [];
          return;
        }
        refreshSuggestions(search);
      }, 250);
    }]
  };
}]);
ngModule.directive("tlSearchFieldResult", function () {
  return {
    restrict: "A",
    scope: true,
    require: "^tlSearchField",
    link: function link($scope, $el, $attrs, ctrl) {
      var linkFn = ctrl.getResultLink();
      linkFn($scope, function (clone) {
        clone.appendTo($el);
      });
    }
  };
});
ngModule.filter("underlineSearchResultMatch", function () {
  return function searchResultUnderlineFilter(value, term) {
    if (term == null || !term.length) {
      return value;
    }
    var termRegexp = new RegExp(term.replace(/[.()\[\]]/g, "").replace(/[- ]/g, "[- ]"), "i"),
      regexpMatch = termRegexp.exec(value);
    if (regexpMatch == null) {
      return value;
    }
    var matchIndex = regexpMatch.index,
      matchLength = regexpMatch[0].length;
    var prefix = value.substring(0, matchIndex),
      highlight = value.substr(matchIndex, matchLength),
      suffix = value.substring(matchIndex + matchLength);
    return "<span>" + prefix + "</span>" + "<span class='b'>" + highlight + "</span>" + "<span>" + suffix + "</span>";
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/form/searchField/tlSearchField.js", __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 2951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * FieldSet with a legend label.
 *
 * peut ontenir un <tl-field-tooltip>
 */
ngModule.directive("tlField", function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: false,
    template: '<div class="tl-field" ng-transclude></div>',
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        tooltipCtrl = null;
      ctrl.getInputElements = function () {
        var inlineCheckbox = $element.find("label.has-cb, .tl-checkbox");
        return inlineCheckbox.length ? inlineCheckbox : $element.find("input, select, .tl-select, .tl-input-wrapper");
      };
      ctrl.setTooltipCtrl = function (_tooltipCtrl) {
        tooltipCtrl = _tooltipCtrl;
        tooltipCtrl.bindTooltip();
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/form/tlField.js"))

/***/ }),
/* 2952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Input / Select Tooltip Info Box inside a tlField directive
 */
ngModule.directive("tlFieldTooltip", function () {
  return {
    restrict: "E",
    scope: true,
    transclude: true,
    require: ["tlFieldTooltip", "^tlField"],
    replace: true,
    template: '<div class="tl-field-tooltip"></div>',
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        fieldCtrl = null,
        transcludeFn = null,
        tooltipContent = null,
        tooltipScope = null;
      ctrl.setTranscludeFn = function (_transcludeFn) {
        transcludeFn = _transcludeFn;
      };
      ctrl.setFieldCtrl = function (_fieldCtrl) {
        fieldCtrl = _fieldCtrl;
      };
      ctrl.unbindTooltip = function () {
        var inputs = fieldCtrl.getInputElements();
        inputs.qtip("destroy", true);
        if (tooltipScope) {
          tooltipScope.$destroy();
          tooltipScope = null;
          tooltipContent.remove();
          tooltipContent = null;
        }
      };
      ctrl.bindTooltip = function () {
        ctrl.unbindTooltip();
        tooltipScope = $scope.$new();
        tooltipContent = $("<div>");
        transcludeFn(tooltipScope, function (clone) {
          clone.appendTo(tooltipContent);
        });
        var inputs = fieldCtrl.getInputElements().first();
        _.defer(function () {
          // the defer is required to attach to re-compiled directives (tl-input-wrapper)
          var tooltipPosition = {
            container: $element.closest(".main-container"),
            my: 'middle left',
            at: 'middle right',
            adjust: {
              x: 3
            },
            viewport: $(window)
          };
          if ($scope.tlTooltipPosition === 'bottom') {
            tooltipPosition = {
              container: $element.closest(".main-container"),
              my: 'top center',
              at: 'bottom center',
              adjust: {
                y: 8
              },
              viewport: $(window)
            };
          }
          inputs.qtip({
            content: {
              text: tooltipContent
            },
            show: {
              delay: 450
            },
            position: tooltipPosition,
            style: {
              classes: 'qtip-info'
            }
          });
        });
      };
    }],
    link: function link($scope, $el, $attrs, controllers, transcludeFn) {
      $el.hide();
      if ($attrs.tlTooltipPosition) {
        $scope.tlTooltipPosition = $attrs.tlTooltipPosition;
      }
      var ctrl = controllers[0];
      var fieldCtrl = controllers[1];
      ctrl.setTranscludeFn(transcludeFn);
      ctrl.setFieldCtrl(fieldCtrl);
      fieldCtrl.setTooltipCtrl(ctrl);
      $scope.$on("$destroy", function () {
        ctrl.unbindTooltip();
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/form/tlFieldTooltip.js", __webpack_require__(4), __webpack_require__(1)))

/***/ }),
/* 2953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Toggleable form details (only for panel forms)
 * @param showFlag : si true : ajout d'un flag devant le texte
 * @param showLabelKey/hideLabelKey : clés de message
 */
ngModule.directive("tlFormDetails", ["$translate", function ($translate) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      showLabelKey: "@",
      hideLabelKey: "@",
      showLabel: "@",
      hideLabel: "@",
      showFlag: "="
    },
    template: '' + '<div class="tl-form-details" ng-class="{opened : state.opened}">' + '   <a href ng-switch="state.opened"  class="tl-form-detail-link" ng-click="toggle()">' + ' <i ng-if="showFlag" class="mr-s fa fa-eye icon-flag"></i>' + '       <span ng-switch-when="true">{{hideText}}</span>' + '       <span ng-switch-default>{{showText}}</span>' + '   </a>' + '   <div ng-show="state.opened" class="tl-form-details-content" ng-transclude></div>' + '</div>',
    controller: ["$scope", function controller($scope) {
      var ctrl = this;
      var state = $scope.state = {
        opened: false
      };
      ctrl.open = function () {
        state.opened = true;
      };
      ctrl.close = function () {
        state.opened = false;
      };
    }],
    link: function link($scope, $el, $attrs) {
      $scope.showText = $scope.showLabel || $translate($scope.showLabelKey || "saisie.formDetails.show");
      $scope.hideText = $scope.hideLabel || $translate($scope.hideLabelKey || "saisie.formDetails.hide");
      $scope.toggle = function () {
        $scope.state.opened = !$scope.state.opened;
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/form/tlFormDetails.js"))

/***/ }),
/* 2954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);




var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);

/**
 * repose sur une configuration :<br/>
 * data : indique l'objet qui porte les données du formulaire.<br/>
 * customValidation : permet de faire des validations coté front<br/>
 * onError : fonction appellée si une validation est en erreur,
 * onSucces :
 * url : permet de fournir l'url qui traitera la data en soumission
 * beforeSend : methode qui peut traiter la data avant l'envoie (pour modifier des champs calculés par exemple)
 *
 * A la soumission des data, vous pouvez tester $scope.submitting pour savoir si l'envoi est en cours (par afficher un tl-circular-loader par exemple). Si une soumission est en cours, une autre ne peut avoir lieu.
 */
ngModule.directive("tlValidatedForm", ["$http", "$debounce", "objectUtils", "fieldUtils", "$q", "$rootScope", function ($http, $debounce, objectUtils, fieldUtils, $q, $rootScope) {
  return {
    restrict: "A",
    require: ["tlValidatedForm", "form"],
    scope: true,
    controllerAs: '$tlValidatedFormCtrl',
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0];
      $scope.$watch($attrs.tlValidatedForm, function (formConfig) {
        if (!formConfig) {
          return;
        }
        ctrl.setConfig(formConfig);
      });
      $el.submit(function () {
        $scope.$apply(function () {
          ctrl.submitForm();
        });
      });
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        config = null,
        // todo - $scope.submitting et submitting font doublon, a retravailler.
        submitting = false,
        submitted = false,
        done = false,
        fields = {},
        errors = [],
        warns = [],
        // errors with no field name
        globalErrors = [],
        globalWarns = [];
      ctrl.setConfig = function (_config) {
        // TODO: rename to initialize
        config = _config;
        fieldUtils.delegateFieldChange($element, function () {
          // tester $scope.$applyAsync pour résoudre les Error : [$rootScope:inprog] $apply already in progress que nous avons régulièrement ici
          $scope.$applyAsync(function () {
            performClientSideValidation();
          });
        });
      };

      // met à jour l'état suite à une demande de validation externe
      $rootScope.$on("tlValidatedField:validate", function () {
        console.log("receive tlValidatedField:validate");
        performClientSideValidation();
      });
      var getFormData = function getFormData() {
        if (config == null) {
          return null;
        }
        return _.isString(config.data) ? $scope[config.data] : _.isFunction(config.data) ? config.data() : config.data;
      };

      /**
       *
       * @returns {[]} un tableau avec les erreurs au format {
                          fieldName: fieldName,
                          type: 'required',
                          message: 'Champs requis',
                      }.
       Test pour cela les champs avec tl-required, puis passe à customValidation
        */
      var computeValidationErrors = function computeValidationErrors() {
        var data = getFormData();
        var errors = [];
        var validateField = function validateField(field) {
          var fieldName = field.name;

          // l'attribut de data qui permet d'accéder à la donnée (à utiliser si on a fourni un fieldPrefix dans la config et que le fieldName ne permet donc pas d'accéder à l'attribut)
          var fieldAttribute = field.controller.getFieldAttribute();
          var validation = field.controller.getValidation();
          if (validation.required && !validation.virtual) {
            // ATTENTION, l'utilisation directe du fieldName ne marche que si le champs à un tl-validated-field non composé (pas de chemin jusqu'au champs) - sinon obligé d'utiliser un tl-field-attribute qui donne exactement l'attibut du model
            var fieldData = _.get(data, fieldAttribute || fieldName);
            console.log('check has data for fieldName = ' + fieldName, field);
            console.log("data", data);
            console.log("field data (resultat du get data." + (fieldAttribute || fieldName) + ")", fieldData, fieldAttribute || fieldName);
            var hasNoData = _.isArray(fieldData) ? fieldData.length === 0 : fieldData == null || _.isString(fieldData) && fieldData.length === 0;
            if (hasNoData) {
              if (!config) {
                console.log('No config');
                return;
              }
              // on doit retirer le fieldPrefix de fieldName car il est rajouté dans la partie affichage
              if (config.fieldPrefix) {
                if (fieldName.indexOf(config.fieldPrefix) !== -1) {
                  fieldName = fieldName.substring(config.fieldPrefix.length);
                }
              }
              errors.push({
                fieldName: fieldName,
                type: 'required',
                message: 'Champs requis'
              });
              console.log('Erreur added. List of errors :', errors);
            }
          }
        };
        _.each(fields, validateField);
        if (config && config.frontValidation) {
          // retro-compat, ancien nom
          console.warn("Migration : Use 'customValidation' instead of 'frontValidation'");
          errors = [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(errors), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(config.frontValidation()));
        }
        if (config && config.customValidation) {
          // nouveau nom
          errors = [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(errors), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(config.customValidation()));
        }
        return errors;
      };
      var performClientSideValidation = function performClientSideValidation() {
        ctrl.hideErrors();
        var errors = computeValidationErrors();
        if (errors.length > 0) {
          ctrl.showErrors(errors);
        }
        return errors;
      };
      var applyServerSideValidation = function applyServerSideValidation(validation) {
        var errors = validation.errors,
          warns = validation.warns;
        // TODO
      };
      ctrl.submitForm = function () {
        submitted = true;
        if (submitting || done) {
          console.log('soumission du formulaire déjà en cours');
          return;
        }
        if ($scope.submitting) {
          // soumission dejà en cours
          console.log("submission déjà en cours... ne ressoumet pas");
          return;
        }

        // client validation before posting
        var errors = performClientSideValidation();
        if (errors.length > 0) {
          config.onError && config.onError(errors);
          return;
        }
        var data = getFormData();
        var url = _.result(config, "url");
        if (config.beforeSend) {
          config.beforeSend(data);
        }

        /**
         * permet d'inquer une promise appellée avant la soumission (ex: message de confirmation)
         * @returns {*}
         */
        var beforePromiseAsync = function beforePromiseAsync(data) {
          var defered = $q.defer();
          if (!config.beforeSendAsync) {
            // promise vide
            return $q.resolve();
          } else {
            return config.beforeSendAsync(data);
          }
        };
        beforePromiseAsync(data).then(function () {
          $scope.submitting = true;
          $http.post(url, data).then(function (response) {
            var validation = response.data;
            if (validation == null || validation === "") {
              console.error('pas de response.data fourni par la resource pour', url, data, response);
            } else {
              if (validation.valid === null) {
                console.error('pas de response.data.valid fourni par la resource pour', url, data, response);
              }
            }
            ctrl.hideErrors();
            if (validation.valid) {
              config.onSuccess && config.onSuccess(validation.result);
              if (!config.allowResubmit) {
                done = true;
              }
            } else {
              ctrl.showErrors(validation.errors);
              ctrl.showWarns(validation.warns);
              config.onError && config.onError(validation.errors);
            }
            $scope.submitting = false;
          }, function (error) {
            $scope.submitting = false;
          });
        });
      };
      ctrl.hideErrors = function () {
        errors = [];
        globalErrors = [];
        _.each(fields, function (field, fieldName) {
          field.error = null;
        });
      };
      ctrl.hideWarns = function () {
        warns = [];
        globalWarns = [];
        _.each(fields, function (field, fieldName) {
          field.warn = null;
        });
      };
      ctrl.isSubmitting = function () {
        return submitting;
      };
      ctrl.isSubmitted = function () {
        return submitted;
      };
      ctrl.showErrors = function (_errors) {
        errors = _errors;
        _.each(errors, function (error) {
          if (error.fieldName == null) {
            globalErrors.push(error);
          } else {
            var fieldName = (config.fieldPrefix || "") + error.fieldName;
            if (fields[fieldName]) {
              fields[fieldName].error = error;
            } else {
              console.debug('Cannot find field ' + fieldName + ' in fields', fields);
            }
          }
        });
      };
      ctrl.showWarns = function (_warns) {
        warns = _warns;
        _.each(warns, function (warn) {
          if (warn.fieldName == null) {
            globalErrors.push(warn);
          } else {
            var fieldName = (config.fieldPrefix || "") + warn.fieldName;
            if (fields[fieldName]) {
              fields[fieldName].warn = warn;
            }
          }
        });
      };
      var delayedClientValidation = $debounce(performClientSideValidation, 50);
      ctrl.registerField = function (fieldName, fieldController) {
        fields[fieldName] = {
          name: fieldName,
          controller: fieldController,
          error: null,
          warn: null
        };
        delayedClientValidation();
        return fields[fieldName];
      };
      ctrl.unregisterField = function (fieldName) {
        delete fields[fieldName];
        delayedClientValidation();
      };
      ctrl.globalErrors = function () {
        return globalErrors;
      };
      ctrl.globalWarns = function () {
        return globalWarns;
      };
    }]
  };
}]);

/**
 * Necessite d'avoir en parent un form avec tlValidatedForm<br/>
 * directive à placer sur chaque champs d'input qui necessite une validation (champs : input, select, textarea, .tl-checkbox, .tl-select, .tl-select-kind-field)<br/>
 * tlValidatedField : le nom fourni est celui du champs à valider en entier au sein de l'objet.<br/>
 * tlFieldAttribute : permet de donner l'attribut accesseur sur data si tlValidatedField ne le permet pas directement (forme x.y.z)
 * ajouter un tlRequired, pour rendre le champs obligatoire (validation front). Vous pouvez également mettre un 'tlValidatedFieldCheckIcon' sur l'element qui montrera le caractère obligatoire et l'état.
 */
ngModule.directive("tlValidatedField", ["$translate", "fieldUtils", "$rootScope", function ($translate, fieldUtils, $rootScope) {
  // .tl-validated-input permet de définir directement un champs "custom" qui recevra la tooltip d'erreur et la couleur d'erreur
  var inputSelector = ".tl-validated-input, input, select, textarea, .tl-checkbox, .tl-select, .tl-select-kind-field";
  return {
    restrict: "A",
    require: ["tlValidatedField", "^tlValidatedForm"],
    scope: true,
    link: function link($scope, $el, $attrs, controllers) {
      var fieldController = controllers[0],
        formController = controllers[1];
      fieldController.initialize(formController);
    },
    controller: ["$scope", "$element", "$attrs", function controller($scope, $element, $attrs) {
      var ctrl = this;
      var state = {
        valid: true,
        untouched: true,
        error: null,
        warning: null
      };
      ctrl.initialize = function (formController) {
        var fieldName = $attrs.tlValidatedField;
        var field = formController.registerField(fieldName, ctrl);
        console.log('initializing ' + fieldName, field);

        // met à jour l'état suite à une demande de validation externe, pour que le untouched passe à false et que le champs soit du coup bien revalidé
        $rootScope.$on("tlValidatedField:validate", function () {
          // le champs doit etre vu comme ayant été "touché"
          state.untouched = false;
          applyState();
        });
        $scope.$watch(function () {
          return {
            error: field.error,
            warning: field.warn,
            submitted: formController.isSubmitted()
          };
        }, function (_ref) {
          var error = _ref.error,
            warning = _ref.warning,
            submitted = _ref.submitted;
          state.error = error;
          state.warning = warning;
          state.valid = !error && !warning;
          if (submitted) {
            state.untouched = false;
          }
          applyState();
        }, true);
        fieldUtils.delegateFieldBlur($element, function () {
          // tester $scope.$applyAsync pour résoudre les Error : [$rootScope:inprog] $apply already in progress que nous avons régulièrement ici
          $scope.$applyAsync(function () {
            state.untouched = false;
            applyState();
          });
        });
        $scope.$on("$destroy", function () {
          formController.unregisterField(fieldName);
        });
      };
      var isRequired = function isRequired() {
        return _.has($attrs, 'tlRequired') && $attrs.tlRequired !== 'false';
      };
      var isVirtual = function isVirtual() {
        return _.has($attrs, 'tlVirtual') && $attrs.tlVirtual !== 'false';
      };

      /**
       * attribut qui peut etre appelé directement sur la data pour récupérer sa valeur peut etre de la forme x.y.z
       * @returns {*}
       */
      ctrl.getFieldAttribute = function () {
        return $attrs.tlFieldAttribute;
      };
      ctrl.getFieldName = function () {
        return $attrs.tlValidatedField;
      };

      /** Retrieve the inline (from dom) validation of the field */
      ctrl.getValidation = function () {
        return {
          required: isRequired(),
          virtual: isVirtual()
        };
      };

      /** Returns true if the field is valid, false otherwise */
      ctrl.isValid = function () {
        return state.valid;
      };
      /** Returns true if the field is valid, false otherwise */
      ctrl.isUntouched = function () {
        return state.untouched;
      };
      /** Returns true if the field is required, false otherwise */
      ctrl.isRequired = function () {
        return isRequired();
      };
      var applyState = function applyState() {
        hideError();
        hideWarn();
        if (state.error && !state.untouched) {
          showError(state.error);
        }
        if (state.warning && !state.untouched) {
          showWarn(state.warning);
        }
      };
      var showError = function showError(error) {
        $element.addClass("has-error");
        var input = $element.find(inputSelector).first();
        // scroll si nécessaire pour rendre visible le champs
        if (!isInViewport(input[0])) {
          input[0].scrollIntoView({
            block: "start",
            inline: "nearest",
            behavior: "smooth"
          });
        }
        input.qtip({
          content: {
            text: error.message || $translate(error.messageKey, error.params)
          },
          position: {
            container: $element.closest("form"),
            my: 'middle left',
            at: 'middle right',
            adjust: {
              x: 3
            }
          },
          style: {
            classes: 'qtip-error'
          }
        });
      };
      function isInViewport(element) {
        var rect = element.getBoundingClientRect();
        return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
      }
      var hideError = function hideError() {
        $element.removeClass("has-error");
        var input = $element.find(inputSelector);
        input.qtip("destroy", true);
      };
      var showWarn = function showWarn(warn) {
        $element.addClass("has-warn");
        var input = $element.find(inputSelector);
        input.qtip({
          content: {
            text: warn.message || $translate(warn.messageKey, error.params)
          },
          position: {
            container: $element.closest("form"),
            my: 'middle left',
            at: 'middle right',
            adjust: {
              x: 3
            }
          },
          style: {
            classes: 'qtip-warn'
          }
        });
      };
      var hideWarn = function hideWarn() {
        $element.removeClass("has-warn");
        var input = $element.find("input, select, textarea, .tl-checkbox");
        input.qtip("destroy", true);
      };
    }]
  };
}]);

/**
 * Pour montrer l'état de validation
 */
ngModule.directive("tlValidatedFieldCheckIcon", function () {
  return {
    restrict: "E",
    require: "^tlValidatedField",
    replace: true,
    scope: {},
    template: "<i tl-tooltip ng-show=\"state !== 'hidden' \" class=\"tl-field-check-icon {{getIconClass()}}\"></i>",
    link: function link($scope, $el, $attrs, fieldController) {
      $scope.state = 'hidden'; // hidden | required | valid | error

      $scope.getIconClass = function () {
        switch ($scope.state) {
          case 'required':
            return 'fas fa-asterisk required';
          case 'valid':
            return 'fas fa-check valid';
          case 'error':
            return 'fad fa-exclamation-triangle error';
          default:
            return '';
        }
      };
      $scope.getFieldName = function () {
        return fieldController.getFieldName();
      };
      $scope.$watch(function () {
        return {
          valid: fieldController.isValid(),
          untouched: fieldController.isUntouched(),
          required: fieldController.isRequired()
        };
      }, function (_ref2) {
        var valid = _ref2.valid,
          untouched = _ref2.untouched,
          required = _ref2.required;
        if (required) {
          if (valid) {
            $scope.state = 'valid';
          } else {
            $scope.state = untouched ? 'required' : 'error';
          }
        } else {
          $scope.state = !valid ? 'error' : 'hidden';
        }
        $scope.untouched = untouched;
      }, true);
    }
  };
});

/**
 * Permet d'afficher les erreurs sans champs indiqué.
 */
ngModule.directive("tlValidatedGlobalErrors", ["$translate", function ($translate) {
  return {
    restrict: "A",
    require: "^tlValidatedForm",
    scope: true,
    link: function link($scope, $el, $attrs, formController) {
      $scope.$watch(function () {
        return formController.globalErrors();
      }, function (globalErrors) {
        if (globalErrors != null && globalErrors.length > 0) {
          showError(globalErrors);
        } else {
          hideError();
        }
      });

      // validation

      var showError = function showError(globalErrors) {
        $el.addClass("has-error");
        $el.addClass("global-errors");
        // clean current messages
        $el.html("");
        _.each(globalErrors, function (error) {
          var msg;
          if (error.message) {
            msg = error.message;
          } else {
            msg = $translate(error.messageKey);
          }
          $el.append('<div>' + msg + '</div>');
        });
      };
      var hideError = function hideError() {
        $el.removeClass("has-error");
        $el.removeClass("global-errors");
        $el.html("");
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/form/tlValidatedForm.js", __webpack_require__(1)))

/***/ }),
/* 2955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('guSectionTitle', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    transclude: true,
    template: "\n            <div class=\"gu-section-title\">\n                <div class=\"line-around line-before\"></div>\n                <div class=\"content\">\n                    <h3 ng-transclude></h3>\n                </div>\n                <div class=\"line-around line-after\"></div>\n            </div>\n        "
  };
});
ngModule.directive('guSection', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    transclude: true,
    template: "<div class=\"gu-section\" ng-transclude></div>"
  };
});
ngModule.directive('guSectionContent', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    transclude: true,
    template: "<div class=\"gu-section-content\" ng-transclude></div>"
  };
});
ngModule.directive('guImageBox', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    transclude: true,
    template: "<div class=\"gu-image-box\" ng-transclude></div>"
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/guide-utilisateur/gu-section-title.js"))

/***/ }),
/* 2956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_getNgModule__ = __webpack_require__(0);




function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_getNgModule__["a" /* default */])(__filename);
ngModule.controller("highchartExportPopinController", ["$scope", "$element", "$timeout", "urlUtils", "security", "highchartUtils", "highchartConfigUpdater", function ($scope, $element, $timeout, urlUtils, security, highchartUtils, highchartConfigUpdater) {
  var getUpdaterParameters = highchartConfigUpdater.getUpdaterParameters,
    applyConfigUpdate = highchartConfigUpdater.applyConfigUpdate;
  var copyChartConfig = function copyChartConfig(chart) {
    return highchartUtils.copyChartConfigForPopins(chart);
  };
  var originalChart = $scope.originalChart;
  var preprocessedConfig = copyChartConfig(originalChart);
  var exporting = preprocessedConfig.options && preprocessedConfig.options.exporting || originalChart && originalChart.options && originalChart.options.exporting || originalChart && originalChart.userOptions && originalChart.userOptions.exporting;
  var exportTitle = null;
  if (exporting && exporting.chartOptions && exporting.chartOptions.title) {
    exportTitle = exporting.chartOptions.title.text != null ? exporting.chartOptions.title.text : typeof exporting.chartOptions.title === 'string' ? exporting.chartOptions.title : null;
  }
  if (exportTitle) {
    var currentTitle = preprocessedConfig.title && preprocessedConfig.title.text || preprocessedConfig.options && preprocessedConfig.options.title && preprocessedConfig.options.title.text;
    if (!currentTitle) {
      if (!preprocessedConfig.title || __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(preprocessedConfig.title) !== 'object') {
        preprocessedConfig.title = {};
      }
      preprocessedConfig.title.text = exportTitle;
      if (preprocessedConfig.options) {
        preprocessedConfig.options.title = preprocessedConfig.options.title || {};
        preprocessedConfig.options.title.text = exportTitle;
      }
    }
  }
  function prepareChartConfig() {
    var config = angular.copy(preprocessedConfig);
    return _objectSpread({}, config, {
      series: _.filter(config.series, function (s) {
        return s.id !== "highcharts-navigator-series";
      }),
      options: _objectSpread({}, config.options, {
        navigator: {
          enabled: false
        },
        scrollbar: {
          enabled: false
        },
        rangeSelector: {
          enabled: false
        }
      })
    });
  }
  $scope.exportedChartConfig = prepareChartConfig();
  $scope.chartType = preprocessedConfig.options.chart.type;
  var chartParams = $scope.chartParams = {};
  var initializeParameters = function initializeParameters() {
    chartParams = $scope.chartParams = getUpdaterParameters($scope.exportedChartConfig);
    if (exportTitle && !chartParams.title) {
      chartParams.title = exportTitle;
    }
  };
  $scope.updateChartConfig = function () {
    var chartConfig = prepareChartConfig();
    $scope.exportedChartConfig = applyConfigUpdate(chartConfig, chartParams);
    resizeChart();
  };
  var resizeChart = function resizeChart() {
    var maxHeight = 430,
      maxWidth = 820;
    var originalHeight = chartParams.height,
      originalWidth = chartParams.width,
      heightRatio = maxHeight / originalHeight,
      widthRatio = maxWidth / originalWidth,
      useHeightRatio = heightRatio != null && (widthRatio == null || heightRatio < widthRatio),
      effectiveRatio = useHeightRatio ? heightRatio : widthRatio,
      heightOffset = (maxHeight - originalHeight * effectiveRatio) / (2 * effectiveRatio),
      widthOffset = (maxWidth - originalWidth * effectiveRatio) / (2 * effectiveRatio);
    getChart().setSize(originalWidth, originalHeight, false);
    var scale = "scale(" + effectiveRatio + ")";
    var translateX = "translateX(" + widthOffset + "px)";
    var translateY = "translateY(" + heightOffset + "px)";
    var transform = scale + " " + translateX + " " + translateY;
    $element.find("div.highchart").css({
      "transform": transform,
      "transform-origin": "top left"
    });
  };

  // init
  $timeout(function () {
    initializeParameters();
    $scope.updateChartConfig();
  }, 0);

  // chart accessors
  var getChart = function () {
    var highchartCtrl = null;
    var getChartCtrl = function getChartCtrl() {
      if (highchartCtrl == null) {
        highchartCtrl = $element.find("div.highchart").controller("highchart");
      }
      return highchartCtrl;
    };
    return function () {
      return getChartCtrl().getChart();
    };
  }();

  // exporting
  var exportChart = function exportChart(mimetype) {
    var exportUrl = "/rest/highcharts/generate";
    getChart().exportChart({
      url: exportUrl + "?" + urlUtils.param(security.getTokens()),
      type: mimetype,
      width: chartParams.width,
      sourceWidth: chartParams.width,
      sourceHeight: chartParams.height
    });
  };
  $scope.exportToPdf = function () {
    return exportChart("application/pdf");
  };
  $scope.exportImage = function () {
    return exportChart("image/png");
  };
  $scope.exportImageSVG = function () {
    return exportChart("image/svg+xml");
  };
}]);
ngModule.directive("highchartExportPreview", function () {
  return {
    restrict: "A",
    require: ["highchart"],
    link: function link($scope, $el, $attrs, controllers) {
      var chartCtrl = controllers[0];
      chartCtrl.setAutoResize(false);
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/highcharts/exporter/highchartExportPopin.js", __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
ngModule.factory("highchartConfigUpdater", ["stringUtils", "highchartConfigBlocks", function (stringUtils, highchartConfigBlocks) {
  var stripHtml = stringUtils.stripHtml;

  /**
   * Extract the editable pieces of a chart config and populate with the chart's current value.
   *
   * @param chartConfig
   */
  var getUpdaterParameters = function getUpdaterParameters(chartConfig) {
    var options = chartConfig.options,
      series = chartConfig.series;
    var parameters = {};
    var isPie = options.chart.type === 'pie';

    // title & subtitle
    parameters.title = stripHtml(options.title.text);
    parameters.subtitle = stripHtml(options.subtitle.text);

    // height / width
    parameters.width = isPie ? 800 : 1200;
    parameters.height = 400;

    // legend
    if (options.legend.enabled) {
      parameters.legend = options.legend.align === "right" ? "RIGHT" : "BOTTOM";
    } else {
      parameters.legend = "HIDDEN";
    }
    parameters.legendFloating = options.legend.floating === true ? 'true' : 'false';

    // series
    parameters.series = _.map(series, function (serie) {
      return {
        id: serie.id,
        name: serie.name || serie.id,
        color: serie.color,
        visible: true
      };
    });

    // pie chart specific
    if (isPie) {
      parameters.pie = {
        chartColors: options.colors,
        chartPieData: series[0].data,
        colorChartPieOnSerie: series[0].data[0]['color'] !== undefined
      };
      parameters.dataLabelsEnabled = true;
    }

    // data labels
    if (options.plotOptions && options.plotOptions.series && options.plotOptions.series.dataLabels) {
      parameters.dataLabelsEnabled = options.plotOptions.series.dataLabels.enabled;
    }

    // xAxis
    parameters.xAxis = _.map(options.xAxis, function (axis) {
      return {
        title: stripHtml(axis.title && axis.title.text || "")
      };
    });

    // yAxis
    parameters.yAxis = _.map(options.yAxis, function (axis) {
      return {
        title: stripHtml(axis.title && axis.title.text || "")
      };
    });
    return parameters;
  };
  var applyConfigUpdate = function applyConfigUpdate(chartConfig, updaterParams) {
    var options = chartConfig.options,
      series = chartConfig.series;

    // title
    options.title.text = updaterParams.title;
    options.subtitle.text = updaterParams.subtitle;

    // height / width
    options.chart.height = updaterParams.height;
    options.chart.width = updaterParams.width;

    // init plotOptions if missing
    if (!options.plotOptions) {
      options.plotOptions = {
        series: {},
        pie: {}
      };
    }
    options.plotOptions.series.animation = false;

    // series
    var filteredSeries = [];
    for (var i = 0; i < series.length; i++) {
      var serie = series[i];
      var serieOptions = updaterParams.series[i];
      if (!serieOptions.visible) {
        continue;
      }
      serie.color = serieOptions.color;
      filteredSeries.push(serie);
    }
    chartConfig.series = filteredSeries;

    // pie chart specific
    if (updaterParams.pie) {
      if (updaterParams.pie.colorChartPieOnSerie) {
        for (var _i = 0; _i < series[0].data.length; _i++) {
          series[0].data[_i].color = updaterParams.pie.chartPieData[_i].color;
        }
      } else {
        for (var _i2 = 0; _i2 < series[0].data.length; _i2++) {
          options.colors[_i2] = updaterParams.pie.chartColors[_i2];
        }
      }
    }

    // data labels
    if (updaterParams.dataLabelsEnabled != null) {
      _.each(chartConfig.series, function (serie) {
        serie.dataLabels.enabled = updaterParams.dataLabelsEnabled;
      });
    }

    // xAxis
    _.each(updaterParams.xAxis, function (axisConfig, i) {
      if (!options.xAxis[i].title) {
        options.xAxis[i].title = {};
      }
      options.xAxis[i].title.text = axisConfig.title;
    });

    // yAxis
    _.each(updaterParams.yAxis, function (axisConfig, i) {
      if (!options.yAxis[i].title) {
        options.yAxis[i].title = {};
      }
      options.yAxis[i].title.text = axisConfig.title;
    });

    // legend
    switch (updaterParams.legend) {
      case "HIDDEN":
        {
          options.legend.enabled = false;
          break;
        }
      case "RIGHT":
        {
          options.legend = _objectSpread({}, options.legend, {}, highchartConfigBlocks.legendOnRight);
          break;
        }
      case "BOTTOM":
        {
          options.legend = _objectSpread({}, options.legend, {}, highchartConfigBlocks.legendOnBottom);
          break;
        }
    }
    options.legend.floating = updaterParams.legendFloating === 'true' && updaterParams.legend === "RIGHT" ? true : false;
    // retire le marginRight qui bloque la position de la legende à droite
    options.chart.marginRight = undefined;
    if (options.chart.type === 'pie') {
      _.each(chartConfig.series, function (serie) {
        return serie.showInLegend = updaterParams.legend !== 'HIDDEN';
      });
    }
    return chartConfig;
  };
  return {
    getUpdaterParameters: getUpdaterParameters,
    applyConfigUpdate: applyConfigUpdate
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/highcharts/exporter/highcharts-config-updater.js", __webpack_require__(1)))

/***/ }),
/* 2958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.run(["defaultChartOptions", "highchartExporter", function (defaultChartOptions, highchartExporter) {
  defaultChartOptions.exporting.buttons.contextButton.menuItems.push({
    textKey: 'ExporterLeGraphique',
    onclick: function onclick() {
      highchartExporter.openExportPopin(this);
    }
  });
}]);
ngModule.factory("highchartExporter", ["$modal", function ($modal) {
  return {
    openExportPopin: function openExportPopin(chart) {
      $modal.open({
        controller: "highchartExportPopinController",
        template: __webpack_require__(3731),
        vars: {
          originalChart: chart
        },
        options: {
          width: 1220
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/highcharts/exporter/highcharts-exporter.js"))

/***/ }),
/* 2959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.run(["defaultChartOptions", "highchartFullscreenOpener", function (defaultChartOptions, highchartFullscreenOpener) {
  defaultChartOptions.exporting.buttons.contextButton.menuItems.push({
    textKey: 'AfficherEnPleinEcran',
    onclick: function onclick() {
      highchartFullscreenOpener.openFullscreenPopin(this);
    }
  });
}]);
ngModule.factory("highchartFullscreenOpener", ["$modal", function ($modal) {
  return {
    openFullscreenPopin: function openFullscreenPopin(chart) {
      $modal.open({
        controller: "highchartFullscreenPopinController",
        template: __webpack_require__(3732),
        vars: {
          originalChart: chart
        },
        options: {
          fullWidth: true
          //width : 1220
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/highcharts/full-screen/highchartFullscreenOpener.js"))

/***/ }),
/* 2960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
ngModule.controller("highchartFullscreenPopinController", ["$scope", "highchartUtils", function ($scope, highchartUtils) {
  var originalChart = $scope.originalChart;
  var initialExportedChartConfig = highchartUtils.copyChartConfigForPopins(originalChart);
  function prepareChartConfig() {
    var chartConfig = angular.copy(initialExportedChartConfig);

    // this remove the highchart navigator for highstock charts
    chartConfig.series = _.filter(chartConfig.series, function (serie) {
      return serie.id !== "highcharts-navigator-series";
    });

    // Surcharge les options avec d'éventuelles options fullScreen
    if (originalChart.fsOptions) {
      chartConfig.options = _objectSpread({}, chartConfig.options, {}, originalChart.fsOptions);
    }
    /*
    chartConfig.options = {
        ...chartConfig.options,
        navigator : {
            enabled : false
        },
        scrollbar : {
            enabled : false
        },
        rangeSelector : {
            enabled : false
        }
    };
    */

    return chartConfig;
  }
  $scope.fullscreenChartConfig = prepareChartConfig();

  // fix highchart autoscale due to transition on popin
  _.delay(function () {
    $scope.$broadcast("$resize");
    $scope.$apply();
  }, 200);
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/highcharts/full-screen/highchartFullscreenPopin.js", __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * The base chart config to use for sparkline type charts.
 */
ngModule.factory('sparklineChartOptions', function () {
  return {
    chart: {
      type: 'line',
      height: '50',
      width: '150',
      zoomType: null,
      margin: [0, 0, 0, 0],
      backgroundColor: "#fafaff"
    },
    legend: {
      enabled: false
    },
    xAxis: {
      labels: {
        enabled: false
      },
      alternateGridColor: null,
      startOnTick: false,
      endOnTick: false
    },
    yAxis: {
      labels: {
        enabled: false
      }
    },
    tooltip: {
      enabled: false,
      crosshairs: false
    },
    exporting: {
      enabled: false
    },
    plotOptions: {
      series: {
        animation: false
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/highcharts/highchart-sparkline-options.js"))

/***/ }),
/* 2962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory('highchartConfigBlocks', function () {
  return {
    legendOnRight: {
      enabled: true,
      align: 'right',
      layout: 'vertical',
      verticalAlign: 'top',
      y: 30,
      backgroundColor: 'rgba(109,176,194,0.1)',
      borderWidth: 0,
      borderRadius: 0
    },
    legendOnBottom: {
      enabled: true,
      align: 'center',
      layout: 'horizontal',
      verticalAlign: 'bottom',
      y: 0,
      backgroundColor: null,
      borderWidth: 0,
      borderRadius: 0,
      // on retire tout caractère flottant (parfois utilisé quand legende à droite)
      floating: false
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/highcharts/highcharts-config-blocks.js"))

/***/ }),
/* 2963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory('defaultChartOptions', ["chartUtils", function (chartUtils) {
  var exportUrl = "/rest/highcharts/generate";
  return {
    chart: {
      borderWidth: 0,
      borderColor: '#322f8f',
      events: {},
      resetZoomButton: {
        theme: {
          fill: "#F0F6F8"
        }
      }
    },
    colors: chartUtils.getGraphColors(),
    title: {
      text: null
    },
    subtitle: {
      text: null
    },
    xAxis: {
      alternateGridColor: 'rgba(109,176,194,0.1)'
    },
    yAxis: {
      title: {
        text: null
      }
    },
    tooltip: {
      crosshairs: true
    },
    legend: {
      margin: 8
    },
    plotOptions: {
      series: {
        marker: {
          enabled: false
        }
      },
      area: {
        fillColor: "rgba(170, 180, 220, 0.3)",
        marker: {
          enabled: false,
          symbol: 'circle',
          radius: 2,
          states: {
            hover: {
              enabled: true
            }
          }
        }
      }
    },
    series: null,
    scrollbar: {
      barBackgroundColor: '#DADADA',
      buttonBackgroundColor: '#DADADA',
      trackBackgroundColor: '#F5F5F5'
    },
    navigation: {
      buttonOptions: {
        theme: {
          fill: "#F5F5F5"
        }
      }
    },
    rangeSelector: {
      buttonSpacing: 5,
      inputEnabled: false,
      buttons: [{
        type: 'month',
        count: 1,
        text: '1m'
      }, {
        type: 'month',
        count: 3,
        text: '3m'
      }, {
        type: 'month',
        count: 6,
        text: '6m'
      }, {
        type: 'year',
        count: 1,
        text: '1an'
      }, {
        type: 'all',
        text: 'Tout'
      }],
      buttonTheme: {
        r: 8,
        width: 35,
        fill: "#f2f2f7",
        style: {
          color: "#3F3F3F",
          cursor: "pointer"
        },
        states: {
          hover: {
            fill: "#DADADA",
            style: {
              color: "#3F3F3F"
            }
          },
          select: {
            fill: "#bfd7ff",
            style: {
              color: "#3F3F3F"
            }
          }
        }
      }
    },
    navigator: {
      enabled: false,
      handles: {
        backgroundColor: '#FFFFFF',
        borderColor: '#000000'
      },
      series: {
        id: "highcharts-navigator-series"
      }
    },
    exporting: {
      enabled: true,
      url: exportUrl,
      buttons: {
        contextButton: {
          align: "right",
          menuClassName: 'highcharts-contextmenu',
          symbol: 'menu',
          _titleKey: 'contextButtonTitle',
          menuItems: []
        }
      }
    },
    credits: {
      enabled: false
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/highcharts/highcharts-defaults.js"))

/***/ }),
/* 2964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);




var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
ngModule.config(function () {
  if (!__WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src___default.a.translations) {
    __WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src___default.a.translations = [];
  }
  __WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src___default.a.translations["fr_FR"] = {
    months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    shortMonths: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aout', 'Sept', 'Oct', 'Nov', 'Déc'],
    decimalPoint: ",",
    thousandsSep: " ",
    numericSymbols: ["k", "M", "G", "T", "P", "E"],
    downloadPNG: "Télécharger en image PNG",
    downloadJPEG: "Télécharger en image JPEG",
    downloadPDF: "Télécharger en document PDF",
    downloadSVG: "Télécharger en document Vectoriel",
    exportButtonTitle: "Export du graphique",
    loading: "Chargement en cours...",
    printButtonTitle: "Imprimer le graphique",
    resetZoom: "Réinitialiser le zoom",
    resetZoomTitle: "Réinitialiser le zoom au niveau 1:1",
    contextButtonTitle: "Actions",
    ExporterLeGraphique: "Exporter le graphique",
    AfficherEnPleinEcran: "Afficher en plein écran"
  };
  __WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src___default.a.translations["en_GB"] = {
    loading: "Loading...",
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    decimalPoint: ".",
    thousandsSep: ",",
    numericSymbols: ["k", "M", "G", "T", "P", "E"],
    resetZoom: "Reset zoom",
    resetZoomTitle: "Reset zoom level 1:1",
    rangeSelectorZoom: "Zoom",
    rangeSelectorFrom: "From:",
    rangeSelectorTo: "To:",
    downloadPNG: "Download PNG image",
    downloadJPEG: "Download JPEG image",
    downloadPDF: "Download PDF document",
    downloadSVG: "Download SVG vector image",
    exportButtonTitle: "Export to raster or vector image",
    printButtonTitle: "Print the chart",
    contextButtonTitle: "Actions",
    ExporterLeGraphique: "Export chart",
    AfficherEnPleinEcran: "Show in full screen"
  };
});
ngModule.run(function () {
  __WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src___default.a.setOptions({
    lang: __WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src___default.a.translations["fr_FR"]
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/highcharts/highcharts-i18n.js"))

/***/ }),
/* 2965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("highchartUtils", function () {
  var utils = {};
  utils.copyChartOptions = function (chart) {
    var options = chart._originalOptions || chart.options;
    var renderTo = options.chart.renderTo;
    options.chart.renderTo = null;
    var optionsCopy = angular.copy(options);
    options.chart.renderTo = renderTo;
    return optionsCopy;
  };
  utils.copyChartSeries = function (chart) {
    return angular.copy(_.map(chart.series, function (serie) {
      var serieOptions = serie.options;
      if (!serieOptions.color) {
        serieOptions.color = serie.color;
      }
      serieOptions.animation = false;
      return serieOptions;
    }));
  };
  utils.copyChartConfigForPopins = function (chart) {
    var options = utils.copyChartOptions(chart);
    var series = utils.copyChartSeries(chart);

    // options override
    options.exporting.enabled = false;

    // disable animation on init
    options.chart.animation = false;
    options.plotOptions.series.animation = false;

    // force xAxis & yAxis to be lists to make it easier to work with later
    if (options.xAxis && !_.isArray(options.xAxis)) {
      options.xAxis = [options.xAxis];
    }
    if (options.yAxis && !_.isArray(options.yAxis)) {
      options.yAxis = [options.yAxis];
    }
    return {
      options: options,
      series: series
    };
  };
  return utils;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/highcharts/highcharts-utils.js", __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);




var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
ngModule.directive('highchart', ["$timeout", "defaultChartOptions", function ($timeout, defaultChartOptions) {
  var seriesId = 0;
  var ensureIds = function ensureIds(series) {
    series.forEach(function (s) {
      if (!angular.isDefined(s.id)) {
        s.id = "series-" + seriesId++;
      }
    });
  };
  var getMergedOptions = function getMergedOptions(scope, element, config, height) {
    var mergedOptions = angular.copy(defaultChartOptions);

    // allows to remove an Export action from the defaut Chat options, attibute is an array with id of the action
    if (config.removeExportOptions) {
      var menuItems = mergedOptions.exporting.buttons.contextButton.menuItems;
      mergedOptions.exporting.buttons.contextButton.menuItems = _.filter(menuItems, function (e) {
        return _.indexOf(config.removeExportOptions, e.id) === -1;
      });
    }

    // permet d'ajouter des items au menu d'export sans retirer ceux par défaut.
    // ex : exportMenuItems: [{
    //                     id: "showAll",
    //                     text: "Afficher tout",
    //                     onclick: function () {
    //                         _.each(this.series, function (ser) {
    //                             ser.show();
    //                         });
    //                     }
    //                 }
    if (config.exportMenuItems) {
      var _menuItems = mergedOptions.exporting.buttons.contextButton.menuItems;
      _.each(config.exportMenuItems, function (item) {
        mergedOptions.exporting.buttons.contextButton.menuItems.push(item);
      });
    }
    if (config.options) {
      $.extend(true, mergedOptions, config.options);
    }
    if (height) {
      mergedOptions.chart.height = height;
    }
    mergedOptions.chart.renderTo = element[0];
    if (config.title) {
      mergedOptions.title = config.title;
    }
    if (config.series) {
      mergedOptions.series = config.series;
    }
    return mergedOptions;
  };
  var processSeries = function processSeries(chart, series) {
    // filter navigator series from current series
    var currentSeries = _.filter(chart.series, function (serie) {
      return serie.options.id !== "highcharts-navigator-series";
    });
    var newSeriesIds = [];
    if (series != null) {
      ensureIds(series);

      //Find series to add or update
      _.each(series, function (s) {
        newSeriesIds.push(s.id);
        var chartSeries = chart.get(s.id);
        if (chartSeries) {
          chartSeries.update(s, false);
        } else {
          chart.addSeries(angular.copy(s), false);
        }
      });
    }
    _.each(currentSeries, function (serie) {
      if (newSeriesIds.indexOf(serie.options.id) === -1) {
        serie.remove(false);
      }
    });
  };
  var initializeChart = function initializeChart(scope, element, config, height) {
    config || (config = {});
    var mergedOptions = getMergedOptions(scope, element, config, height);
    var chart = config.useHighStocks ? __WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src___default.a.stockChart(mergedOptions) : __WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src___default.a.chart(mergedOptions);

    // processSeries(chart, config.series && config.series.length ? config.series : mergedOptions.series);

    if (config.loading) {
      chart.showLoading();
    }
    chart.redraw();
    chart._originalOptions = mergedOptions;

    // Passe les éventuelles options fullScreen
    chart.fsOptions = config.fsOptions;
    return chart;
  };
  return {
    restrict: 'E',
    replace: true,
    template: '<div class="highchart"></div>',
    scope: {
      config: '='
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        autoresize = true,
        height = null,
        chart = null;
      ctrl.getChart = function () {
        return chart;
      };
      ctrl.setAutoResize = function (_autoresize) {
        autoresize = _autoresize;
      };
      ctrl.onResize = function () {
        if (autoresize) {
          ctrl.redraw();
        }
      };
      ctrl.setHeight = function (_height) {
        height = _height;
        if (chart) {
          // PGA - if resize animation trigger just before setSeries's redraw, the series wont be redrawn.
          // this trick fix the probleme 99% of the time on initial data load. Enjoy debugging the last 1%.
          var animate = chart.series.length > 0;
          chart.setSize($element.width(), height, animate);
        }
      };
      ctrl.redraw = function () {
        // this is the only fu*** way to redraw correctly a chart...
        $element.is(":visible") && chart && chart.setSize($element.width(), height || $element.height(), false);
      };
      ctrl.initializeChart = function (config) {
        if (chart) {
          chart.destroy();
        }
        chart = initializeChart($scope, $element, config, height);
      };
      ctrl.setTitle = function (title) {
        chart.setTitle(title, true);
      };
      ctrl.setSeries = function (series) {
        processSeries(chart, series);
        chart.redraw();
      };
      ctrl.dispose = function () {
        if (chart) {
          chart.destroy();
          chart = null;
        }
      };
    }],
    link: function link($scope, $element, $attrs, ctrl) {
      var unwatch = $scope.$watch("config", function (config) {
        if (config == null) {
          return;
        }
        unwatch();
        ctrl.initializeChart($scope.config);
        $scope.$watch("config.title", function (newTitle) {
          ctrl.setTitle(newTitle);
        }, true);
        $scope.$watch("config.options", function (newOptions, oldOptions) {
          if (newOptions === oldOptions) {
            return;
          }
          ctrl.initializeChart($scope.config);
        }, true);
        $scope.$watch("config.series", function (newSeries, oldSeries) {
          if (newSeries === oldSeries) {
            return;
          }
          ctrl.setSeries(newSeries);
        });
        $scope.$on("$redraw", function () {
          ctrl.redraw();
        });
        $scope.$on("$resize", function () {
          ctrl.onResize();
        });
        $scope.$on("$destroy", function () {
          ctrl.dispose();
        });
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/highcharts/highcharts.js", __webpack_require__(3), __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 2967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);




var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
ngModule.factory("highchartDraggablePoints", function () {
  return {
    getSelectionModes: function getSelectionModes() {
      return [{
        id: "POINT",
        label: "Point uniquement"
      }, {
        id: "NEXT",
        label: "Point et suivants"
      }, {
        id: "PREVIOUS",
        label: "Point et précédents"
      }, {
        id: "STEP",
        label: "Points du palier"
      }, {
        id: "ALL",
        label: "Tous les points"
      }];
    },
    getDragModes: function getDragModes() {
      return [{
        id: "POSITION",
        label: "Positionner"
      }, {
        id: "TRANSLATION",
        label: "Translater"
      }];
    }
  };
});

/**
 * Home-made Highchart draggable points plugin.
 *
 * Greatly inspired from Draggable points plugin from Torstein Honsi (MIT License)
 */
(function (Highcharts) {
  var addEvent = Highcharts.addEvent,
    each = Highcharts.each,
    pick = Highcharts.pick;
  var selectionModes = ["POINT", "ALL", "STEP", "NEXT", "PREVIOUS"];
  var dragModes = ["POSITION", "TRANSLATION"];
  Highcharts.Chart.prototype.callbacks.push(function (chart) {
    var container = chart.container,
      options,
      dragOptions,
      dragged = false,
      originY,
      dragPoint,
      dragY,
      dragPlotY,
      selectionMode,
      dragMode;
    var getSelection = function getSelection(event, selectionMode) {
      var data = dragPoint.series.data;
      switch (selectionMode) {
        case "POINT":
          return [dragPoint];
        case "STEP":
          var index = dragPoint.index,
            originY = event.originY,
            min = index,
            max = index;
          if (index < data.length - 1) {
            for (var i = index + 1; i < data.length; i++) {
              if (data[i].y == originY) {
                max = i;
              } else {
                break;
              }
            }
          }
          if (index > 0) {
            for (var i = index - 1; i >= 0; i--) {
              if (data[i].y == originY) {
                min = i;
              } else {
                break;
              }
            }
          }
          return data.slice(min, max + 1);
        case "NEXT":
          return _.slice(data, dragPoint.index);
        case "PREVIOUS":
          return _.take(data, dragPoint.index + 1);
        case "ALL":
          return data;
      }
      return [dragPoint];
    };
    var computeNewPosition = function computeNewPosition(e) {
      var originalEvent = e.originalEvent || e,
        series = dragPoint.series,
        newX = dragPoint.x,
        newY;
      if (options.draggable) {
        var pageY = originalEvent.changedTouches ? originalEvent.changedTouches[0].pageY : e.pageY,
          deltaY = dragY - pageY,
          newPlotY = chart.plotHeight - dragPlotY + deltaY;
        newY = dragY === undefined ? dragPoint.y : dragPoint.series.yAxis.translate(newPlotY, true);
        if (dragOptions.dragStep) {
          newY = dragOptions.dragStep * parseInt(newY / dragOptions.dragStep);
        }
      } else {
        newY = dragPoint.y;
      }

      // verifie que l'on ne sorte pas des bornes imposées dans la config
      if (dragOptions.maxY !== undefined && newY > dragOptions.maxY) {
        newY = dragOptions.maxY;
      } else if (dragOptions.minY !== undefined && newY <= dragOptions.minY) {
        newY = dragOptions.minY;
      }
      return {
        x: newX,
        y: newY
      };
    };
    var applyPositionChange = function applyPositionChange(e, selectionMode, dragMode, doRedraw) {
      var newPosition = computeNewPosition(e),
        selection = getSelection(e, selectionMode);
      if (dragMode === "POSITION") {
        _.each(selection, function (point) {
          point.update({
            x: point.x,
            y: newPosition.y
          }, false);
        });
      } else {
        var offset = newPosition.y - dragPoint.y;
        _.each(selection, function (point) {
          point.update({
            x: point.x,
            y: point.y + offset
          }, doRedraw);
        });
      }
    };
    function mouseDown(e) {
      var hoverPoint = chart.hoverPoint,
        originalEvent = e.originalEvent || e;
      if (hoverPoint) {
        options = hoverPoint.series.options;
        dragOptions = options.dragOptions || {};
        originY = hoverPoint.y;
        selectionMode = dragOptions.selectionMode ? _.result(dragOptions, "selectionMode") : "POINT";
        dragMode = dragOptions.dragMode ? _.result(dragOptions, "dragMode") : "TRANSLATION";
        if (options.draggable) {
          dragPoint = hoverPoint;
          dragY = originalEvent.changedTouches ? originalEvent.changedTouches[0].pageY : e.pageY;
          dragPlotY = dragPoint.plotY + (chart.plotHeight - (dragPoint.yBottom || chart.plotHeight));
        }

        // Disable zooming when dragging
        if (dragPoint) {
          chart.mouseIsDown = false;
        }
      }
    }
    function mouseMove(e) {
      e.preventDefault();
      if (dragPoint) {
        var proceed = false,
          series = dragPoint.series,
          newPosition = computeNewPosition(e);
        dragged = true;

        // Fire the 'drag' event with a default action to move the point.
        dragPoint.firePointEvent('drag', {
          originY: originY,
          newY: newPosition.y
        }, function () {
          proceed = true;

          // Hide halo while dragging
          if (series.halo) {
            series.halo = series.halo.destroy();
          }
          if (chart.tooltip) {
            chart.tooltip.refresh(chart.tooltip.shared ? [dragPoint] : dragPoint);
          }
          applyPositionChange(e, selectionMode, dragMode, false);
          series.redraw();
        });

        // The default handler has not run because of prevented default
        if (!proceed) {
          drop();
        }
      }
    }
    function drop(e) {
      if (dragPoint && e && dragged) {
        var newPosition = computeNewPosition(e);
        dragPoint.firePointEvent('drop', {
          originY: originY,
          newY: newPosition.y
        });
        applyPositionChange(e, selectionMode, dragMode, true); // used to force yAxis to recompute min / max

        chart.redraw();
      }
      dragPoint = dragY = originY = undefined;
      dragged = false;
    }

    // Kill animation (why was this again?)
    chart.redraw();

    // Add'em
    addEvent(container, 'mousemove', mouseMove);
    addEvent(container, 'touchmove', mouseMove);
    addEvent(container, 'mousedown', mouseDown);
    addEvent(container, 'touchstart', mouseDown);
    addEvent(document, 'mouseup', drop);
    addEvent(document, 'touchend', drop);
    addEvent(container, 'mouseleave', drop);
  });

  /**
   * Extend the column chart tracker by visualizing the tracker object for small points
   */
  Highcharts.wrap(Highcharts.seriesTypes.column.prototype, 'drawTracker', function (proceed) {
    var series = this,
      options = series.options;
    proceed.apply(series);
    if (options.draggable) {
      each(series.points, function (point) {
        point.graphic.attr(point.shapeArgs.height < 3 ? {
          'stroke': 'black',
          'stroke-width': 2,
          'dashstyle': 'shortdot'
        } : {
          'stroke-width': series.options.borderWidth,
          'dashstyle': series.options.dashStyle || 'solid'
        });
      });
    }
  });
})(__WEBPACK_IMPORTED_MODULE_0_highcharts_highstock_src___default.a);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/highcharts/serie-editor/highcharts.draggable-points.js", __webpack_require__(1)))

/***/ }),
/* 2968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("imgScale", function () {
  return {
    restrict: "A",
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        maxWidth = null,
        maxHeight = null;
      var img = $element;
      if (!img.is("img")) {
        img = $element.find("img");
      }
      if (!img) {
        console.log("Pas d'<img> trouvée par la directive imgScale");
        return;
      }
      ctrl.setDimensions = function (width, height) {
        maxWidth = width && parseInt(width) || null;
        maxHeight = height && parseInt(height) || null;
      };
      ctrl.scaleImage = function () {
        // Remove all attributes and CSS rules
        img.removeAttr("height width");
        img.css({
          height: "auto",
          width: "auto"
        });
        var originalHeight = img[0].height,
          originalWidth = img[0].width,
          heightRatio = maxHeight ? maxHeight / originalHeight : null,
          widthRatio = maxWidth ? maxWidth / originalWidth : null,
          useHeightRatio = heightRatio != null && (widthRatio == null || heightRatio < widthRatio),
          scaledHeight,
          scaledWidth;
        if (useHeightRatio) {
          scaledHeight = originalHeight * heightRatio;
          scaledWidth = originalWidth * heightRatio;
        } else {
          scaledHeight = originalHeight * widthRatio;
          scaledWidth = originalWidth * widthRatio;
        }
        img.css({
          height: parseInt(scaledHeight),
          width: parseInt(scaledWidth)
        });
        $scope.$emit("$resize:required");
      };
    }],
    link: function link($scope, $el, $attrs, ctrl) {
      var img = $el;
      if (!img.is("img")) {
        img = $el.find("img");
        if (!img) {
          console.log("Pas d'<img> trouvée par la directive imgScale");
          return;
        }
      }
      if ($attrs.imgWidth || $attrs.imgHeight) {
        $attrs.imgWidth && img.width($attrs.imgWidth + "px");
        $attrs.imgHeight && img.height($attrs.imgHeight + "px");
      } else {
        img.hide();
      }
      var setDimensions = function setDimensions() {
        $el.show();
        ctrl.setDimensions($attrs.imgWidth, $attrs.imgHeight);
        ctrl.scaleImage();
      };
      img.on("load", function () {
        setDimensions();
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/imgScale.js"))

/***/ }),
/* 2969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlCheckbox", ["$timeout", "keyCodes", "uiUtils", function ($timeout, keyCodes, uiUtils) {
  var CHECKED_CLASS = "tl-checked",
    FOCUSED_CLASS = "tl-focused";
  return {
    restrict: "E",
    require: "?ngModel",
    transclude: true,
    replace: true,
    template: '' + '<div class="tl-checkbox">' + '<div class="tl-checkbox-container">' + '<div class="tl-checkbox-icon"></div>' + '</div>' + '   <div class="tl-checkbox-label" ng-transclude></div>' + '</div>',
    compile: function compile($el, $attrs) {
      // attach before ng-click to stop propagation when disabled
      $el.on('click', function (event) {
        if (this.hasAttribute('disabled')) {
          event.stopImmediatePropagation();
        }
      });

      // set tabindex to allow focus if unspecified
      if (!$attrs.tabindex) {
        $attrs.$set("tabindex", 0);
      }
      return function postLink($scope, $el, $attrs, ngModelCtrl) {
        if (ngModelCtrl == null) {
          ngModelCtrl = uiUtils.fakeNgModel();
        }
        if ($attrs.ngChecked) {
          $scope.$watch($scope.$eval.bind($scope, $attrs.ngChecked), ngModelCtrl.$setViewValue.bind(ngModelCtrl));
        }
        if ($attrs.checklistValue) {
          checklistLink();
        } else {
          checkboxLink();
        }

        // applying no label class to remove spacing
        var cbxLabel = $el.find(".tl-checkbox-label");
        if (cbxLabel.children().length === 0 && $.trim(cbxLabel.text()) === "") {
          $el.addClass("no-label");
        }

        /**
         * Link for the standard checkbox mecanism
         */
        function checkboxLink() {
          var trueValue = uiUtils.parseConstantExpr($scope, 'ngTrueValue', $attrs.ngTrueValue, true);
          var falseValue = uiUtils.parseConstantExpr($scope, 'ngFalseValue', $attrs.ngFalseValue, false);
          ngModelCtrl.$isEmpty = function (value) {
            return value === false;
          };
          ngModelCtrl.$formatters.push(function (value) {
            return angular.equals(value, trueValue);
          });
          ngModelCtrl.$parsers.push(function (value) {
            return value ? trueValue : falseValue;
          });
          ngModelCtrl.$render = function () {
            if (ngModelCtrl.$viewValue) {
              $el.addClass(CHECKED_CLASS);
            } else {
              $el.removeClass(CHECKED_CLASS);
            }
          };
          function checkboxValueGet() {
            return $attrs.ngChecked ? $attrs.checked : !ngModelCtrl.$viewValue;
          }
          bindEvents(checkboxValueGet);
        }

        /**
         * Link for the checklist mecanism
         */
        function checklistLink() {
          var listboxValue = $scope.$eval($attrs.checklistValue);
          if ($attrs.ngModel) {
            $scope.$watchCollection($attrs.ngModel, function () {
              ngModelCtrl.$render();
            });
          }
          ngModelCtrl.$render = function () {
            if (_.includes(ngModelCtrl.$viewValue, listboxValue)) {
              $el.addClass(CHECKED_CLASS);
            } else {
              $el.removeClass(CHECKED_CLASS);
            }
          };
          function checklistValueGet() {
            var list = ngModelCtrl.$viewValue;
            if (list == null || !_.isArray(list)) {
              list = [];
            }
            var position = _.indexOf(list, listboxValue);
            if (position > -1) {
              list.splice(position, 1);
            } else {
              list.push(listboxValue);
            }
            return list;
          }
          bindEvents(checklistValueGet);
        }
        function bindEvents(viewValueGetter) {
          $scope.mouseActive = false;
          $el.on('click', valueSwitchHandler).on('keypress', function keypressHandler(ev) {
            var keyCode = ev.which || ev.keyCode;
            if (keyCode === keyCodes.SPACE || keyCode === keyCodes.ENTER) {
              ev.preventDefault();
              if (!$el.hasClass(FOCUSED_CLASS)) {
                $el.addClass(FOCUSED_CLASS);
              }
              valueSwitchHandler(ev);
            }
          }).on('mousedown', function () {
            $scope.mouseActive = true;
            $timeout(function () {
              $scope.mouseActive = false;
            }, 100);
          }).on('focus', function () {
            if ($scope.mouseActive === false) {
              $el.addClass(FOCUSED_CLASS);
            }
          }).on('blur', function () {
            $el.removeClass(FOCUSED_CLASS);
          });
          function valueSwitchHandler(ev) {
            if ($el[0].hasAttribute('disabled')) {
              return;
            }
            $scope.$apply(function () {
              // Toggle the checkbox value...
              var viewValue = viewValueGetter();
              ngModelCtrl.$setViewValue(viewValue, ev && ev.type);
              ngModelCtrl.$render();
            });
            $el.trigger("change");
          }
        }
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/inputs/tl-checkbox.js", __webpack_require__(4), __webpack_require__(3), __webpack_require__(1)))

/***/ }),
/* 2970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * tlCurrencyInput
 */
ngModule.directive("tlCurrencyInput", ["$interpolate", function ($interpolate) {
  var DEFAULT_SYMBOL = "€"; // TODO : add service to register default currency ( wire to account currency )
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '' + '<div tl-input-wrapper>' + '   <input input-type-number/>' + '   <i class="input-icon currency-icon"></i> ' + '</div>',
    priority: 1200,
    // need to be higher than ngModel or any other transcluding directive
    compile: function compile($el, $attrs) {
      var currencyWatch;

      // The "dual compilating plus terminal" directive combo seems to make angular attribute interpolation break...
      // So we manually handles the currency interpolation & watch.
      if ($attrs.currency) {
        currencyWatch = $interpolate($attrs.currency);
        $attrs.$set("currency", null);
      }
      if ($attrs.allowNegative) {
        $el.find('input').attr('allow-negative', 'true');
      }
      return function postLink($scope, $el, $attrs) {
        $el.addClass("tl-currency-input-wrapper");
        var currencyIcon = $el.find(".currency-icon");
        if (currencyWatch != null) {
          $scope.$watch(currencyWatch, function (currencyValue) {
            var currencySymbol = currencyValue || DEFAULT_SYMBOL;
            currencyIcon.text(currencySymbol);
            if (currencySymbol.length > 1) {
              $el.addClass("long-symbol");
            } else {
              $el.removeClass("long-symbol");
            }
          });
        } else {
          currencyIcon.text(DEFAULT_SYMBOL);
        }
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/inputs/tl-currency-input.js"))

/***/ }),
/* 2971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * tlDateInput
 */
ngModule.directive("tlDateInput", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '' + '<div tl-input-wrapper>' + '   <input input-type-date tl-datepicker/>' + '   <i class="input-icon date-icon fa fa-calendar"></i> ' + '</div>',
    priority: 1000,
    // need to be higher than ngModel or any other transcluding directive
    link: function link($scope, $el, $attrs) {
      $el.addClass("tl-date-input-wrapper");
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/inputs/tl-date-input.js"))

/***/ }),
/* 2972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * attribut disable (et non ng-disabled) pour desactiver les champs année et mois
 */
ngModule.directive("tlFieldYearAndMonth", function () {
  return {
    restrict: 'E',
    require: "ngModel",
    replace: true,
    scope: {},
    template: __webpack_require__(3733),
    link: function link($scope, $el, $attrs, ngModelCtrl) {
      var duration = $scope.duration = {
        years: null,
        months: null
      };
      $scope.refreshInputValues = function () {
        ngModelCtrl.$render();
      };

      // observe
      $attrs.$observe("disabled", function (disabled) {
        $scope.disabled = disabled == 'true' || disabled == true;
      });
      ngModelCtrl.$render = function () {
        var valueInMonths = ngModelCtrl.$viewValue;
        if (valueInMonths != null) {
          duration.years = Math.floor(valueInMonths / 12);
          duration.months = valueInMonths % 12;
        } else {
          duration.years = null;
          duration.months = null;
        }
      };
      var onDurationChange = function onDurationChange() {
        var valueInMonths = 12 * (duration.years || 0) + (duration.months || 0);
        ngModelCtrl.$setViewValue(valueInMonths || null); // yes, 0 -> null.
      };
      $scope.$watch("duration.years", onDurationChange);
      $scope.$watch("duration.months", onDurationChange);
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/inputs/tl-field-year-and-month.js"))

/***/ }),
/* 2973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

// TODO : keyboard controls. See tlSelect.js

ngModule.directive("tlIconInput", ["$document", "fontAwesomeIconList", function ($document, fontAwesomeIconList) {
  return {
    restrict: "E",
    scope: true,
    require: ["tlIconInput", "ngModel"],
    controllerAs: "inputCtrl",
    replace: true,
    template: __webpack_require__(3734),
    link: function link($scope, $el, $attrs, ctrls) {
      var ctrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      ctrl.setModelCtrl(ngModelCtrl);
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        dropdownEl = $element.find(".tl-icon-input-dropdown"),
        modelCtrl = null;
      ctrl.state = {
        opened: false
      };
      ctrl.setModelCtrl = function (_ngModelCtrl) {
        modelCtrl = _ngModelCtrl;
        $scope.$watch(function () {
          return modelCtrl.$modelValue;
        }, function (modelValue) {
          $scope.iconId = modelValue;
        });
      };
      ctrl.toggleIconSelectorMenu = function () {
        if (ctrl.state.opened) {
          ctrl.closeDropdown();
        } else {
          ctrl.openDropdown();
        }
      };
      ctrl.selectIcon = function (iconId) {
        modelCtrl.$setViewValue(iconId);
        modelCtrl.$commitViewValue();
        ctrl.closeDropdown();
      };
      ctrl.openDropdown = function () {
        if (ctrl.state.opened === true) {
          return;
        }
        dropdownEl.show().width(dropdownEl.width()) // avoid .position to set width auto.
        .appendTo(document.body).position({
          my: "left top",
          at: "left bottom+0px",
          of: $element,
          collision: "flip",
          within: document.body
        });
        _.defer(function () {
          bindClickHandler();
        });
        ctrl.state.opened = true;
      };
      ctrl.closeDropdown = function () {
        if (ctrl.state.opened === false) {
          return;
        }
        dropdownEl.hide().appendTo($element);
        dropdownEl.css({
          top: "",
          left: "",
          bottom: "",
          right: "",
          width: ""
        });
        unbindClickHandler();
        ctrl.state.opened = false;
      };
      ctrl.getIconList = function () {
        return fontAwesomeIconList;
      };
      var onDocumentClick = function onDocumentClick(e) {
        var parents = $(e.target).parents();
        if (parents.index($element) > -1) {
          return;
        }
        $scope.$apply(function () {
          ctrl.closeDropdown();
        });
      };
      var bindClickHandler = function bindClickHandler() {
        $document.bind("click", onDocumentClick);
      };
      var unbindClickHandler = function unbindClickHandler() {
        $document.unbind("click", onDocumentClick);
      };
      $scope.$on("$destroy", function () {
        unbindClickHandler();
      });
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/inputs/tl-icon-input.js", __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 2974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Input wrapper directive, used to stop the compilation of the current element
 * and copy all attributes to the underneath input element.
 *
 * To keep a property on the wrapper, prefix it with "wrapper-*"
 * In example, "wrapper-class" will create the "class" property on the wrapper, where "class" will be copied to the input.
 */
ngModule.directive("tlInputWrapper", ["$compile", function ($compile) {
  // TODO : keep ngShow, ngIf... and other logic directive on the wrapper.
  return {
    restrict: "A",
    priority: 1200,
    terminal: true,
    compile: function compile($el, $attrs) {
      var input = $el.find("input");
      $attrs.$set("tlInputWrapper", null);
      var attributesToKeep = {};
      _.each($attrs.$attr, function (domAttributeName, normalizedAttributeName) {
        if (domAttributeName.indexOf("wrapper-") === 0) {
          attributesToKeep[domAttributeName.substring(8)] = $attrs[normalizedAttributeName];
          $attrs.$set(normalizedAttributeName, null);
        } else {
          input.attr(domAttributeName, $attrs[normalizedAttributeName]);
          $attrs.$set(normalizedAttributeName, null);
        }
      });
      _.each(attributesToKeep, function (attrValue, attrName) {
        $attrs.$set(attrName, attrValue);
      });
      return {
        pre: function pre($scope, $el) {
          $compile($el)($scope);
        },
        post: function post($scope, $el) {
          $el.addClass("tl-input-wrapper");
        }
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/inputs/tl-input-wrapper.js", __webpack_require__(1)))

/***/ }),
/* 2975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, moment, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlMonthPicker", ["$timeout", "keyCodes", function ($timeout, keyCodes) {
  return {
    restrict: "E",
    replace: true,
    transclude: true,
    scope: true,
    template: __webpack_require__(3735),
    controllerAs: "$monthPicker",
    require: ["tlMonthPicker", "ngModel"],
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        ngModelCtrl = controllers[1];
      ctrl.initialize(ngModelCtrl);
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        dropdownEl = $element.find(".tl-month-picker-dropdown"),
        ngModelCtrl = null,
        focusOutPromise = null;
      ctrl.state = {
        focused: false,
        opened: false,
        selectedMonth: null,
        selectedYear: null
      };
      ctrl.initialize = function (_modelCtrl) {
        ngModelCtrl = _modelCtrl;
        generateSelectOptions();
        bindDomEvents();
        wireToModel();
      };
      ctrl.toggleDropdown = function () {
        if (ctrl.state.opened) {
          ctrl.closeDropdown();
        } else {
          ctrl.openDropdown();
        }
      };
      ctrl.openDropdown = function () {
        if (ctrl.state.opened === true) {
          return;
        }
        dropdownEl.show().appendTo(document.body);
        dropdownEl.position({
          my: "left top",
          at: "left bottom+0px",
          of: $element,
          collision: "flip",
          within: document.body
        });
        ctrl.state.opened = true;
      };
      ctrl.closeDropdown = function () {
        if (ctrl.state.opened === false) {
          return;
        }
        dropdownEl.hide().appendTo($element);
        dropdownEl.css({
          top: "",
          left: "",
          bottom: "",
          right: ""
        });
        ctrl.state.opened = false;
      };
      ctrl.validateDate = function () {
        syncValueToModel();
        ctrl.closeDropdown();
      };
      var modelUnwatch = null;
      var wireToModel = function wireToModel() {
        if (modelUnwatch != null) {
          modelUnwatch();
        }
        modelUnwatch = $scope.$watch(function () {
          return ngModelCtrl.$modelValue;
        }, applyModelValue);
      };
      function bindDomEvents() {
        var selectAndDropdown = $element.add(dropdownEl);
        var openedByFocus = false;

        // click on collapsed select
        $element.find(".tl-month-picker-input").click(function (e) {
          if (openedByFocus) {
            openedByFocus = false;
            return;
          }
          ctrl.toggleDropdown();
          $scope.$apply();
        });
        selectAndDropdown.bind("focusin", function (e) {
          cancelFocusOut();
          ctrl.state.focused = true;
          ctrl.openDropdown();
          openedByFocus = true;
          $scope.$apply();
        });
        selectAndDropdown.bind("focusout", function (e) {
          cancelFocusOut();
          focusOutPromise = $timeout(function () {
            $scope.$apply(function () {
              if (!ctrl.state.focused) {
                return;
              }
              if (focusIsInsideWidget()) {
                return;
              }
              ctrl.closeDropdown();
              ctrl.state.focused = false;
              focusOutPromise = null;
              openedByFocus = false;
            });
          }, 50, false);
        });
        selectAndDropdown.keydown(function (e) {
          switch (e.which) {
            case keyCodes.ESCAPE:
              e.preventDefault();
              ctrl.closeDropdown();
              $scope.$apply();
              break;
          }
        });
      }
      function generateSelectOptions() {
        // months
        var monthOptions = [];
        _.times(12, function (i) {
          var label = moment().month(i).format("MMMM");
          monthOptions.push({
            month: i,
            label: label
          });
        });
        $scope.monthOptions = monthOptions;

        // years
        var currentYear = moment().year();
        var yearOptions = [];
        for (var i = currentYear - 20; i < currentYear + 10; i++) {
          yearOptions.push({
            year: i,
            label: i
          });
        }
        $scope.yearOptions = yearOptions;
      }
      function applyModelValue() {
        ctrl.modelValue = ngModelCtrl.$modelValue;
        ctrl.state.selectedMonth = moment(ctrl.modelValue).month();
        ctrl.state.selectedYear = moment(ctrl.modelValue).year();
      }
      function syncValueToModel() {
        var newDate = moment().year(ctrl.state.selectedYear).month(ctrl.state.selectedMonth).startOf("day").toDate();
        if (moment(newDate).isSame(ngModelCtrl.$modelValue, "month")) {
          return;
        }
        ngModelCtrl.$setViewValue(newDate);
        ngModelCtrl.$commitViewValue();
        $element.trigger("change", {
          value: newDate
        });
      }
      function focusIsInsideWidget() {
        var focusParents = $(document.activeElement).parents().addBack();
        return focusParents.index($element) > -1 || focusParents.index(dropdownEl) > -1;
      }
      function cancelFocusOut() {
        if (focusOutPromise != null) {
          $timeout.cancel(focusOutPromise);
          focusOutPromise = null;
        }
      }
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/inputs/tl-month-picker.js", __webpack_require__(1), __webpack_require__(2), __webpack_require__(4)))

/***/ }),
/* 2976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * tlPercentInput
 *
 * PAr défaut un % positif
 * supporte les attributs : allow-negative et max-decimals de input-type-number
 */
ngModule.directive("tlPercentInput", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '' + '<div tl-input-wrapper>' + '   <input input-type-number/>' + '   <i class="input-icon percent-icon">%</i> ' + '</div>',
    priority: 1000,
    link: function link($scope, $el, $attrs) {
      $el.addClass("tl-percent-input-wrapper");
      if ($attrs.allowNegative) {
        $el.find('input').attr('allow-negative', 'true');
      }
      if ($attrs.maxDecimals) {
        $el.find('input').attr('max-decimals', $attrs['maxDecimals']);
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/inputs/tl-percent-input.js"))

/***/ }),
/* 2977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlRadioGroup", ["$timeout", "uiUtils", "keyCodes", function ($timeout, uiUtils, keyCodes) {
  var FOCUSED_CLASS = "tl-focused";
  return {
    restrict: 'E',
    require: ['tlRadioGroup', '?ngModel'],
    transclude: true,
    replace: true,
    template: '<div class="tl-radio-group" ng-transclude></div>',
    link: {
      pre: function linkRadioGroup($scope, $el, $attr, controllers) {
        $el.attr({
          role: "radiogroup",
          tabindex: $el.attr("tabindex") || "0"
        });
        var rgCtrl = controllers[0],
          ngModelCtrl = controllers[1] || uiUtils.fakeNgModel();
        rgCtrl.init(ngModelCtrl);
      }
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        modelCtrl = null;
      ctrl._radioButtonRenderFns = [];
      ctrl.init = function (ngModelCtrl) {
        modelCtrl = ngModelCtrl;
        modelCtrl.$render = ctrl.render;
        bindEvents();
      };
      ctrl.add = function (rbRender) {
        ctrl._radioButtonRenderFns.push(rbRender);
      };
      ctrl.remove = function (rbRender) {
        var index = _.indexOf(ctrl._radioButtonRenderFns, rbRender);
        if (index !== -1) {
          ctrl._radioButtonRenderFns.splice(index, 1);
        }
      };
      ctrl.render = function () {
        for (var i = 0; i < ctrl._radioButtonRenderFns.length; i++) {
          ctrl._radioButtonRenderFns[i]();
        }
      };
      ctrl.setViewValue = function (value, eventType) {
        modelCtrl.$setViewValue(value, eventType);
        ctrl.render();
      };
      ctrl.getViewValue = function () {
        return modelCtrl.$viewValue;
      };
      ctrl.selectNext = function () {
        return changeSelectedButton(1);
      };
      ctrl.selectPrevious = function () {
        return changeSelectedButton(-1);
      };

      /**
       * Change the radio group's selected button by a given increment.
       * If no button is selected, select the first button.
       */
      function changeSelectedButton(increment) {
        var buttons = $element.find('.tl-radio-button');
        var nbButtons = buttons.length;
        if (nbButtons > 0) {
          // TODO : skip disabled radio buttons
          var selected = buttons.filter('.tl-checked');
          var index = buttons.index(selected);
          var nextIndex = index + increment;
          if (nextIndex < 0) {
            nextIndex = nbButtons - 1;
          } else if (nextIndex >= nbButtons) {
            nextIndex = 0;
          }
          var target = buttons.eq(nextIndex);
          target.trigger("click");
        }
      }
      function bindEvents() {
        $scope.mouseActive = false;
        $element.on('keydown', keydownListener).on('mousedown', function (event) {
          $scope.mouseActive = true;
          $timeout(function () {
            $scope.mouseActive = false;
          }, 100);
        }).on('focus', function () {
          if ($scope.mouseActive === false) {
            $element.addClass(FOCUSED_CLASS);
          }
        }).on('blur', function () {
          $element.removeClass(FOCUSED_CLASS);
        });
      }
      function setFocus() {
        if (!$element.hasClass(FOCUSED_CLASS)) {
          $element.addClass(FOCUSED_CLASS);
        }
      }
      function keydownListener(ev) {
        var keyCode = ev.which || ev.keyCode;
        switch (keyCode) {
          case keyCodes.LEFT:
          case keyCodes.UP:
            ev.preventDefault();
            ctrl.selectPrevious();
            setFocus();
            break;
          case keyCodes.RIGHT:
          case keyCodes.DOWN:
            ev.preventDefault();
            ctrl.selectNext();
            setFocus();
            break;
          case keyCodes.ENTER:
            var form = $element.closest("form");
            if (form.length > 0) {
              form.triggerHandler('submit');
            }
            break;
        }
      }
    }]
  };
}]);
ngModule.directive("tlRadioButton", function () {
  var CHECKED_CSS = 'tl-checked';
  return {
    restrict: 'E',
    require: '^tlRadioGroup',
    transclude: true,
    replace: true,
    template: '' + '<div class="tl-radio-button">' + '   <div class="tl-radio-container">' + '       <div class="tl-radio-off"></div>' + '       <div class="tl-radio-on"></div>' + '   </div>' + '   <div ng-transclude class="tl-radio-label"></div>' + '</div>',
    link: function link($scope, $el, $attr, rgCtrl) {
      var lastChecked;

      // TODO : handle both [^tlRadioGroup] , [ngModel] and [ngChecked] approaches (look at tl-checkbox)

      initialize();
      function initialize() {
        rgCtrl.add(render);
        $attr.$observe('value', render); // allow ng-value to set the value of the checkbox

        $el.on('click', clickHandler);
        $scope.$on('$destroy', function () {
          rgCtrl.remove(render);
        });
      }
      function clickHandler(ev) {
        if ($el[0].hasAttribute('disabled')) {
          return;
        }
        $scope.$apply(function () {
          rgCtrl.setViewValue($attr.value, ev && ev.type);
        });
        $el.trigger("change");
      }
      function render() {
        var checked = rgCtrl.getViewValue() === $attr.value;
        if (checked === lastChecked) {
          return;
        }
        lastChecked = checked;
        if (checked) {
          $el.addClass(CHECKED_CSS);
        } else {
          $el.removeClass(CHECKED_CSS);
        }
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/inputs/tl-radio-button.js", __webpack_require__(1)))

/***/ }),
/* 2978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);




var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * tlTextInput: Directive "conteneur" qui orchestre les autres.
 * 1. Fournit le template HTML (input, icone, liste de suggestions).
 * 2. Décore la fonction $clear pour qu'elle vide aussi le modèle de suggestion.
 *
 * En option vous pouvez fournir une liste de suggestions :
 * ex:
 * suggestions="collaborateurs" (la liste d'objets pour la suggestion)
 *   suggestion-label="label" (attribut pour afficher dans la liste)
 *   suggestion-text="nom" (attribut pour mettre dans l'input quand on selectionne une des suggestion, par defaut label)
 *   suggestion-model="vm.contributeur" (model à mettre a jout avec l'element selectionné)
 */
ngModule.directive("tlTextInput", ["$parse", function ($parse) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    // Scope hérité pour que les directives communiquent
    template: "\n            <div tl-input-wrapper class=\"tl-text-input-wrapper\" ng-class=\"{ 'open': suggestionsVisible }\">\n                <input tl-text-clear tl-suggestions/>\n                <i class=\"text-icon fa fa-circle-xmark\" ng-click=\"$clear(); $event.stopPropagation();\" ng-show=\"notEmpty()\"></i>\n                <ul class=\"suggestions-list\" ng-if=\"suggestionsVisible && filteredSuggestions.length > 0\">\n                    <li ng-repeat=\"suggestion in filteredSuggestions\" \n                        ng-mousedown=\"selectSuggestion(suggestion)\" \n                        ng-class=\"{ 'active': $index === activeSuggestionIndex }\">\n                        {{ suggestion[suggestionLabel] }}\n                    </li>\n                </ul>\n            </div>\n        ",
    priority: 1000,
    // Priorité haute pour que sa fonction link s'exécute après celles des directives avec une priorité plus basse
    compile: function compile(tElement, tAttrs) {
      // 1. On transfère dynamiquement ng-model (et les attributs de suggestion) 
      // vers l'élément <input> enfant AVANT que les directives ne soient liées.
      var inputElement = tElement.find('input');
      var attrsToTransfer = ['ngModel', 'suggestions', 'suggestionLabel', 'suggestionText', 'suggestionModel'];
      attrsToTransfer.forEach(function (attrName) {
        if (tAttrs[attrName]) {
          var htmlAttrName = tAttrs.$attr[attrName]; // récupère le nom avec tirets (ex: "ng-model")
          inputElement.attr(htmlAttrName, tAttrs[attrName]);
          if (attrName === 'ngModel') {
            tElement.removeAttr(htmlAttrName); // Retire ng-model du div racine pour éviter les conflits
          }
        }
      });

      // 2. On retourne la fonction link
      return function link($scope, $el, $attrs) {
        // On récupère le vrai contrôleur ngModel directement depuis l'élément <input>
        var inputEl = $el.find('input');
        var ngModelCtrl = inputEl.controller('ngModel');

        // La fonction link du parent s'exécute après les controllers des enfants.
        // On peut donc décorer $clear, qui a été défini par tlTextClear.
        if ($scope.$clear && $attrs.suggestionModel) {
          var originalClear = $scope.$clear;
          var suggestionModelSetter = $parse($attrs.suggestionModel).assign;
          $scope.$clear = function () {
            originalClear.apply(this, arguments);
            // Vider le modèle de suggestion en plus du ngModel
            suggestionModelSetter($scope, undefined);
          };
        }
        $scope.notEmpty = function () {
          if (!ngModelCtrl) return false;
          var inputValue = ngModelCtrl.$viewValue || '';
          return inputValue.length > 0;
        };
      };
    }
  };
}]);

/**
 * tlSuggestions:  directive dédiée à la gestion des suggestions.
 * Elle est ajoutée sur l'input et contient toute la logique associée.
 */
ngModule.directive('tlSuggestions', ["$timeout", "$parse", function ($timeout, $parse) {
  return {
    restrict: 'A',
    require: 'ngModel',
    // On a besoin du ngModelController pour lire/écrire la valeur de l'input
    link: function link($scope, $element, $attrs, ngModelCtrl) {
      // Ne rien faire si l'attribut 'suggestions' n'est pas présent
      if (__WEBPACK_IMPORTED_MODULE_1_angular___default.a.isUndefined($attrs.suggestions)) {
        return;
      }
      $scope.filteredSuggestions = [];
      $scope.suggestionsVisible = false;
      $scope.activeSuggestionIndex = -1;
      $scope.suggestionLabel = $attrs.suggestionLabel || 'label';
      $scope.suggestionText = $attrs.suggestionText || 'label';
      var suggestions = [];
      var suggestionModelSetter = $attrs.suggestionModel ? $parse($attrs.suggestionModel).assign : __WEBPACK_IMPORTED_MODULE_1_angular___default.a.noop;

      // Surveiller la collection de suggestions pour les chargements asynchrones
      $scope.$watch($attrs.suggestions, function (newVal) {
        suggestions = newVal || [];
      });
      var filterSuggestions = function filterSuggestions() {
        var inputValue = ngModelCtrl.$viewValue || '';
        if (inputValue.length > 0 && suggestions && suggestions.length > 0) {
          $scope.filteredSuggestions = suggestions.filter(function (item) {
            return item[$scope.suggestionLabel] && item[$scope.suggestionLabel].toLowerCase().includes(inputValue.toLowerCase());
          });
          $scope.suggestionsVisible = $scope.filteredSuggestions.length > 0;
          if (!$scope.suggestionsVisible) {
            suggestionModelSetter($scope, null);
          }
        } else {
          $scope.suggestionsVisible = false;
          suggestionModelSetter($scope, null);
        }
        $scope.activeSuggestionIndex = -1;
      };
      $scope.selectSuggestion = function (suggestion) {
        var text = suggestion[$scope.suggestionText];
        ngModelCtrl.$setViewValue(text);
        ngModelCtrl.$render();
        suggestionModelSetter($scope, suggestion);
        $scope.suggestionsVisible = false;
      };
      $element.on('input focus', function () {
        return $scope.$apply(filterSuggestions);
      });
      $element.on('blur', function () {
        return $timeout(function () {
          $scope.suggestionsVisible = false;
          suggestionModelSetter($scope, null);
        }, 200);
      });
      $element.on('keydown', function (event) {
        if (!$scope.suggestionsVisible) return;
        $scope.$apply(function () {
          switch (event.keyCode) {
            case 38:
              // Up
              event.preventDefault();
              if ($scope.activeSuggestionIndex > 0) $scope.activeSuggestionIndex--;
              break;
            case 40:
              // Down
              event.preventDefault();
              if ($scope.activeSuggestionIndex < $scope.filteredSuggestions.length - 1) $scope.activeSuggestionIndex++;
              break;
            case 13:
              // Enter
              if ($scope.activeSuggestionIndex > -1) {
                event.preventDefault();
                $scope.selectSuggestion($scope.filteredSuggestions[$scope.activeSuggestionIndex]);
              }
              break;
            case 27:
              // Escape
              $scope.suggestionsVisible = false;
              break;
          }
        });
      });
    }
  };
}]);

/**
 * tlTextClear: Directive originale, INCHANGÉE.
 * Son unique rôle est de fournir la fonction $clear pour vider le ngModel.
 */
ngModule.directive('tlTextClear', function () {
  return {
    require: ['tlTextClear', 'ngModel'],
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0];
      var modelCtrl = controllers[1];
      ctrl.setNgModelCtrl(modelCtrl);
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this;
      ctrl.setNgModelCtrl = function (ngModelCtrl) {
        ctrl.ngModelCtrl = ngModelCtrl;
      };
      $scope.$clear = function () {
        if ($element.attr('disabled') === 'disabled' || $element.attr('readonly') === 'readonly') {
          return;
        }
        ctrl.ngModelCtrl.$setViewValue(null);
        ctrl.ngModelCtrl.$render();
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/inputs/tl-text-input.js"))

/***/ }),
/* 2979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * fixez la taille avec class : small, xs
 */
ngModule.directive('tlCircularLoader', function () {
  return {
    restrict: 'E',
    scope: true,
    replace: true,
    template: __webpack_require__(3736),
    link: function link($scope, $el, $attrs) {}
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/loaders/tl-circular-loader.js"))

/***/ }),
/* 2980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Wrapper around the ngRouter to allow nested routes inside a page.
 */
ngModule.factory("$pageRouter", ["$rootScope", "$route", "routeUtils", function ($rootScope, $route, routeUtils) {
  var locationHandlers = [];
  var currentRoute = $route.current,
    previousRoute = null,
    nextRoute = null;
  $rootScope.$on("$routeChangeStart", function (event, _nextRoute, _previousRoute) {
    previousRoute = _previousRoute;
    nextRoute = _nextRoute;
  });
  $rootScope.$on('$locationChangeSuccess', function (event, newUrl, oldUrl) {
    currentRoute = nextRoute;
    var matched = false;

    //console.log("location change", oldUrl, newUrl);

    _.each(locationHandlers, function (locationHandler) {
      var regexp = locationHandler.regexp,
        oldFragment = regexp.exec(oldUrl),
        newFragment = regexp.exec(newUrl);
      if (oldFragment && newFragment && oldFragment[0] !== newFragment[0]) {
        locationHandler.handler(nextRoute.params);
        matched = true;
        // console.log("handler matched", locationHandler.route, oldFragment[0], newFragment[0] );
      }
    });

    // same section -> we hyjack the router behaviour by putting back the old route as $route.current.
    if (matched && previousRoute != null) {
      // console.log("***** current route = ", previousRoute)
      $route.current = previousRoute;
    }
  });
  return {
    getCurrentRoute: function getCurrentRoute() {
      return currentRoute || $route.current;
    },
    registerLocationHandler: function registerLocationHandler(routeSegment, handler) {
      var locationHandler = {
        route: routeSegment,
        regexp: routeUtils.getRouteRegexp(routeSegment, false),
        handler: handler
      };
      locationHandlers.push(locationHandler);
      return function unregister() {
        var handlerIdx = _.indexOf(locationHandlers, locationHandler);
        if (handlerIdx > -1) {
          locationHandlers.splice(handlerIdx, 1);
        }
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/pageRouter.js", __webpack_require__(1)))

/***/ }),
/* 2981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
var pdfObject = __webpack_require__(909);
ngModule.directive("pdfViewer", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      url: "<",
      height: "<",
      page: "<",
      /**
       * ne fonctionne pas avec le embed de pdfObject. Il faudrait tester avec jspdf
       */
      highlightText: "<"
    },
    template: "\n            <div class=\"tl-pdf-viewer\"> \n               <div class=\"pdf-container\"></div> \n            </div>",
    link: function link($scope, $element, $attrs, ctrl) {
      if (pdfObject.supportsPDFs) {
        $scope.$watchGroup(['url', 'page', 'highlightText'], function (newValues) {
          var newUrl = newValues[0];
          var newPage = newValues[1];
          var newText = newValues[2];
          if (newUrl) {
            ctrl.refreshDocument(newUrl, newPage, newText);
          }
        });
      } else {
        $element.find(".pdf-container").text("Votre navigateur ne supporte pas la lecture de fichiers pdf. " + "Veuillez télécharger le lecteur Acrobat reader.");
      }
      $scope.$watch("height", function (height) {
        if (height != null) {
          ctrl.setHeight(height);
        }
      });
      $element.on("mouseenter", function () {
        $scope.$emit('pdfViewer::mouseenter');
      });
    },
    controller: ["$element", function controller($element) {
      var ctrl = this;
      ctrl.refreshDocument = function (baseUrl, page, textToHighlight) {
        if (!baseUrl) {
          return;
        }
        var container = $element.find(".pdf-container");
        container.empty();

        // On utilise l'objet d'options de pdfObject, avec la bonne structure.
        var options = {
          // 'page' est une option de premier niveau.
          page: page || 1
        };

        // 'search' et les autres paramètres doivent aller dans l'objet 'pdfOpenParams'.
        if (textToHighlight) {
          // On ne met PAS les guillemets nous-mêmes. On passe le texte brut.
          // pdfObject s'occupera de formater correctement le paramètre.
          options.pdfOpenParams = {
            search: textToHighlight
          };
        }

        // On laisse pdfObject construire l'URL finale.
        pdfObject.embed(baseUrl, container, options);
      };
      ctrl.setHeight = function (height) {
        $element.css("height", "".concat(height, "px"));
        $element.find(".pdf-container").css("height", "".concat(height, "px"));
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/pdfViewer.js"))

/***/ }),
/* 2982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("gissler", ["security", "urlUtils", "$translate", function (security, urlUtils, $translate) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      gissler: "="
    },
    template: '<span></span>',
    link: function link($scope, $el, $attrs, controller) {
      $scope.$watch("gissler", function () {
        var code;
        if ($scope.gissler == null) {
          return "";
        }
        if ($scope.gissler.indice === 'HORS_CHARTE' || $scope.gissler.structure === 'HORS_CHARTE') {
          code = $translate("lov.structuresGissler.HC");
        } else {
          code = $translate('lov.structuresGissler.' + $scope.gissler.structure) + $translate('lov.indicesGissler.' + $scope.gissler.indice);
        }
        $el.html(code);
        $el.addClass("gissler");
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/pills/gissler.js"))

/***/ }),
/* 2983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Directive affichant l'image associé à une contrepartie.
 *
 * Peut être utilisée de deux façon :
 *
 * 1/ en passant la reference de la contrepartie
 *    via <... contrepartie="ref" ...
 *
 * 2/ en passant les valeurs id et type de la contrepartie
 *    via <... contrepartie-id="{{}}" contrepartie-type="{{}}" ...
 */
ngModule.directive("logoContrepartie", ["security", "urlUtils", function (security, urlUtils) {
  var sizeMap = {
    big: 100,
    small: 50,
    icon: 24
  };
  return {
    restrict: "E",
    replace: true,
    scope: false,
    template: '<img img-scale img-height="40" class="contrepartie-logo">',
    link: function link($scope, $el, $attrs, ctrl) {
      var unwatch;
      if ($attrs.contrepartie) {
        unwatch = $scope.$watch($attrs.contrepartie, function (contrepartie) {
          if (contrepartie == null) {
            return;
          }
          $el.attr("title", contrepartie.libelleJuridique);
          // Le type est quelque fois présent dans l'attribut type, quelque fois dans typeContrepartie..
          ctrl.setContrepartieInfo(contrepartie.id, contrepartie.type || contrepartie.typeContrepartie);
          unwatch();
        });
      } else if ($attrs.contrepartieId) {
        unwatch = $attrs.$observe("contrepartieId", function () {
          ctrl.setContrepartieInfo($attrs.contrepartieId, $attrs.contrepartieType);
          unwatch();
        });
      }
    },
    controller: ["$scope", "$element", "$attrs", function controller($scope, $element, $attrs) {
      var ctrl = this;
      ctrl.setContrepartieInfo = function (cpId, cpType) {
        var iconSize = $attrs.size || "small";
        var iconDimension = sizeMap[iconSize] || sizeMap["small"];
        var isBigIcon = iconDimension >= 100;
        $element.height(iconDimension + "px");
        $element.width(iconDimension + "px");
        $attrs.$set("imgHeight", iconDimension);
        $attrs.$set("imgWidth", iconDimension);
        if (cpId && cpId !== "$NO_ID$") {
          var params = _.extend(security.getTokens(), {
            id: cpId,
            type: cpType
          });
          var url = urlUtils.addParams("/rest/contreparties/logo/" + (isBigIcon ? "big" : "small"), params);
          $element.attr("src", url);
        } else {
          $element.attr("src", "/images/no_image.png");
          $element.attr("title", "Pas de contrepartie rattachée");
        }
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/pills/logoContrepartie.js", __webpack_require__(1)))

/***/ }),
/* 2984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("pillInterfacageEcheance", ["$montantFormat", function ($montantFormat) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      interfacage: "="
    },
    template: '<span title="{{::title}}" class="pill-mandatement-echeance icon-mandatement-{{::interfacage.etat}}-{{::interfacage.montantAChange}}">{{description}}</span>',
    link: function link($scope, $el, $attrs, controller) {
      if ($scope.interfacage.etat === 'AUCUN') {
        $scope.title = $scope.description = "Non transféré";
      }
      var description = function description(libelleEtat, interfacage) {
        if (interfacage.montantAChange) {
          return libelleEtat + " : " + $montantFormat.montant(interfacage.montantMandate, 2) + ", actuel : " + $montantFormat.montant(interfacage.montant, 2);
        }
        return libelleEtat;
      };
      var title = function title(libelleEtat, interfacage) {
        var title = '';
        if (interfacage.infoComplementaireDuRetour) {
          title += interfacage.infoComplementaireDuRetour;
        }
        if (interfacage.montantAChange) {
          title += "Le montant " + libelleEtat + " (" + $montantFormat.montant(interfacage.montantMandate, 2) + ") differt du montant actuel.";
        }
        return title;
      };
      if ($scope.interfacage.etat === 'REJETE') {
        $scope.description = "Rejeté";
        $scope.title = title("rejeté", $scope.interfacage);
      }
      if ($scope.interfacage.etat === 'TRANSFERE') {
        $scope.description = description("Transféré", $scope.interfacage);
        $scope.title = title("transféré", $scope.interfacage);
      }
      if ($scope.interfacage.etat === 'TRAITE') {
        $scope.description = description("Traité", $scope.interfacage);
        $scope.title = title("traité", $scope.interfacage);
      }
      if ($scope.interfacage.etat === 'ACCEPTE') {
        $scope.description = description("Accepté", $scope.interfacage);
        $scope.title = title("accepté", $scope.interfacage);
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/pills/pillInterfacageEcheance.js"))

/***/ }),
/* 2985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("pillNatureProduit", ["security", "urlUtils", "$translate", "$applications", function (security, urlUtils, $translate, $applications) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      nature: "@"
    },
    template: '<span class="pill-nature-produit icon-nature-{{::nature}}" tl-tooltip>' + '<tl-tooltip-content><div class="tooltip">{{::getTooltip()}}</div></tl-tooltip-content></span>',
    link: function link($scope, $el, $attrs) {
      var unwatch = $scope.$watch("nature", function (nature) {
        if (!nature) {
          return;
        }
        if ($applications.isPretApplication()) {
          if ($scope.nature === 'EMPRUNT_BANCAIRE') {
            $scope.nature = 'PRET';
          }
        }
        var initiales = $translate('nature.initiales.' + $scope.nature);
        if (initiales) {
          $el.text(initiales);
        }

        // obligé de recopier dans une autre variable sinon c'est l valeur initiale qui est conservée
        $scope.natureFinal = $scope.nature;
        $scope.getTooltip = function () {
          return $translate('nature.' + $scope.natureFinal);
        };
        unwatch();
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/pills/pillNatureProduit.js"))

/***/ }),
/* 2986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlBindRichtext", function () {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs) {
      $el.addClass("tl-richtext-container");
      $scope.$watch($attrs.tlBindRichtext, function tlBindRichtextWatchAction(value) {
        $el.html(value);
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/richtext/tl-bind-richtext.js"))

/***/ }),
/* 2987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_getNgModule__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tinymce_tinymce__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tinymce_tinymce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_tinymce_tinymce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_core_tinymce_langs_fr_FR__ = __webpack_require__(3030);



function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_getNgModule__["a" /* default */])(__filename);

// console.log("** tinyMCE = ", tinymce);

// UI-tinyMCE
// https://github.com/angular-ui/ui-tinymce/blob/master/src/tinymce.js

ngModule.directive("tlRichtextEditor", ["$authz", function ($authz) {
  return {
    restrict: "E",
    replace: true,
    scope: {},
    bindToController: {},
    require: ["tlRichtextEditor", "?ngModel"],
    template: "\n            <div class=\"tl-richtext-editor\">\n                <div class=\"tl-richtext-content\"></div>\n            </div>\n        ",
    link: function link($scope, $el, $attrs, ctrls) {
      var _ctrls = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(ctrls, 2),
        ctrl = _ctrls[0],
        ngModelCtrl = _ctrls[1];
      ctrl.setNgModel(ngModelCtrl);
    },
    controller: /*#__PURE__*/function () {
      RichTextInputController.$inject = ["$element", "$sce"];
      function RichTextInputController($element, $sce) {
        'ngInject';

        __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, RichTextInputController);
        this.$element = $element;
        this.$sce = $sce;
      }
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(RichTextInputController, [{
        key: "setNgModel",
        value: function setNgModel(ngModel) {
          var _this = this;
          var $sce = this.$sce;
          this.ngModel = ngModel;
          ngModel.$formatters.unshift(function (modelValue) {
            return modelValue ? $sce.trustAsHtml(modelValue) : '';
          });
          ngModel.$parsers.unshift(function (viewValue) {
            return viewValue ? $sce.getTrustedHtml(viewValue) : '';
          });
          ngModel.$render = function () {
            var editor = _this.getEditor();
            // instance.getDoc() check is a guard against null value
            if (editor && editor.getDoc()) {
              var viewValue = ngModel.$viewValue ? $sce.getTrustedHtml(ngModel.$viewValue) : '';
              editor.setContent(viewValue);
              // Triggering change event due to TinyMCE not firing event & becoming out of sync for change callbacks
              editor.fire('change');
            }
          };
        }
      }, {
        key: "updateView",
        value: function updateView() {
          var editor = this.getEditor();
          var content = editor.getContent({
            format: "html"
          }).trim();
          content = this.$sce.trustAsHtml(content);

          // console.log("updateView ->", content);

          this.ngModel.$setViewValue(content);

          /*
          ngModel.$setViewValue(content);
          if (!$rootScope.$$phase) {
              scope.$digest();
          }
          */
        }
      }, {
        key: "getEditor",
        value: function getEditor() {
          if (this.editor == null) {
            this.editor = __WEBPACK_IMPORTED_MODULE_4_tinymce_tinymce___default.a.get(this.editorId);
          }
          return this.editor;
        }
      }, {
        key: "$onDestroy",
        value: function $onDestroy() {
          // console.log("*** on destroy !");
          if (this.editor) {
            this.editor.remove();
            this.editor = null;
          }
        }
      }, {
        key: "$onInit",
        value: function $onInit() {
          var _this2 = this;
          console.log("onInit", this);

          // console.log("*ONINIT")

          this.editorId = _.uniqueId("tl-rich-text");
          this.$element.find(".tl-richtext-content").attr("id", this.editorId);
          if (this.$element.attr('macros')) {
            this.showMacros = true;
          }
          var debouncedUpdateView = function debouncedUpdateView() {};
          var editor = __WEBPACK_IMPORTED_MODULE_4_tinymce_tinymce___default.a.init({
            selector: "#" + this.editorId,
            language: 'fr_FR',
            height: 350,
            menubar: false,
            statusbar: false,
            branding: false,
            theme: "modern",
            skin: false,
            plugins: ['textcolor colorpicker autolink lists link paste table'],
            toolbar: [(this.showMacros ? 'macro | ' : '') + 'bold italic underline forecolor fontsizeselect | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | link | table tableinsertdialog tablecellprops tableprops'],
            /*content_css: [
                '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
                '//www.tinymce.com/css/codepen.min.css']*/
            setup: function setup(ed) {
              ed.on('init', function () {
                _this2.ngModel.$render();
              });
              if (_this2.showMacros) {
                // idealement cette liste devrait être injectée sur la directive, mais j'ai pas réussi à faire cela pour le moment.
                var macros = [{
                  text: 'Budget',
                  items: [{
                    macro: '{budget=INDIQUEZ LE NOM DU BUDGET ICI}',
                    text: 'Change le budget pour la suite du commentaire. Exemple : {Budget=Eau}'
                  }, {
                    macro: '{nom-budget}',
                    text: 'Affiche le nom du budget courant. Si aucun n\'a été choisi, alors affiche \'Tous\''
                  }]
                }];
                macros.push({
                  text: 'Dates',
                  items: [{
                    macro: '{date-visualisation}',
                    text: 'Date de visualisation'
                  }, {
                    macro: '{annee}',
                    text: 'Année de la date de visualisation'
                  }, {
                    macro: '{date-cloture-exercice}',
                    text: 'Date de clôture de l\'exercice'
                  }]
                });
                if ($authz.hasAnyRole("MODULE_DETTE_GARANTIE", "MODULE_DETTE", "MODULE_PLACEMENT", "MODULE_PRET")) {
                  macros.push({
                    text: 'Durées',
                    items: [{
                      macro: '{duration}',
                      text: 'Duration'
                    }, {
                      macro: '{duree-residuelle}',
                      text: 'Durée résiduelle'
                    }, {
                      macro: '{duree-residuelle-moyenne}',
                      text: 'Durée résiduelle moyenne'
                    }]
                  });
                }
                if ($authz.hasAnyRole("MODULE_DETTE_GARANTIE", "MODULE_DETTE", "MODULE_PLACEMENT", "MODULE_PRET")) {
                  macros.push({
                    text: 'Portefeuille',
                    items: [{
                      macro: '{nombre-produits-vivants}',
                      text: 'Nombre de produits non échus'
                    }, {
                      macro: '{nombre-emprunts-vivants}',
                      text: 'Nombre d\'emprunts non échus'
                    }, {
                      macro: '{crd}',
                      text: 'CRD à date de visualisation'
                    }, {
                      macro: '{amortissements-annee}',
                      text: 'Amortissements de l\'année de visualisation'
                    }, {
                      macro: '{interets-annee}',
                      text: 'Intérêts de l\'année de visualisation'
                    }, {
                      macro: '{annuites-annee}',
                      text: 'Annuités de l\'année de la date de visualisation'
                    }, {
                      macro: '{icne-exercice}',
                      text: 'ICNE de l\'exercice'
                    }, {
                      macro: '{taux-moyen-exercice}',
                      text: 'Taux moyen de l\'exercice (base exact/exact)'
                    }, {
                      macro: '{taux-moyen-sur-12-mois}',
                      text: 'Taux moyen sur les 12 prochains mois (base exact/exact)'
                    }]
                  });
                }
                if ($authz.hasAnyRole("MODULE_DETTE_GARANTIE", "MODULE_DETTE", "MODULE_PLACEMENT", "MODULE_PRET")) {
                  macros.push({
                    text: 'Risque',
                    items: [{
                      macro: '{part-taux-fixe}',
                      text: 'Part de l\'encours taux fixe à la date de visualisation'
                    }, {
                      macro: '{part-taux-variable}',
                      text: 'Part de l\'encours taux varibale et structuré à la date de visualisation'
                    }
                    //{macro: '{nombre-produits-taux-fixe-vivants}', text: 'Nombre de produits non échus'},
                    //{macro: '{nombre-produits-taux-variable-vivants}', text: 'Nombre de produits non échus'},
                    ]
                  });
                }
                if ($authz.hasRole("MODULE_DETTE_GARANTIE")) {
                  macros.push({
                    text: 'Dette garantie',
                    items: [{
                      macro: '{encours-garanti-galland}',
                      text: 'Encours garanti sous loi Galland'
                    }, {
                      macro: '{encours-garanti-hors-galland}',
                      text: 'Encours garanti hors loi Galland'
                    }, {
                      macro: '{duree-residuelle-moyenne-dette-garantie}',
                      text: 'Durée résiduelle moyenne de la dette garantie'
                    }]
                  });
                }
                var menuItems = [];
                macros = _.sortBy(macros, ['text']);
                var _iterator = _createForOfIteratorHelper(macros),
                  _step;
                try {
                  var _loop = function _loop() {
                    var macroEntry = _step.value;
                    // menu
                    if (macroEntry.items) {
                      var menuRoot = {
                        text: macroEntry.text
                      };
                      // ajout sous menus

                      var subMenu = [];
                      var _iterator2 = _createForOfIteratorHelper(macroEntry.items),
                        _step2;
                      try {
                        var _loop2 = function _loop2() {
                          var item1 = _step2.value;
                          subMenu.push({
                            text: item1.text,
                            onclick: function onclick() {
                              ed.insertContent(item1.macro);
                            }
                          });
                        };
                        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                          _loop2();
                        }
                      } catch (err) {
                        _iterator2.e(err);
                      } finally {
                        _iterator2.f();
                      }
                      subMenu = _.sortBy(subMenu, ['text']);
                      menuRoot.menu = subMenu;
                      menuItems.push(menuRoot);
                    } else {
                      menuItems.push({
                        type: 'menuitem',
                        text: macroEntry.text,
                        onclick: function onclick() {
                          ed.insertContent(macroEntry.macro);
                        }
                      });
                    }
                  };
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _loop();
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                ed.addButton('macro', {
                  type: 'menubutton',
                  text: 'Macros',
                  icon: false,
                  menu: menuItems
                });
              }
              ed.on('change ExecCommand NodeChange ObjectResized', function (e) {
                // console.log('the editor object ', ed);
                // console.log('the content ', ed.getContent());

                ed.save();
                _this2.updateView();
              });
            }
          });
        }
      }]);
    }()
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/richtext/tl-richtext-editor.js", __webpack_require__(1)))

/***/ }),
/* 2988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

// use : $mdButtonInkRipple.attach(scope, element);

ngModule.factory('$mdButtonInkRipple', ["$mdInkRipple", function MdButtonInkRipple($mdInkRipple) {
  return {
    attach: function attachRipple(scope, element, options) {
      options = angular.extend(optionsForElement(element), options);
      return $mdInkRipple.attach(scope, element, options);
    }
  };
  function optionsForElement(element) {
    if (element.hasClass('md-icon-button')) {
      return {
        isMenuItem: element.hasClass('md-menu-item'),
        fitRipple: true,
        center: true
      };
    } else {
      return {
        isMenuItem: element.hasClass('md-menu-item'),
        dimBackground: true
      };
    }
  }
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/ripple/button-ripple.js", __webpack_require__(3)))

/***/ }),
/* 2989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ 
UtilFactory.$inject = ["$timeout", "$rootScope"];var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory('$mdUtil', UtilFactory);
function UtilFactory($timeout, $rootScope) {
  // Setup some core variables for the processTemplate method

  var $mdUtil = {
    dom: {},
    /**
     * supplant() method from Crockford's `Remedial Javascript`
     * Equivalent to use of $interpolate; without dependency on
     * interpolation symbols and scope. Note: the '{<token>}' can
     * be property names, property chains, or array indices.
     */
    supplant: function supplant(template, values, pattern) {
      pattern = pattern || /\{([^\{\}]*)\}/g;
      return template.replace(pattern, function (a, b) {
        var p = b.split('.'),
          r = values;
        try {
          for (var s in p) {
            if (p.hasOwnProperty(s)) {
              r = r[p[s]];
            }
          }
        } catch (e) {
          r = a;
        }
        return typeof r === 'string' || typeof r === 'number' ? r : a;
      });
    },
    /**
     * Create an implicit getter that caches its `getter()`
     * lookup value
     */
    valueOnUse: function valueOnUse(scope, key, getter) {
      var value = null,
        args = Array.prototype.slice.call(arguments);
      var params = args.length > 3 ? args.slice(3) : [];
      Object.defineProperty(scope, key, {
        get: function get() {
          if (value === null) value = getter.apply(scope, params);
          return value;
        }
      });
    },
    // Stop watchers and events from firing on a scope without destroying it,
    // by disconnecting it from its parent and its siblings' linked lists.
    disconnectScope: function disconnectScope(scope) {
      if (!scope) {
        return;
      }

      // we can't destroy the root scope or a scope that has been already destroyed
      if (scope.$root === scope) {
        return;
      }
      if (scope.$$destroyed) {
        return;
      }
      var parent = scope.$parent;
      scope.$$disconnected = true;

      // See Scope.$destroy
      if (parent.$$childHead === scope) parent.$$childHead = scope.$$nextSibling;
      if (parent.$$childTail === scope) parent.$$childTail = scope.$$prevSibling;
      if (scope.$$prevSibling) scope.$$prevSibling.$$nextSibling = scope.$$nextSibling;
      if (scope.$$nextSibling) scope.$$nextSibling.$$prevSibling = scope.$$prevSibling;
      scope.$$nextSibling = scope.$$prevSibling = null;
    },
    // Undo the effects of disconnectScope above.
    reconnectScope: function reconnectScope(scope) {
      if (!scope) {
        return;
      }

      // we can't disconnect the root node or scope already disconnected
      if (scope.$root === scope) {
        return;
      }
      if (!scope.$$disconnected) {
        return;
      }
      var child = scope;
      var parent = child.$parent;
      child.$$disconnected = false;
      // See Scope.$new for this logic...
      child.$$prevSibling = parent.$$childTail;
      if (parent.$$childHead) {
        parent.$$childTail.$$nextSibling = child;
        parent.$$childTail = child;
      } else {
        parent.$$childHead = parent.$$childTail = child;
      }
    },
    /**
     * Alternative to $timeout calls with 0 delay.
     * nextTick() coalesces all calls within a single frame
     * to minimize $digest thrashing
     *
     * @param callback
     * @param digest
     * @returns {*}
     */
    nextTick: function nextTick(callback, digest, scope) {
      //-- grab function reference for storing state details
      var nextTick = $mdUtil.nextTick;
      var timeout = nextTick.timeout;
      var queue = nextTick.queue || [];

      //-- add callback to the queue
      queue.push(callback);

      //-- set default value for digest
      if (digest == null) {
        digest = true;
      }

      //-- store updated digest/queue values
      nextTick.digest = nextTick.digest || digest;
      nextTick.queue = queue;

      //-- either return existing timeout or create a new one
      return timeout || (nextTick.timeout = $timeout(processQueue, 0, false));

      /**
       * Grab a copy of the current queue
       * Clear the queue for future use
       * Process the existing queue
       * Trigger digest if necessary
       */
      function processQueue() {
        var skip = scope && scope.$$destroyed;
        var queue = !skip ? nextTick.queue : [];
        var digest = !skip ? nextTick.digest : null;
        nextTick.queue = [];
        nextTick.timeout = null;
        nextTick.digest = false;
        queue.forEach(function (callback) {
          callback();
        });
        if (digest) {
          $rootScope.$digest();
        }
      }
    }
  };
  return $mdUtil;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/ripple/ripple-utils.js"))

/***/ }),
/* 2990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, angular) {/* harmony import */ 
InkRippleDirective.$inject = ["$mdButtonInkRipple"];
InkRippleService.$inject = ["$injector"];
InkRippleCtrl.$inject = ["$scope", "$element", "rippleOptions", "$window", "$timeout", "$mdUtil"];var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory('$mdInkRipple', InkRippleService).directive('mdInkRipple', InkRippleDirective).directive('mdNoInk', attrNoDirective).directive('mdNoBar', attrNoDirective).directive('mdNoStretch', attrNoDirective);
var DURATION = 450;

/**
 * Directive used to add ripples to any element
 * @ngInject
 */
function InkRippleDirective($mdButtonInkRipple) {
  return {
    controller: angular.noop,
    link: function link(scope, element, attr) {
      $mdButtonInkRipple.attach(scope, element);
    }
  };
}

/**
 * Service for adding ripples to any element
 * @ngInject
 */
function InkRippleService($injector) {
  return {
    attach: attach
  };
  function attach(scope, element, options) {
    if (element.controller('mdNoInk')) {
      return angular.noop;
    }
    return $injector.instantiate(InkRippleCtrl, {
      $scope: scope,
      $element: element,
      rippleOptions: options
    });
  }
}

/**
 * Controller used by the ripple service in order to apply ripples
 * @ngInject
 */
function InkRippleCtrl($scope, $element, rippleOptions, $window, $timeout, $mdUtil) {
  this.$window = $window;
  this.$timeout = $timeout;
  this.$mdUtil = $mdUtil;
  this.$scope = $scope;
  this.$element = $element;
  this.options = rippleOptions;
  this.mousedown = false;
  this.ripples = [];
  this.timeout = null; // Stores a reference to the most-recent ripple timeout
  this.lastRipple = null;
  $mdUtil.valueOnUse(this, 'container', this.createContainer);
  $mdUtil.valueOnUse(this, 'background', this.getColor, 0.5);
  this.color = this.getColor(1);
  this.$element.addClass('md-ink-ripple');

  // attach method for unit tests
  ($element.controller('mdInkRipple') || {}).createRipple = angular.bind(this, this.createRipple);
  ($element.controller('mdInkRipple') || {}).setColor = angular.bind(this, this.setColor);
  this.bindEvents();
}

/**
 * Returns the color that the ripple should be (either based on CSS or hard-coded)
 * @returns {string}
 */
InkRippleCtrl.prototype.getColor = function () {
  return this._parseColor(this.$element.attr('md-ink-ripple')) || this._parseColor(getElementColor.call(this));

  /**
   * Finds the color element and returns its text color for use as default ripple color
   * @returns {string}
   */
  function getElementColor() {
    var colorElement = this.options.colorElement && this.options.colorElement[0];
    colorElement = colorElement || this.$element[0];
    return colorElement ? this.$window.getComputedStyle(colorElement).color : 'rgb(0,0,0)';
  }
};
/**
 * Takes a string color and converts it to RGBA format
 * @param color {string}
 * @param [multiplier] {int}
 * @returns {string}
 */

InkRippleCtrl.prototype._parseColor = function parseColor(color, multiplier) {
  multiplier = multiplier || 1;
  if (!color) {
    return;
  }
  if (color.indexOf('rgba') === 0) {
    return color.replace(/\d?\.?\d*\s*\)\s*$/, (0.1 * multiplier).toString() + ')');
  }
  if (color.indexOf('rgb') === 0) {
    return rgbToRGBA(color);
  }
  if (color.indexOf('#') === 0) {
    return hexToRGBA(color);
  }

  /**
   * Converts hex value to RGBA string
   * @param color {string}
   * @returns {string}
   */
  function hexToRGBA(color) {
    var hex = color[0] === '#' ? color.substr(1) : color,
      dig = hex.length / 3,
      red = hex.substr(0, dig),
      green = hex.substr(dig, dig),
      blue = hex.substr(dig * 2);
    if (dig === 1) {
      red += red;
      green += green;
      blue += blue;
    }
    return 'rgba(' + parseInt(red, 16) + ',' + parseInt(green, 16) + ',' + parseInt(blue, 16) + ',0.1)';
  }

  /**
   * Converts an RGB color to RGBA
   * @param color {string}
   * @returns {string}
   */
  function rgbToRGBA(color) {
    return color.replace(')', ', 0.1)').replace('(', 'a(');
  }
};

/**
 * Binds events to the root element for
 */
InkRippleCtrl.prototype.bindEvents = function () {
  this.$element.on('mousedown', angular.bind(this, this.handleMousedown));
  this.$element.on('mouseup', angular.bind(this, this.handleMouseup));
  this.$element.on('mouseleave', angular.bind(this, this.handleMouseup));
};

/**
 * Create a new ripple on every mousedown event from the root element
 * @param event {MouseEvent}
 */
InkRippleCtrl.prototype.handleMousedown = function (event) {
  if (this.mousedown) {
    return;
  }
  this.setColor(window.getComputedStyle(this.$element[0])['color']);

  // When jQuery is loaded, we have to get the original event
  if (event.hasOwnProperty('originalEvent')) {
    event = event.originalEvent;
  }
  this.mousedown = true;
  if (this.options.center) {
    this.createRipple(this.container.prop('clientWidth') / 2, this.container.prop('clientWidth') / 2);
  } else {
    this.createRipple(event.layerX, event.layerY);
  }
};

/**
 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
 * mouseup or mouseleave event)
 */
InkRippleCtrl.prototype.handleMouseup = function () {
  if (this.mousedown || this.lastRipple) {
    var ctrl = this;
    this.mousedown = false;
    this.$mdUtil.nextTick(function () {
      ctrl.clearRipples();
    }, false);
  }
};

/**
 * Cycles through all ripples and attempts to remove them.
 * Depending on logic within `fadeInComplete`, some removals will be postponed.
 */
InkRippleCtrl.prototype.clearRipples = function () {
  for (var i = 0; i < this.ripples.length; i++) {
    this.fadeInComplete(this.ripples[i]);
  }
};

/**
 * Creates the ripple container element
 * @returns {*}
 */
InkRippleCtrl.prototype.createContainer = function () {
  var container = angular.element('<div class="md-ripple-container"></div>');
  this.$element.append(container);
  return container;
};
InkRippleCtrl.prototype.clearTimeout = function () {
  if (this.timeout) {
    this.$timeout.cancel(this.timeout);
    this.timeout = null;
  }
};
InkRippleCtrl.prototype.isRippleAllowed = function () {
  var element = this.$element[0];
  do {
    if (!element.tagName || element.tagName === 'BODY') {
      break;
    }
    if (element && element.hasAttribute && element.hasAttribute('disabled')) {
      return false;
    }
  } while (element = element.parentNode);
  return true;
};

/**
 * Creates a new ripple and adds it to the container.  Also tracks ripple in `this.ripples`.
 * @param left
 * @param top
 */
InkRippleCtrl.prototype.createRipple = function (left, top) {
  if (!this.isRippleAllowed()) {
    return;
  }
  var ctrl = this;
  var ripple = angular.element('<div class="md-ripple"></div>');
  var width = ctrl.$element.prop('clientWidth');
  var height = ctrl.$element.prop('clientHeight');
  var x = Math.max(Math.abs(width - left), left) * 2;
  var y = Math.max(Math.abs(height - top), top) * 2;
  var size = getSize(ctrl.options.fitRipple, x, y);
  ripple.css({
    left: left + 'px',
    top: top + 'px',
    background: 'black',
    width: size + 'px',
    height: size + 'px',
    backgroundColor: rgbaToRGB(ctrl.color),
    borderColor: rgbaToRGB(ctrl.color)
  });
  ctrl.lastRipple = ripple;

  // we only want one timeout to be running at a time
  ctrl.clearTimeout();
  ctrl.timeout = ctrl.$timeout(function () {
    ctrl.clearTimeout();
    if (!ctrl.mousedown) {
      ctrl.fadeInComplete(ripple);
    }
  }, DURATION * 0.35, false);
  if (this.options.dimBackground) {
    this.container.css({
      backgroundColor: this.background
    });
  }
  this.container.append(ripple);
  this.ripples.push(ripple);
  ripple.addClass('md-ripple-placed');
  ctrl.$mdUtil.nextTick(function () {
    ripple.addClass('md-ripple-scaled md-ripple-active');
    ctrl.$timeout(function () {
      ctrl.clearRipples();
    }, DURATION, false);
  }, false);
  function rgbaToRGB(color) {
    return color ? color.replace('rgba', 'rgb').replace(/,[^\),]+\)/, ')') : 'rgb(0,0,0)';
  }
  function getSize(fit, x, y) {
    return fit ? Math.max(x, y) : Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
  }
};
InkRippleCtrl.prototype.setColor = function (color) {
  this.color = this._parseColor(color);
};

/**
 * Either kicks off the fade-out animation or queues the element for removal on mouseup
 * @param ripple
 */
InkRippleCtrl.prototype.fadeInComplete = function (ripple) {
  if (this.lastRipple === ripple) {
    if (!this.timeout && !this.mousedown) {
      this.removeRipple(ripple);
    }
  } else {
    this.removeRipple(ripple);
  }
};

/**
 * Kicks off the animation for removing a ripple
 * @param ripple {Element}
 */
InkRippleCtrl.prototype.removeRipple = function (ripple) {
  var ctrl = this;
  var index = ctrl.ripples.indexOf(ripple);
  if (index < 0) {
    return;
  }
  ctrl.ripples.splice(ctrl.ripples.indexOf(ripple), 1);
  ripple.removeClass('md-ripple-active');
  if (this.ripples.length === 0) {
    this.container.css({
      backgroundColor: ''
    });
  }
  // use a 2-second timeout in order to allow for the animation to finish
  // we don't actually care how long the animation takes
  ctrl.$timeout(function () {
    ctrl.fadeOutComplete(ripple);
  }, DURATION, false);
};

/**
 * Removes the provided ripple from the DOM
 * @param ripple
 */
InkRippleCtrl.prototype.fadeOutComplete = function (ripple) {
  ripple.remove();
  this.lastRipple = null;
};

/**
 * Used to create an empty directive.  This is used to track flag-directives whose children may have
 * functionality based on them.
 *
 * Example: `md-no-ink` will potentially be used by all child directives.
 */
function attrNoDirective() {
  return {
    controller: angular.noop
  };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/ripple/ripple.js", __webpack_require__(3)))

/***/ }),
/* 2991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.run(["tlSelectConfigRegistry", "banqueSelectConfig", "allBanqueSelectConfig", function (tlSelectConfigRegistry, banqueSelectConfig, allBanqueSelectConfig) {
  tlSelectConfigRegistry.registerConfig("banque", banqueSelectConfig);
  tlSelectConfigRegistry.registerConfig("all-banque", allBanqueSelectConfig);
}]);
ngModule.factory("banqueSearchMatcher", ["stringUtils", function (stringUtils) {
  return function (text, option) {
    return stringUtils.containsIgnoringCaseAndAccents(option.libelleJuridique, text) || stringUtils.containsIgnoringCaseAndAccents(option.libelleCourtUsuel, text) || stringUtils.containsIgnoringCaseAndAccents(option.groupLabel, text);
  };
}]);
ngModule.factory("banqueSelectConfig", ["banqueSearchMatcher", "banqueSelectPopin", function (banqueSearchMatcher, banqueSelectPopin) {
  return {
    idAttribute: "id",
    optionTemplate: __webpack_require__(947),
    optionsFilter: function optionsFilter(option) {
      return option.$inCompte;
    },
    sort: function sort(a, b) {
      var attrA = a.libelleCourtUsuel;
      var attrB = b.libelleCourtUsuel;
      return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
    },
    expandButton: {
      label: "Toutes les banques",
      handler: function handler(ctrl) {
        ctrl.closeDropdown();
        banqueSelectPopin.open().then(function (selected) {
          ctrl.setSelectedOptionById(selected.id);
        });
      }
    },
    allowEmptySelect: false,
    matcher: banqueSearchMatcher
  };
}]);
ngModule.factory("allBanqueSelectConfig", ["banqueSearchMatcher", function (banqueSearchMatcher) {
  return {
    idAttribute: "id",
    optionTemplate: __webpack_require__(947),
    groupBy: "groupLabel",
    groupLabelTemplate: "<span>{{::group.value}}</span>",
    matcher: banqueSearchMatcher,
    allowEmptySelect: false
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/selectbox/configs/banques/banqueSelectConfig.js"))

/***/ }),
/* 2992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
var banqueSelectPopinModal = {
  controller: "banqueSelectPopinController",
  template: __webpack_require__(3737),
  options: {
    width: 800
  }
};
ngModule.factory("banqueSelectPopin", ["$modal", function ($modal) {
  return {
    open: function open() {
      return $modal.open(_objectSpread({}, banqueSelectPopinModal));
    }
  };
}]);
ngModule.controller("banqueSelectPopinController", ["$scope", "contrepartieService", "banqueSearchMatcher", function ($scope, contrepartieService, banqueSearchMatcher) {
  var ctrl = this;
  ctrl.searchTerm = "";
  ctrl.banques = [];
  contrepartieService.getContreparties().then(function (banques) {
    ctrl.banques = banques;
    refreshResults();
  });
  $scope.selectBanque = function (banque) {
    $scope.$close(banque);
  };
  $scope.$watch(function () {
    return ctrl.searchTerm;
  }, function () {
    return refreshResults();
  });
  var refreshResults = function refreshResults() {
    var filtered = _.filter(ctrl.banques, function (b) {
      return banqueSearchMatcher(ctrl.searchTerm, b);
    });
    var groups = [];
    _.each(filtered, function (option) {
      var optGroupByValue = option.groupLabel;
      var group = _.find(groups, {
        value: optGroupByValue
      });
      if (group == null) {
        group = {
          value: optGroupByValue,
          options: []
        };
        groups.push(group);
      }
      group.options.push(option);
    });
    ctrl.results = groups;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/selectbox/configs/banques/banqueSelectPopin.js", __webpack_require__(1)))

/***/ }),
/* 2993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.run(["tlSelectConfigRegistry", "currencySelectConfig", function (tlSelectConfigRegistry, currencySelectConfig) {
  tlSelectConfigRegistry.registerConfig("currency", currencySelectConfig);
}]);
ngModule.factory("currencySelectConfig", function () {
  return {
    idAttribute: "isoCode",
    groupBy: "majorCurrency",
    optionTemplate: __webpack_require__(3739),
    groupLabelTemplate: __webpack_require__(3738)
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/selectbox/configs/currencies/currencySelectConfig.js"))

/***/ }),
/* 2994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("DemandeCreationFinanceurPopinController", ["$scope", "$session", "$applications", function ($scope, $session, $applications) {
  $scope.appPath = $applications.getCurrentAppPath();
  $scope.telephoneFixe = $session.getUser().telephoneFixe;
  $scope.telephonePortable = $session.getUser().telephonePortable;
  $scope.hasTelephone = $scope.telephoneFixe != null || $scope.telephonePortable != null;
  $scope.emptyMessage = function () {
    // au moins 3 carac
    $scope.message == null || $scope.message.comment.length < 3;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/selectbox/configs/finaceursSubvention/demande-creation-financeur/demandeCreationFinanceurPopin.js"))

/***/ }),
/* 2995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.run(["tlSelectConfigRegistry", "financeurSubventionSelectConfig", "allFinanceurSubventionSelectConfig", function (tlSelectConfigRegistry, financeurSubventionSelectConfig, allFinanceurSubventionSelectConfig) {
  tlSelectConfigRegistry.registerConfig("financeur-subvention", financeurSubventionSelectConfig);
  tlSelectConfigRegistry.registerConfig("all-financeur-subvention", allFinanceurSubventionSelectConfig);
}]);
ngModule.factory("financeurSubventionSearchMatcher", ["stringUtils", function (stringUtils) {
  return function (text, option) {
    return stringUtils.containsIgnoringCaseAndAccents(option.libelleJuridique, text) || stringUtils.containsIgnoringCaseAndAccents(option.libelleCourtUsuel, text) || stringUtils.containsIgnoringCaseAndAccents(option.departement, text) || stringUtils.containsIgnoringCaseAndAccents(option.groupLabel, text);
  };
}]);
ngModule.factory("financeurSubventionSelectConfig", ["financeurSubventionSearchMatcher", "financeurSubventionSelectPopin", function (financeurSubventionSearchMatcher, financeurSubventionSelectPopin) {
  return {
    idAttribute: "id",
    optionTemplate: __webpack_require__(948),
    optionsFilter: function optionsFilter(option) {
      return option.$inCompte;
    },
    sort: function sort(a, b) {
      var attrA = a.libelleCourtUsuel;
      var attrB = b.libelleCourtUsuel;
      return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
    },
    expandButton: {
      label: "Tous les financeurs",
      handler: function handler(ctrl) {
        ctrl.closeDropdown();
        financeurSubventionSelectPopin.open().then(function (selected) {
          ctrl.setSelectedOptionById(selected.id);
        });
      }
    },
    allowEmptySelect: false,
    matcher: financeurSubventionSearchMatcher
  };
}]);
ngModule.factory("allFinanceurSubventionSelectConfig", ["financeurSubventionSearchMatcher", function (financeurSubventionSearchMatcher) {
  return {
    idAttribute: "id",
    optionTemplate: __webpack_require__(948),
    groupBy: "groupLabel",
    groupLabelTemplate: "<span>{{::group.value}}</span>",
    matcher: financeurSubventionSearchMatcher,
    allowEmptySelect: false
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/selectbox/configs/finaceursSubvention/financeurSubventionSelectConfig.js"))

/***/ }),
/* 2996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
var financeurSubventionSelectPopinModal = {
  controller: "financeurSubventionSelectPopinController",
  template: __webpack_require__(3741),
  options: {
    width: 800
  }
};
ngModule.factory("financeurSubventionSelectPopin", ["$modal", function ($modal) {
  return {
    open: function open() {
      return $modal.open(_objectSpread({}, financeurSubventionSelectPopinModal));
    }
  };
}]);
ngModule.controller("financeurSubventionSelectPopinController", ["$scope", "contrepartieService", "financeurSubventionSearchMatcher", "$dialogBox", "$modal", "$http", "$timeout", "$element", function ($scope, contrepartieService, financeurSubventionSearchMatcher, $dialogBox, $modal, $http, $timeout, $element) {
  var ctrl = this;
  ctrl.searchTerm = "";
  ctrl.financeurs = [];
  contrepartieService.getFinanceursSubvention().then(function (financeurs) {
    ctrl.financeurs = financeurs;
    refreshResults();
  });
  $timeout(function () {
    $element.find('.tl-select-searchbox')[0].focus();
  }, 100, false);
  $scope.selectBanque = function (financeur) {
    $scope.$close(financeur);
  };
  $scope.$watch(function () {
    return ctrl.searchTerm;
  }, function () {
    return refreshResults();
  });
  var refreshResults = function refreshResults() {
    var filtered = _.filter(ctrl.financeurs, function (b) {
      return financeurSubventionSearchMatcher(ctrl.searchTerm, b);
    });
    var groups = [];
    _.each(filtered, function (option) {
      var optGroupByValue = option.groupLabel;
      var group = _.find(groups, {
        value: optGroupByValue
      });
      if (group == null) {
        group = {
          value: optGroupByValue,
          options: []
        };
        groups.push(group);
      }
      group.options.push(option);
    });
    ctrl.results = groups;
  };
  $scope.demandeCreationFinanceur = function () {
    $modal.open({
      controller: "DemandeCreationFinanceurPopinController",
      template: __webpack_require__(3740)
    }).then(function (message) {
      $http.post("/rest/aide-subvention/financeur-subvention/demande-creation", message.comment).then(function () {
        $dialogBox.alert({
          title: 'Demande création effectuée',
          html: '<p>La demande a été transmise. Elle sera réalisé dans les meilleurs délais. ' + 'Un ticket a été créé sur la plateforme pour vous permettre de suivre le traitement de votre demande.</p>' + '<p>En attendant, nous vous suggérons de choisir dans la liste des financeurs \'<span class="b">Autre</span>\'. ' + 'Vous pourrez modifier ce financeur une fois celui demandé créé.</p>'
        });
      });
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/selectbox/configs/finaceursSubvention/financeurSubventionSelectPopin.js", __webpack_require__(1)))

/***/ }),
/* 2997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

// TODO : handle disabled with ng-disabled
// TODO : how to wire to sp-field
// TODO : open up or down depending on absolute position on the screen
// TODO : permettre la deselection
// TODO : specifier le placeholder
// TODO : ouvrir la popin quand on commence à tapper du texte
// TODO : allow alternative template for selected option
/**
 * ex :
 *<pre>
 * <tl-select ng-model="emprunt.devise" base-config-name="currency"  options="currencies"></tl-select>
 * </pre>
 * <pre>
 * <tl-select ng-model="test.currency" base-config-name="currency"  select-config="currencySelectConfig" empty-option-label="Aucune">
 *</pre>
 *  avec
 * $scope.currencySelectConfig = {
 options : "currencies",
 idAttribute : "isoCode",
 groupBy : "majorCurrency"
 };

 *<br/><br/>
 * attention, l'initialisation (et la lecture des attributs) est faite dans le link. Résultat le config associcée à select-config
 * peut ne pas être trouvée dans le $scope si elle est déclarée dans un controller qui serait chargé après la directive. Cela arrive
 * avec les $modal. J'ai implementé un watch pour contourner le soucis, mais cela reste à valider à l'épreuve des utilisations.
 *
 */
ngModule.directive("tlSelect", ["keyCodes", "$q", "$timeout", "$parse", "$debounce", "$compile", "stringUtils", "objectUtils", "templateUtils", "tlSelectConfigRegistry", function (keyCodes, $q, $timeout, $parse, $debounce, $compile, stringUtils, objectUtils, templateUtils, tlSelectConfigRegistry) {
  var defaultSelectConfig = {
    idAttribute: "id",
    groupBy: null,
    groupLabelTemplate: "<span>{{::group.value}}</span>",
    showSearch: true,
    matcher: function matcher(text, option) {
      for (var attribute in option) {
        if (option.hasOwnProperty(attribute)) {
          var value = option[attribute];
          if (_.isString(value) && stringUtils.containsIgnoringCaseAndAccents(value, text)) {
            return true;
          }
        }
      }
      return false;
    }
  };
  return {
    restrict: "E",
    replace: true,
    transclude: true,
    scope: true,
    template: __webpack_require__(3742),
    controllerAs: "$select",
    require: ["tlSelect", "ngModel"],
    link: function link($scope, $el, $attrs, controllers) {
      var tlSelect = controllers[0],
        ngModel = controllers[1];
      tlSelect.setModelCtrl(ngModel);
      tlSelect._initialize();
    },
    controller: ["$scope", "$element", "$attrs", function controller($scope, $element, $attrs) {
      var ctrl = this,
        source = null,
        config = null,
        modelCtrl = null,
        dropdownEl = null,
        optionTranscludeFn = null,
        groupLabelTranscludeFn = null,
        valueAtOpening = null,
        unwatchSelectConfig = null,
        unwatchSource;
      ctrl.state = {
        focused: false,
        opened: false,
        ignoreHover: false,
        activeOptionIdx: null,
        selectedOption: null,
        searchTerm: "",
        // true si la source qui fourni les options est chargée (pas à undefined)
        sourceLoaded: false,
        // true si les options ont pu être construites, on peut retirer les loader et afficher l'accès a la liste d'options
        loadingRenderDone: false
      };
      var focusIsInsideWidget = function focusIsInsideWidget() {
        var focusParents = $(document.activeElement).parents().addBack();
        return focusParents.index($element) > -1 || focusParents.index(dropdownEl) > -1;
      };
      ctrl.setModelCtrl = function (ngModel) {
        modelCtrl = ngModel;
        wireToModel();
      };
      ctrl._initialize = function () {
        ctrl.processConfiguration();
        unwatchSource = watchSource();
        watchSearch();
      };
      ctrl.getConfig = function () {
        return config;
      };

      // we need to wait for the dropdown element to link it's template to access the real element.
      ctrl.setDropdownCtrl = function (dropdownCtrl) {
        dropdownEl = dropdownCtrl.getElement();
        bindEvents();
      };
      ctrl.shouldDisplayOption = function (option) {
        return config.optionsFilter(option);
      };

      /**
       * Process widget configuration,
       * picking options from config and from attributes.
       */
      ctrl.processConfiguration = function () {
        config = angular.copy(defaultSelectConfig);
        if ($attrs.baseConfigName) {
          var baseConfig = tlSelectConfigRegistry.getConfig($attrs.baseConfigName);
          if (baseConfig != null) {
            _.extend(config, baseConfig);
          }
        }
        if ($attrs.selectConfig) {
          var attrConfig = $scope.$eval($attrs.selectConfig);
          //console.log('config on attribute is named ' + $attrs.selectConfig, attrConfig);
          if (attrConfig) {
            $scope.attrConfig = attrConfig;
            _.extend(config, attrConfig);
          }

          // ceci est nécessaire si la config est déclarée dans le controller alors que cette partie du code est executé dans le link de la directive select.
          // le selectConfig peut donc ne pas etre encore dispo (exemple avec les fenetre $modal)
          if (!attrConfig) {
            if (unwatchSelectConfig) {
              console.error('ERROR : Config cannot be found in scope for select-config named -> ' + $attrs.selectConfig);
            } else {
              unwatchSelectConfig = $scope.$watch($attrs.selectConfig, function (newVal, oldVal) {
                if ($attrs.selectConfig && !angular.equals(newVal, oldVal) || !$scope.attrConfig) {
                  console.debug('processConfiguration again based on attibute config provided in scope', oldVal, newVal);
                  ctrl.processConfiguration();
                  // todo - surement besoin d'unwatch avant
                  if (unwatchSource) {
                    console.debug('Unwatch source');
                    unwatchSource();
                  }
                  watchSource();
                  watchSearch();
                }
              });
            }
          } else {
            // unbind le watch
            if (unwatchSelectConfig) {
              unwatchSelectConfig();
            }
          }
        }
        if ($attrs.idAttribute) {
          config.idAttribute = $attrs.idAttribute;
        }
        if ($attrs.groupBy) {
          config.groupBy = $attrs.groupBy;
        }
        if ($attrs.options) {
          config.options = $attrs.options;
          // console.log('override options with attribute options ' + $attrs.options);
        }
        if ($attrs.emptyOptionLabel) {
          config.emptyOptionLabel = $attrs.emptyOptionLabel;
        }
        if ($attrs.fixedOptionWidth) {
          config.fixedOptionWidth = $attrs.fixedOptionWidth;
        }
        if ($attrs.optionLabelAttribute) {
          config.optionLabelAttribute = $attrs.optionLabelAttribute;
        }
        if ($attrs.optionLabelFct) {
          //console.log('override options with attribute optionLabelFct ' + $attrs.optionLabelFct);
          config.optionLabelFct = $attrs.optionLabelFct;
        }
        if ($attrs.optionTemplateUrl) {
          config.optionTemplateUrl = $attrs.optionTemplateUrl;
        }
        if (config.sort && !config.sortable) {
          config.sortable = true;
        }
        if ($attrs.sortable) {
          config.sortable = $attrs.sortable;
        }
        if ($attrs.sortAttribute) {
          config.sortAttribute = $$attrs.sortAttribute;
        }

        // observe
        $attrs.$observe("disabled", function (disabled) {
          $scope.disabled = $scope.$eval(disabled) == true;
        });
        if ($attrs.optionsFilter) {
          config.optionsFilter = $scope[$attrs.optionsFilter];
        }

        // option template
        // TODO : factorisable dans templateUtils.
        if (config.optionTemplateUrl) {
          templateUtils.load(config.optionTemplateUrl).then(function (template) {
            config.optionLinkFn = $compile(template);
          });
        } else if (config.optionTemplate) {
          config.optionLinkFn = $compile(config.optionTemplate);
        } else {
          var labelOption;
          if (config.optionLabelFct) {
            // todo - ne marche pas pour le moment, erreur à la compilation
            // console.log('config.optionLabelFct', config.optionLabelFct, config);
            labelOption = '{{ ' + config.optionLabelFct + "(option)}}";
          } else {
            labelOption = '{{option.' + (config.optionLabelAttribute ? config.optionLabelAttribute : 'label') + '}}';
          }
          config.optionLinkFn = $compile('<div class="report-template-option">' + ' <span class="label">' + labelOption + '</span>' + '</div>');
        }

        // group label template
        if (config.groupLabelTemplateUrl) {
          templateUtils.load(config.groupLabelTemplateUrl).then(function (template) {
            config.groupLabelLinkFn = $compile(template);
          });
        } else if (config.groupLabelTemplate) {
          config.groupLabelLinkFn = $compile(config.groupLabelTemplate);
        }
        if (config.emptyOptionLabel && !config.emptyOption) {
          config.emptyOption = {
            $empty: true,
            label: config.emptyOptionLabel
          };
        }
        if (config.optionsFilter == null) {
          config.optionsFilter = function () {
            return true;
          };
        }
        ctrl.config = config;
      };
      var watchSearch = function watchSearch() {
        $scope.$watch("$select.state.searchTerm", $debounce(function (searchTerm, oldValue) {
          if (searchTerm === oldValue) {
            return;
          }
          refreshOptionList();
        }, 200));
      };
      var watchSource = function watchSource() {
        var sourceName = config.options;
        // console.log("watchSource config =", config);
        var unwatch = $scope.$watch(sourceName, function (sourceValue) {
          //console.log("source for options loaded : ", sourceValue);
          source = sourceValue;
          if (sourceValue !== undefined) {
            refreshOptionList();
            applyModelValue();
            console.debug('Source [' + sourceName + '] changed - sourceLoaded-> true');
            ctrl.state.sourceLoaded = true;
          }
        });
        return unwatch;
      };
      var refreshOptionList = function refreshOptionList() {
        //     console.log("source for options", source);

        var sourceValue = source;
        var emptyOption = config.emptyOption;

        // filter with given options filter
        // TODO : need to also check if the value is (was ?) selected
        sourceValue = _.filter(sourceValue, function (item) {
          return item.$forceDisplay || config.optionsFilter(item) || ctrl.state.selectedOption === item;
        });

        // Filtering source
        if (config.matcher && ctrl.state.searchTerm.length > 0) {
          sourceValue = _.filter(sourceValue, function (element) {
            return config.matcher(ctrl.state.searchTerm, element);
          });
          ctrl.setActiveOptionIdx(-1);
          $element.find(".tl-select-dropdown-options").scrollTop(0);
          emptyOption = null; // no empty option when searching ?
        }
        var groupBy = config.groupBy;
        if (groupBy) {
          var groups = [];
          var groupLabelParser = $parse(groupBy);

          // grouping options per groups
          _.each(sourceValue, function (option) {
            var optGroupByValue = groupLabelParser(option);
            var group = _.find(groups, {
              value: optGroupByValue
            });
            if (group == null) {
              group = {
                value: optGroupByValue,
                options: []
              };
              groups.push(group);
            }
            group.options.push(option);
          });

          // counting index for options inside group
          var initialIdx = 0;
          if (emptyOption != null) {
            groups.unshift({
              noGroup: true,
              options: [emptyOption]
            });
          }
          _.each(groups, function (group) {
            group.initialIdx = initialIdx;
            initialIdx += group.options.length;
          });
          ctrl.groups = groups;
        } else {
          ctrl.groups = [{
            noGroup: true,
            initialIdx: 0,
            options: sourceValue
          }];
          if (emptyOption != null) {
            ctrl.groups[0].options.unshift(emptyOption);
          }
        }

        //console.log('config.sortable', config.sortable)
        if (_.isFunction(config.sort)) {
          _.each(ctrl.groups, function (group) {
            return group.options.sort(config.sort);
          });
        } else if (config.sortable == 'true' || config.sortable === true) {
          _.each(ctrl.groups, function (group) {
            return group.options.sort(function (a, b) {
              var attrA = a[config.sortAttribute || config.optionLabelAttribute || 'label'];
              var attrB = b[config.sortAttribute || config.optionLabelAttribute || 'label'];
              return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
            });
          });
        }

        // si la source n'est pas encore chargée on ne veut laisser crtl.source à undefined
        if (ctrl.state.sourceLoaded || ctrl.groups && (ctrl.groups.length > 1 ||
        // au moins 1 option (qui peut etre celle empty)
        ctrl.groups.length > 0 && ctrl.groups[0].options.length > 0 && (ctrl.groups[0].options.length > 1 || ctrl.groups[0].options[0].$empty !== true))) {
          // to have correct indegroups[x after in-group distribution.
          ctrl.source = _.flatten(_.map(ctrl.groups, "options"));
          ctrl.state.sourceLoaded = true;
        }
        ctrl.state.loadingRenderDone = true;
      };
      ctrl.setOptionTranscludeFn = function (transcludeFn) {
        optionTranscludeFn = transcludeFn;
      };
      ctrl.getOptionTranscludeFn = function () {
        return optionTranscludeFn || config.optionLinkFn;
      };
      ctrl.setGroupLabelTranscludeFn = function (transcludeFn) {
        groupLabelTranscludeFn = transcludeFn;
      };
      ctrl.getGroupLabelTranscludeFn = function () {
        return groupLabelTranscludeFn || config.groupLabelLinkFn;
      };
      var bindEvents = function bindEvents() {
        // click on collapsed select
        $element.find(".tl-select-selection").click(function () {
          ctrl.toggleDropdown();
          $scope.$apply();
        });
        var focusOutPromise = null;
        var cancelFocusOut = function cancelFocusOut() {
          if (focusOutPromise != null) {
            $timeout.cancel(focusOutPromise);
            focusOutPromise = null;
          }
        };

        // focusin
        var selectAndDropdown = $element.add(dropdownEl);
        selectAndDropdown.bind("focusin", function (e) {
          cancelFocusOut();
          ctrl.state.focused = true;
          $scope.$apply();
        });

        // focusout
        selectAndDropdown.bind("focusout", function () {
          cancelFocusOut();
          focusOutPromise = $timeout(function () {
            $scope.$apply(function () {
              if (!ctrl.state.focused) {
                return;
              }
              if (focusIsInsideWidget()) {
                return;
              }
              ctrl.closeDropdown();
              ctrl.state.focused = false;
              focusOutPromise = null;
            });
          }, 100, false);
        });

        // Réactiver le hover si l'utilisateur bouge physiquement la souris
        dropdownEl.mousemove(function (e) {
          if (ctrl.state.ignoreHover) {
            ctrl.state.ignoreHover = false;

            // Rendre l'option survolée active immédiatement
            var optionEl = $(e.target).closest(".tl-select-dropdown-option");
            if (optionEl.length > 0) {
              var optionIdx = parseInt(optionEl.attr("option-idx"), 10);
              if (!isNaN(optionIdx) && ctrl.state.activeOptionIdx !== optionIdx) {
                $scope.$apply(function () {
                  ctrl.setActiveOptionIdx(optionIdx, false);
                });
              }
            }
          }
        });

        // keyboard events
        selectAndDropdown.keydown(function (e) {
          $scope.$apply(function () {
            // Bloquer le hover lors de la navigation au clavier
            if ([keyCodes.UP, keyCodes.DOWN, keyCodes.HOME, keyCodes.END, keyCodes.PAGE_UP, keyCodes.PAGE_DOWN].includes(e.which)) {
              ctrl.state.ignoreHover = true;
            }
            switch (e.which) {
              case keyCodes.UP:
                e.preventDefault();
                if (ctrl.isDropdownOpened()) {
                  if (ctrl.state.activeOptionIdx > 0) {
                    var idx = ctrl.state.activeOptionIdx - 1;
                    ctrl.setSelectedOptionIdx(idx, true, true);
                    ctrl.setActiveOptionIdx(idx, true);
                    ctrl.scrollToActiveOption();
                  }
                } else {
                  ctrl.openDropdown();
                }
                break;
              case keyCodes.DOWN:
                {
                  e.preventDefault();
                  if (ctrl.isDropdownOpened()) {
                    if (ctrl.state.activeOptionIdx < ctrl.source.length - 1) {
                      var _idx = ctrl.state.activeOptionIdx + 1;
                      ctrl.setSelectedOptionIdx(_idx, true, true);
                      ctrl.setActiveOptionIdx(_idx, true);
                      ctrl.scrollToActiveOption();
                    }
                  } else {
                    ctrl.openDropdown();
                  }
                  break;
                }
              case keyCodes.ESCAPE:
                e.preventDefault();
                ctrl.closeDropdown();
                break;
              case keyCodes.ENTER:
                e.preventDefault();
                if (ctrl.isDropdownOpened()) {
                  if (ctrl.state.activeOptionIdx > -1) {
                    ctrl.setSelectedOptionIdx(ctrl.state.activeOptionIdx, true);
                  } else {
                    ctrl.closeDropdown();
                  }
                } else {
                  ctrl.toggleDropdown();
                }
                break;
              case keyCodes.HOME:
              case keyCodes.PAGE_UP:
                e.preventDefault();
                ctrl.setActiveOptionIdx(0, true);
                ctrl.scrollToActiveOption();
                break;
              case keyCodes.END:
              case keyCodes.PAGE_DOWN:
                e.preventDefault();
                ctrl.setActiveOptionIdx(ctrl.source.length - 1, true);
                ctrl.scrollToActiveOption();
                break;
            }
          });
        });
      };
      ctrl.scrollToActiveOption = function () {
        if (!ctrl.state.opened) {
          return;
        }

        // TODO : when grouped by and scrolling to first option of a group, scroll up to the group label instead

        var container = dropdownEl.find(".tl-select-dropdown-options"),
          option = container.find(".tl-select-dropdown-option[option-idx=" + ctrl.state.activeOptionIdx + "]");
        if (option.length === 0) {
          return;
        }
        var currentScroll = container.scrollTop(),
          containerHeight = container.height(),
          optionPosition = option.position().top + currentScroll,
          optionHeight = option.outerHeight();
        if (optionPosition < currentScroll) {
          container.scrollTop(optionPosition);
        } else if (optionPosition + optionHeight > currentScroll + containerHeight) {
          container.scrollTop(optionPosition + optionHeight - containerHeight);
        }
      };

      /**
       * Sets the active (hovered) option index.
       *
       * @param idx The index of the option to select
       * @param [setSelected] if set to true, it will also set the option as the selected one.
       */
      ctrl.setActiveOptionIdx = function (idx, setSelected) {
        ctrl.state.activeOptionIdx = idx;
        $scope.$broadcast("tl-select:active-change", idx);
        if (setSelected && idx > -1) {
          ctrl.setSelectedOptionIdx(idx, false);
        }
      };

      /**
       * Set the selected option index.
       *
       * @param idx The index of the option to select
       * @param [apply] if set to true, will close the dropdown after selection.
       * @param keepOpen ne referme pas la liste de selection au moment de la selection
       */
      ctrl.setSelectedOptionIdx = function (idx, apply, keepOpen) {
        var selectedOption = ctrl.source[idx];
        ctrl.setSelectedOption(selectedOption, apply, keepOpen);
      };
      ctrl.setSelectedOption = function (option, apply, keepOpenOptions) {
        if (ctrl.state.selectedOption !== option) {
          option.$forceDisplay = true;
          ctrl.state.selectedOption = option;
          refreshOptionList();
        }
        if (apply) {
          if (ctrl.state.opened) {
            if (!keepOpenOptions) {
              ctrl.closeDropdown();
            }
          } else {
            syncValueToModel();
          }
        }
      };
      ctrl.setSelectedOptionById = function (optionId) {
        var apply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        // TODO
        var idAttribute = config.idAttribute || "id";
        var selectedOption = _.find(source, function (option) {
          return objectUtils.getProperty(option, idAttribute) === optionId;
        });
        ctrl.setSelectedOption(selectedOption, apply);
      };
      ctrl.isDropdownOpened = function () {
        return ctrl.state.opened;
      };

      /**
       * Closes the select dropdown.
       * It moves the focus to the closed select if focus was inside the widget.
       */
      ctrl.closeDropdown = function () {
        if (ctrl.state.opened === false) {
          return;
        }
        if (focusIsInsideWidget()) {
          _.defer(function () {
            return $element.focus();
          });
        }
        if (ctrl.state.selectedOption !== valueAtOpening) {
          syncValueToModel(true);
        }

        // TODO : move to own method
        dropdownEl.hide().appendTo($element);
        dropdownEl.css({
          top: "",
          left: "",
          bottom: "",
          right: "",
          width: "auto"
        });
        // TODO : end

        ctrl.state.searchTerm = "";
        ctrl.state.activeOptionId = -1;
        ctrl.state.opened = false;
        ctrl.state.ignoreHover = false;
      };

      /**
       * Opens the select dropdown
       */
      ctrl.openDropdown = function () {
        if (ctrl.state.opened === true) {
          return;
        }
        valueAtOpening = ctrl.state.selectedOption;
        ctrl.state.opened = true;
        ctrl.setActiveOptionIdx(ctrl.getSelectedOptionIdx());

        // TODO : move to own method
        dropdownEl.show().appendTo(document.body);
        // la boite d'option ne dépasse pas la taille de la select. Sinon cela autorise que les options fassent des retours à la ligne.
        if (ctrl.config.fixedOptionWidth) {
          dropdownEl.outerWidth($element.outerWidth());
        }
        dropdownEl.position({
          my: "left top",
          at: "left bottom+0px",
          of: $element,
          collision: "flip",
          within: document.body
        });
        // TODO : end

        _.defer(function () {
          dropdownEl.find(".tl-select-searchbox").focus();
          ctrl.scrollToActiveOption();
        });
      };

      /**
       * Returns the index of the currently selected option
       * in the currently displayed (potentially filtered) option list
       */
      ctrl.getSelectedOptionIdx = function () {
        if (ctrl.state.selectedOption != null) {
          return _.indexOf(ctrl.source, ctrl.state.selectedOption);
        } else {
          return -1;
        }
      };

      /**
       * Toggles the dropdown
       */
      ctrl.toggleDropdown = function () {
        if (ctrl.state.opened || !ctrl.state.loadingRenderDone // pendant l'init de l'affichage on ne permet pas d'ouvrir la liste
        ) {
          ctrl.closeDropdown();
        } else {
          ctrl.openDropdown();
        }
      };
      var syncValueToModel = function syncValueToModel() {
        var emit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var selectedOption = ctrl.state.selectedOption;
        var modelValue;
        if (selectedOption == null || selectedOption === config.emptyOption || selectedOption.$empty) {
          modelValue = null;
        } else {
          if (config.idAttribute) {
            modelValue = objectUtils.getProperty(selectedOption, config.idAttribute);
          } else {
            modelValue = selectedOption;
          }
        }
        modelCtrl.$setViewValue(modelValue);
        modelCtrl.$commitViewValue();
        if (emit) {
          emitChangeEvent();
        }
      };

      /**
       * emit both angular and dom events to allow easy listening
       */
      var emitChangeEvent = function emitChangeEvent() {
        $scope.$emit("tl-select:change", {
          ctrl: ctrl,
          element: $element,
          value: ctrl.state.selectedOption
        });
        $element.trigger("change", {
          value: ctrl.state.selectedOption
        });
      };
      var applyModelValue = function applyModelValue() {
        var modelValue = modelCtrl.$modelValue;
        var selectedOption;
        if (modelValue == null) {
          if (config.emptyOption != null) {
            selectedOption = config.emptyOption;
          }
        } else {
          if (config.idAttribute) {
            selectedOption = _.find(source, function (option) {
              return objectUtils.getProperty(option, config.idAttribute) === modelValue;
            });
          } else {
            selectedOption = modelValue;
          }
        }
        ctrl.state.selectedOption = selectedOption;
      };
      var modelUnwatch = null;
      var wireToModel = function wireToModel() {
        if (modelUnwatch != null) {
          modelUnwatch();
        }
        modelUnwatch = $scope.$watch(function () {
          return modelCtrl.$modelValue;
        }, applyModelValue);
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/selectbox/tlSelect.js", __webpack_require__(1), __webpack_require__(4), __webpack_require__(3)))

/***/ }),
/* 2998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("tlSelectConfigRegistry", function () {
  var registry = {};
  return {
    registerConfig: function registerConfig(configName, config) {
      registry[configName] = config;
    },
    getConfig: function getConfig(configName) {
      return registry[configName];
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/selectbox/tlSelectConfigRegistry.js"))

/***/ }),
/* 2999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlSelectDropdown", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: __webpack_require__(3743),
    require: ["tlSelectDropdown", "^tlSelect"],
    controllerAs: "$dropdown",
    link: function link($scope, $el, $attrs, controllers) {
      var dropdownCtrl = controllers[0],
        selectCtrl = controllers[1];
      selectCtrl.setDropdownCtrl(dropdownCtrl);
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        selectCtrl = $scope.$select;
      ctrl.getElement = function () {
        return $element;
      };
      ctrl.getActiveOptionIdx = function () {
        return selectCtrl.state.activeOptionIdx;
      };
      ctrl.showFooter = function () {
        var config = selectCtrl.getConfig();
        return config.expandButton != null;
      };
      ctrl.onExpandClick = function (event) {
        event.preventDefault();
        var config = selectCtrl.getConfig();
        config.expandButton.handler(selectCtrl);
      };
      console.log('ready');
    }]
  };
});
ngModule.directive("tlSelectGroupLabel", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: __webpack_require__(3745),
    require: "^tlSelectDropdown",
    link: function link($scope, $el, $attrs, dropdownCtrl) {
      var groupLabelTranscludeFn = $scope.$select.getGroupLabelTranscludeFn(); // TODO : access from dropdown
      groupLabelTranscludeFn($scope, function (clone) {
        clone.appendTo($el);
        //                console.log("ajoute ",clone);
      });
    }
  };
});

/**
 * une ligne d'option
 */
ngModule.directive("tlSelectDropdownOption", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: __webpack_require__(3744),
    require: "^tlSelectDropdown",
    link: function link($scope, $el, $attrs, dropdownCtrl) {
      var option = $scope.option,
        optionIdx = $scope.optionIdx;

      // optimize watchers by using event to set active option.
      var onActiveChange = function onActiveChange() {
        if (dropdownCtrl.getActiveOptionIdx() === optionIdx) {
          $el.addClass("active");
        } else {
          $el.removeClass("active");
        }
      };
      $scope.$on("tl-select:active-change", onActiveChange);
      onActiveChange();

      // transclude option template or empty label template
      if (option.$empty) {
        $("<span>").addClass("empty-label").text(option.label).appendTo($el);
      } else {
        var optionTranscludeFn = $scope.$select.getOptionTranscludeFn(); // TODO : access from dropdown //selectCtrl.getOptionTranscludeFn();
        optionTranscludeFn($scope, function (clone) {
          clone.appendTo($el);
          $scope.loadingRenderDone = true;
        });
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/selectbox/tlSelectDropdown.js", __webpack_require__(4)))

/***/ }),
/* 3000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * rendu de l'input avec la valeur choisie
 */
ngModule.directive("tlSelectSelectedOption", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '<div class="tl-select-selection-option tl-select-option tl-validated-input" ng-class="{\'disabled\':disabled}">' + '<tl-circular-loader class="xs" ng-if="!$select.state.loadingRenderDone"></tl-circular-loader>' + '</div>',
    require: "^tlSelect",
    link: function link($scope, $el, $attrs, selectCtrl) {
      var optionScope = null,
        optionEl = null;
      $scope.$watch("$select.state.selectedOption", function (selectedOption) {
        var optionTranscludeFn = selectCtrl.getOptionTranscludeFn();
        if (optionScope != null) {
          optionScope.$destroy();
          optionScope = null;
        }
        if (optionEl != null) {
          optionEl.remove();
          optionEl = null;
        }
        if (selectedOption != null) {
          optionScope = $scope.$new();
          optionScope.option = selectedOption;
          if (selectedOption.$empty) {
            optionEl = $("<span>").addClass("empty-label").text(selectedOption.label).appendTo($el);

            // todo - doit etre placé là où la liste se construit
            $scope.loadingRenderDone = true;
            selectCtrl.state.loadingRenderDone = true;
          } else {
            optionTranscludeFn(optionScope, function (clone) {
              optionEl = clone.appendTo($el);
              // todo - doit plutot etre placé là où la liste se construit
              $scope.loadingRenderDone = true;
              selectCtrl.state.loadingRenderDone = true;
            });
          }
        } else {
          // pas de rendu prévu pour la valeur absente
          // TODO : placeholder ?
          optionEl = $("<span>").html("&nbsp;").appendTo($el);
          if (selectCtrl.source === undefined || !selectCtrl.state.sourceLoaded) {} else {
            $scope.loadingRenderDone = true;
            selectCtrl.state.loadingRenderDone = true;
          }
        }
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/selectbox/tlSelectSelectedOption.js", __webpack_require__(4)))

/***/ }),
/* 3001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlSelectOptionTpl", function () {
  return {
    restrict: "E",
    replace: false,
    transclude: true,
    scope: true,
    require: "^tlSelect",
    link: function link($scope, $el, $attrs, tlSelectCtrl, transcludeFn) {
      tlSelectCtrl.setOptionTranscludeFn(transcludeFn);
      $el.hide();
    }
  };
});
ngModule.directive("tlSelectGroupLabelTpl", function () {
  return {
    restrict: "E",
    replace: false,
    transclude: true,
    scope: true,
    require: "^tlSelect",
    link: function link($scope, $el, $attrs, tlSelectCtrl, transcludeFn) {
      tlSelectCtrl.setGroupLabelTranscludeFn(transcludeFn);
      $el.hide();
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/selectbox/tlSelectTemplates.js"))

/***/ }),
/* 3002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Link to another account, and/or another app
 *
 * attributes are the followings
 *      - id   : the id of the account to switch to
 *      - path : the path to go to, relative to the target app.
 *      - app-id  : the app to switch to.
 *
 * Example :
 * <link-to-compte id="{{compteId}} url="home" app-id="DETTE">
 *     <span>My link text</span>
 * </link-to-compte>
 *
 */
ngModule.directive("linkToCompte", ["$window", "$session", "$applications", function ($window, $session, $applications) {
  return {
    restrict: "EA",
    replace: true,
    scope: true,
    transclude: true,
    template: '<a class="compte-link" ng-click="go($event)" href="{{url}}" ng-transclude></a>',
    link: function link($scope, $el, $attrs) {
      var compteId = null,
        appId = $applications.getCurrentAppId(),
        path = "";
      var recomputeUrl = function recomputeUrl() {
        $scope.url = $applications.getApplicationUrl(appId, path, compteId);
      };
      var refreshCompteId = function refreshCompteId(_compteId) {
        compteId = _compteId;
        if (!compteId) {
          var compte = $session.getCompte();
          if (compte != null) {
            compteId = compte.id;
          }
        }
      };
      var refreshAppId = function refreshAppId(_appId) {
        appId = _appId;
        if (!appId) {
          appId = $applications.getCurrentAppId();
          if (appId === "INTRA") {
            appId = "DETTE";
          }
        }
      };
      var refreshPath = function refreshPath(_path) {
        path = _path || "";
      };
      $attrs.$observe("compteId", function (_compteId) {
        refreshCompteId(_compteId);
        recomputeUrl();
      });
      $attrs.$observe("appId", function (_appId) {
        refreshAppId(_appId);
        recomputeUrl();
      });
      $attrs.$observe("path", function (_path) {
        refreshPath(_path);
        recomputeUrl();
      });
      $scope.go = function (event) {
        if (!event.ctrlKey) {
          $window.location.href = $scope.url;
        }
      };
      refreshCompteId();
      refreshAppId();
      refreshPath();
      recomputeUrl();
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/structure/linkToCompte.js"))

/***/ }),
/* 3003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlMainContainer", function () {
  var breadCrumbClass = "tl-breadcrumb-page";
  return {
    restrict: "A",
    scope: true,
    link: function link($scope, $el, $attrs, ctrl) {},
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this;
      ctrl.setBreadcrumbLayout = function (flag) {
        flag ? $element.addClass(breadCrumbClass) : $element.removeClass(breadCrumbClass);
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/structure/mainContainer.js"))

/***/ }),
/* 3004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlPageBreadcrumb", function () {
  return {
    restrict: "E",
    replace: true,
    require: "^tlMainContainer",
    transclude: true,
    scope: true,
    template: '<div class="tl-page-breadcrumb" ng-transclude></div>',
    link: function link($scope, $el, $attrs, containerCtrl) {
      containerCtrl.setBreadcrumbLayout(true);
      $scope.$on("$destroy", function () {
        containerCtrl.setBreadcrumbLayout(false);
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/structure/pageBreacrumb.js"))

/***/ }),
/* 3005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("pageStatus", ["$rootScope", function ($rootScope) {
  return {
    /**
     * permet de recharcher notamment les sections qui ont dans leur configuration invalidable:true
     */
    invalidate: function invalidate() {
      $rootScope.$emit("$PAGE_DATA_UPDATED");
    }
  };
}]);

/**
 * config.max : x - si plus de x tabs alors des flèches de scroll apparaissent pour atteindre les ongets à droites.
 */
ngModule.directive("tlTabsetPage", ["$route", "$location", "$pageRouter", "routeUtils", "directiveUtils", function ($route, $location, $pageRouter, routeUtils, directiveUtils) {
  var defaultConfig = {
    tabsetClass: "tl-tab-layout",
    pillsClass: "tl-layout-nav",
    tabParameter: "tab",
    tabs: []
  };
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '' + '<div class="ts-tabset">' + '   <div class="ts-tab-pills">' + '<div class="display-ib" ng-if="hasPrevious() || hasNext()" style="min-width: 40px"> ' + '<i class="fa fa-caret-left pill-previous fa-2x align-middle" ng-class="{\'darkBlue\':hasPrevious(), \'grey\':!hasPrevious()}" ng-click="previous()"></i>' + ' <i class="fa fa-caret-right pill-next fa-2x align-middle" ng-class="{\'darkBlue\':hasNext() , \'grey\':!hasNext()}"  ng-click="next()"></i>' + '</div>' + '       <tl-tabset-pill ng-repeat="tab in tabs | filter: { visible: true } track by tab.fragment"></tl-tabset-pill>' + '   </div>' + '   <div class="ts-tab-contents tl-layout-content">' + '       <tl-tabset-content ng-repeat="tab in tabs"></tl-tabset-content>' + '   </div>' + '</div>',
    link: function link($scope, $el, $attrs, ctrl) {
      var unwatch = $attrs.$observe("config", function (configProp) {
        unwatch();
        $scope.$parent.$watch(configProp, function (config) {
          if (config == null) {
            return;
          }
          // TODO : check if re-init is working ( config change )
          ctrl.initialize(config);
        });
      });
    },
    controller: ["$scope", "$element", "$rootScope", function controller($scope, $element, $rootScope) {
      var ctrl = this,
        config = null,
        tabs = ctrl.$tabs = $scope.tabs = [],
        section = null,
        initialRoute = $pageRouter.getCurrentRoute(),
        // index du premier tab visible
        firstTabIdx = 0;
      ctrl.initialize = function (_config) {
        config = _.extend(angular.copy(defaultConfig), _config);
        _.each(config.tabs, ctrl.addTab, ctrl);
        $element.addClass(config.tabsetClass);
        $element.find(".ts-tab-pills").addClass(config.pillsClass);
        var sectionParam = config.tabParameter || "tab",
          initialTabFragment = initialRoute.params[sectionParam],
          path = initialRoute.$$route.originalPath,
          routeSectionRegexp = new RegExp("^.*[\/]:" + sectionParam + "[?]?"),
          sectionParams = _.omit(initialRoute.params, sectionParam);
        var regExpExecArray = routeSectionRegexp.exec(path);
        if (regExpExecArray == null) {
          console.error("impossible de créer la regExp avec le path [" + path + ") via l'expression " + routeSectionRegexp);
        }
        section = regExpExecArray[0];
        section = routeUtils.replaceParams(section, sectionParams);
        var unregisterLocationHandler = $pageRouter.registerLocationHandler(section, function (newParams) {
          var tabId = newParams[sectionParam];
          ctrl.selectTabById(tabId);
        });
        $scope.$on("$destroy", unregisterLocationHandler);
        var initialTab = initialTabFragment && _.find(ctrl.$tabs, {
          fragment: initialTabFragment
        }) || ctrl.$tabs[0];
        ctrl.selectTab(initialTab, true);

        // reaffiche le tab si iil n'est pas visible par défaut
        if (config.max && (initialTab.index < firstTabIdx || initialTab.index >= firstTabIdx + config.max)) {
          $scope.firstTab = initialTab.index - (config.max - 1);
          if (firstTabIdx < 0) {
            firstTabIdx = 0;
          }
        }
        ctrl.updateVisibility();
      };
      ctrl.getConfig = function () {
        return config;
      };
      ctrl.getParentParameters = function () {
        var parameters = {};
        var parentTabset = directiveUtils.getParentController($element, "tlTabsetPage");
        var parentTab = directiveUtils.getParentController($element, "tlTabsetContent");
        if (parentTabset && parentTab) {
          var paramName = parentTabset.getConfig().tabParameter;
          var paramValue = parentTab.getFragment();
          parameters[paramName] = paramValue;
          _.extend(parameters, parentTabset.getParentParameters());
        }
        return parameters;
      };
      ctrl.selectTabById = function (tabId) {
        var selected = _.find(tabs, {
          fragment: tabId
        });
        if (selected) {
          ctrl.selectTab(selected);
        }
      };
      ctrl.changeUrl = function (tab) {
        // replaces :params with actual values.
        var params = ctrl.getParentParameters();
        params[config.tabParameter] = tab.fragment;
        var tabUrl = routeUtils.replaceParams(section, params);
        $location.search({}).path(tabUrl);
      };
      ctrl.selectTab = function selectTab(tab, noUrlChange) {
        _.each(tabs, function (tab) {
          tab.active = false;
        });
        tab.active = true;
        if (tab.id) {
          // permet à du code d'être alerté facilement du changement de tab
          $rootScope.$emit('TlTab:' + tab.id);
        }
        if (!noUrlChange) {
          ctrl.changeUrl(tab);
        }
      };
      ctrl.addTab = function addTab(tab) {
        tab.active = false;
        tab.index = tabs.length;
        tabs.push(tab);
      };
      ctrl.updateVisibility = function () {
        for (var i = 0; i < tabs.length; i++) {
          if (i < firstTabIdx) {
            // si le tab est actif alors on le desactive
            if (tabs[i].active) {
              if (i - 1 >= firstTabIdx) {
                ctrl.changeUrl(tabs[i - 1]);
              } else {
                ctrl.changeUrl(tabs[i + 1]);
              }
            }
            tabs[i].visible = false;
          } else {
            tabs[i].visible = true;
          }
        }
      };
      $scope.hasNext = function () {
        var nextTab = firstTabIdx + (config ? config.max : 100);
        return nextTab < tabs.length;
      };
      $scope.next = function () {
        if ($scope.hasNext()) {
          firstTabIdx++;
          ctrl.updateVisibility();
        }
      };
      $scope.hasPrevious = function () {
        return firstTabIdx > 0;
      };
      $scope.previous = function () {
        if ($scope.hasPrevious()) {
          firstTabIdx--;
          ctrl.updateVisibility();
        }
      };
    }]
  };
}]);
ngModule.directive("tlTabsetPill", ["$mdButtonInkRipple", "iconUtils", function ($mdButtonInkRipple, iconUtils) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: "^tlTabsetPage",
    template: '' + '<div class="ts-tab-pill tl-panel-menu" ng-click="onPillClick()" ng-class="{selected : tab.active, \'panel-opened\' : tab.panelOpened}">' + '   <i ng-show="tab.icon" class="ts-tab-pill-icon {{fullIcon}} {{tab.class}}"></i>' + '   <h1>{{ tab.title || (tab.label | translate) }}</h1>' + '</div>',
    link: function link($scope, $el, $attrs, tabsetCtrl) {
      $mdButtonInkRipple.attach($scope, $el);
      $scope.tab = $scope.$eval("tab");
      $el.attr("tabset-fragment", $scope.tab.fragment);
      $scope.$watch('tab.icon', function (icon) {
        $scope.fullIcon = iconUtils.getFullName(icon);
      });
      $scope.onPillClick = function () {
        tabsetCtrl.changeUrl($scope.tab);
      };
    }
  };
}]);
ngModule.directive("tlTabsetContent", ["$rootScope", "$compile", "$q", "templateUtils", "$controller", "deferredUtils", function ($rootScope, $compile, $q, templateUtils, $controller, deferredUtils) {
  var INVALIDATION_EVENT = "$PAGE_DATA_UPDATED";
  var defaultTabConfig = {
    tabClass: "",
    unload: false,
    invalidable: false
  };
  return {
    restrict: "E",
    replace: true,
    require: ["tlTabsetContent", "^tlTabsetPage", "hideableContainer"],
    scope: true,
    template: '<div hideable-container class="ts-tab-content autosize-reference"></div>',
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        tabsetCtrl = null,
        visibilityCtrl = null,
        tab = $scope.tab,
        //$scope.$eval("tab"),
        tabLoaded = false,
        tabContent = null,
        tabScope = null,
        config = null;
      var generateConfig = function generateConfig() {
        var keys = _.keys(defaultTabConfig),
          tabsetConfig = tabsetCtrl.getConfig();
        config = {};
        _.each(keys, function (key) {
          if (_.has(tab, key)) {
            config[key] = tab[key];
          } else if (_.has(tabsetConfig, key)) {
            config[key] = tabsetConfig[key];
          } else {
            config[key] = defaultTabConfig[key];
          }
        });
      };
      ctrl.$initialize = function (_tabsetCtrl, _visibilityCtrl) {
        tabsetCtrl = _tabsetCtrl;
        visibilityCtrl = _visibilityCtrl;
        generateConfig();
        $element.attr("tabset-fragment", tab.fragment);
        if (config.tabClass) {
          $element.addClass(config.tabClass);
        }
        $scope.$watch("tab.active", function (activeTab) {
          visibilityCtrl.setVisible(activeTab);
        });
        var visibilityChangeHandler = function visibilityChangeHandler(visible) {
          visible ? ctrl.showTab() : ctrl.hideTab();
        };
        visibilityCtrl.on("visibility:change", visibilityChangeHandler);
        visibilityCtrl.setVisible(tab.active || false);
        if (tab.active) {
          ctrl.showTab();
        }
        if (config.invalidable) {
          bindInvalidationEvents();
        }
      };
      var bindInvalidationEvents = function bindInvalidationEvents() {
        var invalidationHandler = function invalidationHandler() {
          if (visibilityCtrl.isVisible()) {
            return;
          }
          ctrl.unloadTabContent();
        };
        var removeInvalidationListener = $rootScope.$on(INVALIDATION_EVENT, invalidationHandler);
        $scope.$on("$destroy", function () {
          removeInvalidationListener();
        });
      };
      ctrl.getFragment = function () {
        return tab.fragment;
      };
      ctrl.usePanelLayout = function (panelLayout) {
        panelLayout ? $element.addClass("has-panel") : $element.removeClass("has-panel");
        ctrl.setPanelOpened(false);
      };

      // only used with panel layout (for pill styles purposes)
      ctrl.setPanelOpened = function (panelOpened) {
        tab.panelOpened = panelOpened;
      };
      ctrl.showTab = function () {
        if (!tabLoaded) {
          ctrl.loadTabContent();
        }
        $element.show();
      };
      ctrl.hideTab = function () {
        if (tabLoaded && (config.unload && tab.unload !== false || tab.unload)) {
          ctrl.unloadTabContent();
        }
        $element.hide();
      };
      ctrl.unloadTabContent = function () {
        if (tabScope != null) {
          tabScope.$destroy();
          tabScope = null;
          tabContent.remove();
          tabContent = null;
        }
        tabLoaded = false;
      };
      ctrl.loadTabContent = function () {
        var resolvesPromise = deferredUtils.resolvePromiseMap(tab.resolve || {});
        var templatePromise = templateUtils.loadTemplate(tab);
        $q.all([resolvesPromise, templatePromise]).then(function (resolves) {
          tabScope = $scope.$new();
          var locals = resolves[0],
            template = resolves[1];
          if (tab.controller) {
            locals.$scope = tabScope;
            locals.$element = $element;
            $controller(tab.controller, locals);
          }
          $compile(template)(tabScope, function (content) {
            tabContent = content;
            $element.append(content);
          });
          tabLoaded = true;
        });
      };
    }],
    link: function link($scope, $el, $attrs, controllers) {
      var tabController = controllers[0],
        tabsetController = controllers[1],
        visibilityCtrl = controllers[2];
      tabController.$initialize(tabsetController, visibilityCtrl);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/structure/tabsetPage.js", __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 3006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * Simple panel layout with left panel and right content sub directives.
 *
 * Can be used as a simplePage or inside a tabsetPage.
 */
ngModule.directive("tlPanelLayout", function () {
  var PANEL_OPENED_CLASS = "panel-opened",
    PANEL_CLOSED_CLASS = "panel-closed",
    PANEL_ANIMATING_CLASS = "panel-animating",
    PANEL_HIDDEN_CLASS = "panel-invisible";
  return {
    restrict: "E",
    replace: true,
    require: ["tlPanelLayout", "?^tlTabsetContent"],
    scope: true,
    transclude: true,
    template: '<div class="tl-panel-container" ng-transclude></div>',
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        tabContentCtrl = controllers[1];
      var opened = _.has($attrs, "panelOpened") && $attrs.panelOpened !== "false" ? true : false;
      ctrl.setPanelInitialState(opened);
      if (tabContentCtrl) {
        tabContentCtrl.usePanelLayout(true);
        ctrl.$setTabCtrl(tabContentCtrl);
      }
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        tabCtrl = null,
        animating = false,
        panelOpened = true;
      var notifyResize = function notifyResize() {
        $scope.$parent.$broadcast("$resize");
      };
      ctrl.$setTabCtrl = function (_tabCtrl) {
        tabCtrl = _tabCtrl;
        tabCtrl.setPanelOpened(panelOpened);
      };
      ctrl.setPanelInitialState = function (opened) {
        panelOpened = opened;
        $element.addClass(panelOpened ? PANEL_OPENED_CLASS : PANEL_CLOSED_CLASS).removeClass(panelOpened ? PANEL_CLOSED_CLASS : PANEL_OPENED_CLASS);
      };
      ctrl.togglePanel = function () {
        if (animating) {
          return;
        }
        animating = true;
        $element.addClass(PANEL_ANIMATING_CLASS);
        var leftPanel = $element.find(".tl-panel-left"),
          rightPanel = $element.find(".tl-panel-right");
        var onAnimationEnd = function onAnimationEnd() {
          $scope.$apply(function () {
            panelOpened = !panelOpened;
            animating = false;
            leftPanel.css({
              left: ""
            });
            rightPanel.css({
              left: ""
            });
            $element.removeClass(PANEL_ANIMATING_CLASS).addClass(panelOpened ? PANEL_OPENED_CLASS : PANEL_CLOSED_CLASS).removeClass(panelOpened ? PANEL_CLOSED_CLASS : PANEL_OPENED_CLASS);
            tabCtrl && tabCtrl.setPanelOpened(panelOpened);
            notifyResize();
          });
        };
        if (panelOpened) {
          $.when(leftPanel.animate({
            left: "-270px"
          }), rightPanel.animate({
            left: "0px"
          })).then(onAnimationEnd);
        } else {
          $.when(leftPanel.animate({
            left: "0px"
          }), rightPanel.animate({
            left: "270px"
          })).then(onAnimationEnd);
        }
      };

      /**
       * retire ou remet le panel de gauche (et le handler).
       * @param visible
       */
      ctrl.panelVisible = function (visible) {
        if (!visible) {
          console.log('==> - panelLayout::hidePanel');
          var panelLeft = $element.find(".tl-panel-left");
          var panelRight = $element.find(".tl-panel-right");
          var find = panelLeft.find(".tl-panel-handle");
          find.addClass(PANEL_HIDDEN_CLASS);
          panelLeft.addClass(PANEL_HIDDEN_CLASS);
          panelRight.addClass(PANEL_HIDDEN_CLASS);
        } else {
          console.log('==> - panelLayout::showPanel');
          var _panelLeft = $element.find(".tl-panel-left");
          var _panelRight = $element.find(".tl-panel-right");
          var _find = _panelLeft.find(".tl-panel-handle");
          _find.removeClass(PANEL_HIDDEN_CLASS);
          _panelLeft.removeClass(PANEL_HIDDEN_CLASS);
          _panelRight.removeClass(PANEL_HIDDEN_CLASS);
        }
      };
    }]
  };
});

/**
 * The left side ( panel ) of the layout
 */
ngModule.directive("tlPanelLeft", function () {
  return {
    restrict: "E",
    require: "^tlPanelLayout",
    replace: true,
    scope: true,
    transclude: true,
    template: '' + '<div class="tl-panel-left">' + '   <div class="tl-panel-content tl-panel-form" ng-transclude></div>' + '   <div class="tl-panel-handle" ng-click="togglePanel()"></div>' + '</div>',
    link: function link($scope, $el, $attrs, layoutCtrl) {
      $scope.togglePanel = function () {
        layoutCtrl.togglePanel();
      };
    }
  };
});

/**
 * The right side ( content ) of the layout
 */
ngModule.directive("tlPanelRight", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    transclude: true,
    template: '<div class="tl-panel-right autosize-reference" ng-transclude></div>'
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/structure/tlPanelLayout.js", __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 3007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tsTabset", function () {
  return {
    restrict: "E",
    replace: true,
    transclude: true,
    scope: true,
    template: '' + '<div class="ts-tabset">' + '   <div class="ts-tab-pills {{headersClass}} has-{{tabs.length}}-tabs">' + '       <ts-tab-pill ng-repeat="tab in tabs | orderBy:tabSorterFn track by tab.tabId"></ts-tab-pill>' + '   </div>' + '   <div class="ts-tab-contents {{contentsClass}}">' + '       <ts-tab-box ng-repeat="tab in tabs | filter:isNotButton track by tab.tabId"></ts-tab-pill>' + '   </div>' + '   <div class="ts-tabs"></div>' + '</div>',
    controller: ["$scope", function controller($scope) {
      var ctrl = this,
        tabs = ctrl.tabs = $scope.tabs = [],
        initialTabId = null;
      $scope.isNotButton = function (tab) {
        return !tab.isButton;
      };
      $scope.tabSorterFn = function (tab) {
        return tab.el.index();
      };
      var findTabById = function findTabById(tabId) {
        return _.find(tabs, {
          tabId: tabId
        });
      };
      ctrl.setInitialTab = function (tabId) {
        initialTabId = tabId;
      };
      ctrl.selectTab = function selectTab(tab) {
        tab = _.isString(tab) ? findTabById(tab) : tab;
        _.each(tabs, function (tab) {
          tab.active = false;
        });
        tab.active = true;
      };
      ctrl.addTab = function addTab(tab, index) {
        tabs.splice(index || 0, 0, tab);
        if (tabs.length === 1 || tab.active || initialTabId === tab.tabId) {
          ctrl.selectTab(tab);
        } else {
          tab.active = false;
        }
      };
      ctrl.removeTab = function removeTab(tab) {
        var index = tabs.indexOf(tab);
        if (tab.active && tabs.length > 1) {
          var newActiveIndex = index === tabs.length - 1 ? index - 1 : index + 1;
          ctrl.selectTab(tabs[newActiveIndex]);
        }
        tabs.splice(index, 1);
      };
    }],
    link: function link($scope, $el, $attrs, ctrl, transcludeFn) {
      $attrs.$observe("headersClass", function (headersClass) {
        $scope.headersClass = headersClass;
      });
      $attrs.$observe("contentsClass", function (contentsClass) {
        $scope.contentsClass = contentsClass;
      });
      transcludeFn($scope, function (children) {
        $el.find(".ts-tabs").append(children);
      });

      // ts-tabset-id

      var selectTabHandler = function selectTabHandler(event, tabId) {
        event.stopPropagation && event.stopPropagation(); // check for broadcast events...
        ctrl.selectTab(tabId);
      };
      $scope.$on("tsTabset:selectTab", selectTabHandler);
      if ($attrs.tsTabsetId) {
        $scope.$on("tsTabset:" + $attrs.tsTabsetId + ":selectTab", selectTabHandler);
      }

      // ts-tabset-initial-tab

      if ($attrs.tsTabsetInitialTab) {
        ctrl.setInitialTab($attrs.tsTabsetInitialTab);
      }
    }
  };
});
ngModule.directive("tsTab", function () {
  return {
    restrict: "E",
    require: "^tsTabset",
    scope: true,
    transclude: true,
    controller: ["$scope", function controller($scope) {
      var ctrl = this;
      ctrl.getTab = function () {
        return $scope.tab;
      };
    }],
    compile: function compile(element, attrs, transcludeFn) {
      return {
        pre: function pre($scope, $el, $attrs, tabsetCtrl) {
          var tab = $scope.tab = {
            tabId: $attrs["tsTabId"] || _.uniqueId("tsTab-"),
            isButton: false,
            el: $el,
            scope: $scope,
            active: _.has($attrs, "active"),
            onSelect: function onSelect() {
              if ($attrs.select) {
                $scope.$eval($attrs.select);
              }
            },
            onUnselect: function onUnselect() {
              if ($attrs.unselect) {
                $scope.$eval($attrs.unselect);
              }
            }
          };
          $attrs.$observe("headerClass", function (headersClass) {
            tab.headerClass = headersClass;
          });
          $scope.$watch("tab.active", function (isActive, oldValue) {
            if (isActive === oldValue) {
              return;
            }
            isActive ? tab.onSelect() : tab.onUnselect();
          });

          // what we do here is finding the highter level from where the tab directive was imported.
          // this is useful when doing specific tab's directive,
          // which require a wrapper div to avoid multiple replace on same directive element.
          var tabChild = $el;
          while (tabChild.parent().get(0) != null && !tabChild.parent().is("div.ts-tabs")) {
            tabChild = tabChild.parent();
          }
          var position = tabChild.index();
          tabsetCtrl.addTab(tab, position);
          transcludeFn($scope, function (children) {
            $el.append(children);
          });
          $scope.$on('$destroy', function () {
            tabsetCtrl.removeTab(tab);

            // we remove the box & pill now, to avoid the blinking effect from deletion from tabset.
            if (tab.$boxScope) {
              tab.$boxScope.$destroy();
              tab.$box.remove();
            }
            if (tab.$pillScope) {
              tab.$pillScope.$destroy();
              tab.$pill.remove();
            }
          });

          // no longer need the wrapper element.
          // Next steps will be done using the tab transclude fn in content and header
          $el.hide();
        }
      };
    }
  };
});
ngModule.directive("tsTabButton", function () {
  return {
    restrict: "E",
    require: "^tsTabset",
    scope: true,
    transclude: true,
    controller: ["$scope", function controller($scope) {}],
    compile: function compile(element, attrs, transcludeFn) {
      return {
        pre: function pre($scope, $el, $attrs, tabsetCtrl) {
          var tab = $scope.tab = {
            tabId: $attrs["tsTabId"] || _.uniqueId("tsTab-"),
            isButton: true,
            el: $el,
            scope: $scope,
            onClick: function onClick() {
              if ($attrs.click) {
                $scope.$eval($attrs.click);
              }
            }
          };
          $attrs.$observe("headerClass", function (headersClass) {
            tab.headerClass = headersClass;
          });
          var position = $el.index();
          tabsetCtrl.addTab(tab, position);
          tab.$headerTranscludeFn = transcludeFn;
          $scope.$on('$destroy', function () {
            tabsetCtrl.removeTab(tab);
          });
          $el.hide();
        }
      };
    }
  };
});
ngModule.directive("tsTabHeader", function () {
  return {
    restrict: "E",
    require: "^tsTab",
    transclude: true,
    link: function link($scope, $el, $attrs, tabCtrl, transcludeFn) {
      var tab = tabCtrl.getTab();
      tab.$headerTranscludeFn = transcludeFn;
    }
  };
});
ngModule.directive("tsTabContent", function () {
  return {
    restrict: "E",
    require: "^tsTab",
    transclude: true,
    link: function link($scope, $el, $attrs, tabCtrl, transcludeFn) {
      var tab = tabCtrl.getTab();
      tab.$contentTranscludeFn = transcludeFn;
    }
  };
});
ngModule.directive("tsTabPill", ["directiveUtils", "$mdButtonInkRipple", function (directiveUtils, $mdButtonInkRipple) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: "^tsTabset",
    template: '<div class="ts-tab-pill {{tab.headerClass}}" ng-click="onPillClick()" ng-class="{selected : tab.active}"></div>',
    link: function link($scope, $el, $attrs, tabsetCtrl) {
      var tab = $scope.tab = $scope.$eval("tab");
      tab.$pill = $el;
      tab.$pillScope = $scope;
      $mdButtonInkRipple.attach($scope, $el);
      directiveUtils.copyControllers(tab.el, $el);
      $el.attr("ts-tab-id", tab.tabId);
      $scope.onPillClick = function () {
        if (tab.isButton) {
          tab.onClick();
        } else {
          tabsetCtrl.selectTab(tab);
        }
      };
      var unwatchTransclude = $scope.$watch(function () {
        return tab.$headerTranscludeFn;
      }, function (transcludeFn) {
        if (transcludeFn == null) {
          return;
        }
        unwatchTransclude();
        transcludeFn(tab.scope, function (contents) {
          $el.append(contents);
        });
      });
    }
  };
}]);
ngModule.directive("tsTabBox", ["directiveUtils", function (directiveUtils) {
  return {
    restrict: "E",
    replace: true,
    require: "hideableContainer",
    scope: true,
    template: '<div hideable-container class="ts-tab-content autosize-reference"></div>',
    link: function link($scope, $el, $attrs, visibilityCtrl) {
      var tab = $scope.tab = $scope.$eval("tab");
      tab.$box = $el;
      tab.$boxScope = $scope;
      if (!tab.active) {
        $el.hide();
      }
      directiveUtils.copyControllers(tab.el, $el);
      var transcluded = false;
      $scope.$watch("tab.active", function (active) {
        $el[active ? "show" : "hide"]();
        visibilityCtrl.setVisible(tab.active);
        if (active && !transcluded) {
          tab.$contentTranscludeFn(tab.scope, function (tabContent) {
            $el.append(tabContent);
          });
          transcluded = true;
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/structure/tsTabset.js", __webpack_require__(1)))

/***/ }),
/* 3008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlTabLayout", ["$route", "$location", "$pageRouter", "routeUtils", "directiveUtils", function ($route, $location, $pageRouter, routeUtils, directiveUtils) {
  var defaultConfig = {
    tabsetClass: "tl-tab-layout",
    pillsClass: "tl-layout-nav",
    pillDirective: "tlTabLayoutPillDefaultContent",
    tabParameter: "tab",
    tabs: []
  };
  return {
    restrict: "E",
    replace: true,
    scope: true,
    controllerAs: "tabLayoutCtrl",
    template: '' + '<div class="ts-tabset">' + '   <div class="ts-tab-pills">' + '<div class="display-ib" ng-if="hasPrevious() || hasNext()" style="min-width: 40px"> ' + '<div class="display-ib" ng-click="previous()"><i class="fa fa-caret-left pill-previous fa-2x align-middle" ng-class="{\'darkBlue\':hasPrevious(), \'grey\':!hasPrevious()}"></i></div>' + ' <div  class="display-ib" ng-click="next()"><i class="fa fa-caret-right pill-next fa-2x align-middle" ng-class="{\'darkBlue\':hasNext() , \'grey\':!hasNext()}"></i></div>' + '</div>' + '       <tl-tab-layout-pill ng-repeat="tab in tabLayoutCtrl.tabs | filter: { visible: true } track by tabLayoutCtrl.getTabId(tab)"></tl-tab-layout-pill>' + "<div ng-if=\"reportPageCtrl.isEditing() && tabLayoutCtrl.getConfig().section===true\" tl-tooltip=\"Cr\xE9er une nouvelle section\" class=\"tl-panel-menu edition-section\" ng-click=\"reportPageCtrl.createSection()\">\n                <i class=\"fa fa-plus fa-2x\"></i>\n            </div>" + '   </div>' + '   <div class="ts-tab-contents tl-layout-content">' + '       <tl-tab-layout-content ng-repeat="tab in tabLayoutCtrl.tabs track by tabLayoutCtrl.getTabId(tab)"></tl-tab-layout-content>' + '   </div>' + '</div>',
    link: function link($scope, $el, $attrs, ctrl) {
      var unwatch = $attrs.$observe("config", function (configProp) {
        unwatch();
        $scope.$parent.$watch(configProp, function (config) {
          if (config == null) {
            return;
          }
          // TODO : check if re-init is working ( config change )
          ctrl.initialize(config);
        });
      });
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        selectedTabId = null,
        config = null,
        section = null,
        initialRoute = $pageRouter.getCurrentRoute(),
        // index du premier tab visible
        firstTabIdx = 0;
      ctrl.tabs = [];
      ctrl.initialize = function (_config) {
        config = _.extend(angular.copy(defaultConfig), _config);
        if (config.tabsetId) {
          $scope.$on("tabset:" + config.tabsetId + ":select-tab", function (e, tabId) {
            ctrl.selectTabById(tabId);
          });
        }
        $element.addClass(config.tabsetClass);
        $element.find(".ts-tab-pills").addClass(config.pillsClass);
        var sectionParam = config.tabParameter || "tab",
          initialTabFragment = initialRoute.params[sectionParam],
          path = initialRoute.$$route.originalPath,
          routeSectionRegexp = new RegExp("^.*[\/]:" + sectionParam + "[?]?"),
          sectionParams = _.omit(initialRoute.params, sectionParam);
        section = routeSectionRegexp.exec(path)[0];
        section = routeUtils.replaceParams(section, sectionParams);
        var unregisterLocationHandler = $pageRouter.registerLocationHandler(section, function (newParams) {
          var tabId = newParams[sectionParam];
          ctrl.selectTabById(tabId);
        });
        $scope.$on("$destroy", unregisterLocationHandler);
        $scope.$watchCollection(function () {
          return config.tabs;
        }, function (newTabs, oldTabs) {
          if (newTabs === oldTabs) {
            return;
          }
          onConfigTabChange(newTabs, false);
        });
        onConfigTabChange(config.tabs, true);
        if (ctrl.tabs.length > 0) {
          var initialTab = initialTabFragment && _.find(ctrl.tabs, {
            fragment: initialTabFragment
          }) || ctrl.tabs[0];
          ctrl.selectTab(initialTab, true);

          // reaffiche le tab si iil n'est pas visible par défaut
          var indexInitialTab = _.indexOf(ctrl.tabs, initialTab);
          if (config.max && (indexInitialTab < firstTabIdx || indexInitialTab >= firstTabIdx + config.max)) {
            firstTabIdx = indexInitialTab - (config.max - 1);
            if (firstTabIdx < 0) {
              firstTabIdx = 0;
            }
          }
          ctrl.updateVisibility();
        }
      };
      function onConfigTabChange(newTabs, initial) {
        if (config.tabMapper) {
          ctrl.tabs = _.map(newTabs, config.tabMapper);
        } else {
          ctrl.tabs = newTabs;
        }
        ctrl.updateVisibility();

        // check if there should be an active tab id change.
        var nextTabId = null;
        if (ctrl.tabs.length === 0) {
          nextTabId = null;
        } else {
          if (nextTabId == null) {
            nextTabId = getTabId(ctrl.tabs[0]);
          } else {
            var tabIds = _.map(ctrl.tabs, getTabId);
            if (!_.includes(tabIds, selectedTabId)) {
              nextTabId = tabIds[0];
            }
          }
        }
        if (nextTabId !== selectedTabId) {
          ctrl.selectTabById(nextTabId, initial);
        }
      }
      function getTabId(tab) {
        return tab.fragment; // TODO : stuff here ?
      }
      ctrl.getTabId = function (tab) {
        return getTabId(tab);
      };
      ctrl.isSelectedTab = function (tab) {
        return getTabId(tab) === selectedTabId;
      };
      ctrl.getSelectedTabId = function () {
        return selectedTabId;
      };
      ctrl.getConfig = function () {
        return config;
      };
      ctrl.getParentParameters = function () {
        var parameters = {};
        var parentTabset = directiveUtils.getParentController($element, "tlTabLayout");
        var parentTab = directiveUtils.getParentController($element, "tlTabLayoutContent");
        if (parentTabset && parentTab) {
          var paramName = parentTabset.getConfig().tabParameter;
          var paramValue = parentTab.getFragment();
          parameters[paramName] = paramValue;
          _.extend(parameters, parentTabset.getParentParameters());
        }
        return parameters;
      };
      ctrl.selectTabById = function (tabId, noUrlChange) {
        var selected = _.find(ctrl.tabs, function (tab) {
          return getTabId(tab) === tabId;
        });
        if (selected) {
          ctrl.selectTab(selected, noUrlChange);
        }
      };
      ctrl.changeUrl = function (tab) {
        // replaces :params with actual values.
        var params = ctrl.getParentParameters();
        params[config.tabParameter] = tab.fragment;
        var tabUrl = routeUtils.replaceParams(section, params);
        $location.path(tabUrl);
      };
      ctrl.selectTab = function selectTab(tab, noUrlChange) {
        selectedTabId = getTabId(tab);
        if (config.onTabChange) {
          config.onTabChange(tab);
        }
        _.each(ctrl.tabs, function (tab) {
          tab.active = false;
        });
        tab.active = true;
        if (!noUrlChange) {
          ctrl.changeUrl(tab);
        }
      };
      ctrl.updateVisibility = function () {
        for (var i = 0; i < ctrl.tabs.length; i++) {
          if (i < firstTabIdx) {
            // si le tab est actif alors on le desactive
            if (ctrl.tabs[i].active) {
              if (i - 1 >= firstTabIdx) {
                ctrl.changeUrl(ctrl.tabs[i - 1]);
              } else {
                ctrl.changeUrl(ctrl.tabs[i + 1]);
              }
            }
            ctrl.tabs[i].visible = false;
          } else {
            ctrl.tabs[i].visible = true;
          }
        }
      };
      $scope.hasNext = function () {
        var nextTab = firstTabIdx + (config ? config.max : 100);
        return nextTab < ctrl.tabs.length;
      };
      $scope.next = function () {
        if ($scope.hasNext()) {
          firstTabIdx++;
          ctrl.updateVisibility();
        }
      };
      $scope.hasPrevious = function () {
        return firstTabIdx > 0;
      };
      $scope.previous = function () {
        if ($scope.hasPrevious()) {
          firstTabIdx--;
          ctrl.updateVisibility();
        }
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/tabset/tlTabLayout.js", __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 3009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlTabLayoutContent", ["$rootScope", "$compile", "$q", "templateUtils", "$controller", "deferredUtils", function ($rootScope, $compile, $q, templateUtils, $controller, deferredUtils) {
  var INVALIDATION_EVENT = "$PAGE_DATA_UPDATED";
  var defaultTabConfig = {
    tabClass: "",
    unload: false,
    invalidable: false
  };
  return {
    restrict: "E",
    replace: true,
    require: ["tlTabLayoutContent", "^tlTabLayout", "hideableContainer"],
    scope: true,
    template: '<div hideable-container class="ts-tab-content autosize-reference"></div>',
    link: function link($scope, $el, $attrs, controllers) {
      var tabController = controllers[0],
        tabsetController = controllers[1],
        visibilityCtrl = controllers[2];
      tabController.$initialize(tabsetController, visibilityCtrl);
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        tabsetCtrl = null,
        visibilityCtrl = null,
        tab = $scope.tab,
        tabId = null,
        tabLoaded = false,
        tabContent = null,
        tabScope = null,
        config = null;
      var generateConfig = function generateConfig() {
        var keys = _.keys(defaultTabConfig),
          tabsetConfig = tabsetCtrl.getConfig();
        config = {};
        _.each(keys, function (key) {
          if (_.has(tab, key)) {
            config[key] = tab[key];
          } else if (_.has(tabsetConfig, key)) {
            config[key] = tabsetConfig[key];
          } else {
            config[key] = defaultTabConfig[key];
          }
        });
      };
      ctrl.$initialize = function (_tabsetCtrl, _visibilityCtrl) {
        tabsetCtrl = _tabsetCtrl;
        visibilityCtrl = _visibilityCtrl;
        tabId = tabsetCtrl.getTabId(tab);
        generateConfig();
        $element.attr("tabset-fragment", tab.fragment);
        if (config.tabClass) {
          $element.addClass(config.tabClass);
        }
        $scope.$watch(ctrl.isSelected, function (isSelected) {
          visibilityCtrl.setVisible(isSelected);
        });
        var visibilityChangeHandler = function visibilityChangeHandler(visible) {
          visible ? ctrl.showTab() : ctrl.hideTab();
        };
        visibilityCtrl.on("visibility:change", visibilityChangeHandler);
        var selected = ctrl.isSelected();
        visibilityCtrl.setVisible(selected);
        if (selected) {
          ctrl.showTab();
        }
        if (config.invalidable) {
          bindInvalidationEvents();
        }
      };
      var bindInvalidationEvents = function bindInvalidationEvents() {
        var invalidationHandler = function invalidationHandler() {
          if (visibilityCtrl.isVisible()) {
            return;
          }
          ctrl.unloadTabContent();
        };
        var removeInvalidationListener = $rootScope.$on(INVALIDATION_EVENT, invalidationHandler);
        $scope.$on("$destroy", function () {
          removeInvalidationListener();
        });
      };
      ctrl.isSelected = function () {
        return tabsetCtrl.getSelectedTabId() === tabId;
      };
      ctrl.getFragment = function () {
        return tab.fragment;
      };
      ctrl.usePanelLayout = function (panelLayout) {
        panelLayout ? $element.addClass("has-panel") : $element.removeClass("has-panel");
        ctrl.setPanelOpened(false);
      };

      // only used with panel layout (for pill styles purposes)
      ctrl.setPanelOpened = function (panelOpened) {
        tab.panelOpened = panelOpened;
      };
      ctrl.showTab = function () {
        if (!tabLoaded) {
          ctrl.loadTabContent();
        }
        $element.show();
      };
      ctrl.hideTab = function () {
        if (tabLoaded && config.unload) {
          ctrl.unloadTabContent();
        }
        $element.hide();
      };
      ctrl.unloadTabContent = function () {
        if (tabScope != null) {
          tabScope.$destroy();
          tabScope = null;
          tabContent.remove();
          tabContent = null;
        }
        tabLoaded = false;
      };
      ctrl.loadTabContent = function () {
        var resolvesPromise = deferredUtils.resolvePromiseMap(tab.resolve || {});
        var templatePromise = templateUtils.loadTemplate(tab);
        $q.all([resolvesPromise, templatePromise]).then(function (resolves) {
          tabScope = $scope.$new();
          var locals = resolves[0],
            template = resolves[1];
          if (tab.controller) {
            locals.$scope = tabScope;
            locals.$element = $element;
            $controller(tab.controller, locals);
          }
          $compile(template)(tabScope, function (content) {
            tabContent = content;
            $element.append(content);
          });
          tabLoaded = true;
        });
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/tabset/tlTabLayoutContent.js", __webpack_require__(1)))

/***/ }),
/* 3010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlTabLayoutPill", ["$mdButtonInkRipple", "directiveUtils", "$animate", function ($mdButtonInkRipple, directiveUtils, $animate) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: "^tlTabLayout",
    template: '<div class="ts-tab-pill tl-panel-menu" ng-click="onPillClick()" ng-class="{selected : isSelectedTab(), \'panel-opened\' : tab.panelOpened}"></div>',
    link: function link($scope, $el, $attrs, tabsetCtrl) {
      $mdButtonInkRipple.attach($scope, $el);
      var tab = $scope.$eval("tab");
      $el.attr("tabset-fragment", tab.fragment);

      // PGA : bug entre ng-repeat et l'ajout de classe selected qui pose soucis lors du déplacement dans la section reporting.
      //       a priori on a pas besoin des animations angular ici, donc je désactive.
      $animate.enabled($el, false);
      $scope.onPillClick = function () {
        tabsetCtrl.changeUrl(tab);
      };
      $scope.isSelectedTab = function () {
        return tabsetCtrl.isSelectedTab(tab);
      };
      var directiveName = tab.pillDirective || tabsetCtrl.getConfig().pillDirective;
      directiveUtils.compileDirective(directiveName)($scope, function (clone) {
        clone.appendTo($el);
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/tabset/tlTabLayoutPill.js"))

/***/ }),
/* 3011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlTabLayoutPillDefaultContent", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: "^tlTabLayout",
    template: '' + '<div class="ts-tab-pill-content">' + '   <i ng-show="tab.icon" class="fa {{tab.icon}}"></i>' + '   <h1>{{ tab.label || (tab.labelKey | translate) }}</h1>' + '</div>',
    link: function link($scope, $el, $attrs, tabLayoutCtrl) {
      var tab = $scope.tab;
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/tabset/tlTabLayoutPillDefaultContent.js"))

/***/ }),
/* 3012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('tfForm', function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: "\n            <div class=\"tf-form\">\n                <div class=\"tf-form-inner\" ng-transclude></div>               \n            </div>\n        "
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/tf-form/tf-form.js"))

/***/ }),
/* 3013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('tfMultiStepsIndicator', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      steps: '<',
      selected: '<'
    },
    transclude: true,
    template: "\n            <div class=\"tf-multi-steps-indicator\">\n                <tf-multi-steps-indicator-step\n                    ng-repeat=\"step in steps\"\n                    step=\"step\"\n                    selected=\"selected\"\n                ></tf-multi-steps-indicator-step>\n            </div>\n        "
  };
});
ngModule.directive('tfMultiStepsIndicatorStep', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      step: '<',
      selected: '<'
    },
    template: "\n            <div class=\"tf-multi-steps-indicator-step\"\n                 ng-class=\"{selected: step.id === selected}\">\n                <span>{{::step.label}}</span>\n            </div>\n        "
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/tf-form/tf-multi-steps-indicator.js"))

/***/ }),
/* 3014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive('tfSectionTitle', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    transclude: true,
    template: "\n            <div class=\"tf-section-title\">\n                <div class=\"line-around line-before\"></div>\n                <div class=\"content\">\n                    <h3 ng-transclude></h3>\n                </div>\n                <div class=\"line-around line-after\"></div>\n            </div>\n        "
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/tf-form/tf-section-title.js"))

/***/ }),
/* 3015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlChart", ["scopeUtils", function (scopeUtils) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: '' + '<div class="tl-chart">' + '   <highchart config="chartConfig"></highchart>' + '</div>',
    link: function link($scope, $element, $attrs, ctrl) {
      var unwatch = null;
      $attrs.$observe("chartConfig", function (configAttrName) {
        unwatch && unwatch();
        scopeUtils.dataBind(configAttrName, "chartConfig", $scope);
      });
      $scope.$on("$print:toggle", function (evt, print) {
        var highchartCtrl = ctrl.getHighchartCtrl();
        highchartCtrl.redraw();
      });
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        highchartCtrl = null;
      ctrl.getHighchartCtrl = function () {
        if (highchartCtrl == null) {
          highchartCtrl = $element.find("div.highchart").controller("highchart");
        }
        return highchartCtrl;
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/tl-chart.js"))

/***/ }),
/* 3016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlCountryFlag", function () {
  return {
    restrict: "E",
    replace: true,
    scope: {
      // cf. enum Pays
      isoCode: "="
    },
    template: "<span tl-tooltip=\"{{'lov.pays.'+(isoCode || 'FRA')|translate}}\" class=\"tl-currency-flag flag24 flag-{{flagCode}}\"></span",
    link: function link($scope, $el, $attrs) {
      $scope.code = $scope.isoCode || 'FRA';
      var toFlagCode = function toFlagCode(pays) {
        if (pays == null) {
          return "fr";
        } else return pays.substring(0, 2).toLowerCase();
      };
      $scope.flagCode = toFlagCode($scope.isoCode);
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/tl-country-flag.js"))

/***/ }),
/* 3017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlCurrencyFlag", ["currencyService", function (currencyService) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      currencyCode: "="
    },
    template: '<span class="tl-currency-flag flag24 flag-{{flagCode}}"></span>',
    link: function link($scope, $el, $attrs) {
      var currencies = currencyService.getAll();
      var getFlagCode = function getFlagCode(currencyCode) {
        var currency = _.find(currencies, {
          isoCode: currencyCode
        });
        return currency != null && currency.flagCode;
      };
      $scope.$watch("currencyCode", function (currencyCode) {
        $scope.flagCode = getFlagCode(currencyCode);
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/tl-currency-flag.js", __webpack_require__(1)))

/***/ }),
/* 3018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("tlTable", ["$print", function ($print) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: ["tlTable", "?^hideableContainer"],
    template: '' + '<div class="tl-table">' + '   <infini-table table-config="innerTableConfig"></infini-table>' + '</div>',
    link: function link($scope, $element, $attrs, controllers) {
      var ctrl = controllers[0],
        hideableContainerCtrl = controllers[1];
      var unwatch = null;
      $attrs.$observe("tableConfig", function (configName) {
        if (unwatch != null) {
          unwatch();
        }
        $scope.$watch(configName, function (tableConfig) {
          prepareTableConfig(tableConfig);
        });
      });
      function prepareTableConfig(tableConfig) {
        if (tableConfig == null) {
          return;
        }
        var wrappedConfig = _.extend(tableConfig, {
          visibilityManager: hideableContainerCtrl
        });
        if ($print.isPrintEnabled()) {
          wrappedConfig.fullMode = true;
        }
        $scope.innerTableConfig = wrappedConfig;
      }
      $scope.$on("$print:toggle", function (evt, print) {
        var itCtrl = ctrl.getInfiniTableCtrl();
        if (print) {
          itCtrl.enableFullMode();
        } else {
          itCtrl.disableFullMode();
        }
      });
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        infiniTableCtrl = null;
      ctrl.getInfiniTableCtrl = function () {
        if (infiniTableCtrl == null) {
          infiniTableCtrl = $element.find("div.infini-table").controller("infiniTable");
        }
        return infiniTableCtrl;
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/tl-table.js", __webpack_require__(1)))

/***/ }),
/* 3019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

// javascript-accessible copy of the colors contained in the colors.less file
ngModule.factory("tlColors", function () {
  return {
    WHITE: "#FFFFFF",
    BLACK: "#000000",
    FUSCHIA: "#A52694",
    DARK_YELLOW: "#ffc902",
    // NEW COLORS

    NEW_LIGHT_BLUE: "#39BEE7",
    NEW_BLUE_1: "#0069C0",
    NEW_BLUE_2: "#5D9CEC",
    NEW_PURPLE_1: "#564AA3",
    NEW_PURPLE_2: "#7266BA",
    NEW_GREEN_1: "#2B957A",
    NEW_GREEN_2: "#37BC9B",
    NEW_GREEN_3: "#1E983B",
    NEW_GREEN_4: "#27C24C",
    NEW_RED_1: "#EC2121",
    NEW_RED_2: "#F05050",
    NEW_ORANGE_1: "#F77600",
    NEW_ORANGE_2: "#FF902B",
    NEW_BLACK_1: "#131E26",
    // NEW_BLUE_1
    CAPITAL: "#0069C0",
    CAPITAL_SIMULES: '#cddef5',
    // NE_ORANGE_1
    INTERET: "#F77600",
    INTERET_SIMULES: '#FFB56B',
    // NEW_GREEN_1:
    COMMISSION: "#2B957A",
    COMMISSION_SIMULEES: '#77F079',
    // NEW_BLUE_1
    FIXE: "#0069C0",
    // NEW_ORANGE_1
    VARIABLE: "#F77600",
    // NEW_GREEN_1
    STRUCTURE: "#2B957A",
    DATE_VISUALISATION: '#4DC100',
    COURBE_TAUX_1: '#4DC100',
    COURBE_TAUX_2: '#0069C0',
    COURBE_TAUX_3: '#F77600',
    GREY2: '#BEBEBE',
    PREPARATION_DEMANDE: '#0083de',
    ATTENTE_ATTRIBUTION: '#ffc902',
    ATTRIBUEE: '#4DC100',
    TERMINEE: '#000000'
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/tlColors.js"))

/***/ }),
/* 3020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

// helpers pour les tlTable
ngModule.factory("tlTableUtils", ["itTableRegistry", "$interpolate", function (itTableRegistry, $interpolate) {
  function _getNewTableSelection(selectedElement, list, idAttributeName) {
    if (idAttributeName === undefined) {
      idAttributeName = 'id';
    }
    var foundItem = null;
    if (selectedElement != null) {
      _.each(list, function (c) {
        if (c[idAttributeName] === selectedElement[idAttributeName]) {
          foundItem = c;
        }
      });
    }
    return foundItem;
  }
  return {
    /**
     * workaround sur les problème d'affichage lors de resize du contenu de la page qui impacte le tl-table
     * @param listOrElementName les nom (chaine) de la list/element a watcher pour générer un resize
     */
    fixResize: function fixResize($scope, listOrElementName) {
      $scope.$watch(listOrElementName, function () {
        // fix resize issue on table selection/resize
        _.delay(function () {
          $scope.$broadcast("$resize");
          $scope.$apply();
        }, 200);
      });
    },
    /**
     * après une mise à jour d'une liste, renvoie le nouvel element qui correspond à la selection en ce basant sur un attribut 'id'
     * @param selectedElement l'éléement du tableau préalablement selectionné (ex: $scope.selected)
     * @param list la liste des donnes du tableau
     * @param {string} [idAttributeName=id] si non fourni alors 'id'
     * @return le nouvel element selectionné, null si aucun
     */
    getNewTableSelection: function getNewTableSelection(selectedElement, list, idAttributeName) {
      return _getNewTableSelection(selectedElement, list, idAttributeName);
    },
    /**
     * unwatch et vide le tableau
     * @param watchers un array des "unwatchers" créé via watchers.push($scope.$watcher(...))
     */
    unbindWatchers: function unbindWatchers(watchers) {
      var length = watchers.length;
      for (var i = 0; i < length; i++) {
        // unbind
        watchers[i]();
      }
      while (watchers.length) {
        watchers.pop();
      }
    },
    /**
     * prochain element de la source de la table (en tenant bien compte de la visualisation actuelle avec le tri)
     * @param tableId champs id de la configuration de la table
     * @param id valeur de l'identifiant
     * @param idAttributeName par défaut 'id'
     * @returns {null|*}
     */
    getNextTableElement: function getNextTableElement(tableId, id, idAttributeName) {
      if (idAttributeName === undefined) {
        idAttributeName = 'id';
      }
      var tableRendererCtrl = itTableRegistry.getController(tableId);
      if (!tableRendererCtrl) {
        console.error('Impossible de trouver le controller de la table d\'id : ' + tableId + " pour trouver l'id : " + id);
      }
      var data = tableRendererCtrl.getDataSource();
      for (var i = 1; i < data.length; i++) {
        if (data[i - 1][idAttributeName] === id) {
          return data[i];
        }
      }
      return null;
    },
    /**
     * met à jour la selection avec la derniere selectionner ou si non présente la next
     * @param $scope
     * @param selectedAttribute
     * @param nextAttribute
     * @param list la liste où l'on veut retrouver l'élement suivant
     * @param idAttributeName
     */
    updateSelectedWithSelectedOrNextTableElement: function updateSelectedWithSelectedOrNextTableElement($scope, selectedAttribute, nextAttribute, list, idAttributeName) {
      var newSelection;
      if (idAttributeName === undefined) {
        idAttributeName = 'id';
      }
      newSelection = _getNewTableSelection($scope[selectedAttribute], list, idAttributeName);

      // selectionne l'element suivant si la selection n'est plus présente
      if (newSelection == null && $scope[nextAttribute] != null) {
        newSelection = _.find(list, function (m) {
          return m[idAttributeName] === $scope[nextAttribute][idAttributeName];
        });
        if (newSelection == null) {
          console.log('non trouvé', $scope[nextAttribute], list);
        }
      }
      $scope[nextAttribute] = null;
      $scope[selectedAttribute] = newSelection;
    },
    /**
     * pour gérer le formattage en fonction du filtre de la colonne de référence (nécessaire pour la date)
     * subtotalTemplate: '<span>TOTAL : {{displaySubtotalRefValue(model)}}</span>'
     *
     */
    displaySubtotalRefValue: function displaySubtotalRefValue(model) {
      var expression = '{{model.__refValue__';
      if (model.__refValueFilter__) {
        expression += '|' + model.__refValueFilter__;
      }
      expression += '}}';
      return $interpolate(expression)({
        'model': model
      });
    },
    /**
     * ajoute les colonnes du tableau (qui ont un id de défini) au choix d'affichage des colonnes.<br/>
     * Ne gère pour le moment pas les "sous-colonnes"<br/>
     *
     * Vous pouvez ajouter sur les colonne : <br/>
     * columnGroup=false pour ne pas mettre cette colonne dans le colomnGroup automatiquement<br/>
     * columnGroupTitle titre de la colonne dans le columnGroup (pratique par exemple pour une colonne où l'on affiche pas le titre ou un abrégé)<br/>
     * columnGroupVisible : indique si la colonne est cochée (visible) ou non par défaut. Si non précisée, elle est non affichée par défaut.<br/>
     * @param columnGroups
     * @param columns
     */
    updateColumnGroup: function updateColumnGroup(columnGroups, columns) {
      _.each(columns, function (column) {
        if (column.columnGroup !== false && column.id) {
          columnGroups.push({
            id: column.id,
            title: column.columnGroupTitle || column.title,
            columns: [column.id],
            visible: column.columnGroupVisible || false
          });
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/tlTableUtils.js", __webpack_require__(1)))

/***/ }),
/* 3021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("topbarAppSwitcher", ["$location", "$translate", "$applications", "$authz", "$session", function ($location, $translate, $applications, $authz, $session) {
  var IGNORED_APPS = ["INTRA", "OBSERVATOIRE"];
  return {
    restrict: 'E',
    replace: true,
    template: __webpack_require__(3746),
    link: function link($scope, $el, $attrs) {
      var currentAppId = $applications.getCurrentAppId();
      var appLabelKey = "topbar.appLabel." + currentAppId;
      if (currentAppId === 'OBSERVATOIRE_FINANCIER' && $authz.hasRole('OBSERVATOIRE_FINANCIER_SIMPLIFIE')) {
        appLabelKey += ".COMPAROSCOPE";
      }
      ;
      if (currentAppId === 'AIDE_SUBVENTION' && $authz.hasRole('SUBVENTION_COLLABORATEUR_EXTERNE')) {
        appLabelKey += ".PORTAIL";
      }
      ;
      $scope.appLabel = $translate(appLabelKey);
      $scope.applications = _.reject($applications.getAllowedApplications(), function (app) {
        return app.id === currentAppId || _.includes(IGNORED_APPS, app.id);
      });
      $scope.externalApplications = $session.getExternalApplications();
      $scope.showSwitcher = ($scope.applications.length > 0 || $scope.externalApplications.length > 0) && !_.includes(IGNORED_APPS, currentAppId);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/topbar/app-switcher/topbar-app-switcher.js", __webpack_require__(1)))

/***/ }),
/* 3022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.component("topbarPrint", {
  template: __webpack_require__(3747),
  controller: ["$scope", "$session", function controller($scope, $session) {
    $scope.nomClient = $session.getCompte().nomClient;
  }]
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/topbar/topbar-print.js"))

/***/ }),
/* 3023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("topbarStatus", function () {
  return {
    key: null
  };
});
ngModule.run(["$rootScope", "topbarStatus", function ($rootScope, topbarStatus) {
  $rootScope.$on("$routeChangeSuccess", function (angularEvent, currentRoute, previousRoute) {
    topbarStatus.key = currentRoute.topbarKey || "";
  });
}]);
ngModule.directive("topbarLogo", ["$location", "$translate", "$applications", function ($location, $translate, $applications) {
  return {
    restrict: 'E',
    replace: true,
    template: '' + '<div class="topbar-logo" ng-click="toHome()">' + '   <img class="taelys-logo" src="/images/logo_taelys.svg"/>' + '</div>',
    link: function link($scope, $el, $attrs) {
      $scope.toHome = function () {
        $location.path('/');
      };
      var appId = $applications.getCurrentAppId();
      $scope.appLabel = $translate("topbar.appLabel." + appId);
    }
  };
}]);
ngModule.directive("topbarNav", function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<ul class="topbar-nav" ng-transclude></ul>'
  };
});
ngModule.directive("topbarNavElem", ["topbarStatus", "iconUtils", function (topbarStatus, iconUtils) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      key: "@",
      url: "@",
      label: "@",
      title: "@",
      /**
       * permet de choisir une couleur spécifique pour l'icone
       */
      color: "@",
      icon: "@"
    },
    template: '' + '<li class="topbar-nav-el" ng-class="{ selected : selected }">' + '   <a href="{{::url}}">' + '       <i class="nav-icon {{::fullIcon}} {{::color}}"></i>' + '       <span ng-if="::label">{{::label | translate}}</span>' + '       <span ng-if="::title">{{::title}}</span>' + '   </a>' + '</li>',
    link: function link($scope, $el, $attrs) {
      $scope.fullIcon = iconUtils.getFullName($scope.icon);
      $scope.$watch(function () {
        return topbarStatus.key;
      }, function (topbarKey) {
        $scope.selected = topbarKey === $scope.key;
      });
    }
  };
}]);
ngModule.directive("topbarUserboxContent", ["$session", "$authz", function ($session, $authz) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '' + '<div class="userbox-content">' + '   <div class="client-picture-box">' + '       <file-image img-scale img-width="100" img-height="42" class="client-picture" url="/rest/compte/current/icon"></file-image>' + '   </div>' + '   <span class="client-name" ng-class="{\'vueClient\':isVueClient}">{{username}}</span>' + '   <i class="fa fa-caret-down"></i>' + '</div>',
    link: function link($scope, $el, $attrs) {
      var user = $session.getUser(),
        compte = $session.getCompte();
      $scope.username = compte && (compte.nomClientCourt || compte.nomClient) || user.prenom + " " + user.nom;
      $scope.isVueClient = $authz.hasRole("INTRA_TAELYS_AVEC_VUE_CLIENT");
    }
  };
}]);
ngModule.directive("topbarEnvironment", ["$session", function ($session) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: "<div class=\"environment environnement-{{::environment}}\" ng-if=\"::environment!=='prod'\">{{::environment|uppercase}}</div>",
    link: function link($scope, $el, $attrs) {
      $scope.environment = $session.getEnvironment();
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/topbar/topbar.js"))

/***/ }),
/* 3024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("userMenuLogoutButton", ["security", "$session", "$applications", function (security, $session, $applications) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: __webpack_require__(3753),
    link: function link($scope, $el, $attrs) {
      var user = $session.getUser();
      if ($applications.getCurrentAppId() !== 'INTRA' && _.includes(user.habilitations, 'INTRA_TAELYS')) {
        $scope.toIntra = true;
      }
      $scope.performLogout = function () {
        return security.exit();
      };
    }
  };
}]);
ngModule.directive("userMenuPrintModeButton", ["$print", function ($print) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: __webpack_require__(3754),
    link: function link($scope, $el, $attrs) {
      $scope.enablePrintMode = function () {
        $print.enablePrint();
      };
    }
  };
}]);
ngModule.directive("userMenuGestionCompteButton", ["$print", function ($print) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: __webpack_require__(3750),
    link: function link($scope, $el, $attrs) {}
  };
}]);
ngModule.directive("userMenuAccountsSection", ["$http", "security", function ($http, security) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: __webpack_require__(3748),
    link: function link($scope, $el, $attrs, stringUtils) {},
    controller: ["$scope", "stringUtils", function controller($scope, stringUtils) {
      $scope.params = {
        search: null
      };
      $scope.authToken = security.getTokens().authenticationToken;
      $http.get('/rest/compte/comptes-accessibles').then(function (response) {
        $scope.filteredComptesAccessibles = $scope.comptesAccessibles = response.data;
        updateFiltered(true);
      });
      var updateFiltered = function updateFiltered(updateShowSearchTextBox) {
        $scope.filteredComptesAccessibles = _.extend({}, $scope.comptesAccessibles);
        $scope.filteredComptesAccessibles.parents = _.filter($scope.comptesAccessibles.parents, function (c) {
          return !$scope.params.search || stringUtils.containsIgnoringCaseAndAccents(c.nomClient, $scope.params.search);
        });
        $scope.filteredComptesAccessibles.enfants = _.filter($scope.comptesAccessibles.enfants, function (c) {
          return !$scope.params.search || stringUtils.containsIgnoringCaseAndAccents(c.nomClient, $scope.params.search);
        });
        $scope.filteredComptesAccessibles.autres = _.filter($scope.comptesAccessibles.autres, function (c) {
          return !$scope.params.search || stringUtils.containsIgnoringCaseAndAccents(c.nomClient, $scope.params.search);
        });

        // limite l'affichage du search au fait d'avoir + de 6 comptes
        if (updateShowSearchTextBox) {
          $scope.showSearchTextBox = $scope.filteredComptesAccessibles.parents.length + $scope.filteredComptesAccessibles.enfants.length + $scope.filteredComptesAccessibles.autres.length > 6;
        }
      };
      $scope.$watch('params', function (newVal, oldVal) {
        if (newVal && oldVal && newVal !== oldVal) {
          updateFiltered(false);
        }
      }, true);
    }]
  };
}]);
ngModule.directive("userMenuToolboxButton", ["toolboxService", function (toolboxService) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: __webpack_require__(3757),
    link: function link($scope, $el, $attrs) {
      $scope.openToolbox = function () {
        toolboxService.openToolboxPopin();
      };
    }
  };
}]);
ngModule.directive("userMenuTaskManagerButton", ["userTaskService", function (userTaskService) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: __webpack_require__(3756),
    link: function link($scope, $el, $attrs) {
      $scope.openTaskList = function () {
        userTaskService.openTaskList();
      };
    }
  };
}]);
ngModule.directive("userMenuGuideUtilisateurButton", function () {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: __webpack_require__(3751),
    link: function link($scope, $el, $attrs) {}
  };
});
ngModule.directive("userMenuLab", function () {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: __webpack_require__(3752),
    link: function link($scope, $el, $attrs) {}
  };
});

/**
 * pour la partie subvention
 */
ngModule.directive("userMenuFormatMontants", ["$http", function ($http) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: __webpack_require__(3749),
    link: function link($scope, $el, $attrs, stringUtils) {},
    controller: ["$scope", "contextService", function controller($scope, contextService) {
      $scope.context = contextService.getContext();
      $scope.switchDecimales = function () {
        if (!$scope.context.cacherDecimales || $scope.context.cacherDecimales == false) {
          $scope.context.cacherDecimales = true;
        } else {
          $scope.context.cacherDecimales = false;
        }
      };
      $scope.changeUnite = function () {
        if ($scope.context.uniteAffichageMontant === 'K') {
          $scope.context.uniteAffichageMontant = 'M';
        } else if ($scope.context.uniteAffichageMontant === 'M') {
          $scope.context.uniteAffichageMontant = null;
        } else {
          $scope.context.uniteAffichageMontant = 'K';
        }
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/topbar/user-menu/actions/userMenuActions.js", __webpack_require__(1)))

/***/ }),
/* 3025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("userMenuSwitchVueClient", function () {
  return {
    restrict: "E",
    replace: true,
    template: __webpack_require__(3755),
    controller: ["$scope", "$http", "routeUtils", function controller($scope, $http, routeUtils) {
      $scope.switchVueClient = function () {
        $http.post('/rest/home/switch-vue-client-intra').then(function () {
          routeUtils.reloadApp();
        });
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/topbar/user-menu/actions/userMenuSwitchVueClient.js"))

/***/ }),
/* 3026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("topbarUserMenu", function () {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: __webpack_require__(3758)
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/topbar/user-menu/topbar-user-menu.js"))

/***/ }),
/* 3027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, _, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
var computeRepeatScopeMeta = function computeRepeatScopeMeta(scopeArray) {
  var scope;
  var length = scopeArray.length;
  for (var i = 0; i < length; i++) {
    scope = scopeArray[i];
    scope.$index = i;
    scope.$first = i === 0;
    scope.$last = i === length - 1;
    scope.$middle = !(scope.$first || scope.$last);
  }
};
ngModule.factory("treeTableDefaultConfig", function () {
  return {
    // config
    idAttribute: "id",
    labelAttribute: "id",
    childrenAttribute: "children",
    // images path
    spacerCrossClass: "spacer-cross",
    spacerCornerClass: "spacer-corner",
    spacerLineClass: "spacer-line",
    spacerNoneClass: "spacer-none",
    // events
    onRowClick: function onRowClick(model, scope, row) {},
    // templates
    rowTemplate: '<tr tree-table-row></tr>',
    mainCellTemplate: '<td></td>',
    mainCellContentTemplate: '<span>{{model[config.labelAttribute]}}</span>',
    spacerTemplate: '<tree-table-spacer></tree-table-spacer>'
  };
});
ngModule.directive("treeTable", ["$compile", "$interpolate", function ($compile, $interpolate) {
  return {
    restrict: "E",
    scope: true,
    replace: true,
    template: '<div class="tree-table" tabindex="0">' + '   <div class="tree-head">' + '       <table class="tree-head-table">' + '           <colgroup></colgroup>' + '           <thead></thead>' + '       </table>' + '   </div>' + '   <div class="tree-body">' + '       <table class="tree-body-table">' + '           <colgroup></colgroup>' + '           <tbody></tbody>' + '       </table>' + '   </div>' + '</div>',
    controller: ["$scope", "$element", "treeTableDefaultConfig", function controller($scope, $element, treeTableDefaultConfig) {
      var ctrl = this,
        initialized = false,
        linkers = {};
      var ui = {
        table: $element,
        headDiv: $element.find(".tree-head"),
        headTable: $element.find(".tree-head table"),
        headColgroup: $element.find(".tree-head table colgroup"),
        contentDiv: $element.find(".tree-body"),
        contentTable: $element.find(".tree-body table"),
        contentColgroup: $element.find(".tree-body table colgroup"),
        contentBody: $element.find(".tree-body table tbody")
      };
      var compileLinkers = function compileLinkers() {
        linkers.row = $compile(config.rowTemplate);
        linkers.mainCell = $compile(config.mainCellTemplate);
        linkers.mainCellContent = $compile(config.mainCellContentTemplate);
        linkers.spacer = $compile(config.spacerTemplate);
      };
      var bindEvents = function bindEvents() {
        // row click
        $element.delegate(".tree-body table tbody tr", "click", function (event) {
          var row = $(event.currentTarget);
          var rowScope = row.scope();
          var rowModel = rowScope.model;
          $scope.$apply(function () {
            config.onRowClick(rowModel, rowScope, row);
          });
        });
      };
      var config = null;
      ctrl.initialize = function (_config) {
        config = _.extend({}, angular.copy(treeTableDefaultConfig), _config);
        $scope.config = config;
        compileLinkers();
        config.$linkers = linkers;
        config.$ui = ui;
        bindEvents();
        initialized = true;
      };
      ctrl.getConfig = function () {
        return config;
      };
      var dataSource = null;
      ctrl.setDataSource = function (_dataSource) {
        dataSource = _dataSource;
        startCollectionWatch();
      };
      var childCollection = [];
      var startCollectionWatch = function startCollectionWatch() {
        var watchDataSource = function watchDataSource() {
          return dataSource;
        };
        $scope.$watchCollection(watchDataSource, function (newCollection, oldCollection) {
          var addedChildren = newCollection === oldCollection ? newCollection : _.difference(newCollection, oldCollection);
          _.each(addedChildren, function (model) {
            ctrl.createRootRow(model);
          });
          var removedChildren = newCollection === oldCollection ? [] : _.difference(oldCollection, newCollection);
          _.each(removedChildren, function (model) {
            ctrl.removeRootRow(model);
          });
          ctrl.recomputeChildrenScopesMeta();
        });
      };
      ctrl.recomputeChildrenScopesMeta = function () {
        computeRepeatScopeMeta(_.map(childCollection, function (row) {
          return row.scope;
        }));
      };
      $scope.$on("recompute-tree-indexes", function (event) {
        event.stopPropagation();
        ctrl.recomputeChildrenScopesMeta();
      });
      ctrl.createRootRow = function (model) {
        var rowScope = $scope.$new();
        _.extend(rowScope, {
          model: model,
          root: true,
          depth: 0,
          parent: null
        });
        linkers.row(rowScope, function (row) {
          ui.contentBody.append(row);
          childCollection.push({
            model: model,
            scope: rowScope,
            element: row
          });
        });
      };
      ctrl.removeRootRow = function (model) {
        var child = _.find(childCollection, {
          model: model
        });
        child.scope.$destroy();
        child.element.remove();
      };
    }],
    link: function link($scope, $el, $attrs, ctrl) {
      $attrs.$observe("tableConfig", function (tableConfigAttrName) {
        var tableConfig = $scope.$parent.$eval(tableConfigAttrName);
        ctrl.initialize(tableConfig);
        var source = tableConfig.source;
        $scope.$watch(source, function (source) {
          if (source == null) {
            return;
          }
          ctrl.setDataSource(source);
        });
      });
    }
  };
}]);
ngModule.directive("treeTableRow", function () {
  return {
    restrict: "A",
    scope: true,
    require: ["^treeTable", "treeTableRow"],
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this;
      var childCollection = $scope.children = [];
      var findLastNode = function findLastNode() {
        if (!$scope.children.length) {
          return $element;
        }
        var children = $scope.children;
        var lastChild;
        do {
          lastChild = children[children.length - 1];
          children = lastChild.element.scope().children;
        } while (children.length);
        return lastChild.element;
      };
      ctrl.createChildRow = function (model) {
        var childScope = $scope.$new();
        _.extend(childScope, {
          model: model,
          root: false,
          depth: $scope.depth + 1,
          parent: $scope
        });
        $scope.config.$linkers.row(childScope, function (row) {
          var lastNode = findLastNode();
          row.insertAfter(lastNode);
          childCollection.push({
            model: model,
            scope: childScope,
            element: row
          });
        });
      };
      ctrl.removeChildRow = function (model) {
        var child = _.find(childCollection, {
          model: model
        });
        if (child == null) {
          return;
        }
        child.scope.$destroy();
        child.element.remove();
        var childIdx = _.indexOf(childCollection, child);
        if (childIdx > -1) {
          childCollection.splice(childIdx, 1);
        }
      };
      ctrl.recomputeSpacers = function () {
        $scope.$emit("recompute-tree-indexes");
        $scope.$broadcast("recompute-spacer");
      };
      $scope.$on("recompute-tree-indexes", function () {
        ctrl.recomputeChildrenScopesMeta();
      });
      ctrl.recomputeChildrenScopesMeta = function () {
        // console.log('recompute children scopes meta')
        computeRepeatScopeMeta(_.map(childCollection, function (row) {
          return row.scope;
        }));
      };
      ctrl.getScope = function () {
        return $scope;
      };
      $scope.$on("$destroy", function () {
        _.each(_objectSpread({}, childCollection), function (child) {
          ctrl.removeChildRow(child.model);
        });
      });
    }],
    link: function link($scope, $el, $attrs, controllers) {
      var tableCtrl = controllers[0];
      var rowCtrl = controllers[1];
      var config = tableCtrl.getConfig();
      $el.attr("row-depth", $scope.depth);
      $el.addClass("depth-" + $scope.depth);
      var mainCell;
      config.$linkers.mainCell($scope, function (_mainCell) {
        mainCell = _mainCell.appendTo($el);
      });
      for (var i = 0; i < $scope.depth; i++) {
        var spacerScope = $scope.$new();
        spacerScope.$index = i;
        config.$linkers.spacer(spacerScope, function (spacer) {
          spacer.appendTo(mainCell);
        });
      }
      config.$linkers.mainCellContent($scope, function (mainCellContent) {
        mainCellContent.appendTo(mainCell);
      });
      $scope.$watchCollection("model." + config.childrenAttribute, function (newChildren, oldChildren) {
        var removedChildren = newChildren === oldChildren ? [] : _.difference(oldChildren, newChildren);
        _.each(removedChildren, function (child) {
          rowCtrl.removeChildRow(child);
        });
        var addedChildren = newChildren === oldChildren ? newChildren : _.difference(newChildren, oldChildren);
        _.each(addedChildren, function (child) {
          rowCtrl.createChildRow(child);
        });
        rowCtrl.recomputeSpacers();
      });
    }
  };
});
ngModule.directive("treeTableSpacer", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: ["^treeTable", "^treeTableRow"],
    template: '<div class="spacer"></div>',
    link: function link($scope, $el, $attrs, controllers) {
      var tableCtrl = controllers[0];
      var rowCtrl = controllers[1];
      var config = tableCtrl.getConfig();
      var depth = $scope.depth;
      var index = $scope.$index;
      var upwardCount = depth - index - 1;
      var isLastSpacer = upwardCount === 0;
      var spacerRowScope = rowCtrl.getScope();
      for (var i = 0; i < upwardCount; i++) {
        spacerRowScope = spacerRowScope.parent;
      }
      $scope.$on("recompute-spacer", function () {
        recomputeSpacer();
      });
      var lastClass = null;
      var recomputeSpacer = function recomputeSpacer() {
        var hasNextSibling = !spacerRowScope.$last;
        var newClass = null;
        if (isLastSpacer) {
          if (hasNextSibling) {
            newClass = config.spacerCrossClass;
          } else {
            newClass = config.spacerCornerClass;
          }
        } else {
          if (hasNextSibling) {
            newClass = config.spacerLineClass;
          } else {
            newClass = config.spacerNoneClass;
          }
        }
        $el.removeClass(lastClass).addClass(newClass);
        lastClass = newClass;
      };
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/ui/treeTable.js", __webpack_require__(4), __webpack_require__(1), __webpack_require__(3)))

/***/ }),
/* 3028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("XlsMetadataPopinController", ["$scope", "$q", "$http", "$notifications", "$translate", function ($scope, $q, $http, $notifications, $translate) {
  function initData() {
    var promise;
    var postfix = '?xls-metadata';
    if ($scope.componentUuid) {
      postfix += "&componentUuid=" + $scope.componentUuid;
    }
    if ($scope.defautConfiguration) {
      postfix += "&defautConfiguration=true";
    }
    if ($scope.post) {
      promise = $http.post($scope.url + postfix);
    } else {
      promise = $http.get($scope.url + postfix);
    }
    promise.then(function (response) {
      $scope.metadata = response.data;
      $scope.columns = $scope.metadata.columns;
    });
  }
  initData();
  var columns = [];
  columns.push({
    id: "title",
    title: $translate("xls.metadata.Colonne"),
    attribute: "title",
    template: "<div ng-if=\"model.sharedTitle.length>0\" class=\"b i\">{{model.sharedTitle}}</div>{{model.title}}"
  });
  columns.push({
    id: "visible",
    title: "Excel (.xlsx)",
    headerTemplate: "    <div>Excel (.xlsx)</div><a class=\"toggle-all-btn tl-link\" ng-click=\"toggleAllXlsx()\" ng-switch=\"areAllSelectedXlsx()\">\n" + "                <span ng-switch-when=\"false\">{{\'xls.metadata.Tous\'|translate}}</span>\n" + "                <span ng-switch-when=\"true\">{{\'xls.metadata.Aucun\'|translate}}</span>\n" + "            </a>\n" + "        ",
    template: "<tl-checkbox ng-if='model.availableInXlsx'  ng-model='model.visibleXlsx'></tl-checkbox>" + "<i ng-if='!model.availableInXlsx' class='fa fa-ban grey' tl-tooltip=\"Ce champs n'est pas disponible dans ce format\"></i>",
    cellClass: 'align-c'
  });
  if (!$scope.hideDocx) columns.push({
    id: "visible",
    title: "Word (.docx)",
    headerTemplate: "    <div>Word (.docx)</div><a class=\"toggle-all-btn tl-link\" ng-click=\"toggleAllDocx()\" ng-switch=\"areAllSelectedDocx()\">\n" + "                <span ng-switch-when=\"false\">{{\'xls.metadata.Tous\'|translate}}</span>\n" + "                <span ng-switch-when=\"true\">{{\'xls.metadata.Aucun\'|translate}}</span>\n" + "            </a>\n" + "        ",
    template: "<tl-checkbox ng-if='model.availableInDocx' ng-model='model.visibleDocx'></tl-checkbox>" + "<i ng-if='!model.availableInDocx' class='fa fa-ban grey' tl-tooltip=\"Ce champs n'est pas disponible dans ce format\"></i>",
    cellClass: 'align-c'
  });
  $scope.tableOptions = {
    source: "columns",
    id: 'xlsMetadatas',
    allowSelection: true,
    selectionAttribute: "selectedModel",
    selectionScope: $scope,
    columns: [].concat(columns)
  };
  $scope.save = function () {
    // saving
    $http.post("/rest/xls-metadata/save", $scope.metadata).then(function (response) {
      var validation = response.data;
      // TODO : override values with result.
      if (validation.valid) {
        $notifications.info($translate("xls.metadata.ColonnesEnregistrees"));
        $scope.$close(validation.result);
      } else {
        $scope.errorMessage = validation.errors[0].message;
      }
    });
  };

  // Sélectionne ou désélectionne tous
  $scope.toggleAllXlsx = function () {
    if ($scope.areAllSelectedXlsx()) {
      unselectAllXlsx();
    } else {
      selectAllXlsx();
    }
  };
  $scope.areAllSelectedXlsx = function () {
    return $scope.columns && _.size(_.filter($scope.columns, function (model) {
      return !model.availableInXlsx || model.visibleXlsx === true;
    })) === $scope.columns.length;
  };
  var selectAllXlsx = function selectAllXlsx() {
    _.each($scope.columns, function (p) {
      if (p.availableInXlsx) {
        p.visibleXlsx = true;
      }
    });
  };
  var unselectAllXlsx = function unselectAllXlsx() {
    _.each($scope.columns, function (p) {
      if (p.availableInXlsx) {
        p.visibleXlsx = false;
      }
    });
  };

  // Sélectionne ou désélectionne tous
  $scope.toggleAllDocx = function () {
    if ($scope.areAllSelectedDocx()) {
      unselectAllDocx();
    } else {
      selectAllDocx();
    }
  };
  $scope.areAllSelectedDocx = function () {
    return $scope.columns && _.size(_.filter($scope.columns, function (model) {
      return !model.availableInDocx || model.visibleDocx === true;
    })) === $scope.columns.length;
  };
  var selectAllDocx = function selectAllDocx() {
    _.each($scope.columns, function (p) {
      if (p.availableInDocx) {
        p.visibleDocx = true;
      }
    });
  };
  var unselectAllDocx = function unselectAllDocx() {
    _.each($scope.columns, function (p) {
      if (p.availableInDocx) {
        p.visibleDocx = false;
      }
    });
  };
  $scope.resetToDefaut = function () {
    // saving
    $http.post("/rest/xls-metadata/reset-to-defaut", $scope.metadata).then(function (response) {
      $notifications.info($translate("xls.metadata.ColonnesReinitialisees"));
      initData();
    });
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/xls/metadata/xlsMetadataPopin.js", __webpack_require__(1)))

/***/ }),
/* 3029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("xlsMetadataService", ["$modal", "$http", "$dialogBox", "$q", function ($modal, $http, $dialogBox, $q) {
  var popinOptions = {
    controller: "XlsMetadataPopinController",
    template: __webpack_require__(3759)
  };
  return {
    /**
     *
     * @param url
     * @param post
     * @param componentUuid identifiant unique du composant (pour les rapports)
     * @param defautConfiguration à true uniquement pour récupérer la configuration par défaut
     * @param hideDocx pour ne pas afficher la colonne docx (si vous ne voule pas permettre l'export pour ce tableau)
     * @returns {*}
     */
    openMetadataPopin: function openMetadataPopin(url, post, componentUuid, defautConfiguration, hideDocx) {
      return $modal.open(_.extend(popinOptions, {
        vars: {
          url: url,
          post: post,
          componentUuid: componentUuid,
          // indique si il s'agit de la configuration par defaut
          defautConfiguration: defautConfiguration,
          hideDocx: hideDocx
        }
      }));
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/common/ng/xls/metadata/xlsMetadataService.js", __webpack_require__(1)))

/***/ }),
/* 3030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tinymce_tinymce__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tinymce_tinymce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tinymce_tinymce__);

__WEBPACK_IMPORTED_MODULE_0_tinymce_tinymce___default.a.addI18n('fr_FR', {
  "Cut": "Couper",
  "Heading 5": "En-t\xEAte 5",
  "Header 2": "Titre 2",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X\/C\/V keyboard shortcuts instead.": "Votre navigateur ne supporte pas la copie directe. Merci d'utiliser les touches Ctrl+X\/C\/V.",
  "Heading 4": "En-t\xEAte 4",
  "Div": "Div",
  "Heading 2": "En-t\xEAte 2",
  "Paste": "Coller",
  "Close": "Fermer",
  "Font Family": "Police",
  "Pre": "Pre",
  "Align right": "Aligner \xE0 droite",
  "New document": "Nouveau document",
  "Blockquote": "Citation",
  "Numbered list": "Num\xE9rotation",
  "Heading 1": "En-t\xEAte 1",
  "Headings": "En-t\xEAtes",
  "Increase indent": "Augmenter le retrait",
  "Formats": "Formats",
  "Headers": "Titres",
  "Select all": "Tout s\xE9lectionner",
  "Header 3": "Titre 3",
  "Blocks": "Blocs",
  "Undo": "Annuler",
  "Strikethrough": "Barr\xE9",
  "Bullet list": "Puces",
  "Header 1": "Titre 1",
  "Superscript": "Exposant",
  "Clear formatting": "Effacer la mise en forme",
  "Font Sizes": "Taille de police",
  "Subscript": "Indice",
  "Header 6": "Titre 6",
  "Redo": "R\xE9tablir",
  "Paragraph": "Paragraphe",
  "Ok": "Ok",
  "Bold": "Gras",
  "Code": "Code",
  "Italic": "Italique",
  "Align center": "Centrer",
  "Header 5": "Titre 5",
  "Heading 6": "En-t\xEAte 6",
  "Heading 3": "En-t\xEAte 3",
  "Decrease indent": "Diminuer le retrait",
  "Header 4": "Titre 4",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Le presse-papiers est maintenant en mode \"texte plein\". Les contenus seront coll\xE9s sans retenir les formatages jusqu'\xE0 ce que vous d\xE9sactiviez cette option.",
  "Underline": "Soulign\xE9",
  "Cancel": "Annuler",
  "Justify": "Justifier",
  "Inline": "En ligne",
  "Copy": "Copier",
  "Align left": "Aligner \xE0 gauche",
  "Visual aids": "Aides visuelle",
  "Lower Greek": "Grec minuscule",
  "Square": "Carr\xE9",
  "Default": "Par d\xE9faut",
  "Lower Alpha": "Alpha minuscule",
  "Circle": "Cercle",
  "Disc": "Disque",
  "Upper Alpha": "Alpha majuscule",
  "Upper Roman": "Romain majuscule",
  "Lower Roman": "Romain minuscule",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "L'Id doit commencer par une lettre suivi par des lettres, nombres, tirets, points, deux-points ou underscores",
  "Name": "Nom",
  "Anchor": "Ancre",
  "Id": "Id",
  "You have unsaved changes are you sure you want to navigate away?": "Vous avez des modifications non enregistr\xE9es, \xEAtes-vous s\xFBr de quitter la page?",
  "Restore last draft": "Restaurer le dernier brouillon",
  "Special character": "Caract\xE8res sp\xE9ciaux",
  "Source code": "Code source",
  "Language": "Langue",
  "Insert\/Edit code sample": "Ins\xE9rer / modifier une exemple de code",
  "B": "B",
  "R": "R",
  "G": "V",
  "Color": "Couleur",
  "Right to left": "Droite \xE0 gauche",
  "Left to right": "Gauche \xE0 droite",
  "Emoticons": "Emotic\xF4nes",
  "Robots": "Robots",
  "Document properties": "Propri\xE9t\xE9 du document",
  "Title": "Titre",
  "Keywords": "Mots-cl\xE9s",
  "Encoding": "Encodage",
  "Description": "Description",
  "Author": "Auteur",
  "Fullscreen": "Plein \xE9cran",
  "Horizontal line": "Ligne horizontale",
  "Horizontal space": "Espacement horizontal",
  "Insert\/edit image": "Ins\xE9rer/modifier une image",
  "General": "G\xE9n\xE9ral",
  "Advanced": "Avanc\xE9",
  "Source": "Source",
  "Border": "Bordure",
  "Constrain proportions": "Conserver les proportions",
  "Vertical space": "Espacement vertical",
  "Image description": "Description de l'image",
  "Style": "Style",
  "Dimensions": "Dimensions",
  "Insert image": "Ins\xE9rer une image",
  "Image": "Image",
  "Zoom in": "Zoomer",
  "Contrast": "Contraste",
  "Back": "Retour",
  "Gamma": "Gamma",
  "Flip horizontally": "Retournement horizontal",
  "Resize": "Redimensionner",
  "Sharpen": "Affiner",
  "Zoom out": "D\xE9zoomer",
  "Image options": "Options de l'image",
  "Apply": "Appliquer",
  "Brightness": "Luminosit\xE9",
  "Rotate clockwise": "Rotation horaire",
  "Rotate counterclockwise": "Rotation anti-horaire",
  "Edit image": "Modifier l'image",
  "Color levels": "Niveaux de couleur",
  "Crop": "Rogner",
  "Orientation": "Orientation",
  "Flip vertically": "Retournement vertical",
  "Invert": "Inverser",
  "Date\/time": "Date\/heure",
  "Insert date\/time": "Ins\xE9rer date/heure",
  "Remove link": "Enlever le lien",
  "Url": "Url",
  "Text to display": "Texte \xE0 afficher",
  "Anchors": "Ancres",
  "Insert link": "Ins\xE9rer un lien",
  "Link": "Lien",
  "New window": "Nouvelle fen\xEAtre",
  "None": "n\/a",
  "The URL you entered seems to be an external link. Do you want to add the required http:\/\/ prefix?": "L'URL que vous avez entr\xE9e semble \xEAtre un lien externe. Voulez-vous ajouter le pr\xE9fixe http:// n\xE9cessaire?",
  "Paste or type a link": "Coller ou taper un lien",
  "Target": "Cible",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "L'URL que vous avez entr\xE9e semble \xEAtre une adresse e-mail. Voulez-vous ajouter le pr\xE9fixe mailto: n\xE9cessaire?",
  "Insert\/edit link": "Ins\xE9rer/modifier un lien",
  "Insert\/edit video": "Ins\xE9rer/modifier une vid\xE9o",
  "Media": "M\xE9dia",
  "Alternative source": "Source alternative",
  "Paste your embed code below:": "Collez votre code d'int\xE9gration ci-dessous :",
  "Insert video": "Ins\xE9rer une vid\xE9o",
  "Poster": "Publier",
  "Insert\/edit media": "Ins\xE9rer/modifier un m\xE9dia",
  "Embed": "Int\xE9grer",
  "Nonbreaking space": "Espace ins\xE9cable",
  "Page break": "Saut de page",
  "Paste as text": "Coller comme texte",
  "Preview": "Pr\xE9visualiser",
  "Print": "Imprimer",
  "Save": "Enregistrer",
  "Could not find the specified string.": "Impossible de trouver la cha\xEEne sp\xE9cifi\xE9e.",
  "Replace": "Remplacer",
  "Next": "Suiv",
  "Whole words": "Mots entiers",
  "Find and replace": "Trouver et remplacer",
  "Replace with": "Remplacer par",
  "Find": "Chercher",
  "Replace all": "Tout remplacer",
  "Match case": "Respecter la casse",
  "Prev": "Pr\xE9c ",
  "Spellcheck": "V\xE9rification orthographique",
  "Finish": "Finie",
  "Ignore all": "Tout ignorer",
  "Ignore": "Ignorer",
  "Add to Dictionary": "Ajouter au dictionnaire",
  "Insert row before": "Ins\xE9rer une ligne avant",
  "Rows": "Lignes",
  "Height": "Hauteur",
  "Paste row after": "Coller la ligne apr\xE8s",
  "Alignment": "Alignement",
  "Border color": "Couleur de la bordure",
  "Column group": "Groupe de colonnes",
  "Row": "Ligne",
  "Insert column before": "Ins\xE9rer une colonne avant",
  "Split cell": "Diviser la cellule",
  "Cell padding": "Espacement interne cellule",
  "Cell spacing": "Espacement inter-cellulles",
  "Row type": "Type de ligne",
  "Insert table": "Ins\xE9rer un tableau",
  "Body": "Corps",
  "Caption": "Titre",
  "Footer": "Pied",
  "Delete row": "Effacer la ligne",
  "Paste row before": "Coller la ligne avant",
  "Scope": "Etendue",
  "Delete table": "Supprimer le tableau",
  "H Align": "Alignement H",
  "Top": "Haut",
  "Header cell": "Cellule d'en-t\xEAte",
  "Column": "Colonne",
  "Row group": "Groupe de lignes",
  "Cell": "Cellule",
  "Middle": "Milieu",
  "Cell type": "Type de cellule",
  "Copy row": "Copier la ligne",
  "Row properties": "Propri\xE9t\xE9s de la ligne",
  "Table properties": "Propri\xE9t\xE9s du tableau",
  "Bottom": "Bas",
  "V Align": "Alignement V",
  "Header": "En-t\xEAte",
  "Right": "Droite",
  "Insert column after": "Ins\xE9rer une colonne apr\xE8s",
  "Cols": "Colonnes",
  "Insert row after": "Ins\xE9rer une ligne apr\xE8s",
  "Width": "Largeur",
  "Cell properties": "Propri\xE9t\xE9s de la cellule",
  "Left": "Gauche",
  "Cut row": "Couper la ligne",
  "Delete column": "Effacer la colonne",
  "Center": "Centr\xE9",
  "Merge cells": "Fusionner les cellules",
  "Insert template": "Ajouter un th\xE8me",
  "Templates": "Th\xE8mes",
  "Background color": "Couleur d'arri\xE8re-plan",
  "Custom...": "Personnalis\xE9...",
  "Custom color": "Couleur personnalis\xE9e",
  "No color": "Aucune couleur",
  "Text color": "Couleur du texte",
  "Table of Contents": "Table des mati\xE8res",
  "Show blocks": "Afficher les blocs",
  "Show invisible characters": "Afficher les caract\xE8res invisibles",
  "Words: {0}": "Mots : {0}",
  "Insert": "Ins\xE9rer",
  "File": "Fichier",
  "Edit": "Editer",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Zone Texte Riche. Appuyer sur ALT-F9 pour le menu. Appuyer sur ALT-F10 pour la barre d'outils. Appuyer sur ALT-0 pour de l'aide.",
  "Tools": "Outils",
  "View": "Voir",
  "Table": "Tableau",
  "Format": "Format"
});

/***/ }),
/* 3031 */,
/* 3032 */,
/* 3033 */,
/* 3034 */,
/* 3035 */,
/* 3036 */,
/* 3037 */,
/* 3038 */,
/* 3039 */,
/* 3040 */,
/* 3041 */,
/* 3042 */,
/* 3043 */,
/* 3044 */,
/* 3045 */,
/* 3046 */,
/* 3047 */,
/* 3048 */,
/* 3049 */,
/* 3050 */,
/* 3051 */,
/* 3052 */,
/* 3053 */,
/* 3054 */,
/* 3055 */,
/* 3056 */,
/* 3057 */,
/* 3058 */,
/* 3059 */,
/* 3060 */,
/* 3061 */,
/* 3062 */,
/* 3063 */,
/* 3064 */,
/* 3065 */,
/* 3066 */,
/* 3067 */,
/* 3068 */,
/* 3069 */,
/* 3070 */,
/* 3071 */,
/* 3072 */,
/* 3073 */,
/* 3074 */,
/* 3075 */,
/* 3076 */,
/* 3077 */,
/* 3078 */,
/* 3079 */,
/* 3080 */,
/* 3081 */,
/* 3082 */,
/* 3083 */,
/* 3084 */,
/* 3085 */,
/* 3086 */,
/* 3087 */,
/* 3088 */,
/* 3089 */,
/* 3090 */,
/* 3091 */,
/* 3092 */,
/* 3093 */,
/* 3094 */,
/* 3095 */,
/* 3096 */,
/* 3097 */,
/* 3098 */,
/* 3099 */,
/* 3100 */,
/* 3101 */,
/* 3102 */,
/* 3103 */,
/* 3104 */,
/* 3105 */,
/* 3106 */,
/* 3107 */,
/* 3108 */,
/* 3109 */,
/* 3110 */,
/* 3111 */,
/* 3112 */,
/* 3113 */,
/* 3114 */,
/* 3115 */,
/* 3116 */,
/* 3117 */,
/* 3118 */,
/* 3119 */,
/* 3120 */,
/* 3121 */,
/* 3122 */,
/* 3123 */,
/* 3124 */,
/* 3125 */,
/* 3126 */,
/* 3127 */,
/* 3128 */,
/* 3129 */,
/* 3130 */,
/* 3131 */,
/* 3132 */,
/* 3133 */,
/* 3134 */,
/* 3135 */,
/* 3136 */,
/* 3137 */,
/* 3138 */,
/* 3139 */,
/* 3140 */,
/* 3141 */,
/* 3142 */,
/* 3143 */,
/* 3144 */,
/* 3145 */,
/* 3146 */,
/* 3147 */,
/* 3148 */,
/* 3149 */,
/* 3150 */,
/* 3151 */,
/* 3152 */,
/* 3153 */,
/* 3154 */,
/* 3155 */,
/* 3156 */,
/* 3157 */,
/* 3158 */,
/* 3159 */,
/* 3160 */,
/* 3161 */,
/* 3162 */,
/* 3163 */,
/* 3164 */,
/* 3165 */,
/* 3166 */,
/* 3167 */,
/* 3168 */,
/* 3169 */,
/* 3170 */,
/* 3171 */,
/* 3172 */,
/* 3173 */,
/* 3174 */,
/* 3175 */,
/* 3176 */,
/* 3177 */,
/* 3178 */,
/* 3179 */,
/* 3180 */,
/* 3181 */,
/* 3182 */,
/* 3183 */,
/* 3184 */,
/* 3185 */,
/* 3186 */,
/* 3187 */,
/* 3188 */,
/* 3189 */,
/* 3190 */,
/* 3191 */,
/* 3192 */,
/* 3193 */,
/* 3194 */,
/* 3195 */,
/* 3196 */,
/* 3197 */,
/* 3198 */,
/* 3199 */,
/* 3200 */,
/* 3201 */,
/* 3202 */,
/* 3203 */,
/* 3204 */,
/* 3205 */,
/* 3206 */,
/* 3207 */,
/* 3208 */,
/* 3209 */,
/* 3210 */,
/* 3211 */,
/* 3212 */,
/* 3213 */,
/* 3214 */,
/* 3215 */,
/* 3216 */,
/* 3217 */,
/* 3218 */,
/* 3219 */,
/* 3220 */,
/* 3221 */,
/* 3222 */,
/* 3223 */,
/* 3224 */,
/* 3225 */,
/* 3226 */,
/* 3227 */,
/* 3228 */,
/* 3229 */,
/* 3230 */,
/* 3231 */,
/* 3232 */,
/* 3233 */,
/* 3234 */,
/* 3235 */,
/* 3236 */,
/* 3237 */,
/* 3238 */,
/* 3239 */,
/* 3240 */,
/* 3241 */,
/* 3242 */,
/* 3243 */,
/* 3244 */,
/* 3245 */,
/* 3246 */,
/* 3247 */,
/* 3248 */,
/* 3249 */,
/* 3250 */,
/* 3251 */,
/* 3252 */,
/* 3253 */,
/* 3254 */,
/* 3255 */,
/* 3256 */,
/* 3257 */,
/* 3258 */,
/* 3259 */,
/* 3260 */,
/* 3261 */,
/* 3262 */,
/* 3263 */,
/* 3264 */,
/* 3265 */,
/* 3266 */,
/* 3267 */,
/* 3268 */,
/* 3269 */,
/* 3270 */,
/* 3271 */,
/* 3272 */,
/* 3273 */,
/* 3274 */,
/* 3275 */,
/* 3276 */,
/* 3277 */,
/* 3278 */,
/* 3279 */,
/* 3280 */,
/* 3281 */,
/* 3282 */,
/* 3283 */,
/* 3284 */,
/* 3285 */,
/* 3286 */,
/* 3287 */,
/* 3288 */,
/* 3289 */,
/* 3290 */,
/* 3291 */,
/* 3292 */,
/* 3293 */,
/* 3294 */,
/* 3295 */,
/* 3296 */,
/* 3297 */,
/* 3298 */,
/* 3299 */,
/* 3300 */,
/* 3301 */,
/* 3302 */,
/* 3303 */,
/* 3304 */,
/* 3305 */,
/* 3306 */,
/* 3307 */,
/* 3308 */,
/* 3309 */,
/* 3310 */,
/* 3311 */,
/* 3312 */,
/* 3313 */,
/* 3314 */,
/* 3315 */,
/* 3316 */,
/* 3317 */,
/* 3318 */,
/* 3319 */,
/* 3320 */,
/* 3321 */,
/* 3322 */,
/* 3323 */,
/* 3324 */,
/* 3325 */,
/* 3326 */,
/* 3327 */,
/* 3328 */,
/* 3329 */,
/* 3330 */,
/* 3331 */,
/* 3332 */,
/* 3333 */,
/* 3334 */,
/* 3335 */,
/* 3336 */,
/* 3337 */,
/* 3338 */,
/* 3339 */,
/* 3340 */,
/* 3341 */,
/* 3342 */,
/* 3343 */,
/* 3344 */,
/* 3345 */,
/* 3346 */,
/* 3347 */,
/* 3348 */,
/* 3349 */,
/* 3350 */,
/* 3351 */,
/* 3352 */,
/* 3353 */,
/* 3354 */,
/* 3355 */,
/* 3356 */,
/* 3357 */,
/* 3358 */,
/* 3359 */,
/* 3360 */,
/* 3361 */,
/* 3362 */,
/* 3363 */,
/* 3364 */,
/* 3365 */,
/* 3366 */,
/* 3367 */,
/* 3368 */,
/* 3369 */,
/* 3370 */,
/* 3371 */,
/* 3372 */,
/* 3373 */,
/* 3374 */,
/* 3375 */,
/* 3376 */,
/* 3377 */,
/* 3378 */,
/* 3379 */,
/* 3380 */,
/* 3381 */,
/* 3382 */,
/* 3383 */,
/* 3384 */,
/* 3385 */,
/* 3386 */,
/* 3387 */,
/* 3388 */,
/* 3389 */,
/* 3390 */,
/* 3391 */,
/* 3392 */,
/* 3393 */,
/* 3394 */,
/* 3395 */,
/* 3396 */,
/* 3397 */,
/* 3398 */,
/* 3399 */,
/* 3400 */,
/* 3401 */,
/* 3402 */,
/* 3403 */,
/* 3404 */,
/* 3405 */,
/* 3406 */,
/* 3407 */,
/* 3408 */,
/* 3409 */,
/* 3410 */,
/* 3411 */,
/* 3412 */,
/* 3413 */,
/* 3414 */,
/* 3415 */,
/* 3416 */,
/* 3417 */,
/* 3418 */,
/* 3419 */,
/* 3420 */,
/* 3421 */,
/* 3422 */,
/* 3423 */,
/* 3424 */,
/* 3425 */,
/* 3426 */,
/* 3427 */,
/* 3428 */,
/* 3429 */,
/* 3430 */,
/* 3431 */,
/* 3432 */,
/* 3433 */,
/* 3434 */,
/* 3435 */,
/* 3436 */,
/* 3437 */,
/* 3438 */,
/* 3439 */,
/* 3440 */,
/* 3441 */,
/* 3442 */,
/* 3443 */,
/* 3444 */,
/* 3445 */,
/* 3446 */,
/* 3447 */,
/* 3448 */,
/* 3449 */,
/* 3450 */,
/* 3451 */,
/* 3452 */,
/* 3453 */,
/* 3454 */,
/* 3455 */,
/* 3456 */,
/* 3457 */,
/* 3458 */,
/* 3459 */,
/* 3460 */,
/* 3461 */,
/* 3462 */,
/* 3463 */,
/* 3464 */,
/* 3465 */,
/* 3466 */,
/* 3467 */,
/* 3468 */,
/* 3469 */,
/* 3470 */,
/* 3471 */,
/* 3472 */,
/* 3473 */,
/* 3474 */,
/* 3475 */,
/* 3476 */,
/* 3477 */,
/* 3478 */,
/* 3479 */,
/* 3480 */,
/* 3481 */,
/* 3482 */,
/* 3483 */,
/* 3484 */,
/* 3485 */,
/* 3486 */,
/* 3487 */,
/* 3488 */,
/* 3489 */,
/* 3490 */,
/* 3491 */,
/* 3492 */,
/* 3493 */,
/* 3494 */,
/* 3495 */,
/* 3496 */,
/* 3497 */,
/* 3498 */,
/* 3499 */,
/* 3500 */,
/* 3501 */,
/* 3502 */,
/* 3503 */,
/* 3504 */,
/* 3505 */,
/* 3506 */,
/* 3507 */,
/* 3508 */,
/* 3509 */,
/* 3510 */,
/* 3511 */,
/* 3512 */,
/* 3513 */,
/* 3514 */,
/* 3515 */,
/* 3516 */,
/* 3517 */,
/* 3518 */,
/* 3519 */,
/* 3520 */,
/* 3521 */,
/* 3522 */,
/* 3523 */,
/* 3524 */,
/* 3525 */,
/* 3526 */,
/* 3527 */,
/* 3528 */,
/* 3529 */,
/* 3530 */,
/* 3531 */,
/* 3532 */,
/* 3533 */,
/* 3534 */,
/* 3535 */,
/* 3536 */,
/* 3537 */,
/* 3538 */,
/* 3539 */,
/* 3540 */,
/* 3541 */,
/* 3542 */,
/* 3543 */,
/* 3544 */,
/* 3545 */,
/* 3546 */,
/* 3547 */,
/* 3548 */,
/* 3549 */,
/* 3550 */,
/* 3551 */,
/* 3552 */,
/* 3553 */,
/* 3554 */,
/* 3555 */,
/* 3556 */,
/* 3557 */,
/* 3558 */,
/* 3559 */,
/* 3560 */,
/* 3561 */,
/* 3562 */,
/* 3563 */,
/* 3564 */,
/* 3565 */,
/* 3566 */,
/* 3567 */,
/* 3568 */,
/* 3569 */,
/* 3570 */,
/* 3571 */,
/* 3572 */,
/* 3573 */,
/* 3574 */,
/* 3575 */,
/* 3576 */,
/* 3577 */,
/* 3578 */,
/* 3579 */,
/* 3580 */,
/* 3581 */,
/* 3582 */,
/* 3583 */,
/* 3584 */,
/* 3585 */,
/* 3586 */,
/* 3587 */,
/* 3588 */,
/* 3589 */,
/* 3590 */,
/* 3591 */,
/* 3592 */,
/* 3593 */,
/* 3594 */,
/* 3595 */,
/* 3596 */,
/* 3597 */,
/* 3598 */,
/* 3599 */,
/* 3600 */,
/* 3601 */,
/* 3602 */,
/* 3603 */,
/* 3604 */,
/* 3605 */,
/* 3606 */,
/* 3607 */,
/* 3608 */,
/* 3609 */,
/* 3610 */,
/* 3611 */,
/* 3612 */,
/* 3613 */,
/* 3614 */,
/* 3615 */,
/* 3616 */,
/* 3617 */,
/* 3618 */,
/* 3619 */,
/* 3620 */,
/* 3621 */,
/* 3622 */,
/* 3623 */,
/* 3624 */,
/* 3625 */,
/* 3626 */,
/* 3627 */,
/* 3628 */,
/* 3629 */,
/* 3630 */,
/* 3631 */,
/* 3632 */,
/* 3633 */,
/* 3634 */,
/* 3635 */,
/* 3636 */,
/* 3637 */,
/* 3638 */,
/* 3639 */,
/* 3640 */,
/* 3641 */,
/* 3642 */,
/* 3643 */,
/* 3644 */,
/* 3645 */,
/* 3646 */,
/* 3647 */,
/* 3648 */,
/* 3649 */,
/* 3650 */,
/* 3651 */,
/* 3652 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box offre-edition-popin\"> <form class=popin-form tl-validated-form=aadFormConfig> <div class=title ng-switch=edit> <h3 ng-switch-when=true>Edition <span ng-if=\"aad.typeContrat=='ABONNEMENT'\">d'une assistance au démarrage</span> <span ng-if=\"aad.typeContrat=='ASSISTANCE_PONCTUELLE'\">d'une assistance ponctuelle</span> <span ng-if=\"aad.typeContrat=='FORMATION'\">d'une formation</span> </h3> <h3 ng-switch-when=false>Création <span ng-if=\"aad.typeContrat=='ABONNEMENT'\">d'une assistance au démarrage</span> <span ng-if=\"aad.typeContrat=='ASSISTANCE_PONCTUELLE'\">d'une assistance ponctuelle</span> <span ng-if=\"aad.typeContrat=='FORMATION'\">d'une formation</span></h3> </div> <div class=content> <div tl-validated-global-errors></div> <tl-field> <label class=tl-label>Consultant</label> <select ng-model=aad.consultantId ng-options=\"n.id as n.label for n in consultants\" tl-null-option=Aucun></select> </tl-field> <div class=tl-field tl-validated-field=aad.afficherAADAuClient> <tl-checkbox ng-model=aad.afficherAADAuClient><span class=b>Afficher au client que l'AAD est en cours sur sa page d'accueil.</span> <div class=i>Uniqument lorsqu'il s'agit d'une AAD pour un nouveau client : Ne pas cocher lorsqu'il s'agit d'une AAD pour l'ajout d'un module supplémentaire, d'un interfaçage : passez par les tickets pour les échanges avec le client.</div> </tl-checkbox> </div> <h4>Intégration</h4> <div class=tl-field tl-validated-field=aad.priseDeContactConsultantEffectuee> <tl-checkbox ng-model=aad.priseDeContactConsultantEffectuee><span class=b>Prise de contact consultant effectuée</span> </tl-checkbox> </div> <div class=tl-field tl-validated-field=aad.abonnementFacturable> <tl-checkbox ng-model=aad.abonnementFacturable><span class=b>Code d'accès envoyés - l'abonnement est facturable</span> <div class=i>Quand le client a accès à la plateforme (même si l'intégration n'a pas encore été faite), la facture à l'abonnement peut être envoyée. Si vous ne cochez pas, seule la clôture de l'ADD déclenchera la facturation (ou trop de retard mais jugé au feeling par la personne qui fait la facturation). </div> </tl-checkbox> </div> <div class=tl-field tl-validated-field=aad.receptionDonneesFinancieres> <tl-checkbox ng-model=aad.receptionDonneesFinancieres><span class=b>Réception des données financières</span> </tl-checkbox> </div> <div class=tl-field tl-validated-field=aad.saisieTerminee> <tl-checkbox ng-model=aad.saisieTerminee><span class=b>Saisie terminée</span> <div class=i>Il peut vous manquer des informations, mais elle ne vous empêchent pas d'effectuer la fin de l'AAD et la formation. Les ajustements éventuellement nécessaires seront à suivre via des tickets.</div> </tl-checkbox> </div> <h4><span ng-if=\"aad.typeContrat=='ABONNEMENT'\">Assistance au démarrage</span> <span ng-if=\"aad.typeContrat=='ASSISTANCE_PONCTUELLE'\">Assistance ponctuelle</span> <span ng-if=\"aad.typeContrat=='FORMATION'\">Formation</span></h4> <div class=tl-field tl-validated-field=aad.dateDemarrage> <label class=tl-label>Date de présentation prévue (ou <span class=\"b u\">réalisée une fois faite</span>) au client - Pensez a créer un Ticket de visite sur le compte du client avec la date prévisionnelle de visite</label> <tl-date-input ng-model=aad.dateDemarrage></tl-date-input> </div> <h4>Commentaires (non visibles du client)</h4> <div class=tl-field tl-validated-field=aad.commentaire> <label>(l'historique des commentaires est conservé)</label> <textarea style=width:40em;height:8em ng-model=aad.commentaire></textarea> </div> </div> <div class=footer> <tl-button type=submit class=btn-primary> {{'common.Enregistrer' | translate}} </tl-button> <tl-button type=button class=btn-warning ng-click=$dismiss()> {{'common.Annuler' | translate}} </tl-button> </div> </form> </div>";

/***/ }),
/* 3653 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box abonnementSyntheseMail-popin\"> <form class=popin-form tl-validated-form=formConfig> <div class=title> <h3>Abonner des utilisateurs à la synthèse de la dette de {{compte}}</h3> </div> <div class=content> <div class=mb-m ng-if=\"utilisateursDejaAbonnes.length>0\"> <span ng-if=info.utilisateurCourantInscrit>Vous êtes déjà abonnés.</span> <span ng-if=\"info.nbAutresUtilisateursInscrits==1\"> Un autre utilisteur est déjà abonné.</span> <span ng-if=\"info.nbAutresUtilisateursInscrits>1\"> {{info.nbAutresUtilisateursInscrits}} utilisateurs sont déjà abonnés.</span> <i class=\"fa icon-tooltip-question\" tl-tooltip> <tl-tooltip-content> <div> <p ng-repeat=\" u in utilisateursDejaAbonnes track by $index\"> {{u.label}} <span ng-if=u.dernierePublication> - dernier envoi le {{u.dernierePublication | dateShort}}</span> <span ng-if=u.prochainePublication> - prochain envoi le {{u.prochainePublication | dateShort}}</span> </p> </div> </tl-tooltip-content> </i> </div> <div class=\"mt-m mb-m\" ng-if=\"abonnables.length==0\"> <p class=b>Vous ne pouvez plus ajouter d'abonnement car tous les utilisateurs du compte sont déjà abonnés.</p> </div> <div class=formulaire-inscription ng-if=\"abonnables.length>0\"> <div> <tl-field ng-show=\"(abonnement.abonneIds.length>0 || abonneList().length>0)\" tl-validated-field=abonnement.abonneIds> <label class=tl-label style=width:90%>Qui souhaitez vous abonner ?</label> <div> <span ng-repeat=\"abonneId in abonnement.abonneIds\"> <span class=mr-m>{{renderUser(abonneId)}} <tl-icon-button icon=fa-minus-circle ng-click=removeAbonne(abonneId) title=Retirer></tl-icon-button> </span> </span> <span ng-if=\"abonneList().length>0\"> <select ng-change=addAbonne() ng-model=params.newAbonneId ng-options=\"d.id as d.label for d in abonneList()\" style=font-size:.9em tl-null-option=\"[+ Ajouter des utilisateurs à abonner]\"></select> </span> </div> </tl-field> </div> <div> <tl-field> <label>Quand sera envoyé le mail ? </label><select ng-model=abonnement.frequence ng-options=\"f.id as f.label for f in frequences\"></select> </tl-field> </div> <div> <tl-field> <label>Je souhaite recevoir une première synthèse dès demain</label> <tl-checkbox ng-model=abonnement.premiereSyntheseImmediate></tl-checkbox> </tl-field> </div> </div> </div> <div class=footer> <span class=\"on-left float-l\"> <i class=\"fa icon-tooltip-info\"></i> Pour modifier votre abonnement, rendez-vous dans la page Gestion de compte > Profil. </span> <tl-button class=btn-primary ng-disabled=\"abonnables.length==0\" type=submit> Abonner </tl-button> <tl-button class=btn-warning ng-click=$dismiss() type=button> {{'common.dialog.cancel' | translate}} </tl-button> </div> </form> </div> ";

/***/ }),
/* 3654 */
/***/ (function(module, exports) {

module.exports = "<span class=tl-bookmark> <span tl-tooltip> <i ng-if=loaded class=\"fa bookmark-icon\" ng-class=\"{'fas fa-bookmark':bookmark!=null, 'fal fa-bookmark-o':bookmark==null}\" ng-click=changeBookmark();$event.stopPropagation();></i> <tl-tooltip-content> <div> <span ng-if=\"bookmark!=null\">{{'raccourci.CliquezPourRetirer' | translate}}</span> <span ng-if=\"bookmark==null\">{{'raccourci.CliquezPourAjouter' | translate}}</span> </div> </tl-tooltip-content> </span> </span>";

/***/ }),
/* 3655 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box budget-edition-popin\"> <div class=title ng-switch=edition> <h3 ng-switch-when=true> <span if-budget>Editer un budget</span> <span if-operation>Editer une opération</span> </h3> <h3 ng-switch-default> <span if-budget>Créer un nouveau budget</span> <span if-operation>Créer une opération</span> </h3> </div> <div class=content> <form class=popin-form ng-submit=saveBudget()> <div class=error-message ng-if=errorMessage>{{errorMessage}}</div> <tl-field> <label>Nom</label> <input class=long ng-model=budget.nom tl-focus-init> </tl-field> <tl-field ng-if=collectivite> <label>Budget principal <i authz-if-role=MODULE_DETTE_GARANTIE class=\"fa icon-tooltip-question\" tl-tooltip=\"Si un budget est marqué comme &quot;Principal&quot; seuls les produits imputés à ce budget seront pris en compte dans le calcul des ratios d'endettement dans le cadre de la dette garantie.\"></i></label> <tl-checkbox ng-model=params.budgetPrincipal></tl-checkbox> </tl-field> <tl-field> <label>Plan comptable <i class=\"fa icon-tooltip-question\" tl-tooltip=\"Permet de définir le plan comptable qui sera sélectionné par défaut lors de la génération des états de dette.\"></i></label> <select class=long ng-model=budget.planComptable> <option ng-if=\"budget.type === null\" value=\"\">Utiliser le plan comptable du budget principal </option> <option ng-if=\"budget.type === 'PRINCIPAL'\" value=\"\">Sélectionnez un plan comptable</option> <option ng-repeat=\"plan in plansComptables\" value={{plan.id}}> {{plan.label}} </option> </select> </tl-field> <tl-field> <label>Couleur (pour la forcer sur les graphiques)</label> <input input-type-color ng-model=budget.color /> </tl-field> <tl-field ng-if=aComptesLies> <label>Emprunteur</label> <select class=long ng-model=budget.compteId ng-disabled=budget.id ng-options=\"c.id as c.nom for c in comptesLies\"></select> </tl-field> <tl-field> <label>Archivé <i class=\"fa icon-tooltip-info\" tl-tooltip=\"Un budget archivé ne vous sera plus proposé dans les sélections et filtres.\"></i></label> <tl-checkbox ng-model=budget.archive></tl-checkbox> </tl-field> <div ng-if=\"parent==null && budget.compteBudgetAvecModuleDette && budget.compteBudgetAvecModuleSubvention\"> <tl-field> <label>Budget disponible dans votre module Dette</label> <tl-checkbox ng-model=budget.moduleDette></tl-checkbox> </tl-field> <tl-field> <label>Budget disponible dans votre module Subvention</label> <tl-checkbox ng-model=budget.moduleSubvention></tl-checkbox> </tl-field> </div> </form> </div> <div class=footer> <tl-button class=btn-primary ng-click=saveBudget()> {{'common.dialog.confirm' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss()> {{'common.dialog.cancel' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3656 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box budget-edition-popin\"> <div class=title ng-switch=edition> <h3> <span if-budget>Déplacer le budget {{budget.nom}}</span> <span if-operation>Déplacer l'opération {{budget.nom}}</span> </h3> </div> <div class=content> <form class=popin-form ng-submit=saveBudget()> <tl-field> <label>Nouveau parent</label> <select class=long ng-model=budget.parentId ng-options=\"b.id as b.nom for b in budgetsDeplacement\" tl-null-option=\"Aucun budget parent\"></select> </tl-field> </form> </div> <div class=footer> <tl-button class=btn-primary ng-click=saveBudget() ng-disabled=\"budget.parentId===originalBudget.parentId\"> {{'common.dialog.confirm' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss()> {{'common.dialog.cancel' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3657 */
/***/ (function(module, exports) {

module.exports = "<div class=gestion-budget> <tree-table class=budget-tree table-config=treeTableConfig></tree-table> <tl-button class=\"btn-secondary no-print\" ng-click=addBudget()> <i class=\"fa fa-plus-circle\"></i> <span if-budget>Créer un nouveau budget</span> <span if-operation>Créer une nouvelle opération</span> </tl-button> </div>";

/***/ }),
/* 3658 */
/***/ (function(module, exports) {

module.exports = "<div class=\"s-champ-additionnel-page two-zones\"> <tl-loader-overlay ng-if=submitting></tl-loader-overlay> <div class=zone-1> <div ng-if=\"champs.length>0\"> <table class=\"tl-simple-table tl-table-row-select\" style=width:100%> <thead> <tr> <th authz-if-role=SAISIE style=width:25px></th> <th>Libellé</th> <th class=align-c style=width:130px>Type</th> <th class=align-c style=width:40px></th> </tr> </thead> <tbody ng-model=champs ui-sortable=sortableOptions> <tr ng-class=\"{selected: model.id === selectedChamp.id}\" ng-click=\"selectChamp(model, $event)\" ng-repeat=\"model in champs track by model.id\"> <td authz-if-role=SAISIE class=align-c> <span ng-if=model.editable tl-tooltip> <i class=\"fa fa-grip-vertical grip\" ng-class=\"{disabled: editChamp.$dirty}\" style=cursor:move></i> <tl-tooltip-content> <div> <div>Changer l'ordre par glisser-déposer.</div> <div class=\"b i\" ng-if=editChamp.$dirty>Cette action est désactivée tant que des modifications sont en cours d'édition.</div> </div> </tl-tooltip-content> </span> </td> <td> <span tl-tooltip=\"Créé par {{model.metadata.creationUser}} le {{model.metadata.creationDate|dateShort}} \">{{model.nom}}</span> <i class=\"fa fa-chevron-circle-up blue ml-m\" ng-if=\"model.editable==false\" tl-tooltip=\"Ce champ additionnel est défini sur le compte '{{model.compteNomClient}}' et ne peut être modifié que sur ce compte.\"></i> <i class=\"fa fa-warning orange ml-m\" ng-if=\"model.type=='CLASSIFICATION' &&  model.valeurs.length==0\" tl-tooltip=\"N'oubliez pas d'ajouter des valeurs à cette classification\"></i> </td> <td class=align-c> {{'lov.typeClassification.' + model.type | translate}} <div><span class=ml-m ng-if=\"model.type=='CLASSIFICATION' && model.pseudoType=='REPARTITION'\">(<i class=\"fa fa-percent\" tl-tooltip=\"Répartition en pourcentage sur plusieurs valeurs de la classification\"></i>)</span><span class=ml-m ng-if=\"model.type=='CLASSIFICATION' && model.pseudoType=='MULTIPLE'\">(<i class=\"fa fa-ellipsis-h\" tl-tooltip=\"Association possible à plusieurs valeurs de la classification\"></i>)</span><span class=ml-m ng-if=\"model.multiple && model.type!=='CLASSIFICATION'\">(<i class=\"fa fa-ellipsis-h\" tl-tooltip=\"Association possible à plusieurs valeurs\"></i>)</span></div> </td> <td class=align-c> <tl-icon-button icon=delete ng-class={disabled:editChamp.$dirty} ng-click=\"deleteChamp(model); $event.stopPropagation();\" ng-if=model.editable tl-tooltip> <tl-tooltip-content> <div> <div>Supprimer le champ.</div> <div class=\"b i\" ng-if=editChamp.$dirty>La suppression n'est pas accessible tant que vous n'avez pas terminé l'édition du champ. </div> </div> </tl-tooltip-content> </tl-icon-button> </td> </tr> </tbody> </table> </div> <div ng-if=\"champs && champs.length==0\">Aucun champ additionnel n'a encore été créé.</div> <tl-button class=\"btn-secondary no-print mt-m\" ng-click=addChamp()> <i class=\"fa fa-plus-circle\"></i> <span>Créer un nouveau champ additionnel</span> </tl-button> </div> <div class=zone-2 ng-if=editChamp> <div class=\"tl-box popin-form classification-edition\"> <h4>Caractéristiques</h4> <tl-field class=libelle> <label>Libellé</label> <input class=size-s ng-disabled=!editChamp.editable ng-model=editChamp.nom tl-focus-init> </tl-field> <tl-field class=type> <label>Type</label> <input disabled=true readonly=true value=\"{{'lov.typeClassification.' + editChamp.type | translate}}\"> </tl-field> <tl-field ng-if=\"editChamp.type=='UTILISATEUR' || editChamp.type=='GROUPE'\"> <label>Plusieurs valeurs possibles</label> <tl-checkbox ng-model=editChamp.multiple></tl-checkbox> </tl-field> <tl-field ng-show=\"editChamp.type=='CLASSIFICATION'\"> <label>Type de classification <i class=\"fa icon-tooltip-question\" tl-tooltip> <tl-tooltip-content> <p>Vous pouvez autoriser chaque élément : </p> <ul> <li>- à n'avoir qu'une seule valeur de la classification</li> <li>- à avoir plusieurs valeurs de la classification</li> <li ng-if=!moduleSubvention>- à être répartis entre plusieurs valeurs avec un total maximum de 100% </li> </ul> </tl-tooltip-content> </i></label> <select ng-model=editChamp.pseudoType ng-options=\"type.id as type.label for type in typesClassification\"></select> </tl-field> <div class=\"errors global-errors mt-xs mb-xs\" ng-if=\"errors.length>0\" style=background-color:rgba(255,45,45,.27)> <div class=\"red b\" ng-repeat=\"error in errors track by $index\"> {{error.message}} </div> </div> <tl-field> <label>Description</label> <textarea class=\"full-width height-m resize-v\" ng-disabled=!editChamp.editable ng-model=editChamp.commentaire></textarea> </tl-field> <tl-field ng-if=\"moduleSubvention && (cible=='PRODUIT' || cible=='PROJET')\"> <label>Principal <i class=\"fa icon-tooltip-question\" tl-tooltip=\"Un champ marqué comme principal sera affiché en début d'inventaire.\"></i></label> <tl-checkbox ng-disabled=!editChamp.editable ng-model=editChamp.principal></tl-checkbox> </tl-field> <div class=mt-s ng-if=\"moduleSubvention && cible=='PRODUIT'\"> <h4 class=mb-xs>Ecrans de saisie où ce champ est affiché</h4> <div class=\"group-border-left mb-m\"> <tl-field> <label>Saisie d'une nouvelle subvention</label> <tl-checkbox checklist-value=\"'CREATION'\" ng-model=editChamp.affichages></tl-checkbox> </tl-field> <tl-field> <label>Demande transmise</label> <tl-checkbox checklist-value=\"'TRANSMISSION'\" ng-model=editChamp.affichages></tl-checkbox> </tl-field> <tl-field> <label>Subvention attribuée</label> <tl-checkbox checklist-value=\"'ATTRIBUTION'\" ng-model=editChamp.affichages></tl-checkbox> </tl-field> </div> <tl-field> <label>Champ obligatoire à la saisie <i class=\"fa icon-tooltip-question\" tl-tooltip=\"Concerne les écrans indiqués ci-dessus où le champ est affiché.\"></i></label> <tl-checkbox ng-model=editChamp.obligatoire></tl-checkbox> </tl-field> </div> <div class=align-r> <span ng-if=editChamp.editable> <tl-circular-loader class=xs ng-if=submitting></tl-circular-loader> <tl-button class=btn-primary ng-click=save() ng-disabled=\"!editChamp.$dirty || submitting\" type=button> {{'common.Enregistrer' | translate}} </tl-button> <tl-button class=btn-warning ng-click=annulerModifications() ng-disabled=\"!editChamp.$dirty ||submitting\" ng-if=editChamp.editable type=button> {{'common.Annuler' | translate}} </tl-button> </span> </div> </div> <div class=mt-xs ng-if=\"editChamp.type==='CLASSIFICATION'\"> <div> <h4>Valeurs</h4> </div> <div class=tl-box> <tl-button authz-if-role=SAISIE class=\"btn-sm btn-secondary no-print\" ng-click=editClassificationValue(editChamp) ng-if=editChamp.editable style=margin-bottom:3px;position:absolute;right:30px> <i class=\"fa fa-plus-circle\"></i> <span>Editer les valeurs</span> </tl-button> <div style=overflow-y:auto;max-height:300px> <div class=mb-xs ng-repeat=\"valeur in editChamp.valeurs\"> <div ng-if=valeur.color ng-style=\"{'background-color': valeur.color}\" style=\"display:inline-block;border:#0d0d35 solid 1px;min-height:1.3em;min-width:1.5em;width:1.5em\"></div> <div ng-if=!valeur.color style=display:inline-block;min-height:1.3em;min-width:1.5em;width:1.5em></div> <span style=vertical-align:top>{{valeur.nom}}</span> </div> </div> <div class=i ng-if=\"editChamp.valeurs.length==0\">Aucune valeur.</div> </div> </div> </div> </div> ";

/***/ }),
/* 3659 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box se-details-echeances checkEcheanceEdition\"> <div class=title> <h3>Validation d'échéance</h3> </div> <div class=content> <div ng-if=echeance.lignesLiees class=warning> La modification du statut s'applique à l'ensemble des lignes (capital, intérêts et commissions) de ce produit en date d'échéance du {{editedEcheance.dateFin | dateShort}}. </div> <div ng-if=\"! echeance.lignesLiees\" class=detail> <div>Echéance du {{editedEcheance.dateFin | dateShort}}</div> <div> <span ng-if=editedEcheance.prime>Prime : {{editedEcheance.prime | montant:2}}</span> <span ng-if=editedEcheance.capital>Capital : {{editedEcheance.capital | montant:2}}</span> <span ng-if=editedEcheance.interet>Interets : {{editedEcheance.interet | montant:2}}</span> <span ng-if=editedEcheance.commission>Commissions : {{editedEcheance.commission| montant:2}}</span> </div> </div> <div class=popin-form> <tl-field tl-field-error=label> <label> Etat </label> <select ng-model=editedEcheance.validation ng-options=\"v.id as v.label for v in validationStates\"> <option value=\"\">Non vérifié</option> </select> </tl-field> <tl-field> <label> Mandat </label> <input id=mandatInput ng-model=editedEcheance.numeroMandat /> </tl-field> </div> </div> <div class=footer> <div class=footer> <span ng-if=echeance.validation class=float-l> {{formatePointage(echeance)}} </span> <tl-button type=button ng-disabled=saving ng-click=validateAndSave() class=btn-primary> {{'common.Enregistrer' | translate}} </tl-button> <tl-button class=btn-warning ng-disabled=saving ng-click=$dismiss() ng-disabled=submitting type=button> {{'common.Annuler' | translate}} </tl-button> </div> </div> </div> ";

/***/ }),
/* 3660 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box classification-edition\"> <form class=popin-form tl-validated-form=classificationFormConfig> <div class=title ng-switch=edit> <h3 ng-switch-when=true>Edition un champ additionnel</h3> <h3 ng-switch-when=false>Création d'un champ additionnel</h3> </div> <div class=content> <tl-field tl-validated-field=classification.nom> <label>Nom</label> <input ng-model=classification.nom tl-focus-init type=text> </tl-field> <tl-field tl-validated-field=classification.type> <label>Type</label> <select ng-disabled=edit ng-model=classification.type ng-readonly=edit ng-options=\"type.id as type.label for type in typesChamps\"></select> <i class=\"fa icon-tooltip-info\" ng-if=\"classification.type=='CLASSIFICATION'\" tl-tooltip> <tl-tooltip-content> <div> <p>Le type <span class=b>classification</span> vous permettent d'ajouter des champs et de leur affecter une ou plusieurs valeurs selon les valeurs d'une liste que vous aurez prédéfinie.</p> <p>Pour chaque classification que vous créez vous pouvez décider si une seule ou plusieurs valeurs peut être saisie sur chaque element. En cas de valeurs multiples, vous pouvez également définir s'il s'agit d'une répartition et dans ce cas chaque valeur pourra être associée à un pourcentage.</p> <p>Vous pouvez autoriser chaque élément : </p> <ul> <li>- à n'avoir qu'une seule valeur de la classification</li> <li>- à avoir plusieurs valeurs de la classification</li> <li ng-if=!moduleSubvention>- à être répartis entre plusieurs valeurs avec un total maximum de 100% </li> </ul> </div> </tl-tooltip-content> </i> </tl-field> <tl-field ng-if=\"classification.type=='CLASSIFICATION'\" tl-validated-field=classification.typeClassification> <label>Type de classification </label> <select ng-model=classification.pseudoType ng-options=\"type.id as type.label for type in typesClassification\"></select> </tl-field> <tl-field ng-if=\"classification.type=='UTILISATEUR' || classification.type=='GROUPE'\" tl-validated-field=classification.multiple> <label>Plusieurs valeurs possibles</label> <tl-checkbox ng-model=classification.multiple></tl-checkbox> </tl-field> </div> <div class=footer> <tl-circular-loader class=xs ng-if=submitting></tl-circular-loader> <tl-button class=btn-primary type=submit> {{'common.Enregistrer' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss() type=button> {{'common.Annuler' | translate}} </tl-button> </div> </form> </div>";

/***/ }),
/* 3661 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box classification-edition\"> <form class=popin-form tl-validated-form=classificationFormConfig> <div class=title ng-switch=edit> <h3 ng-switch-when=true>Edition d'une classification</h3> <h3 ng-switch-when=false>Création d'une classification</h3> </div> <div class=content> <tl-field tl-validated-field=classification.nom> <label>Nom</label> <input type=text ng-model=classification.nom tl-focus-init style=width:59%> </tl-field> <tl-field ng-if=\"typesClassification.length > 1\" tl-validated-field=classification.type> <label>Type <i class=\"fa icon-tooltip-question\" tl-tooltip> <tl-tooltip-content> <p>Vous pouvez autoriser chaque élément : </p> <ul> <li>- à n'avoir qu'une seule valeur de la classification</li> <li>- à avoir plusieurs valeurs de la classification</li> <li ng-if=!moduleSubvention>- à être répartis entre plusieurs valeurs avec un total maximum de 100% </li> </ul> </tl-tooltip-content> </i></label> <select ng-model=classification.pseudoType ng-options=\"type.id as type.label for type in typesClassification\"></select> </tl-field> <div class=mt-s ng-if=moduleSubvention> <h4 class=mb-xs>Ecrans de saisie où ce champ est affiché</h4> <div class=group-border-left> <tl-field> <label>Saisie d'une nouvelle subvention</label> <tl-checkbox checklist-value=\"'CREATION'\" ng-model=classification.affichages></tl-checkbox> </tl-field> <tl-field> <label>Demande transmise</label> <tl-checkbox checklist-value=\"'TRANSMISSION'\" ng-model=classification.affichages></tl-checkbox> </tl-field> <tl-field> <label>Subvention attribuée</label> <tl-checkbox checklist-value=\"'ATTRIBUTION'\" ng-model=classification.affichages></tl-checkbox> </tl-field> </div> </div> </div> <div class=footer> <tl-circular-loader ng-if=submitting class=xs></tl-circular-loader> <tl-button type=submit class=btn-primary ng-disabled=nomExistant()> {{'common.Enregistrer' | translate}} </tl-button> <tl-button type=button class=btn-warning ng-click=$dismiss()> {{'common.Annuler' | translate}} </tl-button> </div> </form> </div>";

/***/ }),
/* 3662 */
/***/ (function(module, exports) {

module.exports = "<div class=two-zones> <div class=zone-1> <tl-table ng-if=\"classifications.length>0\" table-config=classificationsTableConfig></tl-table> <div ng-if=\"classifications && classifications.length==0\">Aucune classification n'a encore été créée.</div> <tl-button class=\"btn-secondary no-print mt-m\" ng-click=addClassification()> <i class=\"fa fa-plus-circle\"></i> <span>Créer une nouvelle classification</span> </tl-button> </div> <div class=zone-2 ng-if=\"selectedClassification && !selectedClassification.champAdditionnel\"> <h4>Valeurs</h4> <div class=tl-box> <div style=overflow-y:scroll;max-height:500px> <div ng-repeat=\"valeur in selectedClassification.valeurs\" class=mb-xs> <div ng-if=valeur.color ng-style=\"{'background-color': valeur.color}\" style=\"display:inline-block;border:#0d0d35 solid 1px;min-height:1.3em;min-width:1.5em;width:1.5em\"></div> <div ng-if=!valeur.color style=display:inline-block;min-height:1.3em;min-width:1.5em;width:1.5em></div> {{valeur.nom}} </div> </div> <div class=i ng-if=\"selectedClassification.valeurs.length==0\">Aucune valeur.</div> <tl-button class=\"btn-secondary no-print mt-s\" authz-if-role=SAISIE ng-if=selectedClassification.editable ng-click=editClassificationValue(selectedClassification)> <i class=\"fa fa-plus-circle\"></i> <span>Editer les valeurs</span> </tl-button> </div> </div> </div> ";

/***/ }),
/* 3663 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box classification-valeurs-edition\"> <form class=popin-form tl-validated-form=classificationValeursFormConfig> <div class=title ng-switch=edit> <h3>Edition des valeurs de la classification</h3> <div class=\"float-r b blue\" ng-if=\"classificationValeurs.length>1\">({{classificationValeurs.length}} valeurs) </div> </div> <div class=content> <tl-field tl-validated-field=classification.valeur{{$index}} class=valeur ng-repeat=\"value in classificationValeurs track by $index\"> <input ng-class=\"{'new-classification-valeur' : value.new }\" ng-model=value.nom> <input input-type-color ng-model=value.color /> <i class=\"fa fa-minus-circle\" ng-if=!value.deleteErreur ng-click=remove(value)></i> <div ng-if=value.deleteErreur class=red>{{value.deleteErreur}}</div> </tl-field> <tl-button class=\"btn-secondary no-print mt-s\" type=button ng-click=addClassificationValue()> <i class=\"fa fa-plus-circle\"></i> <span>Ajouter une valeur</span> </tl-button> <tl-button class=\"btn-success ml-xs no-print mt-s float-r\" ng-click=createFromClipboard() tl-tooltip=\"Placez plusieurs lignes dans le presse-papier, par exemple en copiant une plage de lignes d'un ichier excel. Chaque ligne donnera une nouvelle valeur.\" type=button> <i class=\"fa fa-clipboard-list\"></i> <span>Ajouter à partir du presse-papier</span> </tl-button> </div> <div class=footer> <tl-circular-loader ng-if=submitting class=xs></tl-circular-loader> <tl-button type=submit class=btn-primary ng-disabled=hasNomEnDoublon()> {{'common.Enregistrer' | translate}} </tl-button> <tl-button type=button class=btn-warning ng-click=$dismiss()> {{'common.Annuler' | translate}} </tl-button> </div> </form> </div>";

/***/ }),
/* 3664 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box http-error-popin\"> <div class=title> <h3>Une erreur est survenue</h3> </div> <div class=content> <p class=summary> Une erreur est survenue. <br/> Si le problème se reproduit, merci de contacter votre consultant en indiquant les informations disponibles ci-dessous </p> <div> <a class=details-link ng-click=toggleDetails() ng-switch=showDetails> <span ng-switch-when=false>Afficher les détails</span> <span ng-switch-when=true>Cacher les détails</span> </a> <div class=details-content ng-show=showDetails> <div class=error-info> <span class=label>Identifiant erreur</span> <span class=value>{{::error.errorId || 'indisponible'}}</span> </div> <div authz-if-role=EXPERIMENTATEUR> <div class=error-info> <span class=label>Message</span> <span class=value>{{::error.message || 'indisponible'}}</span> </div> </div> <div class=error-info> <span class=label>Code http</span> <span class=value>{{::error.httpCode || 'indisponible'}}</span> </div> <div class=error-info> <span class=label>Code status</span> <span class=value>{{::error.statusCode || 'indisponible'}}</span> </div> <div authz-if-role=EXPERIMENTATEUR> <div class=error-info> <span class=label>Cause</span> <span class=value>{{::error.cause || 'indisponible'}}</span> </div> <div class=error-info> <span class=label>Stacktrace</span> <div class=stack-trace> <p ng-if=::error.cause>{{::error.cause}}</p> <p ng-repeat=\"line in ::error.stackTrace track by $index\"> {{::line}} </p> </div> </div> </div> </div> </div> </div> <div class=footer> <tl-button class=btn-warning ng-click=$close()> Fermer </tl-button> </div> </div> ";

/***/ }),
/* 3665 */
/***/ (function(module, exports) {

module.exports = "<div class=tl-print-toolbar> <div class=title> <i class=\"fa fa-print\"></i> <span>Mode impression</span> </div> <div class=content> <div class=action ng-click=printPage()> <i class=\"fa fa-print\"></i> <span>Imprimer</span> </div> <div class=action ng-click=exitPrintMode()> <i class=\"fa fa-reply\"></i> <span>Sortir du mode impression</span> </div> </div> </div>";

/***/ }),
/* 3666 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box couche-additionnelle-edition\"> <form class=popin-form tl-validated-form=coucheAdditionnelleFormConfig> <div class=title ng-switch=edit> <h3 ng-switch-when=true>Edition d'une couche additionnelle</h3> <h3 ng-switch-when=false>Création d'une couche additionnelle</h3> </div> <div class=content> <tl-field tl-validated-field=coucheAdditionnelle.nom> <label>Nom</label> <input type=text ng-model=coucheAdditionnelle.nom tl-focus-init> </tl-field> </div> <div class=footer> <tl-circular-loader ng-if=submitting class=xs></tl-circular-loader> <tl-button type=submit class=btn-primary> {{'common.Enregistrer' | translate}} </tl-button> <tl-button type=button class=btn-warning ng-click=$dismiss()> {{'common.Annuler' | translate}} </tl-button> </div> </form> </div>";

/***/ }),
/* 3667 */
/***/ (function(module, exports) {

module.exports = "<div class=two-zones> <div class=zone-1> <tl-table ng-if=\"coucheAdditionnelles.length>0\" table-config=coucheAdditionnellesTableConfig></tl-table> <div ng-if=\"coucheAdditionnelles && coucheAdditionnelles.length==0\">Aucune couche additionnelle n'a encore été créée.</div> <tl-button class=\"btn-secondary no-print mt-m\" ng-click=addCoucheAdditionnelle()> <i class=\"fa fa-plus-circle\"></i> <span>Créer une nouvelle couche additionnelle</span> </tl-button> </div> </div> ";

/***/ }),
/* 3668 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box sp-popin sp-frais-popin\"> <div class=title> <h3 ng-switch=document.externe> <span ng-switch-when=true> {{'documents.AjoutDUnDocumentExterne' | translate}} </span> <span ng-switch-default> {{'documents.AjoutDUnDocument' | translate}} </span> à l'échéance du {{document.tags.DATE_ECHEANCE | dateShort}} </h3> </div> <div class=content> <div class=popin-form> <tl-field tl-field-error=label> <label> {{'documents.NomDuDocument' | translate}} </label> <input ng-model=document.label maxlength=100 tl-focus-init/> </tl-field> <tl-field tl-field-error=type> <label> {{'documents.TypeDeDocument' | translate}} </label> <select ng-model=document.type ng-options=\"d.id as d.label for d in allowedTypes | orderBy\"> <option disabled=disabled value=\"\">-- Sélectionnez un type --</option> </select> </tl-field> <tl-field ng-if=document.externe tl-field-error=url> <label> {{'documents.UrlDuDocumentExterne' | translate}} </label> <input ng-model=document.url maxlength=1000 /> </tl-field> <tl-field if-application=DETTE||PRET> <label> {{'documents.JustificatifComptable' | translate}} </label> <tl-checkbox ng-model=document.tags.JUSTIFICATIF_TRESORERIE /> </tl-field> </div> </div> <div class=footer> <tl-button class=btn-primary ng-click=saveAndClose()> {{ initial ? 'common.add' : 'common.Enregistrer' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss()> {{'common.dialog.cancel' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3669 */
/***/ (function(module, exports) {

module.exports = "<div class=confirm-box> <div class=title> <h3> <span>{{::document.name}}</span> </h3> <div class=float-r> <i class=\"fa fa-window-maximize simple-action-icon\" ng-click=maximizeWindow() ng-if=!maximized tl-tooltip=Agrandir></i> <i class=\"fa fa-window-restore simple-action-icon\" ng-click=restoreWindow() ng-if=maximized tl-tooltip=Diminuer></i> </div> </div> <div class=content> <tl-document-preview document=document document-view-url={{documentViewUrl}} height=600 style=height:600px> </tl-document-preview> </div> <div class=footer> <tl-button class=btn-primary ng-click=$close()> {{'common.dialog.close' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3670 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box se-details-echeances\"> <div class=title> <h3>Documents pour l'échéance du {{echeance.dateFin | dateShort}}</h3> </div> <div class=\"content popin-form\"> <div ng-if=echeanceDocuments> <div ng-if=\"echeanceDocuments.length === 0\" style=font-size:1.5em;margin:50px;text-align:center> Pas de document<br> Vous pouvez en ajouter par glisser-déposer </div> <div ng-if=\"echeanceDocuments.length !== 0\"> <tl-table table-config=echeanceDocumentsTable></tl-table> </div> </div> <div class=mt-s> <div class=i ng-if=\"echeanceDocuments && echeanceDocuments.length !== 0 && !selectedDocument\" style=font-size:1.5em;margin:50px;text-align:center> Sélectionnez un document pour en voir l'aperçu ici </div> <tl-document-preview ng-if=selectedDocument document=selectedDocument height=700> </tl-document-preview> </div> </div> <div class=footer> <span authz-if-role=SAISIE> <fileupload-btn btn-label-key=documents.AjouterUnDocument class=\"float-l on-left\" options=uploadOptions before-upload=beforeDocumentUpload upload-success=onDocumentUpload tl-tooltip=\"{{'documents.VousPouvezAussiAjouterDesFichiersParGlisserDeposer' | translate}}\"> </fileupload-btn> <tl-button authz-if-role=DOCUMENTS_EXTERNES class=\"float-l btn-secondary\" ng-click=createDocumentExterne() tl-tooltip=\"{{'documents.PourReferencerParSonUrlUnDocumentGereDansUneAutreGED'|translate}}\"> <i class=\"fa fa-plus-circle\"></i> <span>{{'documents.AjouterUnDocumentExterne' | translate}}</span> </tl-button> </span> <tl-button type=submit class=btn-primary ng-click=$close()> {{'common.dialog.close' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3671 */
/***/ (function(module, exports) {

module.exports = "<div class=tl-directory-box> <div class=name> <h3 class=name>{{directory.label}} <span class=sim-pill ng-if=directory.simulation>sim</span> </h3> </div> <div ng-if=\"directory.tags.DIRECTORY_TYPE!='MODELES_DE_DOCUMENTS'\" class=type> {{renduNbDocs(directory)}} </div> <div class=box-icon> <i class=\"file-icon fal fa-folder\"></i> <span class=doc-node-directory-type-MODELES_DE_DOCUMENTS ng-if=\"directory.tags.DIRECTORY_TYPE=='MODELES_DE_DOCUMENTS'\" tl-tooltip=\"Modèles de documents TAELYS\">TAELYS</span> <span class=doc-node-directory-type-PROJET ng-if=\"directory.tags.DIRECTORY_TYPE=='PROJET'\" tl-tooltip=Projet>P</span> <span class=doc-node-directory-type-SUBVENTION ng-if=\"directory.tags.DIRECTORY_TYPE=='SUBVENTION'\" tl-tooltip=Subvention>S</span> </div> <div class=box-footer> <span class=doc-size ng-class=\"{'doc-size-medium' : directory.sizeRec/directory.nbDocsRec > 500000 && directory.sizeRec/directory.nbDocsRec <= 1000000,\n                     'doc-size-big' : directory.sizeRec/directory.nbDocsRec > 1000000}\"> {{directory.sizeRec > 0 ? (directory.sizeRec | bytes) : \"\"}} </span> <div class=actions ng-transclude tl-stop-event-propagation></div> </div> </div> ";

/***/ }),
/* 3672 */
/***/ (function(module, exports) {

module.exports = "<div class=tl-document-box> <div class=name title={{document.label}}> <h3 class=name>{{document.label}}</h3> </div> <div class=type> {{renderType(document)}} </div> <div class=box-icon> <i class=\"file-icon {{$ctrl.getIcon()}}\"></i> <i ng-if=document.tags.JUSTIFICATIF_TRESORERIE class=\"tresorerie fa sim-pill fa-light fa-receipt\" title=\"{{'documents.JustificatifComptable' | translate}}\"> </i> </div> <div class=box-footer> <span class=doc-size ng-class=\"{'doc-size-medium' : document.size > 300000 && document.size <= 1000000,\n                         'doc-size-big' : document.size > 1000000}\"> {{document.fileId ? (document.size | bytes) : (\"documents.DocumentExterne\" |translate) }} </span> <div class=actions ng-transclude></div> </div> </div> ";

/***/ }),
/* 3673 */
/***/ (function(module, exports) {

module.exports = "<div class=tl-document-preview> <div ng-switch=documentType> <div ng-switch-when=pdf> <pdf-viewer height=componentHeight highlight-text=currentHighlightText page=currentPage url=documentUrl></pdf-viewer> </div> <div class=doc-img-wrapper ng-switch-when=image> <img class=doc-img ng-src={{documentUrl}} /> </div> <div class=doc-msg-wrapper ng-style=\"componentHeight ? {'height': componentHeight + 'px'} : {}\" ng-switch-when=msg> <div class=msg-loading ng-if=loadingMsg> <tl-circular-loader class=small></tl-circular-loader> <span class=ml-xs>Chargement du message...</span> </div> <div class=msg-error ng-if=msgError> <i class=\"fal fa-exclamation-triangle mr-xs\"></i> <span>{{msgError}}</span> </div> <div class=msg-viewer-container ng-if=\"!loadingMsg && !msgError && msgData\"> <div class=msg-header> <div class=msg-subject ng-if=msgData.subject> <i class=\"fal fa-envelope-open mr-xs\"></i> <span class=subject-text>{{msgData.subject}}</span> </div> <div class=msg-meta> <div class=msg-meta-row ng-if=msgData.from> <span class=msg-meta-label>De :</span> <span class=msg-meta-value>{{msgData.from}}</span> </div> <div class=msg-meta-row ng-if=msgData.to> <span class=msg-meta-label>À :</span> <span class=msg-meta-value>{{msgData.to}}</span> </div> <div class=msg-meta-row ng-if=msgData.cc> <span class=msg-meta-label>Cc :</span> <span class=msg-meta-value>{{msgData.cc}}</span> </div> <div class=msg-meta-row ng-if=msgData.date> <span class=msg-meta-label>Date :</span> <span class=msg-meta-value>{{msgData.date | dateMedium}}</span> </div> </div> <div class=msg-attachments-bar ng-if=\"msgData.attachments && msgData.attachments.length > 0\"> <div class=msg-attachments-title> <i class=\"fal fa-paperclip mr-xs\"></i> <span>Pièces jointes ({{msgData.attachments.length}}) :</span> </div> <div class=msg-attachments-list> <span class=msg-attachment-chip ng-click=downloadAttachment(att) ng-repeat=\"att in msgData.attachments\" title=\"Télécharger {{att.filename}}\"> <i class=mr-xs ng-class=getFileIcon(att.filename)></i> <span class=msg-att-name>{{att.filename || 'pièce jointe'}}</span> <span class=msg-att-size ng-if=att.size> ({{att.size | bytes}})</span> <i class=\"fal fa-download ml-xs\"></i> </span> </div> </div> </div> <div class=msg-body> <div class=msg-body-html ng-if=msgData.htmlBody tl-bind-richtext=msgData.htmlBody></div> <pre class=msg-body-text ng-if=\"!msgData.htmlBody && msgData.textBody\">{{msgData.textBody}}</pre> <div class=msg-body-empty ng-if=\"!msgData.htmlBody && !msgData.textBody\"> <em>(Message vide)</em> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 3674 */
/***/ (function(module, exports) {

module.exports = "<div class=tl-modeles-documents> <div class=\"b align-c mt-l\" ng-if=\"documents && documents.length==0\">Aucun modèle de disponible.</div> <tl-loader-overlay ng-if=loading></tl-loader-overlay> <tl-table ng-if=\"documents.length>0\" table-config=documentsTableConfig></tl-table> </div> ";

/***/ }),
/* 3675 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box compte-edition-popin\"> <form class=popin-form tl-validated-form=compteFormConfig> <div class=title ng-switch=edit> <h3 ng-switch-when=true>{{'comptes.EditerUnCompte' | translate}}</h3> <h3 ng-switch-when=false>{{'comptes.CreerUnCompte' | translate}} <span ng-if=compte.compteParentId>Filiale</span> </h3> </div> <div class=content ng-if=!compte style=min-height:200px> <tl-circular-loader></tl-circular-loader> </div> <div class=content ng-if=compte> <tl-field tl-validated-field=compte.typeCompte> <label class=tl-label>Type de compte</label> <select ng-disabled=\"edit && !admin\" ng-model=compte.typeCompte tl-lov-options=typesCompte></select> <div class=\"i ml-m\" ng-if=\"edit && !admin\">Seul un admin peut modifier le type de compte</div> </tl-field> <tl-field tl-validated-field=compte.clientId> <label class=tl-label>Client</label> <tl-select empty-option-label=Aucun ng-model=compte.clientId options=clients select-config=clientSelectConfig style=max-width:95%></tl-select> </tl-field> <tl-field tl-validated-field=compte.affectation> <label class=tl-label>{{'comptes.Affectation' | translate}}</label> <select ng-model=compte.affectation tl-lov-options=affectations></select> </tl-field> <tl-field tl-validated-field=compte.commentaireTaelys> <label class=tl-label> Commentaire (non visible du client). indiquez notamment si des modules sont ouverts alors que non contractuellement souscrit (démo, cas particuliers, ...) </label> <textarea class=text-area-box ng-model=compte.commentaireTaelys rows=3></textarea> </tl-field> <tl-field tl-validated-field=compte.applicationParDefaut> <label class=tl-label>{{'comptes.ApplicationParDefaut' | translate}}</label> <select ng-model=compte.applicationParDefaut tl-lov-options=applicationsClients></select> </tl-field> <tl-field tl-validated-field=compte.nomInterne> <label class=tl-label>{{'comptes.NomInterne' | translate}}</label> <input ng-model=compte.nomInterne type=text> </tl-field> <tl-field tl-validated-field=compte.nomClient> <label class=tl-label>{{'comptes.NomClient' | translate}}</label> <input ng-model=compte.nomClient type=text> </tl-field> <tl-field tl-validated-field=compte.nomClientCourt> <label class=tl-label>{{'comptes.NomClientCourt' | translate}}</label> <input ng-model=compte.nomClientCourt type=text> </tl-field> <tl-field class=search-area tl-validated-field=compte.compteParentId> <label class=tl-label>{{'comptes.CompteParent' | translate}}</label> <tl-select empty-option-label=Aucun ng-model=compte.compteParentId options=comptes select-config=compteParentSelectConfig style=max-width:95%></tl-select> </tl-field> <tl-field ng-show=\"(((compte.typeCompte == 'ENTREPRISE' || compte.typeCompte == 'SEM') && compte.compteParentId!=null) || compte.participation!=null)\" tl-validated-field=compte.participation> <label class=tl-label>Pourcentage de participation du parent</label> <input input-type-number ng-model=compte.participation> % </tl-field> <tl-field> <label class=tl-label>Pays</label> <select ng-model=compte.pays tl-lov-options=pays tl-null-option=\"par défaut (France)\"></select> </tl-field> <tl-field tl-validated-field=compte.zone> <label class=tl-label>{{'comptes.Zone' | translate}} (numéro du département)</label> <input ng-model=compte.zone type=text> </tl-field> <tl-field tl-validated-field=compte.codeEntite> <label class=tl-label>{{'comptes.codeEntite' | translate}}</label> <input ng-model=compte.codeEntite type=text> </tl-field> <tl-field tl-validated-field=compte.consultantId> <label class=tl-label>{{'comptes.Consultant' | translate}}</label> <select ng-model=compte.consultantId ng-options=\"c.id as c.label for c in consultants\"></select> </tl-field> <tl-field tl-validated-field=compte.consultant2Id> <label class=tl-label>Second consultant (optionnel)</label> <select ng-model=compte.consultant2Id ng-options=\"c.id as c.label for c in consultants\" tl-null-option=Aucun></select> </tl-field> <tl-field tl-validated-field=compte.devise> <label class=tl-label>{{'comptes.Devise' | translate}}</label> <select ng-model=compte.devise ng-options=\"c.name as c.name for c in currencies\"></select> </tl-field> <tl-field> <label class=tl-label>{{'comptes.Langue' | translate}}</label> <select ng-model=compte.locale tl-lov-options=locales></select> </tl-field> <tl-field> <label class=tl-label ng-if=\"compte.datasId==null\">Nom de la donnée associée (si le nom client ne permet pas de le trouver)</label> <input ng-if=\"compte.datasId==null\" ng-model=compte.nomDonneeAssociee type=text> <label class=tl-label tl-tooltip=\"Permet de lier le compte à des données DGFiP pour l'observatoire, l'obs. fi, les indicateurs officiels, ...\">{{'comptes.DonneesAssociees' | translate}} - Entité officielle à associer (basé par défaut sur 'Nom client', N'oubliez pas de Renseigner 'Zone').</label> <select ng-if=\"compte.datasId==null\" ng-model=compte.datasId ng-options=\"d.id as d.label for d in datas\"></select> <span class=b ng-if=\"compte.datasId!=null\" tl-tooltip=\"Permet de lier le compte à des données DGFiP pour l'observatoire, l'obs. fi, les indicateurs officiels, ...\">{{nomData}}</span> <tl-icon-button icon=delete ng-click=\"compte.datasId=null\" ng-if=\"compte.datasId!=null\" tl-tooltip=Modifier></tl-icon-button> </tl-field> <tl-field> <label class=tl-label>Affiche 'Opération' (au lieu de budget)</label> <tl-checkbox ng-model=compte.budgetAsOperation></tl-checkbox> </tl-field> <tl-field> <label class=tl-label>{{'comptes.DateActivation' | translate}}</label> <tl-date-input ng-model=compte.dateActivation></tl-date-input> </tl-field> <tl-field> <label class=tl-label>{{'comptes.DateDesactivation' | translate}} <i class=\"fa icon-tooltip-info\" tl-tooltip=\"A partir de cette date incluse, le compte ne sera plus accessible\"></i></label> <tl-date-input ng-model=compte.dateDesactivation></tl-date-input> </tl-field> <tl-field> <label class=tl-label>{{'common.SmallIcon' | translate}} (format png/jpg/gif. Ne pas mettre de svg ! Idealement : 150px*60px ou un carré de 150px*150px) <span ng-if=\"compte.compteParentId!=null\"> - si aucun, c'est celui du compte parent (récursivement) qui sera utilisé</span></label> <fileupload-btn btn-label-key=common.upload options=uploadIconOptions type=ICONE upload-success=onSmallIconUpload></fileupload-btn> <div class=img-preview ng-if=compte.smallIconFileId> <file-image-with-size url=\"{{compte.smallIconFileId ? '/rest/intra/comptes/icon/' + compte.smallIconFileId : ''}}\"></file-image-with-size> </div> <tl-icon-button icon=delete ng-click=\"compte.smallIconFileId=null\" ng-if=compte.smallIconFileId></tl-icon-button> </tl-field> <tl-field> <label class=tl-label>{{'common.BigIcon' | translate}} (format png/jpg/gif. Ne pas mettre de svg ! Utilisé en contrepartie fiche produit et en entête de tous les documents word/pdf. A défaut, et si aucun n'est défini sur un compte parent, utilise le petit logo)</label> <fileupload-btn btn-label-key=common.upload options=uploadIconOptions type=ICONE upload-success=onBigIconUpload></fileupload-btn> <div class=img-preview ng-if=compte.bigIconFileId> <file-image-with-size url=\"{{compte.bigIconFileId ? '/rest/intra/comptes/icon/' + compte.bigIconFileId : ''}}\"></file-image-with-size> </div> <tl-icon-button icon=delete ng-click=\"compte.bigIconFileId=null\" ng-if=compte.bigIconFileId></tl-icon-button> </tl-field> <br/> <h4>Habilitations</h4> <tl-field authz-if-role=IT_ADMINISTRATION> <label class=tl-label><i class=\"fa fa-hat-cowboy red\"></i> IPs authorisées (séparées par des virgules, pour restreindre à une plage, indiquez le début, par exemple '<span class=b>252.123.</span>' pour n'autoriser que les ip commençant par 252.123.)</label> <input ng-model=compte.authorizedIPs type=text> </tl-field> <tl-field> <label class=tl-label>Module dette</label> <tl-checkbox ng-model=compte.moduleDette></tl-checkbox> </tl-field> <tl-field ng-if=\"compte.typeCompte=='PETITE_COMMUNE'\"> <label class=\"tl-label b u\">Offre 'essentiel' avec assistance financière continue inclue</label> <tl-checkbox ng-model=compte.essentielAvecConseilInclu></tl-checkbox> </tl-field> <tl-field> <label class=tl-label>Module dette garantie</label> <tl-checkbox ng-model=compte.moduleDetteGarantie></tl-checkbox> </tl-field> <tl-field> <label class=tl-label>Interfacages</label> <tl-checkbox ng-model=compte.interfacage></tl-checkbox> </tl-field> <tl-field> <label class=tl-label tl-tooltip=\"Pour référencer par son url un document géré dans une autre GED\">Gestion des documents externes (GED externe)</label> <tl-checkbox ng-model=compte.documentsExternes></tl-checkbox> </tl-field> <tl-field> <label class=tl-label>Module observatoire financier</label> <tl-checkbox ng-model=compte.moduleObservatoireFinancier></tl-checkbox> </tl-field> <div ng-if=compte.moduleObservatoireFinancier> <tl-field class=ml-m> <label class=\"tl-label b\">Ouvert à titre d'essai / démo</label> <tl-checkbox ng-model=compte.observatoireFinancierDemo></tl-checkbox> </tl-field> <tl-field class=ml-m ng-if=compte.observatoireFinancierDemo> <label class=\"tl-label b\">Ouvert jusqu'au (si vous ne renseignez rien la date de fin sera mise à dans 1 mois)</label> <tl-date-input ng-model=compte.observatoireFinancierDemoDateFin></tl-date-input> </tl-field> <tl-field class=ml-m> <label class=tl-label>Comparoscope - Version simplifiée (\"petites comunes, uniquement le comparatif d'un panel par défaut\")</label> <tl-checkbox ng-model=compte.observatoireFinancierSimplifie></tl-checkbox> </tl-field> </div> <tl-field> <label class=tl-label>Module placement</label> <tl-checkbox ng-model=compte.modulePlacement></tl-checkbox> </tl-field> <tl-field> <label class=tl-label>Module prêts octroyés</label> <tl-checkbox ng-model=compte.modulePret></tl-checkbox> </tl-field> <tl-field> <label class=tl-label><i class=fa></i>Module subvention</label> <tl-checkbox ng-model=compte.moduleAideSubvention></tl-checkbox> </tl-field> <div class=block-module-subvention ng-if=compte.moduleAideSubvention> <tl-field tl-validated-field=compte.aideSubventionConsultantId> <label class=tl-label>Chargé de support (à défaut sera le consultant)</label> <select ng-model=compte.aideSubventionConsultantId ng-options=\"c.id as c.label for c in consultants\" tl-null-option=Aucun></select> </tl-field> <tl-field tl-validated-field=compte.aideSubventionConsultant2Id> <label class=tl-label>Second chargé de support (à défaut sera le second consultant)</label> <select ng-model=compte.aideSubventionConsultant2Id ng-options=\"c.id as c.label for c in consultants\" tl-null-option=Aucun></select> </tl-field> </div> <tl-field> <label class=tl-label>Fonctionnalité Garants</label> <tl-checkbox ng-model=compte.garant></tl-checkbox> </tl-field> <tl-field ng-if=\"compte.typeCompte=='SEM'\"> <label class=tl-label>Fonctionnalité Observatoire</label> <tl-checkbox ng-model=compte.observatoire></tl-checkbox> </tl-field> <tl-field> <label class=tl-label>Module dette limité à la partie demande de financement (sans accès à la partie Portefeuille / Gestion de dette)</label> <tl-checkbox ng-model=compte.dfOnly></tl-checkbox> </tl-field> <tl-field authz-if-role=IT_ADMINISTRATION> <label class=tl-label><i class=\"fa fa-hat-cowboy red\"></i> Fonctionnalité SUIVI_COMPTABLE_REVOLVING</label> <tl-checkbox ng-model=compte.suiviComptableRevolving></tl-checkbox> </tl-field> <tl-field> <label class=\"tl-label b\">Ne pas inviter aux journées Taelys Collectivités (ne pas lister dans le module campagne)</label> <tl-checkbox ng-model=compte.excluJourneesTaelysCollectivites></tl-checkbox> </tl-field> <h4>Saisies</h4> <div ng-if=\"compte.typeCompte=='ENTREPRISE' || compte.typeCompte=='PLATEFORME_ENTREPRISE'\"> <tl-field ng-if=\"compte.compteParentId == null\"> <label class=tl-label><span class=b>Désactiver le cadrage</span></label> <tl-checkbox ng-model=compte.cadrageDesactive tl-tooltip=\"Désactive le cadrage sur le compte et les sous-comptes\"></tl-checkbox> <div class=\"b i blue\" ng-if=compte.cadrageDesactiveCompteParent>Ce compte est rattaché à un compte où le cadrage est desactivé. Le mode sera automatiquement appliqué à ce compte </div> </tl-field> <tl-field> <label class=tl-label><span class=b>Validation des saisies par les utilisateurs du client</span></label> <tl-checkbox ng-model=compte.validationParClient tl-tooltip=\"Les utilisateurs ayant le droit 'Validation' peuvent valider les produits\"></tl-checkbox> <div class=\"b i blue\" ng-if=compte.validationParClientCompteParent>Ce compte est rattaché à un compte où la validation par le client est activée. Le mode sera automatiquement appliqué à ce compte </div> </tl-field> <tl-field> <label class=tl-label><span class=b>Mode 4 yeux : La validation de la saisie doit être faite par un utilisateur différent de celui qui a activé le produit. (NON ENCORE ACTIF) </span></label> <tl-checkbox ng-model=compte.mode4Yeux tl-tooltip=\"Les utilisateurs ayant le droit 'Validation' peuvent valider les produits qu'ils n'ont pas saisi\"></tl-checkbox> <div class=\"b i blue\" ng-if=compte.mode4YeuxCompteParent>Ce compte est rattaché à un compte où le mode 4 yeux est activé. Le mode sera automatiquement appliqué à ce compte </div> </tl-field> </div> <tl-field> <label class=tl-label>Saisie des <span class=b>Schuldschein</span></label> <tl-checkbox ng-model=compte.saisieProduitSchuldschein></tl-checkbox> </tl-field> <tl-field> <label class=tl-label>Saisie des <span class=b>Euro PP</span></label> <tl-checkbox ng-model=compte.saisieProduitEuroPP></tl-checkbox> </tl-field> <tl-field> <label class=tl-label>Saisie des <span class=b>Billets de trésorerie</span></label> <tl-checkbox ng-model=compte.saisieProduitProgrammeBilletTresorerie></tl-checkbox> </tl-field> <tl-field> <label class=tl-label>Saisie des <span class=b>Comptes bancaires</span></label> <tl-checkbox ng-model=compte.saisieCompteBancaire></tl-checkbox> </tl-field> <tl-field> <label class=tl-label>Saisie des <span class=b>subventions d'emprunt</span></label> <tl-checkbox ng-model=compte.saisieProduitEmpruntSubvention></tl-checkbox> </tl-field> <div ng-if=\"compte.typeCompte=='ENTREPRISE' || compte.typeCompte=='PLATEFORME_ENTREPRISE'\"> <h4>Autres droits</h4> <tl-field> <label class=tl-label>Section <span class=b>Analyse &gt; Demande de financement</span></label> <tl-checkbox ng-model=compte.droitDemandeFinancement></tl-checkbox> </tl-field> <tl-field> <label class=tl-label>Section <span class=b>Analyse &gt; Baromètre des offres \"SPL\"</span></label> <tl-checkbox ng-model=compte.droitRubriqueAnalyseBarometre tl-tooltip=\"(habilitation DETTE_RUBRIQUE_ANALYSE_BAROMETRE)\"></tl-checkbox> </tl-field> <tl-field> <label class=tl-label>Section <span class=b>Saisie &gt; Intégration des soldes des LC via XRT (format Nexity)</span></label> <tl-checkbox ng-model=compte.droitXRTIntegrationSoldeLC tl-tooltip=\"(habilitation XRT_INTEGRATION_SOLDES_LC)\"></tl-checkbox> </tl-field> </div> <tl-field authz-if-role=IT_ADMINISTRATION> <label class=tl-label><i class=\"fa fa-hat-cowboy red\"></i> Accès au Lab expérimentateur</label> <tl-checkbox ng-model=compte.droitExperimentateur></tl-checkbox> </tl-field> <tl-field authz-if-role=EXPERIMENTATEUR> <label class=tl-label><i class=\"fa fa-hat-cowboy color-experimentateur\"></i>Proto - Module prêts intragroupe (entreprises)</label> <tl-checkbox ng-model=compte.modulePretIntra></tl-checkbox> </tl-field> <tl-field authz-if-role=EXPERIMENTATEUR> <label class=tl-label><i class=\"fa fa-hat-cowboy color-experimentateur\"></i>Proto - Module credit bail (entreprises)</label> <tl-checkbox ng-model=compte.moduleCreditBail></tl-checkbox> </tl-field> </div> <div class=footer> <tl-button class=btn-primary type=submit> {{'common.Enregistrer' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss() type=button> {{'common.Annuler' | translate}} </tl-button> </div> </form> </div>";

/***/ }),
/* 3676 */
/***/ (function(module, exports) {

module.exports = "<div> A gauche, la page est dédiée à l'aspect relation et communication : En haut vous retrouvez <span class=b>votre consultant</span>, avec ses coordonnées et un bouton vous permettant de demander qu'il vous rappelle : Lorsque vous cliquez, une boite de confirmation avec la possibilité de mettre un message apparait (pour préciser votre demande, ou à quelle heure vous rappeler). Dès que vous pressez le bouton 'Envoyer la demande', un mail avec votre message est envoyé à votre consultant (et aux consultants qui assurent la permanence en cas d'indisponibilité). Le bloc suivant <span class=b>\"Dernières assistances\"</span>, vous liste les assistances en cours ou récemment fermées. Il vous permet également de créer un ticket complet d'assistance. Ce méchanisme de ticket sera décrit plus en détail dans la rubrique <span class=b>'Nos échanges'</span>. Préférez autant que possible les tickets aux emails, car ceux-ci vous permettent de suivre automatiquement l'avancée du traitement de vos demandes. <p>Le bouton \"Nos échanges\" permet d'accéder à cette rubrique où vous retrouverez tickets, documents et publications de Taelys.</p> <p>Juste en dessous un fil d'information propose des liens vers les dernières communications et publications de Taelys.</p> <p>Enfin, toute modification de produit qui aura été validée par votre consultant fera appraitre une vignette</p> </div> ";

/***/ }),
/* 3677 */
/***/ (function(module, exports) {

module.exports = "<div> <gu-section id=connexion> <gu-section-title>Se connecter à la plateforme</gu-section-title> <gu-section-content> <p>Pour vous connecter la première fois, rendez-vous sur <a href=https://taelys.com target=_blank>https://taelys.com.</a> </p> <p>Cliquez sur le lien <span class=b>Première connexion ?</span> Une boite de dialogue vous invitera alors à saisir votre adresse email. Cet email contiendra un lien vous permettant de créer votre mot de passe. </p> <gu-image-box> <img src=/images/of/guide-utilisateur/connexion-2.png /> </gu-image-box> <p>Vous avez oublié votre mot de passe ? Pas de soucis, cliquez sur le lien <span class=b>Mot de passe oublié</span>. Entrez votre adresse email et vous recevrez un nouvel email vous permettant de saisir un nouveau mot de passe.</p> <div class=mt-s> <h4>Quel navigateur utiliser ?</h4> <p>Nous faisons de notre mieux pour que le site fonctionne parfaitement avec tous les navigateurs récents. Nous conseillons l'usage de Chrome qui offre les meilleures performances et le meilleur rendu.</p> </div> </gu-section-content> </gu-section> </div>";

/***/ }),
/* 3678 */
/***/ (function(module, exports) {

module.exports = "<div> <gu-section id=rubrique-conventions> <gu-section-title>Conventions</gu-section-title> <gu-section-content> <p><span class=b>* : </span> Lorsqu'un montant est basé sur une donnée financière estimée (taux futur), une petite étoile * est affichée à côté. 1000€ * d'intérêt signifie donc que ces intérêts sont déterminés par rapport à un fixing futur calculé suivant les anticipés de marché actuels.</p> <p><span class=b>Signe : </span> Par défaut, un montant payé est positif, un montant reçu est négatif.</p> <p><span class=b>Pastille de vie : </span> A coté d'un produit, une pastille noire signifie que le produit est échu (date de fin située avant la date de visualisation). Une pastille verte signifie que le produit est 'en vie\", c'est à dire que la date de visualisation est entre sa date de début et sa date de fin.</p> <p>Une pastille bleue siginifie que la vie du produit n'a pas encore débuté et donc que la date de visualisation se situe entre la date de début de prise en compte (date de signature ou date de création, selon la la date la plus ancienne) et la date de début du produit</p> <p><span class=b>Pastille M : </span> Indique que l'information de l'échéance à été modifiée manuellement. Si le M apparait en <span class=\"b green\">vert</span>, cela signifie que le montant manuel est égal au montant calculé. Si le M apparait en <span class=\"b green blue\">bleu</span>, cela signifie que l'écart avec le montant calculé est de moins de 5 centimes. <gu-image-box> <img src=/images/guides-utilisateur/presentation-plateforme/pastilles-manuelles.png width=400px /> </gu-image-box> </p><p><span class=b>Couleurs dans les séries des graphiques : </span></p> <p>Pour les montants, le <span class=blue>bleu</span> est utilisé pour la partie capital, le <span class=orange>orange</span> pour les intérêts, le <span class=green>vert</span> pour les frais. Le <span>violet</span> pour les enveloppes.</p> <p>Pour le risque, les taux fixes sont en <span class=blue>bleu</span>, les taux variables en <span class=orange>orange</span>, les taux structurés en <span class=green>vert</span>.</p> </gu-section-content> </gu-section> </div>";

/***/ }),
/* 3679 */
/***/ (function(module, exports) {

module.exports = "<div> <gu-section id=rubrique-fonctionnalites-transverses> <gu-section-title>Fonctionnalités transverses</gu-section-title> <gu-section-content> <h4>Les tableaux</h4> <p>- Les colonnes peuvent être triées dès qu'elle font apparaitre le symbole <i class=\"fa fa-sort\"></i>. Le choix de la colonne de tri est enregistrée pour chaque tableau et chaque utilisateur. Vous retrouverez donc chaque tableau trié suivant le dernier tri que vous avez utilisé pour celui-ci à chaque fois que vous y reviendrez</p> <p>- Certaines colonnes peuvent être masquées / affichées. Il vous suffit de cliquer sur 'gestion des colonnes' pour modifier leur affichage. Cette configuration est également enregistrée par utilisateur.</p> <p>- Tous les tableaux peuvent être exportés au format Excel (.xlsx). Afin de vous donner plus de détails, ces excels comportent généralement plus de colonnes que le tableau affiché dans le navigateur.</p> <h4 class=mt-xs>Les graphiques</h4> <p>- Tous les graphiques peuvent être exportés. Cliquez en haut à droite du graphique et choisissez exporter. Une fenêtre apparait alors, vous permettant de paramétrer plus finement le graphique avant son export. Vous pouvez l'exporter ou format image (.png) ou pdf (.pdf).</p> <p>- Vous pouvez passer en plein écran les graphiques</p> <p>- Les graphiques sont interactifs :</p> <p>Survolez-les pour afficher les valeurs, mettre en évidence les séries.</p> <p>Zoomez dans les graphiques de type 'ligne' en sélectionnant une période directement sur le graphique (cliquez à la date de début souhaitée et déplacez le pointeur de souris jusqu'à la date de fin souhaitée en maintenant le bouton de souris enfoncé) Vous pouvez ensuite quitter ce zoom en appuyant sur le bouton 'Réinitialiser le zoom' en haut à droite du graphique. </p> <p>Cliquez sur les légendes des séries, pour les retirer ou les réafficher dans le graphique.</p> <h4 class=mt-xs>Les impressions</h4> <p>- Utilisez le mode 'Impression' situé dans le menu accessible par un clic sur le logo toute à droite de la barre menu. Celui-ci bascule dans un affichage optimisé pour les impressions.</p> <p>- Pour imprimer, cliquez ensuite sur le lien correspondant dans le petit menu en haut à droite. Vous pouvez alors choisir une imprimante ou 'Imprimer en pdf' pour un export en document pdf</p> <h4 class=mt-xs>Le contexte</h4> <p>- Le contexte est un élément clé dans votre utilisation de la plateforme. Il vous permet de définir votre vision des produits.</p> <p class=mt-xs>Vous accédez au contexte par la barre de menu. Par défaut le contexte apparait en noir pour indiquer qu'aucun filtre n'est activé et que vous visualisez la plateforme en date du jour.</p> <p>Cliquez dessus pour ouvrir la fenêtre du contexte.</p> <p>Celui-ci se présente ainsi :</p> <p>En haut, tout à gauche le nom que vous avez le cas échéant donné à votre contexte. Par défaut il est nommé 'Contexte libre' </p> <p>Ensuite apparaissent les différents modules dont vous disposez et sur lequels vous pouvez paramétrer des filtres. Le module courant est selectionné par défaut, permettant de visualiser en dessous les filtres de ce module.</p> <p>La case 'Montants' qui suit vous permet de paramétrer l'affichage des nombres dans la plateforme : en €, K€, M€ avec ou sans centimes.</p> <p>La date de visualisation modifie à la fois la date à laquelle regarder les produits et la date de marché utilisée. Le bouton <i class=\"fa fa-repeat\"></i> vous remet en date du jour.</p> <p>La simulation de marché vous permet de choisir un scénario de données de marché spécifique parmi ceux que vous avez créés et enregistrés dans la rubrique <span class=b> marché &gt; simulations de marché</span></p> <p>Enfin à droite, les menus vous permettront de sauvegarder, gérer, recharger vos contextes.</p> <p>Revenons sur les filtres des modules :</p> <p>Ceux-ci apparaissent à gauche. Il vous permettent de filtrer les produits pris en compte, un à un, ou suivant leur nature, ou leur contrepartie, en ajoutant des simulations ...</p> <p>Par defaut les filtres sont inactifs : ils ne sont pas appliqués à vos produits. Cliquez sur le bouton pour passer un filtre à actif. La liste des valeurs du filtre va être activée. Sélectionnez à droite les valeurs à conserver (un racourci en haut vous permet de rapidement tout sélectionner/désélectionner). Attention, si vous ne sélectionnez rien, aucun produit ne sera conservé par ce filtre et la plateforme ne vous restituera aucune donnée. </p> <p>Une fois votre contexte paramétré, cliquez sur la croix en haut à gauche pour sortir de cette page et voir son impact sur le site .</p> <p>Le contexte est passé en rouge. Un survol de la souris vous affiche un résumé des filtres activés.</p> </gu-section-content> </gu-section> </div> ";

/***/ }),
/* 3680 */
/***/ (function(module, exports) {

module.exports = "<div> <gu-section id=rubrique-gestion-compte> <gu-section-title>Gestion du compte</gu-section-title> <gu-section-content> <div> Accédez à cette rubrique en cliquant sur le logo de votre entité en haut à droite. Puis, dans le menu déroulant, cliquez sur 'Gestion de compte'. </div> <div class=mt-xs> <h4>Profil</h4> <p>Cette section vous permet de mettre à jour vos informations.</p> <p>Elle contient aussi la liste de vos connexions, vous permettant de contrôler votre historique de connexion</p> </div> <div class=mt-xs> <h4>Utilisateurs</h4> <p>Cette section vous permet de gérer les utilisateurs et d'en ajouter de nouveaux.</p> </div> </gu-section-content> </gu-section> </div>";

/***/ }),
/* 3681 */
/***/ (function(module, exports) {

module.exports = "<div> <gu-section id=organisation-generale> <gu-section-title>Organisation générale</gu-section-title> <gu-section-content> <p>Nous avons cherché à vous proposer un site convivial et facilement appréhendable pour que sa prise en main soit rapide et intuitive.</p> <p>Toutes les pages du site offrent ainsi une structuration identique :</p> <p>En haut se trouve la barre de menu contenant les différentes <span class=b>rubriques</span> disponibles. La rubrique affichée apparait en <span class=violet>violet</span>.</p> <div ng-switch=module> <div ng-switch-when=DETTE_GARANTIE> <gu-image-box> <img src=/images/guides-utilisateur/dg/dg-top-bar.png /> </gu-image-box> </div> <div ng-switch-when=PRET> <gu-image-box> <img src=/images/guides-utilisateur/pret/pret-top-bar.png /> </gu-image-box> </div> <div ng-switch-default> <gu-image-box> <img src=/images/guides-utilisateur/presentation-plateforme/top-bar.png /> </gu-image-box> </div> </div> <p>Chaque rubrique est organisée en <span class=b>sections</span> qui apparaissent dans la barre située à gauche. La section affichée apparait elle aussi en <span class=violet>violet</span>. </p> <div>La page qui apparait au centre correspond donc à la rubrique et à la section sélectionnées. Elle peut elle même être composée de plusieurs onglets dont la sélection s'effectue en haut de la page. </div> <div class=\"gu-flex-line mt-m\"> <div class=\"\">Un <span class=b>volet de paramètres</span> dépliable est généralement disponible sur la gauche de la page (à droite de la barre de menu des sections) pour vous permettre de choisir différentes options qui impacteront la page affichée. </div> <div class=\"\"> <gu-image-box> <img src=/images/of/guide-utilisateur/organisation-2.png /> </gu-image-box> </div> </div> <div class=\"gu-flex-line mt-m\"> <div> <gu-image-box> <img src=/images/guides-utilisateur/presentation-plateforme/bar-contexte.png /> </gu-image-box> </div> <div class=box-70>Dans la barre de menu, juste avant le logo, se situe le <span class=b>contexte</span>. En cliquant dessus une fenêtre apparait. Elle vous permet de configurer toute la visualisation, en choisissant par exemple une date à laquelle visualiser votre portefeuille, en filtrant les produits, en incluant des simulations, ...<p></p> </div> </div> <div> <p>Un clic sur le logo à droite de la barre de menu affiche un <span class=b>sous menu</span> qui permet d’accéder :</p> <ul> <li class=mt-s>A la <span class=b>gestion de compte</span>, si vous disposez des droit d'administration, pour ajouter des utilisateurs et en gérer les droits. <gu-image-box><img src=/images/of/guide-utilisateur/organisation-3.png /></gu-image-box> </li> <li class=mt-s>Au <span class=b>mode impression</span> pour afficher la page dans un mode adapté à l'impression. <gu-image-box><img src=/images/of/guide-utilisateur/organisation-4.png /></gu-image-box> </li> <li class=mt-s>Au <span class=b>lien de déconnexion</span> pour fermer votre session de travail. Tout nouvel accès à une page de la plateforme nécessitera alors de saisir à nouveau votre mot de passe. </li> <li class=mt-s>Aux <span class=b>autres comptes</span> auquel vous pourriez avoir accès. </li> </ul> <br> <p>Enfin, si vous avez souscrit à plusieurs modules, un clic sur le nom du module courant sous le logo Taelys (Dette et financement, Dette garantie, Observatoire financier, Prêts octroyés, ...) ouvre un menu vous permettant d'accéder à ces autres modules. </p> </div> </gu-section-content> </gu-section> </div>";

/***/ }),
/* 3682 */
/***/ (function(module, exports) {

module.exports = "<div> <gu-section id=rubrique-vocabulaire> <gu-section-title>Vocabulaire de la plateforme</gu-section-title> <gu-section-content> <ul> <li><span class=b>Indexation</span> : Il s'agit de l'expression/la formule servant à définir un taux. Généralement constituée d'un ou plusieurs index au sein d'une formule (ex : EUR3M + 0,4%). </li> <li><span class=b>Date de visualisation</span> : date à laquelle vous observez la dette. Par exemple si vous positionnez votre date de visualisation au 1er janvier 2019, vous visualiserez les emprunts dont la date de signature (à défaut la date de saisie) est située au 1er janvier ou avant. Les données de marché qui sont utilisées seront celles telles qu'elles étaient connues à cette date. Pour les produits, seuls les évènements (remboursements anticipés, changements d'index, échéances manuelles) dont la date de prise en compte est située avant le 1er janvier seront prises en compte. </li> </ul> </gu-section-content> </gu-section> </div>";

/***/ }),
/* 3683 */
/***/ (function(module, exports) {

module.exports = "<div class=home-aad> <div class=\"tl-box b mb-xs\" ng-if=resumeInformationClient.contratTermine style=background-color:#ff4522;color:#fff> Votre contrat a expiré le {{resumeInformationClient.dateFinAbo | dateShort}}. Merci de retourner le contrat de renouvellement signé au plus vite. </div> <div class=\"tl-box-aad mb-xs\" ng-if=\"resumeInformationClient && resumeInformationClient.afficherAADAuClient\"> <h2>Vous avez une assistance au démarrage en cours</h2> <div ng-if=aad.afficherAADAuClient ng-repeat=\"aad in resumeInformationClient.aads\"> <tl-button authz-if-intra class=\"btn-primary float-r green\" ng-click=editAad(aad.id)><i class=\"fa fa-edit\" tl-tooltip=\"Edition de l'AAD (disponible pour le consultant uniquement)\"></i> </tl-button> <table class=table-aad> <tr class=row-images> <td><i class=\"fa fa-user-tie-hair fa-5x\"></i></td> <td><i class=\"fa fa-files fa-5x\"></i></td> <td><i class=\"fa fa-cloud-download fa-5x\"></i></td> <td><i class=\"fa fa-calendar-check-o fa-5x\"></i></td> </tr> <tr> <td class=b>Prise de contact par votre consultant</td> <td class=b>Transmission à votre consultant des documents pour initialiser votre base</td> <td class=b>Saisie des données dans la plateforme</td> <td class=b>RDV de formation</td> </tr> <tr> <td><i class=\"fa fa-check fa-3x\" ng-class=\"{'green':aad.priseDeContactConsultantEffectuee, 'grey':!aad.priseDeContactConsultantEffectuee}\"></i> </td> <td><i class=\"fa fa-check fa-3x\" ng-class=\"{'green':aad.receptionDonneesFinancieres, 'grey':!aad.receptionDonneesFinancieres}\"></i> </td> <td><i class=\"fa fa-check fa-3x\" ng-class=\"{'green':aad.saisieTerminee, 'grey':!aad.saisieTerminee}\"></i></td> <td><i class=\"fa fa-check fa-3x\" ng-class=\"{'green':aad.dateDemarrage, 'grey':!aad.dateDemarrage}\"></i></td> </tr> <tr> <td></td> <td><span ng-if=!aad.receptionDonneesFinancieres>Nous sommes en attente de vos documents :<br/>Pensez à les transmettre dès que possible !</span> </td> <td><span ng-if=aad.saisieTerminee> L'initialisation de votre base est maintenant terminée. Vous pouvez d'ores et déjà réaliser les vérifications que vous pensez nécessaires. </span></td> <td><span class=\"b blue\" ng-if=aad.dateDemarrage>Prévu le {{aad.dateDemarrage | dateShort}}</span> <span ng-if=!aad.dateDemarrage>La date n'est pas encore fixée.</span> </td> </tr> </table> </div> <p></p> <div class=\"tl-box mt-s\"><i class=\"fa icon-tooltip-info\"></i> En attendant la fin de cette assistance, n'oubliez pas que <span class=b>vous bénéficiez dès à présent de l'ensemble des prestations souscrites</span>. <span>N'hésitez pas notamment à contacter votre consultant dès que nécessaire.</span> </div> </div> </div>";

/***/ }),
/* 3684 */
/***/ (function(module, exports) {

module.exports = "<div no-print> <div class=\"tl-home-section annonce-top home-annonce-nouvelle-version\" ng-if=show> <i class=\"fa fa-times-circle-o close float-r\" tl-tooltip=Fermer ng-click=close()></i> <h2><span class=\"fa fa-bullhorn fa-2x logo-annonce\"></span>{{'accueil.LaPlateformeVientDEtreMiseAJour' | translate}} ({{'accueil.version' | translate}} {{::taelVersion}}).</h2> <p> <a class=b href=echanges/nouveautes>{{'accueil.DecouvrezLesDernieresNouveautesIci' | translate}}.</a> </p> <p class=alerte> <tl-checkbox ng-click=changeAlerteMail() ng-model=params.alerteMailMaj></tl-checkbox> <i class=\"fa fa-bell-o\"></i> {{'accueil.MInformerParMailAChaqueNouvelleMiseAJour' | translate}} </p> </div> </div> ";

/***/ }),
/* 3685 */
/***/ (function(module, exports) {

module.exports = "<div no-print class=home-bookmark> <div ng-if=\"bookmarks.length>0\" class=mb-xs> <div><h3 class=home-bookmark-title><span class=\"fa fal fa-bookmark mr-s\" style=font-size:1.2em></span> {{'accueil.bookmark.Vosraccourcis'|translate}}</h3> <tl-icon-button class=bkm-edit-btn ng-class=\"{green : editionBookmarks}\" no-print icon=\"{{editionBookmarks ? 'fa-check' : 'fa-gears'}}\" tl-tooltip=\"{{'accueil.bookmark.Vosraccourcis.tooltip'|translate}}\" ng-click=toggleBookmarkEdition()></tl-icon-button> </div> <div ng-repeat=\"bookmark in bookmarks\" class=home-bookmark-button> <i ng-if=\"editionBookmarks && !bookmark.deleting\" class=\"fa fa-2x fa-times-circle-o close red icon\" tl-tooltip=\"{{'accueil.bookmark.Supprimer'|translate}}\" ng-click=remove(bookmark)></i> <tl-circular-loader class=xs ng-if=bookmark.deleting></tl-circular-loader> <a href={{getFullUrl(bookmark)}}><i class=\"action-icon fa {{bookmark.icone||'fa-link'}} mr-xs\"></i>{{bookmark.titre}}</a> </div> <div ng-if=editionBookmarks>{{'accueil.bookmark.PourAjouterUnRaccourci1'|translate}} <i class=\"b fa fal fa-2x fa-bookmark-o\"></i> {{'accueil.bookmark.PourAjouterUnRaccourci2'|translate}} </div> </div> </div> ";

/***/ }),
/* 3686 */
/***/ (function(module, exports) {

module.exports = "<div> <div class=mb-xs no-print> <div class=tl-box ng-if=\"campagne && campagne.reponse=='VIENDRA' && !campagne.sessionTerminee\"> <p>Vous êtes inscrit à <span ng-if=\"campage.type=='JOURNEE_TAELYS'\">la journée Taelys</span><span ng-if=\"campage.type!=='JOURNEE_TAELYS'\">l'évènement : {{campagne.titreInvitation}}</span> de <span class=b>{{campagne.lieuSession}}</span> qui aura lieu le <span class=b>{{campagne.dateSession | date}}</span> <span ng-if=campagne.heureSession> à {{campagne.heureSession}}h<span ng-if=campagne.minutesSession>{{campagne.minutesSession}}</span></span>. </p> <p ng-if=campagne.adresseSession>L'adresse est {{campagne.adresseSession}}.</p> <p ng-if=campagne.lienVisio>Vous pourrez <span class=b>rejoindre la visio</span> en cliquant sur le lien <a class=b ng-href={{campagne.lienVisio}}>{{campagne.lienVisio}}</a></p> <p class=i>En cas d'indisponibilité merci de prévenir votre consultant.</p> </div> <div class=\"tl-box b mb-xs\" ng-if=\"campagne && campagne.reponse=='DOIT_CONFIRMER' && !campagne.sessionTerminee\"> <p>Votre participation <span ng-if=\"campage.type=='JOURNEE_TAELYS'\">aux journées Taelys</span><span ng-if=\"campage.type!=='JOURNEE_TAELYS'\">à l'évènement</span> reste à confirmer. Merci d'informer de votre décision de venir (ou non !) a votre consultant dès que possible.</p> </div> <div class=tl-box ng-if=\"campagne && !campagne.sessionsTermines && campagne.envoye && !campagne.echecEnvoi && (!campagne.aRepondu || campagne.reponse=='DOIT_CONFIRMER') \"> <i class=\"fa fa-envelope fa-2x blue mr-s\"></i> <span class=b ng-if=\"campagne.type=='JOURNEE_TAELYS'\" style=font-size:1.4em>Les journées Taelys approchent !</span> <span class=b ng-if=\"campagne.type!=='JOURNEE_TAELYS'\" style=font-size:1.4em>Evènement Taelys : {{campagne.titreInvitation}}</span> <p class=mt-xs>Vous avez reçu une invitation par mail. Merci de nous faire part de votre participation (ou non !) par retour de mail ou directement via le formulaire ci-dessous.</p> <div class=mt-xs> <div> <span> <label style=min-width:80px>Présence</label> : <select ng-model=reponseInvitation.reponse tl-lov-options=reponsesInvitationCampagne> </select> </span> <span class=ml-m ng-if=\"reponseInvitation.reponse!='NE_VIENDRA_PAS'\"> <label>Session</label> : <select ng-model=reponseInvitation.sessionId tl-lov-options=sessions ng-disabled=\"campagne.sessions.length==1\" tl-null-option=\"[Choisissez une session]\"> </select> <i class=\"fa icon-tooltip-info\" tl-tooltip> <tl-tooltip-content> <div> <div class=mb-s ng-repeat=\"session in campagne.sessions\">- <span class=b>{{session.lieu}}</span>, le {{session.date|date}}. <p>{{session.adresse}}</p></div> </div> </tl-tooltip-content> </i> </span> <span class=ml-m ng-if=\"reponseInvitation.reponse!='NE_VIENDRA_PAS' && campagne.type=='JOURNEE_TAELYS'\"> <label>Participation</label> : <select ng-model=reponseInvitation.journee tl-lov-options=journeesCampagne> </select> </span> <tl-button class=\"btn-primary ml-m\" ng-click=envoiReponseInvitation() ng-disabled=\"reponseInvitation.reponse!='NE_VIENDRA_PAS' && reponseInvitation.sessionId==null\"> Envoyer la réponse </tl-button> </div> <div style=margin-top:5px> <span> <label style=min-width:80px>Remarques</label> : <textarea class=text-area-box ng-model=reponseInvitation.remarque style=width:890px>\n                    </textarea> </span> </div> </div> </div> </div> </div> ";

/***/ }),
/* 3687 */
/***/ (function(module, exports) {

module.exports = "<div class=home-dashboard-changelog> <div class=\"tl-content-box no-content-border intra-logged-users\"> <div class=tl-box-header> <div class=header-icon> <i class=\"fa fa-users\"></i> </div> <div class=header-title> Changements clients sur les <input ng-model=componentCtrl.filter.depuis input-type-number number-integer size=4> derniers jours ({{modifications.length}}) </div> <div class=right-actions> <div> <tl-checkbox ng-model=componentCtrl.filter.comptesFils> <span>Arborescence</span> </tl-checkbox> <tl-checkbox ng-model=view.detail> <span>Détail</span> </tl-checkbox> </div> <div> <tl-checkbox ng-model=componentCtrl.filter.saisieConsultants> <span>Saisies consultants</span> </tl-checkbox> <tl-checkbox ng-model=componentCtrl.filter.saisieClients> <span>Saisies clients</span> </tl-checkbox> </div> <i class=\"fa fab icon action-icon icon-b header-show-icon\" tl-tooltip no-print ng-class=\"{'fa-chevron-circle-up':view.showSection, 'fa-chevron-circle-down':!view.showSection}\" ng-click=changeShow()> <tl-tooltip-content> {{view.showSection == true ? 'Masquer' : 'Afficher'}} </tl-tooltip-content> </i> </div> </div> <div class=tl-box-content ng-if=view.showSection> <div> <tl-loader-overlay ng-if=loadingChangelog></tl-loader-overlay> <tl-table table-config=modificationsTableConfig ng-if=\"modifications && modifications.length>0\"></tl-table> <span ng-if=\"modifications.length==0\">Aucun changement</span> <tl-circular-loader class=small ng-if=!modifications></tl-circular-loader> </div> </div> </div> </div>";

/***/ }),
/* 3688 */
/***/ (function(module, exports) {

module.exports = "<div class=home-contrat> <div class=section> <div class=header> Contrat </div> <div class=body> <span ng-if=::resume.assistanceFinanciereContinu class=\"pill assistance-pill\">Assistance financière Continue</span> <span ng-if=!resume.assistanceFinanciereContinu class=\"pill no-assistance-pill\">Assistance financière non inclue</span> <span authz-if-role=INTRA_CRM_GESTION_CLIENTS class=\"pill facture-pill\" ng-if=::resume.factureEnRetard>Paiement facture en retard</span> <p ng-if=::resume.clientAbonneDepuis>Client abonné depuis : {{::resume.clientAbonneDepuis | dateShort}} </p> <p ng-if=\"::resume.dateFinAbo!=null\">Date fin de contrat : {{::resume.dateFinAbo | dateShort}} ({{::resume.nbMoisAboRestant}} mois)</p> <span class=b ng-class=\"{'red':crm.observatoireFinancierDemoDateFinDepassee}\" ng-if=\"crm.droitObservatoireFinancier && crm.observatoireFinancierDemo\">Observatoire en démo jusqu'au {{crm.observatoireFinancierDemoDateFin|dateShort}} <i class=\"red fa fa-warning\" ng-if=crm.observatoireFinancierDemoDateFinDepassee></i></span> <div authz-if-role=INTRA_CRM_GESTION_CLIENTS ng-if=\"resume.authorizedIPs.length>0\"> <p class=red>Accès restreint aux ip : <span ng-repeat=\"ip in resume.authorizedIPs track by $index\"><span ng-if=\"$index>0\"> ,</span>{{ip}}</span></p> </div> </div> </div> <div class=section> <div class=header> CRM </div> <div class=body> <div> <span ng-if=\"! resume.nbTicketsOuverts\">Aucun ticket ouvert</span> <span ng-if=resume.nbTicketsOuverts> {{::resume.nbTicketsOuverts}} {{resume.nbTicketsOuverts > 1 ? 'tickets ouverts' : 'ticket ouvert'}} <a href={{appPath}}/echanges/nos-echanges><i class=\"fa fa-regular fa-square-arrow-right\"></i></a> </span> </div> <div ng-if=resume.dateDernierVisite>Dernière visite : <span class=\"{{resume.moisDepuisDernierVisite > 12 ? 'too-old' : resume.moisDepuisDernierVisite > 9 ? 'old' : 'recent'}}-visite\">{{::resume.dateDernierVisite | dateShort}}</span> <span ng-if=\"resume.moisDepuisDernierVisite > 9\"> ({{resume.moisDepuisDernierVisite}} mois)</span> </div> <div ng-if=!resume.dateDernierVisite class=no-visite>Aucune visite effectuée</div> <p> <span ng-if=resume.dateDernierAcces> Date de dernier accès client : {{::resume.dateDernierAcces | dateMedium}} <span ng-if=\"::resume.actif===false\" class=false-circle tl-tooltip=\"Compte inactif\"></span> </span> <span ng-if=\"! resume.dateDernierAcces\">Aucun accès client</span> </p> </div> </div> </div>";

/***/ }),
/* 3689 */
/***/ (function(module, exports) {

module.exports = "<div class=\"info-intra mb-s\" no-print> <div class=\"tl-box resume-box\" ng-if=::resume> <div class=info-generales> <div class=info-colonne> <div class=colonne-header>Notre relation</div> <home-contrat class=colonne-body></home-contrat> </div> <div if-dette class=info-colonne> <div class=colonne-header>Portefeuille</div> <home-portefeuille-dette class=colonne-body></home-portefeuille-dette> </div> <div if-dette-garantie class=info-colonne> <div class=colonne-header>Portefeuille</div> <home-portefeuille-dette-garantie class=colonne-body></home-portefeuille-dette-garantie> </div> <div if-application=DETTE||PRET class=info-colonne> <div class=colonne-header>Interfaçages</div> <home-interfacages class=colonne-body></home-interfacages> </div> </div> <br> <tl-form-details show-label=\"Suivi CRM\" hide-label=Cacher> <table class=\"tl-simple-table crm\"> <tr> <td>Affectation</td> <td> <span>{{crm.affectation}}</span> <span ng-if=\"crm.dateFinAbonnement!==null\"> <i ng-if=\"crm.nbMoisAboRestant<0\" class=\"ml-xs fa fa-ban\" tl-tooltip=\"Client avec abonnement terminé et non renouvellé (depuis {{-crm.nbMoisAboRestant}} mois)\"></i> <i ng-if=\"crm.nbMoisAboRestant>=0\" class=\"ml-xs fa fa-user-circle-o\" tl-tooltip=\"Fin abonnement dans {{crm.nbMoisAboRestant}} mois\"></i> <i ng-if=\"crm.nbMoisAboRestant>=0 && crm.nbMoisAboRestant<6\" class=\"ml-xs fa fa-flag\" tl-tooltip=\"Fin abonnement dans {{crm.nbMoisAboRestant}} mois\"> {{crm.nbMoisAboRestant}}m.</i> </span> <span ng-if=\"crm.dateFinAbonnement==null && crm.compteClientAbonne\"> <i ng-if=\"crm.typeCompte!='PLATEFORME'\" class=\"ml-xs fa fa-user-circle-o red\" tl-tooltip=\"Compte marqué comme abonné sans abo lié sur un client du crm\"></i> <i ng-if=\"crm.typeCompte=='PLATEFORME'\" class=\"ml-xs fa fa-user-circle-o blue\" tl-tooltip=\"Compte marqué comme abonné sans abo lié (plateforme, ce sont sans doute les comptes fils qui sont lié à un contrat)\"></i> </span> <span ng-if=crm.compteClientPonctuel> <i ng-if=crm.compteClientPonctuel class=\"ml-xs fa fa-support\" tl-tooltip=\"Client avec assistance ponctuelle\"></i> </span> </td> <td>Date activation</td> <td><span>{{crm.dateActivation | dateShort}}</span></td> </tr> <tr> <td>Modules du compte</td> <td> <tl-module-dette ng-if=crm.droitDette>D</tl-module-dette> <tl-module-interfacage ng-if=crm.droitInterfacage></tl-module-interfacage> <tl-module-placement ng-if=crm.droitPlacement></tl-module-placement> <tl-module-pret ng-if=crm.droitPret></tl-module-pret> <tl-module-aide-subvention ng-if=crm.droitAideSubvention></tl-module-aide-subvention> <tl-module-credit-bail ng-if=crm.droitCreditBail></tl-module-credit-bail> <tl-module-dette-garantie ng-if=crm.droitDetteGarantie></tl-module-dette-garantie> <tl-module-of ng-if=\"crm.droitObservatoireFinancier && !crm.observatoireFinancierSimplifie\"></tl-module-of> <tl-module-of-comparoscope ng-if=\"crm.droitObservatoireFinancier && crm.observatoireFinancierSimplifie\"></tl-module-of-comparoscope> <span class=b ng-class=\"{'red':crm.observatoireFinancierDemoDateFinDepassee}\" ng-if=\"crm.droitObservatoireFinancier && crm.observatoireFinancierDemo\" tl-tooltip=\"Démo fin : {{crm.observatoireFinancierDemoDateFin|dateShort}}\">(D) <i class=\"red fa fa-warning\" ng-if=crm.observatoireFinancierDemoDateFinDepassee></i></span> </td> <td> Options au contrat </td> <td> <span class=\"client-options simple-pill\"> <tl-module-dette ng-if=crm.options.detteEtFinancement></tl-module-dette> <tl-module-dette-garantie ng-if=crm.options.detteGarantie></tl-module-dette-garantie> <tl-module-pret ng-if=crm.options.pretOctroyes></tl-module-pret> <tl-module-of ng-if=crm.options.observatoireFinancier></tl-module-of> <tl-module-placement ng-if=crm.options.placement></tl-module-placement> <tl-module-aide-subvention ng-if=crm.options.aideSubvention></tl-module-aide-subvention> <tl-module-interfacage interface={{crm.options.logicielInterfacage}} ng-if=crm.options.interfacage></tl-module-interfacage> <span ng-if=crm.options.audit tl-tooltip=Audit class=\"ml-s mr-s b\">Audit</span> <span ng-if=crm.options.assistanceFinanciereContinu tl-tooltip=\"Assistance d'un consultant en continu\" class=\"ml-s mr-s b sim-pill\">AC</span> </span> </td> </tr> <tr> <td>Statut de suivi</td> <td> <div tl-tooltip> <span ng-if=\"crm.statut!=null\">{{'lov.compteSuiviStatuts.' + crm.statut | translate}}</span> <tl-tooltip-content> <div>NEANT : aucun risque identifié</div> <div>FAIBLE : quelques indices de risque. Client sur lequel il faut mener des actions. </div> <div>HAUT : Risque avéré. Il faut rapidement mener des actions.</div> <div>PERDU : Des actions ont été menées, mais sans succès. Le client ira au terme de son engagement contractuel, mais ne renouvellera pas. </div> </tl-tooltip-content> </div> </td> <td>Bureau</td> <td>{{crm.bureau}}</td> </tr> <tr> <td>Suivi</td> <td colspan=3> <div class=suivi-commentaires> <div tl-tooltip class=suivi-commentaire ng-class={grey:suivi.cloture} ng-repeat=\"suivi in crm.compteSuivi.commentaires track by $index\"> {{suivi.metadata.creationDate | dateShort}} : {{suivi.commentaire}} <i class=\"fa fa-running\" ng-if=suivi.pourAction tl-tooltip=\"Une action est à faire\"></i> <tl-tooltip-content> Créé le {{suivi.metadata.creationDate | dateMedium}} par {{suivi.metadata.creationUser}}<br/> Maj le {{suivi.metadata.lastUpdateDate | dateMedium}} par {{suivi.metadata.lastUpdateUser}}<br/> </tl-tooltip-content> </div> </div> </td> </tr> <tr> <td>Activité de suivi commercial ({{crm.activiteSuiviCommercialCloture | number}})</td> <td colspan=3> <div> <p ng-repeat=\"description in crm.activiteSuiviCommercialClotureDescriptions track by $index\"> <span ng-bind-html=description></span> </p> </div> </td> </tr> <tr> <td>Nb tickets</td> <td>{{crm.nbTickets}}</td> <td></td> <td></td> </tr> <tr> <td>Tickets Ouverts</td> <td>{{crm.ticketsOuverts}}</td> <td>Tickets Ouverts >2m.</td> <td><span ng-class=\"{'red b':crm.ticketsOuvertsPlusDe2Mois>0}\">{{crm.ticketsOuvertsPlusDe2Mois | number}}</span> </td> </tr> <tr> <td>Visite</td> <td>{{crm.nbVisites}}</td> <td>Vis.&lt;18mois</td> <td><span ng-class=\"{'red b':model.nbVisites18mois==0}\">{{model.nbVisites18mois | number}}</span> </td> </tr> <tr> <td>Nb connexions</td> <td>{{crm.nbConnexions}}</td> <td ng-class=\"{'red b':model.nbConnexions<=5}\">Nb connexions &lt; 1an</td> <td>{{crm.nbConnexions1an}}</td> </tr> <tr> <td>Dernier accès</td> <td>{{::crm.dateDernierAcces | dateMedium}} <i class=\"fa fa-bell red ml-xs\" ng-if=crm.alerteConnexion title=\"Aucune connexion depuis plus de 3 mois\"></i> </td> <td></td> <td></td> </tr> <tr ng-if=crm.droitInterfacage> <td>Interfaçage 12m.</td> <td><span ng-class=\"{'red b': !(crm.nbExportInterfacage12mois>0)}\">{{crm.nbExportInterfacage12mois | number}}</span> </td> <td></td> <td></td> </tr> <tr> <td>Nb acces module OF &lt; 18m</td> <td><span>{{crm.nbAccesModuleOf18m | number}}</span></td> <td>Nb acces module OF</td> <td><span>{{crm.nbAccesModuleOf | number}}</span></td> </tr> <tr> <td>Obs Fi. cmp 12m.</td> <td><span>{{crm.ofComparaison12mois | number}}</span></td> <td>Obs Fi. cmp</td> <td><span>{{crm.ofComparaison | number}}</span></td> </tr> <tr ng-if=crm.droitDetteGarantie> <td>DG</td> <td> <div ng-if=crm.besoinNouvelleIntegrationCdc>Maj CDC nécessaire, dernière {{crm.dateDerniereIntegrationCdc | dateShort}} </div> <div ng-if=crm.integrationCdcPlusDe12Mois class=\"red b\">dernière CDC &gt; 12 mois</div> <div ng-if=crm.aucuneInteration>Aucune integration</div> <i class=\"fa fa-check green\" ng-if=crm.integrationCdcOk tl-tooltip=\"Intégration CDC à jour\"></i> <i class=\"fa fa-warning orange\" ng-if=!crm.integrationCdcOk></i> <div>Nb export etats xls : {{crm.exportEtatDG18Mois}}</div> </td> <td></td> <td></td> </tr> <tr> <td>Etats (18 derniers mois)</td> <td> <div ng-if=\"crm.exportEtatDG18Mois>0\">xls DG : {{crm.exportEtatDG18Mois}}</div> <div ng-if=\"crm.exportEtatDette18Mois>0\">xls dette : {{crm.exportEtatDette18Mois}}</div> <div ng-if=\"crm.exportTotem18Mois>0\">totem : {{crm.exportTotem18Mois}}</div> <div ng-if=\"crm.exportTotemDg18Mois>0\">totem DG : {{crm.exportTotem18Mois}}</div> </td> <td></td> <td></td> </tr> <tr> <td>Mails (&lt;12m.)</td> <td><span>{{crm.nbMails | number}}</span></td> <td><span ng-if=crm.clientLocalNova>Client LocalNova</span></td> <td><span class=\"b blue\" ng-if=crm.clientLocalNova>OUI</span></td> </tr> </table> </tl-form-details> <div class=mt-xs ng-if=resume.invitations> <h4>Campagne</h4> <tl-table table-config=invitationsTableConfig></tl-table> </div> <div class=mt-xs> <h4>Utilisateurs du compte connectés dans les 3 dernières heures <i class=\"fa fa-refresh blue\" ng-click=loadUtilisateursConnectes() ng-if=!loadingUtilisateursConnectes></i> <tl-circular-loader class=xs ng-if=loadingUtilisateursConnectes></tl-circular-loader></h4> <div class=i ng-if=\"utilisateurs.length===0\">Aucun.</div> <tl-table ng-if=\"utilisateurs.length>0\" table-config=utilisateursTableConfig></tl-table> </div> <div class=mt-xs ng-if=resume.formations> <h4>Utilisateurs du compte inscrits aux formations à venir</h4> <tl-table table-config=formationsTableConfig></tl-table> </div> </div> </div> ";

/***/ }),
/* 3690 */
/***/ (function(module, exports) {

module.exports = "<div class=confirm-box> <div class=title> <h3>Bienvenue {{user.civilite}} {{user.nom}} sur la plateforme Taelys</h3> </div> <div class=content> <div class=popin-form> <p><i class=\"fa fa-2x fa-bell-o mr-s\"></i> <span ng-if=!homeInfo.afficheWelcomeUtilisateurDejaExistant>Avant de démarrer nous voudrions confirmer vos inscriptions aux alertes suivantes :</span> <span ng-if=homeInfo.afficheWelcomeUtilisateurDejaExistant>Nous voudrions confirmer vos inscriptions aux alertes suivantes :</span> </p> <p class=i>(vous pourrez très simplement modifier votre choix à tout moment sur la plateforme)</p> <ul class=\"mt-m ml-m mb-m\"> <li class=\"alerte mt-m\"> <tl-checkbox class=mr-m ng-model=params.alerteMailPublicationMaj ng-click=changeAlerteMailPublication()></tl-checkbox> M'informer par mail à chaque nouvelle publication (lettres d'actualités) </li> <li class=alerte> <tl-checkbox class=mr-m ng-model=params.alerteMailVersionMaj ng-click=changeAlerteMailVersion()></tl-checkbox> M'informer par mail à chaque nouvelle mise à jour majeure de la plateforme pour découvir les nouveautés </li> </ul> <div ng-if=!homeInfo.afficheWelcomeUtilisateurDejaExistant> <p class=mb-m>N'hésitez pas à contacter votre consultant pour qu'il vous aide à prendre en main la plateforme.</p> <p>Un guide utilisateur et des tutoriaux sont disponibles dans le menu profil accessible en cliquant sur votre logo en haut à droite.</p> </div> </div> </div> <div class=footer> <tl-button class=btn-primary ng-click=validateAndSave()> Terminer </tl-button> </div> </div> ";

/***/ }),
/* 3691 */
/***/ (function(module, exports) {

module.exports = "<div class=it-column-selector tl-dropdown> <a class=\"it-cs-btn tl-link\" tl-dropdown-toggle> <i class=\"fa fa-columns\"></i> <span>{{'it-column-selector.gestionDesColonnes'|translate}}</span> </a> <div class=it-cs-menu tl-dropdown-menu> <div class=it-cs-group ng-if=xlsUrl> <a class=\"it-cs-btn tl-link xls-metadata-group\" ng-click=xlsMetadata() ng-if=!docx> <i class=\"ft ft-excel\"></i> <span>{{'it-column-selector.gestionDesColonnesExcel'|translate}}</span> </a> <a class=\"it-cs-btn tl-link xls-metadata-group\" ng-click=xlsMetadata() ng-if=docx> <i class=\"fa fa-th-list\"></i> <span>{{'it-column-selector.ChoixDesColonnesExport'|translate}}</span> </a> </div> <div class=it-cs-group ng-repeat=\"group in columnGroups\" tl-dropdown-keep-open-on-click> <tl-checkbox ng-click=toggleGroup(group) ng-checked=isGroupVisible(group)> <span>{{::group.title}}</span> </tl-checkbox> </div> <div class=it-cs-group ng-if=isResizable tl-dropdown-keep-open-on-click> <a class=\"it-cs-btn tl-link\" ng-click=resetColumnsSize()> <i class=\"fa fa-text-width\"></i> <span>{{'it-column-selector.reinitialiserTailleColonnes' | translate:'Réinitialiser la taille des colonnes'}}</span> </a> </div> <div class=it-cs-group ng-if=isReorderable tl-dropdown-keep-open-on-click> <a class=\"it-cs-btn tl-link\" ng-click=resetColumnsOrder()> <i class=\"fa fa-arrows-h\"></i> <span>{{'it-column-selector.reinitialiserOrdreColonnes' | translate:'Réinitialiser l\\'ordre des colonnes'}}</span> </a> </div> </div> </div>";

/***/ }),
/* 3692 */
/***/ (function(module, exports) {

module.exports = "<div class=it-subtotal-button> <a class=tl-link ng-click=click() ng-if=\"group!==null\"> <span ng-if=\"group===false\"><i class=\"fa fa-list-tree\"></i> {{groupLabel}}</span> <span ng-if=\"group===true\"><i class=\"fa fa-list\"></i> {{ungroupLabel}}</span> </a> </div>";

/***/ }),
/* 3693 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box sp-popin sp-frais-popin\"> <div class=title> <h3 ng-switch=initial> <span ng-switch-when=true> {{'documents.AjoutDUnRepertoire' | translate}} </span> <span ng-switch-default> {{'documents.EditionDUnRepertoire' | translate}} </span> </h3> </div> <div class=content> <div class=popin-form> <tl-field> <label> {{'documents.NomDuRepertoire' | translate}} </label> <input maxlength=80 ng-model=document.label tl-focus-init/> </tl-field> </div> </div> <div class=footer> <tl-button class=btn-primary ng-click=saveAndClose()> {{ initial ? 'common.add' : 'common.Enregistrer' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss()> {{'common.dialog.cancel' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3694 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box sp-popin sp-frais-popin\"> <div class=title> <h3 ng-switch=initial> <span ng-switch-when=true> {{'documents.AjoutDUnDocument' | translate}} <span ng-if=\"nbUpload>1\">({{nbFinishedUpload + 1}}/{{nbUpload}})</span> </span> <span ng-switch-default> {{'documents.EditionDUnDocument' | translate}} </span> </h3> </div> <div class=content> <div class=popin-form> <tl-field tl-field-error=label> <label> {{'documents.NomDuDocument' | translate}} </label> <input ng-model=document.label maxlength=100 tl-focus-init/> </tl-field> <tl-field tl-field-error=type> <label> {{'documents.TypeDeDocument' | translate}} </label> <select ng-model=document.type ng-options=\"d.id as d.label for d in allowedTypes | orderBy\"> <option disabled=disabled value=\"\">-- Sélectionnez un type --</option> </select> </tl-field> <tl-field ng-if=\"!aideSubventionApplication && typesDocumentsEcheancesIds.includes(document.type)\"> <label>Date d'échéance</label> <select ng-model=document.tags.DATE_ECHEANCE ng-options=\"de.date as de.label for de in dateEcheances\"> <option value=\"\">-- Non associé à une échéance --</option> </select> </tl-field> <tl-field ng-if=\"document.url != null\" tl-field-error=url> <label> {{'documents.UrlDuDocumentExterne' | translate}} </label> <input ng-model=document.url maxlength=1000 /> </tl-field> <tl-field if-application=DETTE||PRET> <label> {{'documents.JustificatifComptable' | translate}} </label> <tl-checkbox ng-model=document.tags.JUSTIFICATIF_TRESORERIE /> </tl-field> </div> </div> <div class=footer> <tl-button class=btn-primary ng-click=saveAndClose()> {{ initial ? 'common.add' : 'common.Enregistrer' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss()> {{'common.dialog.cancel' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3695 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box sp-popin sp-frais-popin\"> <div class=title> <h3 ng-switch=document.type> <span ng-switch-when=DIRECTORY> {{'documents.DeplacementDUnRepertoire' | translate}} </span> <span ng-switch-default> {{'documents.DeplacementDUnDocument' | translate}} </span> </h3> </div> <div class=content> <div class=popin-form> <tl-field tl-field-error=emplacement> <label> {{'documents.NouvelEmplacement' | translate}} </label> <select ng-model=document.parentId style=max-width:59%> <option ng-repeat=\"d in directories | orderBy:'label'\" value={{d.id}}>{{d.label}}</option> <option value=__NEW_DIR>Dans un nouveau répertoire</option> </select> </tl-field> </div> </div> <div class=footer> <tl-button class=btn-primary ng-click=saveAndClose()> {{ 'common.dialog.confirm' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss()> {{'common.dialog.cancel' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3696 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box sp-popin sp-frais-popin\"> <div class=title> <h3 ng-switch=initial> {{'documents.TelechargementDesDocuments' | translate}} </h3> </div> <div class=content> <div class=popin-form> <div class=\"mb-s b\"> <p ng-if=selectionIsTooBig()> {{'documents.LesSousRepertoiresContiennentTropDeFichiersPourEtreTelechargesEnUneSeuleArchive' | translate}} ({{params.sizeRec | bytes}} &gt; {{'documents.LesSousRepertoiresContiennentTropDeFichiersPourEtreTelechargesEnUneSeuleArchive2' | translate}} {{MAX_FILES_SIZE | bytes}})</p> <p ng-if=\"!selectionIsTooBig() && nbDocsATelecharger()==0\"> {{'documents.AucunDocumentATelecharger' | translate}}.</p> <p ng-if=\"!selectionIsTooBig() &&  nbDocsATelecharger()>0\"> {{'documents.zipDownload.VousAllezTelecharger' | translate}} {{params.recursive ? params.nbDocsRec : params.nbDocs}} {{'documents.documents' | translate}}{{((params.recursive == false && params.size == 0) || (params.recursive && params.sizeRec == 0)) ? \"\" : \", \" + (params.recursive ? params.sizeRec : params.size | bytes)}}</p> </div> <tl-field> <tl-checkbox ng-model=params.recursive> {{'documents.InclureLeContenuDesSousRepertoires' | translate}} </tl-checkbox> </tl-field> <p class=\"i mt-xs\" ng-if=\"nbDocsATelecharger()>0\">{{'documents.zipDownload.explicationZip' | translate}}</p> </div> </div> <div class=footer> <tl-button class=btn-primary ng-click=downloadAndClose() ng-disabled=\"nbDocsATelecharger()==0 || selectionIsTooBig()\"> {{'common.Telecharger' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss()> {{'common.dialog.cancel' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3697 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box df-offre-edition-popin\"> <form class=popin-form tl-validated-form=offreFormConfig> <div class=title ng-switch=edit> <h3 ng-switch-when=true>Baromètre - Edition d'une offre d'emprunt</h3> <h3 ng-switch-when=false>Baromètre - Création d'une offre d'emprunt<span ng-if=copieId> (duplication)</span></h3> </div> <div class=content> <div tl-validated-global-errors></div> <tl-field tl-field-attribute=banqueId tl-required tl-validated-field=offre.banqueId> <label class=tl-label>Banque <tl-validated-field-check-icon></tl-validated-field-check-icon></label> <tl-select ng-model=offre.banqueId base-config-name=banque options=contreparties></tl-select> </tl-field> <tl-field class=search-area tl-field-attribute=compteId tl-required tl-validated-field=offre.compteId> <label class=tl-label>Client (compte) <tl-validated-field-check-icon></tl-validated-field-check-icon></label> <tl-search-field config=searchConfig></tl-search-field> </tl-field> <tl-field tl-field-attribute=dateOffre tl-required tl-validated-field=offre.dateOffre> <label class=tl-label>Date de l'offre <tl-validated-field-check-icon></tl-validated-field-check-icon></label> <tl-date-input ng-model=offre.dateOffre></tl-date-input> </tl-field> <tl-field tl-field-attribute=maturite tl-required tl-validated-field=offre.maturite> <label class=tl-label>Maturité (en années) <tl-validated-field-check-icon></tl-validated-field-check-icon></label> <input input-type-number ng-model=offre.maturite number-integer type=text> </tl-field> <tl-field tl-validated-field=offre.dureeMobilisation> <label class=tl-label>Durée de la phase de mobilisation (en mois)</label> <input type=text input-type-number number-integer ng-model=offre.dureeMobilisation> </tl-field> <tl-field class=tl-field tl-field-attribute=typeAmortissement tl-required tl-validated-field=offre.typeAmortissement> <label class=tl-label> Type d'amortissement <tl-validated-field-check-icon></tl-validated-field-check-icon> </label> <select ng-model=offre.typeAmortissement tl-lov-options=typesAmortissement></select> </tl-field> <tl-field tl-field-attribute=periodicite tl-required tl-validated-field=offre.periodicite> <label class=tl-label> <span>Périodicité <tl-validated-field-check-icon></tl-validated-field-check-icon></span> </label> <select ng-model=offre.periodicite tl-lov-options=periodicites></select> </tl-field> <tl-field tl-field-attribute=montant tl-required tl-validated-field=offre.montant> <label class=tl-label>Montant <tl-validated-field-check-icon></tl-validated-field-check-icon></label> <input type=text input-type-number ng-model=offre.montant max-decimals=2> </tl-field> <tl-field tl-validated-field=offre.frais> <label class=tl-label>Frais (en % du CRD)</label> <input type=text input-type-number ng-model=offre.frais max-decimals=3> </tl-field> <div class=tl-field tl-validated-field=offre.commentaire> <label class=tl-label>Commentaire</label> <textarea ng-model=offre.commentaire></textarea> </div> <div class=tl-field tl-validated-field=offre.visibleClient> <tl-checkbox ng-model=offre.visibleClient><span>Visible aux clients</span></tl-checkbox> </div> <tl-field tl-field-attribute=indexation.typeModaliteIndexation tl-required tl-validated-field=offre.indexation.typeModaliteIndexation> <label class=tl-label>Type d'indexation <tl-validated-field-check-icon></tl-validated-field-check-icon></label> <select ng-model=offre.indexation.typeModaliteIndexation tl-lov-options=typesModaliteIndexation></select> </tl-field> <div ng-switch=offre.indexation.typeModaliteIndexation> <div ng-switch-when=FIXE> <tl-field class=tl-field tl-validated-field=offre.indexation.tauxFixe> <label class=tl-label> Taux </label> <tl-percent-input ng-model=offre.indexation.tauxFixe max-decimals=5></tl-percent-input> </tl-field> </div> <div ng-switch-when=VARIABLE> <div> <div class=tl-field> <label class=tl-label>Indexation</label> <div class=taux-variable-line> <select ng-model=offre.indexation.index ng-options=\"index.id as index.label group by index.groupe for index in indices\"></select> <span>+</span> <tl-percent-input ng-model=offre.indexation.marge allow-negative max-decimals=5></tl-percent-input> </div> </div> </div> <div class=\"tl-field tl-field-inline phase-taux-line\" ng-class=\"{ 'tl-off' : !tauxMax.checked }\"> <label class=tl-label></label> <tl-checkbox ng-model=tauxMax.checked> <span>Taux max</span> </tl-checkbox> <tl-percent-input class=taux ng-model=tauxMax.value max-decimals=5 allow-negative ng-disabled=!tauxMax.checked></tl-percent-input> </div> <div class=\"tl-field tl-field-inline phase-taux-line\" ng-class=\"{ 'tl-off' : !tauxMin.checked }\"> <label class=tl-label></label> <tl-checkbox ng-model=tauxMin.checked> <span>Taux min</span> </tl-checkbox> <tl-percent-input class=taux ng-model=tauxMin.value max-decimals=5 allow-negative ng-disabled=!tauxMin.checked></tl-percent-input> </div> </div> </div> <div> <div class=tl-field tl-validated-field={{penaliteFieldPrefix}}.typePenalite> <label class=tl-label> Type de pénalité </label> <select ng-model=penalite.typePenalite tl-lov-options=typesPenalite tl-null-option=\"Non précisée\"></select> </div> <div ng-if=\"penalite.typePenalite == 'FORFAITAIRE' \"> <div class=tl-field tl-validated-field={{penaliteFieldPrefix}}.penaliteForfaitaire.penaliteNbMoisInteret> <label class=tl-label> Nombre de mois d'intérets </label> <input input-type-number number-integer ng-model=penalite.penaliteForfaitaire.penaliteNbMoisInteret> </div> <div class=tl-field tl-validated-field={{penaliteFieldPrefix}}.penaliteForfaitaire.penalitePourcentageCrd> <label class=tl-label> Pourcentage du montant remboursé </label> <tl-percent-input ng-model=penalite.penaliteForfaitaire.penalitePourcentageCrd></tl-percent-input> </div> <div class=tl-field tl-validated-field={{penaliteFieldPrefix}}.penaliteForfaitaire.montantForfaitaire> <label class=tl-label> Montant forfaitaire </label> <tl-currency-input ng-model=penalite.penaliteForfaitaire.montantForfaitaire currency={{getProductCurrency()}}></tl-currency-input> </div> </div> <div ng-if=\"penalite.typePenalite == 'DEGRESSIVE' \"> <div class=tl-field tl-validated-field={{penaliteFieldPrefix}}.penaliteDegressive.typePenaliteDegressive> <label class=tl-label> Formule de calcul </label> <select ng-model=penalite.penaliteDegressive.typePenaliteDegressive tl-lov-options=typesPenaliteDegressive></select> </div> <div class=tl-field tl-validated-field={{penaliteFieldPrefix}}.penaliteDegressive.tauxIndemniteDegressive> <label class=tl-label> Taux de l'indemnité dégressive </label> <tl-percent-input ng-model=penalite.penaliteDegressive.tauxIndemniteDegressive></tl-percent-input> </div> </div> <div ng-if=\"penalite.typePenalite == 'ACTUARIELLE'\"> <div tl-tooltip class=tl-field tl-validated-field={{penaliteFieldPrefix}}.penaliteActuarielle.typePenaliteActuarielle> <label class=tl-label> Formule de calcul </label> <select ng-model=penalite.penaliteActuarielle.typePenaliteActuarielle tl-lov-options=typesPenaliteActuarielle tl-null-option=\"Par défaut\"> </select> <tl-tooltip-content> <ul> <li>Semi-actuarielle : IRA = variation TEC10 * durée restante * CRD / 24 ou 12(infine) (uniquement proposé par le Crédit Agricole) </li> <li>Différentiel de CRD : IRA = (Amortissement + intérêt) actualisé - CRD</li> <li>Marché : IRA = Valeur de marché (flux actualisés - flux sans actualisation), cest la valeur par défaut </li> </ul> </tl-tooltip-content> </div> <div ng-if=\"penalite.penaliteActuarielle.typePenaliteActuarielle=='DIFFERENTIEL_CRD'\" class=tl-field tl-validated-field={{penaliteFieldPrefix}}.penaliteActuarielle.tauxPenaliteActuarielleIndex tl-tooltip> <label class=tl-label> Index de détermination du taux d'actualisation </label> <select ng-model=penalite.penaliteActuarielle.tauxActualisation tl-lov-options=tauxPenaliteActuarielleIndex></select> <tl-tooltip-content> OAT ou CMS de maturité = DVM de l'emprunt à date de RA </tl-tooltip-content> </div> <div class=tl-field tl-validated-field={{penaliteFieldPrefix}}.penaliteActuarielle.montantForfaitaire tl-tooltip> <label class=tl-label> Montant forfaitaire </label> <tl-currency-input ng-model=penalite.penaliteActuarielle.montantForfaitaire currency={{getProductCurrency()}}></tl-currency-input> <tl-tooltip-content> Montant forfaitaire ajouté dans tous les cas à la pénalité </tl-tooltip-content> </div> <div class=tl-field tl-validated-field={{penaliteFieldPrefix}}.penaliteActuarielle.penaliteNbMoisInteret tl-tooltip> <label class=tl-label> Nombre de mois d'intérets </label> <input input-type-number number-integer ng-model=penalite.penaliteActuarielle.penaliteNbMoisInteret> <tl-tooltip-content> Montant forfaitaire ajouté dans tous les cas à la pénalité </tl-tooltip-content> </div> <div class=tl-field tl-validated-field={{penaliteFieldPrefix}}.penaliteActuarielle.penaliteToujoursPayee> <tl-checkbox ng-model=penalite.penaliteActuarielle.penaliteToujoursPayee> Pénalité versée même si en faveur de l'emprunteur </tl-checkbox> </div> </div> </div> </div> <div class=footer> <tl-button type=submit class=btn-primary> {{'common.Enregistrer' | translate}} </tl-button> <tl-button type=button class=btn-warning ng-click=$dismiss()> {{'common.Annuler' | translate}} </tl-button> </div> </form> </div>";

/***/ }),
/* 3698 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box df-offre-edition-popin\"> <form class=popin-form tl-validated-form=offreFormConfig> <div class=title ng-switch=edit> <h3 ng-switch-when=true>Edition d'une offre de ligne de trésorerie</h3> <h3 ng-switch-when=false>Création d'une offre de ligne de trésorerie<span ng-if=copieId> (duplication)</span></h3> </div> <div class=content> <div class=tl-field tl-validated-field=offre.banqueId> <label class=tl-label>Banque</label> <tl-select ng-model=offre.banqueId base-config-name=banque options=contreparties></tl-select> </div> <tl-field class=search-area> <label class=tl-label>Client (compte)</label> <tl-search-field config=searchConfig></tl-search-field> </tl-field> <div class=tl-field tl-validated-field=offre.dateOffre> <label class=tl-label>Date de l'offre</label> <tl-date-input ng-model=offre.dateOffre></tl-date-input> </div> <tl-field tl-validated-field=offre.montant> <label class=tl-label>Montant</label> <input type=text input-type-number ng-model=offre.montant max-decimals=2> </tl-field> <tl-field tl-validated-field=offre.frais> <label class=tl-label>Frais (en % du CRD)</label> <input type=text input-type-number ng-model=offre.frais max-decimals=3> </tl-field> <div class=tl-field> <label class=tl-label>Commentaire</label> <textarea ng-model=offre.commentaire></textarea> </div> <div class=tl-field> <tl-checkbox ng-model=offre.visibleClient><span>Visible aux clients</span></tl-checkbox> </div> <h3>Indexation</h3> <div class=tl-field> <label class=tl-label>Type d'indexation</label> <select ng-model=offre.indexation.typeModaliteIndexation tl-lov-options=typesModaliteIndexation></select> </div> <div ng-switch=offre.indexation.typeModaliteIndexation> <div ng-switch-when=FIXE> <div class=tl-field> <label class=tl-label> Taux </label> <tl-percent-input ng-model=offre.indexation.tauxFixe max-decimals=5></tl-percent-input> </div> </div> <div ng-switch-when=VARIABLE> <div> <label class=tl-label>Indexation</label> <div class=taux-variable-line> <select ng-model=offre.indexation.index ng-options=\"index.id as index.label group by index.groupe for index in indices\"></select> <span>+</span> <tl-percent-input ng-model=offre.indexation.marge allow-negative max-decimals=5></tl-percent-input> </div> <div class=\"tl-field tl-field-inline phase-taux-line\" ng-class=\"{ 'tl-off' : !tauxMax.checked }\"> <label class=tl-label></label> <tl-checkbox ng-model=tauxMax.checked> <span>Taux max</span> </tl-checkbox> <tl-percent-input class=taux ng-model=tauxMax.value max-decimals=5 allow-negative ng-disabled=!tauxMax.checked></tl-percent-input> </div> <div class=\"tl-field tl-field-inline phase-taux-line\" ng-class=\"{ 'tl-off' : !tauxMin.checked }\"> <label class=tl-label></label> <tl-checkbox ng-model=tauxMin.checked> <span>Taux min</span> </tl-checkbox> <tl-percent-input class=taux ng-model=tauxMin.value max-decimals=5 allow-negative ng-disabled=!tauxMin.checked></tl-percent-input> </div> </div> </div> </div> <h3>CNU</h3> <div class=tl-field tl-validated-field=offre.typeModaliteIndexationCNU> <label class=tl-label>Type d'indexation de la CNU</label> <select ng-model=offre.indexationCNU.typeModaliteIndexation tl-lov-options=typesModaliteIndexation tl-null-option=\"Aucune ou autre\"></select> </div> <div ng-switch=offre.indexationCNU.typeModaliteIndexation class=clearfix> <div ng-switch-when=FIXE> <div class=tl-field tl-validated-field=offre.indexationCNU.tauxFixe> <label class=tl-label> Taux </label> <tl-percent-input ng-model=offre.indexationCNU.tauxFixe max-decimals=5></tl-percent-input> </div> </div> <div ng-switch-when=VARIABLE> <div class=indexation-labels> <label class=left>Index</label> <label class=right>Marge</label> </div> <div class=indexation-inputs tl-validated-field=offre.indexationCNU.indexationInputs> <div class=float-l tl-validated-field=offre.indexationCNU.index> <select ng-model=offre.indexationCNU.index ng-options=\"index.id as index.label group by index.groupe for index in indices\"></select> <span>+</span> </div> <div class=float-r tl-validated-field=offre.indexationCNU.marge> <tl-percent-input ng-model=offre.indexationCNU.marge allow-negative max-decimals=5></tl-percent-input> </div> </div> </div> </div> <div class=tl-field tl-validated-field=offre.commentaireCNU> <label class=tl-label>Commentaire sur la CNU</label> <textarea ng-model=offre.commentaireCNU></textarea> </div> </div> <div class=footer> <tl-button type=submit class=btn-primary> {{'common.Enregistrer' | translate}} </tl-button> <tl-button type=button class=btn-warning ng-click=$dismiss()> {{'common.Annuler' | translate}} </tl-button> </div> </form> </div>";

/***/ }),
/* 3699 */
/***/ (function(module, exports) {

module.exports = "<tl-panel-layout> <tl-panel-left> <div class=tl-legend> {{'marche.history.courbesTaux.filters.DateDesCourbes'|translate}} </div> <tl-field> <tl-checkbox ng-model=params.datesCustom> <span>{{'marche.history.courbesTaux.filters.DatesPersonnalisees'|translate}}</span> </tl-checkbox> </tl-field> <tl-field ng-show=\"params.courbeId == 'EUR' && params.datesCustom!==true\"> <tl-checkbox ng-model=params.avecCourbeOAT> <span>{{'marche.history.courbesTaux.filters.AfficherLaDerniereCourbeDesTauxOAT'|translate}}</span> </tl-checkbox> </tl-field> <div ng-show=\"params.datesCustom===true\"> <tl-field> <label class=tl-label>{{'marche.history.courbesTaux.filters.Courbe'|translate}} 1</label> <tl-date-input ng-model=params.date1></tl-date-input> </tl-field> <tl-field ng-show=\"params.courbeId == 'EUR'\"> <tl-checkbox ng-model=params.avecCourbeOAT> <span>{{'marche.history.courbesTaux.filters.AfficherLaCourbeDesTauxOATACetteDate'|translate}}</span> </tl-checkbox> </tl-field> <tl-field> <tl-checkbox ng-model=params.date2Active> {{'marche.history.courbesTaux.filters.Courbe'|translate}} 2 </tl-checkbox> <tl-date-input ng-model=params.date2 ng-if=params.date2Active></tl-date-input> </tl-field> <tl-field> <tl-checkbox ng-model=params.date3Active>{{'marche.history.courbesTaux.filters.Courbe'|translate}} 3 </tl-checkbox> <tl-date-input ng-model=params.date3 ng-if=params.date3Active></tl-date-input> </tl-field> </div> </tl-panel-left> <tl-panel-right> <div class=section autosizing-container sizable-container> <div class=box-layout sizable-container as-line-container> <div class=box-60 sizable-container> <h3 fixed-component> <span>{{'marche.history.courbesTaux.CourbeDesTaux'|translate}}</span> <select class=tl-dropdown-select ng-model=params.courbeId ng-options=\"c.id as c.label group by c.groupe for c in courbes\"></select> </h3> <tl-loader-overlay ng-if=loader></tl-loader-overlay> <tl-chart chart-config=chartConfigCourbeTaux sizeable-component></tl-chart> </div> <div class=box-40 style=margin-top:3.2em sizable-container> <tl-loader-overlay ng-if=loader></tl-loader-overlay> <div class=table-actions> <a class=excel-download ng-click=exportXls()> <i class=\"ft ft-excel\"></i> <span>{{'common.Telecharger' | translate}}</span> </a> </div> <tl-table table-config=indexCourbeTauxTableConfig sizeable-component></tl-table> </div> </div> </div> </tl-panel-right> </tl-panel-layout>";

/***/ }),
/* 3700 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box mkt-dashboard-create-favorite-popin\"> <div class=title> <h3>Création d'une indexation favorite</h3> </div> <div class=content> <div class=popin-form> <div class=error-message ng-show=\"$ctrl.error != null\"> <span>{{$ctrl.error}}</span> </div> <tl-field> <label class=tl-label>Type</label> <tl-radio-group class=\"tl-inline-group reference-type\" ng-model=$ctrl.reference.type> <tl-radio-button value=INDEX>Index</tl-radio-button> <tl-radio-button value=CUSTOM_INDEXATION>Mes indexations</tl-radio-button> </tl-radio-group> </tl-field> <div ng-switch=$ctrl.reference.type> <div ng-switch-when=INDEX> <tl-field> <label class=tl-label>Indice</label> <select ng-model=$ctrl.reference.indexId ng-options=\"index.id as index.label group by index.groupe for index in $ctrl.indices\"></select> </tl-field> </div> <div ng-switch-when=CUSTOM_INDEXATION> <tl-field> <label class=tl-label>Indexation</label> <select ng-model=$ctrl.reference.indexationId ng-options=\"i.id as i.name for i in $ctrl.indexations\"></select> </tl-field> </div> </div> </div> </div> <div class=footer> <tl-button type=submit class=btn-primary ng-click=$ctrl.saveFavorite()> {{'common.Enregistrer' | translate}} </tl-button> <tl-button type=button class=btn-warning ng-click=$dismiss()> {{'common.Annuler' | translate}} </tl-button> </div> </div>";

/***/ }),
/* 3701 */
/***/ (function(module, exports) {

module.exports = "<div class=mkt-dashboard-page> <div class=box-layout> <div class=box-60> <div class=tl-content-box> <div class=tl-box-header> <h3 class=small>{{'marche.dashboard.courbeDesTaux'|translate}} {{$ctrl.state.currency}}</h3> </div> <div class=tl-box-content> <mkt-dashboard-courbe-taux-chart currency=$ctrl.state.currency></mkt-dashboard-courbe-taux-chart> </div> </div> </div> <div class=box-40> <h3>{{'marche.dashboard.TauxFixeDeMarche'|translate}}</h3> <i class=\"fa fa-info-circle ml-xs icon-b\" no-print style=cursor:help tl-tooltip=\"{{'marche.dashboard.TauxFixeDeMarche.tooltip'|translate}}\"></i> <mkt-dashboard-taux-fixe-table></mkt-dashboard-taux-fixe-table> </div> </div> <div class=index-section> <h3>{{'marche.dashboard.LesIndicesDeMonPortefeuille'|translate}}</h3> <div class=mkt-index-summary-list> <mkt-dashboard-index-summary ng-repeat=\"index in $ctrl.detteIndexes\" index=index editing=false> </mkt-dashboard-index-summary> </div> </div> <div class=index-section> <h3>{{'marche.dashboard.MesIndexationsFavorites'|translate}}</h3> <tl-icon-button class=\"fav-edit-btn no-print\" icon=\"{{$ctrl.state.favEdition ? 'fa-check' : 'fa-gears'}}\" title=\"{{'marche.dashboard.GestionDesFavoris'|translate}}\" ng-click=$ctrl.toggleFavEdition()></tl-icon-button> <p class=no-data-placeholder ng-if=\"$ctrl.favoriteIndexations.length === 0 && !$ctrl.state.favEdition\"> {{'marche.dashboard.AucunFavori'|translate}} </p> <div class=mkt-index-summary-list> <mkt-dashboard-index-summary ng-repeat=\"index in $ctrl.favoriteIndexations track by index.favoriteId\" index=index editing=$ctrl.state.favEdition on-delete=$ctrl.deleteFavorite on-move=$ctrl.moveFavorite> </mkt-dashboard-index-summary> <mkt-dashboard-index-add-btn ng-if=$ctrl.state.favEdition click-handler=$ctrl.createFavorite></mkt-dashboard-index-add-btn> </div> </div> </div> ";

/***/ }),
/* 3702 */
/***/ (function(module, exports) {

module.exports = "<div class=\"mkt-dashboard-index-summary mkt-dashboard-index-add-btn no-print\" ng-click=$ctrl.onClick() title=\"{{'marche.dashboard.favori.AjouterUnFavori'|translate}}\"> <div class=inner> <i class=\"fa fa-plus-circle\"></i> </div> </div>";

/***/ }),
/* 3703 */
/***/ (function(module, exports) {

module.exports = "<div class=mkt-dashboard-index-summary> <div class=editing-overlay ng-if=editing> <tl-icon-button class=\"action delete-action\" icon=delete tl-tooltip=\"{{'marche.dashboard.favori.Supprimer.tooltip'|translate}}\" ng-click=onDelete(index.favoriteId)></tl-icon-button> <tl-icon-button class=\"action move-left-action\" icon=fa-chevron-left tl-tooltip=\"{{'marche.dashboard.favori.DeplacerAGauche.tooltip'|translate}}\" ng-click=\"onMove(index.favoriteId, true)\"></tl-icon-button> <tl-icon-button class=\"action move-right-action\" icon=fa-chevron-right tl-tooltip=\"{{'marche.dashboard.favori.DeplacerADroite.tooltip'|translate}}\" ng-click=\"onMove(index.favoriteId, false)\"></tl-icon-button> </div> <div class=content> <div class=header> <div class=left> <span class=label>{{$ctrl.state.referenceLabel}}</span> <span class=weight ng-if=$ctrl.index.inDette> {{'marche.dashboard.favori.PoidsDansMaDette'|translate}} : {{$ctrl.index.poids | percentage}} </span> </div> <div class=right> <span class=value>{{$ctrl.state.value}}</span> </div> </div> <div class=variations> <div class=values> <div> <mkt-up-down-caret down=\"$ctrl.state.var1M < 0\"></mkt-up-down-caret> <span class=value>{{$ctrl.state.var1M | number:2}} %</span> </div> <div> <mkt-up-down-caret down=\"$ctrl.state.var3M < 0\"></mkt-up-down-caret> <span class=value>{{$ctrl.state.var3M | number:2}} %</span> </div> <div> <mkt-up-down-caret down=\"$ctrl.state.var1Y < 0\"></mkt-up-down-caret> <span class=value>{{$ctrl.state.var1Y | number:2}} %</span> </div> </div> <div class=labels> <div> <span>{{'marche.dashboard.favori.1M'|translate}}</span> </div> <div> <span>{{'marche.dashboard.favori.3M'|translate}}</span> </div> <div> <span>{{'marche.dashboard.favori.1A'|translate}}</span> </div> </div> </div> <div class=history> <tl-chart class=no-border chart-config=$ctrl.state.chartConfig></tl-chart> </div> </div> </div>";

/***/ }),
/* 3704 */
/***/ (function(module, exports) {

module.exports = "<div class=mkt-dashboard-taux-fixe-table> <tl-loader-overlay ng-if=\"$ctrl.loading==true\"></tl-loader-overlay> <table class=tl-simple-table> <thead> <th></th> <th>{{'marche.dashboard.tauxFixe.Taux'|translate}}</th> <th>{{'marche.dashboard.tauxFixe.Evolution1Mois'|translate}}</th> <th>{{'marche.dashboard.tauxFixe.Evolution1An'|translate}}</th> </thead> <tbody> <tr ng-repeat=\"row in $ctrl.tableData\"> <td class=align-c> <span>{{row.nbAnnee}} {{'marche.dashboard.tauxFixe.ans'|translate}}</span> </td> <td class=align-c> <span>{{row.taux | taux:2}}</span> </td> <td class=align-c> <mkt-up-down-caret down=\"row.variationTaux1M.valeur < 0\"></mkt-up-down-caret> <span>{{row.variationTaux1M | taux:2:true}}</span> </td> <td class=align-c> <mkt-up-down-caret down=\"row.variationTaux1Y.valeur < 0\"></mkt-up-down-caret> <span>{{row.variationTaux1Y | taux:2:true}}</span> </td> </tr> </tbody> </table> <select ng-model=$ctrl.state.periodicite ng-change=$ctrl.onChange() ng-options=\"i.id as i.name for i in $ctrl.periodicites\"></select> - {{'marche.dashboard.tauxFixe.base30360'|translate}} - <select ng-model=$ctrl.state.typeAmortissement ng-options=\"i.id as i.name for i in $ctrl.typeAmortissements\" ng-change=$ctrl.onChange()></select> </div> ";

/***/ }),
/* 3705 */
/***/ (function(module, exports) {

module.exports = "<tl-panel-layout panel-opened class=mkt-history-page> <tl-panel-left> <div> <div class=tl-legend> {{\"marche.history.filtres.Graphique\"|translate}} </div> <tl-field class=mkt-indexation-field ng-repeat=\"reference in $ctrl.formData.references\"> <label class=tl-label> {{\"marche.history.filtres.CourbeNumero\"|translate}}{{$index+1}} </label> <tl-icon-button class=delete-btn icon=delete ng-if=\"$ctrl.formData.references.length > 1\" tl-tooltip=\"{{'marche.history.filtres.SupprimerCetteCourbe'|translate}}\" ng-click=$ctrl.removeReference($index)></tl-icon-button> <mkt-indexation-selector indexation-ref=reference allow-creation=true on-create=refreshIndexationList()> </mkt-indexation-selector> </tl-field> <tl-field ng-show=\"$ctrl.formData.references.length === 2\"> <tl-checkbox ng-model=$ctrl.formData.spread> <span>Spread</span> </tl-checkbox> </tl-field> <div class=\"page-actions mb-s\" ng-show=\"$ctrl.formData.references.length < 8\"> <a class=tl-link ng-click=$ctrl.addReference()> <i class=\"fa fa-plus\"></i> <span>{{\"marche.history.filtres.AjouterUneCourbe\"|translate}}</span> </a> </div> </div> <div if-not-placement> <div class=tl-legend> Calendriers </div> <tl-field ng-show=\"$ctrl.validReferences.length > 1\"> <label class=tl-label> {{\"marche.history.filtres.DonneesAffichees\"|translate}} </label> <select ng-model=$ctrl.formData.calendarRef ng-options=\"c.reference as c.label for c in $ctrl.calendarRefOptions\"></select> </tl-field> <tl-field> <label class=tl-label> {{\"marche.history.filtres.MoisDuCalendrier\"|translate}} </label> <tl-month-picker ng-model=$ctrl.formData.calendarDate></tl-month-picker> </tl-field> </div> <div if-not-placement> <div class=tl-legend> {{\"marche.history.filtres.Options\"|translate}} </div> <div class=\"page-actions mb-s\"> <a class=tl-link ng-click=$ctrl.toggleFullPageChart()> <i class=\"fa fa-arrows-v\"></i> <span ng-switch=$ctrl.formData.fullScreenChart> <span ng-switch-when=true> {{\"marche.history.filtres.AfficherLesCalendriers\"|translate}} </span> <span ng-switch-when=false> {{\"marche.history.filtres.GraphiquePleinEcran\"|translate}} </span> </span> </a> </div> <div class=page-actions> <a class=tl-link ng-click=$ctrl.toggleForward()> <i class=\"fa fa-forward\"></i> <span ng-switch=$ctrl.formData.forward> <span ng-switch-when=true> {{\"marche.history.filtres.CacherLesAnticipes\"|translate}} </span> <span ng-switch-when=false> {{\"marche.history.filtres.AfficherLesAnticipes\"|translate}} </span> </span> </a> <tl-field ng-show=$ctrl.formData.forward class=mt-s> <label> {{\"marche.history.filtres.NombreAnneesAnticipes\"|translate}} </label> <select ng-model=$ctrl.formData.forwardNbAnnees ng-options=\"a as a for a in $ctrl.forwardNbAnneesList\"></select> </tl-field> </div> </div> </tl-panel-left> <tl-panel-right> <div autosizing-container sizable-container> <div class=table-actions fixed-component> <a class=excel-download ng-click=$ctrl.openHistoryExportPopin()> <i class=\"ft ft-excel\"></i> <span>{{\"marche.history.filtres.ExporterLesDonnees\"|translate}}</span> </a> </div> <mkt-history-chart references=$ctrl.validReferences forward=$ctrl.formData.forward forward-nb-annees=$ctrl.formData.forwardNbAnnees spread=$ctrl.formData.spread on-point-click=$ctrl.onChartPointClick on-set-extremes=$ctrl.onChartSetExtremes></mkt-history-chart> <div ng-show=!$ctrl.formData.fullScreenChart> <mkt-history-calendar-carousel fixed-component calendar-date=$ctrl.formData.calendarDate indexation-ref=$ctrl.formData.calendarRef> </mkt-history-calendar-carousel> </div> </div> </tl-panel-right> </tl-panel-layout> ";

/***/ }),
/* 3706 */
/***/ (function(module, exports) {

module.exports = "<div class=mkt-fixing-calendar> <tl-loader-overlay ng-if=calendarCtrl.isLoading></tl-loader-overlay> <h3> {{calendarConfig.date | dateCustom:'MMMM YYYY'}} </h3> <tl-calendar calendar-config=calendarConfig> <tl-calendar-cell-template> <mkt-calendar-cell-template></mkt-calendar-cell-template> </tl-calendar-cell-template> </tl-calendar> </div>";

/***/ }),
/* 3707 */
/***/ (function(module, exports) {

module.exports = "<div class=mkt-history-calendar-carousel> <div class=\"mkt-carousel-btn previous-btn\" ng-click=carouselCtrl.showPrevious()> <i class=\"fa fa-chevron-left\"></i> </div> <div class=mkt-calendars-container> <div ng-repeat=\"month in carouselCtrl.months track by carouselCtrl.monthTrackKey(month)\" class=mkt-cal-container> <mkt-history-calendar reference=indexationRef date=month></mkt-history-calendar> </div> </div> <div class=\"mkt-carousel-btn next-btn\" ng-click=carouselCtrl.showNext()> <i class=\"fa fa-chevron-right\"></i> </div> </div> ";

/***/ }),
/* 3708 */
/***/ (function(module, exports) {

module.exports = "<div class=mkt-history-chart> <tl-loader-overlay ng-if=$ctrl.loading></tl-loader-overlay> <tl-chart chart-config=$ctrl.chartConfig sizeable-component></tl-chart> </div>";

/***/ }),
/* 3709 */
/***/ (function(module, exports) {

module.exports = "<div class=confirm-box> <div class=title> <h3>{{\"marche.history.export.ExporterLesDonneesDeMarcheDe\"|translate}} : <span>{{fullReferenceLabel}}</span></h3> </div> <form ng-submit=performExport()> <div class=content ng-switch=\"html != null\"> <div class=mb-s> <p>{{\"marche.history.export.VeuillezSelectionnerLaPlageDeDateSouhaitee\"|translate}}.</p> <p class=\"i small\">{{\"marche.history.export.VeuillezSelectionnerLaPlageDeDateSouhaitee2\"|translate}}</p> </div> <div class=popin-form> <tl-field> <label class=tl-label> {{\"marche.history.export.DateDeDebut\"|translate}} </label> <tl-date-input ng-model=exportParams.dateDebut></tl-date-input> </tl-field> <tl-field> <label class=tl-label> {{\"marche.history.export.DateDeFin\"|translate}} </label> <tl-date-input ng-model=exportParams.dateFin></tl-date-input> </tl-field> </div> </div> <div class=footer> <tl-button type=submit class=btn-primary> {{\"marche.history.export.Exporter\"|translate}} </tl-button> <tl-button type=button class=btn-warning ng-click=$dismiss()> {{\"marche.history.export.Annuler\"|translate}} </tl-button> </div> </form> </div> ";

/***/ }),
/* 3710 */
/***/ (function(module, exports) {

module.exports = "<div> <tl-panel-layout class=pricer-option panel-opened> <tl-panel-left> <div>Date de marché : <input input-type-date ng-model=params.dateMarche tl-datepicker> </div> <div>Index : <select ng-model=params.index ng-options=\"index.id as index.label for index in indices\"></select> </div> <div class=tl-field> <label class=tl-label> <span>Type de volatilité</span> </label> <select ng-model=params.typeVol ng-options=\"t.id as t.label for t in typeVolatilites\"></select> </div> </tl-panel-left> <tl-panel-right> <tl-loader-overlay ng-if=loading></tl-loader-overlay> <h4>Données de marché de construction de la courbe des taux ICE {{params.index}}</h4> <tl-table table-config=ycDataTableConfig></tl-table> <h4>Données de marché matrice de vol ICE - {{params.typeVol}} (date de valeur : {{matrice.dateValeur | dateShort}})</h4> <tl-table table-config=volTableConfig></tl-table> <h4>Courbes des taux EUR (ICE {{params.index}} / Taelys)</h4> <tl-chart chart-config=courbesTauxChartConfig></tl-chart> <h4>Courbes des anticipés de taux EUR (ICE {{params.index}} / Taelys)</h4> <tl-chart chart-config=courbesAnticipesChartConfig></tl-chart> </tl-panel-right> </tl-panel-layout> </div>";

/***/ }),
/* 3711 */
/***/ (function(module, exports) {

module.exports = "<div autosizing-container class=\"section mk-indexation\" sizable-container> <tl-table table-config=indexationTableConfig sizeable-component></tl-table> <div class=mt-s fixed-component> <tl-button class=btn-primary ng-click=createNewIndexation()> <i class=\"fa fa-plus\"></i> <span>{{\"marche.history.indexations.NouvelleIndexation\"|translate}}</span> </tl-button> </div> </div>";

/***/ }),
/* 3712 */
/***/ (function(module, exports) {

module.exports = "<div> <tl-tabset-page config=indexationsTabConfig></tl-tabset-page> </div>";

/***/ }),
/* 3713 */
/***/ (function(module, exports) {

module.exports = "<div class=confirm-box> <div class=title> <h3> Comment intégrer vos fichiers xml dans TotEM ? </h3> </div> <div class=content> <table style=width:1000px class=tl-simple-table> <tr> <td>Dans votre application TotEM, double-cliquez sur la ligne de votre budget. </td> <td><img src=/images/totem/image1.png></td> </tr> <tr> <td>Chaque fichier doit être importé dans la bonne Annexe (sections à gauche) : <ul> <li>- etats_dematerialises_emprunts_ .xml : dans la section <span class=b>'Emprunts'</span> </li> <li>- etats_dematerialises_garanties_ .xml : également dans la section <span class=b>'Emprunts'</span> </li> <li>- etats_dematerialises_tresoreries_ .xml : dans la section <span class=b>'Crédits de trésorerie'</span> </li> <li>- etats_dematerialises_dettes_ .xml : dans la section <span class=b>'Dettes'</span></li> <li>- etats_dematerialises_organismes_engagement_financier_ .xml : dans la section <span class=b>'Organismes dans lesquels la collectivité a pris un engagement financier'</span> </li> </ul> <br/> Choisissez la section à gauche en cliquant dessus et vérifiez grâce au nom situé au dessus du tableau à droite que vous êtes dans l'annexe souhaitée. <br/> <br/> A droite cliquez sur l'icône qui représente des outils et choisissez <span class=b>'Importer une annexe'</span>. </td> <td><img src=/images/totem/image2.png></td> </tr> <tr> <td>Assurez vous que le Type de fichier est bien sur XML et cliquez sur le bouton '...' pour choisir le fichier à importer (par défaut les fichiers .xml sont généralement situés dans votre répertoire 'Télécharger'). <br/><br/> Une fois l'import réalisé : <ul> <li> - si vous avez un message : 'Aucune ligne d'annexe à importer', vérifiez bien que vous avez choisi le fichier correspondant bien à l'annexe dans laquelle vous êtes situé. </li> <li> - si vous avez un message vous indiquant une erreur, merci de faire une copie écran et de nous l'envoyer avec le fichier xml utilisé pour que nous puissions identifier le problème. </li> </ul> </td> <td><img src=/images/totem/image3.png></td> </tr> </table> </div> <div class=footer> <tl-button class=btn-primary ng-click=$dismiss()> {{'common.dialog.close' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3714 */
/***/ (function(module, exports) {

module.exports = "<div class=user-task-list-popin> <div class=\"align-r mb-xs\" ng-if=\"$ctrl.tasks.length !== 0\"> <tl-button class=btn-primary ng-click=$ctrl.deleteAllTasks()> <span>Tout supprimer</span> <i class=\"icon icon-delete\"></i> </tl-button> </div> <div ng-if=\"$ctrl.tasks == null || $ctrl.tasks.length === 0\"> Aucune tâche à afficher. </div> <user-task-list-table ng-if=\"$ctrl.tasks.length > 0\"> </user-task-list-table> </div> ";

/***/ }),
/* 3715 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box ticket-edition\"> <form class=popin-form> <div class=title ng-switch=edit> <h3>Annuler la demande de réouverture du ticket</h3> </div> <div class=content> <tl-field> <label class=\"tl-label large\">Message</label> <textarea class=text-area-box cols=50 ng-model=params.message placeholder=\"Ajouter un message expliquant la raison de cette annulation.\" rows=10 tl-focus-init>\n                </textarea> </tl-field> </div> <div class=footer> <tl-button class=btn-primary ng-click=annuler() ng-disabled=\"!params.message || loading\" type=submit> <tl-circular-loader class=xs ng-if=loading></tl-circular-loader> Annuler la demande de réouverture </tl-button> <tl-button class=btn-warning ng-click=$dismiss() type=button> {{'common.Annuler' | translate}} </tl-button> </div> </form> </div>";

/***/ }),
/* 3716 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box sp-popin sy-prospect-selection\"> <div class=title> <h3>Choix ticket</h3> </div> <div class=content> <div class=prospect-choix ng-if=ticket>Choisi : {{ticket.titre}}</div> <tl-table table-config=ticketsTableConfig></tl-table> <div class=mt-s ng-if=loading> <tl-circular-loader class=small></tl-circular-loader> <span>{{'common.Chargement'|translate}}</span> </div> <div class=mb-s ng-if=\"tickets!=null && !tickets.length\"> Aucun ticket. </div> </div> <div class=footer> <tl-button class=btn-primary ng-click=saveAndClose()> {{'common.Enregistrer' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss()> {{'common.dialog.cancel' | translate}} </tl-button> </div> </div>";

/***/ }),
/* 3717 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box ticket-edition\"> <form class=popin-form> <div class=title ng-switch=edit> <h3>Demande de réouverture du ticket</h3> </div> <div class=content> <div> <p class=b>Vous considérez que la clôture de ce ticket a été prématurée car la demande n'est pas totalement réalisée.</p> </div> <tl-field> <label class=\"tl-label large\">Motif de la demande de réouverture</label> <textarea class=text-area-box cols=50 ng-model=params.message placeholder=\"Merci d'expliciter la raison de la demande de réouverture en indiquant ce qu'il manque pour que la demande soit réalisée suivant votre attente.\" rows=10 tl-focus-init>\n                </textarea> </tl-field> <div class=mt-xs> <i class=\"fa icon-tooltip-info\"></i> Si il s'agit d'une nouvelle demande, merci de créer un nouveau ticket. </div> </div> <div class=footer> <tl-button class=btn-primary ng-click=reouvrir() ng-disabled=\"!params.message || loading\" type=submit> <tl-circular-loader class=xs ng-if=loading></tl-circular-loader> Demande de réouverture </tl-button> <tl-button class=btn-warning ng-click=$dismiss() type=button> {{'common.Annuler' | translate}} </tl-button> </div> </form> </div>";

/***/ }),
/* 3718 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box page-echange ticket-edition\"> <form class=popin-form tl-validated-form=ticketFormConfig> <div class=title ng-switch=edit> <h3 ng-switch-when=true>Modifier votre demande</h3> <h3 ng-switch-when=false>Création d'une demande (assistance, évolution, ...)</h3> </div> <div class=content> <tl-field tl-validated-field=ticket.demande> <label>Votre demande</label> <textarea class=text-area-box ng-model=ticket.demande cols=90 rows=20 tl-focus-init></textarea> </tl-field> <tl-field tl-validated-field=ticket.titre> <label>Titre (optionnel)</label> <input ng-model=ticket.titre style=width:100% type=text> </tl-field> <tl-field tl-validated-field=ticket.watcherIds ng-show=\"(ticket.watcherIds.length>0 || watcherList().length>0)\"> <label class=tl-label style=width:90%>Personnes que vous souhaitez voir notifiées par email des évolutions du ticket, en plus du demandeur</label> <div> <span ng-repeat=\"watcherId in ticket.watcherIds\"> <span class=mr-m>{{renderUser(watcherId)}} <tl-icon-button icon=fa-minus-circle title=Retirer ng-click=removeWatcher(watcherId)></tl-icon-button> </span> </span> <span ng-if=\"watcherList().length>0\"> <select style=font-size:.9em ng-model=params.newWatcherId ng-options=\"d.id as d.label for d in watcherList()\" ng-change=addWatcher() tl-null-option=\"[Ajouter des utilisateurs à notifier]\"></select> </span> </div> </tl-field> <div ng-if=!edit class=documents-drop-zone> <tl-file-drop-overlay ng-if=showDemandeFileDropOverlay()></tl-file-drop-overlay> <label ng-if=\"ticket.documentsIn && ticket.documentsIn.length === 0\">Aucun document.</label> <label ng-if=\"ticket.documentsIn && ticket.documentsIn.length > 0\">Documents</label> <br> <fileupload-btn btn-label-key=documents.NouveauDocument owner={{compteVisualiseId}} upload-success=onDocumentUpload options=uploadDocumentOptions> </fileupload-btn> <span class=\"i ml-s\">(Ou déplacez le fichier depuis votre ordinateur)</span> <tl-table ng-if=\"ticket.documentsIn && ticket.documentsIn.length > 0\" class=mt-s table-config=documentsTableConfig></tl-table> </div> </div> <div class=footer> <tl-circular-loader ng-if=submitting class=xs></tl-circular-loader> <tl-button class=btn-primary ng-disabled=submitting type=submit> {{'common.Enregistrer' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss() ng-disabled=submitting type=button> {{'common.Annuler' | translate}} </tl-button> </div> </form> </div>";

/***/ }),
/* 3719 */
/***/ (function(module, exports) {

module.exports = "<div class=confirm-box> <form class=popin-form> <div class=title ng-switch=edit> <h3>Déplacement du ticket vers un autre compte</h3> </div> <div class=content> <tl-field ng-if=\"comptesAccessibles && comptesAccessibles.length>1\"> <label>Compte associé</label> <select ng-model=params.compteCibleId ng-options=\"o.id as o.nomClient for o in comptesAccessibles\"></select> </tl-field> </div> <div class=footer> <tl-button class=btn-primary ng-click=deplacer() type=submit> {{'common.Enregistrer' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss() type=button> {{'common.Annuler' | translate}} </tl-button> </div> </form> </div>";

/***/ }),
/* 3720 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box ticket-edition\" xmlns=http://www.w3.org/1999/html> <form class=popin-form tl-validated-form=ticketFormConfig> <div class=title ng-switch=edit> <h3 ng-switch-when=true>Edition</h3> <h3 ng-switch-when=false>Création d'un ticket</h3> </div> <div class=content> <tl-field tl-validated-field=ticket.demandeurUtilisateurId> <label class=tl-label>Demandeur</label> <tl-select class=long empty-option-label=Aucun ng-model=ticket.demandeurUtilisateurId options=demandeurs></tl-select> <div class=i>Si un demandeur est indiqué, et que la demande est 'visible' il sera notifié des évolutions de statut par mail. </div> </tl-field> <tl-field tl-validated-field=ticket.watcherIds ng-show=\"ticket.demandeurUtilisateurId && (ticket.watcherIds.length>0 || watcherList().length>0)\"> <label class=tl-label>Personnes à notifier des évolutions du ticket en plus du demandeur</label> <span> <span ng-repeat=\"watcherId in ticket.watcherIds\"> <span class=mr-m>{{renderUser(watcherId)}} <tl-icon-button icon=fa-minus-circle title=Retirer ng-click=removeWatcher(watcherId)></tl-icon-button> </span> </span> <span ng-if=\"watcherList().length>0\"> <select style=font-size:.9em ng-model=params.newWatcherId ng-options=\"d.id as d.label for d in watcherList()\" ng-change=addWatcher() tl-null-option=\"[Ajouter des utilisateurs à notifier]\"></select> </span> </span> </tl-field> <tl-field tl-validated-field=ticket.typeTicket> <label class=tl-label>Type</label> <select ng-model=ticket.typeTicket tl-lov-options=typeTickets></select> </tl-field> <tl-field tl-validated-field=ticket.titre> <label>Titre</label> <input class=long ng-model=ticket.titre type=text> </tl-field> <tl-field tl-validated-field=ticket.subvention> <label> Module Subvention</label> <tl-checkbox ng-model=ticket.subvention></tl-checkbox> </tl-field> <tl-field tl-validated-field=ticket.dateDebutTicket> <label>Date création</label> <tl-date-input ng-model=ticket.dateDebutTicket></tl-date-input> </tl-field> <tl-field tl-validated-field=ticket.deadline> <label><span ng-if=\"ticket.typeTicket!=='VISITE'\">Deadline</span><span ng-if=\"ticket.typeTicket==='VISITE'\">Date prévue de la visite</span></label> <tl-date-input ng-model=ticket.deadline></tl-date-input> </tl-field> <tl-field tl-validated-field=ticket.idAttribution> <label class=tl-label>Traité par</label> <select ng-model=ticket.idAttribution tl-lov-options=users tl-null-option=Aucun></select> <tl-button class=btn-primary ng-click=traiteParMoi() type=button>Moi</tl-button> </tl-field> <tl-field tl-validated-field=ticket.visibleClient> <label> <tl-checkbox ng-model=ticket.visibleClient></tl-checkbox> Ticket visible par le client</label> </tl-field> <tl-field tl-validated-field=ticket.echanges> <div><label>Demande</label></div> <div ng-repeat=\"echange in ticket.echanges\"> <div ng-class=\"{'typeTicket-DEMANDE':echange.type=='DEMANDE','typeTicket-REPONSE':echange.type=='REPONSE'}\"> <div class=message ng-bind-html=echange.messageAffichage ng-if=!echange.edit> </div> <textarea class=\"text-area-box message\" cols=50 ng-if=echange.edit ng-model=echange.message placeholder=\"Saisissez {{(echange.type=='REPONSE') ? 'votre réponse' :'la demande ou information complémentaire du client'}}. Si ce champs reste vide, il ne sera pas enregistré dans le ticket.\" rows=10></textarea> <div class=detail> <span class=metadata> <span ng-if=\"$index==0 && echange.type=='DEMANDE'\">Demande initiale<span ng-if=echange.date> - Le {{echange.date | dateLong}} par {{echange.auteur}}</span></span> <span ng-if=\"$index!=0 && echange.type=='DEMANDE'\"> <span ng-if=!echange.demandeReouverture>Complément</span> <span ng-if=echange.demandeReouverture>Demande de réouverture</span> <span ng-if=echange.date>- Le {{echange.date | dateLong}} par {{echange.auteur}}</span></span> <span ng-if=\"echange.type=='REPONSE'\">Réponse <span ng-if=echange.date>- Le {{echange.date | dateLong}} par {{echange.auteur}}</span></span> </span> <i class=\"ml-xs fa fa-pencil action-icon icon\" ng-click=\"echange.edit=true\" ng-if=!echange.edit></i> </div> </div> </div> <div class=\"mt-xs mb-xs\"> <tl-button class=\"btn-warning mr-xs\" ng-click=ajouterReponse() type=button> <i class=\"fa fa-reply\"></i> Ajouter une réponse Taelys </tl-button> <tl-button class=\"btn-primary ml-s\" ng-click=ajouterDemande() type=button> <i class=\"fa fa-question-circle-o\"></i> Ajouter un complément d'information envoyé par le client </tl-button> </div> </tl-field> <tl-field class=mt-m tl-validated-field=ticket.statutTicket> <label>Statut</label> <select ng-model=ticket.statutTicket tl-lov-options=taskStatuts></select> </tl-field> <tl-field ng-if=\"ticket.statutTicket=='TERMINE' || ticket.statutTicket=='ANNULE'\" tl-validated-field=ticket.dateFinTicket> <label>Date de clôture <span ng-if=\"ticket.typeTicket==='VISITE'\">(date où a effectivement eu lieu la visite)</span></label> <tl-date-input ng-model=ticket.dateFinTicket></tl-date-input> <tl-button class=btn-primary ng-click=dateFinAujourdhui() type=button>auj. </tl-button> </tl-field> <tl-field ng-if=\"ticket.statutTicket=='TERMINE' && originalTicket.statutTicket=='TERMINE'\" tl-validated-field=ticket.demandeReouverture> <label> <tl-checkbox ng-model=ticket.demandeReouverture></tl-checkbox> Demande de réouverture par le client</label> </tl-field> <tl-field class=blue ng-if=\"genereraNotificationMail() && !ticket.envoieMailForce\" tl-validated-field=ticket.notificationClientChangementStatusOff> <label class=\"blue large notificationClient\"> <tl-checkbox ng-model=ticket.notificationClientChangementStatutOff></tl-checkbox> <span ng-if=\"edit==false\">Cocher cette case pour ne pas ne pas notifier par email le client de la création de ce ticket</span> <span ng-if=edit>Cocher cette case pour ne pas notifier par email le client de ce changement de statut</span> </label> </tl-field> <tl-field tl-validated-field=ticket.commentaireInterne> <label class=\"tl-label large\"><i class=\"fa fa-user-cowboy green\" tl-tooltip=\"Non visible par les clients\"></i> Commentaire interne (compte rendu de visite, infos divers sur l'action réalisée, ...)</label> <textarea class=\"text-area-box commentaireInterne\" cols=50 ng-model=ticket.commentaireInterne rows=10></textarea> </tl-field> </div> <div class=footer> <div class=\"float-l align-l\"> <tl-field class=\"display-ib mail-pill mr-s\" ng-if=\"ticket.demandeurUtilisateurId!=null && ticket.visibleClient\" tl-validated-field=ticket.envoieMailForce> <span><tl-checkbox ng-model=ticket.envoieMailForce></tl-checkbox> <span class=align-text-top>Forcer l'envoi d'un mail lié aux changements de ce ticket <i class=\"ml-xs icon-tooltip-info fa\" tl-tooltip=\"Par défaut, un mail n'est envoyé que si il demandeur est renseigné, que le ticket est visible par le client et que le statut a été modifié\"></i></span> </span> </tl-field> <tl-field class=\"display-ib mail-pill\" ng-if=\"(genereraNotificationMail() && !ticket.notificationClientChangementStatutOff) || ticket.envoieMailForce\" tl-validated-field=ticket.visibleClient> <span><tl-checkbox ng-model=ticket.ajoutSignature></tl-checkbox> <span class=align-text-top>Ajouter la signature au mail</span></span> </tl-field> </div> <tl-circular-loader ng-if=submitting class=xs></tl-circular-loader> <tl-button type=submit class=btn-primary ng-disabled=submitting> {{'common.Enregistrer' | translate}}<span ng-if=\"(genereraNotificationMail() && !ticket.notificationClientChangementStatutOff) || ticket.envoieMailForce\"> <i class=\"far fa-envelope\"></i> (avec envoi de mail)</span> <span ng-if=\"(!genereraNotificationMail() || ticket.notificationClientChangementStatutOff) && !ticket.envoieMailForce\">(sans envoi de mail)</span> </tl-button> <tl-button type=button class=btn-warning ng-click=$dismiss()> {{'common.Annuler' | translate}} </tl-button> </div> </form> </div> ";

/***/ }),
/* 3721 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box ticket-edition\"> <div class=popin-form> <div class=title> <h3>Nouveau message</h3> </div> <div class=content> <tl-field> <textarea class=text-area-box cols=90 ng-model=echange.message placeholder=\"Saississez votre message ici...\" rows=20 tl-focus-init></textarea> <div class=mt-xs><i class=\"fa icon-tooltip-info\"></i> Si il s'agit d'une nouvelle demande, merci de créer un nouveau ticket</div> </tl-field> </div> <div class=footer> <tl-circular-loader class=xs ng-if=submitting></tl-circular-loader> <tl-button class=btn-primary ng-click=saveMessage() ng-disabled=\"isMessageEmpty() || submitting\" type=button> {{'common.Enregistrer' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss() ng-disabled=submitting type=button> {{'common.Annuler' | translate}} </tl-button> </div> </div> </div>";

/***/ }),
/* 3722 */
/***/ (function(module, exports) {

module.exports = "<div class=crm-ticket-details> <div class=\"block title\"> <i class=\"fa fa-ban color-intra\" ng-if=!ticket.visibleClient tl-tooltip=\"Ticket non visible par les clients\"></i> <span>{{ticket.titre}}</span> <i authz-if-intra class=\"fa fa-link copier-lien-ticket color-intra\" ng-click=copyToClipboard() tl-tooltip> <tl-tooltip-content>Copier dans le presse-papier le lien vers ce ticket</tl-tooltip-content> </i> <div class=right-area> <span class=\"b red reouverture\" ng-if=\"ticket.demandeReouverture && intra\">Réouverture demandée </span> <tl-button class=\"btn btn-danger btn-sm\" ng-click=annulerDemandeReouverture(ticket) ng-if=\"!intra && ticket.demandeReouverture\">Annuler la demande de réouverture</tl-button> <tl-button authz-if-intra class=\"btn-deplacement btn btn-warning\" ng-click=deplacerTicket(ticket) ng-if=\"comptesAccessibles.length>1\" tl-tooltip=\"Déplacer vers un autre compte de l'arborescence\"> <i class=\"fa fa-sitemap\"></i> </tl-button> <tl-button class=\"btn-edit btn btn-primary\" ng-click=\"edition ? editTicket(ticket) : editTicketClient(ticket)\" ng-if=\"edition || (editionClient && ticket.statutTicket=='A_TRAITER')\"> <i class=\"fa fa-edit\"></i> </tl-button> <tl-button class=\"float-r btn-edit btn btn-warning\" ng-click=demandeReouverture(ticket) ng-if=\"(!intra && ticket.statutTicket=='TERMINE') && !ticket.demandeReouverture\"> <i class=\"fa fa-folder-open\"></i> Demande de réouverture </tl-button> </div> </div> <div class=\"group block\"> <div ng-if=ticket.subvention> <label>Module :</label> <span><div class=display-i><tl-module-aide-subvention></tl-module-aide-subvention> Subvention</div></span> </div> <div> <label>Type :</label> <span>{{'lov.typeTickets.' + ticket.typeTicket | translate}}</span> </div> <div ng-if=possedeComptesLies> <label>Compte :</label> <span>{{ticket.compte}}</span> </div> <div ng-if=ticket.demandeur> <label>Demandeur</label> <span>{{ticket.demandeur}}</span> </div> <div ng-if=ticket.watchers> <label>Autres personnes notifiées</label> <span>{{ticket.watchers}}</span> </div> <div authz-if-intra> <label>Attribué à</label> <span>{{ticket.attribution}}</span> </div> <div> <label>Date de la demande :</label> <span>{{ticket.dateDebutTicket | dateLong}}</span> </div> <div ng-if=ticket.deadline> <label>Deadline :</label> <span>{{ticket.deadline | dateShort}}</span> </div> <div ng-if=ticket.dateFinTicket> <label>Date de clôture :</label> <span>{{ticket.dateFinTicket | dateLong}}</span> </div> <div> <label>Statut :</label> <span>{{'lov.taskStatuts.' + ticket.statutTicket | translate}}</span> </div> </div> <div class=\"block block_demande\"> <tl-file-drop-overlay ng-if=showDemandeFileDropOverlay()></tl-file-drop-overlay> <div class=block__title>Demande</div> <div class=\"mb-xs text-area\" ng-bind-html=ticket.demandeAffichage></div> <div class=\"b mb-xs\">Documents <tl-icon-button class=color-intra icon=fa-download ng-click=downloadAllDemandeDocuments() ng-if=\"ticket.documentsIn.length!==0\" title=Télécharger tl-tooltip=\"Téléchargement de tous les documents de demande dans un .zip\"> </tl-icon-button> </div> <div class=\"grey i mb-xs\" ng-if=\"ticket.documentsIn.length===0\">Aucun document.</div> <div class=document ng-repeat=\"document in ticket.documentsIn\"> <i class=\"file-icon fa fa-file-text-o\"></i> <span class=name>{{document.name}}</span> <span class=doc-size>({{document.size | bytes}})</span> <span class=actions> <tl-icon-button icon=fa-eye title=Prévisualiser ng-if=canPreviewDoc(document) ng-click=previewDocument(document)> </tl-icon-button> <tl-icon-button ng-if=\"edition || editionClient\" icon=fa-pencil-square-o title=Editer ng-click=editDocument(document)> </tl-icon-button> <tl-icon-button ng-if=edition icon=fa-times-circle title=Supprimer ng-click=removeDocument(document)> </tl-icon-button> <tl-icon-button icon=fa-download title=Télécharger ng-click=downloadDocument(document)> </tl-icon-button> </span> </div> <div ng-if=\"edition || editionClient\"> <fileupload-btn type=TICKET_IN btn-label=Ajouter options=demandeUploadOptions upload-success=onResultatUpload> </fileupload-btn> <span class=\"i ml-s\">(Ou déplacez le fichier depuis votre ordinateur)</span> </div> </div> <div class=\"block block_echanges\"> <div class=block__title>Echanges</div> <div ng-repeat=\"echange in ticket.echangesAffichage\"> <div ng-class=\"{'typeTicket-DEMANDE':echange.type=='DEMANDE','typeTicket-REPONSE':echange.type=='REPONSE'}\"> <div class=\"text-area message\" ng-bind-html=echange.messageAffichage> </div> <div class=\"i grey detail\">Le {{echange.date | dateLong}} par {{echange.auteur}}</div> </div> </div> <div class=\"align-l mt-xs\" ng-if=editionClient> <tl-button class=btn-primary ng-click=addMessage() type=button><i class=\"fa fa-plus\"></i> Message </tl-button> </div> </div> <div class=\"block block_reponse\"> <tl-file-drop-overlay ng-if=showReponseFileDropOverlay()></tl-file-drop-overlay> <div class=block__title>Documents de réponse</div> <div class=\"grey i mb-xs\" ng-if=\"ticket.documentsOut.length===0\">Aucun document.</div> <div class=document ng-repeat=\"document in ticket.documentsOut\"> <i class=\"file-icon fa fa-file-text-o\"></i> <span class=name>{{document.name}}</span> <span class=doc-size>({{document.size | bytes}})</span> <span class=actions> <tl-icon-button icon=fa-eye title=Prévisualiser ng-if=canPreviewDoc(document) ng-click=previewDocument(document)> </tl-icon-button> <tl-icon-button ng-if=edition icon=fa-pencil-square-o title=Editer ng-click=editDocument(document)> </tl-icon-button> <tl-icon-button ng-if=edition icon=fa-times-circle title=Supprimer ng-click=removeDocument(document)> </tl-icon-button> <tl-icon-button icon=fa-download title=Télécharger ng-click=downloadDocument(document)> </tl-icon-button> </span> </div> <div ng-if=edition> <fileupload-btn type=TICKET_OUT btn-label=Ajouter options=reponseUploadOptions upload-success=onResultatUpload> </fileupload-btn> <span class=\"i ml-s\">(Ou déplacez le fichier depuis votre ordinateur)</span> </div> </div> <div class=block ng-if=ticket.commentaireInterne authz-if-intra> <div class=block__title><i class=\"fa fa-user-cowboy green\" tl-tooltip=\"Non visible par les clients\"></i> Commentaire interne : CR visite, ... </div> <div class=\"mb-xs text-area\" ng-bind-html=ticket.commentaireInterne></div> </div> <div authz-if-intra class=block ng-if=ticket.historiques> <div class=block__title>Historique ({{ticket.historiques.length}})</div> <tl-form-details hide-label=Cacher show-label=Détail> <table class=historique> <thead> <tr> <td>Date</td> <td>Statut</td> <td>Demande</td> </tr> </thead> <tbody> <tr ng-repeat=\"historique in ticket.historiques\"> <td tl-tooltip={{historique.date|dateLong}}>{{historique.date | dateShort}}</td> <td><span ng-if=historique.statutTicket>{{'lov.taskStatuts.' + historique.statutTicket | translate}}</span> </td> <td ng-bind-html=historique.demande></td> </tr> </tbody> </table> </tl-form-details> </div> <div class=block ng-if=edition> <div class=block__title>Autres actions</div> <tl-button class=\"btn btn-danger\" ng-click=supprimerTicket(ticket)> <i class=\"fa fa-times\"></i> <span>Supprimer la demande</span> </tl-button> </div> </div> ";

/***/ }),
/* 3723 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box sp-popin sp-frais-popin\"> <div class=title> <h3> <span> Edition d'un document </span> </h3> </div> <div class=content> <div class=popin-form> <tl-field> <label> Nom du document </label> <input ng-model=document.name maxlength=100 /> </tl-field> </div> </div> <div class=footer> <tl-button class=btn-primary ng-click=saveAndClose()> {{ 'common.Enregistrer' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss()> {{'common.dialog.cancel' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3724 */
/***/ (function(module, exports) {

module.exports = "<div class=confirm-box> <div class=title> <h3>{{title}}</h3> </div> <div class=content ng-switch=\"html != null\"> <p ng-switch-when=false ng-bind=text></p> <div ng-switch-when=true ng-bind-html=html></div> </div> <div class=footer> <tl-button class=btn-primary ng-click=$close()> {{'common.dialog.close' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3725 */
/***/ (function(module, exports) {

module.exports = "<div class=confirm-box> <div class=title> <h3>{{title}}</h3> </div> <div class=content ng-switch=\"html != null\"> <p ng-switch-when=false ng-bind=text></p> <div ng-switch-when=true ng-bind-html=html></div> </div> <div class=footer> <tl-button class=btn-primary ng-click=$close()> {{confirmLabel | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss()> {{cancelLabel | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3726 */
/***/ (function(module, exports) {

module.exports = "<div class=sticky-dialog ng-class=\"{ minimized : stickyCtrl.isMinimized() }\"> <div class=dialog-header> <div class=title ng-dblclick=stickyCtrl.toggleDialog()> {{::dialogOptions.title}} </div> <div class=actions> <i class=\"fa fa-minus\" tl-tooltip=Réduire ng-show=!stickyCtrl.isMinimized() ng-click=stickyCtrl.minimizeDialog()></i> <i class=\"fa fa-square-o\" tl-tooltip=Agrandir ng-show=stickyCtrl.isMinimized() ng-click=stickyCtrl.maximizeDialog()></i> <i class=\"fa fa-close\" tl-tooltip=Fermer ng-click=stickyCtrl.closeDialog()></i> </div> </div> <div class=dialog-content ng-transclude></div> </div>";

/***/ }),
/* 3727 */
/***/ (function(module, exports) {

module.exports = "<div class=btn-file-upload> <form file-upload=mergedOptions method=POST enctype=multipart/form-data> <div class=\"btn btn-primary fileinput-button {{btnClass}}\" ng-class=\"{disabled: disabled}\"> <i class=\"fa {{icon}}\"></i> <span ng-if=btnLabelKey>{{btnLabelKey | translate}}</span> <span ng-if=btnLabel>{{btnLabel}}</span> <input class=file-input type=file name=file accept={{accept}} ng-disabled=disabled> </div> </form> </div>";

/***/ }),
/* 3728 */
/***/ (function(module, exports) {

module.exports = "<div class=content> <span class=label>Transfert du fichier en cours...</span> <span class=speed>({{bitrate | bytes}}/sec)</span> <tl-progress-bar position=progress></tl-progress-bar> </div>";

/***/ }),
/* 3729 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box tl-form-wizard-popin\"> <div class=title> <h3> <span>{{wizardTitle}}</span> <span ng-if=\"config.steps.length > 1\">- Etape {{ formWizard.getStepNumber() }} / {{config.steps.length}}</span> </h3> </div> <div class=content> </div> <div class=footer> <tl-button class=btn-primary ng-if=!formWizard.isFirstStep() ng-click=formWizard.toPreviousStep()> <i class=\"fa fa-step-backward\"></i> <span>Précédent</span> </tl-button> <tl-button class=btn-primary ng-if=!formWizard.isLastStep() ng-disabled=!formWizard.isCurrentStepValid() ng-click=formWizard.toNextStep()> <i class=\"fa fa-step-forward\"></i> <span>Suivant</span> </tl-button> <tl-button class=btn-primary ng-if=formWizard.isLastStep() ng-disabled=!formWizard.isCurrentStepValid() ng-click=formWizard.validateAndSave()> <i class=\"fa fa-save\"></i> <span>Enregistrer</span> </tl-button> <tl-button class=btn-warning ng-click=$dismiss()> <i class=\"fa fa-times\"></i> <span>Annuler</span> </tl-button> </div> </div> ";

/***/ }),
/* 3730 */
/***/ (function(module, exports) {

module.exports = "<div class=tl-search-field> <div class=search-input> <input class=search ng-model=search.q ng-click=onFocus() ng-focus=onFocus() ng-blur=onBlur() ng-keydown=onKeyDown($event)> <i class=\"fa fa-search\"></i> </div> <div class=search-dropdown ng-if=\"active && search.q.length >= search.minLength\"> <div class=results-loader ng-if=loadingResults> <span>Recherche en cours...</span> </div> <div class=has-no-results ng-if=\"!loadingResults && !results.length\"> <span>Aucuns résultats</span> </div> <div class=search-results ng-if=\"!loadingResults && results.length\"> <div class=search-result ng-repeat=\"result in results | limitTo:100\" ng-class=\"{ selected : selected == $index }\" ng-mouseenter=setActiveItem($index) ng-click=onResultClick(result) tl-search-field-result> </div> </div> </div> </div>";

/***/ }),
/* 3731 */
/***/ (function(module, exports) {

module.exports = "<div class=highchart-export-popin> <div class=title> <h3>Exporter un graphique</h3> </div> <div class=content> <div class=container> <div class=chart-options tl-live-form=updateChartConfig()> <div class=fieldset> <div class=tl-legend> Généralités </div> <tl-field> <label class=tl-label> Titre </label> <input ng-model=chartParams.title /> </tl-field> <tl-field> <label class=tl-label> Sous-titre </label> <input ng-model=chartParams.subtitle /> </tl-field> </div> <div class=fieldset> <div class=tl-legend> Dimensions </div> <tl-field> <label class=tl-label> Longueur </label> <input input-type-number integer-count=4 ng-model=chartParams.width /> </tl-field> <tl-field> <label class=tl-label> Hauteur </label> <input input-type-number integer-count=4 ng-model=chartParams.height /> </tl-field> </div> <div class=fieldset> <div class=tl-legend> Légende </div> <tl-field> <label class=tl-label> Position </label> <select ng-model=chartParams.legend> <option value=BOTTOM>En dessous</option> <option value=RIGHT>A droite</option> <option value=HIDDEN>Ne pas afficher</option> </select> </tl-field> <tl-field ng-if=\"chartParams.legend==='RIGHT'\"> <label class=tl-label> </label> <select ng-model=chartParams.legendFloating> <option value=true>Dans le graphe</option> <option value=false>Hors du graphe</option> </select> </tl-field> </div> <div class=fieldset> <div class=tl-legend ng-switch=chartType> <span ng-switch-when=pie>Secteurs</span> <span ng-switch-default>Séries</span> </div> <div ng-if=\"chartParams.dataLabelsEnabled!=null\"> <tl-field> <label class=tl-label> Afficher les valeurs </label> <tl-checkbox ng-model=chartParams.dataLabelsEnabled></tl-checkbox> </tl-field> </div> <div ng-if=chartParams.pie> <div ng-if=chartParams.pie.colorChartPieOnSerie ng-repeat=\"line in chartParams.pie.chartPieData\"> <tl-field> <label class=tl-label> {{line.name}} </label> <input input-type-color ng-model=line.color /> </tl-field> </div> <div ng-if=!chartParams.pie.colorChartPieOnSerie ng-repeat=\"color in chartParams.pie.chartColors track by $index\"> <tl-field ng-show=\"$index < chartParams.pie.chartPieData.length\"> <label class=tl-label> {{chartParams.pie.chartPieData[$index][0]}} </label> <input input-type-color ng-model=chartParams.pie.chartColors[$index] /> </tl-field> </div> </div> <div ng-repeat=\"serie in chartParams.series\" ng-if=\"chartType !== 'pie'\"> <tl-field> <label class=tl-label> Serie \"{{serie.name}}\" </label> </tl-field> <tl-field class=indent> <label class=tl-label> Visible </label> <tl-checkbox ng-model=serie.visible></tl-checkbox> </tl-field> <tl-field class=indent> <label class=tl-label> Couleur </label> <input input-type-color ng-model=serie.color /> </tl-field> </div> </div> <div class=fieldset ng-if=\"chartParams.chartType!=='pie'\"> <div class=tl-legend> Axes </div> <div ng-repeat=\"axis in chartParams.xAxis\"> <tl-field> <label class=tl-label> Label axe X {{chartParams.xAxis.length > 1 ? $index : \"\"}} </label> <input ng-model=axis.title /> </tl-field> </div> <div ng-repeat=\"axis in chartParams.yAxis\"> <tl-field> <label class=tl-label> Label axe Y {{chartParams.yAxis.length > 1 ? $index : \"\"}} </label> <input ng-model=axis.title /> </tl-field> </div> </div> </div> <div class=chart-preview> <highchart config=exportedChartConfig highchart-export-preview></highchart> <div class=overlay></div> </div> </div> </div> <div class=footer> <tl-button class=btn-primary ng-click=exportImage()> <i class=\"fa fa-file-image-o\"></i> <span>Exporter l'image</span> </tl-button> <tl-button authz-if-role=IT_ADMINISTRATION class=btn-primary ng-click=exportImageSVG() tl-tooltip=\"Disponible uniquement pour les consultants\"> <i class=\"fa fa-file-image-o green\"></i> <span class=green>Exporter en svg</span> </tl-button> <tl-button class=btn-primary ng-click=exportToPdf()> <i class=\"fa fa-file-pdf-o\"></i> <span>Exporter en pdf</span> </tl-button> <tl-button class=btn-warning ng-click=$close()> Annuler </tl-button> </div> </div> ";

/***/ }),
/* 3732 */
/***/ (function(module, exports) {

module.exports = "<div class=highchart-fullscreen-popin> <div class=content> <div class=container autosizing-container sizable-container> <highchart sizeable-component config=fullscreenChartConfig></highchart> </div> </div> <div class=actions> <tl-button class=btn-primary ng-click=$close()> Fermer </tl-button> </div> </div> ";

/***/ }),
/* 3733 */
/***/ (function(module, exports) {

module.exports = "<div class=tl-field-year-and-month> <div class=\"years-field field\"> <input ng-model=duration.years input-type-number number-integer ng-disabled=disabled ng-blur=refreshInputValues() tl-enter-press=refreshInputValues()> <span> {{\"common.Years\" | translate}} </span> </div> <div class=\"months-field field\"> <input ng-model=duration.months input-type-number number-integer ng-disabled=disabled ng-blur=refreshInputValues() tl-enter-press=refreshInputValues()> <span> {{\"common.Months\" | translate}} </span> </div> </div>";

/***/ }),
/* 3734 */
/***/ (function(module, exports) {

module.exports = "<div class=tl-icon-input ng-click=inputCtrl.toggleIconSelectorMenu()> <div class=tl-icon-input-wrapper> <div class=selected-icon-container> <i class=\"fa {{iconId}}\"></i> </div> <div class=caret-container> <span class=caret></span> </div> </div> <div class=tl-icon-input-dropdown> <div class=dropdown-content ng-if=inputCtrl.state.opened> <div class=icon-list> <div ng-repeat=\"iconId in ::inputCtrl.getIconList()\" class=icon-el ng-click=inputCtrl.selectIcon(iconId)> <i class=\"fa {{::iconId}}\"></i> </div> </div> </div> </div> </div>";

/***/ }),
/* 3735 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tl-month-picker tl-select-kind-field\" ng-class=\"{ focus : $monthPicker.state.focused, opened :  $monthPicker.state.opened}\" tabindex=0> <div class=\"tl-month-picker-input tl-fake-input\"> <span ng-bind=\"$monthPicker.modelValue | longMonthAndYear\"></span> </div> <div class=tl-month-picker-dropdown tabindex=-1> <select class=month-select ng-model=$monthPicker.state.selectedMonth ng-options=\"o.month as o.label for o in monthOptions\"> </select> <select class=year-select ng-model=$monthPicker.state.selectedYear ng-options=\"o.year as o.label for o in yearOptions\"> </select> <tl-button class=btn-primary ng-click=$monthPicker.validateDate()> <span>Ok</span> </tl-button> </div> </div>";

/***/ }),
/* 3736 */
/***/ (function(module, exports) {

module.exports = "<div class=tl-circular-loader> <svg class=circular viewBox=\"25 25 50 50\"> <circle class=path cx=50 cy=50 r=20 fill=none stroke-width=3 stroke-miterlimit=10></circle> </svg> </div>";

/***/ }),
/* 3737 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box banque-selection-popin\"> <div class=title> <h3>Selection d'une contrepartie</h3> </div> <div class=content> <div class=search-field> <input class=tl-select-searchbox ng-model=$ctrl.searchTerm tl-focus-init> <i class=\"fa fa-search\"></i> </div> <div class=results> <div class=group ng-repeat=\"group in $ctrl.results\"> <div class=group-label> {{::group.value}} </div> <div class=banques> <div class=banque ng-repeat=\"banque in group.options\" ng-click=selectBanque(banque)> <logo-contrepartie size=icon contrepartie-id={{::banque.id}} contrepartie-type=BANQUE></logo-contrepartie> <span>{{::banque.libelleCourtUsuel}}</span> </div> </div> </div> </div> </div> <div class=footer> <tl-button class=btn-secondary ng-click=$dismiss()> {{'common.dialog.close' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3738 */
/***/ (function(module, exports) {

module.exports = "<div class=currency-group-label> <span>{{::group.value ? 'Devises majeures' : 'Autres devises'}}</span> </div> ";

/***/ }),
/* 3739 */
/***/ (function(module, exports) {

module.exports = "<div class=currency-option> <span ng-if=::option.flagCode class=\"currency-flag flag24 flag-{{::option.flagCode}}\"></span> <span class=currency-name>{{::option.isoCode}}</span> </div>";

/***/ }),
/* 3740 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box financeur-subvention-demande-creation\" ng-init=\"message = {}\"> <div class=title> <h3>Demande de rajout d'un financeur</h3> </div> <div class=content> <div class=mb-s> Cette action permet de demander au support Taelys de créer un nouveau financeur absent du référentiel des financeurs. </div> <div authz-if-client class=mb-xs> <p ng-if=hasTelephone>{{'accueil.rappel.NuméroDeTéléphoneSurLequelIlPeutVousJoindre' | translate}} : <span class=\"blue b\" ng-if=telephoneFixe>{{telephoneFixe}}</span> <span class=b ng-if=\"telephoneFixe && telephonePortable\"> / </span> <span class=\"blue b\" ng-if=telephonePortable>{{telephonePortable}}</span> </p> <p class=\"b red\" ng-if=!hasTelephone>{{'accueil.rappel.AttentionPasDeNuméroEnregistré' | translate}}<br/> {{'accueil.rappel.MerciIndiquerNumero' | translate}} </p> </div> <div> <label> Merci d'indiquer le nom du financeur (idéalement le nom complet pour que nous puissions retrouver à quelle entité légale il correspond) que vous souhaitez voir ajouté. </label> <textarea ng-model=message.comment style=resize:vertical;width:100% tl-focus-init></textarea> </div> <div class=mt-xs><i class=\"icon-tooltip-info fa\"></i> Pour mettre à jour vos informations de contact sur votre profil, cliquez ici : <a class=b href={{appPath}}/gestion-compte/profil target=_blank>Gestion de compte > Profil</a></div> </div> <div class=footer> <tl-button class=btn-primary ng-click=$close(message); ng-disabled=emptyMessage()> {{'accueil.rappel.EnvoyerLaDemande' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss()> {{'common.dialog.cancel' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3741 */
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box financeur-subvention-selection-popin\"> <div class=title> <h3>Sélection d'un financeur</h3> </div> <div class=content> <div class=search-field> <input class=tl-select-searchbox ng-model=$ctrl.searchTerm> <i class=\"fa fa-search\"></i> </div> <div class=results> <div class=group ng-repeat=\"group in $ctrl.results\"> <div class=group-label> {{::group.value}} </div> <div class=banques> <div class=banque ng-click=selectBanque(banque) ng-repeat=\"banque in group.options\"> <logo-contrepartie contrepartie-id={{::banque.id}} contrepartie-type=FINANCEUR_SUBVENTION size=icon></logo-contrepartie> <span>{{::banque.libelleCourtUsuel}}</span> <span class=ml-s ng-if=::banque.departement>({{banque.departement}})</span> </div> </div> </div> </div> </div> <div class=footer> <div class=\"float-l align-l non-trouve mt-xs\"> <div><i class=\"fa icon-tooltip-info\"></i> Vous ne trouvez pas votre financeur dans la liste ? <a class=tl-link ng-click=demandeCreationFinanceur()>Demandez au support de vous le créer en cliquant ici.</a></div> </div> <tl-button class=btn-secondary ng-click=$dismiss()> {{'common.dialog.close' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3742 */
/***/ (function(module, exports) {

module.exports = "<div class=tl-select tabindex=0 ng-class=\"{ focused : $select.state.focused, opened :  $select.state.opened}\"> <div class=tl-select-selection ng-class=\"{'disabled':disabled}\"> <tl-select-selected-option></tl-select-selected-option> <div class=tl-select-selection-arrow ng-if=\"$select.state.loadingRenderDone && !disabled\"> <i class=\"fa fa-caret-down\" ng-if=!disabled></i> </div> </div> <tl-select-dropdown ng-if=!disabled></tl-select-dropdown> <div class=tl-select-garbage ng-transclude></div> </div> ";

/***/ }),
/* 3743 */
/***/ (function(module, exports) {

module.exports = "<div class=tl-select-dropdown ng-show=$select.state.opened> <div class=tl-select-dropdown-search ng-if=$select.config.showSearch> <input class=tl-select-searchbox ng-model=$select.state.searchTerm> <i class=\"fa fa-search\"></i> </div> <div class=tl-select-dropdown-options ng-show=$select.state.opened> <div class=tl-select-opt-group ng-repeat=\"group in $select.groups\"> <tl-select-group-label ng-if=::!group.noGroup></tl-select-group-label> <tl-select-dropdown-option ng-repeat=\"option in ::group.options\" ng-init=\"optionIdx = group.initialIdx + $index\"></tl-select-dropdown-option> </div> <div class=tl-select-no-results ng-if=\"$select.groups.length === 0 && $select.state.searchTerm.length > 0\"> <span>Aucuns résultats</span> </div> </div> <div class=tl-select-dropdown-footer ng-if=$dropdown.showFooter()> <div class=tl-select-expand-button ng-click=$dropdown.onExpandClick($event) tabindex=0> <i class=\"fa fa-plus\"></i> <span>Afficher tout</span> </div> </div> </div> ";

/***/ }),
/* 3744 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tl-select-dropdown-option tl-select-option\" tabindex=-1 option-idx={{::optionIdx}} ng-mouseenter=\"!$select.state.ignoreHover && $select.setActiveOptionIdx(optionIdx, false)\" ng-click=\"$select.setSelectedOption(option, true)\"> </div> ";

/***/ }),
/* 3745 */
/***/ (function(module, exports) {

module.exports = "<div class=tl-select-opt-group-label></div>";

/***/ }),
/* 3746 */
/***/ (function(module, exports) {

module.exports = "<div class=\"topbar-app-switcher no-print\" ng-switch=::showSwitcher tl-dropdown> <div tl-dropdown ng-switch-when=true> <div class=app-switcher-toggle tl-dropdown-toggle title=\"Cliquez pour changer de module\"> <h3 class=app-name> <span>{{::appLabel}}</span> <i class=\"fa fa-angle-down\"></i> </h3> </div> <div class=app-switcher-menu tl-dropdown-menu> <ul> <li ng-repeat=\"app in ::applications\" class=link-to-switcher> <link-to-compte app-id={{::app.id}}> <span>{{::\"topbar.appLabel.\" + app.id | translate}}</span> </link-to-compte> </li> </ul> <hr ng-if=\"applications.length > 0 && externalApplications.length > 0\"> <ul> <li ng-repeat=\"app in ::externalApplications\" class=link-to-switcher> <a target=_blank class=compte-link href={{::app.url}}> <span>{{::app.label}}</span> </a> </li> </ul> </div> </div> <div ng-switch-when=false> <h3 class=app-name> <span>{{::appLabel}}</span> </h3> </div> </div>";

/***/ }),
/* 3747 */
/***/ (function(module, exports) {

module.exports = "<div class=topbar-print> <topbar-logo></topbar-logo> <div class=client-logo> <span class=nom-client>{{nomClient}}</span> <file-image url=/rest/compte/current/icon img-scale img-width=100 img-height=42></file-image> </div> </div>";

/***/ }),
/* 3748 */
/***/ (function(module, exports) {

module.exports = "<div class=menu-section> <tl-circular-loader class=small ng-show=!comptesAccessibles></tl-circular-loader> <div ng-show=\"comptesAccessibles.parents.length > 0 || comptesAccessibles.enfants.length > 0 || comptesAccessibles.autres.length > 0\"> <ul> <li class=section-title> <a> <i class=\"fa fa-users\"></i> <span>{{'index.changerDeCompte' | translate}}</span> </a> </li> </ul> <div class=align-c ng-if=showSearchTextBox> <tl-text-input ng-click=$event.stopPropagation(); ng-model=params.search ng-model-options=\"{debounce : 200}\"></tl-text-input> </div> <div class=accountSection> <ul> <li ng-repeat=\"compte in filteredComptesAccessibles.parents\"> <link-to-compte compte-id={{compte.id}} path=/home> <i class=\"fa fa-arrow-alt-from-bottom\" tl-tooltip=\"Accéder à ce compte parent\"></i> {{compte.nomClient}} </link-to-compte> </li> <li ng-repeat=\"compte in filteredComptesAccessibles.enfants\"> <link-to-compte compte-id={{compte.id}} path=/home> <i class=\"fa fa-arrow-alt-from-top\" ng-if=\"comptesAccessibles.autres.length>0\" tl-tooltip=\"Accéder à ce compte enfant\"></i> {{compte.nomClient}} </link-to-compte> </li> <li ng-repeat=\"compte in filteredComptesAccessibles.autresComptesPlateforme\"> <link-to-compte compte-id={{compte.id}} path=/home> <i class=\"fa fa-mail-forward\" tl-tooltip=\"Accéder à ce compte\"></i> {{compte.nomClient}} </link-to-compte> </li> <li ng-repeat=\"compte in filteredComptesAccessibles.autres\"> <a class=compte-link href=\"/rest/authentication/incarnateOnCompte/{{compte.id}}?authenticationToken={{authToken}}\"> <i class=\"fa fa-user\" tl-tooltip=\"Accéder à ce compte\"></i> {{compte.nomClient}} </a> </li> </ul> </div> <div class=divider></div> </div> </div>";

/***/ }),
/* 3749 */
/***/ (function(module, exports) {

module.exports = "<li class=format-menu> <a> <i class=\"fa fa-hashtag\"></i> <button class=tl-btn ng-class=\"{'pressed' : context.uniteAffichageMontant=='K'}\" ng-click=changeUnite();$event.stopPropagation() title=\"{{context.uniteAffichageMontant=='M' ? 'contexte.MontantsAffichesEnMillions' : (context.uniteAffichageMontant=='K') ? 'contexte.MontantsAffichesEnMilliers' : 'contexte.MontantsAffichesEnEntier' | translate}}\"> <span>{{context.uniteAffichageMontant=='K' ? 'K€' : (context.uniteAffichageMontant=='M') ? 'M€' : '€'}}</span> </button> <button class=tl-btn ng-class=\"{'pressed' : context.cacherDecimales==true}\" ng-click=\"switchDecimales(); $event.stopPropagation()\" title=\"{{context.cacherDecimales ? 'contexte.DecimalesCachees' : 'contexte.DecimalesAffichees' | translate}}\"> <span class=decimals>,00</span> </button> </a> </li>";

/***/ }),
/* 3750 */
/***/ (function(module, exports) {

module.exports = "<li> <a href={{appPath}}/gestion-compte> <i class=\"fa fa-cogs\"></i> <span>{{\"index.GestionDuCompte\" | translate}}</span> </a> </li>";

/***/ }),
/* 3751 */
/***/ (function(module, exports) {

module.exports = "<li> <a href={{appPath}}/guide-utilisateur> <i class=\"fa fa-question-circle-o\"></i> <span>{{'index.guidesUtilisateur'|translate}}</span> </a> </li>";

/***/ }),
/* 3752 */
/***/ (function(module, exports) {

module.exports = "<li> <a href={{appPath}}/lab> <i class=\"fas fa-tachometer-alt-fast\"></i> <span style=color:green>{{'index.Lab'|translate}}</span> </a> </li> ";

/***/ }),
/* 3753 */
/***/ (function(module, exports) {

module.exports = "<li> <a ng-click=performLogout()> <i class=\"fa fa-power-off\"></i> <span ng-if=!toIntra>{{\"index.Deconnection\" | translate}}</span> <span ng-if=toIntra>Retour à l'intra Taelys</span> </a> </li>";

/***/ }),
/* 3754 */
/***/ (function(module, exports) {

module.exports = "<li> <a ng-click=enablePrintMode()> <i class=\"fa fa-print\"></i> <span>{{'index.modeImpression'|translate}}</span> </a> </li>";

/***/ }),
/* 3755 */
/***/ (function(module, exports) {

module.exports = "<div class=\"clearfix mb-xs\"> <tl-button no-print ng-click=switchVueClient() class=\"btn-primary mt-xs ml-s mr-s\"> <span authz-if-role=!INTRA_TAELYS_AVEC_VUE_CLIENT><i class=\"fa fa-hat-cowboy green\"></i> Passer en vue client du compte</span> <span authz-if-role=INTRA_TAELYS_AVEC_VUE_CLIENT><i class=\"fa fa-hat-cowboy green\"></i> Retour en vue consultant du compte</span> </tl-button> </div> ";

/***/ }),
/* 3756 */
/***/ (function(module, exports) {

module.exports = "<li> <a ng-click=openTaskList()> <i class=\"fa fa-tasks\"></i> <span>Gestion des tâches</span> </a> </li>";

/***/ }),
/* 3757 */
/***/ (function(module, exports) {

module.exports = "<li> <a ng-click=openToolbox()> <i class=\"fa fa-wrench\"></i> <span>{{'index.boiteAOutils'|translate}}</span> </a> </li>";

/***/ }),
/* 3758 */
/***/ (function(module, exports) {

module.exports = "<div class=\"topbar-userbox dropdown\" tl-dropdown> <div class=dropdown-toggle tl-dropdown-toggle md-ink-ripple> <topbar-userbox-content></topbar-userbox-content> </div> <div class=dropdown-menu tl-dropdown-menu> <user-menu-gestion-compte-button authz-if-role=!SUBVENTION_COLLABORATEUR_EXTERNE></user-menu-gestion-compte-button> <user-menu-toolbox-button if-application=DETTE||DETTE_GARANTIE||PRET></user-menu-toolbox-button> <user-menu-task-manager-button authz-if-intra></user-menu-task-manager-button> <div authz-if-role=!SUBVENTION_COLLABORATEUR_EXTERNE> <user-menu-guide-utilisateur-button if-application=OBSERVATOIRE_FINANCIER||DETTE||DETTE_GARANTIE||PRET||AIDE_SUBVENTION page=guide-utilisateur></user-menu-guide-utilisateur-button> </div> <user-menu-lab authz-if-role=EXPERIMENTATEUR></user-menu-lab> <user-menu-print-mode-button></user-menu-print-mode-button> <div authz-if-role=!SUBVENTION_COLLABORATEUR_EXTERNE> <user-menu-format-montants if-application=AIDE_SUBVENTION></user-menu-format-montants> </div> <user-menu-switch-vue-client authz-if-role=INTRA_TAELYS></user-menu-switch-vue-client> <div class=divider></div> <user-menu-accounts-section></user-menu-accounts-section> <user-menu-logout-button></user-menu-logout-button> </div> </div>";

/***/ }),
/* 3759 */
/***/ (function(module, exports) {

module.exports = "<div class=confirm-box> <div class=title> <h3>{{'xls.metadata.GestionDesColonnesPourVosExports'|translate}}</h3> </div> <div class=content> <div class=table-actions> <a class=tl-link ng-click=resetToDefaut() tl-tooltip=\"{{'xls.metadata.ChampsDefinisAuNiveauDuRapportParDefautPourTousLesUtilisateurs'|translate}}\">{{'xls.metadata.ReinitialiserAuxChampsParDefaut'|translate}}</a> </div> <tl-table table-config=tableOptions></tl-table> <tl-circular-loader ng-if=!columns class=small></tl-circular-loader> </div> <div class=footer> <tl-button class=btn-primary ng-click=save()> {{'common.dialog.confirm' | translate}} </tl-button> <tl-button class=btn-warning ng-click=$dismiss()> {{'common.dialog.cancel' | translate}} </tl-button> </div> </div> ";

/***/ }),
/* 3760 */,
/* 3761 */,
/* 3762 */,
/* 3763 */,
/* 3764 */,
/* 3765 */,
/* 3766 */,
/* 3767 */,
/* 3768 */,
/* 3769 */,
/* 3770 */,
/* 3771 */,
/* 3772 */,
/* 3773 */,
/* 3774 */,
/* 3775 */,
/* 3776 */,
/* 3777 */,
/* 3778 */,
/* 3779 */,
/* 3780 */,
/* 3781 */,
/* 3782 */,
/* 3783 */,
/* 3784 */,
/* 3785 */,
/* 3786 */,
/* 3787 */,
/* 3788 */,
/* 3789 */,
/* 3790 */,
/* 3791 */,
/* 3792 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./base/base-classes.less": 1709,
	"./base/box-layout.less": 1710,
	"./base/errors.less": 1711,
	"./base/fonts.less": 1712,
	"./base/helpers.less": 1713,
	"./base/icons.less": 1714,
	"./base/inputs.less": 1715,
	"./base/main-print.less": 1716,
	"./base/normalize.less": 1717,
	"./base/reset.less": 1718,
	"./base/row-layout.less": 1719,
	"./base/scrollbar.less": 1720,
	"./base/taelys-icons.less": 1721,
	"./base/tl-table-layout.less": 1722,
	"./colors.less": 1723,
	"./components/cadrage.less": 1724,
	"./components/loaders.less": 1725,
	"./components/tabset.less": 1726,
	"./components/tl-btn.less": 1727,
	"./components/tl-nav-breadcrumb.less": 1728,
	"./components/tl-simple-table.less": 1729,
	"./components/tree-table-subtotal-style.less": 1730,
	"./components/treetable.less": 1731,
	"./main.less": 1732,
	"./mixins.less": 1733,
	"./plugins/bootstrap-dropdown.less": 1734,
	"./plugins/bs-switch.less": 1735,
	"./plugins/jgrowl.less": 1736,
	"./plugins/jquery-ui-datepicker.less": 1737,
	"./plugins/qtip2.less": 1738,
	"./plugins/spectrum.less": 1739,
	"./responsive.less": 1740,
	"./sections/context/context-filters.less": 1741,
	"./sections/context/context-popin-topbar.less": 1742,
	"./sections/context/context-popin.less": 1743,
	"./sections/context/context-tabs.less": 1744,
	"./sections/context/context-tooltip.less": 1745,
	"./sections/context/context-topbar.less": 1746,
	"./sections/document/document.less": 1747,
	"./sections/echange/emails.less": 1748,
	"./sections/fiche/fiche-breadcrumb.less": 1749,
	"./sections/fiche/fiche.less": 1750,
	"./sections/fiche/fp-caract-table.less": 1751,
	"./sections/fiche/fp-dashboard-box.less": 1752,
	"./sections/fiche/fp-tab-budget.less": 1753,
	"./sections/home/home-contents.less": 1754,
	"./sections/home/home-panel.less": 1755,
	"./sections/home/home-popin.less": 1756,
	"./sections/home/home-tabs.less": 1757,
	"./sections/marche/market-simulation-edition.less": 1758,
	"./sections/marche/market.less": 1759,
	"./sections/marche/mkt-history-calendar-carousel.less": 1760,
	"./sections/reporting/etats.less": 1761,
	"./sections/reporting/reporting-tabs.less": 1762,
	"./sections/saisie/budgets/budget-edition-popin.less": 1763,
	"./sections/saisie/budgets/budget-tree.less": 1764,
	"./sections/saisie/echeances/details-echeance.less": 1765,
	"./sections/saisie/evenements/se-echeancier.less": 1766,
	"./sections/saisie/evenements/se-panels.less": 1767,
	"./sections/saisie/historique/changements-produit.less": 1768,
	"./sections/saisie/majCaracParFichier.less": 1769,
	"./sections/saisie/produit/popins/sp-budgets-popin.less": 1770,
	"./sections/saisie/produit/popins/sp-frais-popin.less": 1771,
	"./sections/saisie/produit/popins/sp-popins.less": 1772,
	"./sections/saisie/produit/s-swap-toggle.less": 1773,
	"./sections/saisie/produit/saisie-popins.less": 1774,
	"./sections/saisie/produit/sopt-couverture-tab.less": 1775,
	"./sections/saisie/produit/sp-echeancier.less": 1776,
	"./sections/saisie/produit/sp-forms.less": 1777,
	"./sections/saisie/produit/sp-left-panel.less": 1778,
	"./sections/saisie/produit/sp-misc.less": 1779,
	"./sections/saisie/saisie-portail.less": 1780,
	"./sections/saisie/statut-validation.less": 1781,
	"./sections/toolbox/toolbox-form.less": 1782,
	"./sections/toolbox/toolbox-popin.less": 1783,
	"./sections/toolbox/toolbox-tools.less": 1784,
	"./structure/box-tabset.less": 1785,
	"./structure/layout.less": 1786,
	"./structure/listing-caract.less": 1787,
	"./structure/page-breadcrumb.less": 1788,
	"./structure/page-form.less": 1789,
	"./structure/panel-container.less": 1790,
	"./structure/panel-form.less": 1791,
	"./structure/pills-logos.less": 1792,
	"./structure/popin-form.less": 1793,
	"./structure/table-form.less": 1794,
	"./structure/tl-inline-form.less": 1795,
	"./ui/tl-animation.less": 1796,
	"./ui/tl-content-box.less": 1797,
	"./ui/tl-custom-inputs.less": 1798,
	"./ui/tl-link.less": 1799,
	"./variables.less": 1800
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3792;

/***/ }),
/* 3793 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./aad/aadService.js": 2675,
	"./aad/edition/aadCompteEditionPopin.js": 2676,
	"./abonnementSyntheseMail/abonnementSyntheseMailPopinController.js": 2677,
	"./abonnementSyntheseMail/abonnementSyntheseMailService.js": 2678,
	"./bookmark/tlBookmark.js": 2679,
	"./bookmark/tlBookmark.less": 1801,
	"./budget/gestionBudgets/budget.less": 1802,
	"./budget/gestionBudgets/budgetCreationPopin.js": 2680,
	"./budget/gestionBudgets/budgetDeplacementPopin.js": 2681,
	"./budget/gestionBudgets/gestionBudgets.js": 2682,
	"./budget/if-budget.js": 2683,
	"./budget/if-operation.js": 2684,
	"./champAdditionnel/saisieChampAdditionnel.js": 2685,
	"./champAdditionnel/saisieChampAdditionnel.less": 1803,
	"./checkEcheance/checkEcheanceEdition.js": 2686,
	"./checkEcheance/checkEcheanceEdition.less": 1804,
	"./checkEcheance/checkEcheanceService.js": 2687,
	"./classification/champAdditionnel.less": 1805,
	"./classification/champAdditionnelCreationPopin.js": 2688,
	"./classification/classificationCreationPopin.js": 2689,
	"./classification/classificationService.js": 2690,
	"./classification/saisieClassification.js": 2691,
	"./classification/saisieClassification.less": 1806,
	"./classification/valeur/classificationValeursEditionPopin.js": 2692,
	"./comparaisonPanel/comparaisonPanelService.js": 2693,
	"./core/classes/class.js": 2694,
	"./core/classes/eventbus.js": 2695,
	"./core/error/exceptionHandler.js": 2696,
	"./core/error/http-error-popin.less": 1807,
	"./core/error/httpErrorHandler.js": 2697,
	"./core/events/windowResize.js": 2698,
	"./core/filters/currency.js": 2699,
	"./core/filters/dateOfMonth.js": 2700,
	"./core/filters/ellipsis-filter.js": 2701,
	"./core/filters/fixing-filters.js": 2702,
	"./core/filters/gissler-filters.js": 2703,
	"./core/filters/lov.js": 2704,
	"./core/filters/orDash.js": 2705,
	"./core/filters/period-filter.js": 2706,
	"./core/filters/repeaters.js": 2707,
	"./core/filters/useFilter.js": 2708,
	"./core/filters/yesOrNo.filter.js": 2709,
	"./core/http/$asyncHttp.js": 2710,
	"./core/http/dateParserInterceptor.js": 2711,
	"./core/http/httpErrorInterceptor.js": 2712,
	"./core/http/noCacheHttpInterceptor.js": 2713,
	"./core/i18n/$translate.js": 2714,
	"./core/i18n/datepicker/datepicker_fr.js": 2715,
	"./core/i18n/moment/moment_fr.js": 2716,
	"./core/print/print-toolbar.less": 1808,
	"./core/print/print.js": 2717,
	"./core/print/printOnly.js": 2718,
	"./core/print/printToolbar.js": 2719,
	"./core/security/$applications.js": 2720,
	"./core/security/$authz.js": 2721,
	"./core/security/$session.js": 2722,
	"./core/security/security.js": 2723,
	"./core/types/date/dateFilters.js": 2724,
	"./core/types/date/dateFormat.js": 2725,
	"./core/types/duree/duree-filters.js": 2726,
	"./core/types/duree/dureeFormat.js": 2727,
	"./core/types/index-taux/indexTaux-filter.js": 2728,
	"./core/types/index-taux/indexTauxFormat.js": 2729,
	"./core/types/montant/montantFilter.js": 2730,
	"./core/types/montant/montantFormat.js": 2731,
	"./core/types/number/numberFilters.js": 2732,
	"./core/types/number/numberFormat.js": 2733,
	"./core/types/taux/taux-filters.js": 2734,
	"./core/types/taux/tauxFormat.js": 2735,
	"./core/types/telephoneFilters.js": 2736,
	"./core/types/valeurFormat.js": 2737,
	"./core/utils/$body.js": 2738,
	"./core/utils/$debounce.js": 2739,
	"./core/utils/$localStorage.js": 2740,
	"./core/utils/$now.js": 2741,
	"./core/utils/$throttle.js": 2742,
	"./core/utils/UUID.js": 2743,
	"./core/utils/arrayUtils.js": 2744,
	"./core/utils/chartUtils.js": 2745,
	"./core/utils/colorUtils.js": 2746,
	"./core/utils/dateUtils.js": 2747,
	"./core/utils/debug/injectGlobals.js": 2748,
	"./core/utils/deferredUtils.js": 2749,
	"./core/utils/diacriticsMap.js": 2750,
	"./core/utils/directiveUtils.js": 2751,
	"./core/utils/fieldUtils.js": 2752,
	"./core/utils/fileDropUtils.js": 2753,
	"./core/utils/fileUtils.js": 2754,
	"./core/utils/iconUtils.js": 2755,
	"./core/utils/imageUtils.js": 2756,
	"./core/utils/keyCodes.js": 2757,
	"./core/utils/mktHistoryUtils.js": 2758,
	"./core/utils/numberUtils.js": 2759,
	"./core/utils/objectUtils.js": 2760,
	"./core/utils/pasteUtils.js": 2761,
	"./core/utils/routeUtils.js": 2762,
	"./core/utils/scopeUtils.js": 2763,
	"./core/utils/sortUtils.js": 2764,
	"./core/utils/stringUtils.js": 2765,
	"./core/utils/templateUtils.js": 2766,
	"./core/utils/urlUtils.js": 2767,
	"./core/utils/valeurUtils.js": 2768,
	"./coucheAdditionnelle/coucheAdditionnelleCreationPopin.js": 2769,
	"./coucheAdditionnelle/coucheAdditionnelleService.js": 2770,
	"./coucheAdditionnelle/saisieCoucheAdditionnelle.js": 2771,
	"./coucheAdditionnelle/saisieCoucheAdditionnelle.less": 1809,
	"./documents/documentEcheanceEditionPopin.js": 2772,
	"./documents/documentEcheanceService.js": 2773,
	"./documents/documentPreview.js": 2774,
	"./documents/documentPreviewBox.less": 1810,
	"./documents/documentsEcheanceEdition.js": 2775,
	"./documents/tlDirectoryBox.js": 2776,
	"./documents/tlDocumentBox.js": 2777,
	"./documents/tlDocumentBox.less": 1811,
	"./documents/tlDocumentPreview.js": 2778,
	"./documents/tlDocumentPreview.less": 1812,
	"./documents/tlModelesDocuments.js": 2779,
	"./documents/tlModelesDocuments.less": 1813,
	"./edition/compteEditionPopin.js": 2780,
	"./edition/compteEditionService.js": 2781,
	"./fiche-produit/fpConfigurator.js": 2782,
	"./guide-utilisateur/gu-pres-components.js": 2783,
	"./home/aad/home-aad.js": 2784,
	"./home/aad/home-aad.less": 1814,
	"./home/annonceNouvelleVersion/homeAnnonceNouvelleVersion.js": 2785,
	"./home/annonceNouvelleVersion/homeAnnonceNouvelleVersion.less": 1815,
	"./home/bookmark/homeBookmark.js": 2786,
	"./home/bookmark/homeBookmark.less": 1816,
	"./home/campagne/homeCampagne.js": 2787,
	"./home/changelog/home-dashboard-changeLog.js": 2788,
	"./home/changelog/home-dashboard-changelog.less": 1817,
	"./home/infoIntra/contrat/homeContrat.js": 2789,
	"./home/infoIntra/contrat/homeContrat.less": 1818,
	"./home/infoIntra/homeInfoIntra.js": 2790,
	"./home/infoIntra/infoIntra.less": 1819,
	"./home/welcome/welcome.js": 2791,
	"./home/welcome/welcomeService.js": 2792,
	"./infiniTable/common/itCompiler.js": 2793,
	"./infiniTable/common/itFooterAccumulator.js": 2794,
	"./infiniTable/common/itFooterManager.js": 2795,
	"./infiniTable/common/itHeaderCell.js": 2796,
	"./infiniTable/common/itHeaderGroupCell.js": 2797,
	"./infiniTable/common/itHeaderManager.js": 2798,
	"./infiniTable/common/itKeyboardControls.js": 2799,
	"./infiniTable/common/itRenderingFn.js": 2800,
	"./infiniTable/common/itRowPrecompiler.js": 2801,
	"./infiniTable/common/itRowSelectionFeature.js": 2802,
	"./infiniTable/common/itScrollbar.js": 2803,
	"./infiniTable/common/itSortFactory.js": 2804,
	"./infiniTable/common/itTableRegistry.js": 2805,
	"./infiniTable/common/itUtils.js": 2806,
	"./infiniTable/components/itColumnSelector.js": 2807,
	"./infiniTable/components/subtotalButton/itSubtotalButton.js": 2808,
	"./infiniTable/infiniTable.js": 2809,
	"./infiniTable/infiniTableConfigManager.js": 2810,
	"./infiniTable/standard/itDefaultConfig.js": 2811,
	"./infiniTable/standard/itFooterCell.js": 2812,
	"./infiniTable/standard/itFooterRow.js": 2813,
	"./infiniTable/standard/itRow.js": 2814,
	"./infiniTable/standard/itSubtotalCell.js": 2815,
	"./infiniTable/standard/itSubtotalRow.js": 2816,
	"./infiniTable/standard/itTableRenderer.js": 2817,
	"./infiniTable/styles/infinitable-column-selector.less": 1820,
	"./infiniTable/styles/infinitable-scrollbar.less": 1821,
	"./infiniTable/styles/infinitable-theme.less": 1822,
	"./infiniTable/styles/infinitable-tooltips.less": 1823,
	"./infiniTable/styles/infinitable-tree.less": 1824,
	"./infiniTable/styles/infinitable.less": 1825,
	"./infiniTable/taelTableStateManager.js": 2818,
	"./infiniTable/tree/itTreeRenderer.js": 2819,
	"./infiniTable/tree/itTreeTableDefaultConfig.js": 2820,
	"./infiniTable/tree/itTreeTableNodeCell.js": 2821,
	"./infiniTable/tree/itTreeTableRow.js": 2822,
	"./infiniTable/tree/itTreeTableRowToggler.js": 2823,
	"./infiniTable/tree/itTreeTableSpacer.js": 2824,
	"./inventaire/documents/directoryEditionPopin.js": 2825,
	"./inventaire/documents/documentEditionPopin.js": 2826,
	"./inventaire/documents/documents.js": 2827,
	"./inventaire/documents/inventaire-documents.less": 1826,
	"./inventaire/documents/moveNodePopin.js": 2828,
	"./inventaire/documents/zipDownloadPopin.js": 2829,
	"./inventaire/inventaireModuleFactory.js": 2830,
	"./journalOffres/edition/offreEBEditionPopin.js": 2831,
	"./journalOffres/edition/offreLTEditionPopin.js": 2832,
	"./journalOffres/journalOffreService.js": 2833,
	"./marche/courbes-taux/mktCourbesTauxChartConfigFactory.js": 2834,
	"./marche/courbes-taux/mktCourbesTauxPage.js": 2835,
	"./marche/courbes-taux/mktCourbesTauxService.js": 2836,
	"./marche/dashboard/mkt-dashboad-create-favorite-popin.js": 2837,
	"./marche/dashboard/mkt-dashboard-index-summary.less": 1827,
	"./marche/dashboard/mkt-dashboard-page.js": 2838,
	"./marche/dashboard/mkt-dashboard-page.less": 1828,
	"./marche/dashboard/mkt-dashboard-taux-fixe-table.less": 1829,
	"./marche/dashboard/mkt-up-down-caret.js": 2839,
	"./marche/dashboard/mktDashboardCourbeTauxChart.js": 2840,
	"./marche/dashboard/mktDashboardIndexAddBtn.js": 2841,
	"./marche/dashboard/mktDashboardIndexSummary.js": 2842,
	"./marche/dashboard/mktDashboardService.js": 2843,
	"./marche/dashboard/mktDashboardTauxFixeTable.js": 2844,
	"./marche/historique/mkt-history-page.js": 2845,
	"./marche/historique/mkt-history-page.less": 1830,
	"./marche/historique/mktHistoryCalendar.js": 2846,
	"./marche/historique/mktHistoryCalendarCarousel.js": 2847,
	"./marche/historique/mktHistoryChart.js": 2848,
	"./marche/historique/mktHistoryExportPopin.js": 2849,
	"./marche/ice/marketdataIcePage.js": 2850,
	"./marche/indexations/indexationsPersonnalisees/indexationsPersonnalisees.js": 2851,
	"./marche/indexations/indexationsPersonnalisees/mk-indexation.less": 1831,
	"./marche/indexations/mktIndexations.js": 2852,
	"./modules/tl-application-icon.js": 2853,
	"./modules/tl-module-aide-subvention.js": 2854,
	"./modules/tl-module-credit-bail.js": 2855,
	"./modules/tl-module-dette-garantie.js": 2856,
	"./modules/tl-module-dette.js": 2857,
	"./modules/tl-module-interfacage.js": 2858,
	"./modules/tl-module-of-comparoscope.js": 2859,
	"./modules/tl-module-of.js": 2860,
	"./modules/tl-module-placement.js": 2861,
	"./modules/tl-module-pret.js": 2862,
	"./services/$notifications.js": 2863,
	"./services/abonnementAlerteService.js": 2864,
	"./services/applicationSettings.js": 2865,
	"./services/budgetService.js": 2866,
	"./services/cbcService.js": 2867,
	"./services/contrepartieService.js": 2868,
	"./services/currencyService.js": 2869,
	"./services/etatDetteService.js": 2870,
	"./services/exerciceService.js": 2871,
	"./services/fixingService.js": 2872,
	"./services/groupeService.js": 2873,
	"./services/indexationService.js": 2874,
	"./services/indicateurService.js": 2875,
	"./services/initialisationService.js": 2876,
	"./services/lovService.js": 2877,
	"./services/natureService.js": 2878,
	"./services/saisieEditionRapideService.js": 2879,
	"./services/taelParameters.js": 2880,
	"./services/user-task/ifUserTask.js": 2881,
	"./services/user-task/userTaskListPopin.js": 2882,
	"./services/user-task/userTaskListTable.js": 2883,
	"./services/user-task/userTaskService.js": 2884,
	"./services/webSocketService.js": 2885,
	"./ticket/annulerDemandeReouverture/ticketAnnulerDemandeReouverturePopinController.js": 2886,
	"./ticket/choixTicket/choixTicketPopinController.js": 2887,
	"./ticket/crmTicketService.js": 2888,
	"./ticket/demandeReouverture/ticketDemandeReouverturePopinController.js": 2889,
	"./ticket/editionClient/ticketEditionClientPopinController.js": 2890,
	"./ticket/editionConsultant/ticketDeplacerPopinController.js": 2891,
	"./ticket/editionConsultant/ticketEditionPopinController.js": 2892,
	"./ticket/fiche/addMessage/ticketAddMessagePopinController.js": 2893,
	"./ticket/fiche/crmTicketDetails.js": 2894,
	"./ticket/ticket.less": 1832,
	"./ticket/ticketDocumentEditionPopin.js": 2895,
	"./tl/tl-include-template.js": 2896,
	"./tl/tl-progress-bar.js": 2897,
	"./tl/tl-progress-bar.less": 1833,
	"./tl/tlChecklistModel.js": 2898,
	"./tl/tlDropdown.js": 2899,
	"./tl/tlEnterPress.js": 2900,
	"./tl/tlEscapePress.js": 2901,
	"./tl/tlFocusInit.js": 2902,
	"./tl/tlHorizontalMouseScroll.js": 2903,
	"./tl/tlLoaderOverlay.js": 2904,
	"./tl/tlLovOptions.js": 2905,
	"./tl/tlNullOption.js": 2906,
	"./tl/tlOnExcelPaste.js": 2907,
	"./tl/tlOnFieldChange.js": 2908,
	"./tl/tlStopEventPropagation.js": 2909,
	"./tl/tlTooltip.js": 2910,
	"./tl/tlWaitFor.js": 2911,
	"./tlFieldError.js": 2912,
	"./ui/$uiBlock.js": 2913,
	"./ui/animations/anim-slide.js": 2914,
	"./ui/autosizing/asRegistry.js": 2915,
	"./ui/autosizing/autosizing.js": 2916,
	"./ui/autosizing/componentTypes.js": 2917,
	"./ui/autosizing/containerTypes.js": 2918,
	"./ui/autosizing/hideableContainer.js": 2919,
	"./ui/buttons/tl-button-deck.js": 2920,
	"./ui/buttons/tl-button-deck.less": 1834,
	"./ui/buttons/tl-button-with-subactions.js": 2921,
	"./ui/buttons/tl-button-with-subactions.less": 1835,
	"./ui/buttons/tl-button.js": 2922,
	"./ui/buttons/tl-button.less": 1836,
	"./ui/buttons/tl-checkbox-button.js": 2923,
	"./ui/buttons/tl-choice-button.js": 2924,
	"./ui/buttons/tl-choice-buttons.less": 1837,
	"./ui/buttons/tl-icon-button.js": 2925,
	"./ui/buttons/tl-icon-buttons.less": 1838,
	"./ui/buttons/tl-menu-button.js": 2926,
	"./ui/buttons/tl-menu-button.less": 1839,
	"./ui/buttons/uiUtils.js": 2927,
	"./ui/calendar/tl-calendar.js": 2928,
	"./ui/calendar/tl-calendar.less": 1840,
	"./ui/dialogs/$dialogBox.js": 2929,
	"./ui/dialogs/$modal.js": 2930,
	"./ui/dialogs/$stickyBox.js": 2931,
	"./ui/dialogs/confirm-box.less": 1841,
	"./ui/dialogs/modal.less": 1842,
	"./ui/dialogs/sticky-box.less": 1843,
	"./ui/drag-n-drop/tl-file-drop-overlay.js": 2932,
	"./ui/drag-n-drop/tl-file-drop-overlay.less": 1844,
	"./ui/drag-n-drop/tl-on-file-drag.js": 2933,
	"./ui/file-download/$fileDownload.js": 2934,
	"./ui/file-download/fileDownloadLink.js": 2935,
	"./ui/file-upload/document-drop.js": 2936,
	"./ui/file-upload/file-upload.less": 1845,
	"./ui/file-upload/fileUpload.js": 2937,
	"./ui/fileImage.js": 2938,
	"./ui/fileImageWithSize.js": 2939,
	"./ui/fontAwesomeIconList.js": 2940,
	"./ui/form-wizard/formWizard.js": 2941,
	"./ui/form/button/btn-on-off.js": 2942,
	"./ui/form/fieldSet.js": 2943,
	"./ui/form/inputTypes/inputAcceptableRegexp.js": 2944,
	"./ui/form/inputTypes/inputFilterRegexp.js": 2945,
	"./ui/form/inputTypes/inputTypeColor.js": 2946,
	"./ui/form/inputTypes/inputTypeDate.js": 2947,
	"./ui/form/inputTypes/inputTypeNumber.js": 2948,
	"./ui/form/liveForm.js": 2949,
	"./ui/form/searchField/search-field.less": 1846,
	"./ui/form/searchField/tlSearchField.js": 2950,
	"./ui/form/tl-validated-forms.less": 1847,
	"./ui/form/tlField.js": 2951,
	"./ui/form/tlFieldTooltip.js": 2952,
	"./ui/form/tlFormDetails.js": 2953,
	"./ui/form/tlFormDetails.less": 1848,
	"./ui/form/tlValidatedForm.js": 2954,
	"./ui/guide-utilisateur/gu-section-title.js": 2955,
	"./ui/guide-utilisateur/gu.less": 1849,
	"./ui/highcharts/exporter/highchart-exporter.less": 1850,
	"./ui/highcharts/exporter/highchartExportPopin.js": 2956,
	"./ui/highcharts/exporter/highcharts-config-updater.js": 2957,
	"./ui/highcharts/exporter/highcharts-exporter.js": 2958,
	"./ui/highcharts/full-screen/highchart-fullscreen-popin.less": 1851,
	"./ui/highcharts/full-screen/highchartFullscreenOpener.js": 2959,
	"./ui/highcharts/full-screen/highchartFullscreenPopin.js": 2960,
	"./ui/highcharts/highchart-sparkline-options.js": 2961,
	"./ui/highcharts/highcharts-config-blocks.js": 2962,
	"./ui/highcharts/highcharts-defaults.js": 2963,
	"./ui/highcharts/highcharts-i18n.js": 2964,
	"./ui/highcharts/highcharts-utils.js": 2965,
	"./ui/highcharts/highcharts.js": 2966,
	"./ui/highcharts/serie-editor/highcharts.draggable-points.js": 2967,
	"./ui/imgScale.js": 2968,
	"./ui/inputs/tl-checkbox.js": 2969,
	"./ui/inputs/tl-checkbox.less": 1852,
	"./ui/inputs/tl-currency-input.js": 2970,
	"./ui/inputs/tl-date-input.js": 2971,
	"./ui/inputs/tl-field-year-and-month.js": 2972,
	"./ui/inputs/tl-field-year-and-month.less": 1853,
	"./ui/inputs/tl-icon-input.js": 2973,
	"./ui/inputs/tl-icon-input.less": 1854,
	"./ui/inputs/tl-input-wrapper.js": 2974,
	"./ui/inputs/tl-month-picker.js": 2975,
	"./ui/inputs/tl-month-picker.less": 1855,
	"./ui/inputs/tl-percent-input.js": 2976,
	"./ui/inputs/tl-radio-button.js": 2977,
	"./ui/inputs/tl-radio-buttons.less": 1856,
	"./ui/inputs/tl-text-input.js": 2978,
	"./ui/loaders/tl-circular-loader.js": 2979,
	"./ui/loaders/tl-circular-loader.less": 1857,
	"./ui/pageRouter.js": 2980,
	"./ui/pdfViewer.js": 2981,
	"./ui/pills/gissler.js": 2982,
	"./ui/pills/logoContrepartie.js": 2983,
	"./ui/pills/pillInterfacageEcheance.js": 2984,
	"./ui/pills/pillNatureProduit.js": 2985,
	"./ui/richtext/tl-bind-richtext.js": 2986,
	"./ui/richtext/tl-bind-richtext.less": 1858,
	"./ui/richtext/tl-richtext-editor.js": 2987,
	"./ui/richtext/tl-richtext-editor.less": 1859,
	"./ui/ripple/button-ripple.js": 2988,
	"./ui/ripple/ripple-utils.js": 2989,
	"./ui/ripple/ripple.js": 2990,
	"./ui/ripple/tl-ripple.less": 1860,
	"./ui/selectbox/configs/banques/banqueOption.less": 1861,
	"./ui/selectbox/configs/banques/banqueSelectConfig.js": 2991,
	"./ui/selectbox/configs/banques/banqueSelectPopin.js": 2992,
	"./ui/selectbox/configs/banques/banqueSelectPopin.less": 1862,
	"./ui/selectbox/configs/currencies/currencySelectConfig.js": 2993,
	"./ui/selectbox/configs/finaceursSubvention/demande-creation-financeur/demandeCreationFinanceurPopin.js": 2994,
	"./ui/selectbox/configs/finaceursSubvention/financeurOption.less": 1863,
	"./ui/selectbox/configs/finaceursSubvention/financeurSubventionSelectConfig.js": 2995,
	"./ui/selectbox/configs/finaceursSubvention/financeurSubventionSelectPopin.js": 2996,
	"./ui/selectbox/configs/finaceursSubvention/financeurSubventionSelectPopin.less": 1864,
	"./ui/selectbox/tl-select.less": 1865,
	"./ui/selectbox/tlSelect.js": 2997,
	"./ui/selectbox/tlSelectConfigRegistry.js": 2998,
	"./ui/selectbox/tlSelectDropdown.js": 2999,
	"./ui/selectbox/tlSelectSelectedOption.js": 3000,
	"./ui/selectbox/tlSelectTemplates.js": 3001,
	"./ui/structure/linkToCompte.js": 3002,
	"./ui/structure/mainContainer.js": 3003,
	"./ui/structure/pageBreacrumb.js": 3004,
	"./ui/structure/tabsetPage.js": 3005,
	"./ui/structure/tlPanelLayout.js": 3006,
	"./ui/structure/tsTabset.js": 3007,
	"./ui/tabset/tlTabLayout.js": 3008,
	"./ui/tabset/tlTabLayoutContent.js": 3009,
	"./ui/tabset/tlTabLayoutPill.js": 3010,
	"./ui/tabset/tlTabLayoutPillDefaultContent.js": 3011,
	"./ui/tf-form/tf-form.js": 3012,
	"./ui/tf-form/tf-form.less": 1866,
	"./ui/tf-form/tf-multi-steps-indicator.js": 3013,
	"./ui/tf-form/tf-multi-steps-indicator.less": 1867,
	"./ui/tf-form/tf-section-title.js": 3014,
	"./ui/tl-chart.js": 3015,
	"./ui/tl-chart.less": 1868,
	"./ui/tl-country-flag.js": 3016,
	"./ui/tl-currency-flag.js": 3017,
	"./ui/tl-currency-flag.less": 1869,
	"./ui/tl-table.js": 3018,
	"./ui/tlColors.js": 3019,
	"./ui/tlTableUtils.js": 3020,
	"./ui/topbar/app-switcher/topbar-app-switcher.js": 3021,
	"./ui/topbar/app-switcher/topbar-app-switcher.less": 1870,
	"./ui/topbar/topbar-print.js": 3022,
	"./ui/topbar/topbar-print.less": 1871,
	"./ui/topbar/topbar.js": 3023,
	"./ui/topbar/topbar.less": 1872,
	"./ui/topbar/user-menu/actions/userMenuActions.js": 3024,
	"./ui/topbar/user-menu/actions/userMenuSwitchVueClient.js": 3025,
	"./ui/topbar/user-menu/topbar-user-menu.js": 3026,
	"./ui/topbar/user-menu/topbar-user-menu.less": 1873,
	"./ui/treeTable.js": 3027,
	"./xls/metadata/xlsMetadataPopin.js": 3028,
	"./xls/metadata/xlsMetadataService.js": 3029
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3793;

/***/ })
]);


// WEBPACK FOOTER //
// commons.69b1a196.js